webpackJsonp([1],{

/***/ "+64+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/knee_overstretch_left.ebed546.png";

/***/ }),

/***/ "+Ujf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\nh1[data-v-2d249289],\nh2[data-v-2d249289] {\n  font-weight: normal;\n}\nul[data-v-2d249289] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-2d249289] {\n  display: inline-block;\n  margin: 0 10px;\n}\na[data-v-2d249289] {\n  color: #42b983;\n}\n", ""]);

// exports


/***/ }),

/***/ "+uRf":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAA1CAYAAAC5mTBpAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAA09JREFUWIXlmEtsTGEUx3/j1RSRqNLEo5UQFZFociYkErGxUdbEgnSNRUWiC0GkFlhYeISVVCIiNpLaICIWNnSuiEfqXcokpfWWejQ1FneGmW++c+4ddVk4u+9/7jm/77v3fud7wP9qqeJGJpMBmArsAlYB9cBH4DbQARwHcloyESEIgqVAG7AEqAOywEVgh4hkU6lfSBdeC2SABiX/EWCzMZhmoBMY7fFlgXQ6ne4rCKOcB9oMMMBGoMnwH1DAADOAbcWCC19tJIbwTa1UfLOBxoj4VRbcGnXBZir69Bix9RZce2XFllJ0N5fPSvK7Ae9jJPhcoV5s7yz40xgJnih6T4zY5xb8eowE1xT9DfA4IrbLgp+NCH4G3DD8nRHxJX4Xfhl79PuB74b/EDCo+O4A5y14DlgLPPAEHwOOGmBEpAdoAb45riywRkRKOu6r7QAT851oAj4BF4ArFjgPByAIgsZ8fB3QDZwUkXcAVm0vbtblR7EYmET4Q3UBBz0jK1gzsA6YAgwDN4EOEfn5I8aBbwL2ARM8gJ1Au0efS/i53CI0BOwB2kUkVwz3VaV24LACBhiv6NUeMMBYYDfholNiLnw5sF1JPlJrDYJghQVvQa/df8I2WPCpCYIBai34QMLwDxb8VcLwvuKGC7+fMLxk4XHhDxOGlyzHLjxqSRyplaz5LjxLWMuTsBwRIy90IAkbEJEvUfD+hOBvXMEHf5sQ/HUc+MeE4C/jwJOysgL2N+Hd/xJ+KQ58TEQSbSr2KTrALRG5Gwf+IgJ+VdH78e96QSnbPvhh7NVtoaJXEx6TfXYuLrwHWACcVhLNU/QGYJxHPyMiJ+LCISwIvYpvbIW6ui2z/vZqRf9aoa7lMeGPFP2eovcQ7tFdU5dpC679uWVTJm9D+Dus5THhvukxjL3V8r0V9dLAgvfmYa6mndPAP3J1f2DBhygvOFEbTN/3VYtWVG13p5v2E2rwQREp20TEhbv1enLE8+7h0izVUXB392FdfQIsctrmISQKPslpNwJVxvNu57RjdiR8DLDMo2m1HWC+014QBEHN78DXA7M8ep0RM81pVwFbK4XXAHsVnzv3i813TbYlCII5lcBbKR8FhPPcuqc75dGqce7ZC/YDXGW5afcjCSMAAAAASUVORK5CYII="

/***/ }),

/***/ "/G0s":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("cgc+");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("483ebb2f", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c3986d8a\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_report.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c3986d8a\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_report.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "/GUz":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.avatar {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n}\n.fixed-bg {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #12b5c3;\n  z-index: -1;\n}\n.person-info {\n  height: 4.5rem;\n  background: url(" + escape(__webpack_require__("0gUf")) + ") no-repeat center center/100% 100%;\n}\n.avatar-container {\n  width: 3.5rem;\n  height: 3.5rem;\n  background: url(" + escape(__webpack_require__("yboJ")) + ") no-repeat center center/3.5rem 3.25rem;\n}\n.avatar {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n}\n.risk-show-container {\n  position: relative;\n  padding: .5rem;\n  background: #0ea5b3;\n}\n.swiper-box {\n  position: relative;\n  padding: .4rem 0 1.5rem;\n  border-radius: .3rem;\n  background: #fff;\n}\n.data-info {\n  height: 4rem;\n  background: url(" + escape(__webpack_require__("66wa")) + ") no-repeat center center/100% 100%;\n}\n.badge {\n  width: 1.8rem;\n  height: 2rem;\n  background: url(" + escape(__webpack_require__("flp1")) + ") no-repeat center center/100% 100%;\n}\n/* swiper 自定义样式开始 */\n.posture-swiper-pagination {\n  width: auto !important;\n  left: 50% !important;\n  top: 0 !important;\n  bottom: initial!important;\n  -webkit-transform: translate(-50%, 0) !important;\n          transform: translate(-50%, 0) !important;\n}\n.pagination-bullet {\n  float: left !important;\n  width: 2.2rem !important;\n  height: 20px !important;\n  margin: 0 !important;\n  text-align: center !important;\n  line-height: 20px !important;\n  font-size: 12px !important;\n  color: #9f9f9f !important;\n  opacity: 1 !important;\n  border-radius: 0 !important;\n  background: #fff !important;\n}\n.pagination-bullet:first-child {\n  border-bottom-left-radius: .2rem !important;\n}\n.pagination-bullet:last-child {\n  border-bottom-right-radius: .2rem !important;\n}\n.swiper-pagination-bullet-active {\n  color: #38bbc8 !important;\n}\n.swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled {\n  opacity: 1 !important;\n}\n.swiper-button-next, .swiper-button-prev {\n  width: 1.5rem !important;\n  height: 1rem !important;\n  margin: 0 !important;\n  -webkit-transform: translate(0, -50%) !important;\n          transform: translate(0, -50%) !important;\n}\n.swiper-button-next {\n  right: 5px;\n  background: url(" + escape(__webpack_require__("RtGo")) + ") no-repeat center center/100% 100% !important;\n}\n.swiper-button-prev {\n  left: 5px;\n  background: url(" + escape(__webpack_require__("S015")) + ") no-repeat center center/100% 100% !important;\n}\n.swiper-button-prev.swiper-button-disabled {\n  background: url(" + escape(__webpack_require__("uFFO")) + ") no-repeat center center/100% 100% !important;\n}\n.swiper-button-next.swiper-button-disabled {\n  background: url(" + escape(__webpack_require__("YEkT")) + ") no-repeat center center/100% 100% !important;\n}\n/* swiper 自定义样式结束 */\n.risk-icon {\n  width: .5rem;\n  height: .5rem;\n  background: url(" + escape(__webpack_require__("kiVC")) + ") no-repeat center center /100% 100%;\n}\n.risk-tag {\n  position: absolute;\n  padding: 0 .2rem;\n  color: #fff;\n  background: #4e7f85;\n  border-radius: .2rem;\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%)\n}\n.detail-btn {\n  position: absolute;\n  height: 2rem;\n  bottom: 1.5rem;\n  left: 50%;\n  padding: 0 .3rem;\n  color: #fff;\n  font-weight: bold;\n  background: -webkit-linear-gradient(top, #89e6d9, #1ac7ac, #89e6d9);\n  border-radius: .3rem;\n  -webkit-transform: translate(-50%, 50%);\n          transform: translate(-50%, 50%);\n  z-index: 1;\n}\n.right-arrow {\n  width: .8rem;\n  height: .8rem;\n  background: url(" + escape(__webpack_require__("4X2h")) + ") no-repeat center center / 100% 100%;\n}\n.zoom-out-btn {\n  position: absolute;\n  top: 1.3rem;\n  right: 2.9rem;\n  width: 1rem;\n  height: 1rem;\n  background: url(" + escape(__webpack_require__("Kyw1")) + ") no-repeat center center / 100% 100%;\n  z-index: 3\n}\n.cloud {\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: #000;\n  opacity: .85;\n  z-index: 99997\n}\n.img-container {\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%);\n  z-index: 99998;\n}\n.zoom-in-btn {\n  position: absolute;\n  top: .5rem;\n  right: .5rem;\n  width: 1rem;\n  height: 1rem;\n  background: url(" + escape(__webpack_require__("HUba")) + ") no-repeat center center / 100% 100%;\n  z-index: 99999\n}\n", ""]);

// exports


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0SEy":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAAAsSAAALEgHS3X78AAABXklEQVRIib2WwXHCMBBFnxnuoQR3ADPeOyqBEkwFoYNMOqAE6CAdBN/3EDowHeAKnIOVGcXYkszI/BkfpJX36a8syVnbtrxSy9iBImI84buq/iQFAt+eWAX4JvQU8NMTq2OTTAF+eGIVcEoNrDyxqPWbCrx4YvUcwCQlXUwAJlHmbny718zIWJ/DG+MOT6pajwFXdGu1Ds81SmdVLd2OfyVV1Tudw+scMOg5/JN1WgNvT8IqVTVDgcGPxnHaPAG7Arux4OhXag/jqdArYOyEpwEdaBkJu4VgQaCFfgH7wLAG2IVgUUALPXmgDZ2zqPM0K4piAxxtu3Q3aV8icgTep8BEpMQui6qaBbACtvbJfbNT1QNwdroOEc6Mk/+hpCbwMnYzn4G9LXVIudvo3xabiAQMnSAebd1G32FOQonIQ76+w7WIXBIyVyEg9EqQWi+/gJd0t4LvFzCpBq+nOfULhJ6DWWQXq4gAAAAASUVORK5CYII="

/***/ }),

/***/ "0gUf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/top-bg.3b9b0fb.png";

/***/ }),

/***/ "0tff":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\np[data-v-bd4fa69a] {\n  margin: 0;\n  padding: 0;\n}\nh1[data-v-bd4fa69a],\nh2[data-v-bd4fa69a] {\n  font-weight: normal;\n}\nul[data-v-bd4fa69a] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-bd4fa69a] {\n  display: inline-block;\n  margin: 0 10px;\n}\na[data-v-bd4fa69a] {\n  color: #42b983;\n}\n.risk-box[data-v-bd4fa69a] {\n  float: left !important;\n}\n@media screen and (min-width: 600px) and (max-width: 1024px) {\n.gmnClass[data-v-bd4fa69a] {\n    width: 11rem !important;\n}\n.ItemClass[data-v-bd4fa69a] {\n    width: 11rem !important;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "1V3F":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/high_low_shoulder_left.875b362.png";

/***/ }),

/***/ "1VHe":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAABCCAYAAAAPIWX+AAAACXBIWXMAAAsSAAALEgHS3X78AAADhElEQVR4nO2by3mbQBSFf/R5L6UC00GUCkIHYcsqpAOZCnADfE4FUVYsI1dg1IHcAerArmCyYJD1QDAzwEgGnSWaxz3DPM49gxwhBE1wotQDQsAHpo0VrgfPwEokwfL4B6eOuBOlM2AJ/OgrMktYA6FIgrx8cJa4JJ0BX21EZgHvgCeSYAMwqSm4YjikoViiK/lCq4k7URoC3y0GZQv3wBOcmepOlOay0FDx5eSNO1E6Z9ikAfyqqT63HoZ9uFXEXdtRXABe3a4+aIyW+N0F+nyl0AhQLCuP85vpM7DZK/uzqyBsE/9VqZsL3RDzMQCPwJNIgrejcjEdCSubU/2hijSAfD4HfgPfRBLEx6RluZxihmzbBnMiYOToh2fKm6q5rUgC17DuCWS2+NKiiXVtdnam05BC9umkp48iCWKtjprjyDEXWmvtqS6npYvedMt0++m7TaM1LtdfqFFlZtJPA072AB3cAThR6gMLhfJPIglWACIJMidKX1HbYT0+jrCu4LWpfLfnsqis2TmHb0/1aFEdWCU4Ueoq9nsWEwoyqhvVVGZvurh3orQz4hRnfiuYrHHT9RobDtoB5LJsreBsCpgpkLUhL+suuwjGhHib3dSYvBQtGR3Z2xORBBmFA6mC99KllDCZ9iX5ULWC3B9e6NDTL5MUD2nCNeB4g/IM+50Cf+R6Dat0Oex27yU9GJ/aknVXsb1eLnHgd++176N+zOpCX7LCbpPpSpCUU9/fa38B/KPH6yqtNy7FTkhxjvYR1AOF2Onb0z/NzmrS0hnDuVlZVzkwLsO8RTnAaM3GG/Gx4UZ8bBgtcV0B41Kc8QvUBMxfkQShSWAa8WTou616klUkQS5tYg+1jG6pGZAW5AWDUR+mLusGNZfVM2lfE0Z9OEKIMumIqc+v34B4P4tyonRDs4x9paUVXAMXs0uFnWTNUFuzHoeDk9FM/Cr1/UTm1aYua19vsnfYdFmvCqM9x0dNfIOey5r1F449TKTDuaD52nfL6dntV5T7FOjbZR2GZN3rcIaaD780aV8VViWrtIFVFBtcu2Q9eFD/8Y/OlXKJq5asx4116bJep2S9dACXwo342HAjPjZUEc9tB3EBZFXENxXPhob89verI8Q2o7CMvyIJ3iqJyy+U13bjsYIt8gOmul3dp9DZQ8E74JdfWJ0lLgt4FH+I+exYA/ODO4Gx/nH+PytXNUxyBjF9AAAAAElFTkSuQmCC"

/***/ }),

/***/ "33Ju":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("L/iY");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("c5d0404e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-00e4705f\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Wechat_error.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-00e4705f\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Wechat_error.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "38MQ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAACXBIWXMAAAsSAAALEgHS3X78AAADgklEQVRo3t2av08TYRjHPzR0IQIOLEBSSFi6XEQiYXE4GXTkTBw1lFEW2FgcdXCS/gWtYTZeRx1oV2NiJLewkFASYWGwwRANAw73tvTK9e69932vP3iWJm3f597vPb/f7ztyfX3NXZLRNJRaLg7gADYw1/FzHagBrufgmn72iEkLWS42UA4B0U3qQMFzqJnaQ8YgmF2gmgAM4r9VsXYwLGS53Ad2gXXNvXwEtj2H330DJMDUgAeGXvAB4HgOxz0HZLksCjCThuO6Adiew8+exZDIYmmAQeisWS6FnlhIPKjUo7Ky4TmUU7OQKpjxLKxOKwEqWS7bqQCyXMqqlnm3BMUVyKs56AfxbHOAhELltDyeDX4qyLpsrcpIutk6/ZctmUSR6UUCeO9B9QwOG9qgSnGgumY50ZdVuy1cy4GTA/cEKidmTJCfhB1LSufDbnUqE1E0IzvhiSw8moK3Sz44E2BKj32dE/GxVrNc5qUAiXamHFc0945u3qJjANCOBfeyvs69I6ni64q9Rrtc0oy2PAUXV+Hx0aw/s2M33+13iaW1nG8ZCTCBhtZzgjEVACRS45bu2x7P+m+8myueXvqJYv/MSOgVPeem+LYAxSWBJLFQXIGZsfj/Vk7gzQ8joJ40h8T2GCqbsIwsmKabbeaNACoHkoLonud0tW7m5cE05bXCmrDJV2BoWcgxYZ2XC2prXy0YsVIAkK2rbXlKfa1iJ94pdvsxVqy7zYzBpyd+rQgL6LzGqNfpcms5v2C3mrhvUhlxLtH4cHEFvy7lN2VK/lz5aV5WRpMAelGNboVMSUWjPzR2Lnf+j4GQJqC6NqC/fcdSbwdUY/gl0Cm4dwCQ2wIkWID6EIOpN5mM9qRQGGJAhVtZTnSrxSEEU2ynY7QHvPbCOqtRXL+fKy27NeCFFdZtYJGEjMLpZbKKbkAOxF7jT33ErH5MOofxJqQBzIdxSVHHWLF0yeq0XlMaJoeN2EY0km6JZB/E0PS5W8x8eZrO63/2NdJ9n0eRzbF0StTpaR8sFEuvSPFDPeaElMFId9tCUT9rVFGW+ErE4OnSKopyq9YYm4eE4o0eu1milizxgCdMvzEoMaPlch3uZ4uWPQ1a31G9LqM8gosH2qIFMdnO2Dp3f7TOFES1toGKibMRNC5caLtciAvqMBcBBmEgALXFVZk+Xi8bSeNG4525ADgI8h+xW1GxsNf1ygAAAABJRU5ErkJggg=="

/***/ }),

/***/ "3I8+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/pelvis_lean_normal.075c49e.png";

/***/ }),

/***/ "3fkL":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "3tUu":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "4OYe":
/***/ (function(module, exports, __webpack_require__) {

var imgSrc = __webpack_require__("On8B");
var level = {
  normal: 'normal',
  mild: 'mild',
  severe: 'severe'
};
var bodyPart = {
  faceNormal: true,
  sideNormal: true,
  backNormal: true
};
var pains = {
  back: {
    head: ['rake', 'fore'],
    shoulder: ['shoulder', 'round'],
    trunk: ['spine'],
    'lower extremity': ['legX', 'legO', 'legStretch', 'legXO']
  },
  face: {
    shoulder: ['round'],
    trunk: ['trunk'],
    'lower extremity': ['legForX', 'legForO', 'legForStretch']
  },
  side: {
    head: ['fore'],
    shoulder: ['shoulder', 'round']
  }
};

var init_t = {
  descripName: {},
  boneDescription: {},
  details: {}
};
function init(dName, bDescription, details) {
  init_t.descripName = dName;
  init_t.boneDescription = bDescription;
  init_t.details = details;
}

function descripName(des) {
  console.log('init_t:descripName:', init_t.descripName);
  if (des === 'weak') {
    return { name: ' ' + init_t.descripName.upName, color: 'rgb(179,173,143)' };
  } else if (des === 'tension') {
    return { name: ' ' + init_t.descripName.lowName, color: 'rgb(255,138,128)' };
  }
}
function getShoulderLeftOrRight(direction) {
  if (direction.length > 0) {
    return direction;
  } else {
    return false;
  }
  console.log('|||||||:', init_t.details);
  console.log({
    detail: key
  });
  // switch (key) {
  //
  //   // case init_t.details.lh:
  //   //   return 'left';
  //   // case init_t.details.ll:
  //   //   return 'left';
  //   // case init_t.details.rh:
  //   //   return 'right';
  //   // case init_t.details.rr:
  //   //   return 'right';
  //   // default:
  //   //   return false
  //   case '左高':
  //     return 'left';
  //   case '左倾':
  //     return 'left';
  //   case '右高':
  //     return 'right';
  //   case '右倾':
  //     return 'right';
  //   default:
  //     return false
  // }
}
var boneDescription = {
  face: {
    trunk: '腹部肌群',
    legForX: ['髋外旋肌', '髋内收肌'],
    legForO: '髋外旋肌',
    legForStretch: '股四头肌',
    round: '胸大肌'
  },
  side: {
    round: '胸锁乳突肌',
    fore: '胸锁乳突肌',
    shoulder: '斜角肌'
  },
  back: {
    spine: '高侧斜方肌',
    shoulder: '高侧斜方肌',
    round: ['高侧斜方肌', '低侧斜方肌'],
    fore: ['高侧斜方肌', '低侧斜方肌'],
    rake: '肩胛提肌',
    legStretch: ['腘绳肌', '足底筋膜'],
    legX: ['髋外旋肌', '股二头肌'],
    legO: ['半腱肌半膜肌', '足内翻肌群'],
    legXO: ['股二头肌', '足底筋膜']
  }
};

var faceRad = void 0,
    backRad = void 0,
    faceWidth = void 0,
    backWidth = void 0,
    sideWidth = void 0,
    faceHeight = void 0,
    sideHeight = void 0,
    backHeight = void 0;

//正面数据
function drawFrontBone(data, canvas) {
  //canvas画笔
  var faceCanvas = canvas;
  var windowWidth = document.documentElement.clientWidth > 1025 ? document.documentElement.clientWidth / 2 : document.documentElement.clientWidth;

  /*  if(windowWidth < 376){
     windowWidth= windowWidth+10;
   }else if((windowWidth >= 376 ) && ( windowWidth <700) ){
     //console.log('test',windowWidth)
    }else if((windowWidth >= 700 ) && ( windowWidth <1500) ){
     windowWidth = windowWidth/2
   }else{
     windowWidth= windowWidth/4*0.8;
   } */
  ////console.log("windowWidth",windowWidth)
  var windowHeight = window.screen.height;
  faceCanvas.width = windowWidth * 1.7;
  faceWidth = faceCanvas.width;
  faceHeight = faceCanvas.height;
  var faceBodyPostion = {
    imgUrl: imgSrc.bone.boneCanvas,
    sx: 100,
    sy: 50,
    swidth: 420,
    sheight: 900,
    x: faceWidth / 3 * 0.8,
    y: -24,
    width: 420,
    height: 900

  };
  //取对应的点
  var facePoints = data.conclusion.face.points;
  var faceRisks = data.conclusion.face.risks;

  var bodyDirection = getBodyDirection('face', faceRisks);
  //////console.log('faceBodyDirection =>', bodyDirection);

  var hipRPoint = facePoints['hip']['right'];
  var hipLPoint = facePoints['hip']['left'];
  var hipMPoint = {
    x: 0,
    y: 0
  };
  if (hipLPoint.x === 0 && hipLPoint.y === 0 || hipRPoint.x === 0 && hipRPoint.y === 0) {} else {
    // 计算左右骨盆连线中点
    hipMPoint.x = (hipLPoint.x + hipRPoint.x) / 2;
    hipMPoint.y = (hipLPoint.y + hipRPoint.y) / 2;
  };

  //部位角度
  faceRad = {
    //头部
    // head: getRad(facePoints.ear.right, facePoints.ear.left, true),
    head: getRad(facePoints.nose, hipMPoint),
    //肩膀
    shoulder: getRad(facePoints.shoulder.right, facePoints.shoulder.left, true),
    // 胳膊
    shoulderToElbowL: getRad(facePoints.shoulder.right, facePoints.elbow.right) - 0.5,
    shoulderToElbowR: getRad(facePoints.shoulder.left, facePoints.elbow.left) + 0.5,
    //手臂
    elbowToWristL: getRad(facePoints.elbow.right, facePoints.wrist.right) - 0.5,
    elbowToWristR: getRad(facePoints.elbow.left, facePoints.wrist.left) + 0.5,
    //骨盆
    hip: getRad(facePoints.hip.right, facePoints.hip.left, true),
    //大腿
    hipToKneeL: getRad(facePoints.hip.right, facePoints.knee.right),
    hipToKneeR: getRad(facePoints.hip.left, facePoints.knee.left),
    //小腿
    kneeToAnkleL: getRad(facePoints.knee.right, facePoints.ankle.right),
    kneeToAnkleR: getRad(facePoints.knee.left, facePoints.ankle.left)
  };
  //具体描绘的参数
  var locationInfo = {
    head: {
      key: 'head',
      type: 'normal',
      x: 0,
      y: 0,
      width: 94,
      height: 152,
      offsetW: faceWidth / 2 - 40,
      offsetH: -20,
      translateX: 0,
      //translateX: faceWidth / 2,
      translateY: 0,
      //translateY: 152,
      rotate: 0,
      //rotate: faceRad.head,
      afterTranslate: false,
      //afterTranslate:true,
      globalCompositeOperation: 'source-over'
    },
    body: {
      key: 'body',
      type: 'normal',
      //x: bodyDirection.position=== 'shoulder' ? bodyDirection.lOrR === 'left' ? 1120 : 1400 : bodyDirection.position === 'pelvis' ?  bodyDirection.lOrR === 'left' ? 560 : 840 : 280,
      x: 556,
      y: 0,
      width: 230,
      height: 330,
      offsetW: faceWidth / 2 - 111,
      offsetH: 82,
      translateX: 0,
      //translateX: 0,
      translateY: 0,
      //translateY: 0,
      rotate: 0,
      //rotate: 0,
      afterTranslate: false
      //afterTranslate:false,
    },
    trunk: {
      key: 'trunk',
      type: 'pain',
      x: 560,
      y: 800,
      width: 94,
      height: 200,
      offsetW: faceWidth / 2 - 36,
      offsetH: 202,
      translateX: 0,
      //translateX: 0,
      translateY: 0,
      //translateY: 0 ,
      rotate: 0,
      //rotate: 0,
      afterTranslate: false,
      //afterTranslate:false,
      descriptionX: faceWidth - 182,
      descriptionY: 240,
      descriptionWidth: 180,
      descriptionHeight: 40,
      description: 'weak',
      lineX: faceWidth - 182 + 10 / 4,
      lineY: 240 + 40 - 10 / 4,
      moveX: faceWidth / 2 + 5,
      moveY: 265,
      globalCompositeOperation: 'source-over'
    },
    thigh: {
      left: {
        key: 'thigh-left',
        type: 'normal',
        x: 280,
        y: 400,
        width: 94,
        height: 250,
        offsetW: faceWidth / 2 + 5,
        offsetH: 322,
        translateX: 0,
        //translateX:faceWidth/2+75,
        translateY: 0,
        //translateY:382,
        rotate: 0,
        //rotate: faceRad.hipToKneeR,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'thigh-right',
        type: 'normal',
        x: 0,
        y: 400,
        width: 100,
        height: 250,
        offsetW: faceWidth / 2 - 89,
        offsetH: 322,
        translateX: 0,
        //translateX:faceWidth/2-59,
        translateY: 0,
        //translateY:382,
        rotate: 0,
        //rotate: faceRad.hipToKneeL,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      }
    },
    legForO: {
      right: {
        key: 'legForO-right',
        type: 'pain',
        x: 0,
        y: 800,
        width: 100,
        height: 100,
        offsetW: faceWidth / 2 - 79,
        offsetH: 326,
        translateX: 0,
        //translateX:faceWidth/2-59,
        translateY: 0,
        //translateY:382,
        rotate: 0,
        //rotate: faceRad.hipToKneeL,
        afterTranslate: false,
        //afterTranslate:true,
        // descriptionX:0,
        // descriptionY:400,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'tension',
        // lineX:180-10/4,
        // lineY:400+10/4,
        // moveX:faceRad.hipToKneeL>0?faceWidth/2-111+30-10+2-position(faceRad.hipToKneeL,'x',50)+25 : faceWidth/2-111+30-10+2+position(faceRad.hipToKneeL,'x',50)+25,
        // moveY:152-70+330-80-10+position(faceRad.hipToKneeL,'y',50),
        globalCompositeOperation: 'source-over'
      },
      left: {
        key: 'legForO-left',
        type: 'pain',
        x: 280,
        y: 800,
        width: 100,
        height: 100,
        offsetW: faceWidth / 2 + 50,
        offsetH: 326,
        translateX: 0,
        //translateX:faceWidth/2+35,
        translateY: 0,
        //translateY:382,
        rotate: 0,
        //rotate: faceRad.hipToKneeR,
        afterTranslate: false,
        //afterTranslate:true,
        descriptionX: faceWidth - 182,
        descriptionY: 450,
        descriptionWidth: 180,
        descriptionHeight: 40,
        description: 'tension',
        lineX: faceWidth - 182 + 10 / 4,
        lineY: 450 + 10 / 4,
        moveX: faceWidth / 2 + position(faceRad.hipToKneeR, 'x', 50) + 70,
        moveY: 322 + position(faceRad.hipToKneeR, 'y', 50),
        globalCompositeOperation: 'source-over'
      }
    },
    legForX: {
      right1: {
        key: 'legForX-right1',
        type: 'pain',
        x: 840,
        y: 800,
        width: 100,
        height: 100,
        offsetW: faceWidth / 2 - 78,
        offsetH: 326,
        translateX: 0,
        //translateX:faceWidth/2-59,
        translateY: 0,
        //translateY:382,
        rotate: 0,
        //rotate: faceRad.hipToKneeL,
        afterTranslate: false,
        //afterTranslate:true,
        // descriptionX:0,
        // descriptionY:400,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:180-10/4,
        // lineY:400+10/4,
        // moveX:faceRad.hipToKneeL>0?faceWidth/2-111+30-10+2-position(faceRad.hipToKneeL,'x',50)+25 : faceWidth/2-111+30-10+2+position(faceRad.hipToKneeL,'x',50)+25,
        // moveY:152-70+330-80-10+position(faceRad.hipToKneeL,'y',50),
        globalCompositeOperation: 'source-over'
      },
      right2: {
        key: 'legForX-right2',
        type: 'pain',
        x: 1400,
        y: 800,
        width: 200,
        height: 200,
        offsetW: faceWidth / 2 - 37,
        offsetH: 342,
        translateX: 0,
        //translateX:faceWidth/2-59,
        translateY: 0,
        //translateY:382,
        rotate: 0,
        //rotate: faceRad.hipToKneeL,
        afterTranslate: false,
        //afterTranslate:true,
        descriptionX: 1,
        descriptionY: 160,
        descriptionWidth: 180,
        descriptionHeight: 40,
        description: 'tension',
        lineX: 178.5,
        lineY: 197.5,
        moveX: faceWidth / 2 + position(faceRad.hipToKneeL, 'x', 50) - 15,
        moveY: 342 + position(faceRad.hipToKneeL, 'y', 100),
        globalCompositeOperation: 'source-over'
      },
      left1: {
        key: 'legForX-left1',
        type: 'pain',
        x: 1120,
        y: 800,
        width: 100,
        height: 100,
        offsetW: faceWidth / 2 + 51,
        offsetH: 326,
        translateX: 0,
        //translateX:faceWidth/2+35,
        translateY: 0,
        //translateY:382,
        rotate: 0,
        //rotate: faceRad.hipToKneeR,
        afterTranslate: false,
        //afterTranslate:true,
        descriptionX: faceWidth - 182,
        descriptionY: 450,
        descriptionWidth: 180,
        descriptionHeight: 40,
        description: 'weak',
        lineX: faceWidth - 179.5,
        lineY: 452.5,
        moveX: faceWidth / 2 + position(faceRad.hipToKneeR, 'x', 50) + 70,
        moveY: 322 + position(faceRad.hipToKneeR, 'y', 50),
        globalCompositeOperation: 'source-over'
      },
      left2: {
        key: 'legForX-left2',
        type: 'pain',
        x: 1680,
        y: 800,
        width: 200,
        height: 200,
        offsetW: faceWidth / 2 + 9,
        offsetH: 342,
        translateX: 0,
        //translateX:faceWidth/2+35,
        translateY: 0,
        //translateY:382,
        rotate: 0,
        //rotate: faceRad.hipToKneeR,
        afterTranslate: false,
        //afterTranslate:true,
        // descriptionX:faceWidth-180-2,
        // descriptionY:470,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'tension',
        // lineX:faceWidth-180+10/4-2,
        // lineY:470+10/4,
        // moveX:faceWidth/2-111+111+5+position(faceRad.hipToKneeR,'x',60)+20,
        // moveY:152-70+330-90+position(faceRad.hipToKneeR,'y',120),
        globalCompositeOperation: 'source-over'
      }
    },
    legForStretch: {
      left: {
        key: 'legForStretch-left',
        type: 'pain',
        x: 2240,
        y: 800,
        width: 200,
        height: 200,
        offsetW: faceWidth / 2 + 41,
        offsetH: 350,
        translateX: 0,
        //translateX:faceWidth/2+35,
        translateY: 0,
        //translateY:382,
        rotate: 0,
        //rotate: faceRad.hipToKneeR,
        afterTranslate: false,
        //afterTranslate:true,
        // descriptionX:faceWidth-220-2,
        // descriptionY:540,
        // descriptionWidth:220,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:faceWidth-220+10/4-2,
        // lineY:540+10/4,
        // moveX:faceWidth/2-111+111+5+position(faceRad.hipToKneeR,'x',60)+50,
        // moveY:152-70+330-90+position(faceRad.hipToKneeR,'y',120),
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'legForStretch-right',
        type: 'pain',
        x: 1960,
        y: 800,
        width: 200,
        height: 200,
        offsetW: faceWidth / 2 - 80,
        offsetH: 346,
        translateX: 0,
        //translateX:faceWidth/2-59,
        translateY: 0,
        //translateY:382,
        rotate: 0,
        //rotate: faceRad.hipToKneeL,
        afterTranslate: false,
        //afterTranslate:true,
        descriptionX: 1,
        descriptionY: 500,
        descriptionWidth: 180,
        descriptionHeight: 40,
        description: 'weak',
        lineX: 178.5,
        lineY: 502.5,
        moveX: faceWidth / 2 + position(faceRad.hipToKneeL, 'x', 60) - 50,
        moveY: position(faceRad.hipToKneeL, 'y', 120) + 324,
        globalCompositeOperation: 'source-over'
      }
    },
    shank: {
      left: {
        key: 'shank-left',
        type: 'normal',
        x: 560,
        y: 400,
        width: 58,
        height: 250,
        offsetW: faceWidth / 2 + position(faceRad.hipToKneeL, 'x', 190) - 84,
        offsetH: 322 + position(faceRad.hipToKneeL, 'y', 190),
        translateX: 0,
        //translateX:faceWidth/2-81,
        translateY: 0,
        //translateY:382,
        rotateBefore: false,
        //rotateBefore: true,
        //translateXBefore: faceWidth/2+position(faceRad.hipToKneeL,'x',190)-16,
        //translateYBefore: position(faceRad.hipToKneeL,'y',190)+347,//
        rotateBeforeRad: 0,
        //rotateBeforeRad:faceRad.kneeToAnkleL,
        rotate: 0,
        //rotate: faceRad.hipToKneeL,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'shank-right',
        type: 'normal',
        x: 840,
        y: 400,
        width: 58,
        height: 250,
        offsetW: faceWidth / 2 + position(faceRad.hipToKneeR, 'x', 190) + 30,
        offsetH: 322 + position(faceRad.hipToKneeR, 'y', 190),
        translateX: 0,
        //translateX:faceWidth/2+75,
        translateY: 0,
        //translateY:392,
        rotateBefore: false,
        //rotateBefore: true,
        //translateXBefore:faceWidth/2+position(faceRad.hipToKneeR,'x',190)+45,
        //translateYBefore:position(faceRad.hipToKneeR,'y',190)+352,//
        rotateBeforeRad: 0,
        //rotateBeforeRad:faceRad.kneeToAnkleR,
        rotate: 0,
        //rotate: faceRad.hipToKneeR,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      }
    },
    foot: {
      left: {
        key: 'foot-left',
        type: 'normal',
        x: 1400,
        y: 400,
        width: 68,
        height: 68,
        offsetW: faceWidth / 2 + position(faceRad.hipToKneeR, 'x', 190) + 45,
        offsetH: position(faceRad.hipToKneeR, 'y', 190) + 502,
        translateX: 0,
        //translateX:faceWidth/2+position(faceRad.hipToKneeR,'x',190)+45,
        translateY: 0,
        //translateY:position(faceRad.hipToKneeR,'y',190)+352,
        rotate: 0,
        //rotate: faceRad.kneeToAnkleR,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'foot-right',
        type: 'normal',
        x: 1120,
        y: 400,
        width: 68,
        height: 68,
        offsetW: faceWidth / 2 - 109 + position(faceRad.hipToKneeL, 'x', 190),
        offsetH: 502 + position(faceRad.hipToKneeL, 'y', 190),
        translateX: 0,
        //translateX: faceWidth/2-16+position(faceRad.hipToKneeL,'x',190),
        translateY: 0,
        //translateY:347+position(faceRad.hipToKneeL,'y',190),
        rotate: 0,
        //rotate: faceRad.kneeToAnkleL,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      }
    },
    upperArm: {
      left: {
        key: 'upperArm-left',
        type: 'normal',
        x: 1679,
        y: -20,
        width: 120,
        height: 160,
        offsetW: faceWidth / 2 - 152,
        offsetH: 116,
        translateX: 0,
        //translateX:faceWidth/2-90,
        translateY: 0,
        //translateY:141,
        rotate: 0,
        //rotate:faceRad.shoulderToElbowL,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'upperArm-right',
        type: 'normal',
        x: 1960,
        y: 0,
        width: 120,
        height: 160,
        offsetW: faceWidth / 2 + 83,
        offsetH: 113,
        translateX: 0,
        //translateX:faceWidth/2+84,
        translateY: 0,
        //translateY: 141,
        rotate: -10 * Math.PI / 180,
        //rotate: faceRad.shoulderToElbowR,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      }
    },
    foreArm: {
      left: {
        key: 'foreArm-left',
        type: 'normal',
        x: 2234,
        y: -8,
        width: 150,
        height: 190,
        offsetW: faceWidth / 2 - 147 + position(faceRad.shoulderToElbowL + 0.5, 'x', 120) - 60,
        offsetH: 100 + position(faceRad.shoulderToElbowL + 0.5, 'y', 120),
        translateX: 0,
        //translateX:faceWidth/2-80,
        translateY: 0,
        //translateY:141,
        rotateBefore: false,
        //rotateBefore: true,
        //translateXBefore:faceWidth/2-85+position(faceRad.shoulderToElbowL+0.5,'x',120),
        //translateYBefore:position(faceRad.shoulderToElbowL+0.5,'y', 120) + 150,//
        rotateBeforeRad: 0,
        //rotateBeforeRad:faceRad.elbowToWristL,
        rotate: 0,
        //rotate:faceRad.shoulderToElbowL,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'foreArm-right',
        type: 'normal',
        x: 2520,
        y: 0,
        width: 150,
        height: 190,
        offsetW: faceWidth / 2 + 113 + position(faceRad.shoulderToElbowR - 0.5, 'x', 120),
        offsetH: 100 + position(faceRad.shoulderToElbowR - 0.5, 'y', 120),
        translateX: 0,
        //translateX:faceWidth/2+84,
        translateY: 0,
        //translateY: 141,
        rotateBefore: false,
        //rotateBefore: true,
        //translateXBefore:faceWidth/2+82+position(faceRad.shoulderToElbowR-0.5,'x',120),
        //translateYBefore: 141+position(faceRad.shoulderToElbowR-0.5,'y',120),//
        rotateBeforeRad: 0,
        //rotateBeforeRad:faceRad.elbowToWristR,
        rotate: 0,
        //rotate: faceRad.shoulderToElbowR,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      }
    },
    round: {
      left: {
        key: 'round-left',
        type: 'pain',
        x: 1680,
        y: 400,
        width: 100,
        height: 100,
        offsetW: faceWidth / 2 - 70,
        offsetH: 125,
        translateX: 0,
        //translateX:0,
        translateY: 0,
        //translateY:0,
        rotate: 0,
        //rotate: 0,
        // descriptionX:0,
        // descriptionY:400,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'tension',
        // lineX:180-10/4,
        // lineY:400+10/4,
        // moveX:faceRad.hipToKneeL>0?faceWidth/2-111+30-10+2-position(faceRad.hipToKneeL,'x',50)+25 : faceWidth/2-111+30-10+2+position(faceRad.hipToKneeL,'x',50)+25,
        // moveY:152-70+330-80-10+position(faceRad.hipToKneeL,'y',50),
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'round-right',
        type: 'pain',
        x: 1960,
        y: 400,
        width: 100,
        height: 100,
        offsetW: faceWidth / 2 + 5,
        offsetH: 125,
        translateX: 0,
        //translateX:0,
        translateY: 0,
        //translateY:0,
        rotate: 0,
        //rotate: 0,
        descriptionX: faceWidth - 150 - 2,
        descriptionY: 80,
        descriptionWidth: 150,
        descriptionHeight: 40,
        description: 'weak',
        lineX: faceWidth - 150 - 2 + 2.5,
        lineY: 80 + 40 - 2.5,
        moveX: faceWidth / 2 + 50,
        moveY: 160,
        globalCompositeOperation: 'source-over'
      }
    }
    //描绘部位顺序
  };var faceOrder = ['head', 'body', 'foot-right', 'thigh-left', 'thigh-right', 'shank-right', 'upperArm-right', 'foreArm-right', 'upperArm-left', 'foreArm-left', 'shank-left', 'foot-left', 'foot-right', 'legForStretch-left', 'legForStretch-right', 'legForO-right', 'legForO-left', 'legForX-left1', 'legForX-left2', 'legForX-right1', 'legForX-right2', 'trunk', 'round-left', 'round-right'];

  var facePain = getPainArr('face', data.conclusion, pains);
  ////console.log('facePain->',facePain);
  // 按身体部位绘制顺序取出每个部位的具体信息
  var faceOrderInfos = getOrderInfos(locationInfo, faceOrder);
  //开始绘制
  var faceImg = new Image();
  faceImg.src = imgSrc.bone.faceBone;

  var faceBodyImg = new Image();
  faceBodyImg.src = faceBodyPostion.imgUrl;

  faceImg.onload = function () {
    var ctx = faceCanvas.getContext('2d');
    //console.log("img w:",faceImg.width," img H:",faceImg.height,'faceWidth:',faceWidth,faceBodyImg.width)
    faceBodyPostion.sx = 0;
    faceBodyPostion.sy = 0;
    faceBodyPostion.x = (document.documentElement.clientWidth - 1290 * 0.34 / 3) / 2 - 27;
    faceBodyPostion.y = -50;
    faceBodyPostion.width = 1219 * 0.34;
    faceBodyPostion.height = 913 * 0.9;
    drawBone('face', ctx, faceOrderInfos, facePain, faceImg, 0, (windowHeight - 89) * 220 / faceHeight, faceBodyPostion);
  };
}
//侧面数据
function drawSideBone(data, canvas) {
  var sideCanvas = canvas;
  var windowWidth = document.documentElement.clientWidth > 1025 ? document.documentElement.clientWidth / 2 : document.documentElement.clientWidth;

  var windowHeight = window.screen.height;
  sideCanvas.width = windowWidth * 1.7;
  sideWidth = sideCanvas.width;
  sideHeight = sideCanvas.height;

  if (document.documentElement.clientWidth >= 1500) {
    windowWidth = windowWidth / 2 * 1.1 - 5;
  }

  var sideBody = document.documentElement.clientWidth;

  if (sideBody < 700) {
    sideBody = sideBody / 2 * 0.9 - 10;
  } else if (sideBody >= 700 && sideBody < 1500) {
    sideBody = sideBody * 0.6 + 33;
  } else {
    sideBody = sideBody / 3 + 20;
  }
  var sideBodyPostion = {
    imgUrl: imgSrc.bone.boneCanvas,
    sx: 400,
    sy: 50,
    swidth: 380,
    sheight: 800,
    //x:sideWidth/3*0.8,
    x: sideBody,
    y: -20,
    width: 380,
    height: 800

  };

  var sideRisks = data.conclusion.side.risks;
  var sidePoints = data.conclusion.side.points;
  var sideDirection = data.conclusion.side.side;
  var bodyDirection = getBodyDirection('side', sideRisks);
  ////console.log('sideBodyDirection->',sidePoints['shoulder'][sideDirection], sidePoints['elbow'][sideDirection])
  var sideRad = {
    earToShoulder: getRad(sidePoints['ear'][sideDirection], sidePoints['shoulder'][sideDirection]),
    shoulderToElbow: getRad(sidePoints['shoulder'][sideDirection], sidePoints['elbow'][sideDirection]) + 0.1,
    elbowToWrist: getRad(sidePoints['elbow'][sideDirection], sidePoints['wrist'][sideDirection]) + 0.2,
    hipToKnee: getRad(sidePoints['hip'][sideDirection], sidePoints['knee'][sideDirection]),
    kneeToAnkle: getRad(sidePoints['knee'][sideDirection], sidePoints['ankle'][sideDirection])
  };
  ////console.log('sideRad.shoulderToElbow',sideRad.shoulderToElbow)
  var sideLocationInfo = {
    head: {
      key: 'head',
      type: 'normal',
      x: 0,
      y: 0,
      width: 114,
      height: 156,
      offsetW: sideWidth / 2,
      offsetH: 0,
      translateX: 0,
      //translateX: sideWidth/2+57,
      translateY: 0,
      //translateY: 156,
      rotate: 0,
      //rotate: sideRad.earToShoulder,
      afterTranslate: false
      //afterTranslate:true,
    },
    body: {
      key: 'body',
      type: 'normal',
      x: bodyDirection.position === 'round' ? 560 : 280,
      y: 0,
      width: 200,
      height: 300,
      offsetW: bodyDirection.position === 'round' ? sideWidth / 2 - 40 : sideWidth / 2 - 10,
      offsetH: 106,
      translateX: 0,
      //translateX: 0,
      translateY: 0,
      //translateY: 0,
      rotate: 0,
      //rotate: 0,
      afterTranslate: false
      //afterTranslate:false,
    },
    shank: {
      key: 'shank',
      type: 'normal',
      x: 1400,
      y: 0,
      width: 100,
      height: 270,
      offsetW: sideWidth / 2,
      offsetH: 306,
      translateX: 0,
      //translateX: sideWidth/2+50,
      translateY: 0,
      //translateY: 346,
      rotate: 0,
      //rotate: sideRad.hipToKnee,
      afterTranslate: false,
      //afterTranslate:true,
      globalCompositeOperation: 'source-over'
    },
    thigh: {
      key: 'thigh',
      type: 'normal',
      x: 1680,
      y: 0,
      width: 140,
      height: 270,
      offsetW: sideWidth / 2 + position(sideRad.hipToKnee, 'x', 230),
      offsetH: 306 + position(sideRad.hipToKnee, 'y', 230),
      translateX: 0,
      //translateX: sideWidth/2+50,
      translateY: 0,
      //translateY: 346,
      rotateBefore: false,
      //rotateBefore: true,
      //translateXBefore:sideWidth/2+position(sideRad.hipToKnee,'x',230)+50,
      //translateYBefore:336+position(sideRad.hipToKnee,'y',230),//
      rotateBeforeRad: 0,
      //rotateBeforeRad:sideRad.kneeToAnkle,
      rotate: 0,
      //rotate: sideRad.hipToKnee,
      afterTranslate: false,
      //afterTranslate:true,
      globalCompositeOperation: 'source-over'
    },
    upperArm: {
      key: 'upperArm',
      type: 'normal',
      x: 840,
      y: 0,
      width: 100,
      height: 200,
      offsetW: sideWidth / 2 - 20,
      offsetH: 150,
      translateX: 0,
      //translateX: sideWidth / 2+40,
      translateY: 0,
      //translateY: 165,
      rotate: 0,
      //rotate: sideRad.shoulderToElbow,
      afterTranslate: false,
      //afterTranslate:true,
      globalCompositeOperation: 'source-over'
    },
    foreArm: {
      key: 'upperArm',
      type: 'normal',
      x: 1120,
      y: 0,
      width: 100,
      height: 250,
      offsetW: sideWidth / 2 + position(sideRad.shoulderToElbow, 'x', 110) - 10,
      offsetH: 140 + position(sideRad.shoulderToElbow, 'y', 110) - 20,
      translateX: 0,
      //translateX: sideWidth / 2+40,
      translateY: 0,
      //translateY: 165,
      rotateBefore: false,
      //rotateBefore: true,
      //translateXBefore:sideWidth / 2+position(sideRad.shoulderToElbow,'x',110)+20,
      //translateYBefore:140+position(sideRad.shoulderToElbow,'y',110)+20,//
      rotateBeforeRad: 0,
      //rotateBeforeRad:sideRad.elbowToWrist,
      rotate: 0,
      //rotate: sideRad.shoulderToElbow,
      afterTranslate: false,
      //afterTranslate:true,
      globalCompositeOperation: 'source-over'
    },
    round: {
      key: 'round',
      type: 'pain',
      x: 0,
      y: 400,
      width: 50,
      height: 50,
      offsetW: sideWidth / 2 + 20,
      offsetH: 80,
      translateX: 0,
      //translateX: sideWidth/2+57,
      translateY: 0,
      //translateY: 156,
      rotate: 0,
      //rotate: sideRad.earToShoulder,
      afterTranslate: false,
      //afterTranslate:true,
      descriptionX: sideWidth - 162,
      descriptionY: 180,
      descriptionWidth: 210,
      descriptionHeight: 40,
      description: 'tension',
      lineX: sideWidth - 159.5,
      lineY: 182.5,
      moveX: sideWidth / 2 + 50 - position(sideRad.earToShoulder, 'x', 60),
      moveY: 130 - position(sideRad.earToShoulder, 'y', 30),
      globalCompositeOperation: 'source-over'
    },
    fore: {
      key: 'fore',
      type: 'pain',
      x: 840,
      y: 400,
      width: 50,
      height: 50,
      offsetW: sideWidth / 2 + 20,
      offsetH: 80,
      translateX: 0,
      //translateX: sideWidth/2+57,
      translateY: 0,
      //translateY: 156,
      rotate: 0,
      //rotate: sideRad.earToShoulder,
      afterTranslate: false,
      //afterTranslate:true,
      descriptionX: sideWidth - 162,
      descriptionY: 180,
      descriptionWidth: 210,
      descriptionHeight: 40,
      description: 'tension',
      lineX: sideWidth - 159.5,
      lineY: 182.5,
      moveX: sideWidth / 2 + 50 - position(sideRad.earToShoulder, 'x', 60),
      moveY: 130 - position(sideRad.earToShoulder, 'y', 30),
      globalCompositeOperation: 'source-over'
    },
    shoulder: {
      left: {
        key: 'shoulder-left',
        type: 'pain',
        x: 280,
        y: 400,
        width: 50,
        height: 50,
        offsetW: sideWidth / 2 + 20,
        offsetH: 80,
        translateX: 0,
        //translateX: sideWidth/2+57,
        translateY: 0,
        //translateY: 156,
        rotate: 0,
        //rotate: sideRad.earToShoulder,
        afterTranslate: false,
        //afterTranslate:true,
        descriptionX: 51,
        descriptionY: 180,
        descriptionWidth: 150,
        descriptionHeight: 40,
        description: 'weak',
        lineX: 198.5,
        lineY: 182.5,
        moveX: sideWidth / 2 + 40 - position(sideRad.earToShoulder, 'x', 60),
        moveY: 140 - position(sideRad.earToShoulder, 'y', 30),
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'shoulder-right',
        type: 'pain',
        x: 560,
        y: 400,
        width: 50,
        height: 50,
        offsetW: sideWidth / 2 + 20,
        offsetH: 80,
        translateX: 0,
        //translateX: sideWidth/2+57,
        translateY: 0,
        //translateY: 156,
        rotate: 0,
        //rotate: sideRad.earToShoulder,
        afterTranslate: false,
        //afterTranslate:true,
        descriptionX: 51,
        descriptionY: 180,
        descriptionWidth: 150,
        descriptionHeight: 40,
        description: 'tension',
        lineX: 198.5,
        lineY: 182.5,
        moveX: sideWidth / 2 + 40 - position(sideRad.earToShoulder, 'x', 60),
        moveY: 140 - position(sideRad.earToShoulder, 'y', 30),
        globalCompositeOperation: 'source-over'
      }
    }
  };

  var sideOrder = ['head', 'body', 'shank', 'thigh', 'upperArm', 'foreArm', 'round', 'fore', 'shoulder-left', 'shoulder-right'];

  var sidePain = getPainArr('side', data.conclusion, pains);
  ////console.log('sidePain->',sidePain);

  var sideOrderInfos = getOrderInfos(sideLocationInfo, sideOrder);
  var sideImg = new Image();
  sideImg.src = imgSrc.bone.sideBone;

  sideImg.onload = function () {
    var ctx = sideCanvas.getContext('2d');
    drawBone('side', ctx, sideOrderInfos, sidePain, sideImg, -50, (windowHeight - 89) * 220 / sideHeight, sideBodyPostion);
  };
}
//背面数据
function drawBackBone(data, canvas) {
  var backCanvas = canvas;
  var windowWidth = document.documentElement.clientWidth > 1025 ? document.documentElement.clientWidth / 2 : document.documentElement.clientWidth;
  var windowHeight = window.screen.height;

  backCanvas.width = windowWidth * 1.7;
  backWidth = backCanvas.width;
  backHeight = backCanvas.height;
  //取对应的点
  var backPoints = data.conclusion.face.points;
  var backRisks = data.conclusion.face.risks.concat(data.conclusion.side.risks);
  var bodyDirection = getBodyDirection('back', backRisks);
  //////console.log("backBodyDirection->",bodyDirection);
  var backBody = document.documentElement.clientWidth;

  if (backBody < 700) {
    backBody = backBody / 3 * 0.94;
  } else if (backBody >= 700 && backBody < 1500) {
    backBody = backBody / 2 + 65;
  } else {
    backBody = backBody / 3 - 25;
  }
  var backBodyPostion = {
    imgUrl: imgSrc.bone.boneCanvas,
    sx: 700,
    sy: 50,
    swidth: 500,
    sheight: 800,
    x: sideWidth / 3 * 0.8,
    //x:0,
    y: 15,
    width: 500,
    height: 700

  };
  var hipRPoint = backPoints['hip']['right'];
  var hipLPoint = backPoints['hip']['left'];
  var hipMPoint = {
    x: 0,
    y: 0
  };
  if (hipLPoint.x === 0 && hipLPoint.y === 0 || hipRPoint.x === 0 && hipRPoint.y === 0) {} else {
    // 计算左右骨盆连线中点
    hipMPoint.x = (hipLPoint.x + hipRPoint.x) / 2;
    hipMPoint.y = (hipLPoint.y + hipRPoint.y) / 2;
  };
  backRad = {
    //头部
    head: getRad(backPoints.nose, hipMPoint),
    // head: getRad(backPoints.ear.right, backPoints.ear.left, true),
    //肩膀
    shoulder: getRad(backPoints.shoulder.right, backPoints.shoulder.left, true),
    //胳膊
    shoulderToElbowL: getRad(backPoints.shoulder.right, backPoints.elbow.right) - 0.5,
    shoulderToElbowR: getRad(backPoints.shoulder.left, backPoints.elbow.left) + 0.5,
    //手臂
    elbowToWristL: getRad(backPoints.elbow.right, backPoints.wrist.right) - 0.3,
    elbowToWristR: getRad(backPoints.elbow.left, backPoints.wrist.left) + 0.3,
    //骨盆
    hip: getRad(backPoints.hip.right, backPoints.hip.left, true),
    // 大腿
    hipToKneeL: getRad(backPoints.hip.right, backPoints.knee.right),
    hipToKneeR: getRad(backPoints.hip.left, backPoints.knee.left),
    // 小腿
    kneeToAnkleL: getRad(backPoints.knee.right, backPoints.ankle.right),
    kneeToAnkleR: getRad(backPoints.knee.left, backPoints.ankle.left)
  };
  var thighLeftTranslateX = backWidth / 2,
      thighLeftTranslateY = 376;
  var thighRightTranslateX = backWidth / 2 + 105,
      thighRightTranslateY = 376;
  var translateX = -35;
  var backLocationInfo = {
    head: {
      key: 'head',
      type: 'normal',
      x: 0,
      y: 0,
      width: 114,
      height: 140,
      offsetW: backWidth / 2,
      offsetH: -10,
      translateX: 0,
      //translateX: backWidth/2+57,
      translateY: 0,
      //translateY: 156,
      rotate: 0,
      //rotate: -backRad.head,
      afterTranslate: false
      //afterTranslate:true,
    },
    body: {
      key: 'body',
      type: 'normal',
      x: bodyDirection.position === 'rake' ? 560 : bodyDirection.position === 'shoulder' ? bodyDirection.lOrR === 'left' ? 840 : 1120 : 280,
      y: 0,
      width: 260,
      height: 380,
      offsetW: backWidth / 2 - 65,
      offsetH: 86,
      translateX: 0,
      //translateX: 0,
      translateY: 0,
      //translateY: 0,
      rotate: 0,
      //rotate: 0,
      afterTranslate: false
      //afterTranslate:false,
    },
    shank: {
      left: {
        key: 'shank-left',
        type: 'normal',
        x: 2520,
        y: 0,
        width: 100,
        height: 260,
        offsetW: backWidth / 2 - 50,
        offsetH: 336,
        translateX: 0,
        //translateX: thighLeftTranslateX,
        translateY: 0,
        //translateY: thighLeftTranslateY,
        rotateBefore: false,
        //rotateBefore: 0,
        rotate: 0,
        //rotate: -backRad.hipToKneeR,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'shank-right',
        type: 'normal',
        x: 2800,
        y: 0,
        width: 100,
        height: 260,
        offsetW: backWidth / 2 + 35,
        offsetH: 336,
        translateX: 0,
        //translateX: thighRightTranslateX,
        translateY: 0,
        //translateY: thighRightTranslateY,
        rotate: 0,
        //rotate: -backRad.hipToKneeL,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      }
    },
    thigh: {
      left: {
        key: 'thigh-left',
        type: 'normal',
        x: 3080,
        y: 0,
        width: 100,
        height: 260,
        offsetW: backWidth / 2 - 55 + position(-backRad.hipToKneeR, 'x', 180),
        offsetH: 336 + position(-backRad.hipToKneeR, 'y', 180),
        translateX: 0,
        //translateX: thighLeftTranslateX,
        translateY: 0,
        //translateY: thighLeftTranslateY,
        rotateBefore: false,
        //rotateBefore: true,
        //translateXBefore:backWidth/2-15+position(-backRad.hipToKneeR,'x',180),
        //translateYBefore:376+position(-backRad.hipToKneeR,'y',180),//
        rotateBeforeRad: 0,
        //rotateBeforeRad:-backRad.kneeToAnkleR,
        rotate: 0,
        //rotate: -backRad.hipToKneeR,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'thigh-right',
        type: 'normal',
        x: 3360,
        y: 0,
        width: 100,
        height: 260,
        offsetW: backWidth / 2 + 69 + position(-backRad.hipToKneeL, 'x', 180),
        offsetH: 336 + position(-backRad.hipToKneeL, 'y', 180),
        translateX: 0,
        //translateX: thighRightTranslateX,
        translateY: 0,
        //translateY: thighRightTranslateY,
        rotateBefore: false,
        //rotateBefore: true,
        //translateXBefore:backWidth/2+104+position(-backRad.hipToKneeL,'x',180),
        //translateYBefore:376+position(-backRad.hipToKneeL,'y',180),//
        rotateBeforeRad: 0,
        //rotateBeforeRad:-backRad.kneeToAnkleL,
        rotate: 0,
        //rotate: -backRad.hipToKneeL,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      }
    },
    upperArm: {
      left: {
        key: 'upperArm-left',
        type: 'normal',
        x: 1400,
        y: 0,
        width: 140,
        height: 180,
        offsetW: backWidth / 2 - 120,
        offsetH: 130,
        translateX: 0,
        //translateX: backWidth/2-40,
        translateY: 0,
        //translateY: 180,
        rotate: 0,
        //rotate: -backRad.shoulderToElbowR,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'upperArm-right',
        type: 'normal',
        x: 1680,
        y: 0,
        width: 140,
        height: 260,
        offsetW: backWidth / 2 + 110,
        offsetH: 135,
        translateX: 0,
        //translateX: backWidth/2+130,
        translateY: 0,
        //translateY: 185,
        rotate: 0,
        //rotate:  -backRad.shoulderToElbowL,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      }
    },
    foreArm: {
      left: {
        key: 'foreArm-left',
        type: 'normal',
        x: 1960,
        y: 0,
        width: 140,
        height: 260,
        offsetW: backWidth / 2 - 185 + position(-backRad.shoulderToElbowR + 0.5, 'x', 140) + 32,
        offsetH: 125 + position(-backRad.shoulderToElbowR + 0.5, 'y', 140),
        translateX: 0,
        //translateX: backWidth/2-40,
        translateY: 0,
        //translateY: 180,
        rotateBefore: false,
        //rotateBefore: true,
        //translateXBefore:backWidth/2-120+position(-backRad.shoulderToElbowR+0.5,'x',140)+20+70,
        //translateYBefore:130+position(-backRad.shoulderToElbowR+0.5,'y',140)+35,//
        rotateBeforeRad: 0,
        //rotateBeforeRad: -backRad.elbowToWristR,
        rotate: 0,
        //rotate:-backRad.shoulderToElbowR,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'foreArm-right',
        type: 'normal',
        x: 2240,
        y: 0,
        width: 140,
        height: 260,
        offsetW: backWidth / 2 + 165 + position(-backRad.shoulderToElbowL - 0.5, 'x', 140) - 10,
        offsetH: 135 + position(-backRad.shoulderToElbowL - 0.5, 'y', 140) - 4,
        translateX: 0,
        //translateX: backWidth/2+130,
        translateY: 0,
        //translateY: 185,
        rotateBefore: false,
        //rotateBefore: true,
        //translateXBefore:backWidth/2+97+position(-backRad.shoulderToElbowL-0.5,'x',140)-10+35,
        //translateYBefore:135+position(-backRad.shoulderToElbowL-0.5,'y',140)-4+40,//
        //// translateXBefore:backWidth/2+122+position(-backRad.shoulderToElbowL-0.5,'x',140)+5,
        //// translateYBefore:175+position(-backRad.shoulderToElbowL-0.5,'y',140)-12,//
        rotateBeforeRad: 0,
        //rotateBeforeRad:-backRad.elbowToWristL,
        rotate: 0,
        //rotate: -backRad.shoulderToElbowL,
        afterTranslate: false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      }
    },
    spine: {
      left1: {
        key: 'spine-left1',
        type: 'pain',
        x: 0,
        y: 400,
        width: 100,
        height: 100,
        offsetW: backWidth / 2 - 20,
        offsetH: 115,
        translateX: 0,
        //translateX: 0,
        translateY: 0,
        //translateY: 0,
        rotate: 0,
        //rotate: 0,
        descriptionX: -translateX + 1,
        descriptionY: 220,
        descriptionWidth: 210,
        descriptionHeight: 40,
        description: 'tension',
        lineX: 208.5 - translateX,
        lineY: 222.5,
        moveX: backWidth / 2 + 15,
        moveY: 144,
        globalCompositeOperation: 'source-over'
      },
      left2: {
        key: 'spine-left2',
        type: 'pain',
        x: 280,
        y: 400,
        width: 100,
        height: 100,
        offsetW: backWidth / 2 + 55,
        offsetH: 114,
        translateX: 0,
        //translateX: 0,
        translateY: 0,
        //translateY: 0,
        rotate: 0,
        //rotate: 0,
        /* descriptionX:backWidth-220+50-2,
         descriptionY:0,
         descriptionWidth:220,
         descriptionHeight:40,
         description:'weak',
         lineX:backWidth-220+50-2+10/4,
         lineY:40-10/4,
         moveX:370,
         moveY:140,*/
        globalCompositeOperation: 'source-over'
      },
      right1: {
        key: 'spine-right1',
        type: 'pain',
        x: 560,
        y: 400,
        width: 100,
        height: 100,
        offsetW: backWidth / 2 - 20,
        offsetH: 114,
        translateX: 0,
        //translateX: 0,
        translateY: 0,
        //translateY: 0,
        rotate: 0,
        //rotate: 0,
        // descriptionX:50,
        // descriptionY:0,
        // descriptionWidth:220,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:50+220-10/4,
        // lineY:40-10/4,
        // moveX:320,
        // moveY:140,
        globalCompositeOperation: 'source-over'
      },
      right2: {
        key: 'spine-right2',
        type: 'pain',
        x: 840,
        y: 400,
        width: 100,
        height: 100,
        offsetW: backWidth / 2 + 55,
        offsetH: 114,
        translateX: 0,
        //translateX: 0,
        translateY: 0,
        //translateY: 0,
        rotate: 0,
        //rotate: 0,
        descriptionX: backWidth - 202 - translateX,
        descriptionY: 220,
        descriptionWidth: 200,
        descriptionHeight: 40,
        description: 'tension',
        lineX: backWidth - 199.5 - translateX,
        lineY: 222.5,
        moveX: backWidth / 2 + 80,
        moveY: 144,
        globalCompositeOperation: 'source-over'
      }
    },
    shoulder: {
      left1: {
        key: 'shoulder-left1',
        type: 'pain',
        x: 3360,
        y: 800,
        width: 100,
        height: 100,
        offsetW: backWidth / 2 - 20,
        offsetH: 116,
        translateX: 0,
        //translateX: 0,
        translateY: 0,
        //translateY: 0,
        rotate: 0,
        //rotate: 0,
        descriptionX: -translateX + 1,
        descriptionY: 220,
        descriptionWidth: 210,
        descriptionHeight: 40,
        description: 'tension',
        lineX: 208.5 - translateX,
        lineY: 222.5,
        moveX: backWidth / 2 + 15,
        moveY: 140,
        globalCompositeOperation: 'source-over'
      },
      left2: {
        key: 'shoulder-left2',
        type: 'pain',
        /* x: 3640,
         y: 800,
         width: 100,
         height: 100,*/
        x: 3080,
        y: 790,
        width: 100,
        height: 100,
        offsetW: backWidth / 2 + 55,
        offsetH: 106,
        translateX: 0,
        //translateX: 0,
        translateY: 0,
        //translateY: 0,
        rotate: 0,
        //rotate: 0,
        /*descriptionX:backWidth-200+50-2,
        descriptionY:220,
        descriptionWidth:220,
        descriptionHeight:40,
        description:'weak',
        lineX:backWidth-200+50-2+10/4,
        lineY:220+10/4,
        moveX:backWidth/2+90,
        moveY:140,*/
        globalCompositeOperation: 'source-over'
      },
      right1: {
        key: 'shoulder-right1',
        type: 'pain',
        x: 2800,
        y: 800,
        width: 100,
        height: 100,
        offsetW: backWidth / 2 - 20,
        offsetH: 106,
        translateX: 0,
        //translateX: 0,
        translateY: 0,
        //translateY: 0,
        rotate: 0,
        //rotate: 0,
        // descriptionX:50,
        // descriptionY:0,
        // descriptionWidth:220,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:50+220-10/4,
        // lineY:40-10/4,
        // moveX:320,
        // moveY:140,
        globalCompositeOperation: 'source-over'
      },
      right2: {
        key: 'shoulder-right2',
        type: 'pain',
        x: 3080,
        y: 800,
        width: 100,
        height: 100,
        offsetW: backWidth / 2 + 50,
        offsetH: 116,
        translateX: 0,
        //translateX: 0,
        translateY: 0,
        //translateY: 0,
        rotate: 0,
        //rotate: 0,
        descriptionX: backWidth - 212 - translateX,
        descriptionY: 220,
        descriptionWidth: 210,
        descriptionHeight: 40,
        description: 'tension',
        lineX: backWidth - 209.5 - translateX,
        lineY: 222.5,
        moveX: backWidth / 2 + 80,
        moveY: 140,
        globalCompositeOperation: 'source-over'
      }
    },
    round: {
      left: {
        key: 'round-left',
        type: 'pain',
        x: 1120,
        y: 400,
        width: 100,
        height: 200,
        offsetW: backWidth / 2 - 20,
        offsetH: 116,
        translateX: 0,
        //translateX: 0,
        translateY: 0,
        //translateY: 0,
        rotate: 0,
        //rotate: 0,
        descriptionX: -translateX + 1,
        descriptionY: 220,
        descriptionWidth: 210,
        descriptionHeight: 40,
        description: 'weak',
        lineX: 210 - translateX - 2.5,
        lineY: 222.5,
        moveX: backWidth / 2 + 30,
        moveY: 200,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'round-right',
        type: 'pain',
        x: 1400,
        y: 400,
        width: 100,
        height: 200,
        offsetW: backWidth / 2 + 52,
        offsetH: 116,
        translateX: 0,
        //translateX: 0,
        translateY: 0,
        //translateY: 0,
        rotate: 0,
        //rotate: 0,
        descriptionX: backWidth - 210 - 2 - translateX,
        descriptionY: 220,
        descriptionWidth: 210,
        descriptionHeight: 40,
        description: 'weak',
        lineX: backWidth - 210 - 2 - translateX + 2.5,
        lineY: 222.5,
        moveX: backWidth / 2 + 80,
        moveY: 140,
        globalCompositeOperation: 'source-over'
      }
    },
    fore: {
      left: {
        key: 'fore-left',
        type: 'pain',
        x: 2240,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth / 2 - 20,
        offsetH: 111,
        translateX: 0,
        //translateX: 0,
        translateY: 0,
        //translateY: 0,
        rotate: 0,
        //rotate: 0,
        descriptionX: -translateX + 1,
        descriptionY: 220,
        descriptionWidth: 210,
        descriptionHeight: 40,
        description: 'weak',
        lineX: -translateX + 1 + 210 - 2.5,
        lineY: 222.5,
        moveX: backWidth / 2 + 30,
        moveY: 200,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'fore-right',
        type: 'pain',
        x: 2520,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth / 2 + 50 + 5,
        offsetH: 111,
        translateX: 0,
        //translateX: 0,
        translateY: 0,
        //translateY: 0,
        rotateBefore: false,
        //rotateBefore: 0,
        rotate: 0,
        //rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        descriptionX: backWidth - 210 - translateX - 1,
        descriptionY: 220,
        descriptionWidth: 210,
        descriptionHeight: 40,
        description: 'tension',
        lineX: backWidth - 210 - translateX + 2.5,
        lineY: 222.5,
        moveX: backWidth / 2 + 80,
        moveY: 140,
        globalCompositeOperation: 'source-over'
      }
    },
    rake: {
      left1: {
        key: 'rake-left1',
        type: 'pain',
        /*  x: 1120,
          y: 800,
          width: 100,
          height: 200,*/
        x: 1680,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth / 2 + 20,
        offsetH: 76,
        translateX: backWidth / 2 + 57,
        translateY: 156,
        rotate: -backRad.head,
        afterTranslate: true,
        /* descriptionX:-translateX+2,
         descriptionY:40,
         descriptionWidth:180,
         descriptionHeight:40,
         description:'tension',
         lineX:-translateX+2+180-2.5,
         lineY:77.5,
         moveX:backWidth/2+35-position(-backRad.head,'x',60),
         moveY:120-position(-backRad.head,'y',20),*/
        globalCompositeOperation: 'source-over'
      },
      left2: {
        key: 'rake-left2',
        type: 'pain',
        x: 1400,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth / 2 + 50,
        offsetH: 76,
        translateX: backWidth / 2 + 57,
        translateY: 156,
        rotate: -backRad.head,
        afterTranslate: true,
        descriptionX: backWidth - 200 - 2 + 50,
        descriptionY: 60,
        descriptionWidth: 200,
        descriptionHeight: 40,
        description: 'weak',
        lineX: backWidth - 200 - 2 + 50 + 10 / 4,
        lineY: 60 + 40 - 10 / 4,
        moveX: backWidth / 2 + 57 - position(-backRad.head, 'x', 60),
        moveY: 130 - position(-backRad.head, 'y', 20),
        globalCompositeOperation: 'source-over'
      },
      right1: {
        key: 'rake-right1',
        type: 'pain',
        /*x: 1680,
        y: 800,
        width: 100,
        height: 200,*/
        x: 1120,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth / 2 + 20,
        offsetH: 76,
        translateX: backWidth / 2 + 57,
        translateY: 156,
        rotate: -backRad.head,
        afterTranslate: true,
        // descriptionX:50,
        // descriptionY:60,
        // descriptionWidth:160,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:50+160-10/4,
        // lineY:60+40-10/4,
        // moveX:backWidth/2+35-position(-backRad.head,'x',60),
        // moveY:130-position(-backRad.head,'y',20),
        globalCompositeOperation: 'source-over'
      },
      right2: {
        key: 'rake-right2',
        type: 'pain',
        x: 1960,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth / 2 + 50,
        offsetH: 76,
        translateX: backWidth / 2 + 57,
        translateY: 156,
        rotate: -backRad.head,
        afterTranslate: true,
        descriptionX: backWidth - 180 - translateX - 2,
        descriptionY: 40,
        descriptionWidth: 180,
        descriptionHeight: 40,
        description: 'tension',
        lineX: backWidth - 180 - translateX - 2 + 2.5,
        lineY: 77.5,
        moveX: backWidth / 2 + 57 - position(-backRad.head, 'x', 60),
        moveY: 120 - position(-backRad.head, 'y', 20),
        globalCompositeOperation: 'source-over'
      }
    },
    legStretch: {
      left1: {
        key: 'legStretch-left1',
        type: 'pain',
        x: 0,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth / 2 - 28,
        offsetH: 435,
        translateX: 0,
        //translateX: thighLeftTranslateX,
        translateY: 0,
        //translateY: thighLeftTranslateY,
        rotateBefore: false,
        //rotateBefore: 0,
        rotate: 0,
        //rotate: -backRad.hipToKneeR,
        afterTranslate: false,
        //afterTranslate:true,
        // descriptionX:50+1,
        // descriptionY:550,
        // descriptionWidth:200,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:50+200-10/4+1,
        // lineY:550+10/4,
        // moveX:backWidth/2-50+10+5+5+30+position(-backRad.hipToKneeR,'x',120),
        // moveY:100+380-110+100-30-5+position(-backRad.hipToKneeR,'y',60),
        globalCompositeOperation: 'source-over'
      },
      right1: {
        key: 'legStretch-right1',
        type: 'pain',
        x: 280,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth / 2 + 73,
        offsetH: 435,
        translateX: 0,
        //translateX: thighRightTranslateX,
        translateY: 0,
        //translateY: thighRightTranslateY,
        rotate: 0,
        //rotate: -backRad.hipToKneeL,
        afterTranslate: false,
        //afterTranslate:true,
        descriptionX: backWidth - 150 - translateX - 2,
        descriptionY: 550,
        descriptionWidth: 150,
        descriptionHeight: 40,
        description: 'weak',
        lineX: backWidth - 150 - translateX - 2 + 2.5,
        lineY: 552.5,
        moveX: backWidth / 2 + 95 + position(-backRad.hipToKneeL, 'x', 120),
        moveY: 430 + position(-backRad.hipToKneeL, 'y', 60),
        globalCompositeOperation: 'source-over'
      },
      left2: {
        key: 'legStretch-left2',
        type: 'pain',
        x: 560,
        y: 800,
        width: 100,
        height: 100,
        offsetW: backWidth / 2 - 42 + position(-backRad.hipToKneeR, 'x', 180),
        offsetH: 578 + position(-backRad.hipToKneeR, 'y', 180),
        translateX: 0,
        //translateX: backWidth/2-15+position(-backRad.hipToKneeR,'x',180),
        translateY: 0,
        //translateY: 376+position(-backRad.hipToKneeR,'y',180),
        rotate: 0,
        //rotate: -backRad.kneeToAnkleR,
        afterTranslate: false,
        //afterTranslate:true,
        descriptionX: -translateX + 2,
        descriptionY: 680,
        descriptionWidth: 180,
        descriptionHeight: 40,
        description: 'tension',
        lineX: -translateX + 2 + 180 - 2.5,
        lineY: 717.5,
        moveX: backWidth / 2 + position(-backRad.hipToKneeR, 'x', 180) + position(-backRad.kneeToAnkleR, 'x', 210) - 18,
        moveY: 373 + position(-backRad.hipToKneeR, 'y', 180) + position(-backRad.kneeToAnkleR, 'y', 210),
        globalCompositeOperation: 'source-over'
      },
      right2: {
        key: 'legStretch-right2',
        type: 'pain',
        x: 840,
        y: 800,
        width: 100,
        height: 100,
        offsetW: backWidth / 2 + 97 + position(-backRad.hipToKneeL, 'x', 180),
        offsetH: 578 + position(-backRad.hipToKneeL, 'y', 180),
        translateX: 0,
        //translateX: backWidth/2+104+position(-backRad.hipToKneeL,'x',180),
        translateY: 0,
        //translateY: 376+position(-backRad.hipToKneeL,'y',180),
        rotate: 0,
        //rotate: -backRad.kneeToAnkleL,
        afterTranslate: false,
        //afterTranslate:true,
        // descriptionX:backWidth-180-2+50,
        // descriptionY:680,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'tension',
        // lineX:backWidth-180-2+50+10/4,
        // lineY:680+40-10/4,
        // moveX:backWidth/2+30+5+position(-backRad.hipToKneeL,'x',180)+30+10+position(-backRad.kneeToAnkleL,'x',210)+30,
        // moveY:156-70+200+50+position(-backRad.hipToKneeL,'y',180)+40+position(-backRad.kneeToAnkleL,'y',210),
        globalCompositeOperation: 'source-over'
      }
    },
    legX: {
      left1: {
        key: 'legX-left1',
        type: 'pain',
        x: 1600,
        y: 400,
        width: 200,
        height: 200,
        offsetW: backWidth / 2 - 90,
        offsetH: 366,
        translateX: 0,
        //translateX: thighLeftTranslateX,
        translateY: 0,
        //translateY: thighLeftTranslateY,
        rotate: 0,
        //rotate: -backRad.hipToKneeR,
        afterTranslate: false,
        //afterTranslate:true,
        descriptionX: -translateX + 2,
        descriptionY: 460,
        descriptionWidth: 180,
        descriptionHeight: 40,
        description: 'weak',
        lineX: -translateX + 2 + 180 - 2.5,
        lineY: 462.5,
        moveX: backWidth / 2 + 15,
        moveY: 400,
        globalCompositeOperation: 'source-over'
      },
      left2: {
        key: 'legX-left2',
        type: 'pain',
        x: 2240,
        y: 400,
        width: 100,
        height: 200,
        offsetW: backWidth / 2 - 30,
        offsetH: 435,
        translateX: 0,
        //translateX: thighLeftTranslateX,
        translateY: 0,
        //translateY: thighLeftTranslateY,
        rotate: 0,
        //rotate: -backRad.hipToKneeR,
        afterTranslate: false,
        //afterTranslate:true,
        // descriptionX:50+1,
        // descriptionY:550,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'tension',
        // lineX:50+180-10/4+1,
        // lineY:550+10/4,
        // moveX:backWidth/2-50+10+5+5+15+position(-backRad.hipToKneeR,'x',120),
        // moveY:100+380-110+100-30-5+position(-backRad.hipToKneeR,'y',60),
        globalCompositeOperation: 'source-over'
      },
      right1: {
        key: 'legX-right1',
        type: 'pain',
        x: 1880,
        y: 400,
        width: 200,
        height: 200,
        offsetW: backWidth / 2 - 32,
        offsetH: 366,
        translateX: 0,
        //translateX: thighRightTranslateX,
        translateY: 0,
        //translateY: thighRightTranslateY,
        rotate: 0,
        //rotate: -backRad.hipToKneeL,
        afterTranslate: false,
        //afterTranslate:true,
        // descriptionX:backWidth-180+50-2,
        // descriptionY:460,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:backWidth-180+50+10/4-2,
        // lineY:460+10/4,
        // moveX:backWidth/2-50+10+5+5+15+30+60,
        // moveY:100+380-110-30+60,
        globalCompositeOperation: 'source-over'
      },
      right2: {
        key: 'legX-right2',
        type: 'pain',
        x: 2520,
        y: 400,
        width: 100,
        height: 200,
        offsetW: backWidth / 2 + 85,
        offsetH: 435,
        translateX: 0,
        //translateX: thighRightTranslateX,
        translateY: 0,
        //translateY: thighRightTranslateY,
        rotate: 0,
        //rotate: -backRad.hipToKneeL,
        afterTranslate: false,
        //afterTranslate:true,
        descriptionX: backWidth - 180 - translateX - 2,
        descriptionY: 550,
        descriptionWidth: 180,
        descriptionHeight: 40,
        description: 'weak',
        lineX: backWidth - 180 - translateX - 2 + 2.5,
        lineY: 552.5,
        moveX: backWidth / 2 + 105 + position(-backRad.hipToKneeL, 'x', 120),
        moveY: 434 + position(-backRad.hipToKneeL, 'y', 60),
        globalCompositeOperation: 'source-over'
      }
    },
    legO: {
      left1: {
        key: 'legO-left1',
        type: 'pain',
        x: 2800,
        y: 400,
        width: 200,
        height: 200,
        offsetW: backWidth / 2,
        offsetH: 436,
        translateX: 0,
        //translateX: thighLeftTranslateX,
        translateY: 0,
        //translateY: thighLeftTranslateY,
        rotate: 0,
        //rotate: -backRad.hipToKneeR,
        afterTranslate: false,
        //afterTranslate:true,
        descriptionX: -translateX + 2,
        descriptionY: 550,
        descriptionWidth: 230,
        descriptionHeight: 40,
        description: 'tension',
        lineX: -translateX + 2 + 230 - 2.5,
        lineY: 552.5,
        moveX: backWidth / 2 + 11 + position(-backRad.hipToKneeR, 'x', 120),
        moveY: 435 + position(-backRad.hipToKneeR, 'y', 60),
        globalCompositeOperation: 'source-over'
      },
      left2: {
        key: 'legO-left2',
        type: 'pain',
        x: 3360,
        y: 400,
        width: 200,
        height: 200,
        offsetW: backWidth / 2 - 38 + position(-backRad.hipToKneeR, 'x', 180),
        offsetH: 374 + position(-backRad.hipToKneeR, 'y', 180),
        translateX: 0,
        //translateX: backWidth/2-15+position(-backRad.hipToKneeR,'x',180),
        translateY: 0,
        //translateY: 376+position(-backRad.hipToKneeR,'y',180),
        rotate: 0,
        //rotate: -backRad.kneeToAnkleR,
        afterTranslate: false,
        //afterTranslate:true,
        // descriptionX:50+1,
        // descriptionY:680,
        // descriptionWidth:200,
        // descriptionHeight:40,
        // description:'tension',
        // lineX:50+200-10/4+1,
        // lineY:680+10/4,
        // moveX:backWidth/2-50-5+position(-backRad.hipToKneeR,'x',180)+5+20+position(-backRad.kneeToAnkleR,'x',50)+30+3,
        // moveY:156-70+200+50+position(-backRad.hipToKneeR,'y',180)+40+position(-backRad.kneeToAnkleR,'y',50),
        globalCompositeOperation: 'source-over'
      },
      right1: {
        key: 'legO-right1',
        type: 'pain',
        x: 3080,
        y: 400,
        width: 200,
        height: 200,
        offsetW: backWidth / 2 + 75,
        offsetH: 436,
        translateX: 0,
        //translateX: thighRightTranslateX,
        translateY: 0,
        //translateY: thighRightTranslateY,
        rotate: 0,
        //rotate: -backRad.hipToKneeL,
        afterTranslate: false,
        //afterTranslate:true,
        // descriptionX:backWidth-220-2+50,
        // descriptionY:550,
        // descriptionWidth:220,
        // descriptionHeight:40,
        // description:'tension',
        // lineX:backWidth-200-2+50+10/4,
        // lineY:550+10/4,
        // moveX:backWidth/2+30+60+position(-backRad.hipToKneeL,'x',120),
        // moveY:100+380-110+100-30-10+position(-backRad.hipToKneeL,'y',60),
        globalCompositeOperation: 'source-over'
      },
      right2: {
        key: 'legO-right2',
        type: 'pain',
        x: 3640,
        y: 400,
        width: 200,
        height: 200,
        offsetW: backWidth / 2 + 77 + position(-backRad.hipToKneeL, 'x', 180),
        offsetH: 374 + position(-backRad.hipToKneeL, 'y', 180),
        translateX: 0,
        //translateX:backWidth/2+100+position(-backRad.hipToKneeL,'x',180),
        translateY: 0,
        //translateY: 376+position(-backRad.hipToKneeL,'y',180),
        rotate: 0,
        //rotate: -backRad.kneeToAnkleL,
        afterTranslate: false,
        //afterTranslate:true,
        descriptionX: backWidth - 210 - translateX - 2,
        descriptionY: 680,
        descriptionWidth: 210,
        descriptionHeight: 40,
        description: 'tension',
        lineX: backWidth - 210 - translateX - 2 + 2.5,
        lineY: 682.5,
        moveX: backWidth / 2 + 92 + position(-backRad.hipToKneeL, 'x', 180) + position(-backRad.kneeToAnkleL, 'x', 50),
        moveY: 374 + position(-backRad.hipToKneeL, 'y', 180) + position(-backRad.kneeToAnkleL, 'y', 50),
        globalCompositeOperation: 'source-over'
      }
    },
    legXO: {
      left1: {
        key: 'legXO-left1',
        type: 'pain',
        x: 3640,
        y: 0,
        width: 200,
        height: 200,
        offsetW: backWidth / 2 - 30,
        offsetH: 431,
        translateX: 0,
        //translateX: thighLeftTranslateX,
        translateY: 0,
        //translateY: thighLeftTranslateY,
        rotate: 0,
        //rotate: -backRad.hipToKneeR,
        afterTranslate: false,
        //afterTranslate:true,
        // false,
        //// afterTranslate:true,
        // descriptionX:50+1,
        // descriptionY:550,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:50+180-10/4+1,
        // lineY:550+10/4,
        // moveX:backWidth/2-50+10+5+5+15+position(-backRad.hipToKneeR,'x',120),
        // moveY:100+380-110+100-30-5+position(-backRad.hipToKneeR,'y',60),
        globalCompositeOperation: 'source-over'
      },
      right1: {
        key: 'legXO-right1',
        type: 'pain',
        x: 3820,
        y: 0,
        width: 200,
        height: 200,
        offsetW: backWidth / 2 + 27,
        offsetH: 435,
        translateX: 0,
        //translateX: thighRightTranslateX,
        translateY: 0,
        //translateY: thighRightTranslateY,
        rotate: 0,
        //rotate: -backRad.hipToKneeL,
        afterTranslate: false,
        //afterTranslate:true,
        descriptionX: backWidth - 180 - translateX - 2,
        descriptionY: 550,
        descriptionWidth: 180,
        descriptionHeight: 40,
        description: 'weak',
        lineX: backWidth - 180 - translateX - 2 + 2.5,
        lineY: 552.5,
        moveX: backWidth / 2 + 105 + position(-backRad.hipToKneeL, 'x', 120),
        moveY: 430 + position(-backRad.hipToKneeL, 'y', 60),
        globalCompositeOperation: 'source-over'
      }
    }
  };
  var backOrder = ['head', 'body', 'upperArm-left', 'foreArm-left', 'upperArm-right', 'foreArm-right', 'shank-left', 'thigh-left', 'shank-right', 'thigh-right', 'spine-left1', 'spine-left2', 'spine-right1', 'spine-right2', 'shoulder-left1', 'shoulder-left2', 'shoulder-left2', 'shoulder-right1', 'shoulder-right2', 'round-left', 'round-right', 'fore-left', 'fore-right', 'rake-left1', 'rake-left2', 'rake-right1', 'rake-right2', 'legStretch-left1', 'legStretch-right1', 'legStretch-left2', 'legStretch-right2', 'legXO-left1', 'legXO-right1', 'legX-left1', 'legX-left2', 'legX-right1', 'legX-right2', 'legO-left1', 'legO-left2', 'legO-right1', 'legO-right2'];
  var backPain = getPainArr('back', data.conclusion, pains);
  //////console.log('backPain->',backPain);
  var backOrderInfos = getOrderInfos(backLocationInfo, backOrder);

  var backImg = new Image();
  backImg.src = imgSrc.bone.backBone;

  backImg.onload = function () {
    //console.log("img w:",backImg.width," img H:",backImg.height,'backWidth:',backWidth)
    /*   backBodyPostion.sx = 0;
      backBodyPostion.sy = 0;
      backBodyPostion.x = 0 + backWidth/20; */
    var ctx = backCanvas.getContext('2d');
    drawBone('back', ctx, backOrderInfos, backPain, backImg, translateX, (windowHeight - 89) * 220 / backHeight, backBodyPostion, backWidth);
  };
}
//绘制骨骼筋膜图
function drawBone(direction, ctx, orderInfos, pain, img, translateX, translateY, BodyPostion, backWidth) {
  var bodyImg = new Image();

  bodyImg.src = BodyPostion.imgUrl;
  bodyImg.onload = function () {
    if (direction == 'test') {
      ctx.drawImage(bodyImg, BodyPostion.sx, BodyPostion.sy, BodyPostion.swidth, BodyPostion.sheight, BodyPostion.x, BodyPostion.y, BodyPostion.width, BodyPostion.height);
    }
  };
  //console.log("direction,ctx,orderInfos,",BodyPostion)
  ctx.globalCompositeOperation = 'destination-over';
  ctx.save();

  ctx.translate(translateX, translateY);
  for (var i = 0; i < orderInfos.length; i++) {

    if (orderInfos[i] && (orderInfos[i].type !== 'pain' || orderInfos[i].type === 'pain' && pain.indexOf(orderInfos[i].key) !== -1)) {
      ctx.save();
      //ctx.translate(orderInfos[i].translateX, orderInfos[i].translateY);
      //ctx.rotate(orderInfos[i].rotate);
      /* if(orderInfos[i].afterTranslate){
        ctx.translate(-orderInfos[i].translateX, -orderInfos[i].translateY);
      }
      if(orderInfos[i].rotateBefore) {
        ctx.restore();
        ctx.save();
        ctx.translate(orderInfos[i].translateXBefore, orderInfos[i].translateYBefore);
        ctx.rotate(orderInfos[i].rotateBeforeRad);
        ctx.translate(-orderInfos[i].translateXBefore, -orderInfos[i].translateYBefore);
      } */
      if (orderInfos[i].globalCompositeOperation) {
        ctx.globalCompositeOperation = orderInfos[i].globalCompositeOperation;
      }

      ctx.drawImage(img, orderInfos[i].x, orderInfos[i].y, orderInfos[i].width, orderInfos[i].height, orderInfos[i].offsetW, orderInfos[i].offsetH, orderInfos[i].width, orderInfos[i].height);

      ctx.restore();

      // ctx.globalCompositeOperation = 'source-over'
      // ctx.beginPath();
      // ctx.arc(orderInfos[i].translateXBefore,orderInfos[i].translateYBefore,4,0,360,false);
      // ctx.fillStyle='red';
      // ctx.fill();
      // ctx.closePath();

      // if(direction === 'face'){
      //  drawFaceTest(ctx,attr)
      // }

      if (orderInfos[i].description) {
        var value = null;
        switch (direction) {
          case 'face':
            value = drawFacePainDes(ctx, orderInfos[i]);
            ////console.log("desc value:",value,orderInfos[i].description)
            isNormal('faceNormal', value);
            break;
          case 'side':
            value = drawSidePainDes(ctx, orderInfos[i]);
            ////console.log("desc side:",value,orderInfos[i].description)
            isNormal('sideNormal', value);
            break;
          case 'back':
            value = drawbackPainDes(ctx, orderInfos[i]);
            ////console.log("desc value back:",value,orderInfos[i].description)
            isNormal('backNormal', value);
            break;
          default:
            break;
        }
        console.log('descripName', init_t.descripName);
        drawDescription(ctx, 10, orderInfos[i].descriptionX, orderInfos[i].descriptionY, orderInfos[i].descriptionWidth, orderInfos[i].descriptionHeight, orderInfos[i].moveX, orderInfos[i].moveY, descripName(orderInfos[i].description).color, value, orderInfos[i].lineX, orderInfos[i].lineY, direction);
      }
      ctx.globalCompositeOperation = 'destination-over';
    } else {
      continue;
    }
  }
}
function isNormal(bonePart, value) {
  value != null ? bodyPart[bonePart] = false : null;
}
function drawFacePainDes(ctx, faceOrderInfo) {
  var key = faceOrderInfo.key.split('-');
  var painName = key[0],
      lOrR = key[1];
  var boneDes = init_t.boneDescription['face'];
  console.log('boneDescription', init_t);
  var des = void 0,
      value = void 0;
  if (key.length > 1) {
    if (painName === 'legForX') {
      if (lOrR.indexOf('1') > -1) {
        des = boneDes[painName][0];
      } else if (lOrR.indexOf('2') > -1) {
        des = boneDes[painName][1];
      }
    } else {
      des = boneDes[painName];
    }
  } else {
    des = boneDes[key];
  }
  value = des + descripName(faceOrderInfo.description).name;
  return value;
}

function drawSidePainDes(ctx, sideOrderInfo) {
  var key = sideOrderInfo.key.split('-');
  var painName = key[0];
  var boneDes = init_t.boneDescription['side'];
  var des = void 0,
      value = void 0;
  if (key.length > 1) {
    des = boneDes[painName];
  } else {
    des = boneDes[key];
  }
  value = des + descripName(sideOrderInfo.description).name;
  return value;
}

function drawbackPainDes(ctx, backOrderInfo) {
  var key = backOrderInfo.key.split('-');
  var painName = key[0],
      lOrR = key[1];
  var backDes = init_t.boneDescription['back'];
  var des = void 0,
      value = void 0;
  if (key.length > 1) {
    if (painName === 'round' || painName === 'fore') {
      if (lOrR === 'left') {
        des = backDes[painName][1];
      } else if (lOrR === 'right') {
        des = backDes[painName][0];
      }
    } else if (painName.indexOf('leg') > -1) {
      if (lOrR.indexOf('1') > -1) {
        des = backDes[painName][0];
      } else if (lOrR.indexOf('2') > -1) {
        des = backDes[painName][1];
      }
    } else {
      des = backDes[painName];
    }
  } else {
    des = backDes[key];
  }
  value = des + descripName(backOrderInfo.description).name;
  return value;
}

function drawDescription(ctx, r, x, y, width, height, moveX, moveY, color, value, lineX, lineY, dir) {
  //// //console.log("(x+r,y:",x+r,y,"width-r+x,y:",width-r+x,y)
  //////console.log("width-r+x:",width-r+x)
  var len = 11;
  var fontSize = 23;
  var oldWidth = width;
  if (value.length > len) {
    var count = Math.ceil(value.length / len);
    width = oldWidth;
    height = count * fontSize + 20;
  }
  ctx.globalCompositeOperation = 'source-over';
  ctx.beginPath();
  ctx.arc(moveX, moveY, 4, 0, 360, false);
  ctx.fillStyle = "#808080";
  ctx.fill();
  ctx.closePath();

  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(width - r + x, y);
  ctx.arc(width - r + x, r + y, r, Math.PI * 3 / 2, 0);
  ctx.lineTo(width + x, height - r + y);

  ctx.arc(width - r + x, height - r + y, r, 0, Math.PI / 2);
  ctx.lineTo(r + x, height + y);

  ctx.arc(r + x, height - r + y, r, Math.PI / 2, Math.PI);
  ctx.lineTo(x, r + y);
  ctx.arc(r + x, r + y, r, Math.PI, Math.PI * 3 / 2);

  console.log("lineX,lineY", lineX, lineY, ' moveX,moveY', moveX, moveY);
  if (value.length > len) {
    var count = Math.ceil(value.length / len);
    width = width;
    height = count * fontSize + 20;
  }
  ctx.moveTo(lineX, lineY);
  ctx.lineTo(moveX, moveY);
  ctx.strokeStyle = color;
  ctx.stroke();
  ctx.fillStyle = 'rgba(255,255,255,0.6)';
  ctx.fill();
  ctx.closePath();

  //  canvas文字换行
  var wrapText = function wrapText(text) {
    var text = text,
        fontSize = 23,
        lines = [],
        line = '',
        lineTest = '',
        words = text.split(' '),
        currentY = 0;

    ctx.font = fontSize + 'px Arial';

    for (var i = 0, len = words.length; i < len; i++) {
      lineTest = line + words[i] + ' ';

      // Check total width of line or last word
      if (ctx.measureText(lineTest).width > width) {
        // Calculate the new height
        currentY = lines.length * fontSize + fontSize;

        // Record and reset the current line
        lines.push({ text: line, height: currentY });
        line = words[i] + ' ';
      } else {
        line = lineTest;
      }
    }

    // Catch last line in-case something is left over
    if (line.length > 0) {
      currentY = lines.length * fontSize + fontSize;
      lines.push({ text: line.trim(), height: currentY });
    }

    // Visually output text
    // ctx.clearRect(0, 0, 500, 500);
    for (var i = 0, len = lines.length; i < len; i++) {
      ctx.fillStyle = color;
      ctx.fillText(lines[i].text, width / 10 + x - 10, y + 40 + (i - 1) * fontSize + 24);
    }
  };

  wrapText(value);

  // if (value.length > len) {
  //   if (dir != 'face'){
  //     len= len + 4
  //   }
  //   var count = Math.ceil(value.length / len)
  //   for (var i = 1; i <= count; i++) {
  //       ctx.font = '23px PingFang SC'
  //       ctx.fillStyle = color
  //       ctx.textAlign = 'left'
  //       var riskStr = value.substring((i-1)*len, (i-1)*len+len)
  //     // var riskStr = value.substring((i-1)*len, (i-1)*len+len).replace(/(^\s*)|(\s*$)/g, "")

  //       ctx.fillText(riskStr, width/10+x-5,y+20+(i-1)*fontSize+10);
  //   }


  // }else{
  //   ctx.font = "23px PingFang SC";
  //   ctx.fillStyle = color;
  //   ctx.textAlign = 'center';
  //   ctx.fillText(value, width/2+x+2, height-11+y);
  // }
}
//计算部位角度
function getRad(topOrRightPoint, bottomOrLeftPoint, isHorizontal) {
  // 此时的 right 是指看人体正面时人体的右，即我们的左；
  // 此时的 left 是指看人体正面时人体的左，即我们的右；

  var _x = Math.abs(topOrRightPoint.x - bottomOrLeftPoint.x);
  var _y = Math.abs(topOrRightPoint.y - bottomOrLeftPoint.y);
  var radian = void 0;

  if (isHorizontal) {
    if (topOrRightPoint.y < bottomOrLeftPoint.y) {
      radian = Math.atan(_y / _x);
    } else if (topOrRightPoint.y > bottomOrLeftPoint.y) {
      radian = -Math.atan(_y / _x);
    } else {
      radian = 0;
    }
  } else {
    if (topOrRightPoint.y < bottomOrLeftPoint.y) {
      // 两个点垂直位置正常情况
      if (topOrRightPoint.x > bottomOrLeftPoint.x) {
        radian = Math.atan(_x / _y);
      } else if (topOrRightPoint.x < bottomOrLeftPoint.x) {
        radian = -Math.atan(_x / _y);
      } else {
        radian = 0;
      }
    } else {
      // 两个点位置垂直不正常情况
      if (bottomOrLeftPoint.x === 0 && bottomOrLeftPoint.y === 0 || topOrRightPoint.x === 0 && topOrRightPoint.y === 0) {
        radian = 0;
      } else {
        if (topOrRightPoint.x > bottomOrLeftPoint.x) {
          radian = Math.atan(_y / _x) + Math.PI / 2;
        } else if (topOrRightPoint.x < bottomOrLeftPoint.x) {
          radian = 3 * Math.PI / 2 - Math.atan(_y / _x);
        } else {
          radian = Math.PI;
        }
      }
    }
  }

  return 0;
}

function getOrderInfos(locationInfo, order) {
  var orderInfos = [];
  for (var i = 0; i < order.length; i++) {
    var pathArr = order[i].split('-');
    var info = void 0;
    for (var j = 0; j < pathArr.length; j++) {
      if (j === 0) {
        info = locationInfo[pathArr[j]];
      } else {
        info = info[pathArr[j]];
      }
    }
    orderInfos.push(info);
  }
  return orderInfos;
}

function isHighLowOrRake(name) {
  switch (name) {
    case 'unevenshoulder':
      return 'HighLow';
    case 'roundedshoulder':
      return 'round';
    case 'forwardhead':
      return 'fore';
    case 'lateralhead':
      return 'rake';
    case 'scoliosis':
      return 'spain';
    default:
      return '';
  }
}

function getLeg(name) {
  switch (name) {
    case 'xleg':
      return 'X';
    case 'oleg':
      return 'O';
    case 'xoleg':
      return 'XO';
    case 'kneehyperextension':
      return 'Stretch';
    default:
      return false;
  }
}

function getBodyDirection(direction, risks) {
  //////console.log('risks',risks)
  var risk = void 0,
      position = 'normal',
      lOrR = '';
  switch (direction) {
    case 'face':
      risk = _.maxBy(risks, function (o) {
        if ((o.position === 'pelvis' || o.position === 'shoulder' && isHighLowOrRake(o.key) === 'HighLow') && o.level === level.severe) {
          return o.value;
        }
      });
      if (!_.isEmpty(risk)) {
        lOrR = getShoulderLeftOrRight(risk.direction);
        position = risk.position;
      }
      break;
    case 'side':
      risk = _.maxBy(risks, function (o) {
        if (isHighLowOrRake(o.key) === 'round' && o.level === level.severe) {
          return o.value;
        }
      });
      if (!_.isEmpty(risk)) {
        position = isHighLowOrRake(risk.key);
      }
      break;
    case 'back':
      risk = _.maxBy(risks, function (o) {
        if ((isHighLowOrRake(o.key) === 'rake' || isHighLowOrRake(o.key) === 'HighLow') && o.level === level.severe) {
          return o.value;
        }
      });
      if (!_.isEmpty(risk)) {
        var highLowOrRake = isHighLowOrRake(risk.key);
        if (highLowOrRake === 'HighLow') {
          lOrR = getShoulderLeftOrRight(risk.direction);
        }
        position = highLowOrRake;
      }
      break;
    default:
      break;
  }
  return { position: position, lOrR: lOrR };
}

function position(rad, pos, height) {
  var getPosition = void 0;
  if (pos === 'x') {
    getPosition = Math.sin(Math.abs(rad)) * height;
    if (rad > 0) {
      getPosition = -getPosition;
    }
  } else if (pos === 'y') {
    getPosition = Math.cos(Math.abs(rad)) * height;
  }
  return getPosition;
}

function getPainArr(direction, data, pains) {
  var risks = data.face.risks.concat(data.side.risks);
  console.log({
    risk: risks
  });
  var painsTemplate = pains[direction];
  var left = '-left',
      left1 = '-left1',
      left2 = '-left2',
      right1 = '-right1',
      right2 = '-right2',
      right = '-right';
  var painArr = [];
  switch (direction) {
    case 'face':
      var trunk = _.find(risks, function (o) {
        return o.level === level.severe && o.position === 'trunk';
      });
      if (!_.isEmpty(trunk)) {
        painArr.push(painsTemplate[trunk.position][0]);
      }
      var round = _.find(risks, function (o) {
        return o.level === level.severe && isHighLowOrRake(o.key) === 'round';
      });
      if (!_.isEmpty(round)) {
        var painsTem = painsTemplate[round.position][0];
        painArr.push(painsTem + left);
        painArr.push(painsTem + right);
      }
      var legForStretch = _.find(risks, function (o) {
        return o.level === level.severe && getLeg(o.key) === 'Stretch';
      });
      if (!_.isEmpty(legForStretch)) {
        var _painsTem = painsTemplate[legForStretch.position];
        painArr.push(_painsTem[2] + left);
        painArr.push(_painsTem[2] + right);
      }
      var legForXOrO = _.maxBy(risks, function (o) {
        if ((getLeg(o.key) === 'X' || getLeg(o.key) === 'O') && o.level === level.severe) {
          return o.value;
        }
      });
      if (!_.isEmpty(legForXOrO)) {
        if (getLeg(legForXOrO.key) === 'X') {
          var _painsTem2 = painsTemplate[legForXOrO.position][0];
          painArr.push(_painsTem2 + left1);
          painArr.push(_painsTem2 + right1);
          painArr.push(_painsTem2 + left2);
          painArr.push(_painsTem2 + right2);
        } else {
          var _painsTem3 = painsTemplate[legForXOrO.position][1];
          painArr.push(_painsTem3 + left);
          painArr.push(_painsTem3 + right);
        }
      }
      break;
    case 'side':
      var shoulderOrRakeOrRound = _.maxBy(risks, function (o) {
        if ((isHighLowOrRake(o.key) === 'fore' || isHighLowOrRake(o.key) === 'round') && o.level === level.severe) {
          return o.value;
        }
      });
      if (!_.isEmpty(shoulderOrRakeOrRound)) {
        var _painsTem4 = painsTemplate[shoulderOrRakeOrRound.position];
        if (isHighLowOrRake(shoulderOrRakeOrRound.key) === 'fore') {
          painArr.push(_painsTem4[0]);
        } else {
          painArr.push(_painsTem4[1]);
        }
      }
      var highOrLow = _.find(risks, function (o) {
        return o.level === level.severe && isHighLowOrRake(o.key) === 'HighLow';
      });
      if (!_.isEmpty(highOrLow)) {
        painArr.push(painsTemplate[highOrLow.position][0] + '-' + getShoulderLeftOrRight(highOrLow.direction));
      }
      break;
    case 'back':
      var head = _.maxBy(risks, function (o) {
        if ((isHighLowOrRake(o.key) === 'round' || isHighLowOrRake(o.key) === 'HighLow' || isHighLowOrRake(o.key) === 'spain' || isHighLowOrRake(o.key) === 'fore') && o.level === level.severe) {
          return o.value;
        }
      });
      if (!_.isEmpty(head)) {
        var _painsTem5 = painsTemplate[head.position];
        var highLowOrRake = isHighLowOrRake(head.key);
        var lOrR = getShoulderLeftOrRight(head.direction);
        if (highLowOrRake === 'round' || highLowOrRake === 'fore') {
          painArr.push(_painsTem5[1] + left);
          painArr.push(_painsTem5[1] + right);
        } else if (highLowOrRake === 'HighLow' || highLowOrRake === 'spain') {
          painArr.push(_painsTem5[0] + ('-' + lOrR + '1'));
          painArr.push(_painsTem5[0] + ('-' + lOrR + '2'));
        }
      }
      var rake = _.find(risks, function (o) {
        return isHighLowOrRake(o.key) === 'rake' && o.level === level.severe;
      });
      if (!_.isEmpty(rake)) {
        var _painsTem6 = painsTemplate[rake.position][0];
        var _lOrR = getShoulderLeftOrRight(rake.direction);
        painArr.push(_painsTem6 + ('-' + _lOrR + '1'));
        painArr.push(_painsTem6 + ('-' + _lOrR + '2'));
      }
      var leg = _.maxBy(risks, function (o) {
        if ((getLeg(o.key) === 'O' || getLeg(o.key) === 'X' || getLeg(o.key) === 'XO' || getLeg(o.key) === 'Stretch') && o.level === level.severe) {
          return o.value;
        }
      });
      if (!_.isEmpty(leg)) {
        var _painsTem7 = painsTemplate[leg.position];
        var isLeg = getLeg(leg.key);
        var i = void 0,
            j = void 0;
        if (isLeg === 'X') {
          i = 0;j = 0;
        } else if (isLeg === 'O') {
          i = 1;j = 1;
        } else if (isLeg === 'Stretch') {
          i = 2;j = 2;
        } else if (isLeg === 'XO') {
          i = 2;j = 3;
        }
        painArr.push(_painsTem7[i] + left1);
        painArr.push(_painsTem7[i] + right1);
        painArr.push(_painsTem7[j] + left2);
        painArr.push(_painsTem7[j] + right2);
      }
      break;
    default:
      break;
  }
  return painArr;
}

module.exports = {
  init: init,
  drawFrontBone: drawFrontBone,
  drawSideBone: drawSideBone,
  drawBackBone: drawBackBone,
  bodyPart: bodyPart
};

/***/ }),

/***/ "4X2h":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAHr2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDIgNzkuMTYwOTI0LCAyMDE3LzA3LzEzLTAxOjA2OjM5ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdEV2dD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlRXZlbnQjIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iIHhtbG5zOnBob3Rvc2hvcD0iaHR0cDovL25zLmFkb2JlLmNvbS9waG90b3Nob3AvMS4wLyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpIiB4bXA6Q3JlYXRlRGF0ZT0iMjAxNy0xMi0yMVQxNDozOToyNiswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAxNy0xMi0yMVQxNDozOToyNiswODowMCIgeG1wOk1vZGlmeURhdGU9IjIwMTctMTItMjFUMTQ6Mzk6MjYrMDg6MDAiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjgwMDE1YTctNmM2OS02NjQ4LWJmYmItMjVhMDQxZjlhYWIxIiB4bXBNTTpEb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6Mjg5NjZkNWEtZDYyYy1iZDRmLWEyODQtNmNjNWRkMmM5ZjE5IiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6MmIyZTQ5MzAtMDc3OC0xMzQwLWIxYWEtZTAwZjQxMmM2ZTM1IiBkYzpmb3JtYXQ9ImltYWdlL3BuZyIgcGhvdG9zaG9wOkhpc3Rvcnk9IjIwMTctMTItMjFUMTQ6Mzk6MDkrMDg6MDAmI3g5O+aWh+S7tiDmnKrmoIfpopgtMSDlt7LmiZPlvIAmI3hBO+W7uueriyYjeDk75paw5bu6OiDmlofmoaMmI3hBO0ZBTFNFJiN4QTvmqKHlvI86IFJHQiDpopzoibLmqKHlvI8mI3hBO+WuveW6pjogMC40MTcg6Iux5a+4JiN4QTvpq5jluqY6IDAuNDE3IOiLseWvuCYjeEE75q+P6Iux5a+4IOWIhui+qOeOhzogNzImI3hBO+WDj+e0oOmVv+WuveavlDogMSYjeEE75aGr5YWFOiDnmb3oibImI3hBO+a3seW6pjogOCYjeEE76YWN572u5paH5Lu2OiDigJxub25l4oCdJiN4QTvlj4LogIPnur86IOaXoCYjeEE7MjQyMCYjeEE7JiN4QTvnspjotLQmI3g5OyYjeEE75aSN5Yi25Zu+5bGCJiN4QTvpmpDol48g6IOM5pmvJiN4OTsmI3hBOzIwMTctMTItMjFUMTQ6Mzk6MjYrMDg6MDAmI3g5O+aWh+S7tiBDOlxVc2Vyc1x3YW5nbHVsdVxEZXNrdG9wXOeureWktC5wbmcg5bey5a2Y5YKoJiN4QTsiIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiPiA8eG1wTU06SGlzdG9yeT4gPHJkZjpTZXE+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJjcmVhdGVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjJiMmU0OTMwLTA3NzgtMTM0MC1iMWFhLWUwMGY0MTJjNmUzNSIgc3RFdnQ6d2hlbj0iMjAxNy0xMi0yMVQxNDozOToyNiswODowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIvPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0ic2F2ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6NjgwMDE1YTctNmM2OS02NjQ4LWJmYmItMjVhMDQxZjlhYWIxIiBzdEV2dDp3aGVuPSIyMDE3LTEyLTIxVDE0OjM5OjI2KzA4OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpIiBzdEV2dDpjaGFuZ2VkPSIvIi8+IDwvcmRmOlNlcT4gPC94bXBNTTpIaXN0b3J5PiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PtHhryUAAAFwSURBVEiJ7ZdLLgRRFIY/jxBJWwFiYMQQAzbgEQlhFQbiEcuQIGY2QYiB2ACJNu55txV4DRCfQUsU6nGruuiJP7mTOjf3q/Ofc0+qOlTaoc62UFPAO8BAO8A9QA1YT9nTmtS4NeenrtXxhH2FV1KgT32KwF/UXbXy22DUM3+qri6WAU6r33nMsyHgBDgCBn+jxqgjMRlHdaduqF1lW41ay4Brs/kmyrQa4CLAtEngCtgDKmVYjToTkHFUdXWpDKt71ceccNVjdbAVcNK1CtG9Kc0XMg4vg+v2VRVgHziMC4aApwuCH4BtYDU2mmFz74dleXWqDqedXXZX36orGWcG1Xg+0NY34AAYpTlOs5XxZiGT60adDMky1OqsWX2vbqndeaEq3SlmzKbEToE1oBFYilxWxw2OhrpcJMNQq79/gbyq+2p/GdA0cPQaVS3QPFkr6Tot0Jw8m8AUUC1cywQlNdczMEYrzZOhDv3/hfkbvQNUp97hSTo1GgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "4fDm":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("s9zb");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("781cdc30", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../css-loader/index.js?{\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-19226772\",\"scoped\":false,\"hasInlineConfig\":false}!./default-skin.css", function() {
     var newContent = require("!!../../../css-loader/index.js?{\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-19226772\",\"scoped\":false,\"hasInlineConfig\":false}!./default-skin.css");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "5LIk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5VGa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/leg_o_left.8f265c7.png";

/***/ }),

/***/ "66wa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/bottom-bg.679fb8b.png";

/***/ }),

/***/ "6nyP":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "7+Pl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/leg_xo.ab3f786.png";

/***/ }),

/***/ "7BL5":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "8vL/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAACXBIWXMAAAsSAAALEgHS3X78AAACbUlEQVRo3u2a323bMBCHPwV5tzaoFxCcDaJOYGaCOBNUmSDuBMkGVScoPUGdCaqAC8gT1J7AfeglEAT9oSgpJgQR8Iskivx4vN/d0QrO5zNTaldMrE0O6Nr2wUgTAhtAXWiuOZAaxb7pocDGhyLNDbAHFh4YYQdsjOLotOU8gwFYA7qPD714BPPebiPNpjOQWOfWU/9XLhaKPRa0tQtQOMehiQO9AXfAV+ABeC3cOwCPcu9O5PjzAqsLjFHclK6lkSYBQqPYlu7pSJMC92MCVUXlpeWgSdVFo3hp6aP6hInAJdu2CbZGEbhMKNLoOgWzGeO6ZdJllcuNIjeKTLbOjxG26nFwUZAo/Af4XfplAopRpC0r7ZrExoMDNaz8QlIhm7Z12G4J8MVX2V6JanXxy23fQeuATgNB3dtARZp4qIz+qmEfn2pAk0LBZwv14XsVMFvxz0Ey+sD1kET2+3OHLicgeRcTWZA9sHKdfJVsu8ahrjDF9ghkUqT1skqnOFSQ701FptBHiZ5HFKLW1GfpcYE3lw8zkA+tzYfyUlFmKwoH6evSwj5SPoZsvwFx3UGg5futCr0q2XbaclKkfW9QxmUPmBCqswpnCzUUcB+rLwP/vaS/dLFQXaK4gv+pS58tdQmVW7Q47SzblwZ6aOiT+gxUK9s1hyRHo8gKZwa/at77swd4KH0XLqIwxjHWwSh32S4UfU+DA0lpHFfEmbagt5Oax9VC30aphwTmyWFSaywPC2eVm4EmDpRPDSjzeO67zkASRF89BdKuPpQw3NHwYNap+/ejFUisFHsEtYPqjy46pT6T+nhpjkMz0HDtH68/yRCfPu4jAAAAAElFTkSuQmCC"

/***/ }),

/***/ "9JNv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/pelvis_lean_left.f5bbc6b.png";

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9QSZ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Jj+E");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("a6beda74", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../css-loader/index.js?{\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1adbd40e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vux-loader/src/after-less-loader.js!../../../../less-loader/index.js?{\"sourceMap\":false}!../../../../vux-loader/src/style-loader.js!../../../../vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../css-loader/index.js?{\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1adbd40e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vux-loader/src/after-less-loader.js!../../../../less-loader/index.js?{\"sourceMap\":false}!../../../../vux-loader/src/style-loader.js!../../../../vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "9izx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/pelvis_lean_right.492b5e3.png";

/***/ }),

/***/ "ACA9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("LNMi");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1262eb2c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../css-loader/index.js?{\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c55dc398\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vux-loader/src/style-loader.js!../../../../vue-loader/lib/selector.js?type=styles&index=0!./modal.vue", function() {
     var newContent = require("!!../../../../css-loader/index.js?{\"sourceMap\":false}!../../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c55dc398\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vux-loader/src/style-loader.js!../../../../vue-loader/lib/selector.js?type=styles&index=0!./modal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "BRSA":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "D0EO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/knee_overstretch_normal.55c035f.png";

/***/ }),

/***/ "EXit":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAzCAYAAACE92h3AAADOElEQVRYhbXYX6hVRRTH8Y/HggSzuqZlEUKG9WCUgRYRRFBBQdlDwY0yfOghsof+GIRRFhT0UIQFUUEQQeVDf56MKIJEFImbHtHqJe2P0MWKS5gJcjN7mH1r7pzZe8/p7H5wODNrr7W+Z2b2/DtzJiYmFOp8PIqbcQFO4Fu8j804UpLklELYSnyCsxP7ZdXnLlyLw22JegWwHt7NwGJdjFcKchUBr6sStuk2nNsF8MoCn5lcq7oAjhUC4awugMeGALb6lgC/GwL4fRfAXYWwP7CvC+A31adNW3G8CyC8VOCzuSRRKfANfNnw/G3s7BI4jduFtTPVNtxfmKcRuFL41VNCC37FajyDz/ARHsKNWIDPK99tuKIu6Zya3WIx9mNRZOtjDX5MfK/CB1gS2aZwCX5JE9e18NkEBpdjN+6s4s7Ek0LLliS+Y3g6lzjXwuXCNGjq7qkK2ORzQmjlrHHPBWxoSURoQZvPXDycGtOgMdzdkmgYrZMs/ilwHPM6BM6TNCAFru0QNqN764DLhVe8a10qnHsGgPf8D7AZjeeA4xnHgwYnepM+rWJS3ZECV2BZxnE93hkC+GYVk2pZxfgHeEvGaQs+xvYhgNurmC2ZZ7fGwDXJw9/8O2lzO0ROx3CoKj9Y5cgCFxk83m3EZFX+AScLgIei8mE8ljxfhcU9XG/2y7MLr0X14/IvQqqvk/rr2BHVe7ihh/si459V/a8k+IsC4I6kfrLKNR3Z1vfM3ixfxN5MspKTQe5itB/PR/UVPWwSuu1DPJEJulA0jxr0CE7N2J/CW8Jm/Hjdjh9ro7Ahl+gmYVrUqqSrrs7YvpJfga5pS1YCvChjewAvZOxL25KV3IDPydj6Bt9kBs82A2pr4WnC2SXWQWEV6RtcEEa+kJ6XsfWr7yM40DUwd6/fk4HPaKGWYWoD5m60/ZpyU0wxMHfd3l1T7gS4MKn/jJ+ieuctTINTwKTBP4NGAp6R1PdkfFJbp8DcmKXA00cBLkjquTFLbWnMfwYelT/fpC0cCTg/Ku+VXz8P4PeugPE6mhs/1Y+ITwkjjWF8HmnaqeM/j6ZrvQqAzwndtRPvNfi9LHTtJF5tSvg38DKgLufRjRMAAAAASUVORK5CYII="

/***/ }),

/***/ "EY1w":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAYAAACaq43EAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyOUU2MUU4MkU0QUQxMUU3OTc0OUExOTkzM0I1NzhDNCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyOUU2MUU4M0U0QUQxMUU3OTc0OUExOTkzM0I1NzhDNCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjI5RTYxRTgwRTRBRDExRTc5NzQ5QTE5OTMzQjU3OEM0IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjI5RTYxRTgxRTRBRDExRTc5NzQ5QTE5OTMzQjU3OEM0Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+eU82NgAAAX5JREFUeNrE1s0rBHEAxvHZXS8pZ3+H/0BeWjWSSCQHoiQHHNwcXNzk5SAHoSS15CWXSQ5KykU5KAfaIpGE8nZRan1/9WwN7e7M7K7dpz7b7O7sPDO/+c3MhhKJhFWMlJgXx3EKWmrbthV2va/CwD91lWMHNb+OWImhFpWYyWNpmUptVODIfOg+4lE8YxrDeSyNqfQEHckv3MXnaMQr5jCYY2kE62jFqco/UhWbnCGKdyygL4fSNbS7tvnmXiGc4kfJvfvEInoClpptLqFLoxjVKFpexZbORxO+sIxOn6Uh7WwvLtCAl3R7ly7HaFb5uobNq3Qe/bhEPZ4yDUumHGpyfKu8JcO6sxhCXKWPXufDKwdo0/Kmzv/fTGEE17oX3PuZCH7iuK7BbU2YZCYxhlvU4c7vDPSbPXSjFLs6sgmMq8wM702gh0SAbKncnO993ZkeVBoPes0FzYZmbkTvzfJVVo/FLLKq4moduVWoYpOVXG7koWL9AwlbRcqPAAMA4eBON4VP6c4AAAAASUVORK5CYII="

/***/ }),

/***/ "EccH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/spine_sideway_normal.df562a8.png";

/***/ }),

/***/ "F0Ri":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAqCAYAAADBNhlmAAAACXBIWXMAAAsSAAALEgHS3X78AAACzElEQVRYhe1Zy3HbMBB95vgup4LokHuUe2bMBrxhKrBSQdhB5AoidyB1oKACeiYFSOdc5A6kCpQBsAhXAEFRHJLmIW9GI5KwiLdvsR/AN6fTCQZEHwB8BvAJw+IPgN9Qals1qyVItATwfWBiPtZQau4/TEA0HwE5jUcW6gw3p4eHPYD3/HANYDUwsRmAn+L+HZQ6uJtbQW5XJfEAKEA0MwqWhAs3bSLmPwzNTGAfG0hiA2PB6AnejoCDho7ejK/P8uE4FLRRm5qPiGDUKkh0xynnrgMKWyiVR+aZs3oHnq+Qw3Uu3gC474AczHuIEJAMK5hO1k9QauEe1LlYv+zYEcFjUACI0kgF+wGiLedGU0m4W8ALlEo7IlQPu3y2okg887dP+NtbRfHSq2DW9UQbVtqNLYePYqJMlDWNsrwqVXCpe+Unk2EJlpnB4amiD0yFgsehFdTkJny9k9FqEBqwGI6gde0XvjueubaENEAH7bI+SIjyKxL10q8C4j2BMoFrbcIODKirJCtvMV9CZnJbNclAGW+uKUe2NMC0YHUuLmrGqrCtJGe9cLVr3UBcQaVWJqM3dbFNET65qVGjxD9lPANcSQ0MqF+Dka3gFWjiWmlA7hvQXxRfUIYhDfhlvOahH4KhMvMK1y4aGNCbgr4yG4/czHQtJeaxFNU9QZvPmrjWwRqgSXOL1S9BYCqu80AZ69qPfGcNsMQK3iPL37du+fOGEe6vO9+1mTHAlkG3JKbyd21b/qJhfvT/Rrr2uTJ3eqgjmDORSWQsBqmaLn8H7vFy0Ua9elHegqB1YZsdnVTlMVLPo1Hro/sgsfnuJTKqlfvaxLUOfe1JMnZpypujvVG2Rensh6B1X6M1dgn/T7caIhqMiTg9uOcOZFjYEwZZDs+Suz5ZWHjZ/S2h63Im509467ceAbldVWMh/5HjjsG6OG67FvbIw0/eAP4CQqP90zR+BUYAAAAASUVORK5CYII="

/***/ }),

/***/ "GWoZ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAB8ElEQVRYhc2YMUscURSFv7sQsBA0BCwCFoIWwSBpbCzEf2CTNoUoAQlITJDgFilSKGIhGDAgEgsbCxv9BSZFCk0VY6VgkZBCkGxhIaQ4KdaRYfbO+HZ2dPZ27965Mx+H8+bdGSQ9k7Qn6UDSsqQOAkJSl6Q1Sd8lbUsaCOnzwiTtAb2x3CEwY2ZXt0C8AV7EUjXgpZmdNAtRAR4ncsPAaoAivYl1N7CeR5EK8NXJh4DsO7lcIBXgPfCzWRAz2wU2iwAxAEmdwCfgqXNNpkckzQATTinYIxa7WWkgFl+UBWLJRIsgyW0bxQUwYWa/vL5KA5XZJTBNDrMCK8COk38EbEhKbuv6M1NuFimyDjxxyt+A12b2z+kzoAo8d/rOgamkIg1K3NDVFXkFnDrlEWBZ0gOnT8ACviI9OIqkKhGFpIfUFel3yl+AuVYVuRXiPkCCIO4YZDIYIgDko5l9TunLAjlKNaYXZvYXeAfIKQ9l9AlYBM6c8mBTENdKLOF76UdGnwHzQJ9TPg6GCPDEVgZAlieqQRB3vDt+t/974j4AMiFKPztix7kHcAi8LQrAhWhlngBmUwAu0gAaIAqYrLyBpgZMpwFAO82YpU/bZQNA3RMfcgKMFwEQQYw2C3AdY0UARBB/cgAAJN2e+6ucdvg/8R8vXo0mKeOxJQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "GkfD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/face.dd616e0.png";

/***/ }),

/***/ "HUba":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo2ZTc0YWMwOC1mOGNmLWRlNDktYWE2OS0xODU3MDIwZGEwNWIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDU5QjlBREJFNjMwMTFFNzlCMjZEQUUyQzI3ODlCMkEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDU5QjlBREFFNjMwMTFFNzlCMjZEQUUyQzI3ODlCMkEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjZlNzRhYzA4LWY4Y2YtZGU0OS1hYTY5LTE4NTcwMjBkYTA1YiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo2ZTc0YWMwOC1mOGNmLWRlNDktYWE2OS0xODU3MDIwZGEwNWIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6ZAdWXAAACyElEQVR42uyYzWsTQRjGu6kmTWv9RA8i/gGCPfSgongR1JPeBT/QqpBDPYheRIUe/MCvQ3uIBVHUoxe9WbB6MKAVD14VRcGTIGIbE01qd/0NPIFl2W2y6ya7hwz8mOxOMvvMzDvPvFnLcZyeNJdMT8pLV2BXYNJlSVBDsVi0qJbBQqFQqPq056n6YI72Bdf9E1TXYCn8bfJ88wxjI+b3b+lnb5gZXAGP4Q4PHfRpvwAl2OK5b0RXjHCoNqEM87AKtoeaQY1sNewyHSHyNCOsuNp3wiYYgleu+5MwBf2amcVKHTabiQ/SEigQMbOIOsrHR3ASvnM9xv26vlKRgLrnd+b6Q6sxRp8NodnQm4SHvaM6Bl/hHJxSbMa5wQbUlxNpFyPyJdUo/IAxOKKm+ZgEOv9tM4h8QnUGeuEGs7ibugZ2YjbjUx7ASrgJDzWDTrMZ6JhRy+vG4TyshQ3yscSM2vjZWdjqijdTG4P+7QruTFJLbASMwHqfWHMUgzXZTSICf8JxGJYQv/Awp8XTRAQq5p6Jdmswg82lNZupyr7qYTfJiI6fu8xmrY0CP8kZfoWNwXGN7jm8b5c6Bv+H6nYUH7SUDORTmbAqJuwWUqZm2Yox9QOyLSdAwxuYdie+UY66qGUfXFaG7V4d9+fPsE0JSccF9itMMsqgpxXbWZeGUpDhd0KgLTISOwPX/ZYzSR80sfcFvmm5R4nN3jQJtLQRDirOrsChtAnsY1lfKPG1lfjuj0NgXDlfI97vw0VYAxOI3BFVoKWRlmPcLObkMPE4oWXeCPcQORTFqG1ZwTAdDHh8LKgvYx8fPWd3TsnAoPuvKX1e4uM65ZyTXO/hfjmMQNO2XH/E6y0sdeNovKoZapQZMeU5gyvmZYCsJxflb2dJO85RB9km5DWoWU8/r8G8c7nlkyjMKSk+HGTUVvcVcFdgV+Di5Z8AAwCgP+AqpXTFogAAAABJRU5ErkJggg=="

/***/ }),

/***/ "HmMl":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "I0OA":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("mbMD");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4a549f41", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7329a470\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Risk_ItemVideo.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7329a470\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Risk_ItemVideo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "I1j0":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("iXBp");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5b361909", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b9dea9b4\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_home.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b9dea9b4\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_home.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "IIld":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAeCAYAAAAo5+5WAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAb5JREFUeNq0lt1twjAQx42pxBNS84bESxuJAZigdAHECpmAZgJggsAErBBlgbYTdIBIlBekvCVSnvIQqXepg8zVHyeknmSdY/uOv384Fw8Ew7Is24J7UY+fy+Vy64sZMJK+gUvIcAzJ93cnhqRP4L6gPZKpCtockp9tsdIjODEkFWoscQVKh9oVuJUjdqXW8FFAACr61tWORqPON01DkTwDkoqr+EgRhGHYNQOSIwuFCcFkMhHj8bhr2OcgkQYENwoQwXQ6vT5jv8ei71DFWhUbEQyHw+sz9jlIJAcBNQ4SyUVAzYekV7zxIaDmQLLpzjH8wgL8uz4bBIGYzWac+iTyPBdlWdLhV1S8ZiixmmVnayn+yTDxQR9o21acTid2AlyLMcQOEt7zD+jc1FZkVte1NymuMfDdY84exU4VFJ8S384qlev3uKnqFOkrsIpdLhdrYpwjlQ4t6ivd9c+DgRRcqq8qisKIBMdwjliqchhrReRD4kAQWYsQB4kPgbUeu5BwEPT2YPlvUPVCrx+Ws/1nh85Pkw0JB4H3K21CwkHAvVfE9JRoCOK77hVK9bl/k4jtXLcg1t3t3kvhjwADAGFc4PeWwgH6AAAAAElFTkSuQmCC"

/***/ }),

/***/ "IwwR":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ZtK3");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("070ee1c0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1cc4265a\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_sympipad.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1cc4265a\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_sympipad.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/modal/_modal.js + 3 modules
var _modal = __webpack_require__("rKsW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/modal/modal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var modal = (_modal["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/modal/modal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var modal_modal = (_modal["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/modal/modal.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("ACA9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  modal_modal,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/bootstrap-vue/es/components/modal/modal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c55dc398", Component.options)
  } else {
    hotAPI.reload("data-v-c55dc398", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_modal_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JFR7":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAnCAYAAAD3h5P5AAACaElEQVRYhe3YTYhOURgH8N9735chwiuyEEUS+cpKjfKR8rlWytZ3StlMkpSFpUb5Zq0s7KR8R8pipnwNslF2SBJNGJmxOOeOM7cxo/eaofjXrXP/55znf88593nOc06lpb1HAfOwFWswA02RP4/NsbwTJwr9duFkLF/CBnzBC1zFOXSkHbKkPBLH8Ah7MCcRbhRNmBvtPcQpjM4ra4nwZawqKTYQMmzHbKxFVz7y1iEWTrEy6skwH9t+oVM9KU8ZpH78ILa2YX4NW1D9BfG1OIQ3whoWsRfvMQ1LB7FVxZZKS3vPM+HnGm48zTDzDwjD9Ez40/8ExmaDtxk6/Bf/98Rr/XBHcB0HsSRy34Qgcg/dDeiMwMZooxeVlvaedE99h0nowWpcifxN5WN/BW8xMSeK0z4BzbHhuoRfgOklxZuj/V4Upz3DXXRiTMJPFpKCDyXE60WivzVXEM5R7c9AGfx3tRRfhT17aoHvxOsSWtMEl/up+DfBt+/jMPZF/hUWxY9qFIvRJklcitP+AQ9i+U7CPy8pTMhe+3hLceR1nBXy7P0JvwwHhAjXCKpChOvjLcUIN6z4d13tr/Pz2/HZru/h4ILggo2gIuT9ywcS/xgbfRZc42Lk27CpQeEcrUKQGpcTGbqSBiP9cId01HXlU+w6RiXvnTVhq8xPLE3C1D7GiqThLDzR+LRXhSNUOoCXNSFbSY9LU/R/EJwVn9+Fa5lwY9BIXlYG3TiXCVcVZ4ZZ/Aw6cj/fgxvDJHwr6vUGmS6sx3FDtwTdOC1cFHWl4vkH7MZCHBW20a8lBTsFLzkq5AM78Cmv/A5UknOn124siAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "JUXa":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAvCAYAAAAb1BGUAAAEOklEQVRYha2Yv4/cRBTHPx57z+tsVr5EWW2kRUdxBQKaE0Rp0pA0SBEUhzh+lFCCxM8yoksTqJBCATREAhp+KAUNQiD+gJOggiKC6KQ0K7iQPUvsec9eU3i8zMzO2N5LvtLKfuP33mfmeWZsr7e7u8uKGgBvAs8DDwN7wNfAh8BfqyQSK/h6wGvAn8AV4BGgK49XZPvr0u+Bwk9Sju4jee7yuQ58U+OzMvwU8CPwXJuEwLb0P32/8Bj4CTjfElzpvOxAfFx4AHwLbK0IrrQl44PjwK8Bl5yBQrCxsYEQtcW7BLy/KvwZ4O26rIPBYPFr0FvAs23hp4FPaVgy6+vr2rFGHvAJlglog18DztZm8zx6vR4AvV4Pz2tc2mdl3lr4FvBKU6YoihZAz/OIoqgpBOBVjMlrwq8CflOWbrdbazskZH4r/Engcpssa2trtXaNLgNP2OBv0HJfvg+4R/lQ0uCngB2bdxzHS2XtdDq1drfbJY6dm9uO5C3gO4B11oxGI4bDodYWBPqmZcKHwyGj0cgFjyRvAd+2eXU6HaIoot/v18J9X5+j/X6fKIqWOqVou4KfAC5auyiXUBiGGsCEmdfCMNTiLboInBDAOSC0eagTST0393PVdsUYCoFzArjg8lDLpp7XjdwVY9EFATy2Ctz1FKvaV4A/KoDNNvBqkrn28apdnYwN8E0BbFSWEEIroTpKc4a7pPqp8b7vm1V7SKA86vr9vrY52ErcNHJVanwcx+aSjQXK5tLtdrXdTE1YVaTpnquVU+PDMDR3ypNaLYMgcJb9OFLjO50OeZ6rl/0AmCJHHwRB48iMBAtV7a7b4vu+eS0VwExtcQXP53Nru6miKKztlryHAjhQe6eOXB2lK2kdXI03VxKQCGBSWfP53AmpRu6qQJvrxrV7AhirvXb1vGo3fcw2V7x5DRgL4I7qrAaoPXW1t/UzcwN3AuB2ZWVZpvXu6OjIep7nuXb/1KSumCzLTPjtAPitstI01ZLWJVIfl23gaZqa8N8D4NfKSpJEWxJ1I1eVZVljzGQyMe/5LwFwi/LvjIGaBODw8BAoJ0qaplaYaadpSlEUeJ63iDc7Inm3qkX9AxZNp1OKolgcK81m2r6k2ar/dDq1pV3wKvhNm8d8PidJEiaTidZeB4eyxEmS1O2KN+H/D/fvgL+BM6bX3t7e0j1Wb4HNHo/HS69aiu5J3mLkU8rP4iXNZrMluFlO087zfKkaij6WPO1z6QPgrivC7FA1ybIsqwOZuovyqazC/wHeaZvl4OBAO7bUu5KzBAe4IX+N2t/f144tdAP4TG3wLH9/+sCXwAtN2aIoqltOqr4CXga0yWN7bcmBl4D3MF40TLUAz2SeF02wCw5QUP6L8DjwOZA6/FxKgS9k/FWZb0m2stt0BngaeIryC2eT8gOzDyTAv8AflA+pn4HvKfeNWv0HoUq9aoSpOlsAAAAASUVORK5CYII="

/***/ }),

/***/ "Jj+E":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/**\n* actionsheet\n*/\n/**\n* en: primary type text color of menu item\n* zh-CN: 菜单项primary类型的文本颜色\n*/\n/**\n* en: warn type text color of menu item\n* zh-CN: 菜单项warn类型的文本颜色\n*/\n/**\n* en: default type text color of menu item\n* zh-CN: 菜单项default类型的文本颜色\n*/\n/**\n* en: disabled type text color of menu item\n* zh-CN: 菜单项disabled类型的文本颜色\n*/\n/**\n* datetime\n*/\n/**\n* tabbar\n*/\n/**\n* tab\n*/\n/**\n* dialog\n*/\n/**\n* en: title and content's padding-left and padding-right\n* zh-CN: 标题及内容区域的 padding-left 和 padding-right\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* Header\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* en: border radius\n* zh-CN: 圆角边框\n*/\n/**\n* en: font color\n* zh-CN: 字体颜色\n*/\n/**\n* en: margin-top value between previous button, not works when there is only one button\n* zh-CN: 与相邻按钮的 margin-top 间隙，只有一个按钮时不生效\n*/\n/**\n* en: button height\n* zh-CN: 按钮高度\n*/\n/**\n* en: the font color in disabled\n* zh-CN: disabled状态下的字体颜色\n*/\n/**\n* en: the font color in disabled\n* zh-CN: disabled状态下的字体颜色\n*/\n/**\n* en: font size\n* zh-CN: 字体大小\n*/\n/**\n* en: the font size of the mini type\n* zh-CN: mini类型的字体大小\n*/\n/**\n* en: the line height of the mini type\n* zh-CN: mini类型的行高\n*/\n/**\n* en: the background color of the warn type\n* zh-CN: warn类型的背景颜色\n*/\n/**\n* en: the background color of the warn type in active\n* zh-CN: active状态下，warn类型的背景颜色\n*/\n/**\n* en: the background color of the warn type in disabled\n* zh-CN: disabled状态下，warn类型的背景颜色\n*/\n/**\n* en: the background color of the default type\n* zh-CN: default类型的背景颜色\n*/\n/**\n* en: the font color of the default type\n* zh-CN: default类型的字体颜色\n*/\n/**\n* en: the background color of the default type in active\n* zh-CN: active状态下，default类型的背景颜色\n*/\n/**\n* en: the font color of the default type in disabled\n* zh-CN: disabled状态下，default类型的字体颜色\n*/\n/**\n* en: the background color of the default type in disabled\n* zh-CN: disabled状态下，default类型的背景颜色\n*/\n/**\n* en: the font color of the default type in active\n* zh-CN: active状态下，default类型的字体颜色\n*/\n/**\n* en: the background color of the primary type\n* zh-CN: primary类型的背景颜色\n*/\n/**\n* en: the background color of the primary type in active\n* zh-CN: active状态下，primary类型的背景颜色\n*/\n/**\n* en: the background color of the primary type in disabled\n* zh-CN: disabled状态下，primary类型的背景颜色\n*/\n/**\n* en: the font color of the plain primary type\n* zh-CN: plain的primary类型的字体颜色\n*/\n/**\n* en: the border color of the plain primary type\n* zh-CN: plain的primary类型的边框颜色\n*/\n/**\n* en: the font color of the plain primary type in active\n* zh-CN: active状态下，plain的primary类型的字体颜色\n*/\n/**\n* en: the border color of the plain primary type in active\n* zh-CN: active状态下，plain的primary类型的边框颜色\n*/\n/**\n* en: the font color of the plain default type\n* zh-CN: plain的default类型的字体颜色\n*/\n/**\n* en: the border color of the plain default type\n* zh-CN: plain的default类型的边框颜色\n*/\n/**\n* en: the font color of the plain default type in active\n* zh-CN: active状态下，plain的default类型的字体颜色\n*/\n/**\n* en: the border color of the plain default type in active\n* zh-CN: active状态下，plain的default类型的边框颜色\n*/\n/**\n* en: the font color of the plain warn type\n* zh-CN: plain的warn类型的字体颜色\n*/\n/**\n* en: the border color of the plain warn type\n* zh-CN: plain的warn类型的边框颜色\n*/\n/**\n* en: the font color of the plain warn type in active\n* zh-CN: active状态下，plain的warn类型的字体颜色\n*/\n/**\n* en: the border color of the plain warn type in active\n* zh-CN: active状态下，plain的warn类型的边框颜色\n*/\n/**\n* swipeout\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* en: badge background color\n* zh-CN: badge的背景颜色\n*/\n/**\n* Popover\n*/\n/**\n* Button tab\n*/\n/**\n* en: not used\n* zh-CN: 未被使用\n*/\n/**\n* en: border radius color\n* zh-CN: 圆角边框的半径\n*/\n/**\n* en: border color\n* zh-CN: 边框的颜色\n*/\n/**\n* en: not used\n* zh-CN: 默认状态下圆角边框的颜色\n*/\n/**\n* en: not used\n* zh-CN: 未被使用\n*/\n/**\n* en: default background color\n* zh-CN: 默认状态下的背景颜色\n*/\n/**\n* en: selected background color\n* zh-CN: 选中状态下的背景颜色\n*/\n/**\n* en: not used\n* zh-CN: 未被使用\n*/\n/* alias */\n/**\n* en: not used\n* zh-CN: 未被使用\n*/\n/**\n* en: default text color\n* zh-CN: 默认状态下的文本颜色\n*/\n/**\n* en: height\n* zh-CN: 元素高度\n*/\n/**\n* en: line height\n* zh-CN: 元素行高\n*/\n/**\n* Swiper\n*/\n/**\n* checklist\n*/\n/**\n* popup-picker\n*/\n/**\n* popup\n*/\n/**\n* popup-header\n*/\n/**\n* form-preview\n*/\n/**\n* sticky\n*/\n/**\n* group\n*/\n/**\n* en: margin-top of title\n* zh-CN: 标题的margin-top\n*/\n/**\n* en: margin-bottom of title\n* zh-CN: 标题的margin-bottom\n*/\n/**\n* en: margin-top of footer title\n* zh-CN: 底部标题的margin-top\n*/\n/**\n* en: margin-bottom of footer title\n* zh-CN: 底部标题的margin-bottom\n*/\n/**\n* toast\n*/\n/**\n* en: text color of content\n* zh-CN: 内容文本颜色\n*/\n/**\n* en: default top\n* zh-CN: 默认状态下距离顶部的高度\n*/\n/**\n* en: position top\n* zh-CN: 顶部显示的高度\n*/\n/**\n* en: position bottom\n* zh-CN: 底部显示的高度\n*/\n/**\n* en: z-index\n* zh-CN: z-index\n*/\n/**\n* icon\n*/\n/**\n* calendar\n*/\n/**\n* en: forward and backward arrows color\n* zh-CN: 前进后退的箭头颜色\n*/\n/**\n* en: text color of week highlight\n* zh-CN: 周末高亮的文本颜色\n*/\n/**\n* en: background color when selected\n* zh-CN: 选中时的背景颜色\n*/\n/**\n* en: text color when disabled\n* zh-CN: 禁用时的文本颜色\n*/\n/**\n* en: text color of today\n* zh-CN: 今天的文本颜色\n*/\n/**\n* en: font size of cell\n* zh-CN: 单元格的字号\n*/\n/**\n* en: background color\n* zh-CN: 背景颜色\n*/\n/**\n* en: size of date cell\n* zh-CN: 日期单元格尺寸大小\n*/\n/**\n* en: line height of date cell\n* zh-CN: 日期单元格的行高\n*/\n/**\n* en: text color of header\n* zh-CN: 头部的文本颜色\n*/\n/**\n* week-calendar\n*/\n/**\n* search\n*/\n/**\n* en: text color of cancel button\n* zh-CN: 取消按钮文本颜色\n*/\n/**\n* en: background color\n* zh-CN: 背景颜色\n*/\n/**\n* en: text color of placeholder\n* zh-CN: placeholder文本颜色\n*/\n/**\n* radio\n*/\n/**\n* en: checked icon color\n* zh-CN: 选中状态的图标颜色\n*/\n/**\n* loadmore\n*/\n/**\n* en: not used\n* zh-CN: 未被使用\n*/\n/**\n* loading\n*/\n/**\n* en: z-index\n* zh-CN: z-index\n*/\n.weui-mask {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n}\n.weui-mask_transparent {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n}\n.weui-toast {\n  position: fixed;\n  z-index: 5001;\n  width: 7.6em;\n  min-height: 7.6em;\n  top: 180px;\n  left: 50%;\n  margin-left: -3.8em;\n  background: rgba(17, 17, 17, 0.7);\n  text-align: center;\n  border-radius: 5px;\n  color: #FFFFFF;\n}\n.weui-icon_toast {\n  margin: 22px 0 0;\n  display: block;\n}\n.weui-icon_toast.weui-icon-success-no-circle:before {\n  color: #FFFFFF;\n  font-size: 55px;\n}\n.weui-icon_toast.weui-loading {\n  margin: 30px 0 0;\n  width: 38px;\n  height: 38px;\n  vertical-align: baseline;\n}\n.weui-toast__content {\n  margin: 0 0 15px;\n}\n.weui-loading {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  -webkit-animation: weuiLoading 1s steps(12, end) infinite;\n          animation: weuiLoading 1s steps(12, end) infinite;\n  background: transparent url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgxMDB2MTAwSDB6Ii8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjRTlFOUU5IiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTMwKSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iIzk4OTY5NyIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgzMCAxMDUuOTggNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjOUI5OTlBIiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKDYwIDc1Ljk4IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0EzQTFBMiIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA2NSA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNBQkE5QUEiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoMTIwIDU4LjY2IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0IyQjJCMiIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgxNTAgNTQuMDIgNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjQkFCOEI5IiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKDE4MCA1MCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNDMkMwQzEiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE1MCA0NS45OCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNDQkNCQ0IiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTEyMCA0MS4zNCA2NSkiLz48cmVjdCB3aWR0aD0iNyIgaGVpZ2h0PSIyMCIgeD0iNDYuNSIgeT0iNDAiIGZpbGw9IiNEMkQyRDIiIHJ4PSI1IiByeT0iNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDM1IDY1KSIvPjxyZWN0IHdpZHRoPSI3IiBoZWlnaHQ9IjIwIiB4PSI0Ni41IiB5PSI0MCIgZmlsbD0iI0RBREFEQSIgcng9IjUiIHJ5PSI1IiB0cmFuc2Zvcm09InJvdGF0ZSgtNjAgMjQuMDIgNjUpIi8+PHJlY3Qgd2lkdGg9IjciIGhlaWdodD0iMjAiIHg9IjQ2LjUiIHk9IjQwIiBmaWxsPSIjRTJFMkUyIiByeD0iNSIgcnk9IjUiIHRyYW5zZm9ybT0icm90YXRlKC0zMCAtNS45OCA2NSkiLz48L3N2Zz4=\") no-repeat;\n  background-size: 100%;\n}\n.weui-loading.weui-loading_transparent {\n  background-image: url(\"data:image/svg+xml;base64,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\");\n}\n@-webkit-keyframes weuiLoading {\n0% {\n    -webkit-transform: rotate3d(0, 0, 1, 0deg);\n            transform: rotate3d(0, 0, 1, 0deg);\n}\n100% {\n    -webkit-transform: rotate3d(0, 0, 1, 360deg);\n            transform: rotate3d(0, 0, 1, 360deg);\n}\n}\n@keyframes weuiLoading {\n0% {\n    -webkit-transform: rotate3d(0, 0, 1, 0deg);\n            transform: rotate3d(0, 0, 1, 0deg);\n}\n100% {\n    -webkit-transform: rotate3d(0, 0, 1, 360deg);\n            transform: rotate3d(0, 0, 1, 360deg);\n}\n}\n.vux-loading .weui-toast {\n  z-index: 5001;\n}\n.weui-icon_toast.weui-loading {\n  margin: 30px 0 0;\n  width: 38px;\n  height: 38px;\n  vertical-align: baseline;\n  display: inline-block;\n}\n.vux-mask-enter,\n.vux-mask-leave-active,\n.vux-mask-leave-active,\n.vux-mask-enter-active {\n  position: relative;\n  z-index: 1;\n}\n.vux-mask-enter,\n.vux-mask-leave-active {\n  opacity: 0;\n}\n.vux-mask-leave-active,\n.vux-mask-enter-active {\n  -webkit-transition: opacity 300ms;\n  transition: opacity 300ms;\n}\n.vux-loading-no-text .weui-toast {\n  min-height: 98px;\n}\n", ""]);

// exports


/***/ }),

/***/ "JkoD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kyw1":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo5QkEzMkQ4MUU0QUQxMUU3OTNFMEUxOUVCOEMwMjBCOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo5QkEzMkQ4MkU0QUQxMUU3OTNFMEUxOUVCOEMwMjBCOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjlCQTMyRDdGRTRBRDExRTc5M0UwRTE5RUI4QzAyMEI5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjlCQTMyRDgwRTRBRDExRTc5M0UwRTE5RUI4QzAyMEI5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+RiWSlAAAAaxJREFUeNrsmE1LwzAYx9d2zDdEQRHBg6A3mQ4ELx48+FH6wfpRdvCwozAUTx5EEFQ6RXEim139B55BCG3apF0aJA/8CQ1d8luSPi/x0jRt2Wx+y3JzgFWtLXZEUdQoUBiGckCyS8Vxf6CB0HcOLSuO01fdYo/+hGfNFgtwq7QKU+gd+s55d5LRN6bfFRmbI9ABDGiFX+j5EXrIOis553ZYcpFOoU0dwBmU0Eoy2H3oE3oz+THJziALMV/QE8EyyBNoyxY/OAe8h24Ikr1/DG3b4qhn1I6gWw6yawpSJZLETUCqhjrjkDqxWITctTFZmEO+QndNRJJfapMCyLgGhoSbrzTglUFXN3QJq8uoM+yC2g+FrETXetBG3tn3JeBtWZ6msENFzjzg5jO+xUfQTpWIs2jA56phcdGAlWO3ia+4EqQpNxMLSW+Xy8x9W/zgiFzWlMvMD6AVWVlr2lGz0vWaSlIGtUeAWnVxrdcYXBU4phTtEFoiaQOuQ2clWCYZEacHqI5k59jcHa601QIMCLLM3Yxoaxp3M/8nWejXMPagDkDP3VE7wIbtT4ABACPpYUlOJyhJAAAAAElFTkSuQmCC"

/***/ }),

/***/ "L/iY":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.weui_msg[data-v-00e4705f] {\n  padding-top: 36px;\n  text-align: center;\n}\n.weui_icon_area[data-v-00e4705f]{\n  width:4rem;\n  height:4rem;\n  background-color:#10AEFF ;\n  border-radius: 4rem;\n  color:#fff;\n  font-size:50px ;\n  text-align: center;\n}\n.weui_text_area[data-v-00e4705f]{\n  margin-top: 36px;\n}\n.weui_msg .weui_msg_title[data-v-00e4705f] {\n  margin-bottom: 5px;\n  font-weight: 400;\n  font-size: 20px;\n}\n", ""]);

// exports


/***/ }),

/***/ "LNMi":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n/*\n  This CSS can be removed once Bootstrap V4.beta.3 is released\n  https://github.com/twbs/bootstrap/pull/24510\n  Once BSV4.beta.3 is released, the script section can be moved into the modal.js file\n  V4.beta.3 will be changing modal margin to rem units\n*/\n.modal-dialog-centered {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n            align-items: center;\n    /* min-height: calc(100% - (1rem * 2)); */\n    min-height: calc(100% - (10px * 2));\n}\n.modal-dialog-centered .modal-content {\n    width: 100%;\n}\n@media (min-width: 576px) {\n.modal-dialog-centered {\n        /* min-height: calc(100% - (1.75rem * 2)); */\n        min-height: calc(100% - (30px * 2));\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "LXfq":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("VEhD");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("49c50cd6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-469af010\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HelloWorld.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-469af010\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HelloWorld.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "LYyO":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n#routerView .swiper-slide{\n    overflow:scroll !important;\n}\n.level-box{\n    width: 3.3rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "Lexk":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n#showMiniQrcode {\n}\n#qrimgmini{\n  margin-top:11.2rem !important;\n}\n.postureView-swiper-pagination{\n  position: absolute;\n  top:0;\n  background: #f7f7f7;\n  color:rgb(102,204,255) !important;\n  height: 2rem;\n}\n.postureView-swiper-pagination .pagination-bullet{\n  font-size: 0.9rem !important;\n  height: 18px !important;\n  width: auto !important;\n}\n/* 封面 */\n.margin-bottom-60 {\n    margin-bottom: 3rem;\n}\n.margin-top-60 {\n    margin-top: 3rem;\n}\n.cover {\n    position: relative;\n    background: url(" + escape(__webpack_require__("kWoR")) + ") no-repeat center center / 100% 100%;\n}\n.cover-btn {\n    position: absolute;\n    right: 2rem;\n    bottom: 2rem;\n    width: 10rem;\n    height: 2.5rem;\n    /* background: url(\"../assets/images/posture/cover-arrow.png\") no-repeat center center / 100% 100%; */\n    /* background: url(\"../assets/images/posture/cover-arrow-v2.png\") no-repeat center center / 100% 100%; */\n}\n.senno-logo {\n    width: 10.5rem;\n    height: 2.5rem;\n    background: url(" + escape(__webpack_require__("3tUu")) + ") no-repeat center center / 100% 100%;\n}\n.cover-text span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n/* swiper 自定义样式开始 */\n.swiper-container {\n    width: 100%;\n    height: 100%;\n}\n.swiper-pagination-bullet {\n    opacity: 1;\n}\n.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {\n    bottom: 0\n}\n.swiper-slide {\n    box-sizing: border-box;\n    overflow: scroll;\n    -webkit-overflow-scrolling: touch;\n}\n.posture-swiper-pagination {\n    height: 2.7rem;\n    background: #f7f7f7;\n}\n.postureS-swiper-pagination {\n    top: 0rem;\n    height: 2rem;\n    background: #f7f7f7;\n}\n.pagination-bullet {\n    width: auto !important;\n    height: 12px !important;\n    line-height: 12px !important;\n    font-size: 12px !important;\n    color: #9f9f9f !important;\n    margin-bottom: 0.25rem !important;\n    /*margin-bottom: .1rem !important;;*/\n}\n.hidden-pagination {\n    display: none;\n}\n.head-space {\n    padding-top: 1.5rem;\n}\n.pagintaion-space {\n    padding-bottom: 2.7rem;\n}\n/* swiper 自定义样式结束 */\n.risks-head {\n    color: #2faefd;\n    background: #fff;\n    border-bottom: 1px solid #f8f6f7;\n}\n.risk-img {\n    width: 6rem;\n    height: 5.5rem;\n}\n.compare-img {\n    width: 7.5rem;\n    height: 7.5rem;\n    border-radius: .5rem;\n    overflow: hidden;\n}\n.level-box {\n    display: inline-block;\n    width: 4.3rem;\n    line-height: 1rem;\n    color: #fff;\n    text-align: center;\n    border-bottom-left-radius: .4rem;\n    border-top-right-radius: .4rem;\n}\n.level-severe {\n    background: #ff4d4d;\n}\n.level-mild {\n    background: #ffbf00;\n}\n.level-normal {\n    background: #00d963;\n}\n.line-clamp-2 {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden\n}\n.key-box {\n    padding: 0 .5rem;\n    margin: 0 .5rem .5rem 0;\n    line-height: 1rem;\n    color: #8a898a;\n    border: 1px solid #f3f3f3;\n    border-radius: .3rem;\n}\n.key-name {\n    margin: 1rem 0 .5rem;\n    color: #474747;\n    font-weight: bold;\n}\n.risk-box {\n    /*padding: 1rem 1.5rem 0 .5rem;*/\n    padding-top: .8rem;\n    background: #fff;\n    border-bottom: 1px solid #f8f6f7;\n}\n/* 设定 modal 为全屏覆盖 */\n.posture-modal .modal-dialog, .posture-modal .modal-content {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n}\n.posture-modal .modal-content {\n    overflow: auto;\n}\n.posture-modal .modal-body {\n    width: 100%;\n    min-height: 100%;\n}\n.posture-modal .modal-dialog .modal-content{\n    border: 0;\n    border-radius: 0;\n    box-shadow: 0 0;\n}\n.posture-modal .modal-dialog .modal-content .modal-body {\n    padding: 0;\n}\n/* 定义 modal 结束 */\n.back-btn {\n    padding: 0 .6rem;\n    line-height: 1.5rem;\n    color: #fff;\n    background: #ffaa15;\n    border-radius: .3rem;\n}\n.risk-head {\n    padding: 0 .5rem;\n    background: -webkit-linear-gradient(left, #cecece, #fbfbfb);\n    background: linear-gradient(left, #cecece, #fbfbfb);\n}\n.close-box {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 5rem;\n    background: url(" + escape(__webpack_require__("now/")) + ") no-repeat center center / 100% 100%;\n}\n.close-btn {\n    width: 2.5rem;\n    height: 2.5rem;\n    background: url(" + escape(__webpack_require__("3fkL")) + ") no-repeat center center / 100% 100%;\n}\n.hasrisk-icon {\n    width: 1.4rem;\n    height: 1.4rem;\n    margin: .6rem .5rem .6rem .9rem;\n    background: url(" + escape(__webpack_require__("38MQ")) + ") no-repeat center center / 100% 100%;\n}\n.norisk-icon {\n    width: 1.4rem;\n    height: 1.4rem;\n    margin: .6rem .5rem .6rem .9rem;\n    background: url(" + escape(__webpack_require__("8vL/")) + ") no-repeat center center / 100% 100%;\n}\n.down-arrow {\n    width: .4rem;\n    height: .7rem;\n    margin-top:.2rem;\n    background: url(" + escape(__webpack_require__("npZJ")) + ") no-repeat center center / 100% 100%;\n}\n.potentialRisk-icon {\n    width: 1rem;\n    height: 1rem;\n    margin: .2rem .2rem .2rem 0;\n    background: url(" + escape(__webpack_require__("zrcO")) + ") no-repeat center center / 100% 100%;\n}\n/*.pagination-icon {*/\n/*width: 1.5rem;*/\n/*height: 1.5rem;*/\n/*margin-top: .1rem;*/\n/*background: url(\"../assets/images/posture/navigation-icon.png\") no-repeat left top / 4.5rem 3rem;*/\n/*flex-shrink: 0;*/\n/*}*/\n.pagination-face {\n    background: url(" + escape(__webpack_require__("EXit")) + ") no-repeat center center / 100% 100%;\n    width: .775rem;\n    height: 1.3rem;\n    margin-top: 0.25rem;\n}\n.pagination-side {\n    background: url(" + escape(__webpack_require__("+uRf")) + ") no-repeat center center / 100% 100%;\n    width: .775rem;\n    height: 1.3rem;\n    margin-top: 0.25rem;\n}\n.pagination-bone {\n    background: url(" + escape(__webpack_require__("JUXa")) + ") no-repeat center center / 100% 100%;\n    width: .775rem;\n    height: 1.3rem;\n    margin-top: 0.25rem;\n}\n.pagination-symptom {\n    background: url(" + escape(__webpack_require__("T1Sm")) + ") no-repeat center center / 100% 100%;\n    width: .775rem;\n    height: 1.3rem;\n    margin-top: 0.25rem;\n}\n.pagination-riskassess {\n    background: url(" + escape(__webpack_require__("qJFv")) + ") no-repeat center center / 100% 100%;\n    width: .775rem;\n    height: 1.3rem;\n    margin-top: 0.25rem;\n}\n.pagination-symptom {\n    background: url(" + escape(__webpack_require__("T1Sm")) + ") no-repeat center center / 100% 100%;\n    width: .775rem;\n    height: 1.3rem;\n    margin-top: 0.25rem;\n}\n.swiper-pagination-bullet-active .pagination-face {\n     background: url(" + escape(__webpack_require__("unJv")) + ") no-repeat center center / 100% 100%;\n    width: .775rem;\n    height: 1.3rem;\n}\n.swiper-pagination-bullet-active .pagination-side {\n    background: url(" + escape(__webpack_require__("wKAa")) + ") no-repeat center center / 100% 100%;\n    width: .775rem;\n    height: 1.3rem;\n}\n.swiper-pagination-bullet-active .pagination-bone {\n    background: url(" + escape(__webpack_require__("kRl4")) + ") no-repeat center center / 100% 100%;\n    width: .775rem;\n    height: 1.3rem;\n}\n.swiper-pagination-bullet-active .pagination-symptom {\n    background: url(" + escape(__webpack_require__("JFR7")) + ") no-repeat center center / 100% 100%;\n    width: .775rem;\n    height: 1.3rem;\n}\n.swiper-pagination-bullet-active .pagination-riskassess {\n    background: url(" + escape(__webpack_require__("l7Ol")) + ") no-repeat center center / 100% 100%;\n    width: .775rem;\n    height: 1.3rem;\n}\n/*.swiper-pagination-bullet-active .pagination-icon {*/\n/*background-position-y: -1.5rem;*/\n/*}*/\n.swiper-pagination-bullet-active .pagination-bullet {\n\n    color: rgb(102,204,255) !important;\n}\n.tab-content{\n\n    height: 100%;\n    background: url(" + escape(__webpack_require__("kufR")) + ") no-repeat center center / 100% 100%;\n}\n.potential-risk-box {\n    padding-left: 1rem;\n    margin-bottom: 0;\n    color: #939393;\n}\n.potential-risk-box li {\n    margin-bottom: .3rem\n}\n.split-line {\n    min-height: 2.3rem;\n    border-right: 1px solid #cbcbcb;\n}\n.nav-pills .nav-link.active, .nav-pills .show > .nav-link{\n    border-bottom: 3px solid rgb(102,204,255);\n    color:rgb(102,204,255);\n    background-color: #fff;\n    border-radius: 0;\n    width:2.8rem;\n    /*font-weight: 600;*/\n}\n.nav-pills .nav-link{\n    color:#999;\n    /*font-weight: 500;*/\n    font-size:.9rem;\n    text-align: center;\n    line-height: 0.6rem;\n    height: 1.75rem;\n    /*padding: 0;*/\n    width:2.8rem;\n    padding-left: 0;\n    padding-right: 0;\n    margin-left: 1rem;\n}\n.card-header{\n    padding:0;\n    border-bottom: 0;\n}\n.card-header-pills{\n    margin: 0;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n            justify-content: center;\n}\n.card-style{\n    background-color: #fff;\n    height: 1.75rem;\n}\n.share-wechat-mini {\n    position: fixed;\n    text-align: center;\n    width: 3rem;\n    height: 3rem;\n    bottom: 10%;\n    right: .5rem;\n    z-index: 100;\n    /*opacity: 0;*/\n    background: url(" + escape(__webpack_require__("ePlP")) + ") no-repeat;\n    background-size: 3rem;\n}\n.card-body{\n    padding: 0;\n}\n.bone-desc{\n    position: absolute;\n    text-align: center;\n    width: 7.125rem;\n    height: 1.72rem;\n    bottom: 10%;\n    right: 0;\n    z-index: 100;\n    opacity:1;\n    /*background: url(\"../assets/images/posture/bone/boneDesc.png\") no-repeat;*/\n    background-size: 7.125rem 1.72rem;\n}\n@media(min-width: 768px) {\n#faceBone,#sideBone,#backBone {\n      overflow: hidden !important;\n}\n}\n.solution{\n    display: inline-block;\n    color:#fff;\n    width:90%;\n    height:2.35rem;\n    border-radius: 5px;\n    text-align: center;\n    line-height: 2.35rem;\n    letter-spacing: .05rem;\n    /* background: linear-gradient(#2cd4ff,#2cafff); */\n    background: -webkit-linear-gradient(#ffdc4a,#ffaa15);\n    background: linear-gradient(#ffdc4a,#ffaa15);\n}\n.solutions-modal  .modal-dialog, solutions-modal .modal-content {\n    width: 80%;\n    height: 100%;\n    margin: 0 auto;\n}\n/*.solutions-modal  .modal-dialog{*/\n/*display: flex;align-items: center;justify-content: center;*/\n/*}*/\n.solutions-modal .modal-content {\n    overflow: auto;\n}\n.solutions-modal .modal-body {\n    width: 100%;\n    min-height: 100%;\n}\n.solutions-modal .modal-dialog .modal-content{\n    border: 0;\n    box-shadow: 0 0;\n}\n.solutions-modal .modal-dialog .modal-content .modal-body {\n    padding: 0;\n}\n.solution-head{\n    height: 2rem;\n    background-color: #f4f4f4;\n}\n.download-icon{\n    display: inline-block;\n    width: .6rem;\n    height: .6rem;\n    margin-right: .3rem;\n    background: url(" + escape(__webpack_require__("0SEy")) + ") no-repeat  center center / 100% 100%;\n}\n.shareToCheck{\n    color:#fff;\n    width:90%;\n    height:2.35rem;\n    border-radius: 5px;\n    letter-spacing: .05rem;\n    background: -webkit-linear-gradient(#2cd4ff,#2cafff);\n    background: linear-gradient(#2cd4ff,#2cafff); /* 标准的语法 */\n}\n.shareIcon{\n    display: inline-block;\n    background: url(" + escape(__webpack_require__("RDnu")) + ") no-repeat  center center / 100% 100%;\n    width: .8rem;\n    height: .8rem;\n    margin-right: .5rem;\n}\n.name-icon{\n    display: inline-block;\n    background: url(" + escape(__webpack_require__("JkoD")) + ") no-repeat  left center / 100% 100%;\n    background-size: 1rem;\n}\n.more-icon{\n    display: inline-block;\n    background: url(" + escape(__webpack_require__("Q3KF")) + ") no-repeat  center center / 100% 100%;\n    width: 1.6rem;\n    height: .8rem;\n}\n.line-icon{\n    display: inline-block;\n    background: url(" + escape(__webpack_require__("r2UY")) + ") no-repeat  center center / 100% 100%;\n    width: 5rem;\n    height: 5rem;\n}\n.shelter{\n    opacity:0.8;letter-spacing:.2rem;color:#fff;position:fixed;background-color: #333;left:0;top:0;width:100%;height:100%;z-index:10;\n}\n.pagination-bullet .font-12{\n}\n.mobile_marginTop {\n    margin-top: 2rem;\n}\n.hmnClass{\n    width:14.5rem;\n}\n@media screen and (max-width: 600px) {\n /*    .mobilerisk{\n      float: left;\n      position: absolute;\n      margin-left: 15.4rem\n    } */\n}\n#jumpMiniUrl{\n    width: 90px;\n    position: absolute;\n    bottom: 0;\n    height: 54px;\n    z-index: 1;\n    right: 0px;\n    border: 1px solid red;\n    opacity:0;\n    filter:alpha(opacity=0);\n}\n.swiper-scrollbar{\n    position: absolute;\n    top:50px;\n    width: 100px;\n    height: 2px;\n    z-index: 3;\n}\n.swiper-pagination-bullet-active .pagination-views{\n    width: 2.9rem;\n    height: 0.2rem;\n    background: rgb(102,204,255);\n    border-radius: 0.14rem;\n    margin-top: 33px;\n}\n.views0{\n    margin-left: 24%!important;\n}\n\n", ""]);

// exports


/***/ }),

/***/ "Lltw":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.limit-line-3[data-v-071df230] {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden\n}\n.line[data-v-071df230] {\n  -webkit-line-clamp: 999;\n}\n.risk-box[data-v-071df230] {\n  position: relative;\n  margin: .5rem;\n  padding: 1rem .5rem;\n  border-radius: .3rem;\n  background: url(" + escape(__webpack_require__("l4Vc")) + ") no-repeat center center / 100% 100%;\n}\n.risk-img[data-v-071df230] {\n  width: 4rem;\n  height: 5rem;\n}\n.arrow[data-v-071df230] {\n  position: absolute;\n  width: .8rem;\n  height: .5rem;\n  right: 1rem;\n  bottom: .3rem;\n  background: url(" + escape(__webpack_require__("EY1w")) + ") no-repeat center center/ 100% 100%;\n}\n.up-arrow[data-v-071df230] {\n  background: url(" + escape(__webpack_require__("xXsX")) + ") no-repeat center center/ 100% 100%;\n}\n", ""]);

// exports


/***/ }),

/***/ "Mks9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/head_sideway_left.4c5ece5.png";

/***/ }),

/***/ "Mtz3":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*! PhotoSwipe main CSS by Dmitry Semenov | photoswipe.com | MIT license */\n/*\n\tStyles for basic PhotoSwipe functionality (sliding area, open/close transitions)\n*/\n/* pswp = photoswipe */\n.pswp {\n  display: none;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  overflow: hidden;\n  touch-action: none;\n  z-index: 1500;\n  -webkit-text-size-adjust: 100%;\n  /* create separate layer, to avoid paint on window.onscroll in webkit/blink */\n  -webkit-backface-visibility: hidden;\n  outline: none;\n}\n.pswp * {\n    box-sizing: border-box;\n}\n.pswp img {\n    max-width: none;\n}\n/* style is added when JS option showHideOpacity is set to true */\n.pswp--animate_opacity {\n  /* 0.001, because opacity:0 doesn't trigger Paint action, which causes lag at start of transition */\n  opacity: 0.001;\n  will-change: opacity;\n  /* for open/close transition */\n  -webkit-transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);\n          transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);\n}\n.pswp--open {\n  display: block;\n}\n.pswp--zoom-allowed .pswp__img {\n  /* autoprefixer: off */\n  cursor: -webkit-zoom-in;\n  cursor: -moz-zoom-in;\n  cursor: zoom-in;\n}\n.pswp--zoomed-in .pswp__img {\n  /* autoprefixer: off */\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n  cursor: grab;\n}\n.pswp--dragging .pswp__img {\n  /* autoprefixer: off */\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n  cursor: grabbing;\n}\n/*\n\tBackground is added as a separate element.\n\tAs animating opacity is much faster than animating rgba() background-color.\n*/\n.pswp__bg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  opacity: 0;\n  -webkit-transform: translateZ(0);\n          transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n  will-change: opacity;\n}\n.pswp__scroll-wrap {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n.pswp__container,\n.pswp__zoom-wrap {\n  touch-action: none;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n}\n/* Prevent selection and tap highlights */\n.pswp__container,\n.pswp__img {\n  -webkit-user-select: none;\n      user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n}\n.pswp__zoom-wrap {\n  position: absolute;\n  width: 100%;\n  -webkit-transform-origin: left top;\n  transform-origin: left top;\n  /* for open/close transition */\n  -webkit-transition: -webkit-transform 333ms cubic-bezier(0.4, 0, 0.22, 1);\n          transition: -webkit-transform 333ms cubic-bezier(0.4, 0, 0.22, 1);\n          transition: transform 333ms cubic-bezier(0.4, 0, 0.22, 1);\n          transition: transform 333ms cubic-bezier(0.4, 0, 0.22, 1), -webkit-transform 333ms cubic-bezier(0.4, 0, 0.22, 1);\n}\n.pswp__bg {\n  will-change: opacity;\n  /* for open/close transition */\n  -webkit-transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);\n          transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);\n}\n.pswp--animated-in .pswp__bg,\n.pswp--animated-in .pswp__zoom-wrap {\n  -webkit-transition: none;\n  transition: none;\n}\n.pswp__container,\n.pswp__zoom-wrap {\n  -webkit-backface-visibility: hidden;\n}\n.pswp__item {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  overflow: hidden;\n}\n.pswp__img {\n  position: absolute;\n  width: auto;\n  height: auto;\n  top: 0;\n  left: 0;\n}\n/*\n\tstretched thumbnail or div placeholder element (see below)\n\tstyle is added to avoid flickering in webkit/blink when layers overlap\n*/\n.pswp__img--placeholder {\n  -webkit-backface-visibility: hidden;\n}\n/*\n\tdiv element that matches size of large image\n\tlarge image loads on top of it\n*/\n.pswp__img--placeholder--blank {\n  background: #222;\n}\n.pswp--ie .pswp__img {\n  width: 100% !important;\n  height: auto !important;\n  left: 0;\n  top: 0;\n}\n/*\n\tError message appears when image is not loaded\n\t(JS option errorMsg controls markup)\n*/\n.pswp__error-msg {\n  position: absolute;\n  left: 0;\n  top: 50%;\n  width: 100%;\n  text-align: center;\n  font-size: 14px;\n  line-height: 16px;\n  margin-top: -8px;\n  color: #CCC;\n}\n.pswp__error-msg a {\n  color: #CCC;\n  text-decoration: underline;\n}\n", ""]);

// exports


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var App = ({
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])({
    direction: function direction(state) {
      return state.vux.direction;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectortype_script_index_0_src_App = ({
  computed: extends_default()({}, Object(vuex_esm["d" /* mapState */])({
    direction: function direction(state) {
      return state.vux.direction;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "100%" }, attrs: { id: "app" } },
    [
      _c("meta", {
        attrs: {
          name: "viewport",
          content: "width=device-width, user-scalable=no"
        }
      }),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: {
            name: "vux-pop-" + (_vm.direction === "forward" ? "in" : "out")
          },
          on: {
            "after-enter": function($event) {
              _vm.$vux.bus && _vm.$vux.bus.$emit("vux:after-view-enter")
            }
          }
        },
        [
          _c("router-view", {
            key: _vm.$route.path,
            staticClass: "router-view",
            attrs: { id: "routerView" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
App_render._withStripped = true
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}
// CONCATENATED MODULE: ./src/App.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("iI4W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe.js
var photoswipe = __webpack_require__("i7N3");
var photoswipe_default = /*#__PURE__*/__webpack_require__.n(photoswipe);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe-ui-default.js
var photoswipe_ui_default = __webpack_require__("72M0");
var photoswipe_ui_default_default = /*#__PURE__*/__webpack_require__.n(photoswipe_ui_default);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      return this.photoswipe.getCurrentIndex();
    },
    close: function close() {
      this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      return this.photoswipe.getCurrentIndex();
    },
    close: function close() {
      this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19226772","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/previewer/index.vue
var previewer_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pswp vux-previewer",
      attrs: { tabindex: "-1", role: "dialog", "aria-hidden": "true" }
    },
    [
      _c("div", { staticClass: "pswp__bg" }),
      _vm._v(" "),
      _c("div", { staticClass: "pswp__scroll-wrap" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "pswp__ui pswp__ui--hidden" }, [
          _c(
            "div",
            { staticClass: "pswp__top-bar" },
            [
              _c("div", { staticClass: "pswp__counter" }),
              _vm._v(" "),
              _vm._t("button-after"),
              _vm._v(" "),
              _c("button", {
                staticClass: "pswp__button pswp__button--close",
                attrs: { title: "Close (Esc)" }
              }),
              _vm._v(" "),
              _c("button", {
                staticClass: "pswp__button pswp__button--share",
                attrs: { title: "Share" }
              }),
              _vm._v(" "),
              _c("button", {
                staticClass: "pswp__button pswp__button--fs",
                attrs: { title: "Toggle fullscreen" }
              }),
              _vm._v(" "),
              _c("button", {
                staticClass: "pswp__button pswp__button--zoom",
                attrs: { title: "Zoom in/out" }
              }),
              _vm._v(" "),
              _vm._t("button-before"),
              _vm._v(" "),
              _vm._m(1)
            ],
            2
          ),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("button", {
            staticClass: "pswp__button pswp__button--arrow--left",
            attrs: { title: "Previous (arrow left)" }
          }),
          _vm._v(" "),
          _c("button", {
            staticClass: "pswp__button pswp__button--arrow--right",
            attrs: { title: "Next (arrow right)" }
          }),
          _vm._v(" "),
          _vm._m(3)
        ])
      ])
    ]
  )
}
var previewer_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pswp__container" }, [
      _c("div", { staticClass: "pswp__item" }),
      _vm._v(" "),
      _c("div", { staticClass: "pswp__item" }),
      _vm._v(" "),
      _c("div", { staticClass: "pswp__item" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pswp__preloader" }, [
      _c("div", { staticClass: "pswp__preloader__icn" }, [
        _c("div", { staticClass: "pswp__preloader__cut" }, [
          _c("div", { staticClass: "pswp__preloader__donut" })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
      },
      [_c("div", { staticClass: "pswp__share-tooltip" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pswp__caption" }, [
      _c("div", { staticClass: "pswp__caption__center" })
    ])
  }
]
previewer_render._withStripped = true
var previewer_esExports = { render: previewer_render, staticRenderFns: previewer_staticRenderFns }
/* harmony default export */ var src_components_previewer = (previewer_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19226772", previewer_esExports)
  }
}
// CONCATENATED MODULE: ./node_modules/vux/src/components/previewer/index.vue
var previewer_disposed = false
function previewer_injectStyle (ssrContext) {
  if (previewer_disposed) return
  __webpack_require__("WW73")
  __webpack_require__("4fDm")
}
var previewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var previewer___vue_template_functional__ = false
/* styles */
var previewer___vue_styles__ = previewer_injectStyle
/* scopeId */
var previewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var previewer___vue_module_identifier__ = null
var previewer_Component = previewer_normalizeComponent(
  components_previewer,
  src_components_previewer,
  previewer___vue_template_functional__,
  previewer___vue_styles__,
  previewer___vue_scopeId__,
  previewer___vue_module_identifier__
)
previewer_Component.options.__file = "node_modules/vux/src/components/previewer/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-19226772", previewer_Component.options)
  } else {
    hotAPI.reload("data-v-19226772", previewer_Component.options)
  }
  module.hot.dispose(function (data) {
    previewer_disposed = true
  })
})()}

/* harmony default export */ var vux_src_components_previewer = (previewer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1adbd40e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var loading_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: _vm.transition } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show"
          }
        ],
        staticClass: "weui-loading_toast vux-loading",
        class: !_vm.text ? "vux-loading-no-text" : ""
      },
      [
        _c("div", { staticClass: "weui-mask_transparent" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "weui-toast",
            style: {
              position: _vm.position
            }
          },
          [
            _c("i", { staticClass: "weui-loading weui-icon_toast" }),
            _vm._v(" "),
            _vm.text
              ? _c(
                  "p",
                  { staticClass: "weui-toast__content" },
                  [_vm._v(_vm._s(_vm.text || "加载中")), _vm._t("default")],
                  2
                )
              : _vm._e()
          ]
        )
      ]
    )
  ])
}
var loading_staticRenderFns = []
loading_render._withStripped = true
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var src_components_loading = (loading_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1adbd40e", loading_esExports)
  }
}
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
var loading_disposed = false
function loading_injectStyle (ssrContext) {
  if (loading_disposed) return
  __webpack_require__("9QSZ")
}
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = loading_injectStyle
/* scopeId */
var loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  components_loading,
  src_components_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)
loading_Component.options.__file = "node_modules/vux/src/components/loading/index.vue"


/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1adbd40e", loading_Component.options)
  } else {
    hotAPI.reload("data-v-1adbd40e", loading_Component.options)
  }
  module.hot.dispose(function (data) {
    loading_disposed = true
  })
})()}

/* harmony default export */ var vux_src_components_loading = (loading_Component.exports);

// EXTERNAL MODULE: ./node_modules/swiper/dist/css/swiper.css
var swiper = __webpack_require__("v2ns");
var swiper_default = /*#__PURE__*/__webpack_require__.n(swiper);

// EXTERNAL MODULE: ./node_modules/vue-awesome-swiper/dist/vue-awesome-swiper.js
var vue_awesome_swiper = __webpack_require__("7QTg");
var vue_awesome_swiper_default = /*#__PURE__*/__webpack_require__.n(vue_awesome_swiper);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./src/assets/javascripts/imgSrc.js
var imgSrc = __webpack_require__("On8B");
var imgSrc_default = /*#__PURE__*/__webpack_require__.n(imgSrc);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/assets/javascripts/utils.js
var utils = __webpack_require__("bFVm");
var utils_default = /*#__PURE__*/__webpack_require__.n(utils);

// EXTERNAL MODULE: ./node_modules/url/url.js
var url = __webpack_require__("UZ5h");
var url_default = /*#__PURE__*/__webpack_require__.n(url);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue















var bullets = [{
  text: '正视图',
  className: 'pagination-bullet font-12'
}, {
  text: '侧视图',
  className: 'pagination-bullet font-12'
}];

/* harmony default export */ var Home = ({
  components: {
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    Previewer: vux_src_components_previewer,
    Loading: vux_src_components_loading
  },
  methods: extends_default()({
    go: function go(path) {
      this.$router.push(path);
    },
    createCanvas: function createCanvas(option) {
      var _this = this;
      var NAMES = this.NAMES;
      var level = this.level;
      var canvasDom = null;
      var getImg = new promise_default.a(function (resolved, rejected) {
        var img = new Image();
        img.onload = function () {
          resolved(img);
        };
        img.src = option.src;
      });

      canvasDom = getImg.then(function (img) {
        var width = img.width;
        var height = img.height;
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.style.width = '100%';
        _this[option.key].scale = jquery_default()(option.destination).width() / width;
        var cxt = canvas.getContext('2d');
        cxt.drawImage(img, 0, 0, width, height);
        if (option.key == 'face') {
          for (var i = 0; i < option.data.length; i++) {
            if (option.data[i].valid) {

              if (option.data[i].position == NAMES.pelvis) {
                cxt.save();
                cxt.lineWidth = 3;
                cxt.strokeStyle = '#009901';
                cxt.beginPath();
                cxt.arc((option.data[i].points[0].x + option.data[i].points[1].x) / 2, (option.data[i].points[0].y + option.data[i].points[1].y) / 2, Math.abs(option.data[i].points[1].x - option.data[i].points[0].x) / 2, 0, 2 * Math.PI);
                cxt.closePath();
                cxt.stroke();
                cxt.restore();
              }

              if (option.data[i].level == level.normal) {

                if (option.data[i].position !== NAMES['lower extremity'] && option.data[i].position !== NAMES.trunk) {
                  cxt.save();
                  cxt.setLineDash([4, 6]);
                  cxt.lineWidth = 5;
                  cxt.strokeStyle = '#009901';
                  cxt.beginPath();
                  cxt.moveTo((option.data[i].points[0].x + option.data[i].points[1].x) / 2 - width / 4, option.data[i].points[0].y);
                  cxt.lineTo((option.data[i].points[0].x + option.data[i].points[1].x) / 2 + width / 4, option.data[i].points[0].y);
                  cxt.closePath();
                  cxt.stroke();
                  cxt.restore();
                } else {

                  cxt.save();
                  cxt.setLineDash([5, 6]);
                  cxt.lineWidth = 3;
                  cxt.strokeStyle = '#009901';
                  cxt.beginPath();
                  if (option.data[i].position == NAMES['lower extremity']) {
                    cxt.moveTo(option.data[i].points[0].x, option.data[i].points[0].y);
                    cxt.lineTo(option.data[i].points[0].x, option.data[i].points[2].y);
                  } else {
                    cxt.moveTo(option.data[i].points[0].x, option.data[i].points[0].y + 20);
                    cxt.lineTo(option.data[i].points[0].x, option.data[i].points[1].y - 20);
                  }
                  cxt.closePath();
                  cxt.stroke();
                  cxt.restore();
                }
              } else {

                if (option.data[i].position !== NAMES['lower extremity'] && option.data[i].position !== NAMES.trunk) {

                  cxt.save();
                  cxt.setLineDash([4, 6]);
                  cxt.lineWidth = 3;
                  cxt.strokeStyle = '#009901';
                  cxt.beginPath();
                  cxt.moveTo((option.data[i].points[0].x + option.data[i].points[1].x) / 2 - width / 4, option.data[i].points[0].y);
                  cxt.lineTo((option.data[i].points[0].x + option.data[i].points[1].x) / 2 + width / 4, option.data[i].points[0].y);
                  cxt.closePath();
                  cxt.stroke();
                  cxt.restore();

                  cxt.save();
                  cxt.lineWidth = 3;
                  cxt.strokeStyle = '#ff1605';
                  cxt.beginPath();
                  cxt.moveTo(option.data[i].points[0].x, option.data[i].points[0].y);
                  cxt.lineTo(option.data[i].points[1].x, option.data[i].points[1].y);
                  cxt.closePath();
                  cxt.stroke();
                  cxt.restore();
                } else {

                  cxt.save();
                  cxt.setLineDash([5, 6]);
                  cxt.lineWidth = 3;
                  cxt.strokeStyle = '#009901';
                  cxt.beginPath();
                  if (option.data[i].position == NAMES['lower extremity']) {
                    cxt.moveTo(option.data[i].points[0].x, option.data[i].points[0].y);
                    cxt.lineTo(option.data[i].points[0].x, option.data[i].points[2].y);
                  } else {
                    cxt.moveTo(option.data[i].points[0].x, option.data[i].points[0].y + 20);
                    cxt.lineTo(option.data[i].points[0].x, option.data[i].points[1].y - 20);
                  }
                  cxt.closePath();
                  cxt.stroke();
                  cxt.restore();

                  cxt.save();
                  cxt.lineWidth = 3;
                  cxt.strokeStyle = '#ff1605';
                  cxt.beginPath();
                  for (var j = 0; j < option.data[i].points.length; j++) {
                    if (j == 0) {
                      cxt.moveTo(option.data[i].points[j].x, option.data[i].points[j].y);
                    } else {
                      cxt.lineTo(option.data[i].points[j].x, option.data[i].points[j].y);
                    }
                  }
                  cxt.stroke();
                  cxt.restore();
                }
              }
            }
          }
        } else {
          for (var _i = 0; _i < option.data.length; _i++) {
            if (option.data[_i].valid) {
              if (option.data[_i].position == NAMES.shoulder) {
                cxt.save();
                cxt.lineWidth = 3;
                cxt.setLineDash([4, 6]);
                cxt.strokeStyle = '#009901';
                cxt.beginPath();
                cxt.moveTo(option.data[_i].points[1].x, 0.1 * height);
                cxt.lineTo(option.data[_i].points[1].x, 0.9 * height);
                cxt.closePath();
                cxt.stroke();
                cxt.restore();
              }

              if (option.data[_i].level !== level.normal) {
                cxt.save();
                cxt.lineWidth = 3;
                cxt.strokeStyle = '#ff1605';
                cxt.beginPath();
                for (var _j = 0; _j < option.data[_i].points.length; _j++) {
                  if (_j == 0) {
                    cxt.moveTo(option.data[_i].points[_j].x, option.data[_i].points[_j].y);
                  } else {
                    cxt.lineTo(option.data[_i].points[_j].x, option.data[_i].points[_j].y);
                  }
                }
                cxt.stroke();
                cxt.restore();
              }
            }
          }
        }
        canvas.id = option.destination.slice(1) + 'Canvas';
        jquery_default()(option.destination).append(canvas);
      });
    }
  }, Object(vuex_esm["d" /* mapState */])({
    initReportData: function initReportData(state) {
      var reportData = state.vux.reportData;
      var _this = this;
      if (lodash_default.a.isNull(reportData)) {
        var uuid = '';
        var type = '';

        var urlquery = url_default.a.parse(window.location.href).query;
        var query = urlquery.split('&');
        for (var every = 0; every < query.length; every++) {
          if (query[every].indexOf('uuid=') != -1) {
            uuid = query[every].replace('uuid=', '');
          }
          if (query[every].indexOf('type=') != -1) {
            type = query[every].replace('type=', '');
          }
        }

        this.get({
          url: 'v1/posture/reports/' + uuid,
          params: {
            type: type
          },
          success: function success(result) {
            _this.updateReportData({
              reportData: result
            });
            _this.getReportData();
            console.log('result=>', result);
          },
          error: function error(data) {
            _this.loading = false;
            _this.valid = false;
          }
        });
      } else {
        _this.getReportData();
      }
    },
    getReportData: function getReportData(state) {
      this.loading = false;
      var reportData = state.vux.reportData;
      this.reportData = reportData;
      if (lodash_default.a.isNull(reportData.customer)) {
        this.customer = {
          avatar: null,
          name: '--'
        };
      } else {
        this.customer = reportData.customer;
      }

      if (lodash_default.a.isNull(reportData.conclusion.risks)) {
        this.valid = false;
      } else {
        this.initPostureImg();
      }
    },
    initPostureImg: function initPostureImg(state) {
      var reportData = state.vux.reportData;
      console.log('reportData =>', reportData);
      var face = {
        key: 'face',
        src: reportData.face,
        destination: '#face',
        data: []
      };
      var side = {
        key: 'side',
        src: reportData.side,
        destination: '#side',
        data: []
      };

      var NAMES = this.NAMES;

      for (var i = 0; i < reportData.conclusion.risks.length; i++) {
        if (reportData.conclusion.risks[i].position == NAMES.head && reportData.conclusion.risks[i].code == 2 || reportData.conclusion.risks[i].position == NAMES.shoulder && reportData.conclusion.risks[i].code == 2 || reportData.conclusion.risks[i].position == NAMES['lower extremity'] && reportData.conclusion.risks[i].code == 3) {
          if (lodash_default.a.isNull(reportData.conclusion.risks[i].points)) {
            side.data.push(reportData.conclusion.risks[i]);
            continue;
          }
          reportData.conclusion.risks[i].coord = {};
          reportData.conclusion.risks[i].coord.top = reportData.conclusion.risks[i].points[0].y;
          reportData.conclusion.risks[i].coord.left = 44;
          side.data.push(reportData.conclusion.risks[i]);
        } else {
          if (lodash_default.a.isNull(reportData.conclusion.risks[i].points)) {
            face.data.push(reportData.conclusion.risks[i]);
            continue;
          }
          reportData.conclusion.risks[i].coord = {};

          switch (reportData.conclusion.risks[i].position) {
            case NAMES['lower extremity']:
              reportData.conclusion.risks[i].coord.top = (reportData.conclusion.risks[i].points[0].y + reportData.conclusion.risks[i].points[2].y) / 2;
              break;
            case NAMES.trunk:
              reportData.conclusion.risks[i].coord.top = (reportData.conclusion.risks[i].points[0].y + reportData.conclusion.risks[i].points[1].y) / 2;
              break;
            default:
              reportData.conclusion.risks[i].coord.top = reportData.conclusion.risks[i].points[0].y;
              break;
          }

          switch (reportData.conclusion.risks[i].position) {
            case NAMES['lower extremity']:
              reportData.conclusion.risks[i].coord.left = 44;
              break;
            case NAMES['trunk']:
              reportData.conclusion.risks[i].coord.left = 44;
              break;
            default:
              reportData.conclusion.risks[i].coord.right = 44;
              break;
          }

          face.data.push(reportData.conclusion.risks[i]);
        }
      }
      this.face.data = face.data;
      this.side.data = side.data;
      this.createCanvas(face);
      this.createCanvas(side);
    }
  }), Object(vuex_esm["b" /* mapActions */])(['get']), Object(vuex_esm["c" /* mapMutations */])(['updateReportData'])),
  data: function data() {
    return {
      bullets: [{
        text: 'front',
        className: 'pagination-bullet font-12'
      }, {
        text: 'side',
        className: 'pagination-bullet font-12'
      }],
      swiperOption: {
        pagination: {
          el: '.posture-swiper-pagination',
          clickable: true,
          renderBullet: function renderBullet(index, className) {
            return '<span class="' + className + ' ' + bullets[index].className + '">' + bullets[index].text + '</span>';
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      face: {
        data: [],
        scale: 0
      },
      side: {
        data: [],
        scale: 0
      },
      reportData: {},
      valid: true,
      showImg: false,
      NAMES: {
        head: 'head',
        shoulder: 'shoulder',
        trunk: 'trunk',
        pelvis: 'pelvis',
        "lower extremity": 'lower extremity'
      },
      level: {
        normal: 'normal',
        mild: 'mild',
        severe: 'severe'
      },
      loading: true,
      customer: {}
    };
  },

  computed: {
    avatar: function avatar() {
      return lodash_default.a.isNull(this.customer.avatar) ? imgSrc_default.a.DEFAULT_AVATAR : utils_default.a.base64ToSrc(this.customer.avatar);
    }
  },
  created: function created() {
    this.initReportData();
  },
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue















var Home_bullets = [{
  text: '正视图',
  className: 'pagination-bullet font-12'
}, {
  text: '侧视图',
  className: 'pagination-bullet font-12'
}];

/* harmony default export */ var components_Home = ({
  components: {
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    Previewer: vux_src_components_previewer,
    Loading: vux_src_components_loading
  },
  methods: extends_default()({
    go: function go(path) {
      this.$router.push(path);
    },
    createCanvas: function createCanvas(option) {
      var _this = this;
      var NAMES = this.NAMES;
      var level = this.level;
      var canvasDom = null;
      var getImg = new promise_default.a(function (resolved, rejected) {
        var img = new Image();
        img.onload = function () {
          resolved(img);
        };
        img.src = option.src;
      });

      canvasDom = getImg.then(function (img) {
        var width = img.width;
        var height = img.height;
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.style.width = '100%';
        _this[option.key].scale = jquery_default()(option.destination).width() / width;
        var cxt = canvas.getContext('2d');
        cxt.drawImage(img, 0, 0, width, height);
        if (option.key == 'face') {
          for (var i = 0; i < option.data.length; i++) {
            if (option.data[i].valid) {

              if (option.data[i].position == NAMES.pelvis) {
                cxt.save();
                cxt.lineWidth = 3;
                cxt.strokeStyle = '#009901';
                cxt.beginPath();
                cxt.arc((option.data[i].points[0].x + option.data[i].points[1].x) / 2, (option.data[i].points[0].y + option.data[i].points[1].y) / 2, Math.abs(option.data[i].points[1].x - option.data[i].points[0].x) / 2, 0, 2 * Math.PI);
                cxt.closePath();
                cxt.stroke();
                cxt.restore();
              }

              if (option.data[i].level == level.normal) {

                if (option.data[i].position !== NAMES['lower extremity'] && option.data[i].position !== NAMES.trunk) {
                  cxt.save();
                  cxt.setLineDash([4, 6]);
                  cxt.lineWidth = 5;
                  cxt.strokeStyle = '#009901';
                  cxt.beginPath();
                  cxt.moveTo((option.data[i].points[0].x + option.data[i].points[1].x) / 2 - width / 4, option.data[i].points[0].y);
                  cxt.lineTo((option.data[i].points[0].x + option.data[i].points[1].x) / 2 + width / 4, option.data[i].points[0].y);
                  cxt.closePath();
                  cxt.stroke();
                  cxt.restore();
                } else {

                  cxt.save();
                  cxt.setLineDash([5, 6]);
                  cxt.lineWidth = 3;
                  cxt.strokeStyle = '#009901';
                  cxt.beginPath();
                  if (option.data[i].position == NAMES['lower extremity']) {
                    cxt.moveTo(option.data[i].points[0].x, option.data[i].points[0].y);
                    cxt.lineTo(option.data[i].points[0].x, option.data[i].points[2].y);
                  } else {
                    cxt.moveTo(option.data[i].points[0].x, option.data[i].points[0].y + 20);
                    cxt.lineTo(option.data[i].points[0].x, option.data[i].points[1].y - 20);
                  }
                  cxt.closePath();
                  cxt.stroke();
                  cxt.restore();
                }
              } else {

                if (option.data[i].position !== NAMES['lower extremity'] && option.data[i].position !== NAMES.trunk) {

                  cxt.save();
                  cxt.setLineDash([4, 6]);
                  cxt.lineWidth = 3;
                  cxt.strokeStyle = '#009901';
                  cxt.beginPath();
                  cxt.moveTo((option.data[i].points[0].x + option.data[i].points[1].x) / 2 - width / 4, option.data[i].points[0].y);
                  cxt.lineTo((option.data[i].points[0].x + option.data[i].points[1].x) / 2 + width / 4, option.data[i].points[0].y);
                  cxt.closePath();
                  cxt.stroke();
                  cxt.restore();

                  cxt.save();
                  cxt.lineWidth = 3;
                  cxt.strokeStyle = '#ff1605';
                  cxt.beginPath();
                  cxt.moveTo(option.data[i].points[0].x, option.data[i].points[0].y);
                  cxt.lineTo(option.data[i].points[1].x, option.data[i].points[1].y);
                  cxt.closePath();
                  cxt.stroke();
                  cxt.restore();
                } else {

                  cxt.save();
                  cxt.setLineDash([5, 6]);
                  cxt.lineWidth = 3;
                  cxt.strokeStyle = '#009901';
                  cxt.beginPath();
                  if (option.data[i].position == NAMES['lower extremity']) {
                    cxt.moveTo(option.data[i].points[0].x, option.data[i].points[0].y);
                    cxt.lineTo(option.data[i].points[0].x, option.data[i].points[2].y);
                  } else {
                    cxt.moveTo(option.data[i].points[0].x, option.data[i].points[0].y + 20);
                    cxt.lineTo(option.data[i].points[0].x, option.data[i].points[1].y - 20);
                  }
                  cxt.closePath();
                  cxt.stroke();
                  cxt.restore();

                  cxt.save();
                  cxt.lineWidth = 3;
                  cxt.strokeStyle = '#ff1605';
                  cxt.beginPath();
                  for (var j = 0; j < option.data[i].points.length; j++) {
                    if (j == 0) {
                      cxt.moveTo(option.data[i].points[j].x, option.data[i].points[j].y);
                    } else {
                      cxt.lineTo(option.data[i].points[j].x, option.data[i].points[j].y);
                    }
                  }
                  cxt.stroke();
                  cxt.restore();
                }
              }
            }
          }
        } else {
          for (var _i = 0; _i < option.data.length; _i++) {
            if (option.data[_i].valid) {
              if (option.data[_i].position == NAMES.shoulder) {
                cxt.save();
                cxt.lineWidth = 3;
                cxt.setLineDash([4, 6]);
                cxt.strokeStyle = '#009901';
                cxt.beginPath();
                cxt.moveTo(option.data[_i].points[1].x, 0.1 * height);
                cxt.lineTo(option.data[_i].points[1].x, 0.9 * height);
                cxt.closePath();
                cxt.stroke();
                cxt.restore();
              }

              if (option.data[_i].level !== level.normal) {
                cxt.save();
                cxt.lineWidth = 3;
                cxt.strokeStyle = '#ff1605';
                cxt.beginPath();
                for (var _j = 0; _j < option.data[_i].points.length; _j++) {
                  if (_j == 0) {
                    cxt.moveTo(option.data[_i].points[_j].x, option.data[_i].points[_j].y);
                  } else {
                    cxt.lineTo(option.data[_i].points[_j].x, option.data[_i].points[_j].y);
                  }
                }
                cxt.stroke();
                cxt.restore();
              }
            }
          }
        }
        canvas.id = option.destination.slice(1) + 'Canvas';
        jquery_default()(option.destination).append(canvas);
      });
    }
  }, Object(vuex_esm["d" /* mapState */])({
    initReportData: function initReportData(state) {
      var reportData = state.vux.reportData;
      var _this = this;
      if (lodash_default.a.isNull(reportData)) {
        var uuid = '';
        var type = '';

        var urlquery = url_default.a.parse(window.location.href).query;
        var query = urlquery.split('&');
        for (var every = 0; every < query.length; every++) {
          if (query[every].indexOf('uuid=') != -1) {
            uuid = query[every].replace('uuid=', '');
          }
          if (query[every].indexOf('type=') != -1) {
            type = query[every].replace('type=', '');
          }
        }

        this.get({
          url: 'v1/posture/reports/' + uuid,
          params: {
            type: type
          },
          success: function success(result) {
            _this.updateReportData({
              reportData: result
            });
            _this.getReportData();
            console.log('result=>', result);
          },
          error: function error(data) {
            _this.loading = false;
            _this.valid = false;
          }
        });
      } else {
        _this.getReportData();
      }
    },
    getReportData: function getReportData(state) {
      this.loading = false;
      var reportData = state.vux.reportData;
      this.reportData = reportData;
      if (lodash_default.a.isNull(reportData.customer)) {
        this.customer = {
          avatar: null,
          name: '--'
        };
      } else {
        this.customer = reportData.customer;
      }

      if (lodash_default.a.isNull(reportData.conclusion.risks)) {
        this.valid = false;
      } else {
        this.initPostureImg();
      }
    },
    initPostureImg: function initPostureImg(state) {
      var reportData = state.vux.reportData;
      console.log('reportData =>', reportData);
      var face = {
        key: 'face',
        src: reportData.face,
        destination: '#face',
        data: []
      };
      var side = {
        key: 'side',
        src: reportData.side,
        destination: '#side',
        data: []
      };

      var NAMES = this.NAMES;

      for (var i = 0; i < reportData.conclusion.risks.length; i++) {
        if (reportData.conclusion.risks[i].position == NAMES.head && reportData.conclusion.risks[i].code == 2 || reportData.conclusion.risks[i].position == NAMES.shoulder && reportData.conclusion.risks[i].code == 2 || reportData.conclusion.risks[i].position == NAMES['lower extremity'] && reportData.conclusion.risks[i].code == 3) {
          if (lodash_default.a.isNull(reportData.conclusion.risks[i].points)) {
            side.data.push(reportData.conclusion.risks[i]);
            continue;
          }
          reportData.conclusion.risks[i].coord = {};
          reportData.conclusion.risks[i].coord.top = reportData.conclusion.risks[i].points[0].y;
          reportData.conclusion.risks[i].coord.left = 44;
          side.data.push(reportData.conclusion.risks[i]);
        } else {
          if (lodash_default.a.isNull(reportData.conclusion.risks[i].points)) {
            face.data.push(reportData.conclusion.risks[i]);
            continue;
          }
          reportData.conclusion.risks[i].coord = {};

          switch (reportData.conclusion.risks[i].position) {
            case NAMES['lower extremity']:
              reportData.conclusion.risks[i].coord.top = (reportData.conclusion.risks[i].points[0].y + reportData.conclusion.risks[i].points[2].y) / 2;
              break;
            case NAMES.trunk:
              reportData.conclusion.risks[i].coord.top = (reportData.conclusion.risks[i].points[0].y + reportData.conclusion.risks[i].points[1].y) / 2;
              break;
            default:
              reportData.conclusion.risks[i].coord.top = reportData.conclusion.risks[i].points[0].y;
              break;
          }

          switch (reportData.conclusion.risks[i].position) {
            case NAMES['lower extremity']:
              reportData.conclusion.risks[i].coord.left = 44;
              break;
            case NAMES['trunk']:
              reportData.conclusion.risks[i].coord.left = 44;
              break;
            default:
              reportData.conclusion.risks[i].coord.right = 44;
              break;
          }

          face.data.push(reportData.conclusion.risks[i]);
        }
      }
      this.face.data = face.data;
      this.side.data = side.data;
      this.createCanvas(face);
      this.createCanvas(side);
    }
  }), Object(vuex_esm["b" /* mapActions */])(['get']), Object(vuex_esm["c" /* mapMutations */])(['updateReportData'])),
  data: function data() {
    return {
      bullets: [{
        text: 'front',
        className: 'pagination-bullet font-12'
      }, {
        text: 'side',
        className: 'pagination-bullet font-12'
      }],
      swiperOption: {
        pagination: {
          el: '.posture-swiper-pagination',
          clickable: true,
          renderBullet: function renderBullet(index, className) {
            return '<span class="' + className + ' ' + Home_bullets[index].className + '">' + Home_bullets[index].text + '</span>';
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      face: {
        data: [],
        scale: 0
      },
      side: {
        data: [],
        scale: 0
      },
      reportData: {},
      valid: true,
      showImg: false,
      NAMES: {
        head: 'head',
        shoulder: 'shoulder',
        trunk: 'trunk',
        pelvis: 'pelvis',
        "lower extremity": 'lower extremity'
      },
      level: {
        normal: 'normal',
        mild: 'mild',
        severe: 'severe'
      },
      loading: true,
      customer: {}
    };
  },

  computed: {
    avatar: function avatar() {
      return lodash_default.a.isNull(this.customer.avatar) ? imgSrc_default.a.DEFAULT_AVATAR : utils_default.a.base64ToSrc(this.customer.avatar);
    }
  },
  created: function created() {
    this.initReportData();
  },
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dc7cce2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
var Home_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c("div", [_c("loading", { attrs: { show: _vm.loading } })], 1)
      : _c("div", [
          !_vm.valid
            ? _c("div", {}, [
                _c(
                  "div",
                  {
                    staticClass: "font-20",
                    staticStyle: {
                      position: "fixed",
                      top: "50%",
                      left: "50%",
                      color: "#000",
                      transform: "translate(-50%, -50%)"
                    }
                  },
                  [_vm._v("数据无效")]
                )
              ])
            : _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "content-row content-row-center content-align-center person-info",
                    attrs: { id: "head" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "content-row content-row-center content-align-center auto-width avatar-container"
                      },
                      [
                        _c("img", {
                          staticClass: "avatar",
                          attrs: { src: _vm.avatar }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "content-row content-row-column auto-width font-14",
                        staticStyle: { color: "#fff" }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.customer.name ? _vm.customer.name : "--")
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("***CM  **KG")])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "risk-show-container" }, [
                  _c(
                    "div",
                    { staticClass: "swiper-box" },
                    [
                      _c(
                        "swiper",
                        {
                          ref: "postureSwiper",
                          attrs: { options: _vm.swiperOption }
                        },
                        [
                          _c(
                            "swiper-slide",
                            {
                              attrs: {
                                "data-riskData": JSON.stringify(_vm.face.data)
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    position: "relative",
                                    padding: "0 2rem"
                                  },
                                  attrs: { id: "face" }
                                },
                                _vm._l(_vm.face.data, function(risk) {
                                  return _c(
                                    "div",
                                    {
                                      key: risk.id,
                                      staticClass:
                                        "content-row content-align-center font-14 auto-width risk-tag",
                                      style: !risk.valid
                                        ? "display: none"
                                        : "display: " +
                                          (risk.level == "normal"
                                            ? "none"
                                            : "flex") +
                                          ";top: " +
                                          _vm.face.scale * risk.coord.top +
                                          "px; " +
                                          (risk.coord.left
                                            ? "left:" + risk.coord.left + "px"
                                            : "right:" +
                                              risk.coord.right +
                                              "px")
                                    },
                                    [
                                      _c("div", { staticClass: "risk-icon" }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(risk.name))])
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "swiper-slide",
                            {
                              attrs: {
                                "data-riskData": JSON.stringify(_vm.side.data)
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    position: "relative",
                                    padding: "0 2rem"
                                  },
                                  attrs: { id: "side" }
                                },
                                _vm._l(_vm.side.data, function(risk) {
                                  return _c(
                                    "div",
                                    {
                                      key: risk.id,
                                      staticClass:
                                        "content-row content-align-center font-14 auto-width risk-tag",
                                      style: !risk.valid
                                        ? "display: none"
                                        : "display: " +
                                          (risk.level == "normal"
                                            ? "none"
                                            : "flex") +
                                          ";top: " +
                                          _vm.side.scale * risk.coord.top +
                                          "px; left: " +
                                          risk.coord.left +
                                          "px"
                                    },
                                    [
                                      _c("div", { staticClass: "risk-icon" }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(risk.name))])
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "swiper-pagination posture-swiper-pagination",
                            attrs: { slot: "pagination" },
                            slot: "pagination"
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "swiper-button-prev",
                            attrs: { slot: "button-prev" },
                            slot: "button-prev"
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "swiper-button-next",
                            attrs: { slot: "button-next" },
                            slot: "button-next"
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "content-row content-align-center auto-width font-14 detail-btn",
                          staticStyle: { padding: "0 1rem" },
                          attrs: { id: "btn" },
                          on: {
                            click: function($event) {
                              _vm.go("riskDetail")
                            }
                          }
                        },
                        [
                          _c("span", [_vm._v("症状详情")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "right-arrow" })
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "fixed-bg" })
              ])
        ])
  ])
}
var Home_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "content-row content-row-center content-align-center data-info"
      },
      [
        _c("div", { staticClass: "badge" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "content-row content-row-column auto-width",
            staticStyle: { color: "#fff" }
          },
          [
            _c(
              "div",
              {
                staticClass: "font-16",
                staticStyle: { "line-height": ".8rem" }
              },
              [
                _vm._v("体态综合评分："),
                _c(
                  "span",
                  { staticClass: "font-20", staticStyle: { color: "#57d90e" } },
                  [_vm._v("--")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "font-12", staticStyle: { color: "#d5eef1" } },
              [
                _vm._v("未来5年发生体态风险的概率高于"),
                _c(
                  "span",
                  { staticClass: "font-16", staticStyle: { color: "#a01315" } },
                  [_vm._v("--%")]
                ),
                _vm._v("的人")
              ]
            )
          ]
        )
      ]
    )
  }
]
Home_render._withStripped = true
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Home = (Home_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dc7cce2", Home_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Home.vue
var Home_disposed = false
function Home_injectStyle (ssrContext) {
  if (Home_disposed) return
  __webpack_require__("i0z+")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  components_Home,
  selectortype_template_index_0_src_components_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)
Home_Component.options.__file = "src/components/Home.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8dc7cce2", Home_Component.options)
  } else {
    hotAPI.reload("data-v-8dc7cce2", Home_Component.options)
  }
  module.hot.dispose(function (data) {
    Home_disposed = true
  })
})()}

/* harmony default export */ var src_components_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HelloWorld.vue
//
//
//
//
//
//

/* harmony default export */ var HelloWorld = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HelloWorld.vue
//
//
//
//
//
//

/* harmony default export */ var components_HelloWorld = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-469af010","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
var HelloWorld_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hello" })
}
var HelloWorld_staticRenderFns = []
HelloWorld_render._withStripped = true
var HelloWorld_esExports = { render: HelloWorld_render, staticRenderFns: HelloWorld_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_HelloWorld = (HelloWorld_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-469af010", HelloWorld_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/HelloWorld.vue
var HelloWorld_disposed = false
function HelloWorld_injectStyle (ssrContext) {
  if (HelloWorld_disposed) return
  __webpack_require__("LXfq")
}
var HelloWorld_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HelloWorld___vue_template_functional__ = false
/* styles */
var HelloWorld___vue_styles__ = HelloWorld_injectStyle
/* scopeId */
var HelloWorld___vue_scopeId__ = "data-v-469af010"
/* moduleIdentifier (server only) */
var HelloWorld___vue_module_identifier__ = null
var HelloWorld_Component = HelloWorld_normalizeComponent(
  components_HelloWorld,
  selectortype_template_index_0_src_components_HelloWorld,
  HelloWorld___vue_template_functional__,
  HelloWorld___vue_styles__,
  HelloWorld___vue_scopeId__,
  HelloWorld___vue_module_identifier__
)
HelloWorld_Component.options.__file = "src/components/HelloWorld.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-469af010", HelloWorld_Component.options)
  } else {
    hotAPI.reload("data-v-469af010", HelloWorld_Component.options)
  }
  module.hot.dispose(function (data) {
    HelloWorld_disposed = true
  })
})()}

/* harmony default export */ var src_components_HelloWorld = (HelloWorld_Component.exports);

// EXTERNAL MODULE: ./src/assets/javascripts/canvas.js
var javascripts_canvas = __webpack_require__("sjPr");
var canvas_default = /*#__PURE__*/__webpack_require__.n(javascripts_canvas);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RiskDetail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var RiskDetail = ({
  methods: extends_default()({
    moreOrLess: function moreOrLess(event) {
      jquery_default()(event.target).toggleClass('up-arrow');
      jquery_default()(event.target).parent().find('.risk-des').toggleClass('line');
    }
  }, Object(vuex_esm["d" /* mapState */])({
    initData: function initData(state) {
      var _this = this;
      var riskData = state.vux.reportData.conclusion.risks;
      var sortedData = [];
      var normalArr = [];
      var mildArr = [];
      var severeArr = [];
      // 去除症状重复,等级取最高
      for (var i = 0; i < riskData.length; i++) {
        if (sortedData.indexOf(this.symptoms[riskData[i].position][riskData[i].code - 1]) !== -1) {
          var originLevel = this.symptoms[riskData[i].position][riskData[i].code - 1].level;
          var nowLevel = riskData[i].level;
          var originIndex = void 0;
          var nowIndex = void 0;
          for (var _i = 0; _i < this.level.length; _i++) {
            if (_this.level[_i] == originLevel) {
              originIndex = _i;
            }
            if (_this.level[_i] == nowIndex) {
              nowIndex = _i;
            }
          }

          if (nowIndex > originIndex) {
            this.symptoms[riskData[i].position][riskData[i].code - 1].level = nowLevel;
          } else {
            continue;
          }
        } else {
          var symptom = this.symptoms[riskData[i].position][riskData[i].code - 1];
          symptom.level = riskData[i].level;
          sortedData.push(symptom);
        }
      }

      // 按高风险到低风险排序
      for (var _i2 = 0; _i2 < sortedData.length; _i2++) {
        switch (sortedData[_i2].level) {
          case _this.level[3]:
            severeArr.push(sortedData[_i2]);
            break;
          case _this.level[2]:
            mildArr.push(sortedData[_i2]);
            break;
          default:
            normalArr.push(sortedData[_i2]);
            break;
        }
      }

      sortedData = severeArr.concat(mildArr, normalArr);
      this.sortedData = sortedData;
    }
  })),
  created: function created() {
    this.initData();
  },

  data: function data() {
    return {
      symptoms: {
        head: [{
          name: '头部侧倾',
          img: imgSrc_default.a.HEAD_SIDESWAY,
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '颈椎侧屈',
            muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长'
          }
        }, {
          name: '头部前倾',
          img: imgSrc_default.a.HEAD_LEAN,
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '椎弓变直或出现反弓',
            muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张'
          }
        }],
        shoulder: [{
          name: '高低肩',
          img: imgSrc_default.a.HIGH_LOW_SHOULDER,
          definition: '肩峰左右高度差超过2CM则为高低肩。',
          harm: {
            bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
            muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：'
          }
        }, {
          name: '圆肩',
          img: imgSrc_default.a.ROUND_SHOULDER,
          definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
          harm: {
            bone: '肩胛骨外展、胸廓变小',
            muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长'
          }
        }],
        trunk: [{
          name: '脊柱侧弯',
          img: imgSrc_default.a.SPINE_SIDESWAY,
          definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
          harm: {
            bone: '脊柱出现S型弯曲或C型弯曲',
            muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛'
          }
        }],
        pelvis: [{
          name: '骨盆侧倾',
          img: imgSrc_default.a.PELVIS_LEAN,
          definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
          harm: {
            bone: '骨盆倾斜',
            muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力'
          }
        }],
        "lower extremity": [{
          name: 'O型腿',
          img: imgSrc_default.a.LEG_O,
          definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
          harm: {
            bone: 'O型腿（膝内翻）',
            muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大'
          }
        }, {
          name: 'X型腿',
          img: imgSrc_default.a.LEG_X,
          definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
          harm: {
            bone: 'X型腿（膝外翻）',
            muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张'
          }
        }, {
          name: '膝过伸',
          img: imgSrc_default.a.KNEE_OVERSTRETCH,
          definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
          harm: {
            bone: '踝关节背屈不足，使膝关节无法向前移动',
            muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛'
          }
        }]
      },
      sortedData: [],
      levelDes: {
        normal: {
          text: '低风险',
          color: '#79d023'
        },
        mild: {
          text: '中风险',
          color: '#ff8739'
        },
        severe: {
          text: '高风险',
          color: '#cf2f30'
        }
      },
      level: [null, 'normal', 'mild', 'severe']
    };
  },
  watch: {
    sortedData: function sortedData() {
      jquery_default.a.each(jquery_default()('.risk-canvas'), function (index, element) {
        canvas_default.a.initRiskBar({
          element: element,
          level: jquery_default()(element).data('level')
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RiskDetail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var components_RiskDetail = ({
  methods: extends_default()({
    moreOrLess: function moreOrLess(event) {
      jquery_default()(event.target).toggleClass('up-arrow');
      jquery_default()(event.target).parent().find('.risk-des').toggleClass('line');
    }
  }, Object(vuex_esm["d" /* mapState */])({
    initData: function initData(state) {
      var _this = this;
      var riskData = state.vux.reportData.conclusion.risks;
      var sortedData = [];
      var normalArr = [];
      var mildArr = [];
      var severeArr = [];
      // 去除症状重复,等级取最高
      for (var i = 0; i < riskData.length; i++) {
        if (sortedData.indexOf(this.symptoms[riskData[i].position][riskData[i].code - 1]) !== -1) {
          var originLevel = this.symptoms[riskData[i].position][riskData[i].code - 1].level;
          var nowLevel = riskData[i].level;
          var originIndex = void 0;
          var nowIndex = void 0;
          for (var _i = 0; _i < this.level.length; _i++) {
            if (_this.level[_i] == originLevel) {
              originIndex = _i;
            }
            if (_this.level[_i] == nowIndex) {
              nowIndex = _i;
            }
          }

          if (nowIndex > originIndex) {
            this.symptoms[riskData[i].position][riskData[i].code - 1].level = nowLevel;
          } else {
            continue;
          }
        } else {
          var symptom = this.symptoms[riskData[i].position][riskData[i].code - 1];
          symptom.level = riskData[i].level;
          sortedData.push(symptom);
        }
      }

      // 按高风险到低风险排序
      for (var _i2 = 0; _i2 < sortedData.length; _i2++) {
        switch (sortedData[_i2].level) {
          case _this.level[3]:
            severeArr.push(sortedData[_i2]);
            break;
          case _this.level[2]:
            mildArr.push(sortedData[_i2]);
            break;
          default:
            normalArr.push(sortedData[_i2]);
            break;
        }
      }

      sortedData = severeArr.concat(mildArr, normalArr);
      this.sortedData = sortedData;
    }
  })),
  created: function created() {
    this.initData();
  },

  data: function data() {
    return {
      symptoms: {
        head: [{
          name: '头部侧倾',
          img: imgSrc_default.a.HEAD_SIDESWAY,
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '颈椎侧屈',
            muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长'
          }
        }, {
          name: '头部前倾',
          img: imgSrc_default.a.HEAD_LEAN,
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '椎弓变直或出现反弓',
            muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张'
          }
        }],
        shoulder: [{
          name: '高低肩',
          img: imgSrc_default.a.HIGH_LOW_SHOULDER,
          definition: '肩峰左右高度差超过2CM则为高低肩。',
          harm: {
            bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
            muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：'
          }
        }, {
          name: '圆肩',
          img: imgSrc_default.a.ROUND_SHOULDER,
          definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
          harm: {
            bone: '肩胛骨外展、胸廓变小',
            muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长'
          }
        }],
        trunk: [{
          name: '脊柱侧弯',
          img: imgSrc_default.a.SPINE_SIDESWAY,
          definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
          harm: {
            bone: '脊柱出现S型弯曲或C型弯曲',
            muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛'
          }
        }],
        pelvis: [{
          name: '骨盆侧倾',
          img: imgSrc_default.a.PELVIS_LEAN,
          definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
          harm: {
            bone: '骨盆倾斜',
            muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力'
          }
        }],
        "lower extremity": [{
          name: 'O型腿',
          img: imgSrc_default.a.LEG_O,
          definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
          harm: {
            bone: 'O型腿（膝内翻）',
            muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大'
          }
        }, {
          name: 'X型腿',
          img: imgSrc_default.a.LEG_X,
          definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
          harm: {
            bone: 'X型腿（膝外翻）',
            muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张'
          }
        }, {
          name: '膝过伸',
          img: imgSrc_default.a.KNEE_OVERSTRETCH,
          definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
          harm: {
            bone: '踝关节背屈不足，使膝关节无法向前移动',
            muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛'
          }
        }]
      },
      sortedData: [],
      levelDes: {
        normal: {
          text: '低风险',
          color: '#79d023'
        },
        mild: {
          text: '中风险',
          color: '#ff8739'
        },
        severe: {
          text: '高风险',
          color: '#cf2f30'
        }
      },
      level: [null, 'normal', 'mild', 'severe']
    };
  },
  watch: {
    sortedData: function sortedData() {
      jquery_default.a.each(jquery_default()('.risk-canvas'), function (index, element) {
        canvas_default.a.initRiskBar({
          element: element,
          level: jquery_default()(element).data('level')
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-071df230","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RiskDetail.vue
var RiskDetail_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        background: "#f4fafc",
        "border-top": "1px solid transparent",
        "border-bottom": "1px solid transparent"
      }
    },
    _vm._l(_vm.sortedData, function(symptom) {
      return _c("div", { staticClass: "risk-box" }, [
        _c("div", { staticClass: "content-row" }, [
          _c(
            "div",
            {
              staticClass:
                "content-row content-row-column content-align-center auto-width",
              staticStyle: { "margin-right": ".5rem", "flex-shrink": "0" }
            },
            [
              _c("img", {
                staticClass: "risk-img",
                staticStyle: { "margin-bottom": ".5rem" },
                attrs: { src: symptom.img }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "content-row content-row-center content-align-center"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "font-12",
                      style:
                        "margin-right: .2rem; color: " +
                        (!symptom.level
                          ? _vm.levelDes.normal.color
                          : _vm.levelDes[symptom.level].color) +
                        ";"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          !symptom.level
                            ? _vm.levelDes.normal.text
                            : _vm.levelDes[symptom.level].text
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "risk-bar-container",
                      staticStyle: { height: "1rem", width: "2.5rem" }
                    },
                    [
                      _c("canvas", {
                        staticClass: "risk-canvas",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "data-level": !symptom.level
                            ? "normal"
                            : symptom.level
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content-row content-row-column" }, [
            _c(
              "div",
              {
                staticClass: "content-row content-row-column",
                staticStyle: { "margin-bottom": ".5rem" }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "font-12",
                    staticStyle: { "margin-bottom": ".2rem", color: "#707070" }
                  },
                  [_vm._v("定义")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "font-12", staticStyle: { color: "#777777" } },
                  [_vm._v(_vm._s(symptom.definition))]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "content-row content-row-column" }, [
              _c(
                "span",
                {
                  staticClass: "font-12",
                  staticStyle: { "margin-bottom": ".2rem", color: "#891a16" }
                },
                [_vm._v("危害")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "limit-line-3 font-12 risk-des" }, [
                _c("span", { staticStyle: { color: "#db5a60" } }, [
                  _vm._v("骨骼：")
                ]),
                _c("span", { staticStyle: { color: "#777777" } }, [
                  _vm._v(_vm._s(symptom.harm.bone))
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", { staticStyle: { color: "#db5a60" } }, [
                  _vm._v("肌肉：")
                ]),
                _c("span", { staticStyle: { color: "#777777" } }, [
                  _vm._v(_vm._s(symptom.harm.muscle))
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "arrow down-arrow",
          on: { click: _vm.moreOrLess }
        })
      ])
    }),
    0
  )
}
var RiskDetail_staticRenderFns = []
RiskDetail_render._withStripped = true
var RiskDetail_esExports = { render: RiskDetail_render, staticRenderFns: RiskDetail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_RiskDetail = (RiskDetail_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-071df230", RiskDetail_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/RiskDetail.vue
var RiskDetail_disposed = false
function RiskDetail_injectStyle (ssrContext) {
  if (RiskDetail_disposed) return
  __webpack_require__("c8Po")
}
var RiskDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RiskDetail___vue_template_functional__ = false
/* styles */
var RiskDetail___vue_styles__ = RiskDetail_injectStyle
/* scopeId */
var RiskDetail___vue_scopeId__ = "data-v-071df230"
/* moduleIdentifier (server only) */
var RiskDetail___vue_module_identifier__ = null
var RiskDetail_Component = RiskDetail_normalizeComponent(
  components_RiskDetail,
  selectortype_template_index_0_src_components_RiskDetail,
  RiskDetail___vue_template_functional__,
  RiskDetail___vue_styles__,
  RiskDetail___vue_scopeId__,
  RiskDetail___vue_module_identifier__
)
RiskDetail_Component.options.__file = "src/components/RiskDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-071df230", RiskDetail_Component.options)
  } else {
    hotAPI.reload("data-v-071df230", RiskDetail_Component.options)
  }
  module.hot.dispose(function (data) {
    RiskDetail_disposed = true
  })
})()}

/* harmony default export */ var src_components_RiskDetail = (RiskDetail_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var core_js_object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(core_js_object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/card/card.js + 4 modules
var card = __webpack_require__("/sUu");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/tabs/tabs.js
var tabs = __webpack_require__("HURm");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/tabs/tab.js
var tab = __webpack_require__("VCNE");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/assets/javascripts/bone.js
var bone = __webpack_require__("4OYe");
var bone_default = /*#__PURE__*/__webpack_require__.n(bone);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/modal/modal.js
var modal = __webpack_require__("ESch");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/directives/modal/modal.js + 1 modules
var modal_modal = __webpack_require__("PxEr");

// CONCATENATED MODULE: ./src/assets/lang.conf/en.js

var en = {
    postureHome: {
        indexPage: {
            a_posture_title: "Posture Report",
            show: "1"
        },
        coverInfo: {
            customerName: "Test Subject",
            date: "Test Date",
            time: "Test time",
            userName: "Test analyst",
            clickEnterReport: "click enter report"
        }
    },
    postureIpad: {
        bullet: {
            Home: "Home",
            Posturedata: 'Posture data',
            Score: 'Risk Assessment',
            Muscle: 'Muscular Assessment',
            Solution: 'Solution'
        },
        front: 'front',
        side: 'side',
        viwesNav: 'Side | Front',
        InvalidData: 'Invalid Report',
        qrcode: 'Send us Email unlock your excerise',
        expertsWalk: 'Senno Posture',
        smallProgram: 'support@sennotech.com',
        clickRightTop: 'Click the button on top right corner',
        clickTranspond: 'click to share the mini program',
        symptoms: {
            head: [{
                name: 'Head Tilt',
                key: 'headSidesway',
                normal: {
                    left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
                    normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
                },
                definition: '在直立过程中，头部向左或右倾斜的现象。',
                harm: {
                    bone: '颈椎侧屈',
                    muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
                    neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
                    des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
                },
                risks: [{
                    name: 'Chronic Muscle and Ligament Strain',
                    des: 'Prolonged cephalic tilt or torticollis may lead to chronic strain of the posterior cervical ligament and surrounding muscles. '
                }, {
                    name: 'Cervical Spondylosis',
                    des: 'The neck is a chain of 7 bones connected by ligaments and wrapped in muscles which supports a 15lb weight – your head! Neck pain is a painful problem often attributed to constantly working against gravity to balance your head on your torso.Abnormal position of soft tissue and bones from an ectopic head increases the risk of painful degeneration of the intervertebral discs'
                }]
            }, {
                name: 'Head Forward',
                key: 'headLean',
                normal: {
                    normal: imgSrc_default.a.risk_normal.HEAD_LEAN
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
                },
                definition: '头部过度向前伸的现象。',
                harm: {
                    bone: '椎弓变直或出现反弓',
                    muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
                    neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
                    des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
                },
                risks: [{
                    name: 'Dizziness and Headaches',
                    des: 'Brain hypoxia caused by poor circulation arising from posture with the head forward may lead to dizziness and headaches.'
                }, {
                    name: 'Cervical Spondylosis',
                    des: 'The neck is a chain of 7 bones connected by ligaments and wrapped in muscles which supports a 15lb weight – your head! Neck pain is a painful problem often attributed to constantly working against gravity to balance your head on your torso.Abnormal position of soft tissue and bones from an ectopic head increases the risk of painful degeneration of the intervertebral discs'
                }]
            }],
            shoulder: [{
                name: 'Uneven Shoulders',
                key: 'highLowShoulder',
                normal: {
                    left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
                    right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
                    normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
                    right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
                },
                definition: '肩峰左右高度差超过2CM则为高低肩。',
                harm: {
                    bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
                    muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
                    neurovascular: '',
                    des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
                },
                risks: [{
                    name: 'Chronic Headaches',
                    des: 'Uneven shoulders may eventually lead to chronic headaches.'
                }, {
                    name: 'Bone Spurs',
                    des: 'Shoulders that are not level generate abnormal force on the neck, making a person prone to degeneration of the cervical spine and in some cases bone spurs. '
                }, {
                    name: 'Lumbago',
                    des: 'Slanted shoulders may cause lateral pelvis tilt, waist muscle imbalance, and lumbago.'
                }, {
                    name: 'Leg Length Discrepancy',
                    des: 'Pelvic side-tilt also increases the risk of an apparent inequality in the length of legs.'
                }]
            }, {
                name: 'Rounded Shoulders',
                key: 'roundShoulder',
                normal: {
                    normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
                },
                definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
                harm: {
                    bone: '肩胛骨外展、胸廓变小',
                    muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
                    neurovascular: '',
                    des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
                },
                risks: [{
                    name: 'Cardiovascular Disease',
                    des: ' Rounded shoulders make the diaphragm tense up, increasing the risk of cardiovascular disease.'
                }, {
                    name: 'Headaches',
                    des: 'Neck and shoulder tension that rounds the shoulders can even cause cervical nerve compression and headaches.'
                }, {
                    name: 'Numb Arms',
                    des: 'Cervical nerve compression can also bring on numbness or paresthesia of the arms.'
                }]
            }],
            trunk: [{
                name: 'Scoliosis',
                key: 'spineSidesway',
                normal: {
                    left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
                    normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
                },
                definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
                harm: {
                    bone: '脊柱出现S型弯曲或C型弯曲',
                    muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
                    neurovascular: '',
                    des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
                },
                risks: [{
                    name: 'Scoliosis',
                    des: 'Further 3-D inspection is indicated to diagnose scoliosis.'
                }, {
                    name: 'Uneven Shoulders',
                    des: 'Scoliosis may be accompanied by uneven shoulders.'
                }, {
                    name: 'Uneven Hips',
                    des: 'Scoliosis may be accompanied by uneven hips.'
                }]
            }],
            pelvis: [{
                name: 'Uneven Hips',
                key: 'pelvisLean',
                normal: {
                    left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
                    right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
                    normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
                    right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
                },
                definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
                harm: {
                    bone: '骨盆倾斜',
                    muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
                    neurovascular: '',
                    des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
                },
                risks: [{
                    name: 'Chronic Pain',
                    des: 'Uneven hips may cause extremity pain.'
                }, {
                    name: 'Lumbar Disc Herniation',
                    des: 'Uneven hips may increase the risk of lumbar disc herniation.'
                }, {
                    name: 'Leg Length Discrepency',
                    des: 'Uneven hips may increase the risk of leg length discrepancy.'
                }]
            }],
            'lower extremity': [{
                name: 'Bow Legs (O-shaped Curvature)',
                key: 'legO',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_O
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_O
                },
                definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
                harm: {
                    bone: 'O型腿（膝内翻）',
                    muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
                    neurovascular: '',
                    des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
                },
                risks: [{
                    name: 'Meniscus Injury',
                    des: 'The force on the lower limb of bow-legged individuals is altered so that '
                }, {
                    name: 'Arthritis',
                    des: 'Severe bow legs may eventually progress to osteoarthritis on the lateral interstitial space of the joint.'
                }]
            }, {
                name: 'Genu Valgum (Knock Knees)',
                key: 'legX',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_X
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_X
                },
                definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
                harm: {
                    bone: 'X型腿（膝外翻）',
                    muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
                    neurovascular: '',
                    des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
                },
                risks: [{
                    name: 'Meniscus Injury',
                    des: 'Because knock knees alter the direction of force on the lower limb, the knee is subject to increased lateral pressure. Lateral meniscus strain and injury often result.'
                }, {
                    name: 'Arthritis',
                    des: 'Severe genu valgum may eventually progress to osteoarthritis.'
                }]
            }, {
                name: 'Back Knee',
                key: 'kneeOverstretch',
                normal: {
                    normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
                },
                definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
                harm: {
                    bone: '踝关节背屈不足，使膝关节无法向前移动',
                    muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
                    neurovascular: '',
                    des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
                },
                risks: [{
                    name: 'Knee Joint Degeneration',
                    des: 'Excessive wear and degeneration of the knee is the result of persistent back knee.'
                }, {
                    name: 'Body balance influence',
                    des: 'Deformed knees lead to position changes of the hips, pelvis, and ankles, and can gradually modify the balance of the whole body.'
                }]
            }, {
                name: 'False Bow Legs',
                key: 'legXO',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_XO
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_XO
                },
                definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
                harm: {
                    bone: '这个是XO型腿',
                    muscle: '这个是XO型腿',
                    neurovascular: '',
                    des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
                },
                risks: [{
                    name: 'Knee pain',
                    des: 'When the pelvic tilts forward, it creates a “grid” misalignment at the knee joint as well. Your femur now doesn’t track properly over your tibia (shin bone), creating an imbalance.When imbalance is paired with internally rotated femurs (due to a lack of strong glutes because of APT), you end up with a perfect recipe for false curvature knees.\n' + 'you may hear your knee popping and cracking quite often while moving around throughout your day. '
                }, {
                    name: 'Arthritis',
                    des: 'As time progresses, you may start feeling pain since the stabilizing structures (ie. cartilage and ligaments) in the knee get wore down at a much faster rate compared to a neutral knee.'
                }]
            }]
        }
    },
    postureModalIpad: {
        detection: "Detected",
        item: "items",
        noHeightRisk: "You have very healthy posture, Keep going!",
        otherDetecation: "other items",
        potentialRisk: "Mid risk",
        heightRisk: "High risk",
        suggest: "Your posture needs to improve, a few minutes a day of posture excerise will be very helpful ",
        suggestSolve: "You really need to improve your posture, please find chiropractors or Physio therpist make more evaluation",
        normal: "Normal",
        risk: "Risk",
        return: "return",
        levelName: "High | Mid | Low"
    },
    postureModal: {
        goback: "Back",
        normal: "Normal",
        highRisk: "High Risk",
        potentialRisk: "Mid Risk",
        levelName: "High | Mid | Low",
        symptominterpretation: "Tips",
        triggersymptoms: "Impacts"
    },
    postureReport: {
        redAlert: "Red zone stands for muscle tension",
        yellowAlert: "Yellow zone stands for muscle weakness",
        muscleDire: {
            normal: "Normal",
            face: "Front",
            side: "Side",
            back: "Back"
        },
        details: {
            lh: "lh",
            ll: "ll",
            rh: "rh",
            rr: "rr"
        },
        descripName: {
            upName: "needs to be strengthened",
            lowName: "needs to be stretched "
        },
        navList: "Front | Side | Back",
        boneDescription: {
            face: {
                trunk: "Abdominal muscles",
                legForX: ["Hip abductor muscles", "Hip adductor muscles"],
                legForO: "Hip abductor muscles",
                legForStretch: "Quadriceps femoris",
                round: "Qectoralis major"
            },
            side: {
                round: "Sternocleidomastoid muscle",
                fore: "Sternocleidomastoid muscle",
                shoulder: "Scalene mucscle"
            },
            back: {
                spine: "Upper traps",
                shoulder: "Upper traps",
                round: ["Upper traps", "Lower traps"],
                fore: ["Upper traps", "Lower traps"],
                rake: "Levator scapulae",
                legStretch: ["Hamstring muscles", "Plantar fascia"],
                legX: ['Hip abductor muscles', 'Biceps Femoris'],
                legO: ['Hamstrings', 'Tibialis Anterior， Tibialis Posterior'],
                legXO: ['Biceps Femoris', 'Plantar fascia']
            }
        }
    },
    postureSymp: {
        detection: 'Detected',
        item: 'items',
        noHeightRisk: 'You have very healthy posture, Keep going!',
        otherDetecation: 'other items',
        potentialRisk: 'Mid risk',
        heightRisk: 'High risk',
        suggest: 'Your posture needs to improve, a few minutes a day of posture excerise will be very helpful ',
        suggestSolve: 'You really need to improve your posture, please find chiropractors or Physio therpist make more evaluation',
        normal: 'Normal',
        risk: 'Risk'
    },
    postureSympIpad: {
        detection: "Detected",
        item: "items",
        noHeightRisk: "You have very healthy posture, Keep going!",
        otherDetecation: "other items",
        potentialRisk: "Mid risk",
        heightRisk: "High risk",
        suggest: "Your posture needs to improve, a few minutes a day of posture excerise will be very helpful ",
        suggestSolve: "You really need to improve your posture, please find chiropractors or Physio therpist make more evaluation",
        normal: "Normal",
        risk: "Risk"
    },
    posture: {
        bullet: {
            Home: "Home",
            Posturedata: 'Posture data',
            Score: 'Risk Assessment',
            Muscle: 'Muscular Assessment',
            Solution: 'Solution'
        },

        viwesNav: 'Side | Front',
        InvalidData: 'Invalid Report',
        qrcode: 'Send us Email unlock your excerise',
        expertsWalk: 'Senno Posture',
        smallProgram: 'support@sennotech.com',
        clickRightTop: 'Click the button on top right corner',
        clickTranspond: 'click to share the mini program',
        symptoms: {
            head: [{
                name: 'Head Tilt',
                key: 'headSidesway',
                normal: {
                    left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
                    normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
                },
                definition: '在直立过程中，头部向左或右倾斜的现象。',
                harm: {
                    bone: '颈椎侧屈',
                    muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
                    neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
                    des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
                },
                risks: [{
                    name: 'Chronic Muscle and Ligament Strain',
                    des: 'Prolonged cephalic tilt or torticollis may lead to chronic strain of the posterior cervical ligament and surrounding muscles. '
                }, {
                    name: 'Cervical Spondylosis',
                    des: 'The neck is a chain of 7 bones connected by ligaments and wrapped in muscles which supports a 15lb weight – your head! Neck pain is a painful problem often attributed to constantly working against gravity to balance your head on your torso.Abnormal position of soft tissue and bones from an ectopic head increases the risk of painful degeneration of the intervertebral discs'
                }]
            }, {
                name: 'Head Forward',
                key: 'headLean',
                normal: {
                    normal: imgSrc_default.a.risk_normal.HEAD_LEAN
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
                },
                definition: '头部过度向前伸的现象。',
                harm: {
                    bone: '椎弓变直或出现反弓',
                    muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
                    neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
                    des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
                },
                risks: [{
                    name: 'Dizziness and Headaches',
                    des: 'Brain hypoxia caused by poor circulation arising from posture with the head forward may lead to dizziness and headaches.'
                }, {
                    name: 'Cervical Spondylosis',
                    des: 'The neck is a chain of 7 bones connected by ligaments and wrapped in muscles which supports a 15lb weight – your head! Neck pain is a painful problem often attributed to constantly working against gravity to balance your head on your torso.Abnormal position of soft tissue and bones from an ectopic head increases the risk of painful degeneration of the intervertebral discs'
                }]
            }],
            shoulder: [{
                name: 'Uneven Shoulders',
                key: 'highLowShoulder',
                normal: {
                    left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
                    right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
                    normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
                    right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
                },
                definition: '肩峰左右高度差超过2CM则为高低肩。',
                harm: {
                    bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
                    muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
                    neurovascular: '',
                    des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
                },
                risks: [{
                    name: 'Chronic Headaches',
                    des: 'Uneven shoulders may eventually lead to chronic headaches.'
                }, {
                    name: 'Bone Spurs',
                    des: 'Shoulders that are not level generate abnormal force on the neck, making a person prone to degeneration of the cervical spine and in some cases bone spurs. '
                }, {
                    name: 'Lumbago',
                    des: 'Slanted shoulders may cause lateral pelvis tilt, waist muscle imbalance, and lumbago.'
                }, {
                    name: 'Leg Length Discrepancy',
                    des: 'Pelvic side-tilt also increases the risk of an apparent inequality in the length of legs.'
                }]
            }, {
                name: 'Rounded Shoulders',
                key: 'roundShoulder',
                normal: {
                    normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
                },
                definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
                harm: {
                    bone: '肩胛骨外展、胸廓变小',
                    muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
                    neurovascular: '',
                    des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
                },
                risks: [{
                    name: 'Cardiovascular Disease',
                    des: ' Rounded shoulders make the diaphragm tense up, increasing the risk of cardiovascular disease.'
                }, {
                    name: 'Headaches',
                    des: 'Neck and shoulder tension that rounds the shoulders can even cause cervical nerve compression and headaches.'
                }, {
                    name: 'Numb Arms',
                    des: 'Cervical nerve compression can also bring on numbness or paresthesia of the arms.'
                }]
            }],
            trunk: [{
                name: 'Scoliosis',
                key: 'spineSidesway',
                normal: {
                    left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
                    normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
                },
                definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
                harm: {
                    bone: '脊柱出现S型弯曲或C型弯曲',
                    muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
                    neurovascular: '',
                    des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
                },
                risks: [{
                    name: 'Scoliosis',
                    des: 'Further 3-D inspection is indicated to diagnose scoliosis.'
                }, {
                    name: 'Uneven Shoulders',
                    des: 'Scoliosis may be accompanied by uneven shoulders.'
                }, {
                    name: 'Uneven Hips',
                    des: 'Scoliosis may be accompanied by uneven hips.'
                }]
            }],
            pelvis: [{
                name: 'Uneven Hips',
                key: 'pelvisLean',
                normal: {
                    left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
                    right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
                    normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
                    right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
                },
                definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
                harm: {
                    bone: '骨盆倾斜',
                    muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
                    neurovascular: '',
                    des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
                },
                risks: [{
                    name: 'Chronic Pain',
                    des: 'Uneven hips may cause extremity pain.'
                }, {
                    name: 'Lumbar Disc Herniation',
                    des: 'Uneven hips may increase the risk of lumbar disc herniation.'
                }, {
                    name: 'Leg Length Discrepency',
                    des: 'Uneven hips may increase the risk of leg length discrepancy.'
                }]
            }],
            'lower extremity': [{
                name: 'Bow Legs (O-shaped Curvature)',
                key: 'legO',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_O
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_O
                },
                definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
                harm: {
                    bone: 'O型腿（膝内翻）',
                    muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
                    neurovascular: '',
                    des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
                },
                risks: [{
                    name: 'Meniscus Injury',
                    des: 'The force on the lower limb of bow-legged individuals is altered so that '
                }, {
                    name: 'Arthritis',
                    des: 'Severe bow legs may eventually progress to osteoarthritis on the lateral interstitial space of the joint.'
                }]
            }, {
                name: 'Genu Valgum (Knock Knees)',
                key: 'legX',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_X
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_X
                },
                definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
                harm: {
                    bone: 'X型腿（膝外翻）',
                    muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
                    neurovascular: '',
                    des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
                },
                risks: [{
                    name: 'Meniscus Injury',
                    des: 'Because knock knees alter the direction of force on the lower limb, the knee is subject to increased lateral pressure. Lateral meniscus strain and injury often result.'
                }, {
                    name: 'Arthritis',
                    des: 'Severe genu valgum may eventually progress to osteoarthritis.'
                }]
            }, {
                name: 'genu recurvatum',
                key: 'kneeOverstretch',
                normal: {
                    normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
                },
                definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
                harm: {
                    bone: '踝关节背屈不足，使膝关节无法向前移动',
                    muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
                    neurovascular: '',
                    des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
                },
                risks: [{
                    name: 'Knee Joint Degeneration',
                    des: 'Excessive wear and degeneration of the knee is the result of persistent back knee.'
                }, {
                    name: 'Body balance influence',
                    des: 'Deformed knees lead to position changes of the hips, pelvis, and ankles, and can gradually modify the balance of the whole body.'
                }]
            }, {
                name: 'False Bow Legs',
                key: 'legXO',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_XO
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_XO
                },
                definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
                harm: {
                    bone: '这个是XO型腿',
                    muscle: '这个是XO型腿',
                    neurovascular: '',
                    des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
                },
                risks: [{
                    name: 'Knee pain',
                    des: 'When the pelvic tilts forward, it creates a “grid” misalignment at the knee joint as well. Your femur now doesn’t track properly over your tibia (shin bone), creating an imbalance.When imbalance is paired with internally rotated femurs (due to a lack of strong glutes because of APT), you end up with a perfect recipe for false curvature knees.\n' + 'you may hear your knee popping and cracking quite often while moving around throughout your day. '
                }, {
                    name: 'Arthritis',
                    des: 'As time progresses, you may start feeling pain since the stabilizing structures (ie. cartilage and ligaments) in the knee get wore down at a much faster rate compared to a neutral knee.'
                }]
            }]
        }
    },
    sympItem: {
        levelName: "height | middle | lower"
    },
    sympItemIpad: {
        detection: "Detected",
        item: "items",
        noHeightRisk: "You have very healthy posture, Keep going!",
        otherDetecation: "other items",
        potentialRisk: "Mid risk",
        heightRisk: "High risk",
        suggest: "Your posture needs to improve, a few minutes a day of posture excerise will be very helpful ",
        suggestSolve: "You really need to improve your posture, please find chiropractors or Physio therpist make more evaluation",
        normal: "Normal",
        risk: "Risk",
        levelName: "High | Mid | Low"
    }

};

// CONCATENATED MODULE: ./src/assets/lang.conf/zh.js

var zh = {
    postureHome: {
        indexPage: {
            a_posture_title: "体态分析报告",
            show: "1"
        },
        coverInfo: {
            customerName: "测试对象",
            date: "报告日期",
            time: "检测时间",
            userName: "检测分析师",
            clickEnterReport: "点击进入报告"
        }
    },
    postureIpad: {
        bullet: {
            Home: '首页',
            Posturedata: '体态数据',
            Score: '风险评估',
            Muscle: '肌肉状态',
            Solution: '报告结论'
        },
        front: '正视图',
        side: '侧视图',
        viwesNav: '侧面 | 正面',
        InvalidData: '数据无效',
        qrcode: '长按保存图片，打开微信客户端扫描二维码',
        expertsWalk: '步姿专家',
        smallProgram: '小程序',
        clickRightTop: '点击右上角',
        clickTranspond: '点击[转发]分享小程序',
        symptoms: {
            head: [{
                name: '头部侧倾',
                key: 'headSidesway',
                normal: {
                    left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
                    normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
                },
                definition: '在直立过程中，头部向左或右倾斜的现象。',
                harm: {
                    bone: '颈椎侧屈',
                    muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
                    neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
                    des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
                },
                risks: [{
                    name: '肌肉韧带慢性劳损',
                    des: '长期头侧倾容易导致颈后韧带、颈周围肌肉的慢性劳损。'
                }, {
                    name: '颈椎病',
                    des: '由于头部异位导致颈部软组织、骨骼的异常，增大了颈椎病患病风险。'
                }]
            }, {
                name: '头部前倾',
                key: 'headLean',
                normal: {
                    normal: imgSrc_default.a.risk_normal.HEAD_LEAN
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
                },
                definition: '头部过度向前伸的现象。',
                harm: {
                    bone: '椎弓变直或出现反弓',
                    muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
                    neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
                    des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
                },
                risks: [{
                    name: '头晕头痛',
                    des: '头部前倾可能影响头部血液循环，由于血流不畅而导致头部缺氧，引发头晕头痛。'
                }, {
                    name: '颈椎病',
                    des: '长期的重度头部前倾可能会导致颈椎病。'
                }]
            }],
            shoulder: [{
                name: '高低肩',
                key: 'highLowShoulder',
                normal: {
                    left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
                    right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
                    normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
                    right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
                },
                definition: '肩峰左右高度差超过2CM则为高低肩。',
                harm: {
                    bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
                    muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
                    neurovascular: '',
                    des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
                },
                risks: [{
                    name: '慢性头痛',
                    des: '长期的高低肩容易产生颈肩部位、头部的慢性疼痛。'
                }, {
                    name: '骨刺',
                    des: '高低肩使颈椎受力异常，最后可能导致颈椎部位退化，易形成骨刺。'
                }, {
                    name: '腰痛',
                    des: '高低肩可能造成骨盆的移位，使腰部肌力不平衡，导致腰痛。'
                }, {
                    name: '长短腿',
                    des: '由于高低肩造成的骨盆移位可能会使腿长发生变化。'
                }]
            }, {
                name: '圆肩',
                key: 'roundShoulder',
                normal: {
                    normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
                },
                definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
                harm: {
                    bone: '肩胛骨外展、胸廓变小',
                    muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
                    neurovascular: '',
                    des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
                },
                risks: [{
                    name: '心脏负担加重',
                    des: '过度圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉被压迫，使心脏工作负担加重。'
                }, {
                    name: '头痛',
                    des: '肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起头痛。'
                }, {
                    name: '手臂麻木',
                    des: '肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起手臂麻木。'
                }]
            }],
            trunk: [{
                name: '脊柱异位',
                key: 'spineSidesway',
                normal: {
                    left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
                    normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
                },
                definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
                harm: {
                    bone: '脊柱出现S型弯曲或C型弯曲',
                    muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
                    neurovascular: '',
                    des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
                },
                risks: [{
                    name: '脊柱侧弯',
                    des: '平面拍摄检测出脊柱异位提示您需进一步通过三维检测，确定是否存在脊柱侧弯的症状。'
                }, {
                    name: '高低肩',
                    des: '脊柱侧弯可能伴随高低肩症状。'
                }, {
                    name: '骨盆侧倾',
                    des: '脊柱侧弯可能伴随骨盆侧倾症状。'
                }]
            }],
            pelvis: [{
                name: '骨盆侧倾',
                key: 'pelvisLean',
                normal: {
                    left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
                    right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
                    normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
                    right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
                },
                definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
                harm: {
                    bone: '骨盆倾斜',
                    muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
                    neurovascular: '',
                    des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
                },
                risks: [{
                    name: '慢性疼痛',
                    des: '骨盆侧倾可能会引发腰腿疼痛、肩颈疼痛。'
                }, {
                    name: '腰椎间盘突出',
                    des: '骨盆侧倾可能加重腰椎间盘突出风险。'
                }, {
                    name: '长短腿',
                    des: '骨盆侧倾可能加重长短腿风险。。'
                }]
            }],
            'lower extremity': [{
                name: 'O型腿',
                key: 'legO',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_O
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_O
                },
                definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
                harm: {
                    bone: 'O型腿（膝内翻）',
                    muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
                    neurovascular: '',
                    des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
                },
                risks: [{
                    name: '半月板损伤',
                    des: 'O型腿造成下肢力线发生改变，膝关节内侧间隙承受大于正常负荷的压力。可能引起膝关节内侧半月板损伤。'
                }, {
                    name: '关节炎',
                    des: '严重O型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n' + '置换手术。'
                }]
            }, {
                name: 'X型腿',
                key: 'legX',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_X
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_X
                },
                definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
                harm: {
                    bone: 'X型腿（膝外翻）',
                    muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
                    neurovascular: '',
                    des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
                },
                risks: [{
                    name: '半月板损伤',
                    des: 'X型腿造成下肢力线发生改变，膝关节外侧间隙承受大于正常负荷的压力。可能引起膝关节外侧半月板损伤。'
                }, {
                    name: '关节炎',
                    des: '严重X型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n' + '置换手术。'
                }]
            }, {
                name: '膝过伸',
                key: 'kneeOverstretch',
                normal: {
                    normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
                },
                definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
                harm: {
                    bone: '踝关节背屈不足，使膝关节无法向前移动',
                    muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
                    neurovascular: '',
                    des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
                },
                risks: [{
                    name: '膝关节退变',
                    des: '长期膝关节过伸，会引起膝关节的过度磨损，加大膝关节退变的发生率。'
                }, {
                    name: '损害全身平衡',
                    des: '膝关节位置的改变会引起髋关节、骨盆、踝关节的位置异常，由此逐渐损害全身的平衡状态，长期累积会引发各种体态异常。'
                }]
            }, {
                name: 'XO型腿',
                key: 'legXO',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_XO
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_XO
                },
                definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
                harm: {
                    bone: '这个是XO型腿',
                    muscle: '这个是XO型腿',
                    neurovascular: '',
                    des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
                },
                risks: [{
                    name: '膝关节疼痛',
                    des: '由于XO型腿造成股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛。'
                }, {
                    name: '膝关节炎',
                    des: '重度XO型腿最终可能发展为膝关节骨性关节炎。'
                }]
            }]
        }
    },
    postureModalIpad: {
        detection: "检测到",
        item: "项",
        noHeightRisk: "恭喜您未检测到高风险，请继续保持良好的体态",
        otherDetecation: "其他检测项",
        potentialRisk: "潜在风险",
        heightRisk: "高风险",
        suggest: "平时需要关注自己的体态,并且加强锻炼",
        suggestSolve: "出现了较明显的异常体态,需要及时寻求解决方案或是获取更多专业咨询",
        normal: "正常",
        risk: "风险",
        return: "返回",
        levelName: "高 | 中 | 低"
    },
    postureModal: {
        goback: '返回',
        potentialRisk: '潜在风险',
        levelName: '高 | 中 | 低',
        symptominterpretation: '症状解读',
        triggersymptoms: '引发症状',
        normal: '正常',
        highRisk: '高风险'
    },
    postureReport: {
        redAlert: "红色代表此部分肌肉紧张",
        yellowAlert: "黄色代表此部分肌肉薄弱",
        muscleDire: {
            normal: "正常",
            face: "正面肌肉",
            side: "侧面肌肉",
            back: "背面肌肉"
        },
        details: {
            lh: "lh",
            ll: "ll",
            rh: "rh",
            rr: "rr"
        },
        descripName: {
            upName: "需加强",
            lowName: "需放松"
        },
        navList: "正面 | 侧面 | 背面",
        boneDescription: {
            face: {
                trunk: "腹部肌群",
                legForX: ["髋外旋肌", "髋内收肌"],
                legForO: "髋外旋肌",
                legForStretch: "股四头肌",
                round: "胸大肌"
            },
            side: {
                round: "胸锁乳突肌",
                fore: "胸锁乳突肌",
                shoulder: "斜角肌"
            },
            back: {
                spine: "高侧斜方肌",
                shoulder: "高侧斜方肌",
                round: ["高侧斜方肌", "低侧斜方肌"],
                fore: ["高侧斜方肌", "低侧斜方肌"],
                rake: "肩胛提肌",
                legStretch: ["腘绳肌", "足底筋膜"],
                legX: ["髋外旋肌", "股二头肌"],
                legO: ["半腱肌半膜肌", "胫骨前肌、胫骨后肌"],
                legXO: ["股二头肌", "足底筋膜"]
            }
        }
    },
    postureSymp: {
        detection: '检测到',
        item: '项',
        noHeightRisk: '恭喜您未检测到高风险，请继续保持良好的体态',
        otherDetecation: '其他检测项',
        potentialRisk: '潜在风险',
        heightRisk: '高风险',
        suggest: '平时需要关注自己的体态,并且加强锻炼',
        suggestSolve: '出现了较明显的异常体态,需要及时寻求解决方案或是获取更多专业咨询',
        normal: '正常',
        risk: '风险'
    },
    postureSympIpad: {
        detection: "检测到",
        item: "项",
        noHeightRisk: "恭喜您未检测到高风险，请继续保持良好的体态",
        otherDetecation: "其他检测项",
        potentialRisk: "潜在风险",
        heightRisk: "高风险",
        suggest: "平时需要关注自己的体态,并且加强锻炼",
        suggestSolve: "出现了较明显的异常体态,需要及时寻求解决方案或是获取更多专业咨询",
        normal: "正常",
        risk: "风险"
    },
    posture: {
        bullet: {
            Home: '首页',
            Posturedata: '体态数据',
            Score: '风险评估',
            Muscle: '肌肉状态',
            Solution: '报告结论'
        },
        viwesNav: '侧面 | 正面',
        InvalidData: '数据无效',
        qrcode: '长按保存图片，打开微信客户端扫描二维码',
        expertsWalk: '步姿专家',
        smallProgram: '小程序',
        clickRightTop: '点击右上角',
        clickTranspond: '点击[转发]分享小程序',
        symptoms: {
            head: [{
                name: '头部侧倾',
                key: 'headSidesway',
                normal: {
                    left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
                    normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
                },
                definition: '在直立过程中，头部向左或右倾斜的现象。',
                harm: {
                    bone: '颈椎侧屈',
                    muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
                    neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
                    des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
                },
                risks: [{
                    name: '肌肉韧带慢性劳损',
                    des: '长期头侧倾容易导致颈后韧带、颈周围肌肉的慢性劳损。'
                }, {
                    name: '颈椎病',
                    des: '由于头部异位导致颈部软组织、骨骼的异常，增大了颈椎病患病风险。'
                }]
            }, {
                name: '头部前倾',
                key: 'headLean',
                normal: {
                    normal: imgSrc_default.a.risk_normal.HEAD_LEAN
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
                },
                definition: '头部过度向前伸的现象。',
                harm: {
                    bone: '椎弓变直或出现反弓',
                    muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
                    neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
                    des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
                },
                risks: [{
                    name: '头晕头痛',
                    des: '头部前倾可能影响头部血液循环，由于血流不畅而导致头部缺氧，引发头晕头痛。'
                }, {
                    name: '颈椎病',
                    des: '长期的重度头部前倾可能会导致颈椎病。'
                }]
            }],
            shoulder: [{
                name: '高低肩',
                key: 'highLowShoulder',
                normal: {
                    left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
                    right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
                    normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
                    right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
                },
                definition: '肩峰左右高度差超过2CM则为高低肩。',
                harm: {
                    bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
                    muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
                    neurovascular: '',
                    des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
                },
                risks: [{
                    name: '慢性头痛',
                    des: '长期的高低肩容易产生颈肩部位、头部的慢性疼痛。'
                }, {
                    name: '骨刺',
                    des: '高低肩使颈椎受力异常，最后可能导致颈椎部位退化，易形成骨刺。'
                }, {
                    name: '腰痛',
                    des: '高低肩可能造成骨盆的移位，使腰部肌力不平衡，导致腰痛。'
                }, {
                    name: '长短腿',
                    des: '由于高低肩造成的骨盆移位可能会使腿长发生变化。'
                }]
            }, {
                name: '圆肩',
                key: 'roundShoulder',
                normal: {
                    normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
                },
                definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
                harm: {
                    bone: '肩胛骨外展、胸廓变小',
                    muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
                    neurovascular: '',
                    des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
                },
                risks: [{
                    name: '心脏负担加重',
                    des: '过度圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉被压迫，使心脏工作负担加重。'
                }, {
                    name: '头痛',
                    des: '肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起头痛。'
                }, {
                    name: '手臂麻木',
                    des: '肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起手臂麻木。'
                }]
            }],
            trunk: [{
                name: '脊柱异位',
                key: 'spineSidesway',
                normal: {
                    left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
                    normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
                },
                definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
                harm: {
                    bone: '脊柱出现S型弯曲或C型弯曲',
                    muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
                    neurovascular: '',
                    des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
                },
                risks: [{
                    name: '脊柱侧弯',
                    des: '平面拍摄检测出脊柱异位提示您需进一步通过三维检测，确定是否存在脊柱侧弯的症状。'
                }, {
                    name: '高低肩',
                    des: '脊柱侧弯可能伴随高低肩症状。'
                }, {
                    name: '骨盆侧倾',
                    des: '脊柱侧弯可能伴随骨盆侧倾症状。'
                }]
            }],
            pelvis: [{
                name: '骨盆侧倾',
                key: 'pelvisLean',
                normal: {
                    left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
                    right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
                    normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
                    right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
                },
                definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
                harm: {
                    bone: '骨盆倾斜',
                    muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
                    neurovascular: '',
                    des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
                },
                risks: [{
                    name: '慢性疼痛',
                    des: '骨盆侧倾可能会引发腰腿疼痛、肩颈疼痛。'
                }, {
                    name: '腰椎间盘突出',
                    des: '骨盆侧倾可能加重腰椎间盘突出风险。'
                }, {
                    name: '长短腿',
                    des: '骨盆侧倾可能加重长短腿风险。。'
                }]
            }],
            'lower extremity': [{
                name: 'O型腿',
                key: 'legO',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_O
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_O
                },
                definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
                harm: {
                    bone: 'O型腿（膝内翻）',
                    muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
                    neurovascular: '',
                    des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
                },
                risks: [{
                    name: '半月板损伤',
                    des: 'O型腿造成下肢力线发生改变，膝关节内侧间隙承受大于正常负荷的压力。可能引起膝关节内侧半月板损伤。'
                }, {
                    name: '关节炎',
                    des: '严重O型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n' + '置换手术。'
                }]
            }, {
                name: 'X型腿',
                key: 'legX',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_X
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_X
                },
                definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
                harm: {
                    bone: 'X型腿（膝外翻）',
                    muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
                    neurovascular: '',
                    des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
                },
                risks: [{
                    name: '半月板损伤',
                    des: 'X型腿造成下肢力线发生改变，膝关节外侧间隙承受大于正常负荷的压力。可能引起膝关节外侧半月板损伤。'
                }, {
                    name: '关节炎',
                    des: '严重X型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n' + '置换手术。'
                }]
            }, {
                name: '膝过伸',
                key: 'kneeOverstretch',
                normal: {
                    normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
                },
                definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
                harm: {
                    bone: '踝关节背屈不足，使膝关节无法向前移动',
                    muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
                    neurovascular: '',
                    des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
                },
                risks: [{
                    name: '膝关节退变',
                    des: '长期膝关节过伸，会引起膝关节的过度磨损，加大膝关节退变的发生率。'
                }, {
                    name: '损害全身平衡',
                    des: '膝关节位置的改变会引起髋关节、骨盆、踝关节的位置异常，由此逐渐损害全身的平衡状态，长期累积会引发各种体态异常。'
                }]
            }, {
                name: 'XO型腿',
                key: 'legXO',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_XO
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_XO
                },
                definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
                harm: {
                    bone: '这个是XO型腿',
                    muscle: '这个是XO型腿',
                    neurovascular: '',
                    des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
                },
                risks: [{
                    name: '膝关节疼痛',
                    des: '由于XO型腿造成股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛。'
                }, {
                    name: '膝关节炎',
                    des: '重度XO型腿最终可能发展为膝关节骨性关节炎。'
                }]
            }]
        }
    },
    sympItem: {
        levelName: "高 | 中 | 低"
    },
    sympItemIpad: {
        detection: "检测到",
        item: "项",
        noHeightRisk: "恭喜您未检测到高风险，请继续保持良好的体态",
        otherDetecation: "其他检测项",
        potentialRisk: "潜在风险",
        heightRisk: "高风险",
        suggest: "平时需要关注自己的体态,并且加强锻炼",
        suggestSolve: "出现了较明显的异常体态,需要及时寻求解决方案或是获取更多专业咨询",
        normal: "正常",
        risk: "风险",
        levelName: "高 | 中 | 低"
    }

};

// CONCATENATED MODULE: ./src/assets/lang.conf/tw.js

var tw = {
    postureHome: {
        indexPage: {
            a_posture_title: "體態分析報告",
            show: "1"
        },
        coverInfo: {
            customerName: "測試對象",
            date: "報告日期",
            time: "檢測時間",
            userName: "檢測分析師",
            clickEnterReport: "點擊進入報告"
        }
    },
    postureIpad: {
        bullet: {
            Home: '首頁',
            Posturedata: '體態數據',
            Score: '風險評估',
            Muscle: '肌肉狀態',
            Solution: '報告結論'
        },
        front: '正視圖',
        side: '側視圖',
        viwesNav: '側面 | 正面',
        InvalidData: '數據無效',
        qrcode: '長按保存圖片，打開微信客戶端掃描二維碼',
        expertsWalk: '步姿專家',
        smallProgram: '小程序',
        clickRightTop: '點擊右上角',
        clickTranspond: '點擊[轉發]分享小程序',
        symptoms: {
            head: [{
                name: '頭部側傾',
                key: 'headSidesway',
                normal: {
                    left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
                    normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
                },
                definition: '在直立過程中，頭部向左或右傾斜的現象。',
                harm: {
                    bone: '頸椎側屈',
                    muscle: '屈曲側：胸鎖乳突肌縮短緊張、斜角肌縮短緊張、頭夾肌縮短緊張、肩胛提肌縮短緊張、頸夾肌緊張。拉長側：胸鎖乳突肌拉長、斜角肌拉長、頸夾肌拉長、肩胛提肌拉長',
                    neurovascular: '單側椎動脈受壓迫、單側頸神經受壓迫',
                    des: '長期使脖子側歪容易使頸後韌帶以及肌肉的慢性勞損，導致椎骨增生，頸椎病。'
                },
                risks: [{
                    name: '肌肉韌帶慢性勞損',
                    des: '長期頭側傾容易導致頸後韌帶、頸周圍肌肉的慢性勞損。'
                }, {
                    name: '頸椎病',
                    des: '由於頭部異位導致頸部軟組織、骨骼的異常，增大了頸椎病患病風險。'
                }]
            }, {
                name: '頭部前傾',
                key: 'headLean',
                normal: {
                    normal: imgSrc_default.a.risk_normal.HEAD_LEAN
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
                },
                definition: '頭部過度向前伸的現象。',
                harm: {
                    bone: '椎弓變直或出現反弓',
                    muscle: '胸鎖乳突縮短緊張、斜方肌上束過度拉長、夾肌（頭夾肌、頸夾肌）過度拉長、肩胛提肌緊張、斜角肌縮短緊張',
                    neurovascular: '胸鎖乳突肌--副神經可誘發面部疼痛，椎弓變直使椎間孔間隙變小壓迫頸部神經和椎動脈，斜方肌過度縮短可能壓迫鎖骨下動脈導致手臂供血不足',
                    des: '頭部每前傾出2.5厘米，頸部多增加4千克重量負擔，向前伸出6-9厘米，頸部的負荷已經超過了20升水的重量，頭部前傾還會引發頭暈、搖晃、眼睛裏面疼痛、惡心、食欲不振、長期的頸椎病、肩周炎和偏頭痛、思考能力下降、腹壓降低、腰椎不穩、壓迫神經，緊張性頭痛、肺活量降低，影響心血管健康、血液循環變慢，影響大腦血供、影響形象美觀。'
                },
                risks: [{
                    name: '頭暈頭痛',
                    des: '頭部前傾可能影響頭部血液循環，由於血流不暢而導致頭部缺氧，引發頭暈頭痛。'
                }, {
                    name: '頸椎病',
                    des: '長期的重度頭部前傾可能會導致頸椎病。'
                }]
            }],
            shoulder: [{
                name: '高低肩',
                key: 'highLowShoulder',
                normal: {
                    left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
                    right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
                    normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
                    right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
                },
                definition: '肩峰左右高度差超過2CM則為高低肩。',
                harm: {
                    bone: '脊柱側彎、骨盆側傾、長短腿、高側肩胛骨上擡、單側足弓塌陷',
                    muscle: '高側：肩胛提肌縮短緊張、斜方肌上束縮短緊張、菱形肌緊張、斜角肌縮短緊張、胸小肌拉長、鎖骨下肌緊張、前鋸肌拉長緊張。低側：',
                    neurovascular: '',
                    des: '肩膀附近的肌肉過緊，或者由於脊柱側彎導致的脊柱變形，因此容易產生頸肩部位的慢性疼痛、慢性頭痛、高低肩使姿勢不正確，使得頸椎所承受的負荷量過重，最後可能導致頸椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部組織肌力不平衡，導致腰痛。同時，骨盆移位也會使腿長發生變化。'
                },
                risks: [{
                    name: '慢性頭痛',
                    des: '長期的高低肩容易產生頸肩部位、頭部的慢性疼痛。'
                }, {
                    name: '骨刺',
                    des: '高低肩使頸椎受力異常，最後可能導致頸椎部位退化，易形成骨刺。'
                }, {
                    name: '腰痛',
                    des: '高低肩可能造成骨盆的移位，使腰部肌力不平衡，導致腰痛。'
                }, {
                    name: '長短腿',
                    des: '由於高低肩造成的骨盆移位可能會使腿長發生變化。'
                }]
            }, {
                name: '圓肩',
                key: 'roundShoulder',
                normal: {
                    normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
                },
                definition: '由於胸小肌被動縮短，肩胛骨前引，使肩部向前和向下，造成圓肩的現象。',
                harm: {
                    bone: '肩胛骨外展、胸廓變小',
                    muscle: '胸大肌、胸小肌縮短緊張、菱形肌過度拉長、斜方肌拉長',
                    neurovascular: '',
                    des: '圓肩會影響個人形象、氣質欠佳、緊張的肌肉會造成肩頸酸痛，最嚴重可壓迫頸椎神經，引起頭痛和手臂麻木。頸部曲度減小，僵硬，引起對大腦供血不足，使人整天灰灰沈沈，打不起精神。圓肩會使橫膈膜處於緊張狀態，造成大動脈和腔靜脈的壓迫，使心臟工作負擔加重。'
                },
                risks: [{
                    name: '心臟負擔加重',
                    des: '過度圓肩會使橫膈膜處於緊張狀態，造成大動脈和腔靜脈被壓迫，使心臟工作負擔加重。'
                }, {
                    name: '頭痛',
                    des: '肩頸周圍肌肉緊張，嚴重時可致頸椎神經被壓迫，引起頭痛。'
                }, {
                    name: '手臂麻木',
                    des: '肩頸周圍肌肉緊張，嚴重時可致頸椎神經被壓迫，引起手臂麻木。'
                }]
            }],
            trunk: [{
                name: '脊柱異位',
                key: 'spineSidesway',
                normal: {
                    left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
                    normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
                },
                definition: '是指脊柱的壹個或數個節段向側方彎曲伴有椎體旋轉的三維脊柱畸形的現象。',
                harm: {
                    bone: '脊柱出現S型彎曲或C型彎曲',
                    muscle: '凹側肌肉縮短無力、凸側肌肉拉長無力松弛',
                    neurovascular: '',
                    des: '脊柱側彎會發作肩背不平，腿腳不等長，駝背雞胸，身材矮小，活動範圍減小。胸廓變形、腹腔減小等造成腰背痛痛、神經受損、消化不良、心跳反常、肢體感覺障礙等癥狀。消化不良，食欲不振、肺-血液氣體交換功能障礙，高低肩，肩頸部的不適，、消化不良，食欲不振，心搏加速，心慌意亂，氣短，胸腹脹滿，四肢肌肉無力，四肢反應敏感度不同，體力較弱等.'
                },
                risks: [{
                    name: '脊柱側彎',
                    des: '平面拍攝檢測出脊柱異位提示您需進壹步通過三維檢測，確定是否存在脊柱側彎的癥狀。'
                }, {
                    name: '高低肩',
                    des: '脊柱側彎可能伴隨高低肩癥狀。'
                }, {
                    name: '骨盆側傾',
                    des: '脊柱側彎可能伴隨骨盆側傾癥狀。'
                }]
            }],
            pelvis: [{
                name: '骨盆側傾',
                key: 'pelvisLean',
                normal: {
                    left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
                    right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
                    normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
                    right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
                },
                definition: '在X光片上顯示的兩側髂脊的上緣連線不在同壹條水平線上，觸診時兩手卡在髂脊上緣出現壹手高壹手低的現象。',
                harm: {
                    bone: '骨盆傾斜',
                    muscle: '高側：腰方肌縮短緊張、高髂腰縮短肌緊張、臀中肌縮短緊張，臀大肌緊張。低側：臀大肌薄弱、腰方肌拉長無力、髂腰肌拉長無力',
                    neurovascular: '',
                    des: '骨盆側傾可能會引發腰腿疼痛、坐骨神經痛、腰椎間盤突出、臀肌或腿部肌肉萎縮、脊椎側彎、胸部疼痛、高低肩，長短腿，雙腿並攏的時候可能膝蓋還不壹個高度，痛經，肩頸疼痛。'
                },
                risks: [{
                    name: '慢性疼痛',
                    des: '骨盆側傾可能會引發腰腿疼痛、肩頸疼痛。'
                }, {
                    name: '腰椎間盤突出',
                    des: '骨盆側傾可能加重腰椎間盤突出風險。'
                }, {
                    name: '長短腿',
                    des: '骨盆側傾可能加重長短腿風險。。'
                }]
            }],
            'lower extremity': [{
                name: 'O型腿',
                key: 'legO',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_O
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_O
                },
                definition: '是指兩下肢自然伸直或站立時，兩足內踝能相碰而兩膝不能靠攏。',
                harm: {
                    bone: 'O型腿（膝內翻）',
                    muscle: '髖外旋肌緊張、髖內旋肌無力、臀大肌薄弱、股骨前傾角過大',
                    neurovascular: '',
                    des: '下肢臃腫之感、外側肌肉發達，而內側肌肉菲薄、膝關節內側軟骨面磨損，脛骨平臺塌陷，繼發骨性關節炎，O型腿也會影響體型外觀。'
                },
                risks: [{
                    name: '半月板損傷',
                    des: 'O型腿造成下肢力線發生改變，膝關節內側間隙承受大於正常負荷的壓力。可能引起膝關節內側半月板損傷。'
                }, {
                    name: '關節炎',
                    des: '嚴重O型腿最終可能發展為膝關節骨性關節炎、關節外側間隙關節退變，嚴重者需要進行人工關節\n' + '置換手術。'
                }]
            }, {
                name: 'X型腿',
                key: 'legX',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_X
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_X
                },
                definition: '指兩足並立時，兩側膝關節碰在壹起，而兩足內踝無法靠攏。',
                harm: {
                    bone: 'X型腿（膝外翻）',
                    muscle: '髖外展肌無力、股四頭肌內側頭、髖內旋肌緊張、股二頭肌緊張、髂脛束緊張',
                    neurovascular: '',
                    des: '影響美觀，給人的心理造成壹定的自卑感、膝內翻使下肢的力線發生改變，膝關節內側間隙承受大於正常負荷的壓力，長此以往，引起膝關節內側間隙關節退變，最終可能發展為膝關節骨性關節炎引起疼痛，引起膝關節外側間隙關節退變，嚴重者需要進行人工關節置換手術。'
                },
                risks: [{
                    name: '半月板損傷',
                    des: 'X型腿造成下肢力線發生改變，膝關節外側間隙承受大於正常負荷的壓力。可能引起膝關節外側半月板損傷。'
                }, {
                    name: '關節炎',
                    des: '嚴重X型腿最終可能發展為膝關節骨性關節炎、關節外側間隙關節退變，嚴重者需要進行人工關節\n' + '置換手術。'
                }]
            }, {
                name: '膝過伸',
                key: 'kneeOverstretch',
                normal: {
                    normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
                },
                definition: '在行走或站立過程中，下肢在支撐期出現膝關節過度伸展（膝伸展角度大於5°），身體重心後移，髖關節過度屈曲，身體出現後傾趨勢的現象。',
                harm: {
                    bone: '踝關節背屈不足，使膝關節無法向前移動',
                    muscle: '臀大肌薄弱、較多情況下股四頭較肌薄弱，腘繩肌過度活躍，踝關節周圍韌帶緊張、膝關節周圍韌帶及關節囊松弛',
                    neurovascular: '',
                    des: '膝關節伸展受限、膝關節控制能力差、下肢深感覺障礙、異常的運動模式。'
                },
                risks: [{
                    name: '膝關節退變',
                    des: '長期膝關節過伸，會引起膝關節的過度磨損，加大膝關節退變的發生率。'
                }, {
                    name: '損害全身平衡',
                    des: '膝關節位置的改變會引起髖關節、骨盆、踝關節的位置異常，由此逐漸損害全身的平衡狀態，長期累積會引發各種體態異常。'
                }]
            }, {
                name: 'XO型腿',
                key: 'legXO',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_XO
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_XO
                },
                definition: '股骨、脛骨均呈內旋位，雙側小腿不能並攏。',
                harm: {
                    bone: '這個是XO型腿',
                    muscle: '這個是XO型腿',
                    neurovascular: '',
                    des: 'XO型腿，股骨、脛骨均呈內旋位，雙側小腿間存在較大間隙，不能並攏，影響美觀。由於股骨與脛骨位置相對不平衡，壓力更易集中在膝關節外側，更易發生膝關節疼痛甚至膝關節炎。'
                },
                risks: [{
                    name: '膝關節疼痛',
                    des: '由於XO型腿造成股骨與脛骨位置相對不平衡，壓力更易集中在膝關節外側，更易發生膝關節疼痛。'
                }, {
                    name: '膝關節炎',
                    des: '重度XO型腿最終可能發展為膝關節骨性關節炎。'
                }]
            }]
        }
    },
    postureModalIpad: {
        detection: "檢測到",
        item: "項",
        noHeightRisk: "恭喜您未檢測到高風險，請繼續保持良好的體態",
        otherDetecation: "其他檢測項",
        potentialRisk: "潛在風險",
        heightRisk: "高風險",
        suggest: "平時需要關註自己的體態,並且加強鍛煉",
        suggestSolve: "出現了較明顯的異常體態,需要及時尋求解決方案或是獲取更多專業咨詢",
        normal: "正常",
        risk: "風險",
        return: "返回",
        levelName: "高 | 中 | 低"
    },
    postureModal: {
        goback: "返回",
        potentialRisk: "潛在風險",
        levelName: "高 | 中 | 低",
        symptominterpretation: "癥狀解讀",
        triggersymptoms: "引發癥狀",
        normal: "正常",
        highRisk: "高風險"
    },
    postureReport: {
        redAlert: "紅色代表此部分肌肉緊張",
        yellowAlert: "黃色代表此部分肌肉薄弱",
        muscleDire: {
            normal: "正常",
            face: "正面肌肉",
            side: "側面肌肉",
            back: "背面肌肉"
        },
        details: {
            lh: "lh",
            ll: "ll",
            rh: "rh",
            rr: "rr"
        },
        descripName: {
            upName: "需加強",
            lowName: "需放松"
        },
        navList: "正面 | 側面 | 背面",
        boneDescription: {
            face: {
                trunk: "腹部肌群",
                legForX: ["髖外旋肌", "髖內收肌"],
                legForO: "髖外旋肌",
                legForStretch: "股四頭肌",
                round: "胸大肌"
            },
            side: {
                round: "胸鎖乳突肌",
                fore: "胸鎖乳突肌",
                shoulder: "斜角肌"
            },
            back: {
                spine: "高側斜方肌",
                shoulder: "高側斜方肌",
                round: ["高側斜方肌", "低側斜方肌"],
                fore: ["高側斜方肌", "低側斜方肌"],
                rake: "肩胛提肌",
                legStretch: ["腘繩肌", "足底筋膜"],
                legX: ["髖外旋肌", "股二頭肌"],
                legO: ["半腱肌半膜肌", "脛骨前肌、脛骨後肌"],
                legXO: ["股二頭肌", "足底筋膜"]
            }
        }
    },
    postureSymp: {
        detection: '檢測到',
        item: '項',
        noHeightRisk: '恭喜您未檢測到高風險，請繼續保持良好的體態',
        otherDetecation: '其他檢測項',
        potentialRisk: '潛在風險',
        heightRisk: '高風險',
        suggest: '平時需要關註自己的體態,並且加強鍛煉',
        suggestSolve: '出現了較明顯的異常體態,需要及時尋求解決方案或是獲取更多專業咨詢',
        normal: '正常',
        risk: '風險'
    },
    postureSympIpad: {
        detection: "檢測到",
        item: "項",
        noHeightRisk: "恭喜您未檢測到高風險，請繼續保持良好的體態",
        otherDetecation: "其他檢測項",
        potentialRisk: "潛在風險",
        heightRisk: "高風險",
        suggest: "平時需要關註自己的體態,並且加強鍛煉",
        suggestSolve: "出現了較明顯的異常體態,需要及時尋求解決方案或是獲取更多專業咨詢",
        normal: "正常",
        risk: "風險"
    },
    posture: {
        bullet: {
            Home: '首頁',
            Posturedata: '體態數據',
            Score: '風險評估',
            Muscle: '肌肉狀態',
            Solution: '報告結論'
        },
        viwesNav: '側面 | 正面',
        InvalidData: '數據無效',
        qrcode: '長按保存圖片，打開微信客戶端掃描二維碼',
        expertsWalk: '步姿專家',
        smallProgram: '小程序',
        clickRightTop: '點擊右上角',
        clickTranspond: '點擊[轉發]分享小程序',
        symptoms: {
            head: [{
                name: '頭部側傾',
                key: 'headSidesway',
                normal: {
                    left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
                    normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
                },
                definition: '在直立過程中，頭部向左或右傾斜的現象。',
                harm: {
                    bone: '頸椎側屈',
                    muscle: '屈曲側：胸鎖乳突肌縮短緊張、斜角肌縮短緊張、頭夾肌縮短緊張、肩胛提肌縮短緊張、頸夾肌緊張。拉長側：胸鎖乳突肌拉長、斜角肌拉長、頸夾肌拉長、肩胛提肌拉長',
                    neurovascular: '單側椎動脈受壓迫、單側頸神經受壓迫',
                    des: '長期使脖子側歪容易使頸後韌帶以及肌肉的慢性勞損，導致椎骨增生，頸椎病。'
                },
                risks: [{
                    name: '肌肉韌帶慢性勞損',
                    des: '長期頭側傾容易導致頸後韌帶、頸周圍肌肉的慢性勞損。'
                }, {
                    name: '頸椎病',
                    des: '由於頭部異位導致頸部軟組織、骨骼的異常，增大了頸椎病患病風險。'
                }]
            }, {
                name: '頭部前傾',
                key: 'headLean',
                normal: {
                    normal: imgSrc_default.a.risk_normal.HEAD_LEAN
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
                },
                definition: '頭部過度向前伸的現象。',
                harm: {
                    bone: '椎弓變直或出現反弓',
                    muscle: '胸鎖乳突縮短緊張、斜方肌上束過度拉長、夾肌（頭夾肌、頸夾肌）過度拉長、肩胛提肌緊張、斜角肌縮短緊張',
                    neurovascular: '胸鎖乳突肌--副神經可誘發面部疼痛，椎弓變直使椎間孔間隙變小壓迫頸部神經和椎動脈，斜方肌過度縮短可能壓迫鎖骨下動脈導致手臂供血不足',
                    des: '頭部每前傾出2.5厘米，頸部多增加4千克重量負擔，向前伸出6-9厘米，頸部的負荷已經超過了20升水的重量，頭部前傾還會引發頭暈、搖晃、眼睛裏面疼痛、惡心、食欲不振、長期的頸椎病、肩周炎和偏頭痛、思考能力下降、腹壓降低、腰椎不穩、壓迫神經，緊張性頭痛、肺活量降低，影響心血管健康、血液循環變慢，影響大腦血供、影響形象美觀。'
                },
                risks: [{
                    name: '頭暈頭痛',
                    des: '頭部前傾可能影響頭部血液循環，由於血流不暢而導致頭部缺氧，引發頭暈頭痛。'
                }, {
                    name: '頸椎病',
                    des: '長期的重度頭部前傾可能會導致頸椎病。'
                }]
            }],
            shoulder: [{
                name: '高低肩',
                key: 'highLowShoulder',
                normal: {
                    left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
                    right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
                    normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
                    right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
                },
                definition: '肩峰左右高度差超過2CM則為高低肩。',
                harm: {
                    bone: '脊柱側彎、骨盆側傾、長短腿、高側肩胛骨上擡、單側足弓塌陷',
                    muscle: '高側：肩胛提肌縮短緊張、斜方肌上束縮短緊張、菱形肌緊張、斜角肌縮短緊張、胸小肌拉長、鎖骨下肌緊張、前鋸肌拉長緊張。低側：',
                    neurovascular: '',
                    des: '肩膀附近的肌肉過緊，或者由於脊柱側彎導致的脊柱變形，因此容易產生頸肩部位的慢性疼痛、慢性頭痛、高低肩使姿勢不正確，使得頸椎所承受的負荷量過重，最後可能導致頸椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部組織肌力不平衡，導致腰痛。同時，骨盆移位也會使腿長發生變化。'
                },
                risks: [{
                    name: '慢性頭痛',
                    des: '長期的高低肩容易產生頸肩部位、頭部的慢性疼痛。'
                }, {
                    name: '骨刺',
                    des: '高低肩使頸椎受力異常，最後可能導致頸椎部位退化，易形成骨刺。'
                }, {
                    name: '腰痛',
                    des: '高低肩可能造成骨盆的移位，使腰部肌力不平衡，導致腰痛。'
                }, {
                    name: '長短腿',
                    des: '由於高低肩造成的骨盆移位可能會使腿長發生變化。'
                }]
            }, {
                name: '圓肩',
                key: 'roundShoulder',
                normal: {
                    normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
                },
                definition: '由於胸小肌被動縮短，肩胛骨前引，使肩部向前和向下，造成圓肩的現象。',
                harm: {
                    bone: '肩胛骨外展、胸廓變小',
                    muscle: '胸大肌、胸小肌縮短緊張、菱形肌過度拉長、斜方肌拉長',
                    neurovascular: '',
                    des: '圓肩會影響個人形象、氣質欠佳、緊張的肌肉會造成肩頸酸痛，最嚴重可壓迫頸椎神經，引起頭痛和手臂麻木。頸部曲度減小，僵硬，引起對大腦供血不足，使人整天灰灰沈沈，打不起精神。圓肩會使橫膈膜處於緊張狀態，造成大動脈和腔靜脈的壓迫，使心臟工作負擔加重。'
                },
                risks: [{
                    name: '心臟負擔加重',
                    des: '過度圓肩會使橫膈膜處於緊張狀態，造成大動脈和腔靜脈被壓迫，使心臟工作負擔加重。'
                }, {
                    name: '頭痛',
                    des: '肩頸周圍肌肉緊張，嚴重時可致頸椎神經被壓迫，引起頭痛。'
                }, {
                    name: '手臂麻木',
                    des: '肩頸周圍肌肉緊張，嚴重時可致頸椎神經被壓迫，引起手臂麻木。'
                }]
            }],
            trunk: [{
                name: '脊柱異位',
                key: 'spineSidesway',
                normal: {
                    left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
                    normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
                    right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
                },
                definition: '是指脊柱的壹個或數個節段向側方彎曲伴有椎體旋轉的三維脊柱畸形的現象。',
                harm: {
                    bone: '脊柱出現S型彎曲或C型彎曲',
                    muscle: '凹側肌肉縮短無力、凸側肌肉拉長無力松弛',
                    neurovascular: '',
                    des: '脊柱側彎會發作肩背不平，腿腳不等長，駝背雞胸，身材矮小，活動範圍減小。胸廓變形、腹腔減小等造成腰背痛痛、神經受損、消化不良、心跳反常、肢體感覺障礙等癥狀。消化不良，食欲不振、肺-血液氣體交換功能障礙，高低肩，肩頸部的不適，、消化不良，食欲不振，心搏加速，心慌意亂，氣短，胸腹脹滿，四肢肌肉無力，四肢反應敏感度不同，體力較弱等.'
                },
                risks: [{
                    name: '脊柱側彎',
                    des: '平面拍攝檢測出脊柱異位提示您需進壹步通過三維檢測，確定是否存在脊柱側彎的癥狀。'
                }, {
                    name: '高低肩',
                    des: '脊柱側彎可能伴隨高低肩癥狀。'
                }, {
                    name: '骨盆側傾',
                    des: '脊柱側彎可能伴隨骨盆側傾癥狀。'
                }]
            }],
            pelvis: [{
                name: '骨盆側傾',
                key: 'pelvisLean',
                normal: {
                    left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
                    right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
                    normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
                },
                abnormal: {
                    left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
                    right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
                },
                definition: '在X光片上顯示的兩側髂脊的上緣連線不在同壹條水平線上，觸診時兩手卡在髂脊上緣出現壹手高壹手低的現象。',
                harm: {
                    bone: '骨盆傾斜',
                    muscle: '高側：腰方肌縮短緊張、高髂腰縮短肌緊張、臀中肌縮短緊張，臀大肌緊張。低側：臀大肌薄弱、腰方肌拉長無力、髂腰肌拉長無力',
                    neurovascular: '',
                    des: '骨盆側傾可能會引發腰腿疼痛、坐骨神經痛、腰椎間盤突出、臀肌或腿部肌肉萎縮、脊椎側彎、胸部疼痛、高低肩，長短腿，雙腿並攏的時候可能膝蓋還不壹個高度，痛經，肩頸疼痛。'
                },
                risks: [{
                    name: '慢性疼痛',
                    des: '骨盆側傾可能會引發腰腿疼痛、肩頸疼痛。'
                }, {
                    name: '腰椎間盤突出',
                    des: '骨盆側傾可能加重腰椎間盤突出風險。'
                }, {
                    name: '長短腿',
                    des: '骨盆側傾可能加重長短腿風險。。'
                }]
            }],
            'lower extremity': [{
                name: 'O型腿',
                key: 'legO',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_O
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_O
                },
                definition: '是指兩下肢自然伸直或站立時，兩足內踝能相碰而兩膝不能靠攏。',
                harm: {
                    bone: 'O型腿（膝內翻）',
                    muscle: '髖外旋肌緊張、髖內旋肌無力、臀大肌薄弱、股骨前傾角過大',
                    neurovascular: '',
                    des: '下肢臃腫之感、外側肌肉發達，而內側肌肉菲薄、膝關節內側軟骨面磨損，脛骨平臺塌陷，繼發骨性關節炎，O型腿也會影響體型外觀。'
                },
                risks: [{
                    name: '半月板損傷',
                    des: 'O型腿造成下肢力線發生改變，膝關節內側間隙承受大於正常負荷的壓力。可能引起膝關節內側半月板損傷。'
                }, {
                    name: '關節炎',
                    des: '嚴重O型腿最終可能發展為膝關節骨性關節炎、關節外側間隙關節退變，嚴重者需要進行人工關節\n' + '置換手術。'
                }]
            }, {
                name: 'X型腿',
                key: 'legX',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_X
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_X
                },
                definition: '指兩足並立時，兩側膝關節碰在壹起，而兩足內踝無法靠攏。',
                harm: {
                    bone: 'X型腿（膝外翻）',
                    muscle: '髖外展肌無力、股四頭肌內側頭、髖內旋肌緊張、股二頭肌緊張、髂脛束緊張',
                    neurovascular: '',
                    des: '影響美觀，給人的心理造成壹定的自卑感、膝內翻使下肢的力線發生改變，膝關節內側間隙承受大於正常負荷的壓力，長此以往，引起膝關節內側間隙關節退變，最終可能發展為膝關節骨性關節炎引起疼痛，引起膝關節外側間隙關節退變，嚴重者需要進行人工關節置換手術。'
                },
                risks: [{
                    name: '半月板損傷',
                    des: 'X型腿造成下肢力線發生改變，膝關節外側間隙承受大於正常負荷的壓力。可能引起膝關節外側半月板損傷。'
                }, {
                    name: '關節炎',
                    des: '嚴重X型腿最終可能發展為膝關節骨性關節炎、關節外側間隙關節退變，嚴重者需要進行人工關節\n' + '置換手術。'
                }]
            }, {
                name: '膝過伸',
                key: 'kneeOverstretch',
                normal: {
                    normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
                },
                definition: '在行走或站立過程中，下肢在支撐期出現膝關節過度伸展（膝伸展角度大於5°），身體重心後移，髖關節過度屈曲，身體出現後傾趨勢的現象。',
                harm: {
                    bone: '踝關節背屈不足，使膝關節無法向前移動',
                    muscle: '臀大肌薄弱、較多情況下股四頭較肌薄弱，腘繩肌過度活躍，踝關節周圍韌帶緊張、膝關節周圍韌帶及關節囊松弛',
                    neurovascular: '',
                    des: '膝關節伸展受限、膝關節控制能力差、下肢深感覺障礙、異常的運動模式。'
                },
                risks: [{
                    name: '膝關節退變',
                    des: '長期膝關節過伸，會引起膝關節的過度磨損，加大膝關節退變的發生率。'
                }, {
                    name: '損害全身平衡',
                    des: '膝關節位置的改變會引起髖關節、骨盆、踝關節的位置異常，由此逐漸損害全身的平衡狀態，長期累積會引發各種體態異常。'
                }]
            }, {
                name: 'XO型腿',
                key: 'legXO',
                normal: {
                    normal: imgSrc_default.a.risk_normal.LEG_XO
                },
                abnormal: {
                    normal: imgSrc_default.a.risk_abnormal.LEG_XO
                },
                definition: '股骨、脛骨均呈內旋位，雙側小腿不能並攏。',
                harm: {
                    bone: '這個是XO型腿',
                    muscle: '這個是XO型腿',
                    neurovascular: '',
                    des: 'XO型腿，股骨、脛骨均呈內旋位，雙側小腿間存在較大間隙，不能並攏，影響美觀。由於股骨與脛骨位置相對不平衡，壓力更易集中在膝關節外側，更易發生膝關節疼痛甚至膝關節炎。'
                },
                risks: [{
                    name: '膝關節疼痛',
                    des: '由於XO型腿造成股骨與脛骨位置相對不平衡，壓力更易集中在膝關節外側，更易發生膝關節疼痛。'
                }, {
                    name: '膝關節炎',
                    des: '重度XO型腿最終可能發展為膝關節骨性關節炎。'
                }]
            }]
        }
    },
    sympItem: {
        levelName: "高 | 中 | 低"
    },
    sympItemIpad: {
        detection: "檢測到",
        item: "項",
        noHeightRisk: "恭喜您未檢測到高風險，請繼續保持良好的體態",
        otherDetecation: "其他檢測項",
        potentialRisk: "潛在風險",
        heightRisk: "高風險",
        suggest: "平時需要關註自己的體態,並且加強鍛煉",
        suggestSolve: "出現了較明顯的異常體態,需要及時尋求解決方案或是獲取更多專業咨詢",
        normal: "正常",
        risk: "風險",
        levelName: "高 | 中 | 低"
    }

};

// CONCATENATED MODULE: ./src/assets/lang.conf/pt.js

var pt = {
  postureHome: {
    indexPage: {
      a_posture_title: 'Relatório postural',
      show: '1'
    },
    coverInfo: {
      customerName: 'Paciente/Cliente',
      date: 'Data do teste',
      time: 'Hora do teste',
      userName: 'Profissional',
      clickEnterReport: 'Acessar relatório'
    }
  },
  postureIpad: {
    bullet: {
      Home: 'Casa',
      Posturedata: 'Dados da postura',
      Score: 'Avaliação de risco',
      Muscle: 'Avaliação muscular',
      Solution: 'Solução'
    },
    front: 'Coronal',
    side: 'Sagital',
    viwesNav: 'Sagital | Coronal',
    InvalidData: 'Relatório invalido',
    qrcode: 'Enviamos um email para desbloquear seu exercício',
    expertsWalk: 'Senno Postura',
    smallProgram: 'support@sennotech.com',
    clickRightTop: 'Clique no botão no canto superior direito',
    clickTranspond: 'Clique para compartilhar o mini programa',
    symptoms: {
      head: [{
        name: 'Inclinação da cabeça',
        key: 'headSidesway',
        normal: {
          left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
          normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
        },
        definition: '在直立过程中，头部向左或右倾斜的现象。',
        harm: {
          bone: '颈椎侧屈',
          muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
          neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
          des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
        },
        risks: [{
          name: 'Tensão crônica dos músculos e ligamentos',
          des: 'A inclinação cefálica prolongada ou torcicolo pode levar a tensão crônica do ligamento cervical Posterior e dos músculos circundantes. '
        }, {
          name: 'Espondilose cervical',
          des: 'A região cervical é formada por sete vértebras, conectadas entre se, por ligamentos e envolvida por músculos que suportam o peso da cabeça. A espondilose cervical é a degeneração das vértebras e dos discos intervertebrais, exercendo compressão sobre a medula espinhal no nível do pescoço. A dor nesta região, muitas vezes é atribuída ao trabalho constante contra a gravidade para equilibrar a cabeça no tronco. A posição anormal dos tecidos moles e dos ossos de uma cabeça ectópica (desalinhada) aumenta o risco de dor e degeneração óssea e dos discos intervertebrais.'
        }]
      }, {
        name: 'Cabeça para Coronal',
        key: 'headLean',
        normal: {
          normal: imgSrc_default.a.risk_normal.HEAD_LEAN
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
        },
        definition: '头部过度向前伸的现象。',
        harm: {
          bone: '椎弓变直或出现反弓',
          muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
          neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
          des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
        },
        risks: [{
          name: 'Tonturas e dores de cabeça',
          des: 'Hipóxia cerebral causada por má circulação resultante da postura com a Protusao. de cabeca, pode levar a tonturas e dores de cabeça.'
        }, {
          name: 'Espondilose cervical',
          des: 'O pescoço é um conjunto de 7 vertebras conectadas por ligamentos e envolvidas por músculos que suportam um peso de 50 kg - sua cabeça! A dor no pescoço é um problema doloroso muitas vezes atribuído ao trabalho constante contra a gravidade para equilibrar a cabeça no tronco. A posição normal dos tecidos moles e dos ossos de uma cabeça ectópica aumenta o risco de degeneração dolorosa dos discos intervertebrais'
        }]
      }],
      shoulder: [{
        name: 'Ombros desalinhados',
        key: 'highLowShoulder',
        normal: {
          left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
          right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
          normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
          right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
        },
        definition: '肩峰左右高度差超过2CM则为高低肩。',
        harm: {
          bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
          muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
          neurovascular: '',
          des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
        },
        risks: [{
          name: 'Dor crônica de cabeça',
          des: ' Ombros irregulares podem eventualmente levar a dores de cabeça crônicas.'
        }, {
          name: 'Esporão ósseo',
          des: ' Ombros que não estão nivelados geram força anormal no pescoço, tornando uma pessoa propensa a degeneração da coluna cervical e, em alguns casos, osteófitos (Bico de papagaio). '
        }, {
          name: 'Lombalgia',
          des: ' Ombros inclinados podem causar inclinação lateral da pelve, desequilíbrio muscular da cintura e lombalgia.'
        }, {
          name: 'Discrepância no comprimento dos membros inferiores',
          des: ' A inclinação lateral da pélve, também aumenta o risco de uma aparente discrepância de membros inferiores.'
        }]
      }, {
        name: 'Protusão de ombros',
        key: 'roundShoulder',
        normal: {
          normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
        },
        definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
        harm: {
          bone: '肩胛骨外展、胸廓变小',
          muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
          neurovascular: '',
          des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
        },
        risks: [{
          name: 'Doença cardiovascular',
          des: 'Ombros Rounded tornam o diafragma tenso, aumentando o risco de doença cardiovascular.'
        }, {
          name: 'Dores de cabeça',
          des: ' A tensão no pescoço e nos músculos que circundam os ombros, pode até causar compressão do nervo cervical e provocar dores de cabeça.'
        }, {
          name: 'Parestesia (dormência) dos braços',
          des: ' A compressão do nervo cervical também pode causar dormência ou parestesia dos braços.'
        }]
      }],
      trunk: [{
        name: 'Escoliose',
        key: 'spineSidesway',
        normal: {
          left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
          normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
        },
        definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
        harm: {
          bone: '脊柱出现S型弯曲或C型弯曲',
          muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
          neurovascular: '',
          des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
        },
        risks: [{
          name: 'Escoliose',
          des: 'Uma inspeção 3D, ou um raio x panorâmico são indicados para diagnosticar a escoliose.'
        }, {
          name: 'Ombros desalinhados',
          des: 'A escoliose pode ser acompanhada de desalinhamento dos ombros'
        }, {
          name: 'Desalinhamento do quadril',
          des: 'A escoliose pode ser acompanhada de desalinhamento do quadril.'
        }]
      }],
      pelvis: [{
        name: 'Desalinhamento do quadril',
        key: 'pelvisLean',
        normal: {
          left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
          right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
          normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
          right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
        },
        definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
        harm: {
          bone: '骨盆倾斜',
          muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
          neurovascular: '',
          des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
        },
        risks: [{
          name: 'Dor crônica',
          des: 'O desalinhamento do quadril, pode causar dor nas extremidades.'
        }, {
          name: 'Hérnia de disco lombar',
          des: 'O desalinhamento do quadril, pode aumentar o risco de hérnia de disco lombar.'
        }, {
          name: 'Discrepância do comprimento da perna',
          des: ' Desalinhamento do quadril pode aumentar o risco de discrepância no comprimento das pernas.'
        }]
      }],
      'lower extremity': [{
        name: 'Joelho varo',
        key: 'legO',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_O
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_O
        },
        definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
        harm: {
          bone: 'O型腿（膝内翻）',
          muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
          neurovascular: '',
          des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
        },
        risks: [{
          name: 'Lesão no menisco',
          des: 'A força no membro inferior dos indivíduos com pernas arqueadas, é alterada para que'
        }, {
          name: 'Artrites',
          des: 'Pernas arqueadas podem eventualmente evoluir para osteoartrite no espaço intersticial lateral da articulação.'
        }]
      }, {
        name: 'Genu Valgo',
        key: 'legX',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_X
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_X
        },
        definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
        harm: {
          bone: 'X型腿（膝外翻）',
          muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
          neurovascular: '',
          des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
        },
        risks: [{
          name: 'Lesão no menisco',
          des: 'Os joelhos valgos alteram a direção da força nos membros inferiores, o joelho fica sujeito ao aumento da pressão lateral. Lesões e distensão laterais do menisco geralmente resultam.'
        }, {
          name: 'Artrites',
          des: 'O Genu valgo severo, pode eventualmente progredir para osteoartrite.'
        }]
      }, {
        name: 'Joelho recurvato',
        key: 'kneeOverstretch',
        normal: {
          normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
        },
        definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
        harm: {
          bone: '踝关节背屈不足，使膝关节无法向前移动',
          muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
          neurovascular: '',
          des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
        },
        risks: [{
          name: 'Degeneração da articulação do joelho',
          des: 'Desgaste excessivo e degeneração do joelho é o resultado de genu recurvato persistente.'
        }, {
          name: 'Influência do equilíbrio corporal',
          des: 'Joelhos deformados levam a mudanças de posição dos quadril, pelve e tornozelos, e podem modificar gradualmente o equilíbrio de todo o corpo.'
        }]
      }, {
        name: 'Pernas com arco falso',
        key: 'legXO',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_XO
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_XO
        },
        definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
        harm: {
          bone: '这个是XO型腿',
          muscle: '这个是XO型腿',
          neurovascular: '',
          des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
        },
        risks: [{
          name: 'Dor no joelho',
          des: 'Quando a pelve se inclina para Coronal, cria também um desalinhamento da “grid” na articulação do joelho. Seu fêmur não desliza corretamente sobre a tíbia (Osso da canela), criando um desequilíbrio. Quando este desequilíbrio é combinado com rotações interna do fêmur (devido à fraqueza de glúteos por causa do APT), pode ocorrer perfeitamente uma curvatura falsa dos joelhos.\n' + 'Você pode ouvir seu joelho, estalar e rangir com freqüência durante sua movimentação ao longo do dia. '
        }, {
          name: 'Artrites',
          des: 'À medida que o tempo avança, você pode começar a sentir dor, já que as estruturas estabilizadoras (cartilagem e ligamentos) do joelho são desgastadas a uma taxa muito mais rápida em comparação com um joelho neutro.'
        }]
      }]
    }
  },
  postureModalIpad: {
    detection: 'Detectou',
    item: 'itens',
    noHeightRisk: 'Você tem uma postura muito saudável, continue!',
    otherDetecation: 'Outros itens',
    potentialRisk: 'Risco médio',
    heightRisk: 'Risco alto',
    suggest: ' Sua postura precisam melhorar, alguns minutos por dia de exercício serão muito úteis ',
    suggestSolve: ' Você realmente precisam melhorar sua postura, procure  um fisioterapeuta especialista em quiropraxia, osteopatia ou podoposturologia para fazer mais avaliações',
    normal: 'Normal',
    risk: 'Risco',
    return: 'Retorno',
    levelName: 'Alto | Médio | Baixo'
  },
  postureModal: {
    normal: 'Normal',
    highRisk: 'Risco alto',
    goback: 'Posterior',
    potentialRisk: 'Risco médio',
    levelName: 'Alto | Médio | Baixo',
    symptominterpretation: 'Dicas',
    triggersymptoms: 'Impactos'
  },
  postureReport: {
    redAlert: ' Zona vermelha significa tensão muscular ',
    yellowAlert: ' Zona amarela significa fraqueza muscular',
    muscleDire: {
      normal: 'Normal',
      face: 'Coronal',
      side: 'Sagital',
      back: 'Posterior'
    },
    details: {
      lh: 'lh',
      ll: 'll',
      rh: 'rh',
      rr: 'rr'
    },
    descripName: {
      upName: 'precisa ser fortalecido',
      lowName: 'precisa ser alongado'
    },
    navList: 'Coronal | Sagital | Posterior',
    boneDescription: {
      face: {
        trunk: 'Músculos abdutores',
        legForX: ['Músculos abdutores do quadril', 'Músculos adutores do quadril,'],
        legForO: 'Músculos abdutores do quadril',
        legForStretch: 'Quadriceps femoral',
        round: 'Peitoral maior'
      },
      side: {
        round: 'O músculo esternocleidomastoideo,',
        fore: 'O músculo esternocleidomastoideo, ',
        shoulder: 'Músculo Escaleno'
      },
      back: {
        spine: 'Trapézio superior',
        shoulder: 'Trapézio superior',
        round: ['Trapézio superior', 'Trapézio inferior'],
        fore: ['Trapézio superior', 'Trapézio inferior'],
        rake: 'Levantador da escápula,',
        legStretch: ['Músculos isquiotibiais', 'Fascia plantar'],
        legX: ['Glúteos máximo,médio e minimo', 'Biceps femoral'],
        // TODO invetors -> Tibialis Anterior ；Tibialis Posterior，需要匈牙利语翻译
        legO: ['Isquiotibiais', 'Invetors'],

        legXO: ['Biceps femoral', 'Fascia Plantar']
      }
    }
  },
  postureSymp: {
    detection: 'Detectou',
    item: 'itens',
    noHeightRisk: 'Você tem uma postura muito saudável, continue!',
    otherDetecation: 'Outros itens',
    potentialRisk: 'Risco médio',
    heightRisk: 'Risco alto',
    suggest: 'Sua postura precisam melhorar, alguns minutos por dia de exercício serão muito úteis',
    suggestSolve: 'Você realmente precisam melhorar sua postura, procure um fisioterapeuta especialista em quiropraxia, osteopatia ou em podoposturologia para fazer mais avaliações',
    normal: 'Normal',
    risk: 'Risco'
  },
  postureSympIpad: {
    detection: 'Detectou',
    item: 'itens',
    noHeightRisk: 'Você tem uma postura muito saudável, continue!',
    otherDetecation: 'Outros itens',
    potentialRisk: 'Risco médio',
    heightRisk: 'Risco alto',
    suggest: 'Sua postura precisam melhorar, alguns minutos por dia de exercício serão muito úteis',
    suggestSolve: 'Você realmente precisam melhorar sua postura, procure um fisioterapeuta especialista em quiropraxia, osteopatia ou em podoposturologia para fazer mais avaliações',
    normal: 'Normal',
    risk: 'Risco'
  },
  posture: {
    bullet: {
      Home: 'Casa',
      Posturedata: 'Dados da Postura',
      Score: 'Avaliação de risco',
      Muscle: 'Avaliação Muscular',
      Solution: 'Solução'
    },
    viwesNav: 'Sagital | Coronal',
    InvalidData: 'Relatório inválido',
    qrcode: 'Envie-nos um email para desbloquear seu exercício',
    expertsWalk: 'Senno Postura',
    smallProgram: 'support@sennotech.com',
    clickRightTop: 'Clique no botão no canto superior direito',
    clickTranspond: 'Clique para compartilhar o mini programa',
    symptoms: {
      head: [{
        name: 'Inclinar a cabeça',
        key: 'headSidesway',
        normal: {
          left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
          normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
        },
        definition: '在直立过程中，头部向左或右倾斜的现象。',
        harm: {
          bone: '颈椎侧屈',
          muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
          neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
          des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
        },
        risks: [{
          name: 'Tensão crônica dos músculos e ligamentos',
          des: 'A inclinação cefálica prolongada ou torcicolo, pode levar a tensão crônica do ligamento cervical Posterior e dos músculos circundantes. '
        }, {
          name: 'Espondilose cervical',
          des: 'O pescoço é um conjunto de 7 vertebras conectados por ligamentos e envolvidas por músculos que suportam um peso de 7 kg - sua cabeça! A dor no pescoço é um problema doloroso muitas vezes atribuído ao trabalho constante contra a gravidade para equilibrar a cabeça no tronco. A posição normal dos tecidos moles e dos ossos de uma cabeça ectópica aumenta o risco de degeneração dolorosa dos discos intervertebrais'
        }]
      }, {
        name: 'Protusão de cabeça',
        key: 'headLean',
        normal: {
          normal: imgSrc_default.a.risk_normal.HEAD_LEAN
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
        },
        definition: '头部过度向前伸的现象。',
        harm: {
          bone: '椎弓变直或出现反弓',
          muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
          neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
          des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
        },
        risks: [{
          name: 'Tonturas e dores de cabeça',
          des: 'Hipóxia cerebral causada por má circulação resultante da postura com a Protusao de cabeca pode levar a tonturas e dores de cabeça.'
        }, {
          name: 'Espondilose Cervical',
          des: 'O pescoço é um conjunto de 7 vertebras conectadas por ligamentos e envolvidas por músculos que suportam um peso de 50 kg - sua cabeça! A dor no pescoço é um problema doloroso muitas vezes atribuído ao trabalho constante contra a gravidade para equilibrar a cabeça no tronco. A posição normal dos tecidos moles e dos ossos de uma cabeça ectópica aumenta o risco de degeneração dolorosa dos discos intervertebrais'
        }]
      }],
      shoulder: [{
        name: 'Ombros desalinhados',
        key: 'highLowShoulder',
        normal: {
          left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
          right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
          normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
          right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
        },
        definition: '肩峰左右高度差超过2CM则为高低肩。',
        harm: {
          bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
          muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
          neurovascular: '',
          des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
        },
        risks: [{
          name: 'Dores de cabeça crônica',
          des: 'Ombros desalinhados podem eventualmente, levar a dores de cabeça crônica.'
        }, {
          name: 'Osteófitos',
          des: ' Ombros desalinhados geram força anormal no pescoço, tornando uma pessoa propensa a degeneração da coluna cervical em alguns casos, osteófitos. '
        }, {
          name: 'Lombalgia',
          des: 'Ombros desalinhados(elevaldo ou deprimido) podem causar inclinação lateral da pelve, desequilíbrio muscular da cintura e lombalgia.'
        }, {
          name: 'Discrepância no comprimento dos membros inferiores',
          des: 'A inclinação lateral da pelve, também aumenta o risco de uma aparente desigualdade no comprimento das pernas.'
        }]
      }, {
        name: 'Protusão de ombros',
        key: 'roundShoulder',
        normal: {
          normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
        },
        definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
        harm: {
          bone: '肩胛骨外展、胸廓变小',
          muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
          neurovascular: '',
          des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
        },
        risks: [{
          name: 'Doença Cardiovascular',
          des: 'Ombros protusos tornam o diafragma tenso, aumentando o risco de doença cardiovascular.'
        }, {
          name: 'Dores de cabeça',
          des: ' A tensão no pescoço e nos músculos que circundam os ombros pode  causar compressão do nervo cervical e dores de cabeça.'
        }, {
          name: 'Parestesia de braços (Formigamento)',
          des: 'A compressão do nervo cervical também pode causar dormência ou parestesia dos braços.'
        }]
      }],
      trunk: [{
        name: 'Escoliose',
        key: 'spineSidesway',
        normal: {
          left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
          normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
        },
        definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
        harm: {
          bone: '脊柱出现S型弯曲或C型弯曲',
          muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
          neurovascular: '',
          des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
        },
        risks: [{
          name: 'Escoliose',
          des: 'É indicada uma inspeção 3-D ou um raio x panorâmico para diagnosticar a escoliose.'
        }, {
          name: 'Ombros desalinhados',
          des: ' A escoliose pode ser acompanhada de ombros desalinhados.'
        }, {
          name: 'Quadril desalinhado',
          des: ' A escoliose pode ser acompanhada por quadril desalinhados.'
        }]
      }],
      pelvis: [{
        name: 'Quadril desalinhado',
        key: 'pelvisLean',
        normal: {
          left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
          right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
          normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
          right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
        },
        definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
        harm: {
          bone: '骨盆倾斜',
          muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
          neurovascular: '',
          des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
        },
        risks: [{
          name: 'Dor crônica',
          des: 'Quadril desalinhados, pode causar dor nas extremidades.'
        }, {
          name: 'Hérnia de disco lombar',
          des: 'Quadril desalinhado, pode aumentar o risco de hérnia de disco lombar.'
        }, {
          name: 'Discrepância do comprimento da perna',
          des: 'Quadril desalinhado pode aumentar o risco de discrepância no comprimento das pernas.'
        }]
      }],
      'lower extremity': [{
        name: 'Joelho varo',
        key: 'legO',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_O
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_O
        },
        definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
        harm: {
          bone: 'O型腿（膝内翻）',
          muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
          neurovascular: '',
          des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
        },
        risks: [{
          name: 'Lesão menisco',
          des: ' A força no membro inferior dos indivíduos com pernas arqueadas é alterada para que '
        }, {
          name: 'Artrite',
          des: 'Perna severamente arqueadas podem eventualmente evoluir para osteoartrite no espaço intersticial lateral da articulação.'
        }]
      }, {
        name: 'Genu Valgum',
        key: 'legX',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_X
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_X
        },
        definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
        harm: {
          bone: 'X型腿（膝外翻）',
          muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
          neurovascular: '',
          des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
        },
        risks: [{
          name: 'Lesão de menisco',
          des: 'Como os joelhos valgos alteram a direção da força no membro inferior, o joelho está sujeito a aumento da pressão lateral. Resultando geralmente em lesões e distensão lateral do menisco.'
        }, {
          name: 'Artrite',
          des: 'Genu valgum grave pode eventualmente progredir para osteoartrite.'
        }]
      }, {
        name: 'genu recurvatum',
        key: 'kneeOverstretch',
        normal: {
          normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
        },
        definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
        harm: {
          bone: '踝关节背屈不足，使膝关节无法向前移动',
          muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
          neurovascular: '',
          des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
        },
        risks: [{
          name: 'Degeneração da articulação do joelho',
          des: 'O desgaste excessivo e a degeneração do joelho são o resultado de persistentes dores nas costas.'
        }, {
          name: 'Influência do equilíbrio corporal',
          des: 'Os joelhos deformados levam a mudanças de posição dos quadril, pelve e tornozelos, e podem gradualmente modificar o equilíbrio de todo o corpo.'
        }]
      }, {
        name: 'Arco falso de pernas',
        key: 'legXO',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_XO
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_XO
        },
        definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
        harm: {
          bone: '这个是XO型腿',
          muscle: '这个是XO型腿',
          neurovascular: '',
          des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
        },
        risks: [{
          name: 'Dor no joelho',
          des: 'Quando a p\xE9lvica se inclina para a Coronal, cria tamb\xE9m um desalinhamento da \'grade\' na articula\xE7\xE3o do joelho. Agora, seu f\xEAmur n\xE3o encaixa adequadamente na sua t\xEDbia (osso da canela), criando um desequil\xEDbrio. Quando o desequil\xEDbrio \xE9 combinado com rota\xE7\xE3o interna do f\xEAmur (devido \xE0 falta de gl\xFAteos fortes por causa do APT), voc\xEA acaba com uma receita perfeita para falsas curvaturas dos joelhos.  n ' + 'você pode ouvir o joelho estalando, rangindo com bastante frequência enquanto se movimenta ao longo do dia. '
        }, {
          name: 'Artrite',
          des: 'À medida que o tempo avança, você pode começar a sentir dor, já que as estruturas estabilizadoras (cartilagem e ligamentos) do joelho, são desgastadas a uma taxa muito mais rápida, em comparação com um joelho neutro..'
        }]
      }]
    }
  },
  sympItem: {
    levelName: 'Alto | Médio | Baixo'
  },
  sympItemIpad: {
    detection: 'Detectou',
    item: 'itens',
    noHeightRisk: 'Você tem uma postura muito saudável, continue!',
    otherDetecation: 'Outros itens',
    potentialRisk: 'Risco Médio',
    heightRisk: 'Risco Alto',
    suggest: 'Sua postura precisam melhorar, alguns minutos por dia de exercício serão muito úteis',
    suggestSolve: 'Você realmente precisam melhorar sua postura, procure um fisioterapeuta especialista em quiropraxia, osteopatia ou podoposturologia para fazer melhor avaliá-la',
    normal: 'Normal',
    risk: 'Risco',
    levelName: 'Alto | Médio | Baixo'
  }
};


// CONCATENATED MODULE: ./src/assets/lang.conf/it.js

var it = {
  postureHome: {
    indexPage: {
      a_posture_title: 'Raport Postura',
      show: '1'
    },
    coverInfo: {
      customerName: 'Soggetto della Prova',
      date: 'Data della Prova',
      time: 'Durata della Prova',
      userName: 'Analista della Prova',
      clickEnterReport: 'entra'
    }
  },

  postureIpad: {
    bullet: {
      Home: 'Home',
      Posturedata: 'Dati della postura',
      Score: 'Valutazione del  Rischio',
      Muscle: 'Valutazione Muscolare',
      Solution: 'Soluzione'
    },
    front: 'davanti',
    side: 'lato',
    viwesNav: 'Lato | Davanti',
    InvalidData: 'Report non valido',
    qrcode: 'Mandaci un email e sblocca i tuoi esercizi',
    expertsWalk: 'Senno Posture',
    smallProgram: 'support@sennotech.com',
    clickRightTop: 'Fai click nel pulsante in alto a destra',
    clickTranspond: 'clicca per condividere il mini programma',
    symptoms: {
      head: [{
        name: 'Inclinazione testa',
        key: 'headSidesway',
        normal: {
          left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
          normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
        },
        definition: '在直立过程中，头部向左或右倾斜的现象。',
        harm: {
          bone: '颈椎侧屈',
          muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
          neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
          des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
        },
        risks: [{
          name: 'Sforzo cronico dei muscoli e dei legamenti',
          des: 'L\'Inclinazione cefalica prolungata o il torcicollo possono portare a uno sforzo cronico del legamento cervicale posteriore e dei muscoli circostanti. '
        }, {
          name: 'Spondilosi cervicale',
          des: 'Il collo e’ una catena di 7 ossa collegate da legamenti e avvolte da muscoli che sostengono un peso di 7 kg ( la tua testa!) Il dolore al collo e’un problema spesso attribuito al lavoro costante contro la gravita’ per bilanciare la testa sul busto. La posizione anormale dei tessuti molli e delle ossa da una testa ectopica aumenta il rischio di degenerazione dolorosa dei dischi intervertebrali'
        }]
      }, {
        name: 'Testa in avanti',
        key: 'headLean',
        normal: {
          normal: imgSrc_default.a.risk_normal.HEAD_LEAN
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
        },
        definition: '头部过度向前伸的现象。',
        harm: {
          bone: '椎弓变直或出现反弓',
          muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
          neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
          des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
        },
        risks: [{
          name: 'Vertigini e mal di testa',
          des: 'L\'ipossia cerebrale causata da una cattiva circolazione derivante dalla postura con la testa in avanti puo\u2019  portare a vertigini e mal di testa.'
        }, {
          name: 'Spondilosi cervicale',
          des: 'Il collo e’ una catena di 7 ossa collegate da legamenti e avvolte da muscoli che sostengono un peso di 7 kg ( la tua testa!) Il dolore al collo e’ un problema spesso attribuito al lavoro costante contro la gravita’ per bilanciare la testa sul busto. La posizione anormale dei tessuti molli e delle ossa da una testa ectopica aumenta il rischio di degenerazione dolorosa dei dischi intervertebrali'
        }]
      }],
      shoulder: [{
        name: 'Spalle Irregolari',
        key: 'highLowShoulder',
        normal: {
          left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
          right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
          normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
          right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
        },
        definition: '肩峰左右高度差超过2CM则为高低肩。',
        harm: {
          bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
          muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
          neurovascular: '',
          des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
        },
        risks: [{
          name: 'Mal di testa cronico',
          des: 'Spalle irregolari possono portare a mal di testa cronico.'
        }, {
          name: 'Speroni ossei',
          des: 'Le spalle che non sono a livello generano una forza anormale sul collo, rendendo una persona incline alla degenerazione della colonna cervicale e in alcuni casi a speroni ossei. '
        }, {
          name: 'Lombalgia',
          des: 'Le spalle inclinate possono causare Inclinazione laterale del bacino, squilibrio muscolare in vita e lombalgia.'
        }, {
          name: 'Discrepanza della lunghezza delle gambe',
          des: 'L\'Inclinazione laterale pelvica aumenta anche il rischio di un\' apparente disuguaglianza nella lunghezza delle gambe.'
        }]
      }, {
        name: 'Spalle Curve',
        key: 'roundShoulder',
        normal: {
          normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
        },
        definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
        harm: {
          bone: '肩胛骨外展、胸廓变小',
          muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
          neurovascular: '',
          des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
        },
        risks: [{
          name: 'Malattia cardiovascolare',
          des: 'Le spalle curve aumentano la tensione del diaframma aumentando il rischio di malattie cardiovascolari.'
        }, {
          name: 'Mal di testa',
          des: 'La tensione del collo e delle spalle con le spalle curve puo’ opersino causare compressione del nervo cervicale e mal di testa.'
        }, {
          name: 'Braccia intorpidite',
          des: 'La compressione del nervo cervicale puo’ anche provocare intorpidimento o parestesia delle braccia.'
        }]
      }],
      trunk: [{
        name: 'Scoliosi',
        key: 'spineSidesway',
        normal: {
          left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
          normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
        },
        definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
        harm: {
          bone: '脊柱出现S型弯曲或C型弯曲',
          muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
          neurovascular: '',
          des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
        },
        risks: [{
          name: 'Scoliosi',
          des: 'Ulteriore ispezione 3D e\u2019 indicata per diagnosticare la scoliosi.'
        }, {
          name: 'Spalle irregolari',
          des: 'La scoliosi puo\u2019 essere accompagnata da spalle irregolari.'
        }, {
          name: 'Fianchi irregolari',
          des: 'La scoliosi puo\u2019 essere accompagnata da fianchi irregolari.'
        }]
      }],
      pelvis: [{
        name: 'Fianchi Irregolari',
        key: 'pelvisLean',
        normal: {
          left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
          right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
          normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
          right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
        },
        definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
        harm: {
          bone: '骨盆倾斜',
          muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
          neurovascular: '',
          des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
        },
        risks: [{
          name: 'Dolore cronico',
          des: 'Fianchi irregolari possono causare dolore estremo.'
        }, {
          name: 'Ernia del disco lombare',
          des: 'I fianchi irregolari possono aumentare il rischio di ernia del disco lombare.'
        }, {
          name: 'Discrepanza della lunghezza delle gambe',
          des: 'I fianchi irregolari possono aumentare il rischio di discrepanza nella lunghezza delle gambe.'
        }]
      }],
      'lower extremity': [{
        name: 'Gambe arcuate (curvatura a forma di O)',
        key: 'legO',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_O
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_O
        },
        definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
        harm: {
          bone: 'O型腿（膝内翻）',
          muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
          neurovascular: '',
          des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
        },
        risks: [{
          name: 'Lesione del menisco',
          des: 'La pressione sull\'arto inferiore nelle persone con le gambe arcuate viene modificata in modo tale'
        }, {
          name: 'Artrite',
          des: 'Le gambe  gravemente storte possono eventualmente progredire verso l\'artrite nello spazio interstiziale laterale dell\'articolazione.'
        }]
      }, {
        name: 'Ginocchio Valgo (Ginocchia ad X)',
        key: 'legX',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_X
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_X
        },
        definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
        harm: {
          bone: 'X型腿（膝外翻）',
          muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
          neurovascular: '',
          des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
        },
        risks: [{
          name: 'Lesione del Menisco',
          des: 'Poiche\u2019 le ginocchia ad X alterano la direzione della forza dell\'arto inferiore, il ginocchio e\u2019 soggetto ad una maggiore pressione laterale. Ne\u2019 risultano spesso tensioni e lesioni del menisco laterale.'
        }, {
          name: 'Artrite',
          des: 'Il ginocchio valgo grave puo\u2019 eventualmente progredire verso l\'artrite.'
        }]
      }, {
        name: 'Ginocchio recurvato',
        key: 'kneeOverstretch',
        normal: {
          normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
        },
        definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
        harm: {
          bone: '踝关节背屈不足，使膝关节无法向前移动',
          muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
          neurovascular: '',
          des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
        },
        risks: [{
          name: 'Degenerazione dell\'articolazione del ginocchio',
          des: 'L\'eccessiva usura e la degenerazione del ginocchio sono il risultato di un persistente ginocchio recurvato.'
        }, {
          name: 'Influenza sull\'equilibrio del corpo',
          des: 'Le ginocchia deformate portano a cambiamenti di posizione di fianchi, bacino e caviglie e possono modificare gradualmente l\'equilibrio di tutto il corpo.'
        }]
      }, {
        name: 'Gambe arcuate',
        key: 'legXO',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_XO
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_XO
        },
        definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
        harm: {
          bone: '这个是XO型腿',
          muscle: '这个是XO型腿',
          neurovascular: '',
          des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
        },
        risks: [{
          name: 'Dolore alle ginocchia',
          des: 'Quando il bacino si inclina in avanti, crea anche un disallineamento a \'griglia\' sull\'articolazione del ginocchio. Il femore non segue correttamente la tibia (stinco), creando uno squilibrio. Quando lo squilibrio e\u2019 accoppiato a femori ruotati internamente (a causa della mancanza di forti glutei a causa dell\'APT), si finisce con una ricetta perfetta per falsa curvatura delle ginocchia. \n' + 'Si potrebbe sentire il ginocchio muoversi e cedere abbastanza spesso durante la giornata .'
        }, {
          name: 'Artrite',
          des: 'Col passare del tempo, potresti iniziare a sentire dolore Poiche’ le strutture stabilizzanti (ad es. Cartilagine e legamenti) nel ginocchio si logorano a una velocit?molto piu’ rapida rispetto a un ginocchio neutro.'
        }]
      }]
    }
  },

  postureModalIpad: {
    detection: 'Rilevato',
    item: 'elementi',
    noHeightRisk: 'Hai una sana postura, continua cosi\u2019!',
    otherDetecation: 'altri elementi',
    potentialRisk: 'Rischio medio',
    heightRisk: 'Alto rischio',
    suggest: 'La tua postura deve migliorare, pochi minuti al giorno di esercizi posturali saranno molto utili ',
    suggestSolve: 'Hai davvero bisogno di migliorare la tua postura, per favore contatta uno specialista per fare piu\u2019 valutazioni',
    normal: 'Normale',
    risk: 'Rischio',
    return: 'ritorna',
    levelName: 'Alto | Medio |Basso'
  },

  postureModal: {
    normal: 'Normale',
    highRisk: 'Alto Rischio',
    goback: 'Indietro',
    potentialRisk: 'Rischio Medio',
    levelName: 'Alto | Medio | Basso',
    symptominterpretation: 'Suggerimenti',
    triggersymptoms: 'Impatto'
  },

  postureReport: {
    redAlert: 'Zone rossa sta per tensione muscolare',
    yellowAlert: 'Zona gialla sta per debolezza muscolare',
    muscleDire: {
      normal: 'Normale',
      face: 'Davanti',
      side: 'Lato',
      back: 'Indietro'
    },
    details: {
      lh: 'lh',
      ll: 'll',
      rh: 'rh',
      rr: 'rr'
    },
    descripName: {
      upName: 'deve essere rafforzato',
      lowName: 'deve essere  allungato'
    },
    navList: 'Davanti | Lato | Dietro',
    boneDescription: {
      face: {
        trunk: 'Muscoli Addominali',
        legForX: ['Muscoli abduttori dei fianchi', 'Muscoli adduttori dei fianchi'],
        legForO: 'Muscoli abduttori dei fianchi',
        legForStretch: 'Quadricipite femorale',
        round: 'Pettorale'
      },
      side: {
        round: 'Muscolo sternocleidomastoideo',
        fore: 'Muscolo sternocleidomastoideo',
        shoulder: 'Muscolo scaleno'
      },
      back: {
        spine: 'Trapezio superiore',
        shoulder: 'Trapezio superiore',
        round: ['Trapezio superiore', 'Trapezio inferiore'],
        fore: ['Trapezio superiore', 'Trapezio inferiore'],
        rake: 'Muscolo elevatore della scapola',
        legStretch: ['Muscoli del tendine del ginocchio', 'Fascia plantare'],
        legX: ['Muscoli abduttori dei fianchi', 'Bicipite femorale'],
        legO: ['Muscoli posteriori della coscia', 'Inventori'],
        legXO: ['Bicipite Femorale', 'Fascia Plantare']
      }
    }
  },

  postureSymp: {
    detection: 'Rilevato',
    item: 'elementi',
    noHeightRisk: 'Hai una postura sana, continua cosi!',
    otherDetecation: 'altri elementi',
    potentialRisk: 'Medio rischio',
    heightRisk: 'Alto Rischio',
    suggest: 'La tua postura deve migliorare, pochi minuti al giorno di esercizi posturali saranno molto utili ',
    suggestSolve: 'Hai davvero bisogno di migliorare la tua postura, per favore contatta uno specialista per fare piu’ valutazioni',
    normal: 'Normale',
    risk: 'Rischio'
  },

  postureSympIpad: {
    detection: 'Rilevato',
    item: 'elementi',
    noHeightRisk: 'Hai una postura sana, continua cosi!',
    otherDetecation: 'altri elementi',
    potentialRisk: 'Medio rischio',
    heightRisk: 'Alto Rischio',
    suggest: 'La tua postura deve migliorare, pochi minuti al giorno di esercizi posturali saranno molto utili ',
    suggestSolve: 'Hai davvero bisogno di migliorare la tua postura, per favore contatta uno specialista per fare piu’ valutazioni',
    normal: 'Normale',
    risk: 'Rischio'
  },

  posture: {
    bullet: {
      Home: 'Home',
      Posturedata: 'Dati della Postura',
      Score: 'Valutazione del Rischio',
      Muscle: 'Valutazione muscolare',
      Solution: 'Soluzione'
    },
    viwesNav: 'Lato | Davanti',
    InvalidData: 'Report non valido',
    qrcode: 'Mandaci una mail e sblocca i tuoi esercizi',
    expertsWalk: 'Senno Posture',
    smallProgram: 'support@sennotech.com',
    clickRightTop: 'Clicca il pulsante in alto a destra',
    clickTranspond: 'clicca per condividere il mini programma',
    symptoms: {
      head: [{
        name: 'Inclinazione',
        key: 'headSidesway',
        normal: {
          left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
          normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
        },
        definition: '在直立过程中，头部向左或右倾斜的现象。',
        harm: {
          bone: '颈椎侧屈',
          muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
          neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
          des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
        },
        risks: [{
          name: 'Sforzo cronico dei muscoli e dei legamenti',
          des: 'L\'Inclinazione cefalica prolungata o il torcicollo possono portare a uno sforzo cronico del legamento cervicale posteriore e dei muscoli circostanti. '
        }, {
          name: 'Spondilosi cervicale',
          des: 'Il collo e\u2019 una catena di 7 ossa collegate da legamenti e avvolte da muscoli che sostengono un peso di 7 kg ( la tua testa!) Il dolore al collo e\u2019 un problema spesso attribuito al lavoro costante contro la gravita\u2019 per bilanciare la testa sul busto.La posizione anormale dei tessuti molli e delle ossa da una testa ectopica aumenta il rischio di degenerazione dolorosa dei dischi intervertebrali'
        }]
      }, {
        name: 'Testa in Avanti',
        key: 'headLean',
        normal: {
          normal: imgSrc_default.a.risk_normal.HEAD_LEAN
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
        },
        definition: '头部过度向前伸的现象。',
        harm: {
          bone: '椎弓变直或出现反弓',
          muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
          neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
          des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
        },
        risks: [{
          name: 'Vertigini e Mal di testa',
          des: 'L\'ipossia cerebrale causata da una cattiva circolazione derivante dalla postura con la testa in avanti puo\u2019 portare a vertigini e mal di testa.'
        }, {
          name: 'Spondilosi cervicale',
          des: 'Il collo e\u2019 una catena di 7 ossa collegate da legamenti e avvolte da muscoli che sostengono un peso di 7 kg ( la tua testa!) Il dolore al collo e\u2019 un problema spesso attribuito al lavoro costante contro la gravita\u2019 per bilanciare la testa sul busto.La posizione anormale dei tessuti molli e delle ossa da una testa ectopica aumenta il rischio di degenerazione dolorosa dei dischi intervertebrali'
        }]
      }],
      shoulder: [{
        name: 'Spalle Irregolari',
        key: 'highLowShoulder',
        normal: {
          left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
          right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
          normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
          right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
        },
        definition: '肩峰左右高度差超过2CM则为高低肩。',
        harm: {
          bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
          muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
          neurovascular: '',
          des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
        },
        risks: [{
          name: 'Mal di Testa Cronico',
          des: 'Spalle irregolari potrebbero causare mal di testa cronico.'
        }, {
          name: 'Speroni Ossei',
          des: ' Le spalle non in linea generano una forza anormale sul collo, rendendo una persona incline alla degenerazione della colonna cervicale e in alcuni casi a speroni ossei'
        }, {
          name: 'Lombalgia',
          des: 'le spalle inclinate possono causare Inclinazione laterale del bacino, squilibrio muscolare in vita e lombalgia..'
        }, {
          name: 'Discrepanza Lunghezza Gambe',
          des: 'l\'Inclinazione laterale pelvica aumenta anche il rischio di un\'apparente disuguaglianza nella lunghezza delle gambe.'
        }]
      }, {
        name: 'Spalle Curve',
        key: 'roundShoulder',
        normal: {
          normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
        },
        definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
        harm: {
          bone: '肩胛骨外展、胸廓变小',
          muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
          neurovascular: '',
          des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
        },
        risks: [{
          name: 'Malattie Cardiovascolari',
          des: ' Le spalle curve aumentano la tensione del diaframma, aumentando il rischio di malattie cardiovascolari.'
        }, {
          name: 'MaldiTesta',
          des: 'La tensione del collo e delle spalle dovute a  spalle curve puo\u2019 persino causare compressione del nervo cervicale e mal di testa.'
        }, {
          name: 'Arti Intorpiditi',
          des: 'La compressione del nervo cervicale puo\u2019 anche provocare intorpidimento o parestesia delle braccia.'
        }]
      }],
      trunk: [{
        name: 'Scoliosi',
        key: 'spineSidesway',
        normal: {
          left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
          normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
        },
        definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
        harm: {
          bone: '脊柱出现S型弯曲或C型弯曲',
          muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
          neurovascular: '',
          des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
        },
        risks: [{
          name: 'Scoliosi',
          des: 'Ulteriore ispezione 3D e\u2019 indicata per diagnosticare la scoliosi.'
        }, {
          name: 'Spalle Inclinate',
          des: 'La scoliosi puo\u2019 essere accompagnata da spalle inclinate.'
        }, {
          name: 'Bacino Inclinato',
          des: 'La scoliosi puo\u2019 essere accompagnato da bacino inclinato.'
        }]
      }],
      pelvis: [{
        name: 'Bacino Inclinato',
        key: 'pelvisLean',
        normal: {
          left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
          right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
          normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
          right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
        },
        definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
        harm: {
          bone: '骨盆倾斜',
          muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
          neurovascular: '',
          des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
        },
        risks: [{
          name: 'Dolore Cronico',
          des: 'Un bacino inclinato puo\u2019 causare dolore alle estremita\''
        }, {
          name: 'Ernia Disco Lombare',
          des: 'Un bacino inclinato puo\u2019 aumentare il rischio di una ernia del disco lombare.'
        }, {
          name: 'Discrepanza Lunghezza Gambe',
          des: 'Un bacino inclinato puo\u2019 aumentare il rischio di una discrepanza nella lunghezza delle gambe.'
        }]
      }],
      'lower extremity': [{
        name: 'Gambe ad Arco (Curvatura ad O)',
        key: 'legO',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_O
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_O
        },
        definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
        harm: {
          bone: 'O型腿（膝内翻）',
          muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
          neurovascular: '',
          des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
        },
        risks: [{
          name: 'Lesione meniscale',
          des: 'La forza sull\u2019 arto inferiore nelle persone con le gambe arcuate viene modificata a causa di cio\u2019'
        }, {
          name: 'Artrite',
          des: 'Accentuate gambe ad arco possono causare artrite nello spazio interstiziale laterale dell\u2019 articolazione.'
        }]
      }, {
        name: 'Ginocchio valgo (Gambe ad X)',
        key: 'legX',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_X
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_X
        },
        definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
        harm: {
          bone: 'X型腿（膝外翻）',
          muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
          neurovascular: '',
          des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
        },
        risks: [{
          name: 'Lesione Meniscale',
          des: 'Poiche\u2019 le ginocchia ad X alterano la direzione della pressione dell\u2019 arto inferiore, il ginocchio e\u2019 soggetto ad una maggiore pressione laterale. Ne\u2019 risultano spesso dolore e lesioni del menisco laterale .'
        }, {
          name: 'Artrite',
          des: 'Un grave ginocchio valgo puo\u2019 eventualmente progredire in osteoartrite.'
        }]
      }, {
        name: 'Ginocchio recurvato',
        key: 'kneeOverstretch',
        normal: {
          normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
        },
        definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
        harm: {
          bone: '踝关节背屈不足，使膝关节无法向前移动',
          muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
          neurovascular: '',
          des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
        },
        risks: [{
          name: 'Degenerazione Articolazione Ginocchio',
          des: 'L\u2019 eccessiva usura e la degenerazione del ginocchio sono il risulatato di un persistente ginocchio recurvato .'
        }, {
          name: 'Influenza Equilibrio Corpo',
          des: 'Le ginocchia deformate portano a cambiamenti di posizione di fianchi, bacino e caviglie e possono modificare gradualmente l\'equilibrio di tutto il corpo .'
        }]
      }, {
        name: 'Gambe arcuate',
        key: 'legXO',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_XO
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_XO
        },
        definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
        harm: {
          bone: '这个是XO型腿',
          muscle: '这个是XO型腿',
          neurovascular: '',
          des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
        },
        risks: [{
          name: 'Dolore al ginocchio',
          des: 'Quando il bacino e\u2019 inclinato in avanti, esso crea un disallineamento a griglia dell\u2019 articolazione del ginocchio. Il femore non segue correttamente la tibia (stinco), creando uno squilibrio. Quando lo squilibrio e\u2019 associato a intrarotazione del femore (a causa di debolezza muscolare dei glutei di APT, Inclinazione pelvica anteriore), cio\u2019 porta a false ginocchia curve .\n' + 'Si potrebbe sentire il ginocchio muoversi e cedere abbastanza spesso durante la giornata . '
        }, {
          name: 'Artrite',
          des: 'Con il passare del tempo potresti iniziare a sentire dolore dalle giunture (i.e. Cartilagine e legamenti) In questo tipo di ginocchio si consumano molto piu\u2019 rapidamente rispetto ad un ginocchio neutro .'
        }]
      }]
    }
  },

  sympItem: {
    levelName: 'alto | medio | basso'
  },

  sympItemIpad: {
    detection: 'Rilevato',
    item: 'elementi',
    noHeightRisk: 'Hai una postura molto sana, Continua cosi\u2019',
    otherDetecation: 'altri elementi',
    potentialRisk: 'Medio rischio',
    heightRisk: 'Alto rischio',
    suggest: 'La tua postura necessita di miglioramenti, pochi minuti al giorno di esercizi sulla postura saranno molto utili',
    suggestSolve: 'Hai davvero necessita\u2019 di migliorare la tua postura, per favore contatta uno specialista per ulteri',
    normal: 'Normale',
    risk: 'Rischio',
    levelName: 'Alto | Medio | Basso'
  }
};

// CONCATENATED MODULE: ./src/assets/lang.conf/ja.js

var ja = {
  postureHome: {
    indexPage: {
      a_posture_title: '姿勢レポート',
      show: '1'
    },
    coverInfo: {
      customerName: 'テスト対象',
      date: 'テスト日付',
      time: 'テスト時間',
      userName: 'テストアナリスト',
      clickEnterReport: 'レポートを観覧するにはクリック'
    }
  },

  postureIpad: {
    bullet: {
      Home: 'ホーム',
      Posturedata: '姿勢データ',
      Score: 'リスク分析',
      Muscle: '筋肉分析',
      Solution: '解決法'
    },
    front: '正面',
    side: '側面',
    viwesNav: '側面 | 正面',
    InvalidData: '無効なレポート',
    qrcode: 'エクササイズをアンロックするためには弊社にメールにて問い合わせください。',
    expertsWalk: 'Senno Posture',
    smallProgram: 'support@sennotech.com',
    clickRightTop: '右上のボタンをクリックしてください。',
    clickTranspond: 'ミニプログラムをシェアするにはクリックしてください。',
    symptoms: {
      head: [{
        name: '頭の傾き',
        key: 'headSidesway',
        normal: {
          left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
          normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
        },
        definition: '在直立过程中，头部向左或右倾斜的现象。',
        harm: {
          bone: '颈椎侧屈',
          muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
          neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
          des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
        },
        risks: [{
          name: '慢性的な筋肉および靭帯の緊張',
          des: '長時間の頭部傾斜または斜頸は、後頸部靭帯および周囲の筋肉の慢性的な緊張につながる可能性があります。'
        }, {
          name: '頸椎症',
          des: '首は靭帯で接続された7つの骨で形成されていて、７kgの重さを支える筋肉に包まれています。首の痛みは、重力に逆らって上半身の頭のバランスをとることに起因する痛みを伴う問題です。異所性頭からくる軟組織と骨の異常な位置は、椎間板の痛みを伴うリスクを高めます'
        }]
      }, {
        name: 'ストレートネック',
        key: 'headLean',
        normal: {
          normal: imgSrc_default.a.risk_normal.HEAD_LEAN
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
        },
        definition: '头部过度向前伸的现象。',
        harm: {
          bone: '椎弓变直或出现反弓',
          muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
          neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
          des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
        },
        risks: [{
          name: 'めまいと頭痛',
          des: '頭が前に出た姿勢から生じる循環不良が原因の脳低酸素症は、めまいや頭痛を引き起こす可能性があります。'
        }, {
          name: '頸椎症',
          des: '首は靭帯で接続された7つの骨で形成されていて、７kgの重さを支える筋肉に包まれています。首の痛みは、重力に逆らって上半身の頭のバランスをとることに起因する痛みを伴う問題です。異所性頭からくる軟組織と骨の異常な位置は、椎間板の痛みを伴うリスクを高めます'
        }]
      }],
      shoulder: [{
        name: '肩の高さ違い',
        key: 'highLowShoulder',
        normal: {
          left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
          right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
          normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
          right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
        },
        definition: '肩峰左右高度差超过2CM则为高低肩。',
        harm: {
          bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
          muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
          neurovascular: '',
          des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
        },
        risks: [{
          name: '慢性頭痛',
          des: '肩が不均一になると、最終的には慢性的な頭痛につながる可能性があります。'
        }, {
          name: '骨棘',
          des: '肩が水平でないと、頸部に異常な力が発生し、頸椎や場合によっては骨棘が変性しやすくなります。 '
        }, {
          name: '腰痛',
          des: '肩の傾斜は、骨盤の外側への傾き、腰の筋肉の不均衡、腰痛を引き起こす可能性があります。'
        }, {
          name: '脚長不一致',
          des: '骨盤の側面の傾きは脚長不一致のリスクを高めます。'
        }]
      }, {
        name: '猫背',
        key: 'roundShoulder',
        normal: {
          normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
        },
        definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
        harm: {
          bone: '肩胛骨外展、胸廓变小',
          muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
          neurovascular: '',
          des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
        },
        risks: [{
          name: '循環器疾患',
          des: ' 猫背は横隔膜を緊張させ、心血管疾患のリスクを高めます。'
        }, {
          name: '頭痛',
          des: '猫背の原因となる首と肩の緊張は、頸部神経の圧迫や頭痛を引き起こすことさえあります。'
        }, {
          name: '腕のしびれ',
          des: '頸部神経の圧迫は、腕のしびれや感覚異常を引き起こすこともあります。'
        }]
      }],
      trunk: [{
        name: '脊椎側彎症',
        key: 'spineSidesway',
        normal: {
          left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
          normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
        },
        definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
        harm: {
          bone: '脊柱出现S型弯曲或C型弯曲',
          muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
          neurovascular: '',
          des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
        },
        risks: [{
          name: '脊椎側彎症',
          des: '脊椎側彎症の診断には、さらに3D検査が必要です。'
        }, {
          name: '肩の高さ違い',
          des: '脊椎側彎症には肩の高さ違いが伴う場合があります。'
        }, {
          name: '腰の高さ違い',
          des: '脊椎側彎症には、腰の高さ違いが伴う場合があります。'
        }]
      }],
      pelvis: [{
        name: '腰の高さ違い',
        key: 'pelvisLean',
        normal: {
          left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
          right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
          normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
          right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
        },
        definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
        harm: {
          bone: '骨盆倾斜',
          muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
          neurovascular: '',
          des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
        },
        risks: [{
          name: '慢性的な痛み',
          des: '不均一な腰は四肢の痛みを引き起こす可能性があります。'
        }, {
          name: '腰椎椎間板ヘルニア',
          des: '腰の高さ違いは、腰椎椎間板ヘルニアになるリスクを高める可能性があります。'
        }, {
          name: '脚の長さ違い',
          des: '腰の高さ違いは、脚長不一致のリスクを高める可能性があります。'
        }]
      }],
      'lower extremity': [{
        name: 'O脚',
        key: 'legO',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_O
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_O
        },
        definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
        harm: {
          bone: 'O型腿（膝内翻）',
          muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
          neurovascular: '',
          des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
        },
        risks: [{
          name: '半月板損傷',
          des: 'O脚の人の下肢にかかる力は普通とは違いがあり '
        }, {
          name: '関節炎',
          des: '重度のO脚は、最終的に関節の外側間質腔の変形性関節症に進行する可能性があります。'
        }]
      }, {
        name: '内反脚（ノックニー）',
        key: 'legX',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_X
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_X
        },
        definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
        harm: {
          bone: 'X型腿（膝外翻）',
          muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
          neurovascular: '',
          des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
        },
        risks: [{
          name: '半月板損傷',
          des: 'X脚は下肢にかかる力の方向が変わるため、膝の側圧が増加します。外側半月板の緊張と損傷がしばしば起こります。'
        }, {
          name: '関節炎',
          des: '重度の内反脚は最終的に変形性関節症に進行する可能性があります。'
        }]
      }, {
        name: '反張膝',
        key: 'kneeOverstretch',
        normal: {
          normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
        },
        definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
        harm: {
          bone: '踝关节背屈不足，使膝关节无法向前移动',
          muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
          neurovascular: '',
          des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
        },
        risks: [{
          name: '変性膝関節疾患',
          des: '持続的な反張膝は過度な膝摩耗と変性の原因になります。'
        }, {
          name: 'ボディバランスへの影響',
          des: '変形した膝は、腰、骨盤、足首の位置の変化につながり、徐々に全身のバランスに影響してきます。'
        }]
      }, {
        name: 'XO脚',
        key: 'legXO',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_XO
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_XO
        },
        definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
        harm: {
          bone: '这个是XO型腿',
          muscle: '这个是XO型腿',
          neurovascular: '',
          des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
        },
        risks: [{
          name: '膝の痛み',
          des: '骨盤が前方に傾くと、膝関節にも「グリッド」のずれが生じます。大腿骨が脛骨（脛骨）を適切に追従しないため、不均衡が生じます。不均衡と、骨盤前傾が原因で弱くなった大臀筋の影響で内転した大腿骨が組み合わさると、XO脚（膝下からO脚）になる条件が揃います。\n' + '動き回ると頻繁に膝が鳴ることもあるでしょう。'
        }, {
          name: '関節炎',
          des: '時間の経過とともに、膝の安定化構造（軟骨や靭帯など）がニュートラルポジションの膝に比べてはるかに速い速度ですり減るので、痛みを感じるようになります。'
        }]
      }]
    }
  },

  postureModalIpad: {
    detection: '検出',
    item: '項目',
    noHeightRisk: 'あなたの姿勢は非常に健康的です。この状態を維持しましょう！',
    otherDetecation: 'その他項目',
    potentialRisk: '中リスク',
    heightRisk: 'ハイリスク',
    suggest: '姿勢を改善する必要があります。1日に数分間の姿勢運動が非常に役立ちます。',
    suggestSolve: '姿勢を改善する必要があります。整体または理学療法士の診断を受けてください。',
    normal: 'ノーマル',
    risk: 'リスク',
    return: 'リターン',
    levelName: '高 | 中 | 低'
  },

  postureModal: {
    normal: 'ノーマル',
    highRisk: 'ハイリスク',
    goback: '戻る',
    potentialRisk: '中リスク',
    levelName: '高 | 中 | 低',
    symptominterpretation: 'アドバイス',
    triggersymptoms: 'インパクト'
  },

  postureReport: {
    redAlert: 'レッドゾーンは筋肉の緊張を表します',
    yellowAlert: '黄色のゾーンは筋力低下を意味します',
    muscleDire: {
      normal: 'ノーマル',
      face: '正面',
      side: '側面',
      back: '背面'
    },
    details: {
      lh: 'lh',
      ll: 'll',
      rh: 'rh',
      rr: 'rr'
    },
    descripName: {
      upName: 'を強化する必要があります',
      lowName: 'をストレッチする必要があります'
    },
    navList: '正面 |側面 | 背面',
    boneDescription: {
      face: {
        trunk: '腹筋',
        legForX: ['股関節外転筋', '股関節内転筋'],
        legForO: '股関節外転筋',
        legForStretch: '大腿四頭筋',
        round: '大胸筋'
      },
      side: {
        round: '胸鎖乳突筋',
        fore: '胸鎖乳突筋',
        shoulder: '斜角筋'
      },
      back: {
        spine: '上部僧帽筋',
        shoulder: '上部僧帽筋',
        round: ['上部僧帽筋', '下部僧帽筋'],
        fore: ['上部僧帽筋', '下部僧帽筋'],
        rake: '肩甲骨',
        legStretch: ['大腿部膝屈筋', '足底筋膜'],
        legX: ['股関節外転筋', '大腿二頭筋'],
        legO: ['大腿部膝屈筋', 'Invetors'],
        legXO: ['大腿二頭筋', '足底筋膜']
      }
    }
  },

  postureSymp: {
    detection: '検出',
    item: '項目',
    noHeightRisk: 'あなたの姿勢は非常に健康的です。この状態を維持しましょう！',
    otherDetecation: 'その他項目',
    potentialRisk: '中リスク',
    heightRisk: 'ハイリスク',
    suggest: '姿勢を改善する必要があります。1日に数分間の姿勢運動が非常に役立ちます。 ',
    suggestSolve: '姿勢を改善する必要があります。整体または理学療法士の診断を受けてください。',
    normal: '普通',
    risk: 'リスク'
  },

  postureSympIpad: {
    detection: '検出',
    item: '項目',
    noHeightRisk: 'あなたの姿勢は非常に健康的です。この状態を維持しましょう！',
    otherDetecation: 'その他項目',
    potentialRisk: '中リスク',
    heightRisk: 'ハイリスク',
    suggest: '姿勢を改善する必要があります。1日に数分間の姿勢運動が非常に役立ちます。 ',
    suggestSolve: '姿勢を改善する必要があります。整体または理学療法士の診断を受けてください。',
    normal: '普通',
    risk: 'リスク'
  },

  posture: {
    bullet: {
      Home: 'ホーム',
      Posturedata: '姿勢データ',
      Score: 'リスク分析',
      Muscle: '筋肉分析',
      Solution: '解決法'
    },
    front: '正面',
    side: '側面',
    viwesNav: '側面 | 正面',
    InvalidData: '無効なレポート',
    qrcode: 'エクササイズをアンロックするためには弊社にメールにて問い合わせください。',
    expertsWalk: 'Senno Posture',
    smallProgram: 'support@sennotech.com',
    clickRightTop: '右上のボタンをクリックしてください。',
    clickTranspond: 'ミニプログラムをシェアするにはクリックしてください。',
    symptoms: {
      head: [{
        name: '頭の傾き',
        key: 'headSidesway',
        normal: {
          left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
          normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
        },
        definition: '在直立过程中，头部向左或右倾斜的现象。',
        harm: {
          bone: '颈椎侧屈',
          muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
          neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
          des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
        },
        risks: [{
          name: '慢性的な筋肉および靭帯の緊張',
          des: '長時間の頭部傾斜または斜頸は、後頸部靭帯および周囲の筋肉の慢性的な緊張につながる可能性があります。'
        }, {
          name: '頸椎症',
          des: '首は靭帯で接続された7つの骨で形成されていて、７kgの重さを支える筋肉に包まれています。首の痛みは、重力に逆らって上半身の頭のバランスをとることに起因する痛みを伴う問題です。異所性頭からくる軟組織と骨の異常な位置は、椎間板の痛みを伴うリスクを高めます'
        }]
      }, {
        name: 'ストレートネック',
        key: 'headLean',
        normal: {
          normal: imgSrc_default.a.risk_normal.HEAD_LEAN
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
        },
        definition: '头部过度向前伸的现象。',
        harm: {
          bone: '椎弓变直或出现反弓',
          muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
          neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
          des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
        },
        risks: [{
          name: 'めまいと頭痛',
          des: '頭が前に出た姿勢から生じる循環不良が原因の脳低酸素症は、めまいや頭痛を引き起こす可能性があります。'
        }, {
          name: '頸椎症',
          des: '首は靭帯で接続された7つの骨で形成されていて、７kgの重さを支える筋肉に包まれています。首の痛みは、重力に逆らって上半身の頭のバランスをとることに起因する痛みを伴う問題です。異所性頭からくる軟組織と骨の異常な位置は、椎間板の痛みを伴うリスクを高めます'
        }]
      }],
      shoulder: [{
        name: '肩の高さ違い',
        key: 'highLowShoulder',
        normal: {
          left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
          right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
          normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
          right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
        },
        definition: '肩峰左右高度差超过2CM则为高低肩。',
        harm: {
          bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
          muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
          neurovascular: '',
          des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
        },
        risks: [{
          name: '慢性頭痛',
          des: '肩が不均一になると、最終的には慢性的な頭痛につながる可能性があります。'
        }, {
          name: '骨棘',
          des: '肩が水平でないと、頸部に異常な力が発生し、頸椎や場合によっては骨棘が変性しやすくなります。 '
        }, {
          name: '腰痛',
          des: '肩の傾斜は、骨盤の外側への傾き、腰の筋肉の不均衡、腰痛を引き起こす可能性があります。'
        }, {
          name: '脚長不一致',
          des: '骨盤の側面の傾きは脚長不一致のリスクを高めます。'
        }]
      }, {
        name: '猫背',
        key: 'roundShoulder',
        normal: {
          normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
        },
        definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
        harm: {
          bone: '肩胛骨外展、胸廓变小',
          muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
          neurovascular: '',
          des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
        },
        risks: [{
          name: '循環器疾患',
          des: ' 猫背は横隔膜を緊張させ、心血管疾患のリスクを高めます。'
        }, {
          name: '頭痛',
          des: '猫背の原因となる首と肩の緊張は、頸部神経の圧迫や頭痛を引き起こすことさえあります。'
        }, {
          name: '腕のしびれ',
          des: '頸部神経の圧迫は、腕のしびれや感覚異常を引き起こすこともあります。'
        }]
      }],
      trunk: [{
        name: '脊椎側彎症',
        key: 'spineSidesway',
        normal: {
          left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
          normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
          right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
        },
        definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
        harm: {
          bone: '脊柱出现S型弯曲或C型弯曲',
          muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
          neurovascular: '',
          des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
        },
        risks: [{
          name: '脊椎側彎症',
          des: '脊椎側彎症の診断には、さらに3D検査が必要です。'
        }, {
          name: '肩の高さ違い',
          des: '脊椎側彎症には肩の高さ違いが伴う場合があります。'
        }, {
          name: '腰の高さ違い',
          des: '脊椎側彎症には、腰の高さ違いが伴う場合があります。'
        }]
      }],
      pelvis: [{
        name: '腰の高さ違い',
        key: 'pelvisLean',
        normal: {
          left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
          right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
          normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
        },
        abnormal: {
          left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
          right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
        },
        definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
        harm: {
          bone: '骨盆倾斜',
          muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
          neurovascular: '',
          des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
        },
        risks: [{
          name: '慢性的な痛み',
          des: '不均一な腰は四肢の痛みを引き起こす可能性があります。'
        }, {
          name: '腰椎椎間板ヘルニア',
          des: '腰の高さ違いは、腰椎椎間板ヘルニアになるリスクを高める可能性があります。'
        }, {
          name: '脚の長さ違い',
          des: '腰の高さ違いは、脚長不一致のリスクを高める可能性があります。'
        }]
      }],
      'lower extremity': [{
        name: 'O脚',
        key: 'legO',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_O
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_O
        },
        definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
        harm: {
          bone: 'O型腿（膝内翻）',
          muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
          neurovascular: '',
          des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
        },
        risks: [{
          name: '半月板損傷',
          des: 'O脚の人の下肢にかかる力は普通とは違いがあり '
        }, {
          name: '関節炎',
          des: '重度のO脚は、最終的に関節の外側間質腔の変形性関節症に進行する可能性があります。'
        }]
      }, {
        name: '内反脚（ノックニー）',
        key: 'legX',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_X
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_X
        },
        definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
        harm: {
          bone: 'X型腿（膝外翻）',
          muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
          neurovascular: '',
          des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
        },
        risks: [{
          name: '半月板損傷',
          des: 'X脚は下肢にかかる力の方向が変わるため、膝の側圧が増加します。外側半月板の緊張と損傷がしばしば起こります。'
        }, {
          name: '関節炎',
          des: '重度の内反脚は最終的に変形性関節症に進行する可能性があります。'
        }]
      }, {
        name: '反張膝',
        key: 'kneeOverstretch',
        normal: {
          normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
        },
        definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
        harm: {
          bone: '踝关节背屈不足，使膝关节无法向前移动',
          muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
          neurovascular: '',
          des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
        },
        risks: [{
          name: '変性膝関節疾患',
          des: '持続的な反張膝は過度な膝摩耗と変性の原因になります。'
        }, {
          name: 'ボディバランスへの影響',
          des: '変形した膝は、腰、骨盤、足首の位置の変化につながり、徐々に全身のバランスに影響してきます。'
        }]
      }, {
        name: 'XO脚',
        key: 'legXO',
        normal: {
          normal: imgSrc_default.a.risk_normal.LEG_XO
        },
        abnormal: {
          normal: imgSrc_default.a.risk_abnormal.LEG_XO
        },
        definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
        harm: {
          bone: '这个是XO型腿',
          muscle: '这个是XO型腿',
          neurovascular: '',
          des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
        },
        risks: [{
          name: '膝の痛み',
          des: '骨盤が前方に傾くと、膝関節にも「グリッド」のずれが生じます。大腿骨が脛骨（脛骨）を適切に追従しないため、不均衡が生じます。不均衡と、骨盤前傾が原因で弱くなった大臀筋の影響で内転した大腿骨が組み合わさると、XO脚（膝下からO脚）になる条件が揃います。\n' + '動き回ると頻繁に膝が鳴ることもあるでしょう。'
        }, {
          name: '関節炎',
          des: '時間の経過とともに、膝の安定化構造（軟骨や靭帯など）がニュートラルポジションの膝に比べてはるかに速い速度ですり減るので、痛みを感じるようになります。'
        }]
      }]
    }
  },

  sympItem: {
    levelName: '高 | 中 | 低'
  },

  sympItemIpad: {
    detection: '検出',
    item: '項目',
    noHeightRisk: 'あなたの姿勢は非常に健康的です。この状態を維持しましょう！',
    otherDetecation: 'その他項目',
    potentialRisk: '中リスク',
    heightRisk: '高リスク',
    suggest: '姿勢を改善する必要があります。1日に数分間の姿勢運動が非常に役立ちます。',
    suggestSolve: '姿勢を改善する必要があります。整体または理学療法士の診断を受けてください。',
    normal: '普通',
    risk: 'リスク',
    levelName: '高 | 中 | 低'
  }
};

// CONCATENATED MODULE: ./src/assets/lang.conf/root.js








var postureHome = {
  'cn': zh.postureHome,
  'zhHant': tw.postureHome,
  'en': en.postureHome,
  'pt': pt.postureHome,
  'it': it.postureHome,
  'ja': ja.postureHome
};
var posture = {
  'cn': zh.posture,
  'zhHant': tw.posture,
  'en': en.posture,
  'pt': pt.posture,
  'it': it.posture,
  'ja': ja.posture
};
var postureIpad = {
  'cn': zh.postureIpad,
  'zhHant': tw.postureIpad,
  'en': en.postureIpad,
  'pt': pt.postureIpad,
  'it': it.postureIpad,
  'ja': ja.postureIpad
};
var postureModal = {
  'cn': zh.postureModal,
  'zhHant': tw.postureModal,
  'en': en.postureModal,
  'pt': pt.postureModal,
  'it': it.postureModal,
  'ja': ja.postureModal
};
var postureModalIpad = {
  'cn': zh.postureModalIpad,
  'zhHant': tw.postureModalIpad,
  'en': en.postureModalIpad,
  'pt': pt.postureModalIpad,
  'it': it.postureModalIpad,
  'ja': ja.postureModalIpad
};
var postureReport = {
  'cn': zh.postureReport,
  'zhHant': tw.postureReport,
  'en': en.postureReport,
  'pt': pt.postureReport,
  'it': it.postureReport,
  'ja': ja.postureReport
};
var postureSymp = {
  'cn': zh.postureSymp,
  'zhHant': tw.postureSymp,
  'en': en.postureSymp,
  'pt': pt.postureSymp,
  'it': it.postureSymp,
  'ja': ja.postureSymp
};
var postureSympIpad = {
  'cn': zh.postureSympIpad,
  'zhHant': tw.postureSympIpad,
  'en': en.postureSympIpad,
  'pt': pt.postureSympIpad,
  'it': it.postureSympIpad,
  'ja': ja.postureSympIpad
};
var sympItem = {
  'cn': zh.sympItem,
  'zhHant': tw.sympItem,
  'en': en.sympItem,
  'pt': pt.sympItem,
  'it': it.sympItem,
  'ja': ja.sympItem
};
var sympItemIpad = {
  'cn': zh.sympItemIpad,
  'zhHant': tw.sympItemIpad,
  'en': en.sympItemIpad,
  'pt': pt.sympItemIpad,
  'it': it.sympItemIpad,
  'ja': ja.sympItemIpad
};

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/css/bootstrap.css
var bootstrap = __webpack_require__("Jmt5");
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/dist/bootstrap-vue.css
var bootstrap_vue = __webpack_require__("9M+g");
var bootstrap_vue_default = /*#__PURE__*/__webpack_require__.n(bootstrap_vue);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Symp_item.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Symp_item = ({
  name: "Symp_item",
  i18n: {
    // `i18n` option, setup locale info for component
    messages: extends_default()({}, sympItem)
  },
  data: function data() {
    return {
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      }
    };
  },

  props: ["riskLevelList", "mClass", "hClass", "tips", "classleve", "nClass", "isShow"],
  methods: {
    getRiskImg: function getRiskImg(risk) {
      var direction = "normal";
      var img = void 0;
      if (!_.isNull(risk.direction) && risk.key !== "legO" && risk.key !== "legX" && risk.key !== "legXO" && risk.key !== "kneeOverstretch") {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },


    setModalInfo: function setModalInfo(risk) {
      this.$emit("setModalInfo", risk);
    }
  },
  created: function created() {
    //console.log("this.riskLevelList",this.riskLevelList)
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Symp_item.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_Symp_item = ({
  name: "Symp_item",
  i18n: {
    // `i18n` option, setup locale info for component
    messages: extends_default()({}, sympItem)
  },
  data: function data() {
    return {
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      }
    };
  },

  props: ["riskLevelList", "mClass", "hClass", "tips", "classleve", "nClass", "isShow"],
  methods: {
    getRiskImg: function getRiskImg(risk) {
      var direction = "normal";
      var img = void 0;
      if (!_.isNull(risk.direction) && risk.key !== "legO" && risk.key !== "legX" && risk.key !== "legXO" && risk.key !== "kneeOverstretch") {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },


    setModalInfo: function setModalInfo(risk) {
      this.$emit("setModalInfo", risk);
    }
  },
  created: function created() {
    //console.log("this.riskLevelList",this.riskLevelList)
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d249289","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Symp_item.vue
var Symp_item_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.riskLevelList, function(risk) {
      return _c(
        "div",
        {
          staticClass: "content-row content-row-column risk-box",
          on: {
            click: function($event) {
              _vm.setModalInfo(risk)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "content-row content-align-center content-row-between",
              staticStyle: { "padding-left": ".3rem", "padding-right": ".5rem" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    width: "4rem",
                    height: "4rem",
                    "border-radius": ".5rem",
                    overflow: "hidden"
                  }
                },
                [
                  _c("canvas", {
                    staticClass: "risk-body",
                    attrs: { "data-key": risk.key, "data-detail": risk.detail }
                  })
                ]
              ),
              _vm._v(" "),
              _c("img", {
                staticStyle: {
                  "margin-left": ".1rem",
                  width: "4rem",
                  height: "4rem",
                  "border-radius": ".5rem"
                },
                attrs: { src: _vm.getRiskImg(risk) }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content-row content-row-column auto-width" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "content-row content-row-between content-align-center",
                      staticStyle: {
                        "margin-left": ".2rem",
                        "margin-bottom": ".2rem"
                      }
                    },
                    [
                      _c("span", { staticClass: "font-16" }, [
                        _vm._v(_vm._s(risk.name))
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "font-14",
                          staticStyle: { color: "#8d8d8d" }
                        },
                        [_vm._v(_vm._s(risk.detail))]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "level-box font-12",
                          class: {
                            "level-severe": _vm.hClass,
                            "level-mild": _vm.mClass,
                            "level-normal": _vm.nClass
                          }
                        },
                        [_vm._v(_vm._s(_vm.tips.tip))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "content-row content-align-end",
                      staticStyle: { width: "9rem", height: "1.5rem" }
                    },
                    [
                      _c("canvas", {
                        staticClass: "risk-bar",
                        attrs: {
                          "data-value": risk.value,
                          "data-level": risk.level
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "content-row content-row-between font-12",
                      staticStyle: { width: "9rem", padding: "0 .5rem" }
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 2)))]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 1)))]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 0)))])
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-row",
              staticStyle: {
                "margin-top": ".8rem",
                "padding-right": ".3rem",
                "padding-left": ".3rem"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "content-row font-12",
                  staticStyle: { color: "#949494", "flex-wrap": "wrap" }
                },
                _vm._l(risk.risks, function(key) {
                  return _c("span", { staticClass: "key-box" }, [
                    _vm._v(_vm._s(key.name))
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _vm._m(0, true)
            ]
          )
        ]
      )
    }),
    0
  )
}
var Symp_item_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "content-row-end content-align-end",
        staticStyle: {
          height: "1rem",
          "margin-bottom": ".8rem",
          width: "4rem",
          "padding-left": "3.5rem"
        }
      },
      [_c("div", { staticClass: "down-arrow" })]
    )
  }
]
Symp_item_render._withStripped = true
var Symp_item_esExports = { render: Symp_item_render, staticRenderFns: Symp_item_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Symp_item = (Symp_item_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d249289", Symp_item_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Symp_item.vue
var Symp_item_disposed = false
function Symp_item_injectStyle (ssrContext) {
  if (Symp_item_disposed) return
  __webpack_require__("aA5A")
}
var Symp_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Symp_item___vue_template_functional__ = false
/* styles */
var Symp_item___vue_styles__ = Symp_item_injectStyle
/* scopeId */
var Symp_item___vue_scopeId__ = "data-v-2d249289"
/* moduleIdentifier (server only) */
var Symp_item___vue_module_identifier__ = null
var Symp_item_Component = Symp_item_normalizeComponent(
  components_Symp_item,
  selectortype_template_index_0_src_components_Symp_item,
  Symp_item___vue_template_functional__,
  Symp_item___vue_styles__,
  Symp_item___vue_scopeId__,
  Symp_item___vue_module_identifier__
)
Symp_item_Component.options.__file = "src/components/Symp_item.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2d249289", Symp_item_Component.options)
  } else {
    hotAPI.reload("data-v-2d249289", Symp_item_Component.options)
  }
  module.hot.dispose(function (data) {
    Symp_item_disposed = true
  })
})()}

/* harmony default export */ var src_components_Symp_item = (Symp_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_symp.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Posture_symp = ({
    name: 'Postrue_symp',
    i18n: { // `i18n` option, setup locale info for component
        messages: extends_default()({}, postureSymp)

    },
    directive: {
        bModalDirective: modal_modal["a" /* default */]
    },
    components: {
        Symp_item: src_components_Symp_item
    },
    props: ['severeRisks', 'mildRisks', 'normalRisks'],
    data: function data() {
        return {
            level: {
                normal: 'normal',
                mild: 'mild',
                severe: 'severe'
            },
            tips: {
                riskCount: 0,
                riskTip: this.$t('risk')
            },
            isShow: false,
            riskLevelList: [],
            hClass: false,
            mClass: false,
            nClass: false,
            classleve: 'normal',
            ntips: {
                tip: this.$t('normal')
            },
            mtips: {
                tip: this.$t('potentialRisk')
            }

        };
    },

    computed: {},
    methods: {
        getRiskImg: function getRiskImg(risk) {
            var direction = 'normal';
            var img = void 0;
            if (!lodash_default.a.isNull(risk.direction) && risk.key !== 'legO' && risk.key !== 'legX' && risk.key !== 'legXO' && risk.key !== 'kneeOverstretch') {
                direction = risk.direction;
            }
            if (this.checkIfAbnormal(risk.level)) {
                img = risk.abnormal[direction];
            } else {
                img = risk.normal[direction];
            }
            return img;
        },
        checkIfAbnormal: function checkIfAbnormal(level) {
            switch (level) {
                case this.level.normal:
                    return false;
                case this.level.mild:
                    return false;
                case this.level.severe:
                    return true;
            }
        },

        share: function share(risk) {
            this.$emit('share');
        },
        setModalInfo: function setModalInfo(risk) {
            this.$emit('setModalInfo', risk);
        },
        getSolutions: function getSolutions(risk) {
            this.$emit('getSolutions', risk);
        }

    },
    created: function created() {
        var riskTips = {},
            riskCount = 0,
            riskTip = '';

        if (this.severeRisks.length > 0) {
            riskCount = this.severeRisks.length;
            // riskTip='高风险'
            riskTip = this.$t('heightRisk');
            this.isShow = true;
            this.hClass = true;
            riskTips.tip = riskTip;
            this.classleve = 'severe';
            this.riskLevelList = this.severeRisks;
            //console.log("this.riskTipsddddddddddddddddd:",this.severeRisks)
        } else if (this.mildRisks.length > 0) {
            riskCount = this.mildRisks.length;
            // riskTip='潜在风险';
            riskTip = this.$t('potentialRisk');
            this.isShow = false;
            this.mClass = true;
            riskTips.tip = riskTip;
            this.classleve = 'mild';
            this.riskLevelList = this.mildRisks;
        } else {
            riskCount = this.normalRisks.length;
            // riskTip='风险'
            riskTip = this.$t('risk');
            this.isShow = false;
            this.nClass = true;
        }
        riskTips.riskCount = riskCount;
        riskTips.riskTip = riskTip;
        this.tips = assign_default()({}, riskTips);
    },
    mounted: function mounted() {
        console.log({
            'severeRisks': this.severeRisks,
            'mildRisks': this.mildRisks,
            'normalRisks': this.normalRisks
        });
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_symp.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var components_Posture_symp = ({
    name: 'Postrue_symp',
    i18n: { // `i18n` option, setup locale info for component
        messages: extends_default()({}, postureSymp)

    },
    directive: {
        bModalDirective: modal_modal["a" /* default */]
    },
    components: {
        Symp_item: src_components_Symp_item
    },
    props: ['severeRisks', 'mildRisks', 'normalRisks'],
    data: function data() {
        return {
            level: {
                normal: 'normal',
                mild: 'mild',
                severe: 'severe'
            },
            tips: {
                riskCount: 0,
                riskTip: this.$t('risk')
            },
            isShow: false,
            riskLevelList: [],
            hClass: false,
            mClass: false,
            nClass: false,
            classleve: 'normal',
            ntips: {
                tip: this.$t('normal')
            },
            mtips: {
                tip: this.$t('potentialRisk')
            }

        };
    },

    computed: {},
    methods: {
        getRiskImg: function getRiskImg(risk) {
            var direction = 'normal';
            var img = void 0;
            if (!lodash_default.a.isNull(risk.direction) && risk.key !== 'legO' && risk.key !== 'legX' && risk.key !== 'legXO' && risk.key !== 'kneeOverstretch') {
                direction = risk.direction;
            }
            if (this.checkIfAbnormal(risk.level)) {
                img = risk.abnormal[direction];
            } else {
                img = risk.normal[direction];
            }
            return img;
        },
        checkIfAbnormal: function checkIfAbnormal(level) {
            switch (level) {
                case this.level.normal:
                    return false;
                case this.level.mild:
                    return false;
                case this.level.severe:
                    return true;
            }
        },

        share: function share(risk) {
            this.$emit('share');
        },
        setModalInfo: function setModalInfo(risk) {
            this.$emit('setModalInfo', risk);
        },
        getSolutions: function getSolutions(risk) {
            this.$emit('getSolutions', risk);
        }

    },
    created: function created() {
        var riskTips = {},
            riskCount = 0,
            riskTip = '';

        if (this.severeRisks.length > 0) {
            riskCount = this.severeRisks.length;
            // riskTip='高风险'
            riskTip = this.$t('heightRisk');
            this.isShow = true;
            this.hClass = true;
            riskTips.tip = riskTip;
            this.classleve = 'severe';
            this.riskLevelList = this.severeRisks;
            //console.log("this.riskTipsddddddddddddddddd:",this.severeRisks)
        } else if (this.mildRisks.length > 0) {
            riskCount = this.mildRisks.length;
            // riskTip='潜在风险';
            riskTip = this.$t('potentialRisk');
            this.isShow = false;
            this.mClass = true;
            riskTips.tip = riskTip;
            this.classleve = 'mild';
            this.riskLevelList = this.mildRisks;
        } else {
            riskCount = this.normalRisks.length;
            // riskTip='风险'
            riskTip = this.$t('risk');
            this.isShow = false;
            this.nClass = true;
        }
        riskTips.riskCount = riskCount;
        riskTips.riskTip = riskTip;
        this.tips = assign_default()({}, riskTips);
    },
    mounted: function mounted() {
        console.log({
            'severeRisks': this.severeRisks,
            'mildRisks': this.mildRisks,
            'normalRisks': this.normalRisks
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b56ebd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_symp.vue
var Posture_symp_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c(
        "div",
        { staticClass: "content-row content-align-center font-18 risks-head" },
        [
          _c("div", { staticClass: "hasrisk-icon" }),
          _vm._v(" "),
          _c("div", [
            _vm._v(_vm._s(_vm.$t("detection"))),
            _c(
              "span",
              {
                staticClass: "font-20",
                staticStyle: { margin: "0 .5rem", color: "#fe5b3f" }
              },
              [_vm._v(_vm._s(_vm.tips.riskCount))]
            ),
            _vm._v(_vm._s(_vm.$t("item")))
          ])
        ]
      ),
      _vm._v(" "),
      _vm.riskLevelList.length === 0
        ? _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "content-row content-row-column content-align-center content-row-center",
                staticStyle: {
                  "padding-top": ".5rem",
                  "padding-bottom": ".7rem",
                  background: "#fff",
                  "border-bottom": ".5rem solid #f4f4f4"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "font-16",
                    staticStyle: { width: "91%", color: "#2cafff" }
                  },
                  [_vm._v(_vm._s(_vm.$t("noHeightRisk")))]
                )
              ]
            )
          ])
        : _c(
            "div",
            [
              _c("Symp_item", {
                attrs: {
                  riskLevelList: _vm.riskLevelList,
                  tips: _vm.tips,
                  classleve: _vm.classleve,
                  mClass: _vm.mClass,
                  nClass: false,
                  isShow: true,
                  hClass: _vm.hClass
                },
                on: { setModalInfo: _vm.setModalInfo }
              })
            ],
            1
          )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { "margin-bottom": ".7rem" } },
      [
        _c(
          "div",
          {
            staticClass: "content-row content-align-center font-18 risks-head"
          },
          [
            _c("div", { staticClass: "norisk-icon" }),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t("otherDetecation")))])
          ]
        ),
        _vm._v(" "),
        _vm.severeRisks.length != 0
          ? _c(
              "span",
              [
                _c("Symp_item", {
                  attrs: {
                    riskLevelList: _vm.mildRisks,
                    tips: _vm.mtips,
                    classleve: _vm.classleve,
                    mClass: true,
                    nClass: false,
                    isShow: _vm.isShow,
                    hClass: false
                  },
                  on: { setModalInfo: _vm.setModalInfo }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("Symp_item", {
          attrs: {
            riskLevelList: _vm.normalRisks,
            tips: _vm.ntips,
            classleve: _vm.classleve,
            mClass: false,
            nClass: true,
            isShow: true,
            hClass: false
          },
          on: { setModalInfo: _vm.setModalInfo }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: {
          padding: ".75rem .3rem",
          background: "#fff",
          "margin-bottom": "50px"
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "content-row content-row-column",
            staticStyle: {
              border: "1px solid #cbcbcb",
              "border-radius": ".7rem",
              overflow: "hidden"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "content-row content-row-between",
                staticStyle: { background: "#e5e5e5" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "content-row content-align-center content-row-center",
                    staticStyle: { "flex-shrink": "1" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "level-box level-mild font-12",
                        staticStyle: { "margin-right": ".3rem" }
                      },
                      [_vm._v(_vm._s(_vm.$t("potentialRisk")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "split-line",
                  staticStyle: { "flex-shrink": "0" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "content-row content-align-center content-row-center",
                    staticStyle: { "flex-shrink": "1" }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "level-box level-severe font-12" },
                      [_vm._v(_vm._s(_vm.$t("heightRisk")))]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "content-row content-row-between" }, [
              _c(
                "div",
                {
                  staticClass: "content-row font-14",
                  staticStyle: {
                    padding: ".5rem",
                    "line-height": "1rem",
                    color: "#757575",
                    "flex-shrink": "1"
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("suggest")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "split-line",
                staticStyle: { "flex-shrink": "0" }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content-row font-14",
                  staticStyle: {
                    padding: ".5rem",
                    "line-height": "1rem",
                    color: "#757575",
                    "flex-shrink": "1"
                  }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("suggestSolve")) +
                      "\n            "
                  )
                ]
              )
            ])
          ]
        )
      ]
    )
  ])
}
var Posture_symp_staticRenderFns = []
Posture_symp_render._withStripped = true
var Posture_symp_esExports = { render: Posture_symp_render, staticRenderFns: Posture_symp_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Posture_symp = (Posture_symp_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b56ebd0", Posture_symp_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Posture_symp.vue
var Posture_symp_disposed = false
function Posture_symp_injectStyle (ssrContext) {
  if (Posture_symp_disposed) return
  __webpack_require__("OHj7")
}
var Posture_symp_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Posture_symp___vue_template_functional__ = false
/* styles */
var Posture_symp___vue_styles__ = Posture_symp_injectStyle
/* scopeId */
var Posture_symp___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Posture_symp___vue_module_identifier__ = null
var Posture_symp_Component = Posture_symp_normalizeComponent(
  components_Posture_symp,
  selectortype_template_index_0_src_components_Posture_symp,
  Posture_symp___vue_template_functional__,
  Posture_symp___vue_styles__,
  Posture_symp___vue_scopeId__,
  Posture_symp___vue_module_identifier__
)
Posture_symp_Component.options.__file = "src/components/Posture_symp.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2b56ebd0", Posture_symp_Component.options)
  } else {
    hotAPI.reload("data-v-2b56ebd0", Posture_symp_Component.options)
  }
  module.hot.dispose(function (data) {
    Posture_symp_disposed = true
  })
})()}

/* harmony default export */ var src_components_Posture_symp = (Posture_symp_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_front.vue


//
//
//
//
//
//



/* harmony default export */ var Posture_front = ({
  name: 'Posture_front',
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {},
  props: ['severeRisks', 'mildRisks', 'normalRisks', 'points', 'photos'],
  data: function data() {
    return {
      img: {
        face: null,
        side: null
      }
    };
  },

  computed: {},
  methods: {
    getRiskImg: function getRiskImg(risk) {
      //.log("risk ==>" + JSON.stringify(risk))
      var direction = 'normal';
      var img = void 0;

      if (!_.isNull(risk.direction) && risk.key !== 'legO' && risk.key !== 'legX' && risk.key !== 'legXO' && risk.key !== 'kneeOverstretch') {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    setSymptomCanvasModal: function setSymptomCanvasModal(risk) {
      var points = this.points;
      var needDetail = ['legO', 'legX', 'legXO'];
      var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

      var riskKey = risk.key;
      var keyMap = this.keyMap;
      var positionArr = void 0;
      var positionPointsArr = [];
      var faceOrSide = void 0;
      var scale = void 0;

      keys_default()(keyMap).forEach(function (direction, index) {
        keys_default()(keyMap[direction]).forEach(function (key, index) {
          if (key === riskKey) {
            positionArr = keyMap[direction][key].position;
            scale = keyMap[direction][key].scale;
          }
        });
      });

      if (needDetail.indexOf(riskKey) !== -1) {
        // 当是 legO、legX、legXO 时
        var lOrR = void 0;
        if (risk.detail === '右腿') {
          lOrR = 'right';
        } else {
          lOrR = 'left';
        }

        for (var i = 0; i < positionArr.length; i++) {
          positionPointsArr.push(points.face[positionArr[i]][lOrR]);
        }

        faceOrSide = 'face';
      } else {
        // 正面，并且能取到左右时
        for (var _i = 0; _i < positionArr.length; _i++) {
          var positionAndDirectionArr = positionArr[_i].split('-');
          if (positionAndDirectionArr.length === 1) {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
          } else {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
          }
        }
        faceOrSide = 'face';
      }

      var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
      var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
      var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
      var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

      var width = _x > _y ? _x : _y;
      width *= 1 + scale;

      var x = xMid - width / 2;
      var y = yMid - width / 2;

      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.width = width;
      canvas.height = width;
      // let img = new Image();
      // img.src = this.photos[faceOrSide];

      var img = this.img[faceOrSide];

      ctx.drawImage(img, x, y, width, width, 0, 0, width, width);

      this.canvas = canvas;
    },
    setSymptomCanvas: function setSymptomCanvas(option) {
      var canvas = option.el;
      var ctx = canvas.getContext('2d');

      var points = this.points;
      var needDetail = ['legO', 'legX', 'legXO'];
      var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

      var riskKey = canvas.dataset.key;
      var keyMap = this.keyMap;
      var positionArr = void 0;
      var positionPointsArr = [];
      var faceOrSide = void 0;
      var scale = void 0;
      keys_default()(keyMap).forEach(function (direction, index) {
        keys_default()(keyMap[direction]).forEach(function (key, index) {
          if (key === riskKey) {
            positionArr = keyMap[direction][key].position;
            scale = keyMap[direction][key].scale;
          }
        });
      });

      if (needDetail.indexOf(riskKey) !== -1) {
        // 当是 legO、legX、legXO 时
        var lOrR = void 0;
        if (canvas.dataset.detail === '右腿') {
          lOrR = 'right';
        } else {
          lOrR = 'left';
        }

        for (var i = 0; i < positionArr.length; i++) {
          positionPointsArr.push(points.face[positionArr[i]][lOrR]);
        }

        faceOrSide = 'face';
      } else {
        // 正面，并且能取到左右时
        for (var _i2 = 0; _i2 < positionArr.length; _i2++) {
          var positionAndDirectionArr = positionArr[_i2].split('-');
          if (positionAndDirectionArr.length === 1) {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
          } else {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
          }
        }

        faceOrSide = 'face';
      }

      var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
      var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
      var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
      var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

      var width = _x > _y ? _x : _y;
      width *= 1 + scale;

      var x = xMid - width / 2;
      var y = yMid - width / 2;

      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.width = width;
      canvas.height = width;
      var img = new Image();
      img.src = this.photos[faceOrSide];
      // img.src = this.img[faceOrSide]
      img.onload = function () {
        ctx.drawImage(img, x, y, width, width, 0, 0, width, width);
      };
    },
    getLevel: function getLevel(level) {
      switch (level) {
        case this.level.normal:
          return {
            des: '低风险',
            className: 'level-normal'
          };
        case this.level.mild:
          return {
            des: '中风险',
            className: 'level-mild'
          };
        case this.level.severe:
          return {
            des: '高风险',
            className: 'level-severe'
          };
      }
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    sortHighToLow: function sortHighToLow(arr) {
      return _.orderBy(arr, ['value'], ['desc']);
    },
    initRiskBar: function initRiskBar() {
      this.$refs.riskModalRef.$el.getElementsByClassName('modal-content')[0].scrollTop = 0;
      var modalRiskBar = document.getElementById('modalRiskBar');
      canvas.initRiskLevel({
        el: modalRiskBar,
        width: Number(modalRiskBar.parentNode.offsetWidth),
        height: Number(modalRiskBar.parentNode.offsetHeight),
        color: {
          normal: '#00d963',
          mild: '#ffbf00',
          severe: '#ff4d4d'
        },
        level: this.level
      });
    },
    initRisksData: function initRisksData() {
      var risks = this.risks;
      var level = this.level;
      var symptoms = this.symptoms;
      var normalRisks = this.normalRisks;
      var mildRisks = this.mildRisks;
      var severeRisks = this.severeRisks;

      for (var direction in risks) {
        for (var i = 0; i < risks[direction].length; i++) {
          var symptom = symptoms[risks[direction][i].position][risks[direction][i].code - 1];

          if (symptom.value) {
            var otherSymptom = assign_default()({}, symptom);
            if (!risks[direction][i].valid) {
              otherSymptom.raw = 0;
              otherSymptom.value = 0;
              otherSymptom.level = level.normal;
              otherSymptom.detail = '';
              otherSymptom.direction = 'normal';
            } else {
              otherSymptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              otherSymptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              otherSymptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              otherSymptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
              otherSymptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
            }

            symptoms[risks[direction][i].position].push(otherSymptom);
          } else {
            if (!risks[direction][i].valid) {
              symptom.raw = 0;
              symptom.value = 0;
              symptom.level = level.normal;
              symptom.detail = '';
              symptom.direction = 'normal';
            } else {
              symptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              symptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              symptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              symptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
              symptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
            }
          }
        }
      }

      for (var position in symptoms) {
        for (var _i3 = 0; _i3 < symptoms[position].length; _i3++) {
          if (_.isUndefined(symptoms[position][_i3].value)) {
            continue;
          }
          switch (symptoms[position][_i3].level) {
            case level.normal:
              normalRisks.push(symptoms[position][_i3]);
              break;
            case level.mild:
              mildRisks.push(symptoms[position][_i3]);
              break;
            case level.severe:
              severeRisks.push(symptoms[position][_i3]);
              break;
            default:
              normalRisks.push(symptoms[position][_i3]);
              break;
          }
        }
      }

      this.normalRisks = this.sortHighToLow(normalRisks);
      this.mildRisks = this.sortHighToLow(mildRisks);
      this.severeRisks = this.sortHighToLow(severeRisks);
    },
    initRiskPoints: function initRiskPoints() {
      var that = this;
      var points = this.points;
      var photos = this.photos;
      var faceCanvas = document.createElement('canvas');
      var _this = this;

      // === 初始化正面数据 ===
      var facePointsArr = [];
      var face = points.face;
      var faceImg = new Image();

      // 人体骨架分组

      // 生成两个中点：1、左右骨盆连线中点； 2、骨盆中点和脖子连线的中点
      var hipRPoint = face['hip']['right'];
      var hipLPoint = face['hip']['left'];
      var neckPoint = face['neck'];
      var hipMPoint = {
        x: 0,
        y: 0
      };
      var hipAndNeckMPoint = {
        x: 0,
        y: 0
      };
      if (hipLPoint.x === 0 && hipLPoint.y === 0 || hipRPoint.x === 0 && hipRPoint.y === 0) {} else {
        // 计算左右骨盆连线中点
        hipMPoint.x = (hipLPoint.x + hipRPoint.x) / 2;
        hipMPoint.y = (hipLPoint.y + hipRPoint.y) / 2;

        // 计算骨盆中点和脖子连线的中点
        if (!(neckPoint.x === 0 && neckPoint.y === 0)) {
          hipAndNeckMPoint.x = (neckPoint.x + hipMPoint.x) / 2;
          hipAndNeckMPoint.y = (neckPoint.y + hipMPoint.y) / 2;
        }
      };

      face.hipM = hipMPoint;
      face.hipAndNeckM = hipAndNeckMPoint;

      var faceOrder = [['ear-right', 'eye-right', 'nose', 'eye-left', 'ear-left'], ['wrist-right', 'elbow-right', 'shoulder-right', 'neck', 'shoulder-left', 'elbow-left', 'wrist-left'],
      // ['ankle-right', 'knee-right', 'hip-right', 'neck', 'hip-left', 'knee-left', 'ankle-left'],
      ['ankle-right', 'knee-right', 'hip-right', 'hipM', 'hip-left', 'knee-left', 'ankle-left'], ['neck', 'hipAndNeckM', 'hipM'], ['nose', 'neck']];

      // 垂直标准线
      var verticalStandard = ['shoulder-right', 'ankle-middle', 'shoulder-left'];
      var verticalPointsArr = [];

      // 症状和位置对应
      var risks = this.normalRisks.concat(this.mildRisks, this.severeRisks);

      var faceSymptomWithPosition = ['headSidesway-ear', 'highLowShoulder-shoulder', 'spineSidesway', 'pelvisLean-hip', 'legO-knee', 'legX-knee', 'legXO-knee'];
      var faceHorizontalArr = [];

      for (var i = 0; i < faceSymptomWithPosition.length; i++) {
        var symptomWithPositionArr = faceSymptomWithPosition[i].split('-');
        var pointsAndAngle = {
          key: symptomWithPositionArr[0]
        };

        for (var j = 0; j < risks.length; j++) {
          if (risks[j].key === symptomWithPositionArr[0]) {
            if (!_.isUndefined(pointsAndAngle.raw)) {
              pointsAndAngle.secondRaw = risks[j].raw;
            } else {
              pointsAndAngle.raw = risks[j].raw;
              if (symptomWithPositionArr.length === 1) {
                pointsAndAngle.points = [face['elbow'].left];
              } else {
                pointsAndAngle.points = [face[symptomWithPositionArr[1]].right, face[symptomWithPositionArr[1]].left];
              }
            }
          }
        }

        if (_.isUndefined(pointsAndAngle.raw) || _.isUndefined(pointsAndAngle.points)) {
          continue;
        } else {
          faceHorizontalArr.push(pointsAndAngle);
        }
      }

      // 先将各分组数据点取出来
      for (var _i4 = 0; _i4 < faceOrder.length; _i4++) {
        var pointsArr = [];
        for (var _j = 0; _j < faceOrder[_i4].length; _j++) {
          var positionArr = faceOrder[_i4][_j].split('-');
          if (positionArr.length === 1) {
            pointsArr.push(face[positionArr[0]]);
          } else {
            pointsArr.push(face[positionArr[0]][positionArr[1]]);
          }
        }
        facePointsArr.push(pointsArr);
      }

      // 将垂直标准点取出来
      for (var _i5 = 0; _i5 < verticalStandard.length; _i5++) {
        var _positionArr = verticalStandard[_i5].split('-');

        // 该部分是含过 nose 的标准线
        // if(positionArr.length === 1) {
        //   verticalPointsArr.push(face[positionArr[0]]);
        // } else {
        //   verticalPointsArr.push(face[positionArr[0]][positionArr[1]])
        // }

        // 该部分是过两边足踝中点的标准线
        if (_positionArr[1] === 'middle') {
          if (face[_positionArr[0]].left.x === 0 && face[_positionArr[0]].left.y === 0 || face[_positionArr[0]].right.x === 0 && face[_positionArr[0]].right.y === 0) {
            verticalPointsArr.push({
              x: 0,
              y: 0
            });
          } else {
            verticalPointsArr.push({
              x: (face[_positionArr[0]].left.x + face[_positionArr[0]].right.x) / 2,
              y: 0
            });
          }
        } else {
          verticalPointsArr.push(face[_positionArr[0]][_positionArr[1]]);
        }
      }

      // 开始画图以及各点线
      faceImg.src = photos.face;
      faceImg.onload = function () {
        that.img.face = faceImg;
        // 将图片画进 canvas
        var width = faceImg.width;
        var height = faceImg.height;
        faceCanvas.width = width;
        faceCanvas.height = height;
        faceCanvas.style.width = '100%';

        var cxt = faceCanvas.getContext('2d');
        cxt.drawImage(faceImg, 0, 0, width, height);
        // 按分组画线
        for (var _i6 = 0; _i6 < facePointsArr.length; _i6++) {
          for (var _j2 = 0; _j2 < facePointsArr[_i6].length; _j2++) {
            if (_j2 === 0 || facePointsArr[_i6][_j2].x === 0 && facePointsArr[_i6][_j2].y === 0 || facePointsArr[_i6][_j2 - 1].x === 0 && facePointsArr[_i6][_j2 - 1].y === 0) {
              if (facePointsArr[_i6][_j2].x === 0 && facePointsArr[_i6][_j2].y === 0) {
                continue;
              } else {
                _this.drawPoint({
                  el: faceCanvas,
                  point: facePointsArr[_i6][_j2]
                });
                continue;
              }
            } else {
              _this.drawPoint({
                el: faceCanvas,
                point: facePointsArr[_i6][_j2]
              });
              _this.drawLine({
                el: faceCanvas,
                points: [facePointsArr[_i6][_j2], facePointsArr[_i6][_j2 - 1]]
              });
            }
          }
        }

        // 画垂直标准线
        for (var _i7 = 0; _i7 < verticalPointsArr.length; _i7++) {
          if (verticalPointsArr[_i7].x === 0 && verticalPointsArr[_i7].y === 0) {
            continue;
          } else {
            cxt.save();
            cxt.strokeStyle = '#4db664';
            cxt.beginPath();
            cxt.moveTo(verticalPointsArr[_i7].x, 0);
            cxt.lineTo(verticalPointsArr[_i7].x, height);
            cxt.closePath();
            cxt.stroke();
            cxt.restore();

            cxt.save();
            cxt.fillStyle = '#fe610f';
            cxt.font = '30px serif';
            var windowWidth = document.documentElement.clientWidth;
            var windowHeight = window.screen.height;
            var offsetHeight = (windowHeight - 125) / (windowWidth / width);
            if (_i7 === 0) {
              cxt.fillText('α', verticalPointsArr[_i7].x + 5, offsetHeight - 5);
            } else if (_i7 === verticalPointsArr.length - 1) {
              cxt.fillText('γ', verticalPointsArr[_i7].x + 5, offsetHeight - 5);
            } else {
              cxt.fillText('β', verticalPointsArr[_i7].x + 5, offsetHeight - 5);
            }
            cxt.restore();
          }
        }

        // 画水平线
        var min = 99999;
        var max = 0;
        var indexOfKneeArr = [];
        for (var _i8 = 0; _i8 < faceHorizontalArr.length; _i8++) {
          if (faceHorizontalArr[_i8].points.length !== 1) {
            if (faceHorizontalArr[_i8].points[0].x === 0 && faceHorizontalArr[_i8].points[0].y === 0 || faceHorizontalArr[_i8].points[1].x === 0 && faceHorizontalArr[_i8].points[1].y === 0) {
              continue;
            }
            if (faceHorizontalArr[_i8].points[0].x < min) {
              min = faceHorizontalArr[_i8].points[0].x;
            }
            if (faceHorizontalArr[_i8].points[1].x > max) {
              max = faceHorizontalArr[_i8].points[1].x;
            }
          }

          if (faceHorizontalArr[_i8].key === 'legX' || faceHorizontalArr[_i8].key === 'legO' || faceHorizontalArr[_i8].key === 'legXO') {
            indexOfKneeArr.push(_i8);
          }
        }

        // 将 x 型腿 和 O 型腿的角度合并在一起
        if (indexOfKneeArr.length === 2) {
          faceHorizontalArr[indexOfKneeArr[0]].secondRaw = faceHorizontalArr[indexOfKneeArr[1]].raw;
          faceHorizontalArr.splice(indexOfKneeArr[1], 1);
        }

        for (var _i9 = 0; _i9 < faceHorizontalArr.length; _i9++) {
          _this.drawLineAndAngle({
            el: faceCanvas,
            angle: faceHorizontalArr[_i9].raw,
            secondAngle: faceHorizontalArr[_i9].secondRaw,
            points: faceHorizontalArr[_i9].points,
            min: min,
            max: max
          });
        }

        _this.$nextTick(function () {
          document.getElementById('face').appendChild(faceCanvas);
        });
      };
    },
    drawPoint: function drawPoint(option) {
      var canvas = option.el;
      var point = option.point;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.fillStyle = '#009eff';
      cxt.beginPath();
      cxt.arc(point.x, point.y, 5, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
      cxt.save();
      cxt.fillStyle = 'rgba(83, 158, 255, .3)';
      cxt.beginPath();
      cxt.arc(point.x, point.y, 10, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
    },
    drawLine: function drawLine(option) {
      //console.log("option:",option)
      // 有一个点是x, y 都等于0的时候，不画线
      if (option.points[0].x === 0 && option.points[0].y === 0 || option.points[1].x === 0 && option.points[1].y === 0) {
        return;
      }
      var canvas = option.el;
      var points = option.points;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.lineWidth = 3;
      if (!option.isSide) {
        cxt.strokeStyle = '#5f58f4';
        cxt.beginPath();
        cxt.moveTo(points[0].x, points[0].y);
        cxt.lineTo(points[1].x, points[1].y);
        cxt.closePath();
        cxt.stroke();
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var z = Math.sqrt(Math.pow(_x, 2) + Math.pow(_y, 2));
        var startX = void 0;
        var startY = void 0;
        var endX = void 0;
        var endY = void 0;
        var distance = 80;

        if (points[0].x > points[1].x) {
          startX = Math.round(points[1].x - distance * _x / z);
          startY = Math.round(points[1].y + distance * _y / z);
          endX = Math.round(points[0].x + distance * _x / z);
          endY = Math.round(points[0].y - distance * _y / z);
        } else {
          startX = Math.round(points[0].x - distance * _x / z);
          startY = Math.round(points[0].y - distance * _y / z);
          endX = Math.round(points[1].x + distance * _x / z);
          endY = Math.round(points[1].y + distance * _y / z);
        }

        cxt.strokeStyle = '#0ef8cd';
        cxt.beginPath();
        cxt.moveTo(startX, startY);
        cxt.lineTo(endX, endY);
        cxt.closePath();
        cxt.stroke();
      }

      cxt.restore();
    },
    drawRectAndAngle: function drawRectAndAngle(option) {
      var cxt = option.cxt;
      var angle = option.angle;
      var point = option.point;

      cxt.save();
      if (option.isSecond) {
        cxt.translate(0, 43);
      }
      cxt.save();
      cxt.fillStyle = 'rgba(100, 100, 98, 0.5)';
      cxt.beginPath();
      cxt.moveTo(point.x + 13, point.y + 3);
      cxt.lineTo(point.x + 99, point.y + 3);
      cxt.quadraticCurveTo(point.x + 109, point.y + 3, point.x + 109, point.y + 13);
      cxt.lineTo(point.x + 109, point.y + 33);
      cxt.quadraticCurveTo(point.x + 109, point.y + 43, point.x + 99, point.y + 43);
      cxt.lineTo(point.x + 13, point.y + 43);
      cxt.quadraticCurveTo(point.x + 3, point.y + 43, point.x + 3, point.y + 33);
      cxt.lineTo(point.x + 3, point.y + 13);
      cxt.quadraticCurveTo(point.x + 3, point.y + 3, point.x + 13, point.y + 3);
      cxt.closePath();
      cxt.fill();
      cxt.restore();

      // 绘制角度
      cxt.save();
      cxt.font = '34px Arial';
      cxt.fillStyle = '#0cfcca';
      cxt.textAlign = 'center';
      if (option.isTrunk) {
        cxt.fillText(angle + '%', point.x + 56, point.y + 38);
      } else {
        cxt.fillText(angle + '\xB0', point.x + 56, point.y + 38);
      }
      cxt.restore();
      cxt.restore();
    },
    drawLineAndAngle: function drawLineAndAngle(option) {
      var canvas = option.el;
      var width = canvas.width;
      var points = option.points;
      var min = option.min - 100;
      var max = option.max + 100;
      var cxt = canvas.getContext('2d');

      // 如果有一个点不存在，则不画线
      for (var i = 0; i < points.length; i++) {
        if (points[i].x === 0 && points[i].y === 0) {
          return;
        }
      }

      // 此处画脊柱侧弯

      if (points.length === 1) {
        this.drawRectAndAngle({
          cxt: cxt,
          angle: (option.angle * 100).toFixed(1),
          point: {
            x: width - 120,
            y: points[0].y
          },
          isSecond: false,
          isTrunk: true
        });
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var startPoint = {};
        var endPoint = {};
        var offsetYL = Number(((points[0].x - min) * _y / _x).toFixed(0));
        var offsetYR = Number(((max - points[1].x) * _y / _x).toFixed(0));

        if (points[0].y < points[1].y) {
          startPoint.x = min;
          startPoint.y = points[0].y - offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y + offsetYR;
        } else {
          startPoint.x = min;
          startPoint.y = points[0].y + offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y - offsetYR;
        }

        cxt.save();
        cxt.strokeStyle = '#14bc9a';
        cxt.beginPath();
        cxt.moveTo(startPoint.x, startPoint.y);
        cxt.lineTo(endPoint.x, endPoint.y);
        cxt.closePath();
        cxt.stroke();
        cxt.restore();

        // 绘制圆角矩形框
        this.drawRectAndAngle({
          cxt: cxt,
          angle: option.angle.toFixed(1),
          point: {
            x: width - 120,
            y: points[1].y
          },
          isSecond: false
        });

        if (!_.isUndefined(option.secondAngle)) {
          this.drawRectAndAngle({
            cxt: cxt,
            angle: option.secondAngle.toFixed(1),
            point: {
              x: width - 120,
              y: points[1].y
            },
            isSecond: true
          });
        }
      }
    }
  },
  created: function created() {
    this.initRiskPoints();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_front.vue


//
//
//
//
//
//



/* harmony default export */ var components_Posture_front = ({
  name: 'Posture_front',
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {},
  props: ['severeRisks', 'mildRisks', 'normalRisks', 'points', 'photos'],
  data: function data() {
    return {
      img: {
        face: null,
        side: null
      }
    };
  },

  computed: {},
  methods: {
    getRiskImg: function getRiskImg(risk) {
      //.log("risk ==>" + JSON.stringify(risk))
      var direction = 'normal';
      var img = void 0;

      if (!_.isNull(risk.direction) && risk.key !== 'legO' && risk.key !== 'legX' && risk.key !== 'legXO' && risk.key !== 'kneeOverstretch') {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    setSymptomCanvasModal: function setSymptomCanvasModal(risk) {
      var points = this.points;
      var needDetail = ['legO', 'legX', 'legXO'];
      var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

      var riskKey = risk.key;
      var keyMap = this.keyMap;
      var positionArr = void 0;
      var positionPointsArr = [];
      var faceOrSide = void 0;
      var scale = void 0;

      keys_default()(keyMap).forEach(function (direction, index) {
        keys_default()(keyMap[direction]).forEach(function (key, index) {
          if (key === riskKey) {
            positionArr = keyMap[direction][key].position;
            scale = keyMap[direction][key].scale;
          }
        });
      });

      if (needDetail.indexOf(riskKey) !== -1) {
        // 当是 legO、legX、legXO 时
        var lOrR = void 0;
        if (risk.detail === '右腿') {
          lOrR = 'right';
        } else {
          lOrR = 'left';
        }

        for (var i = 0; i < positionArr.length; i++) {
          positionPointsArr.push(points.face[positionArr[i]][lOrR]);
        }

        faceOrSide = 'face';
      } else {
        // 正面，并且能取到左右时
        for (var _i = 0; _i < positionArr.length; _i++) {
          var positionAndDirectionArr = positionArr[_i].split('-');
          if (positionAndDirectionArr.length === 1) {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
          } else {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
          }
        }
        faceOrSide = 'face';
      }

      var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
      var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
      var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
      var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

      var width = _x > _y ? _x : _y;
      width *= 1 + scale;

      var x = xMid - width / 2;
      var y = yMid - width / 2;

      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.width = width;
      canvas.height = width;
      // let img = new Image();
      // img.src = this.photos[faceOrSide];

      var img = this.img[faceOrSide];

      ctx.drawImage(img, x, y, width, width, 0, 0, width, width);

      this.canvas = canvas;
    },
    setSymptomCanvas: function setSymptomCanvas(option) {
      var canvas = option.el;
      var ctx = canvas.getContext('2d');

      var points = this.points;
      var needDetail = ['legO', 'legX', 'legXO'];
      var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

      var riskKey = canvas.dataset.key;
      var keyMap = this.keyMap;
      var positionArr = void 0;
      var positionPointsArr = [];
      var faceOrSide = void 0;
      var scale = void 0;
      keys_default()(keyMap).forEach(function (direction, index) {
        keys_default()(keyMap[direction]).forEach(function (key, index) {
          if (key === riskKey) {
            positionArr = keyMap[direction][key].position;
            scale = keyMap[direction][key].scale;
          }
        });
      });

      if (needDetail.indexOf(riskKey) !== -1) {
        // 当是 legO、legX、legXO 时
        var lOrR = void 0;
        if (canvas.dataset.detail === '右腿') {
          lOrR = 'right';
        } else {
          lOrR = 'left';
        }

        for (var i = 0; i < positionArr.length; i++) {
          positionPointsArr.push(points.face[positionArr[i]][lOrR]);
        }

        faceOrSide = 'face';
      } else {
        // 正面，并且能取到左右时
        for (var _i2 = 0; _i2 < positionArr.length; _i2++) {
          var positionAndDirectionArr = positionArr[_i2].split('-');
          if (positionAndDirectionArr.length === 1) {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
          } else {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
          }
        }

        faceOrSide = 'face';
      }

      var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
      var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
      var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
      var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

      var width = _x > _y ? _x : _y;
      width *= 1 + scale;

      var x = xMid - width / 2;
      var y = yMid - width / 2;

      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.width = width;
      canvas.height = width;
      var img = new Image();
      img.src = this.photos[faceOrSide];
      // img.src = this.img[faceOrSide]
      img.onload = function () {
        ctx.drawImage(img, x, y, width, width, 0, 0, width, width);
      };
    },
    getLevel: function getLevel(level) {
      switch (level) {
        case this.level.normal:
          return {
            des: '低风险',
            className: 'level-normal'
          };
        case this.level.mild:
          return {
            des: '中风险',
            className: 'level-mild'
          };
        case this.level.severe:
          return {
            des: '高风险',
            className: 'level-severe'
          };
      }
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    sortHighToLow: function sortHighToLow(arr) {
      return _.orderBy(arr, ['value'], ['desc']);
    },
    initRiskBar: function initRiskBar() {
      this.$refs.riskModalRef.$el.getElementsByClassName('modal-content')[0].scrollTop = 0;
      var modalRiskBar = document.getElementById('modalRiskBar');
      canvas.initRiskLevel({
        el: modalRiskBar,
        width: Number(modalRiskBar.parentNode.offsetWidth),
        height: Number(modalRiskBar.parentNode.offsetHeight),
        color: {
          normal: '#00d963',
          mild: '#ffbf00',
          severe: '#ff4d4d'
        },
        level: this.level
      });
    },
    initRisksData: function initRisksData() {
      var risks = this.risks;
      var level = this.level;
      var symptoms = this.symptoms;
      var normalRisks = this.normalRisks;
      var mildRisks = this.mildRisks;
      var severeRisks = this.severeRisks;

      for (var direction in risks) {
        for (var i = 0; i < risks[direction].length; i++) {
          var symptom = symptoms[risks[direction][i].position][risks[direction][i].code - 1];

          if (symptom.value) {
            var otherSymptom = assign_default()({}, symptom);
            if (!risks[direction][i].valid) {
              otherSymptom.raw = 0;
              otherSymptom.value = 0;
              otherSymptom.level = level.normal;
              otherSymptom.detail = '';
              otherSymptom.direction = 'normal';
            } else {
              otherSymptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              otherSymptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              otherSymptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              otherSymptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
              otherSymptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
            }

            symptoms[risks[direction][i].position].push(otherSymptom);
          } else {
            if (!risks[direction][i].valid) {
              symptom.raw = 0;
              symptom.value = 0;
              symptom.level = level.normal;
              symptom.detail = '';
              symptom.direction = 'normal';
            } else {
              symptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              symptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              symptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              symptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
              symptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
            }
          }
        }
      }

      for (var position in symptoms) {
        for (var _i3 = 0; _i3 < symptoms[position].length; _i3++) {
          if (_.isUndefined(symptoms[position][_i3].value)) {
            continue;
          }
          switch (symptoms[position][_i3].level) {
            case level.normal:
              normalRisks.push(symptoms[position][_i3]);
              break;
            case level.mild:
              mildRisks.push(symptoms[position][_i3]);
              break;
            case level.severe:
              severeRisks.push(symptoms[position][_i3]);
              break;
            default:
              normalRisks.push(symptoms[position][_i3]);
              break;
          }
        }
      }

      this.normalRisks = this.sortHighToLow(normalRisks);
      this.mildRisks = this.sortHighToLow(mildRisks);
      this.severeRisks = this.sortHighToLow(severeRisks);
    },
    initRiskPoints: function initRiskPoints() {
      var that = this;
      var points = this.points;
      var photos = this.photos;
      var faceCanvas = document.createElement('canvas');
      var _this = this;

      // === 初始化正面数据 ===
      var facePointsArr = [];
      var face = points.face;
      var faceImg = new Image();

      // 人体骨架分组

      // 生成两个中点：1、左右骨盆连线中点； 2、骨盆中点和脖子连线的中点
      var hipRPoint = face['hip']['right'];
      var hipLPoint = face['hip']['left'];
      var neckPoint = face['neck'];
      var hipMPoint = {
        x: 0,
        y: 0
      };
      var hipAndNeckMPoint = {
        x: 0,
        y: 0
      };
      if (hipLPoint.x === 0 && hipLPoint.y === 0 || hipRPoint.x === 0 && hipRPoint.y === 0) {} else {
        // 计算左右骨盆连线中点
        hipMPoint.x = (hipLPoint.x + hipRPoint.x) / 2;
        hipMPoint.y = (hipLPoint.y + hipRPoint.y) / 2;

        // 计算骨盆中点和脖子连线的中点
        if (!(neckPoint.x === 0 && neckPoint.y === 0)) {
          hipAndNeckMPoint.x = (neckPoint.x + hipMPoint.x) / 2;
          hipAndNeckMPoint.y = (neckPoint.y + hipMPoint.y) / 2;
        }
      };

      face.hipM = hipMPoint;
      face.hipAndNeckM = hipAndNeckMPoint;

      var faceOrder = [['ear-right', 'eye-right', 'nose', 'eye-left', 'ear-left'], ['wrist-right', 'elbow-right', 'shoulder-right', 'neck', 'shoulder-left', 'elbow-left', 'wrist-left'],
      // ['ankle-right', 'knee-right', 'hip-right', 'neck', 'hip-left', 'knee-left', 'ankle-left'],
      ['ankle-right', 'knee-right', 'hip-right', 'hipM', 'hip-left', 'knee-left', 'ankle-left'], ['neck', 'hipAndNeckM', 'hipM'], ['nose', 'neck']];

      // 垂直标准线
      var verticalStandard = ['shoulder-right', 'ankle-middle', 'shoulder-left'];
      var verticalPointsArr = [];

      // 症状和位置对应
      var risks = this.normalRisks.concat(this.mildRisks, this.severeRisks);

      var faceSymptomWithPosition = ['headSidesway-ear', 'highLowShoulder-shoulder', 'spineSidesway', 'pelvisLean-hip', 'legO-knee', 'legX-knee', 'legXO-knee'];
      var faceHorizontalArr = [];

      for (var i = 0; i < faceSymptomWithPosition.length; i++) {
        var symptomWithPositionArr = faceSymptomWithPosition[i].split('-');
        var pointsAndAngle = {
          key: symptomWithPositionArr[0]
        };

        for (var j = 0; j < risks.length; j++) {
          if (risks[j].key === symptomWithPositionArr[0]) {
            if (!_.isUndefined(pointsAndAngle.raw)) {
              pointsAndAngle.secondRaw = risks[j].raw;
            } else {
              pointsAndAngle.raw = risks[j].raw;
              if (symptomWithPositionArr.length === 1) {
                pointsAndAngle.points = [face['elbow'].left];
              } else {
                pointsAndAngle.points = [face[symptomWithPositionArr[1]].right, face[symptomWithPositionArr[1]].left];
              }
            }
          }
        }

        if (_.isUndefined(pointsAndAngle.raw) || _.isUndefined(pointsAndAngle.points)) {
          continue;
        } else {
          faceHorizontalArr.push(pointsAndAngle);
        }
      }

      // 先将各分组数据点取出来
      for (var _i4 = 0; _i4 < faceOrder.length; _i4++) {
        var pointsArr = [];
        for (var _j = 0; _j < faceOrder[_i4].length; _j++) {
          var positionArr = faceOrder[_i4][_j].split('-');
          if (positionArr.length === 1) {
            pointsArr.push(face[positionArr[0]]);
          } else {
            pointsArr.push(face[positionArr[0]][positionArr[1]]);
          }
        }
        facePointsArr.push(pointsArr);
      }

      // 将垂直标准点取出来
      for (var _i5 = 0; _i5 < verticalStandard.length; _i5++) {
        var _positionArr = verticalStandard[_i5].split('-');

        // 该部分是含过 nose 的标准线
        // if(positionArr.length === 1) {
        //   verticalPointsArr.push(face[positionArr[0]]);
        // } else {
        //   verticalPointsArr.push(face[positionArr[0]][positionArr[1]])
        // }

        // 该部分是过两边足踝中点的标准线
        if (_positionArr[1] === 'middle') {
          if (face[_positionArr[0]].left.x === 0 && face[_positionArr[0]].left.y === 0 || face[_positionArr[0]].right.x === 0 && face[_positionArr[0]].right.y === 0) {
            verticalPointsArr.push({
              x: 0,
              y: 0
            });
          } else {
            verticalPointsArr.push({
              x: (face[_positionArr[0]].left.x + face[_positionArr[0]].right.x) / 2,
              y: 0
            });
          }
        } else {
          verticalPointsArr.push(face[_positionArr[0]][_positionArr[1]]);
        }
      }

      // 开始画图以及各点线
      faceImg.src = photos.face;
      faceImg.onload = function () {
        that.img.face = faceImg;
        // 将图片画进 canvas
        var width = faceImg.width;
        var height = faceImg.height;
        faceCanvas.width = width;
        faceCanvas.height = height;
        faceCanvas.style.width = '100%';

        var cxt = faceCanvas.getContext('2d');
        cxt.drawImage(faceImg, 0, 0, width, height);
        // 按分组画线
        for (var _i6 = 0; _i6 < facePointsArr.length; _i6++) {
          for (var _j2 = 0; _j2 < facePointsArr[_i6].length; _j2++) {
            if (_j2 === 0 || facePointsArr[_i6][_j2].x === 0 && facePointsArr[_i6][_j2].y === 0 || facePointsArr[_i6][_j2 - 1].x === 0 && facePointsArr[_i6][_j2 - 1].y === 0) {
              if (facePointsArr[_i6][_j2].x === 0 && facePointsArr[_i6][_j2].y === 0) {
                continue;
              } else {
                _this.drawPoint({
                  el: faceCanvas,
                  point: facePointsArr[_i6][_j2]
                });
                continue;
              }
            } else {
              _this.drawPoint({
                el: faceCanvas,
                point: facePointsArr[_i6][_j2]
              });
              _this.drawLine({
                el: faceCanvas,
                points: [facePointsArr[_i6][_j2], facePointsArr[_i6][_j2 - 1]]
              });
            }
          }
        }

        // 画垂直标准线
        for (var _i7 = 0; _i7 < verticalPointsArr.length; _i7++) {
          if (verticalPointsArr[_i7].x === 0 && verticalPointsArr[_i7].y === 0) {
            continue;
          } else {
            cxt.save();
            cxt.strokeStyle = '#4db664';
            cxt.beginPath();
            cxt.moveTo(verticalPointsArr[_i7].x, 0);
            cxt.lineTo(verticalPointsArr[_i7].x, height);
            cxt.closePath();
            cxt.stroke();
            cxt.restore();

            cxt.save();
            cxt.fillStyle = '#fe610f';
            cxt.font = '30px serif';
            var windowWidth = document.documentElement.clientWidth;
            var windowHeight = window.screen.height;
            var offsetHeight = (windowHeight - 125) / (windowWidth / width);
            if (_i7 === 0) {
              cxt.fillText('α', verticalPointsArr[_i7].x + 5, offsetHeight - 5);
            } else if (_i7 === verticalPointsArr.length - 1) {
              cxt.fillText('γ', verticalPointsArr[_i7].x + 5, offsetHeight - 5);
            } else {
              cxt.fillText('β', verticalPointsArr[_i7].x + 5, offsetHeight - 5);
            }
            cxt.restore();
          }
        }

        // 画水平线
        var min = 99999;
        var max = 0;
        var indexOfKneeArr = [];
        for (var _i8 = 0; _i8 < faceHorizontalArr.length; _i8++) {
          if (faceHorizontalArr[_i8].points.length !== 1) {
            if (faceHorizontalArr[_i8].points[0].x === 0 && faceHorizontalArr[_i8].points[0].y === 0 || faceHorizontalArr[_i8].points[1].x === 0 && faceHorizontalArr[_i8].points[1].y === 0) {
              continue;
            }
            if (faceHorizontalArr[_i8].points[0].x < min) {
              min = faceHorizontalArr[_i8].points[0].x;
            }
            if (faceHorizontalArr[_i8].points[1].x > max) {
              max = faceHorizontalArr[_i8].points[1].x;
            }
          }

          if (faceHorizontalArr[_i8].key === 'legX' || faceHorizontalArr[_i8].key === 'legO' || faceHorizontalArr[_i8].key === 'legXO') {
            indexOfKneeArr.push(_i8);
          }
        }

        // 将 x 型腿 和 O 型腿的角度合并在一起
        if (indexOfKneeArr.length === 2) {
          faceHorizontalArr[indexOfKneeArr[0]].secondRaw = faceHorizontalArr[indexOfKneeArr[1]].raw;
          faceHorizontalArr.splice(indexOfKneeArr[1], 1);
        }

        for (var _i9 = 0; _i9 < faceHorizontalArr.length; _i9++) {
          _this.drawLineAndAngle({
            el: faceCanvas,
            angle: faceHorizontalArr[_i9].raw,
            secondAngle: faceHorizontalArr[_i9].secondRaw,
            points: faceHorizontalArr[_i9].points,
            min: min,
            max: max
          });
        }

        _this.$nextTick(function () {
          document.getElementById('face').appendChild(faceCanvas);
        });
      };
    },
    drawPoint: function drawPoint(option) {
      var canvas = option.el;
      var point = option.point;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.fillStyle = '#009eff';
      cxt.beginPath();
      cxt.arc(point.x, point.y, 5, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
      cxt.save();
      cxt.fillStyle = 'rgba(83, 158, 255, .3)';
      cxt.beginPath();
      cxt.arc(point.x, point.y, 10, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
    },
    drawLine: function drawLine(option) {
      //console.log("option:",option)
      // 有一个点是x, y 都等于0的时候，不画线
      if (option.points[0].x === 0 && option.points[0].y === 0 || option.points[1].x === 0 && option.points[1].y === 0) {
        return;
      }
      var canvas = option.el;
      var points = option.points;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.lineWidth = 3;
      if (!option.isSide) {
        cxt.strokeStyle = '#5f58f4';
        cxt.beginPath();
        cxt.moveTo(points[0].x, points[0].y);
        cxt.lineTo(points[1].x, points[1].y);
        cxt.closePath();
        cxt.stroke();
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var z = Math.sqrt(Math.pow(_x, 2) + Math.pow(_y, 2));
        var startX = void 0;
        var startY = void 0;
        var endX = void 0;
        var endY = void 0;
        var distance = 80;

        if (points[0].x > points[1].x) {
          startX = Math.round(points[1].x - distance * _x / z);
          startY = Math.round(points[1].y + distance * _y / z);
          endX = Math.round(points[0].x + distance * _x / z);
          endY = Math.round(points[0].y - distance * _y / z);
        } else {
          startX = Math.round(points[0].x - distance * _x / z);
          startY = Math.round(points[0].y - distance * _y / z);
          endX = Math.round(points[1].x + distance * _x / z);
          endY = Math.round(points[1].y + distance * _y / z);
        }

        cxt.strokeStyle = '#0ef8cd';
        cxt.beginPath();
        cxt.moveTo(startX, startY);
        cxt.lineTo(endX, endY);
        cxt.closePath();
        cxt.stroke();
      }

      cxt.restore();
    },
    drawRectAndAngle: function drawRectAndAngle(option) {
      var cxt = option.cxt;
      var angle = option.angle;
      var point = option.point;

      cxt.save();
      if (option.isSecond) {
        cxt.translate(0, 43);
      }
      cxt.save();
      cxt.fillStyle = 'rgba(100, 100, 98, 0.5)';
      cxt.beginPath();
      cxt.moveTo(point.x + 13, point.y + 3);
      cxt.lineTo(point.x + 99, point.y + 3);
      cxt.quadraticCurveTo(point.x + 109, point.y + 3, point.x + 109, point.y + 13);
      cxt.lineTo(point.x + 109, point.y + 33);
      cxt.quadraticCurveTo(point.x + 109, point.y + 43, point.x + 99, point.y + 43);
      cxt.lineTo(point.x + 13, point.y + 43);
      cxt.quadraticCurveTo(point.x + 3, point.y + 43, point.x + 3, point.y + 33);
      cxt.lineTo(point.x + 3, point.y + 13);
      cxt.quadraticCurveTo(point.x + 3, point.y + 3, point.x + 13, point.y + 3);
      cxt.closePath();
      cxt.fill();
      cxt.restore();

      // 绘制角度
      cxt.save();
      cxt.font = '34px Arial';
      cxt.fillStyle = '#0cfcca';
      cxt.textAlign = 'center';
      if (option.isTrunk) {
        cxt.fillText(angle + '%', point.x + 56, point.y + 38);
      } else {
        cxt.fillText(angle + '\xB0', point.x + 56, point.y + 38);
      }
      cxt.restore();
      cxt.restore();
    },
    drawLineAndAngle: function drawLineAndAngle(option) {
      var canvas = option.el;
      var width = canvas.width;
      var points = option.points;
      var min = option.min - 100;
      var max = option.max + 100;
      var cxt = canvas.getContext('2d');

      // 如果有一个点不存在，则不画线
      for (var i = 0; i < points.length; i++) {
        if (points[i].x === 0 && points[i].y === 0) {
          return;
        }
      }

      // 此处画脊柱侧弯

      if (points.length === 1) {
        this.drawRectAndAngle({
          cxt: cxt,
          angle: (option.angle * 100).toFixed(1),
          point: {
            x: width - 120,
            y: points[0].y
          },
          isSecond: false,
          isTrunk: true
        });
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var startPoint = {};
        var endPoint = {};
        var offsetYL = Number(((points[0].x - min) * _y / _x).toFixed(0));
        var offsetYR = Number(((max - points[1].x) * _y / _x).toFixed(0));

        if (points[0].y < points[1].y) {
          startPoint.x = min;
          startPoint.y = points[0].y - offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y + offsetYR;
        } else {
          startPoint.x = min;
          startPoint.y = points[0].y + offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y - offsetYR;
        }

        cxt.save();
        cxt.strokeStyle = '#14bc9a';
        cxt.beginPath();
        cxt.moveTo(startPoint.x, startPoint.y);
        cxt.lineTo(endPoint.x, endPoint.y);
        cxt.closePath();
        cxt.stroke();
        cxt.restore();

        // 绘制圆角矩形框
        this.drawRectAndAngle({
          cxt: cxt,
          angle: option.angle.toFixed(1),
          point: {
            x: width - 120,
            y: points[1].y
          },
          isSecond: false
        });

        if (!_.isUndefined(option.secondAngle)) {
          this.drawRectAndAngle({
            cxt: cxt,
            angle: option.secondAngle.toFixed(1),
            point: {
              x: width - 120,
              y: points[1].y
            },
            isSecond: true
          });
        }
      }
    }
  },
  created: function created() {
    this.initRiskPoints();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b012ef2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_front.vue
var Posture_front_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var Posture_front_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", {
        staticStyle: { height: "100%", overflow: "hidden" },
        attrs: { id: "face" }
      })
    ])
  }
]
Posture_front_render._withStripped = true
var Posture_front_esExports = { render: Posture_front_render, staticRenderFns: Posture_front_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Posture_front = (Posture_front_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b012ef2", Posture_front_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Posture_front.vue
var Posture_front_disposed = false
function Posture_front_injectStyle (ssrContext) {
  if (Posture_front_disposed) return
  __webpack_require__("vO9O")
}
var Posture_front_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Posture_front___vue_template_functional__ = false
/* styles */
var Posture_front___vue_styles__ = Posture_front_injectStyle
/* scopeId */
var Posture_front___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Posture_front___vue_module_identifier__ = null
var Posture_front_Component = Posture_front_normalizeComponent(
  components_Posture_front,
  selectortype_template_index_0_src_components_Posture_front,
  Posture_front___vue_template_functional__,
  Posture_front___vue_styles__,
  Posture_front___vue_scopeId__,
  Posture_front___vue_module_identifier__
)
Posture_front_Component.options.__file = "src/components/Posture_front.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4b012ef2", Posture_front_Component.options)
  } else {
    hotAPI.reload("data-v-4b012ef2", Posture_front_Component.options)
  }
  module.hot.dispose(function (data) {
    Posture_front_disposed = true
  })
})()}

/* harmony default export */ var src_components_Posture_front = (Posture_front_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_flank.vue


//
//
//
//
//
//




/* harmony default export */ var Posture_flank = ({
  name: 'Posture_flank',
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {},
  props: ['severeRisks', 'mildRisks', 'normalRisks', 'points', 'photos'],
  data: function data() {
    return {
      img: {
        face: null,
        side: null
      }
    };
  },

  computed: {},
  methods: {
    getRiskImg: function getRiskImg(risk) {
      //.log("risk ==>" + JSON.stringify(risk))
      var direction = 'normal';
      var img = void 0;

      if (!_.isNull(risk.direction) && risk.key !== 'legO' && risk.key !== 'legX' && risk.key !== 'legXO' && risk.key !== 'kneeOverstretch') {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    setSymptomCanvasModal: function setSymptomCanvasModal(risk) {
      var points = this.points;
      var needDetail = ['legO', 'legX', 'legXO'];
      var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

      var riskKey = risk.key;
      var keyMap = this.keyMap;
      var positionArr = void 0;
      var positionPointsArr = [];
      var faceOrSide = void 0;
      var scale = void 0;

      keys_default()(keyMap).forEach(function (direction, index) {
        keys_default()(keyMap[direction]).forEach(function (key, index) {
          if (key === riskKey) {
            positionArr = keyMap[direction][key].position;
            scale = keyMap[direction][key].scale;
          }
        });
      });

      if (needDetail.indexOf(riskKey) !== -1) {
        // 当是 legO、legX、legXO 时
        var lOrR = void 0;
        if (risk.detail === '右腿') {
          lOrR = 'right';
        } else {
          lOrR = 'left';
        }

        for (var i = 0; i < positionArr.length; i++) {
          positionPointsArr.push(points.face[positionArr[i]][lOrR]);
        }

        faceOrSide = 'face';
      } else if (forSide.indexOf(riskKey) !== -1) {
        // 当是侧面时
        var _lOrR = this.conclusion.side.side;

        for (var _i = 0; _i < positionArr.length; _i++) {

          if (points.side[positionArr[_i]].left === undefined) {

            positionPointsArr.push(points.side[positionArr[_i]]);
          } else {
            positionPointsArr.push(points.side[positionArr[_i]][_lOrR]);
          }
        }

        faceOrSide = 'side';
      } else {
        // 正面，并且能取到左右时
        for (var _i2 = 0; _i2 < positionArr.length; _i2++) {
          var positionAndDirectionArr = positionArr[_i2].split('-');
          if (positionAndDirectionArr.length === 1) {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
          } else {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
          }
        }

        faceOrSide = 'face';
      }

      var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
      var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
      var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
      var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

      var width = _x > _y ? _x : _y;
      width *= 1 + scale;

      var x = xMid - width / 2;
      var y = yMid - width / 2;

      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.width = width;
      canvas.height = width;
      // let img = new Image();
      // img.src = this.photos[faceOrSide];

      var img = this.img[faceOrSide];

      ctx.drawImage(img, x, y, width, width, 0, 0, width, width);

      this.canvas = canvas;
    },
    setSymptomCanvas: function setSymptomCanvas(option) {
      var canvas = option.el;
      var ctx = canvas.getContext('2d');

      var points = this.points;
      var needDetail = ['legO', 'legX', 'legXO'];
      var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

      var riskKey = canvas.dataset.key;
      var keyMap = this.keyMap;
      var positionArr = void 0;
      var positionPointsArr = [];
      var faceOrSide = void 0;
      var scale = void 0;
      keys_default()(keyMap).forEach(function (direction, index) {
        keys_default()(keyMap[direction]).forEach(function (key, index) {
          if (key === riskKey) {
            positionArr = keyMap[direction][key].position;
            scale = keyMap[direction][key].scale;
          }
        });
      });

      if (needDetail.indexOf(riskKey) !== -1) {
        // 当是 legO、legX、legXO 时
        var lOrR = void 0;
        if (canvas.dataset.detail === '右腿') {
          lOrR = 'right';
        } else {
          lOrR = 'left';
        }

        for (var i = 0; i < positionArr.length; i++) {
          positionPointsArr.push(points.face[positionArr[i]][lOrR]);
        }

        faceOrSide = 'facet';
      } else if (forSide.indexOf(riskKey) !== -1) {
        // 当是侧面时
        var _lOrR2 = this.conclusion.side.side;

        for (var _i3 = 0; _i3 < positionArr.length; _i3++) {

          if (points.side[positionArr[_i3]].left === undefined) {

            positionPointsArr.push(points.side[positionArr[_i3]]);
          } else {
            positionPointsArr.push(points.side[positionArr[_i3]][_lOrR2]);
          }
        }

        faceOrSide = 'side';
      } else {
        // 正面，并且能取到左右时
        for (var _i4 = 0; _i4 < positionArr.length; _i4++) {
          var positionAndDirectionArr = positionArr[_i4].split('-');
          if (positionAndDirectionArr.length === 1) {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
          } else {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
          }
        }

        faceOrSide = 'facet';
      }

      var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
      var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
      var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
      var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

      var width = _x > _y ? _x : _y;
      width *= 1 + scale;

      var x = xMid - width / 2;
      var y = yMid - width / 2;

      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.width = width;
      canvas.height = width;
      var img = new Image();
      img.src = this.photos[faceOrSide];
      // img.src = this.img[faceOrSide]
      img.onload = function () {
        ctx.drawImage(img, x, y, width, width, 0, 0, width, width);
      };
    },
    getLevel: function getLevel(level) {
      switch (level) {
        case this.level.normal:
          return {
            des: '低风险',
            className: 'level-normal'
          };
        case this.level.mild:
          return {
            des: '中风险',
            className: 'level-mild'
          };
        case this.level.severe:
          return {
            des: '高风险',
            className: 'level-severe'
          };
      }
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    sortHighToLow: function sortHighToLow(arr) {
      return _.orderBy(arr, ['value'], ['desc']);
    },
    initRiskBar: function initRiskBar() {
      this.$refs.riskModalRef.$el.getElementsByClassName('modal-content')[0].scrollTop = 0;
      var modalRiskBar = document.getElementById('modalRiskBar');
      canvas.initRiskLevel({
        el: modalRiskBar,
        width: Number(modalRiskBar.parentNode.offsetWidth),
        height: Number(modalRiskBar.parentNode.offsetHeight),
        color: {
          normal: '#00d963',
          mild: '#ffbf00',
          severe: '#ff4d4d'
        },
        level: this.level
      });
    },
    initRisksData: function initRisksData() {
      var risks = this.risks;
      var level = this.level;
      var symptoms = this.symptoms;
      var normalRisks = this.normalRisks;
      var mildRisks = this.mildRisks;
      var severeRisks = this.severeRisks;

      for (var direction in risks) {
        for (var i = 0; i < risks[direction].length; i++) {
          var symptom = symptoms[risks[direction][i].position][risks[direction][i].code - 1];

          if (symptom.value) {
            var otherSymptom = assign_default()({}, symptom);
            if (!risks[direction][i].valid) {
              otherSymptom.raw = 0;
              otherSymptom.value = 0;
              otherSymptom.level = level.normal;
              otherSymptom.detail = '';
              otherSymptom.direction = 'normal';
            } else {
              otherSymptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              otherSymptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              otherSymptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              otherSymptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
              otherSymptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
            }

            symptoms[risks[direction][i].position].push(otherSymptom);
          } else {
            if (!risks[direction][i].valid) {
              symptom.raw = 0;
              symptom.value = 0;
              symptom.level = level.normal;
              symptom.detail = '';
              symptom.direction = 'normal';
            } else {
              symptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              symptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              symptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              symptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
              symptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
            }
          }
        }
      }

      for (var position in symptoms) {
        for (var _i5 = 0; _i5 < symptoms[position].length; _i5++) {
          if (_.isUndefined(symptoms[position][_i5].value)) {
            continue;
          }
          switch (symptoms[position][_i5].level) {
            case level.normal:
              normalRisks.push(symptoms[position][_i5]);
              break;
            case level.mild:
              mildRisks.push(symptoms[position][_i5]);
              break;
            case level.severe:
              severeRisks.push(symptoms[position][_i5]);
              break;
            default:
              normalRisks.push(symptoms[position][_i5]);
              break;
          }
        }
      }

      this.normalRisks = this.sortHighToLow(normalRisks);
      this.mildRisks = this.sortHighToLow(mildRisks);
      this.severeRisks = this.sortHighToLow(severeRisks);
    },
    initRiskPoints: function initRiskPoints() {
      var that = this;
      var points = this.points;
      var photos = this.photos;
      var faceCanvas = document.createElement('canvas');
      var sideCanvas = document.createElement('canvas');
      var _this = this;
      var risks = this.normalRisks.concat(this.mildRisks, this.severeRisks);

      // === 初始化侧面数据 ===
      var side = points.side;
      var sidePointsArr = [];
      var sideImg = new Image();

      // 人体骨架分组
      var lOrR = side.side;
      var sideOrder = [['ankle-' + lOrR, 'knee-' + lOrR, 'hip-' + lOrR, 'shoulder-' + lOrR,
      // `neck`,
      'elbow-' + lOrR, 'wrist-' + lOrR], [
      //`neck`,
      'shoulder-' + lOrR, //新增
      'ear-' + lOrR, 'eye-' + lOrR, 'nose']];
      ////console.log('side order:',sideOrder)
      // 垂直标准线
      var sideVerticalStandard = ['ankle-' + lOrR, 'nose'];
      var sideVerticalPointsArr = [];

      // 先将各分组数据点取出来
      for (var i = 0; i < sideOrder.length; i++) {
        var pointsArr = [];
        for (var j = 0; j < sideOrder[i].length; j++) {
          var positionArr = sideOrder[i][j].split('-');
          if (positionArr.length === 1) {
            pointsArr.push(side[positionArr[0]]);
          } else {
            pointsArr.push(side[positionArr[0]][positionArr[1]]);
          }
        }
        sidePointsArr.push(pointsArr);
      }

      // 将垂直标准点取出来
      for (var _i6 = 0; _i6 < sideVerticalStandard.length; _i6++) {
        var _positionArr = sideVerticalStandard[_i6].split('-');
        if (_positionArr.length === 1) {
          sideVerticalPointsArr.push(side[_positionArr[0]]);
        } else {
          sideVerticalPointsArr.push(side[_positionArr[0]][_positionArr[1]]);
        }
      }

      // 症状和位置对应
      var sideSymptomWithPosition = ['ear-shoulder', 'hip-knee'];
      var sideHorizontalArr = [];

      for (var _i7 = 0; _i7 < sideSymptomWithPosition.length; _i7++) {
        var horizontalArr = [];
        var _positionArr2 = sideSymptomWithPosition[_i7].split('-');
        for (var _j = 0; _j < _positionArr2.length; _j++) {
          horizontalArr.push(side[_positionArr2[_j]][lOrR]);
        }
        sideHorizontalArr.push(horizontalArr);
      }

      // 取出需要显示度数的症状
      var sideSymptomWithAngle = ['headLean', 'roundShoulder', 'kneeOverstretch'];
      var sideSymptomWithAngleRisk = [];

      for (var _i8 = 0; _i8 < sideSymptomWithAngle.length; _i8++) {
        for (var _j2 = 0; _j2 < risks.length; _j2++) {
          if (risks[_j2].key === sideSymptomWithAngle[_i8]) {
            sideSymptomWithAngleRisk.push(risks[_j2]);
          }
        }
      }

      //console.log("sideImg.src:that.img",that.img)

      // 开始画图以及各点线
      sideImg.src = photos.side;
      sideImg.onload = function () {
        that.img.side = sideImg;
        // 将图片画进 canvas
        var width = sideImg.width;
        var height = sideImg.height;
        sideCanvas.width = width;
        sideCanvas.height = height;
        sideCanvas.style.width = '100%';

        var cxt = sideCanvas.getContext('2d');
        cxt.drawImage(sideImg, 0, 0, width, height);

        // 按分组画线
        for (var _i9 = 0; _i9 < sidePointsArr.length; _i9++) {
          for (var _j3 = 0; _j3 < sidePointsArr[_i9].length; _j3++) {

            if (_j3 === 0 || sidePointsArr[_i9][_j3].x === 0 && sidePointsArr[_i9][_j3].y === 0 || sidePointsArr[_i9][_j3 - 1].x === 0 && sidePointsArr[_i9][_j3 - 1].y === 0) {
              if (sidePointsArr[_i9][_j3].x === 0 && sidePointsArr[_i9][_j3].y === 0) {
                continue;
              } /*else if ( j == 0) {
                    }*/else {
                  _this.drawPoint({
                    el: sideCanvas,
                    point: sidePointsArr[_i9][_j3]
                  });
                  continue;
                }
            } else {
              _this.drawPoint({
                el: sideCanvas,
                point: sidePointsArr[_i9][_j3]
              });
              if (_j3 != 3) {
                _this.drawLine({

                  el: sideCanvas,
                  points: [sidePointsArr[_i9][_j3], sidePointsArr[_i9][_j3 - 1]]
                });
              }
            }
          }
        }

        // 画垂直标准线
        for (var _i10 = 0; _i10 < sideVerticalPointsArr.length; _i10++) {
          if (sideVerticalPointsArr[_i10].x === 0 && sideVerticalPointsArr[_i10].y === 0) {
            continue;
          } else {
            cxt.save();
            cxt.strokeStyle = '#4db664';
            cxt.beginPath();
            cxt.moveTo(sideVerticalPointsArr[_i10].x, 0);
            cxt.lineTo(sideVerticalPointsArr[_i10].x, height);
            cxt.closePath();
            cxt.stroke();
            cxt.restore();

            cxt.save();
            cxt.fillStyle = '#fe610f';
            cxt.font = '30px serif';
            var windowWidth = document.documentElement.clientWidth;
            var windowHeight = window.screen.height;
            var offsetHeight = (windowHeight - 125) / (windowWidth / width);
            if (_i10 === 0) {
              cxt.fillText('α', sideVerticalPointsArr[_i10].x + 5, offsetHeight - 5);
            } else {
              cxt.fillText('β', sideVerticalPointsArr[_i10].x + 5, offsetHeight - 5);
            }
            cxt.restore();
          }
        }

        // 画斜线
        for (var _i11 = 0; _i11 < sideHorizontalArr.length; _i11++) {
          _this.drawLine({
            el: sideCanvas,
            points: sideHorizontalArr[_i11],
            isSide: true
          });
        }

        // 画症状度数
        for (var _i12 = 0; _i12 < sideSymptomWithAngleRisk.length; _i12++) {
          _this.drawRectAndAngle({
            cxt: cxt,
            angle: sideSymptomWithAngleRisk[_i12].raw.toFixed(1),
            point: {
              x: width - 120,
              y: height * 0.2 * (_i12 + 1)
            }
          });
        }

        _this.$nextTick(function () {
          document.getElementById('side').appendChild(sideCanvas);
        });
      };
    },
    drawPoint: function drawPoint(option) {
      var canvas = option.el;
      var point = option.point;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.fillStyle = '#009eff';
      cxt.beginPath();
      cxt.arc(point.x, point.y, 5, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
      cxt.save();
      cxt.fillStyle = 'rgba(83, 158, 255, .3)';
      cxt.beginPath();
      cxt.arc(point.x, point.y, 10, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
    },
    drawLine: function drawLine(option) {
      //console.log("option:",option)
      // 有一个点是x, y 都等于0的时候，不画线
      if (option.points[0].x === 0 && option.points[0].y === 0 || option.points[1].x === 0 && option.points[1].y === 0) {
        return;
      }
      var canvas = option.el;
      var points = option.points;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.lineWidth = 3;
      if (!option.isSide) {
        cxt.strokeStyle = '#5f58f4';
        cxt.beginPath();
        cxt.moveTo(points[0].x, points[0].y);
        cxt.lineTo(points[1].x, points[1].y);
        cxt.closePath();
        cxt.stroke();
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var z = Math.sqrt(Math.pow(_x, 2) + Math.pow(_y, 2));
        var startX = void 0;
        var startY = void 0;
        var endX = void 0;
        var endY = void 0;
        var distance = 80;

        if (points[0].x > points[1].x) {
          startX = Math.round(points[1].x - distance * _x / z);
          startY = Math.round(points[1].y + distance * _y / z);
          endX = Math.round(points[0].x + distance * _x / z);
          endY = Math.round(points[0].y - distance * _y / z);
        } else {
          startX = Math.round(points[0].x - distance * _x / z);
          startY = Math.round(points[0].y - distance * _y / z);
          endX = Math.round(points[1].x + distance * _x / z);
          endY = Math.round(points[1].y + distance * _y / z);
        }

        cxt.strokeStyle = '#0ef8cd';
        cxt.beginPath();
        cxt.moveTo(startX, startY);
        cxt.lineTo(endX, endY);
        cxt.closePath();
        cxt.stroke();
      }

      cxt.restore();
    },
    drawRectAndAngle: function drawRectAndAngle(option) {
      var cxt = option.cxt;
      var angle = option.angle;
      var point = option.point;

      cxt.save();
      if (option.isSecond) {
        cxt.translate(0, 43);
      }
      cxt.save();
      cxt.fillStyle = 'rgba(100, 100, 98, 0.5)';
      cxt.beginPath();
      cxt.moveTo(point.x + 13, point.y + 3);
      cxt.lineTo(point.x + 99, point.y + 3);
      cxt.quadraticCurveTo(point.x + 109, point.y + 3, point.x + 109, point.y + 13);
      cxt.lineTo(point.x + 109, point.y + 33);
      cxt.quadraticCurveTo(point.x + 109, point.y + 43, point.x + 99, point.y + 43);
      cxt.lineTo(point.x + 13, point.y + 43);
      cxt.quadraticCurveTo(point.x + 3, point.y + 43, point.x + 3, point.y + 33);
      cxt.lineTo(point.x + 3, point.y + 13);
      cxt.quadraticCurveTo(point.x + 3, point.y + 3, point.x + 13, point.y + 3);
      cxt.closePath();
      cxt.fill();
      cxt.restore();

      // 绘制角度
      cxt.save();
      cxt.font = '34px Arial';
      cxt.fillStyle = '#0cfcca';
      cxt.textAlign = 'center';
      if (option.isTrunk) {
        cxt.fillText(angle + '%', point.x + 56, point.y + 38);
      } else {
        cxt.fillText(angle + '\xB0', point.x + 56, point.y + 38);
      }
      cxt.restore();
      cxt.restore();
    },
    drawLineAndAngle: function drawLineAndAngle(option) {
      var canvas = option.el;
      var width = canvas.width;
      var points = option.points;
      var min = option.min - 100;
      var max = option.max + 100;
      var cxt = canvas.getContext('2d');

      // 如果有一个点不存在，则不画线
      for (var i = 0; i < points.length; i++) {
        if (points[i].x === 0 && points[i].y === 0) {
          return;
        }
      }

      // 此处画脊柱侧弯

      if (points.length === 1) {
        this.drawRectAndAngle({
          cxt: cxt,
          angle: (option.angle * 100).toFixed(1),
          point: {
            x: width - 120,
            y: points[0].y
          },
          isSecond: false,
          isTrunk: true
        });
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var startPoint = {};
        var endPoint = {};
        var offsetYL = Number(((points[0].x - min) * _y / _x).toFixed(0));
        var offsetYR = Number(((max - points[1].x) * _y / _x).toFixed(0));

        if (points[0].y < points[1].y) {
          startPoint.x = min;
          startPoint.y = points[0].y - offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y + offsetYR;
        } else {
          startPoint.x = min;
          startPoint.y = points[0].y + offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y - offsetYR;
        }

        cxt.save();
        cxt.strokeStyle = '#14bc9a';
        cxt.beginPath();
        cxt.moveTo(startPoint.x, startPoint.y);
        cxt.lineTo(endPoint.x, endPoint.y);
        cxt.closePath();
        cxt.stroke();
        cxt.restore();

        // 绘制圆角矩形框
        this.drawRectAndAngle({
          cxt: cxt,
          angle: option.angle.toFixed(1),
          point: {
            x: width - 120,
            y: points[1].y
          },
          isSecond: false
        });

        if (!_.isUndefined(option.secondAngle)) {
          this.drawRectAndAngle({
            cxt: cxt,
            angle: option.secondAngle.toFixed(1),
            point: {
              x: width - 120,
              y: points[1].y
            },
            isSecond: true
          });
        }
      }
    }
  },
  created: function created() {
    this.initRiskPoints();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_flank.vue


//
//
//
//
//
//




/* harmony default export */ var components_Posture_flank = ({
  name: 'Posture_flank',
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {},
  props: ['severeRisks', 'mildRisks', 'normalRisks', 'points', 'photos'],
  data: function data() {
    return {
      img: {
        face: null,
        side: null
      }
    };
  },

  computed: {},
  methods: {
    getRiskImg: function getRiskImg(risk) {
      //.log("risk ==>" + JSON.stringify(risk))
      var direction = 'normal';
      var img = void 0;

      if (!_.isNull(risk.direction) && risk.key !== 'legO' && risk.key !== 'legX' && risk.key !== 'legXO' && risk.key !== 'kneeOverstretch') {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    setSymptomCanvasModal: function setSymptomCanvasModal(risk) {
      var points = this.points;
      var needDetail = ['legO', 'legX', 'legXO'];
      var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

      var riskKey = risk.key;
      var keyMap = this.keyMap;
      var positionArr = void 0;
      var positionPointsArr = [];
      var faceOrSide = void 0;
      var scale = void 0;

      keys_default()(keyMap).forEach(function (direction, index) {
        keys_default()(keyMap[direction]).forEach(function (key, index) {
          if (key === riskKey) {
            positionArr = keyMap[direction][key].position;
            scale = keyMap[direction][key].scale;
          }
        });
      });

      if (needDetail.indexOf(riskKey) !== -1) {
        // 当是 legO、legX、legXO 时
        var lOrR = void 0;
        if (risk.detail === '右腿') {
          lOrR = 'right';
        } else {
          lOrR = 'left';
        }

        for (var i = 0; i < positionArr.length; i++) {
          positionPointsArr.push(points.face[positionArr[i]][lOrR]);
        }

        faceOrSide = 'face';
      } else if (forSide.indexOf(riskKey) !== -1) {
        // 当是侧面时
        var _lOrR = this.conclusion.side.side;

        for (var _i = 0; _i < positionArr.length; _i++) {

          if (points.side[positionArr[_i]].left === undefined) {

            positionPointsArr.push(points.side[positionArr[_i]]);
          } else {
            positionPointsArr.push(points.side[positionArr[_i]][_lOrR]);
          }
        }

        faceOrSide = 'side';
      } else {
        // 正面，并且能取到左右时
        for (var _i2 = 0; _i2 < positionArr.length; _i2++) {
          var positionAndDirectionArr = positionArr[_i2].split('-');
          if (positionAndDirectionArr.length === 1) {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
          } else {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
          }
        }

        faceOrSide = 'face';
      }

      var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
      var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
      var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
      var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

      var width = _x > _y ? _x : _y;
      width *= 1 + scale;

      var x = xMid - width / 2;
      var y = yMid - width / 2;

      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.width = width;
      canvas.height = width;
      // let img = new Image();
      // img.src = this.photos[faceOrSide];

      var img = this.img[faceOrSide];

      ctx.drawImage(img, x, y, width, width, 0, 0, width, width);

      this.canvas = canvas;
    },
    setSymptomCanvas: function setSymptomCanvas(option) {
      var canvas = option.el;
      var ctx = canvas.getContext('2d');

      var points = this.points;
      var needDetail = ['legO', 'legX', 'legXO'];
      var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

      var riskKey = canvas.dataset.key;
      var keyMap = this.keyMap;
      var positionArr = void 0;
      var positionPointsArr = [];
      var faceOrSide = void 0;
      var scale = void 0;
      keys_default()(keyMap).forEach(function (direction, index) {
        keys_default()(keyMap[direction]).forEach(function (key, index) {
          if (key === riskKey) {
            positionArr = keyMap[direction][key].position;
            scale = keyMap[direction][key].scale;
          }
        });
      });

      if (needDetail.indexOf(riskKey) !== -1) {
        // 当是 legO、legX、legXO 时
        var lOrR = void 0;
        if (canvas.dataset.detail === '右腿') {
          lOrR = 'right';
        } else {
          lOrR = 'left';
        }

        for (var i = 0; i < positionArr.length; i++) {
          positionPointsArr.push(points.face[positionArr[i]][lOrR]);
        }

        faceOrSide = 'facet';
      } else if (forSide.indexOf(riskKey) !== -1) {
        // 当是侧面时
        var _lOrR2 = this.conclusion.side.side;

        for (var _i3 = 0; _i3 < positionArr.length; _i3++) {

          if (points.side[positionArr[_i3]].left === undefined) {

            positionPointsArr.push(points.side[positionArr[_i3]]);
          } else {
            positionPointsArr.push(points.side[positionArr[_i3]][_lOrR2]);
          }
        }

        faceOrSide = 'side';
      } else {
        // 正面，并且能取到左右时
        for (var _i4 = 0; _i4 < positionArr.length; _i4++) {
          var positionAndDirectionArr = positionArr[_i4].split('-');
          if (positionAndDirectionArr.length === 1) {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
          } else {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
          }
        }

        faceOrSide = 'facet';
      }

      var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
      var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
      var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
      var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

      var width = _x > _y ? _x : _y;
      width *= 1 + scale;

      var x = xMid - width / 2;
      var y = yMid - width / 2;

      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.width = width;
      canvas.height = width;
      var img = new Image();
      img.src = this.photos[faceOrSide];
      // img.src = this.img[faceOrSide]
      img.onload = function () {
        ctx.drawImage(img, x, y, width, width, 0, 0, width, width);
      };
    },
    getLevel: function getLevel(level) {
      switch (level) {
        case this.level.normal:
          return {
            des: '低风险',
            className: 'level-normal'
          };
        case this.level.mild:
          return {
            des: '中风险',
            className: 'level-mild'
          };
        case this.level.severe:
          return {
            des: '高风险',
            className: 'level-severe'
          };
      }
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    sortHighToLow: function sortHighToLow(arr) {
      return _.orderBy(arr, ['value'], ['desc']);
    },
    initRiskBar: function initRiskBar() {
      this.$refs.riskModalRef.$el.getElementsByClassName('modal-content')[0].scrollTop = 0;
      var modalRiskBar = document.getElementById('modalRiskBar');
      canvas.initRiskLevel({
        el: modalRiskBar,
        width: Number(modalRiskBar.parentNode.offsetWidth),
        height: Number(modalRiskBar.parentNode.offsetHeight),
        color: {
          normal: '#00d963',
          mild: '#ffbf00',
          severe: '#ff4d4d'
        },
        level: this.level
      });
    },
    initRisksData: function initRisksData() {
      var risks = this.risks;
      var level = this.level;
      var symptoms = this.symptoms;
      var normalRisks = this.normalRisks;
      var mildRisks = this.mildRisks;
      var severeRisks = this.severeRisks;

      for (var direction in risks) {
        for (var i = 0; i < risks[direction].length; i++) {
          var symptom = symptoms[risks[direction][i].position][risks[direction][i].code - 1];

          if (symptom.value) {
            var otherSymptom = assign_default()({}, symptom);
            if (!risks[direction][i].valid) {
              otherSymptom.raw = 0;
              otherSymptom.value = 0;
              otherSymptom.level = level.normal;
              otherSymptom.detail = '';
              otherSymptom.direction = 'normal';
            } else {
              otherSymptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              otherSymptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              otherSymptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              otherSymptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
              otherSymptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
            }

            symptoms[risks[direction][i].position].push(otherSymptom);
          } else {
            if (!risks[direction][i].valid) {
              symptom.raw = 0;
              symptom.value = 0;
              symptom.level = level.normal;
              symptom.detail = '';
              symptom.direction = 'normal';
            } else {
              symptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              symptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              symptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              symptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
              symptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
            }
          }
        }
      }

      for (var position in symptoms) {
        for (var _i5 = 0; _i5 < symptoms[position].length; _i5++) {
          if (_.isUndefined(symptoms[position][_i5].value)) {
            continue;
          }
          switch (symptoms[position][_i5].level) {
            case level.normal:
              normalRisks.push(symptoms[position][_i5]);
              break;
            case level.mild:
              mildRisks.push(symptoms[position][_i5]);
              break;
            case level.severe:
              severeRisks.push(symptoms[position][_i5]);
              break;
            default:
              normalRisks.push(symptoms[position][_i5]);
              break;
          }
        }
      }

      this.normalRisks = this.sortHighToLow(normalRisks);
      this.mildRisks = this.sortHighToLow(mildRisks);
      this.severeRisks = this.sortHighToLow(severeRisks);
    },
    initRiskPoints: function initRiskPoints() {
      var that = this;
      var points = this.points;
      var photos = this.photos;
      var faceCanvas = document.createElement('canvas');
      var sideCanvas = document.createElement('canvas');
      var _this = this;
      var risks = this.normalRisks.concat(this.mildRisks, this.severeRisks);

      // === 初始化侧面数据 ===
      var side = points.side;
      var sidePointsArr = [];
      var sideImg = new Image();

      // 人体骨架分组
      var lOrR = side.side;
      var sideOrder = [['ankle-' + lOrR, 'knee-' + lOrR, 'hip-' + lOrR, 'shoulder-' + lOrR,
      // `neck`,
      'elbow-' + lOrR, 'wrist-' + lOrR], [
      //`neck`,
      'shoulder-' + lOrR, //新增
      'ear-' + lOrR, 'eye-' + lOrR, 'nose']];
      ////console.log('side order:',sideOrder)
      // 垂直标准线
      var sideVerticalStandard = ['ankle-' + lOrR, 'nose'];
      var sideVerticalPointsArr = [];

      // 先将各分组数据点取出来
      for (var i = 0; i < sideOrder.length; i++) {
        var pointsArr = [];
        for (var j = 0; j < sideOrder[i].length; j++) {
          var positionArr = sideOrder[i][j].split('-');
          if (positionArr.length === 1) {
            pointsArr.push(side[positionArr[0]]);
          } else {
            pointsArr.push(side[positionArr[0]][positionArr[1]]);
          }
        }
        sidePointsArr.push(pointsArr);
      }

      // 将垂直标准点取出来
      for (var _i6 = 0; _i6 < sideVerticalStandard.length; _i6++) {
        var _positionArr = sideVerticalStandard[_i6].split('-');
        if (_positionArr.length === 1) {
          sideVerticalPointsArr.push(side[_positionArr[0]]);
        } else {
          sideVerticalPointsArr.push(side[_positionArr[0]][_positionArr[1]]);
        }
      }

      // 症状和位置对应
      var sideSymptomWithPosition = ['ear-shoulder', 'hip-knee'];
      var sideHorizontalArr = [];

      for (var _i7 = 0; _i7 < sideSymptomWithPosition.length; _i7++) {
        var horizontalArr = [];
        var _positionArr2 = sideSymptomWithPosition[_i7].split('-');
        for (var _j = 0; _j < _positionArr2.length; _j++) {
          horizontalArr.push(side[_positionArr2[_j]][lOrR]);
        }
        sideHorizontalArr.push(horizontalArr);
      }

      // 取出需要显示度数的症状
      var sideSymptomWithAngle = ['headLean', 'roundShoulder', 'kneeOverstretch'];
      var sideSymptomWithAngleRisk = [];

      for (var _i8 = 0; _i8 < sideSymptomWithAngle.length; _i8++) {
        for (var _j2 = 0; _j2 < risks.length; _j2++) {
          if (risks[_j2].key === sideSymptomWithAngle[_i8]) {
            sideSymptomWithAngleRisk.push(risks[_j2]);
          }
        }
      }

      //console.log("sideImg.src:that.img",that.img)

      // 开始画图以及各点线
      sideImg.src = photos.side;
      sideImg.onload = function () {
        that.img.side = sideImg;
        // 将图片画进 canvas
        var width = sideImg.width;
        var height = sideImg.height;
        sideCanvas.width = width;
        sideCanvas.height = height;
        sideCanvas.style.width = '100%';

        var cxt = sideCanvas.getContext('2d');
        cxt.drawImage(sideImg, 0, 0, width, height);

        // 按分组画线
        for (var _i9 = 0; _i9 < sidePointsArr.length; _i9++) {
          for (var _j3 = 0; _j3 < sidePointsArr[_i9].length; _j3++) {

            if (_j3 === 0 || sidePointsArr[_i9][_j3].x === 0 && sidePointsArr[_i9][_j3].y === 0 || sidePointsArr[_i9][_j3 - 1].x === 0 && sidePointsArr[_i9][_j3 - 1].y === 0) {
              if (sidePointsArr[_i9][_j3].x === 0 && sidePointsArr[_i9][_j3].y === 0) {
                continue;
              } /*else if ( j == 0) {
                    }*/else {
                  _this.drawPoint({
                    el: sideCanvas,
                    point: sidePointsArr[_i9][_j3]
                  });
                  continue;
                }
            } else {
              _this.drawPoint({
                el: sideCanvas,
                point: sidePointsArr[_i9][_j3]
              });
              if (_j3 != 3) {
                _this.drawLine({

                  el: sideCanvas,
                  points: [sidePointsArr[_i9][_j3], sidePointsArr[_i9][_j3 - 1]]
                });
              }
            }
          }
        }

        // 画垂直标准线
        for (var _i10 = 0; _i10 < sideVerticalPointsArr.length; _i10++) {
          if (sideVerticalPointsArr[_i10].x === 0 && sideVerticalPointsArr[_i10].y === 0) {
            continue;
          } else {
            cxt.save();
            cxt.strokeStyle = '#4db664';
            cxt.beginPath();
            cxt.moveTo(sideVerticalPointsArr[_i10].x, 0);
            cxt.lineTo(sideVerticalPointsArr[_i10].x, height);
            cxt.closePath();
            cxt.stroke();
            cxt.restore();

            cxt.save();
            cxt.fillStyle = '#fe610f';
            cxt.font = '30px serif';
            var windowWidth = document.documentElement.clientWidth;
            var windowHeight = window.screen.height;
            var offsetHeight = (windowHeight - 125) / (windowWidth / width);
            if (_i10 === 0) {
              cxt.fillText('α', sideVerticalPointsArr[_i10].x + 5, offsetHeight - 5);
            } else {
              cxt.fillText('β', sideVerticalPointsArr[_i10].x + 5, offsetHeight - 5);
            }
            cxt.restore();
          }
        }

        // 画斜线
        for (var _i11 = 0; _i11 < sideHorizontalArr.length; _i11++) {
          _this.drawLine({
            el: sideCanvas,
            points: sideHorizontalArr[_i11],
            isSide: true
          });
        }

        // 画症状度数
        for (var _i12 = 0; _i12 < sideSymptomWithAngleRisk.length; _i12++) {
          _this.drawRectAndAngle({
            cxt: cxt,
            angle: sideSymptomWithAngleRisk[_i12].raw.toFixed(1),
            point: {
              x: width - 120,
              y: height * 0.2 * (_i12 + 1)
            }
          });
        }

        _this.$nextTick(function () {
          document.getElementById('side').appendChild(sideCanvas);
        });
      };
    },
    drawPoint: function drawPoint(option) {
      var canvas = option.el;
      var point = option.point;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.fillStyle = '#009eff';
      cxt.beginPath();
      cxt.arc(point.x, point.y, 5, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
      cxt.save();
      cxt.fillStyle = 'rgba(83, 158, 255, .3)';
      cxt.beginPath();
      cxt.arc(point.x, point.y, 10, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
    },
    drawLine: function drawLine(option) {
      //console.log("option:",option)
      // 有一个点是x, y 都等于0的时候，不画线
      if (option.points[0].x === 0 && option.points[0].y === 0 || option.points[1].x === 0 && option.points[1].y === 0) {
        return;
      }
      var canvas = option.el;
      var points = option.points;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.lineWidth = 3;
      if (!option.isSide) {
        cxt.strokeStyle = '#5f58f4';
        cxt.beginPath();
        cxt.moveTo(points[0].x, points[0].y);
        cxt.lineTo(points[1].x, points[1].y);
        cxt.closePath();
        cxt.stroke();
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var z = Math.sqrt(Math.pow(_x, 2) + Math.pow(_y, 2));
        var startX = void 0;
        var startY = void 0;
        var endX = void 0;
        var endY = void 0;
        var distance = 80;

        if (points[0].x > points[1].x) {
          startX = Math.round(points[1].x - distance * _x / z);
          startY = Math.round(points[1].y + distance * _y / z);
          endX = Math.round(points[0].x + distance * _x / z);
          endY = Math.round(points[0].y - distance * _y / z);
        } else {
          startX = Math.round(points[0].x - distance * _x / z);
          startY = Math.round(points[0].y - distance * _y / z);
          endX = Math.round(points[1].x + distance * _x / z);
          endY = Math.round(points[1].y + distance * _y / z);
        }

        cxt.strokeStyle = '#0ef8cd';
        cxt.beginPath();
        cxt.moveTo(startX, startY);
        cxt.lineTo(endX, endY);
        cxt.closePath();
        cxt.stroke();
      }

      cxt.restore();
    },
    drawRectAndAngle: function drawRectAndAngle(option) {
      var cxt = option.cxt;
      var angle = option.angle;
      var point = option.point;

      cxt.save();
      if (option.isSecond) {
        cxt.translate(0, 43);
      }
      cxt.save();
      cxt.fillStyle = 'rgba(100, 100, 98, 0.5)';
      cxt.beginPath();
      cxt.moveTo(point.x + 13, point.y + 3);
      cxt.lineTo(point.x + 99, point.y + 3);
      cxt.quadraticCurveTo(point.x + 109, point.y + 3, point.x + 109, point.y + 13);
      cxt.lineTo(point.x + 109, point.y + 33);
      cxt.quadraticCurveTo(point.x + 109, point.y + 43, point.x + 99, point.y + 43);
      cxt.lineTo(point.x + 13, point.y + 43);
      cxt.quadraticCurveTo(point.x + 3, point.y + 43, point.x + 3, point.y + 33);
      cxt.lineTo(point.x + 3, point.y + 13);
      cxt.quadraticCurveTo(point.x + 3, point.y + 3, point.x + 13, point.y + 3);
      cxt.closePath();
      cxt.fill();
      cxt.restore();

      // 绘制角度
      cxt.save();
      cxt.font = '34px Arial';
      cxt.fillStyle = '#0cfcca';
      cxt.textAlign = 'center';
      if (option.isTrunk) {
        cxt.fillText(angle + '%', point.x + 56, point.y + 38);
      } else {
        cxt.fillText(angle + '\xB0', point.x + 56, point.y + 38);
      }
      cxt.restore();
      cxt.restore();
    },
    drawLineAndAngle: function drawLineAndAngle(option) {
      var canvas = option.el;
      var width = canvas.width;
      var points = option.points;
      var min = option.min - 100;
      var max = option.max + 100;
      var cxt = canvas.getContext('2d');

      // 如果有一个点不存在，则不画线
      for (var i = 0; i < points.length; i++) {
        if (points[i].x === 0 && points[i].y === 0) {
          return;
        }
      }

      // 此处画脊柱侧弯

      if (points.length === 1) {
        this.drawRectAndAngle({
          cxt: cxt,
          angle: (option.angle * 100).toFixed(1),
          point: {
            x: width - 120,
            y: points[0].y
          },
          isSecond: false,
          isTrunk: true
        });
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var startPoint = {};
        var endPoint = {};
        var offsetYL = Number(((points[0].x - min) * _y / _x).toFixed(0));
        var offsetYR = Number(((max - points[1].x) * _y / _x).toFixed(0));

        if (points[0].y < points[1].y) {
          startPoint.x = min;
          startPoint.y = points[0].y - offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y + offsetYR;
        } else {
          startPoint.x = min;
          startPoint.y = points[0].y + offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y - offsetYR;
        }

        cxt.save();
        cxt.strokeStyle = '#14bc9a';
        cxt.beginPath();
        cxt.moveTo(startPoint.x, startPoint.y);
        cxt.lineTo(endPoint.x, endPoint.y);
        cxt.closePath();
        cxt.stroke();
        cxt.restore();

        // 绘制圆角矩形框
        this.drawRectAndAngle({
          cxt: cxt,
          angle: option.angle.toFixed(1),
          point: {
            x: width - 120,
            y: points[1].y
          },
          isSecond: false
        });

        if (!_.isUndefined(option.secondAngle)) {
          this.drawRectAndAngle({
            cxt: cxt,
            angle: option.secondAngle.toFixed(1),
            point: {
              x: width - 120,
              y: points[1].y
            },
            isSecond: true
          });
        }
      }
    }
  },
  created: function created() {
    this.initRiskPoints();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12b7debe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_flank.vue
var Posture_flank_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var Posture_flank_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", {
        staticStyle: { height: "100%", overflow: "hidden" },
        attrs: { id: "side" }
      })
    ])
  }
]
Posture_flank_render._withStripped = true
var Posture_flank_esExports = { render: Posture_flank_render, staticRenderFns: Posture_flank_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Posture_flank = (Posture_flank_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12b7debe", Posture_flank_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Posture_flank.vue
var Posture_flank_disposed = false
function Posture_flank_injectStyle (ssrContext) {
  if (Posture_flank_disposed) return
  __webpack_require__("Xkal")
}
var Posture_flank_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Posture_flank___vue_template_functional__ = false
/* styles */
var Posture_flank___vue_styles__ = Posture_flank_injectStyle
/* scopeId */
var Posture_flank___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Posture_flank___vue_module_identifier__ = null
var Posture_flank_Component = Posture_flank_normalizeComponent(
  components_Posture_flank,
  selectortype_template_index_0_src_components_Posture_flank,
  Posture_flank___vue_template_functional__,
  Posture_flank___vue_styles__,
  Posture_flank___vue_scopeId__,
  Posture_flank___vue_module_identifier__
)
Posture_flank_Component.options.__file = "src/components/Posture_flank.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-12b7debe", Posture_flank_Component.options)
  } else {
    hotAPI.reload("data-v-12b7debe", Posture_flank_Component.options)
  }
  module.hot.dispose(function (data) {
    Posture_flank_disposed = true
  })
})()}

/* harmony default export */ var src_components_Posture_flank = (Posture_flank_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_home.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var langs = {
  en: "中文",
  cn: "English"
};
/* harmony default export */ var Posture_home = ({
  name: "Posture_home",
  i18n: {
    // `i18n` option, setup locale info for component
    messages: extends_default()({}, postureHome)
  },
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {},
  props: ["coverInfo"],
  data: function data() {
    return {
      oldUrl: "",
      locale: "",
      langTag: this.$i18n.locale,
      localUrl: "",
      localeText: langs[this.$i18n.locale]

      // localeText:this.langs[this.$i18n.locale],
    };
  },

  methods: {
    slideIn: function slideIn() {
      this.$emit("slideIn");
    },
    changeLang: function changeLang(lang) {
      this.locale = lang;
      var changeUrl = location.href.substring(0, location.href.lastIndexOf("language")) + "language=" + lang;
      console.log("changeUrl" + changeUrl);
      console.log({
        locale: this.locale,
        text: this.$i18n.locale
      });
      location.href = changeUrl;
      this.$i18n.locale = lang;
      this.localeText = this.langs[lang] || "English";
      setTimeout(function () {
        this.localUrl = changeUrl;
      }, 200);
      // location.reload()
      // this.$emit('changeLang',this.locale)
    }
  },

  computed: {
    show: function show() {
      //console.log('indexPage:', this.$t('indexPage.show'))
      return this.$t("indexPage.show");
    }
  },
  created: function created() {
    // var pathUrl = location.href.match(/(\w+)=(\w+)/g)
    // var pathObj = {};
    // for (var i = 0; i < pathUrl.length; i++) {
    //   var pathItem = pathUrl[i].split('=')
    //   pathObj[pathItem[0]] = pathItem[1] || ''
    // }
    // this.$i18n.locale = pathObj.language || 'cn'
    console.log({
      index: this.$i18n.locale
    });
    var changeLangTag = this.$i18n.locale;

    // console.log((document.title = "Posture Report"));
    var pos = location.href.lastIndexOf("language");
    if (pos > 0) {
      this.localUrl = location.href.substring(0, pos) + "language=" + changeLangTag;
    } else {
      console.log({
        url: location.href
      });
      var spLength = location.href.length - 2;
      this.localUrl = location.href.substring(0, spLength) + "&language=" + changeLangTag;
    }
  }
  // watch: {
  //   locale (val) {
  //     this.$i18n.locale = val
  //   }
  // }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_home.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var Posture_home_langs = {
  en: "中文",
  cn: "English"
};
/* harmony default export */ var components_Posture_home = ({
  name: "Posture_home",
  i18n: {
    // `i18n` option, setup locale info for component
    messages: extends_default()({}, postureHome)
  },
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {},
  props: ["coverInfo"],
  data: function data() {
    return {
      oldUrl: "",
      locale: "",
      langTag: this.$i18n.locale,
      localUrl: "",
      localeText: Posture_home_langs[this.$i18n.locale]

      // localeText:this.langs[this.$i18n.locale],
    };
  },

  methods: {
    slideIn: function slideIn() {
      this.$emit("slideIn");
    },
    changeLang: function changeLang(lang) {
      this.locale = lang;
      var changeUrl = location.href.substring(0, location.href.lastIndexOf("language")) + "language=" + lang;
      console.log("changeUrl" + changeUrl);
      console.log({
        locale: this.locale,
        text: this.$i18n.locale
      });
      location.href = changeUrl;
      this.$i18n.locale = lang;
      this.localeText = this.langs[lang] || "English";
      setTimeout(function () {
        this.localUrl = changeUrl;
      }, 200);
      // location.reload()
      // this.$emit('changeLang',this.locale)
    }
  },

  computed: {
    show: function show() {
      //console.log('indexPage:', this.$t('indexPage.show'))
      return this.$t("indexPage.show");
    }
  },
  created: function created() {
    // var pathUrl = location.href.match(/(\w+)=(\w+)/g)
    // var pathObj = {};
    // for (var i = 0; i < pathUrl.length; i++) {
    //   var pathItem = pathUrl[i].split('=')
    //   pathObj[pathItem[0]] = pathItem[1] || ''
    // }
    // this.$i18n.locale = pathObj.language || 'cn'
    console.log({
      index: this.$i18n.locale
    });
    var changeLangTag = this.$i18n.locale;

    // console.log((document.title = "Posture Report"));
    var pos = location.href.lastIndexOf("language");
    if (pos > 0) {
      this.localUrl = location.href.substring(0, pos) + "language=" + changeLangTag;
    } else {
      console.log({
        url: location.href
      });
      var spLength = location.href.length - 2;
      this.localUrl = location.href.substring(0, spLength) + "&language=" + changeLangTag;
    }
  }
  // watch: {
  //   locale (val) {
  //     this.$i18n.locale = val
  //   }
  // }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9dea9b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_home.vue
var Posture_home_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "contentalignstart",
        class: { sennoTitleActive: !_vm.coverInfo.logo }
      },
      [
        _vm.coverInfo.logo
          ? _c("div", { staticClass: "imgBorder" }, [
              _c("img", {
                staticClass: "companyLogo",
                attrs: {
                  align: "middle",
                  src: "data:image/*;base64," + _vm.coverInfo.logo + ""
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(0)
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mt300" }, [
      _c(
        "div",
        {
          staticClass:
            "content-row content-row-column auto-width font-26 margin_left",
          staticStyle: { "margin-left": "40%", color: "#fff" }
        },
        [
          _c(
            "span",
            {
              staticClass: "big_font",
              staticStyle: { "letter-spacing": ".1rem" }
            },
            [_vm._v(_vm._s(_vm.$t("indexPage.a_posture_title")))]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "margin-top-80", attrs: { id: "ul_list" } }, [
      _c(
        "div",
        {
          staticClass:
            "content-row content-row-column auto-width font-16 cover-text margin_left small_font",
          staticStyle: {
            "margin-left": "40%",
            color: "#fff",
            "line-height": "1.5rem"
          }
        },
        [
          _c(
            "p",
            { staticStyle: { display: "flex", "align-item": "center" } },
            [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "7.2rem" } },
                [_vm._v(_vm._s(_vm.$t("coverInfo.customerName")) + "：")]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.coverInfo.customerName))])
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticStyle: { display: "flex", "align-item": "center" } },
            [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "7.2rem" } },
                [_vm._v(_vm._s(_vm.$t("coverInfo.date")) + "：")]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.coverInfo.date))])
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticStyle: { display: "flex", "align-item": "center" } },
            [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "7.2rem" } },
                [_vm._v(_vm._s(_vm.$t("coverInfo.time")) + "：")]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.coverInfo.time))])
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticStyle: { display: "flex", "align-item": "center" } },
            [
              _c(
                "span",
                { staticStyle: { display: "inline-block", width: "7.2rem" } },
                [_vm._v(_vm._s(_vm.$t("coverInfo.userName")) + "：")]
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.coverInfo.userName))])
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cover-btn", on: { click: _vm.slideIn } }, [
      _c("span", { staticClass: "doublearrortop" }, [
        _vm._v(_vm._s(_vm.$t("coverInfo.clickEnterReport")))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "doublearrorbottom" })
    ])
  ])
}
var Posture_home_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sennoTitle" }, [
      _vm._v("\n      Powered By\n      "),
      _c("div", { staticClass: "senno-logo" })
    ])
  }
]
Posture_home_render._withStripped = true
var Posture_home_esExports = { render: Posture_home_render, staticRenderFns: Posture_home_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Posture_home = (Posture_home_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9dea9b4", Posture_home_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Posture_home.vue
var Posture_home_disposed = false
function Posture_home_injectStyle (ssrContext) {
  if (Posture_home_disposed) return
  __webpack_require__("I1j0")
}
var Posture_home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Posture_home___vue_template_functional__ = false
/* styles */
var Posture_home___vue_styles__ = Posture_home_injectStyle
/* scopeId */
var Posture_home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Posture_home___vue_module_identifier__ = null
var Posture_home_Component = Posture_home_normalizeComponent(
  components_Posture_home,
  selectortype_template_index_0_src_components_Posture_home,
  Posture_home___vue_template_functional__,
  Posture_home___vue_styles__,
  Posture_home___vue_scopeId__,
  Posture_home___vue_module_identifier__
)
Posture_home_Component.options.__file = "src/components/Posture_home.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b9dea9b4", Posture_home_Component.options)
  } else {
    hotAPI.reload("data-v-b9dea9b4", Posture_home_Component.options)
  }
  module.hot.dispose(function (data) {
    Posture_home_disposed = true
  })
})()}

/* harmony default export */ var src_components_Posture_home = (Posture_home_Component.exports);

// EXTERNAL MODULE: ./node_modules/weixin-js-sdk/index.js
var weixin_js_sdk = __webpack_require__("fxnj");
var weixin_js_sdk_default = /*#__PURE__*/__webpack_require__.n(weixin_js_sdk);

// EXTERNAL MODULE: ./node_modules/qr.js/lib/QRCode.js
var QRCode = __webpack_require__("0k+n");
var QRCode_default = /*#__PURE__*/__webpack_require__.n(QRCode);

// EXTERNAL MODULE: ./node_modules/qr.js/lib/ErrorCorrectLevel.js
var ErrorCorrectLevel = __webpack_require__("LpmL");
var ErrorCorrectLevel_default = /*#__PURE__*/__webpack_require__.n(ErrorCorrectLevel);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/qrcode/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_qrcode = ({
  name: 'qrcode',
  props: {
    value: String,
    size: {
      type: Number,
      default: 160
    },
    level: {
      type: String,
      default: 'L'
    },
    bgColor: {
      type: String,
      default: '#FFFFFF'
    },
    fgColor: {
      type: String,
      default: '#000000'
    },
    type: {
      type: String,
      default: 'img'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.render();
    });
  },
  data: function data() {
    return {
      imgData: ''
    };
  },

  watch: {
    value: function value() {
      this.render();
    },
    size: function size() {
      this.render();
    },
    level: function level() {
      this.render();
    },
    bgColor: function bgColor() {
      this.render();
    },
    fgColor: function fgColor() {
      this.render();
    }
  },
  methods: {
    render: function render() {
      var _this2 = this;

      if (typeof this.value === 'undefined') {
        return;
      }

      var qrcode = new QRCode_default.a(-1, ErrorCorrectLevel_default.a[this.level]);
      qrcode.addData(utf16to8(this.value));
      qrcode.make();

      var canvas = this.$refs.canvas;

      var ctx = canvas.getContext('2d');
      var cells = qrcode.modules;
      var tileW = this.size / cells.length;
      var tileH = this.size / cells.length;
      var scale = (window.devicePixelRatio || 1) / getBackingStorePixelRatio(ctx);
      canvas.height = canvas.width = this.size * scale;
      ctx.scale(scale, scale);

      cells.forEach(function (row, rdx) {
        row.forEach(function (cell, cdx) {
          ctx.fillStyle = cell ? _this2.fgColor : _this2.bgColor;
          var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
          var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
          ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
        });
      });
      if (this.type === 'img') {
        this.imgData = canvas.toDataURL('image/png');
      }
    }
  }
});

function getBackingStorePixelRatio(ctx) {
  return ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
}

function utf16to8(str) {
  var out, i, len, c;
  out = '';
  len = str.length;
  for (i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if (c >= 0x0001 && c <= 0x007F) {
      out += str.charAt(i);
    } else if (c > 0x07FF) {
      out += String.fromCharCode(0xE0 | c >> 12 & 0x0F);
      out += String.fromCharCode(0x80 | c >> 6 & 0x3F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    } else {
      out += String.fromCharCode(0xC0 | c >> 6 & 0x1F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    }
  }
  return out;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/qrcode/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_qrcode = ({
  name: 'qrcode',
  props: {
    value: String,
    size: {
      type: Number,
      default: 160
    },
    level: {
      type: String,
      default: 'L'
    },
    bgColor: {
      type: String,
      default: '#FFFFFF'
    },
    fgColor: {
      type: String,
      default: '#000000'
    },
    type: {
      type: String,
      default: 'img'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.render();
    });
  },
  data: function data() {
    return {
      imgData: ''
    };
  },

  watch: {
    value: function value() {
      this.render();
    },
    size: function size() {
      this.render();
    },
    level: function level() {
      this.render();
    },
    bgColor: function bgColor() {
      this.render();
    },
    fgColor: function fgColor() {
      this.render();
    }
  },
  methods: {
    render: function render() {
      var _this2 = this;

      if (typeof this.value === 'undefined') {
        return;
      }

      var qrcode = new QRCode_default.a(-1, ErrorCorrectLevel_default.a[this.level]);
      qrcode.addData(qrcode_utf16to8(this.value));
      qrcode.make();

      var canvas = this.$refs.canvas;

      var ctx = canvas.getContext('2d');
      var cells = qrcode.modules;
      var tileW = this.size / cells.length;
      var tileH = this.size / cells.length;
      var scale = (window.devicePixelRatio || 1) / qrcode_getBackingStorePixelRatio(ctx);
      canvas.height = canvas.width = this.size * scale;
      ctx.scale(scale, scale);

      cells.forEach(function (row, rdx) {
        row.forEach(function (cell, cdx) {
          ctx.fillStyle = cell ? _this2.fgColor : _this2.bgColor;
          var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
          var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
          ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
        });
      });
      if (this.type === 'img') {
        this.imgData = canvas.toDataURL('image/png');
      }
    }
  }
});

function qrcode_getBackingStorePixelRatio(ctx) {
  return ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
}

function qrcode_utf16to8(str) {
  var out, i, len, c;
  out = '';
  len = str.length;
  for (i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if (c >= 0x0001 && c <= 0x007F) {
      out += str.charAt(i);
    } else if (c > 0x07FF) {
      out += String.fromCharCode(0xE0 | c >> 12 & 0x0F);
      out += String.fromCharCode(0x80 | c >> 6 & 0x3F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    } else {
      out += String.fromCharCode(0xC0 | c >> 6 & 0x1F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    }
  }
  return out;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca9710dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/qrcode/index.vue
var qrcode_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("canvas", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.type === "canvas",
          expression: "type === 'canvas'"
        }
      ],
      ref: "canvas",
      style: {
        height: _vm.size + "px",
        width: _vm.size + "px"
      },
      attrs: { height: _vm.size, width: _vm.size }
    }),
    _vm._v(" "),
    _vm.type === "img"
      ? _c("img", {
          style: {
            height: _vm.size + "px",
            width: _vm.size + "px"
          },
          attrs: { src: _vm.imgData }
        })
      : _vm._e()
  ])
}
var qrcode_staticRenderFns = []
qrcode_render._withStripped = true
var qrcode_esExports = { render: qrcode_render, staticRenderFns: qrcode_staticRenderFns }
/* harmony default export */ var vux_src_components_qrcode = (qrcode_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ca9710dc", qrcode_esExports)
  }
}
// CONCATENATED MODULE: ./node_modules/vux/src/components/qrcode/index.vue
var qrcode_disposed = false
var qrcode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var qrcode___vue_template_functional__ = false
/* styles */
var qrcode___vue_styles__ = null
/* scopeId */
var qrcode___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var qrcode___vue_module_identifier__ = null
var qrcode_Component = qrcode_normalizeComponent(
  src_components_qrcode,
  vux_src_components_qrcode,
  qrcode___vue_template_functional__,
  qrcode___vue_styles__,
  qrcode___vue_scopeId__,
  qrcode___vue_module_identifier__
)
qrcode_Component.options.__file = "node_modules/vux/src/components/qrcode/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ca9710dc", qrcode_Component.options)
  } else {
    hotAPI.reload("data-v-ca9710dc", qrcode_Component.options)
  }
  module.hot.dispose(function (data) {
    qrcode_disposed = true
  })
})()}

/* harmony default export */ var node_modules_vux_src_components_qrcode = (qrcode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_report.vue

























var navList = [{
  text: "正面",
  bulletClassName: "pagination-bullet bone_front",
  containerClassName: "",
  iconClassName: "pagination-icon pagination-face"
}, {
  text: "侧面",
  bulletClassName: "pagination-bullet",
  containerClassName: "",
  iconClassName: "pagination-icon pagination-side"
}, {
  text: "背面",
  bulletClassName: "pagination-bullet bone_back",
  containerClassName: "hidden-pagination",
  iconClassName: ""
}];

/* harmony default export */ var Posture_report = ({
  name: "Posture_report",
  i18n: {

    messages: extends_default()({}, postureReport)
  },
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  props: ["updateSwiper"],
  components: {
    Qrcode: node_modules_vux_src_components_qrcode,
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    Previewer: vux_src_components_previewer,
    Loading: vux_src_components_loading,
    bModal: modal["a" /* default */],
    bTabs: tabs["a" /* default */],
    bTab: tab["a" /* default */],
    bCard: card["a" /* default */]
  },
  data: function data() {
    var _this2 = this;

    return {
      boneDescription: this.$t("boneDescription"),
      descripName: this.$t("descripName"),
      details: this.$t("details"),
      navList: [{
        text: this.$tc("navList", 0),
        bulletClassName: "pagination-bullet bone_front",
        containerClassName: "",
        iconClassName: "pagination-icon pagination-face"
      }, {
        text: this.$tc("navList", 1),
        bulletClassName: "pagination-bullet",
        containerClassName: "",
        iconClassName: "pagination-icon pagination-side"
      }, {
        text: this.$tc("navList", 2),
        bulletClassName: "pagination-bullet bone_back",
        containerClassName: "hidden-pagination",
        iconClassName: ""
      }],
      bodyPart: bone_default.a.bodyPart,
      boneIndex: 0,
      shelter: false,
      valid: true,
      loading: true,
      reportData: {},
      customer: {},
      cur_index: window.cur_index,
      swiperOptions: {
        pagination: {
          el: ".postureS-swiper-pagination",
          clickable: true,
          renderBullet: function renderBullet(index, className) {
            var textAlign = "content-align-center";

            var bone_front = "",
                bone_back = "";
            if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
              if (index == 0 || index == 2) {
                textAlign = "";
              }
            }
            var style = "";
            if (index == 1) {
              style = 'style="width: 208px;"';
            }

            return '<div style="position: relative" ' + style + ' class="bone' + index + ' content-row content-row-column ' + textAlign + (' ' + className + '">') + '<div style="height:14px"></div>' + ('<span style="font-size:.9rem !important;"  class="' + navList[index].bulletClassName + '">' + navList[index].text + '</span>') + '<div style="height:0.12rem;margin-top: 3px;" class="boneBar boneBar' + index + '"></div>' + '</div>';
          }
        },
        allowTouchMove: true,
        autoplay: false,
        on: {
          init: function init() {
            _this2.drawBone(0);
          },
          slidePrevTransitionStart: function slidePrevTransitionStart() {},
          slideNextTransitionStart: function slideNextTransitionStart() {},
          transitionEnd: function transitionEnd() {
            localStorage.setItem("bone_index", this.activeIndex);
            console.log("bone:", this.activeIndex);
          },
          touchEnd: function touchEnd() {},
          slideChangeTransitionEnd: function slideChangeTransitionEnd() {
            var boneIndex = localStorage.getItem("bone_index");
            _this2.boneIndex = boneIndex;
            console.log("boneIndex:", boneIndex);
          },
          click: function click() {},
          slideChange: function slideChange() {
            _this2.drawBone(0);
            _this2.drawBone(1);
            _this2.drawBone(2);
          }
        }
      },
      normalRisks: [],
      mildRisks: [],
      severeRisks: [],
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      },
      risks: {},
      points: null,
      photos: null,
      coverInfo: {},
      modalInfo: null,
      canvas: null,
      img: {
        face: null,
        side: null
      },
      isWechat: false,
      uuid: "",
      type: "",
      showMini: false,
      drawFinish: {
        face: false,
        back: false,
        side: false
      }
    };
  },

  computed: {},
  watch: {
    updateSwiper: function updateSwiper() {
      this.slideIn();
      this.$emit("updateSwiper", false);
    }
  },
  methods: extends_default()({
    stop: function stop() {},
    start: function start() {},
    slideIn: function slideIn() {
      this.$refs.postureBoneSwiper.swiper.slideTo(0);
    },
    drawBone: function drawBone(idx) {
      var data = this.reportData;

      if (idx === 0) {
        if (this.drawFinish.face === false) {
          bone_default.a.drawFrontBone(data, document.getElementById("faceBone"));
          this.drawFinish.face = true;
        }
      } else if (idx === 1) {
        if (this.drawFinish.side === false) {
          bone_default.a.drawSideBone(data, document.getElementById("sideBone"));
          this.drawFinish.side = true;
        }
      } else if (idx === 2) {
        if (this.drawFinish.back === false) {
          bone_default.a.drawBackBone(data, document.getElementById("backBone"));
          this.drawFinish.back = true;
        }
      }
    },
    sortHighToLow: function sortHighToLow(arr) {
      return lodash_default.a.orderBy(arr, ["value"], ["desc"]);
    },
    initBone: function initBone() {
      var data = this.reportData;
      this.$nextTick(function () {
        bone_default.a.drawFrontBone(data, document.getElementById("faceBone"));
        bone_default.a.drawSideBone(data, document.getElementById("sideBone"));
        bone_default.a.drawBackBone(data, document.getElementById("backBone"));
      });
    }
  }, Object(vuex_esm["d" /* mapState */])({
    initReportData: function initReportData(state) {
      var reportData = state.vux.reportData;
      var _this = this;
      if (lodash_default.a.isNull(reportData)) {
        var uuid = "";
        var type = "";

        var urlquery = url_default.a.parse(window.location.href).query;
        var query = urlquery.split("&");
        for (var every = 0; every < query.length; every++) {
          if (query[every].indexOf("uuid=") !== -1) {
            uuid = query[every].replace("uuid=", "");
          }
          if (query[every].indexOf("type=") !== -1) {
            type = query[every].replace("type=", "");
          }
        }
        this.uuid = uuid;
        this.type = type;
        this.get({
          url: 'v1/posture/reports/' + uuid,
          params: {
            type: type
          },
          success: function success(result) {
            _this.updateReportData({
              reportData: result
            });
            _this.getReportData();
          },
          error: function error(data) {
            _this.loading = false;
            _this.valid = false;
          }
        });
      } else {
        _this.getReportData();
      }
    },
    getReportData: function getReportData(state) {
      this.loading = false;
      var reportData = state.vux.reportData;
      var that = this;
      weixin_js_sdk_default.a.miniProgram.getEnv(function (res) {

        if (res.miniprogram) {
          that.isWechat = true;
        } else {
          that.isWechat = false;
        }
      });

      this.qrImage = reportData.solutions;

      var customer = reportData.customer;
      var header = reportData.header;
      var user = reportData.user;
      var coverInfo = {};
      if (lodash_default.a.isNull(header)) {
        coverInfo.date = "--";
        coverInfo.time = "--";
      } else {
        coverInfo.date = moment_default()(header.creationTime).format("YYYY-MM-DD");
        coverInfo.time = moment_default()(header.creationTime).format("hh:mm");
      }

      if (lodash_default.a.isNull(user)) {
        coverInfo.userName = "--";
      } else {
        coverInfo.userName = user.name;
      }

      if (lodash_default.a.isNull(customer)) {
        coverInfo.customerName = "--";
      } else {
        coverInfo.customerName = customer.name;
      }

      this.coverInfo = coverInfo;

      this.conclusion = reportData.conclusion;
      var conclusion = this.conclusion;

      var points = {
        face: conclusion.face.points,
        side: assign_default()(conclusion.side.points, {
          side: conclusion.side.side
        })
      };
      this.points = points;

      var photos = {
        face: reportData.face,
        side: reportData.side
      };
      this.photos = photos;
      this.reportData = reportData;
    }
  }), Object(vuex_esm["b" /* mapActions */])(["get"]), Object(vuex_esm["c" /* mapMutations */])(["updateReportData"])),
  created: function created() {
    bone_default.a.init(this.descripName, this.boneDescription, this.details);
    this.initReportData();
    console.log(" this.reportData:", bone_default.a);
    for (var i = 0; i < navList.length; i++) {
      navList[i].text = this.navList[i].text;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_report.vue

























var Posture_report_navList = [{
  text: "正面",
  bulletClassName: "pagination-bullet bone_front",
  containerClassName: "",
  iconClassName: "pagination-icon pagination-face"
}, {
  text: "侧面",
  bulletClassName: "pagination-bullet",
  containerClassName: "",
  iconClassName: "pagination-icon pagination-side"
}, {
  text: "背面",
  bulletClassName: "pagination-bullet bone_back",
  containerClassName: "hidden-pagination",
  iconClassName: ""
}];

/* harmony default export */ var components_Posture_report = ({
  name: "Posture_report",
  i18n: {

    messages: extends_default()({}, postureReport)
  },
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  props: ["updateSwiper"],
  components: {
    Qrcode: node_modules_vux_src_components_qrcode,
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    Previewer: vux_src_components_previewer,
    Loading: vux_src_components_loading,
    bModal: modal["a" /* default */],
    bTabs: tabs["a" /* default */],
    bTab: tab["a" /* default */],
    bCard: card["a" /* default */]
  },
  data: function data() {
    var _this2 = this;

    return {
      boneDescription: this.$t("boneDescription"),
      descripName: this.$t("descripName"),
      details: this.$t("details"),
      navList: [{
        text: this.$tc("navList", 0),
        bulletClassName: "pagination-bullet bone_front",
        containerClassName: "",
        iconClassName: "pagination-icon pagination-face"
      }, {
        text: this.$tc("navList", 1),
        bulletClassName: "pagination-bullet",
        containerClassName: "",
        iconClassName: "pagination-icon pagination-side"
      }, {
        text: this.$tc("navList", 2),
        bulletClassName: "pagination-bullet bone_back",
        containerClassName: "hidden-pagination",
        iconClassName: ""
      }],
      bodyPart: bone_default.a.bodyPart,
      boneIndex: 0,
      shelter: false,
      valid: true,
      loading: true,
      reportData: {},
      customer: {},
      cur_index: window.cur_index,
      swiperOptions: {
        pagination: {
          el: ".postureS-swiper-pagination",
          clickable: true,
          renderBullet: function renderBullet(index, className) {
            var textAlign = "content-align-center";

            var bone_front = "",
                bone_back = "";
            if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
              if (index == 0 || index == 2) {
                textAlign = "";
              }
            }
            var style = "";
            if (index == 1) {
              style = 'style="width: 208px;"';
            }

            return '<div style="position: relative" ' + style + ' class="bone' + index + ' content-row content-row-column ' + textAlign + (' ' + className + '">') + '<div style="height:14px"></div>' + ('<span style="font-size:.9rem !important;"  class="' + Posture_report_navList[index].bulletClassName + '">' + Posture_report_navList[index].text + '</span>') + '<div style="height:0.12rem;margin-top: 3px;" class="boneBar boneBar' + index + '"></div>' + '</div>';
          }
        },
        allowTouchMove: true,
        autoplay: false,
        on: {
          init: function init() {
            _this2.drawBone(0);
          },
          slidePrevTransitionStart: function slidePrevTransitionStart() {},
          slideNextTransitionStart: function slideNextTransitionStart() {},
          transitionEnd: function transitionEnd() {
            localStorage.setItem("bone_index", this.activeIndex);
            console.log("bone:", this.activeIndex);
          },
          touchEnd: function touchEnd() {},
          slideChangeTransitionEnd: function slideChangeTransitionEnd() {
            var boneIndex = localStorage.getItem("bone_index");
            _this2.boneIndex = boneIndex;
            console.log("boneIndex:", boneIndex);
          },
          click: function click() {},
          slideChange: function slideChange() {
            _this2.drawBone(0);
            _this2.drawBone(1);
            _this2.drawBone(2);
          }
        }
      },
      normalRisks: [],
      mildRisks: [],
      severeRisks: [],
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      },
      risks: {},
      points: null,
      photos: null,
      coverInfo: {},
      modalInfo: null,
      canvas: null,
      img: {
        face: null,
        side: null
      },
      isWechat: false,
      uuid: "",
      type: "",
      showMini: false,
      drawFinish: {
        face: false,
        back: false,
        side: false
      }
    };
  },

  computed: {},
  watch: {
    updateSwiper: function updateSwiper() {
      this.slideIn();
      this.$emit("updateSwiper", false);
    }
  },
  methods: extends_default()({
    stop: function stop() {},
    start: function start() {},
    slideIn: function slideIn() {
      this.$refs.postureBoneSwiper.swiper.slideTo(0);
    },
    drawBone: function drawBone(idx) {
      var data = this.reportData;

      if (idx === 0) {
        if (this.drawFinish.face === false) {
          bone_default.a.drawFrontBone(data, document.getElementById("faceBone"));
          this.drawFinish.face = true;
        }
      } else if (idx === 1) {
        if (this.drawFinish.side === false) {
          bone_default.a.drawSideBone(data, document.getElementById("sideBone"));
          this.drawFinish.side = true;
        }
      } else if (idx === 2) {
        if (this.drawFinish.back === false) {
          bone_default.a.drawBackBone(data, document.getElementById("backBone"));
          this.drawFinish.back = true;
        }
      }
    },
    sortHighToLow: function sortHighToLow(arr) {
      return lodash_default.a.orderBy(arr, ["value"], ["desc"]);
    },
    initBone: function initBone() {
      var data = this.reportData;
      this.$nextTick(function () {
        bone_default.a.drawFrontBone(data, document.getElementById("faceBone"));
        bone_default.a.drawSideBone(data, document.getElementById("sideBone"));
        bone_default.a.drawBackBone(data, document.getElementById("backBone"));
      });
    }
  }, Object(vuex_esm["d" /* mapState */])({
    initReportData: function initReportData(state) {
      var reportData = state.vux.reportData;
      var _this = this;
      if (lodash_default.a.isNull(reportData)) {
        var uuid = "";
        var type = "";

        var urlquery = url_default.a.parse(window.location.href).query;
        var query = urlquery.split("&");
        for (var every = 0; every < query.length; every++) {
          if (query[every].indexOf("uuid=") !== -1) {
            uuid = query[every].replace("uuid=", "");
          }
          if (query[every].indexOf("type=") !== -1) {
            type = query[every].replace("type=", "");
          }
        }
        this.uuid = uuid;
        this.type = type;
        this.get({
          url: 'v1/posture/reports/' + uuid,
          params: {
            type: type
          },
          success: function success(result) {
            _this.updateReportData({
              reportData: result
            });
            _this.getReportData();
          },
          error: function error(data) {
            _this.loading = false;
            _this.valid = false;
          }
        });
      } else {
        _this.getReportData();
      }
    },
    getReportData: function getReportData(state) {
      this.loading = false;
      var reportData = state.vux.reportData;
      var that = this;
      weixin_js_sdk_default.a.miniProgram.getEnv(function (res) {

        if (res.miniprogram) {
          that.isWechat = true;
        } else {
          that.isWechat = false;
        }
      });

      this.qrImage = reportData.solutions;

      var customer = reportData.customer;
      var header = reportData.header;
      var user = reportData.user;
      var coverInfo = {};
      if (lodash_default.a.isNull(header)) {
        coverInfo.date = "--";
        coverInfo.time = "--";
      } else {
        coverInfo.date = moment_default()(header.creationTime).format("YYYY-MM-DD");
        coverInfo.time = moment_default()(header.creationTime).format("hh:mm");
      }

      if (lodash_default.a.isNull(user)) {
        coverInfo.userName = "--";
      } else {
        coverInfo.userName = user.name;
      }

      if (lodash_default.a.isNull(customer)) {
        coverInfo.customerName = "--";
      } else {
        coverInfo.customerName = customer.name;
      }

      this.coverInfo = coverInfo;

      this.conclusion = reportData.conclusion;
      var conclusion = this.conclusion;

      var points = {
        face: conclusion.face.points,
        side: assign_default()(conclusion.side.points, {
          side: conclusion.side.side
        })
      };
      this.points = points;

      var photos = {
        face: reportData.face,
        side: reportData.side
      };
      this.photos = photos;
      this.reportData = reportData;
    }
  }), Object(vuex_esm["b" /* mapActions */])(["get"]), Object(vuex_esm["c" /* mapMutations */])(["updateReportData"])),
  created: function created() {
    bone_default.a.init(this.descripName, this.boneDescription, this.details);
    this.initReportData();
    console.log(" this.reportData:", bone_default.a);
    for (var i = 0; i < Posture_report_navList.length; i++) {
      Posture_report_navList[i].text = this.navList[i].text;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3986d8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_report.vue
var Posture_report_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "swiper-slide",
    [
      _c(
        "swiper",
        { ref: "postureBoneSwiper", attrs: { options: _vm.swiperOptions } },
        [
          _c("div", {
            staticClass:
              "swiper-pagination postureS-swiper-pagination content-row content-row-around",
            attrs: { slot: "pagination" },
            slot: "pagination"
          }),
          _vm._v(" "),
          _c("swiper-slide", [
            _c("div", { staticClass: "swiper-slide tab-content" }, [
              _c("div", { staticClass: "content-row content-row-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "pc_marginTop",
                    staticStyle: { height: "30rem" }
                  },
                  [
                    _c("canvas", {
                      staticStyle: { height: "100%" },
                      attrs: { id: "faceBone", height: "1100", width: "600" }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.bodyPart.faceNormal == false
                  ? _c("span", { staticClass: "bone-desc" }, [
                      _c("div", { staticClass: "p1" }, [
                        _c("span", { staticClass: "radiodot" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radiodotfont" }, [
                          _vm._v(_vm._s(_vm.$t("redAlert")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "p2" }, [
                        _c("span", { staticClass: "radiodot" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radiodotfont" }, [
                          _vm._v(_vm._s(_vm.$t("yellowAlert")))
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.bodyPart.faceNormal == true
                  ? _c("span", { staticClass: "body_normal" }, [
                      _vm._v(
                        _vm._s(_vm.$t("muscleDire.face")) +
                          _vm._s(_vm.$t("muscleDire.normal"))
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c("swiper-slide", [
            _c("div", { staticClass: "swiper-slide tab-content" }, [
              _c("div", { staticClass: "content-row content-row-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "pc_marginTop",
                    staticStyle: { height: "30rem" }
                  },
                  [
                    _c("canvas", {
                      staticStyle: { height: "100%" },
                      attrs: { id: "sideBone", height: "1100", width: "600" }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.bodyPart.sideNormal == false
                  ? _c("span", { staticClass: "bone-desc" }, [
                      _c("div", { staticClass: "p1" }, [
                        _c("span", { staticClass: "radiodot" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radiodotfont" }, [
                          _vm._v(_vm._s(_vm.$t("redAlert")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "p2" }, [
                        _c("span", { staticClass: "radiodot" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radiodotfont" }, [
                          _vm._v(_vm._s(_vm.$t("yellowAlert")))
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.bodyPart.sideNormal == true
                  ? _c("span", { staticClass: "body_normal" }, [
                      _vm._v(
                        _vm._s(_vm.$t("muscleDire.side")) +
                          _vm._s(_vm.$t("muscleDire.normal"))
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c("swiper-slide", [
            _c("div", { staticClass: "swiper-slide tab-content" }, [
              _c("div", { staticClass: "content-row content-row-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "pc_marginTop",
                    staticStyle: { height: "30rem" }
                  },
                  [
                    _c("canvas", {
                      staticStyle: { height: "100%" },
                      attrs: { id: "backBone", height: "1100", width: "600" }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.bodyPart.backNormal == false
                  ? _c("span", { staticClass: "bone-desc" }, [
                      _c("div", { staticClass: "p1" }, [
                        _c("span", { staticClass: "radiodot" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radiodotfont" }, [
                          _vm._v(_vm._s(_vm.$t("redAlert")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "p2" }, [
                        _c("span", { staticClass: "radiodot" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radiodotfont" }, [
                          _vm._v(_vm._s(_vm.$t("yellowAlert")))
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.bodyPart.backNormal == true
                  ? _c("span", { staticClass: "body_normal" }, [
                      _vm._v(
                        _vm._s(_vm.$t("muscleDire.back")) +
                          _vm._s(_vm.$t("muscleDire.normal"))
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var Posture_report_staticRenderFns = []
Posture_report_render._withStripped = true
var Posture_report_esExports = { render: Posture_report_render, staticRenderFns: Posture_report_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Posture_report = (Posture_report_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c3986d8a", Posture_report_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Posture_report.vue
var Posture_report_disposed = false
function Posture_report_injectStyle (ssrContext) {
  if (Posture_report_disposed) return
  __webpack_require__("/G0s")
}
var Posture_report_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Posture_report___vue_template_functional__ = false
/* styles */
var Posture_report___vue_styles__ = Posture_report_injectStyle
/* scopeId */
var Posture_report___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Posture_report___vue_module_identifier__ = null
var Posture_report_Component = Posture_report_normalizeComponent(
  components_Posture_report,
  selectortype_template_index_0_src_components_Posture_report,
  Posture_report___vue_template_functional__,
  Posture_report___vue_styles__,
  Posture_report___vue_scopeId__,
  Posture_report___vue_module_identifier__
)
Posture_report_Component.options.__file = "src/components/Posture_report.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c3986d8a", Posture_report_Component.options)
  } else {
    hotAPI.reload("data-v-c3986d8a", Posture_report_Component.options)
  }
  module.hot.dispose(function (data) {
    Posture_report_disposed = true
  })
})()}

/* harmony default export */ var src_components_Posture_report = (Posture_report_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-video-player/dist/vue-video-player.js
var vue_video_player = __webpack_require__("iqGf");
var vue_video_player_default = /*#__PURE__*/__webpack_require__.n(vue_video_player);

// EXTERNAL MODULE: ./node_modules/timers-browserify/main.js
var main = __webpack_require__("162o");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Risk_ItemVideo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__("5LIk");
__webpack_require__("g3Gj");

var Risk_ItemVideo_img = __webpack_require__("nXJ6");
//console.log("img:",img)



/* harmony default export */ var Risk_ItemVideo = ({
    components: {
        videoPlayer: vue_video_player["videoPlayer"]
    },
    name: 'Risk_ItemVideo',
    props: ['videoUrl', 'pauseVideo', 'cover'],
    data: function data() {
        return {
            video: '',
            playerOptions: {
                autoplay: false,
                preload: 'auto',
                teachOrder: ['flash', 'html5'],
                muted: false,
                language: 'en',
                aspectRatio: '4:3',
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [{
                    type: "video/mp4",
                    // mp4
                    src: this.videoUrl
                    // webm
                    // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
                }],
                //poster: "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",
                poster: this.cover

            }
        };
    },

    watch: {
        pauseVideo: function pauseVideo() {
            if (this.pauseVideo) {
                //console.log("this.pausevie item:L",this.pauseVideo)
                this.$refs.videoPlayerRisk.player.pause();
            }
        }
    },
    computed: {
        player: function player() {
            return this.$refs.videoPlayerRisk.player;
        }
    },
    methods: {
        // listen event
        onPlayerPlay: function onPlayerPlay(player) {
            //console.log('player play!', player,player.paused())


            this.$emit('changeIsPause');
        },
        onPlayerPause: function onPlayerPause(player) {
            //console.log('player pause!', player)
        },
        onPlayerEnded: function onPlayerEnded(player) {
            // //console.log('player ended!', player)
        },
        onPlayerLoadeddata: function onPlayerLoadeddata(player) {
            // //console.log('player Loadeddata!', player)
        },
        onPlayerWaiting: function onPlayerWaiting(player) {
            // //console.log('player Waiting!', player)
        },
        onPlayerPlaying: function onPlayerPlaying(player) {
            // //console.log('player Playing!', player)
        },
        onPlayerTimeupdate: function onPlayerTimeupdate(player) {
            // //console.log('player Timeupdate!', player.currentTime())
        },
        onPlayerCanplay: function onPlayerCanplay(player) {
            // //console.log('player Canplay!', player)
        },
        onPlayerCanplaythrough: function onPlayerCanplaythrough(player) {
            // //console.log('player Canplaythrough!', player)
        },

        // or listen state event
        playerStateChanged: function playerStateChanged(playerCurrentState) {
            // //console.log('player current update state', playerCurrentState)
        },

        // player is ready
        playerReadied: function playerReadied(player) {
            // seek to 10s
            //console.log('example player 1 readied', player)
            player.currentTime(10);
            // //console.log('example 01: the player is readied', player)
        }
    },
    created: function created() {},
    mounted: function mounted() {
        var _this2 = this;

        var video = jquery_default()("video")[0];
        var _this = this;
        jquery_default()(".vjs-big-play-button").css("cssText", "height:2rem !important;line-height:2rem !important;width:3rem;left:54%;top:55%;");
        jquery_default()(".vjs-poster").css("background-size", '100% 84%');
        jquery_default()(".video-js").css("background", "#fff");
        jquery_default()(".vjs-poster").css("background-color", "#fff");
        //$(".vjs-control-bar").css("opacity","1")
        //$(".vjs-poster").css("height",'88%')
        //$(".vjs-control-bar").css("opacity","1")
        /*   $(".vjs-poster").css("top","28px")
           $(".vjs-poster").css("height",'88%')
          $(".vjs-poster").css("right","-1px")
          $(".video-js").css("background","#fff")
          $(".video-js").css("top","-14px")
          $(".vjs-tech").css("top","-5px")
          $(".vjs-control-bar").css("opacity","1")
          $(".vjs-control-bar").css("bottom","0") */

        jquery_default()('.vjs-paused,.vjs-playing').on('touchend', function () {
            var video = jquery_default()("video")[0];
            var isPlay = video.paused;

            Object(main["setTimeout"])(function () {
                if (isPlay) {
                    video.pause();
                } else {
                    video.play();
                }
                //console.log("isplay:",isPlay)
            }, 400);
        });
        jquery_default()(".vjs-fullscreen-control").on("touchend", function (event) {

            Object(main["setTimeout"])(function () {
                // $('.vjs-paused,.vjs-playing').trigger("touchend")
                //_this.$refs.videoPlayerRisk.player.isFu
                // $(".vjs-fullscreen-control").trigger("touchend")

            }, 200);
        });
        Object(main["setTimeout"])(function () {
            //console.log('dynamic change options', this.player)
            _this2.player.muted(false);
        }, 5000);
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Risk_ItemVideo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

__webpack_require__("5LIk");
__webpack_require__("g3Gj");

var components_Risk_ItemVideo_img = __webpack_require__("nXJ6");
//console.log("img:",img)



/* harmony default export */ var components_Risk_ItemVideo = ({
    components: {
        videoPlayer: vue_video_player["videoPlayer"]
    },
    name: 'Risk_ItemVideo',
    props: ['videoUrl', 'pauseVideo', 'cover'],
    data: function data() {
        return {
            video: '',
            playerOptions: {
                autoplay: false,
                preload: 'auto',
                teachOrder: ['flash', 'html5'],
                muted: false,
                language: 'en',
                aspectRatio: '4:3',
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [{
                    type: "video/mp4",
                    // mp4
                    src: this.videoUrl
                    // webm
                    // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
                }],
                //poster: "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",
                poster: this.cover

            }
        };
    },

    watch: {
        pauseVideo: function pauseVideo() {
            if (this.pauseVideo) {
                //console.log("this.pausevie item:L",this.pauseVideo)
                this.$refs.videoPlayerRisk.player.pause();
            }
        }
    },
    computed: {
        player: function player() {
            return this.$refs.videoPlayerRisk.player;
        }
    },
    methods: {
        // listen event
        onPlayerPlay: function onPlayerPlay(player) {
            //console.log('player play!', player,player.paused())


            this.$emit('changeIsPause');
        },
        onPlayerPause: function onPlayerPause(player) {
            //console.log('player pause!', player)
        },
        onPlayerEnded: function onPlayerEnded(player) {
            // //console.log('player ended!', player)
        },
        onPlayerLoadeddata: function onPlayerLoadeddata(player) {
            // //console.log('player Loadeddata!', player)
        },
        onPlayerWaiting: function onPlayerWaiting(player) {
            // //console.log('player Waiting!', player)
        },
        onPlayerPlaying: function onPlayerPlaying(player) {
            // //console.log('player Playing!', player)
        },
        onPlayerTimeupdate: function onPlayerTimeupdate(player) {
            // //console.log('player Timeupdate!', player.currentTime())
        },
        onPlayerCanplay: function onPlayerCanplay(player) {
            // //console.log('player Canplay!', player)
        },
        onPlayerCanplaythrough: function onPlayerCanplaythrough(player) {
            // //console.log('player Canplaythrough!', player)
        },

        // or listen state event
        playerStateChanged: function playerStateChanged(playerCurrentState) {
            // //console.log('player current update state', playerCurrentState)
        },

        // player is ready
        playerReadied: function playerReadied(player) {
            // seek to 10s
            //console.log('example player 1 readied', player)
            player.currentTime(10);
            // //console.log('example 01: the player is readied', player)
        }
    },
    created: function created() {},
    mounted: function mounted() {
        var _this2 = this;

        var video = jquery_default()("video")[0];
        var _this = this;
        jquery_default()(".vjs-big-play-button").css("cssText", "height:2rem !important;line-height:2rem !important;width:3rem;left:54%;top:55%;");
        jquery_default()(".vjs-poster").css("background-size", '100% 84%');
        jquery_default()(".video-js").css("background", "#fff");
        jquery_default()(".vjs-poster").css("background-color", "#fff");
        //$(".vjs-control-bar").css("opacity","1")
        //$(".vjs-poster").css("height",'88%')
        //$(".vjs-control-bar").css("opacity","1")
        /*   $(".vjs-poster").css("top","28px")
           $(".vjs-poster").css("height",'88%')
          $(".vjs-poster").css("right","-1px")
          $(".video-js").css("background","#fff")
          $(".video-js").css("top","-14px")
          $(".vjs-tech").css("top","-5px")
          $(".vjs-control-bar").css("opacity","1")
          $(".vjs-control-bar").css("bottom","0") */

        jquery_default()('.vjs-paused,.vjs-playing').on('touchend', function () {
            var video = jquery_default()("video")[0];
            var isPlay = video.paused;

            Object(main["setTimeout"])(function () {
                if (isPlay) {
                    video.pause();
                } else {
                    video.play();
                }
                //console.log("isplay:",isPlay)
            }, 400);
        });
        jquery_default()(".vjs-fullscreen-control").on("touchend", function (event) {

            Object(main["setTimeout"])(function () {
                // $('.vjs-paused,.vjs-playing').trigger("touchend")
                //_this.$refs.videoPlayerRisk.player.isFu
                // $(".vjs-fullscreen-control").trigger("touchend")

            }, 200);
        });
        Object(main["setTimeout"])(function () {
            //console.log('dynamic change options', this.player)
            _this2.player.muted(false);
        }, 5000);
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7329a470","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Risk_ItemVideo.vue
var Risk_ItemVideo_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "content-row content-row-column content-align-start h5video",
      staticStyle: { padding: "0.8rem 0.8rem 0 0.8rem" }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { width: "100%" } },
        [
          _c("videoPlayer", {
            ref: "videoPlayerRisk",
            staticClass: "vjs-custom-skin",
            staticStyle: { background: "none", width: "100%", height: "100%" },
            attrs: { options: _vm.playerOptions },
            on: {
              play: function($event) {
                _vm.onPlayerPlay($event)
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var Risk_ItemVideo_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "font-14 riskdetail",
        staticStyle: {
          margin: "0.8rem 0 0",
          padding: "2px 7px 4px 0",
          "line-height": "25px"
        }
      },
      [
        _c("div", { staticClass: "riskdetailicon" }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              color: "#fd6364",
              "margin-left": "1.7rem",
              "margin-top": "4px"
            }
          },
          [_vm._v("症状解读")]
        )
      ]
    )
  }
]
Risk_ItemVideo_render._withStripped = true
var Risk_ItemVideo_esExports = { render: Risk_ItemVideo_render, staticRenderFns: Risk_ItemVideo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Risk_ItemVideo = (Risk_ItemVideo_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7329a470", Risk_ItemVideo_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Risk_ItemVideo.vue
var Risk_ItemVideo_disposed = false
function Risk_ItemVideo_injectStyle (ssrContext) {
  if (Risk_ItemVideo_disposed) return
  __webpack_require__("I0OA")
}
var Risk_ItemVideo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Risk_ItemVideo___vue_template_functional__ = false
/* styles */
var Risk_ItemVideo___vue_styles__ = Risk_ItemVideo_injectStyle
/* scopeId */
var Risk_ItemVideo___vue_scopeId__ = "data-v-7329a470"
/* moduleIdentifier (server only) */
var Risk_ItemVideo___vue_module_identifier__ = null
var Risk_ItemVideo_Component = Risk_ItemVideo_normalizeComponent(
  components_Risk_ItemVideo,
  selectortype_template_index_0_src_components_Risk_ItemVideo,
  Risk_ItemVideo___vue_template_functional__,
  Risk_ItemVideo___vue_styles__,
  Risk_ItemVideo___vue_scopeId__,
  Risk_ItemVideo___vue_module_identifier__
)
Risk_ItemVideo_Component.options.__file = "src/components/Risk_ItemVideo.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7329a470", Risk_ItemVideo_Component.options)
  } else {
    hotAPI.reload("data-v-7329a470", Risk_ItemVideo_Component.options)
  }
  module.hot.dispose(function (data) {
    Risk_ItemVideo_disposed = true
  })
})()}

/* harmony default export */ var src_components_Risk_ItemVideo = (Risk_ItemVideo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_modal.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Posture_modal = ({
  name: "Posture_modal",
  i18n: {
    // `i18n` option, setup locale info for component
    messages: extends_default()({}, postureModal)
  },
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {
    Risk_ItemVideo: src_components_Risk_ItemVideo
  },
  props: ["modalInfo", "isUpdate"],
  data: function data() {
    return {
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      },
      pauseVideo: false,
      lang: this.$i18n.locale == "cn" ? true : false
    };
  },

  computed: {},
  methods: {
    getRiskImg: function getRiskImg(risk) {
      var direction = "normal";
      var img = void 0;
      console.log(risk.key);
      if (!lodash_default.a.isNull(risk.direction) && risk.key !== "legO" && risk.key !== "legX" && risk.key !== "legXO" && risk.key !== "kneeOverstretch") {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    show: function show() {},

    changeIsPause: function changeIsPause() {
      this.pauseVideo = false;
      console.log("pauseVideo;", this.pauseVideo);
    },
    hideModal: function hideModal() {
      this.pauseVideo = true;
      this.$emit("hideModal");
    },
    initRiskBar: function initRiskBar() {
      this.$emit("initRiskBar");
    },
    getLevel: function getLevel(level) {
      switch (level) {
        case this.level.normal:
          return {
            des: this.$t("normal"),
            className: "level-normal"
          };
        case this.level.mild:
          return {
            des: this.$t("potentialRisk"),
            className: "level-mild"
          };
        case this.level.severe:
          return {
            des: this.$t("highRisk"),
            className: "level-severe"
          };
      }
    }
  },
  created: function created() {
    console.log("model createds:", this.modalInfo);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_modal.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var components_Posture_modal = ({
  name: "Posture_modal",
  i18n: {
    // `i18n` option, setup locale info for component
    messages: extends_default()({}, postureModal)
  },
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {
    Risk_ItemVideo: src_components_Risk_ItemVideo
  },
  props: ["modalInfo", "isUpdate"],
  data: function data() {
    return {
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      },
      pauseVideo: false,
      lang: this.$i18n.locale == "cn" ? true : false
    };
  },

  computed: {},
  methods: {
    getRiskImg: function getRiskImg(risk) {
      var direction = "normal";
      var img = void 0;
      console.log(risk.key);
      if (!lodash_default.a.isNull(risk.direction) && risk.key !== "legO" && risk.key !== "legX" && risk.key !== "legXO" && risk.key !== "kneeOverstretch") {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    show: function show() {},

    changeIsPause: function changeIsPause() {
      this.pauseVideo = false;
      console.log("pauseVideo;", this.pauseVideo);
    },
    hideModal: function hideModal() {
      this.pauseVideo = true;
      this.$emit("hideModal");
    },
    initRiskBar: function initRiskBar() {
      this.$emit("initRiskBar");
    },
    getLevel: function getLevel(level) {
      switch (level) {
        case this.level.normal:
          return {
            des: this.$t("normal"),
            className: "level-normal"
          };
        case this.level.mild:
          return {
            des: this.$t("potentialRisk"),
            className: "level-mild"
          };
        case this.level.severe:
          return {
            des: this.$t("highRisk"),
            className: "level-severe"
          };
      }
    }
  },
  created: function created() {
    console.log("model createds:", this.modalInfo);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-768f2d14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_modal.vue
var Posture_modal_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "content-row content-align-center content-row-between font-16",
        staticStyle: { padding: ".4rem 1rem", background: "#f4f4f4" }
      },
      [
        _c("span", { staticClass: "name-icon" }, [
          _c("span", { staticStyle: { "padding-left": "1.3rem" } }, [
            _vm._v(_vm._s(_vm.$t("potentialRisk")))
          ])
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "back-btn", on: { click: _vm.hideModal } }, [
          _vm._v(_vm._s(_vm.$t("goback")))
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "content-row content-row-column risk-box",
        staticStyle: { padding: ".5rem", "border-top": ".1rem solid #ededed" }
      },
      [
        _c(
          "div",
          {
            staticClass: "content-row content-row-between content-align-center",
            staticStyle: {
              padding: ".5rem .9rem",
              background: "#cbe7ff",
              "border-radius": ".3rem"
            }
          },
          [
            _c("div", {
              staticClass: "compare-img",
              attrs: { id: "modalBody" }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "compare-img",
              attrs: { src: _vm.getRiskImg(_vm.modalInfo) }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "content-row content-align-center content-row-around",
            staticStyle: { "margin-top": "1rem", padding: "0 1rem" }
          },
          [
            _c("div", { staticClass: "content-row content-row-column" }, [
              _c(
                "div",
                {
                  staticClass:
                    "content-row content-row-between content-align-center"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "font-16",
                      staticStyle: { "margin-right": ".5rem" }
                    },
                    [_vm._v(_vm._s(_vm.modalInfo.name))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "font-14",
                      staticStyle: { color: "#8d8d8d" }
                    },
                    [_vm._v(_vm._s(_vm.modalInfo.detail))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      class:
                        "level-box mobilerisk " +
                        _vm.getLevel(_vm.modalInfo.level).className +
                        " font-12"
                    },
                    [_vm._v(_vm._s(_vm.getLevel(_vm.modalInfo.level).des))]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content-row content-align-end",
                  staticStyle: { width: "100%", height: "2rem" }
                },
                [
                  _c("canvas", {
                    attrs: {
                      "data-value": _vm.modalInfo.value,
                      "data-level": _vm.modalInfo.level,
                      id: "modalRiskBar"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "content-row content-row-between font-16 hmnClass",
                  staticStyle: { padding: "0 .5rem" }
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 2)))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 1)))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 0)))])
                ]
              )
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "content-row content-row-column content-align-start",
        staticStyle: { padding: "0 .8rem" }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "content-row content-align-center font-14 risk-head auto-width",
            staticStyle: { margin: ".8rem 0" }
          },
          [
            _c("span", { staticClass: "potentialRisk-icon" }),
            _vm._v(" "),
            _c("span", { staticStyle: { color: "#fd6364" } }, [
              _vm._v(_vm._s(_vm.$t("triggersymptoms")))
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { width: "100%", "padding-bottom": "5rem" } },
          _vm._l(_vm.modalInfo.risks, function(key) {
            return _c("div", [
              _c("div", { staticClass: "key-name font-14" }, [
                _vm._v(_vm._s(key.name))
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "potential-risk-box font-14" }, [
                _c("li", [_vm._v(_vm._s(key.des))])
              ])
            ])
          }),
          0
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "content-row content-align-center content-row-center close-box"
      },
      [_c("span", { staticClass: "close-btn", on: { click: _vm.hideModal } })]
    )
  ])
}
var Posture_modal_staticRenderFns = []
Posture_modal_render._withStripped = true
var Posture_modal_esExports = { render: Posture_modal_render, staticRenderFns: Posture_modal_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Posture_modal = (Posture_modal_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-768f2d14", Posture_modal_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Posture_modal.vue
var Posture_modal_disposed = false
function Posture_modal_injectStyle (ssrContext) {
  if (Posture_modal_disposed) return
  __webpack_require__("go2v")
}
var Posture_modal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Posture_modal___vue_template_functional__ = false
/* styles */
var Posture_modal___vue_styles__ = Posture_modal_injectStyle
/* scopeId */
var Posture_modal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Posture_modal___vue_module_identifier__ = null
var Posture_modal_Component = Posture_modal_normalizeComponent(
  components_Posture_modal,
  selectortype_template_index_0_src_components_Posture_modal,
  Posture_modal___vue_template_functional__,
  Posture_modal___vue_styles__,
  Posture_modal___vue_scopeId__,
  Posture_modal___vue_module_identifier__
)
Posture_modal_Component.options.__file = "src/components/Posture_modal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-768f2d14", Posture_modal_Component.options)
  } else {
    hotAPI.reload("data-v-768f2d14", Posture_modal_Component.options)
  }
  module.hot.dispose(function (data) {
    Posture_modal_disposed = true
  })
})()}

/* harmony default export */ var src_components_Posture_modal = (Posture_modal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture.vue



































window.cur_index = 0;
var Posture_bullets = [{
  text: '首页',
  bulletClassName: 'pagination-bullet font-12',
  containerClassName: 'hidden-pagination',
  iconClassName: ''
}, {
  text: '体态数据',
  bulletClassName: 'pagination-bullet font-12',
  containerClassName: '',
  iconClassName: 'pagination-icon pagination-face'
}, {
  text: '风险评估',
  bulletClassName: 'pagination-bullet font-12',
  containerClassName: '',
  iconClassName: 'pagination-icon pagination-riskassess'
}, {
  text: '肌肉状态',
  bulletClassName: 'pagination-bullet font-12',
  containerClassName: '',
  iconClassName: 'pagination-icon pagination-bone'
}];
var viwesNav = [{
  text: '正面',
  bulletClassName: 'pagination-bullet view-flant',
  containerClassName: '',
  iconClassName: 'pagination-icon pagination-views'
}, {
  text: '侧面',
  bulletClassName: 'pagination-bullet view-side',
  containerClassName: '',
  iconClassName: 'pagination-icon pagination-views'
}];

/* harmony default export */ var Posture = ({
  name: 'posture',
  i18n: { // `i18n` option, setup locale info for component
    messages: extends_default()({}, posture)
  },
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {
    Qrcode: node_modules_vux_src_components_qrcode,
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    Previewer: vux_src_components_previewer,
    Loading: vux_src_components_loading,
    bModal: modal["a" /* default */],
    bTabs: tabs["a" /* default */],
    bTab: tab["a" /* default */],
    bCard: card["a" /* default */],
    Posture_symp: src_components_Posture_symp,
    Posture_front: src_components_Posture_front,
    Posture_flank: src_components_Posture_flank,
    Posture_home: src_components_Posture_home,
    Posture_report: src_components_Posture_report,
    Symp_item: src_components_Symp_item,
    Posture_modal: src_components_Posture_modal
  },
  data: function data() {
    var _this2 = this;

    return {
      bullets: [{
        text: this.$t('bullet.home'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: 'hidden-pagination',
        iconClassName: ''
      }, {
        text: this.$t('bullet.Posturedata'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-face'
      }, {
        text: this.$t('bullet.Score'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-riskassess'
      }, {
        text: this.$t('bullet.Muscle'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-bone'
      }, {
        text: this.$t('bullet.Solution'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-symptom'
      }],
      viwesNav: [{
        text: this.$tc('viwesNav', 0),
        bulletClassName: 'pagination-bullet view-flant',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-views'
      }, {
        text: this.$tc('viwesNav', 1),
        bulletClassName: 'pagination-bullet view-side',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-views'
      }],
      isUpdate: false,
      shelter: false,
      valid: true,
      loading: true,
      updateSwiper: false,
      containerSwiper: 0,
      qrCode: false,
      reportData: {},
      last_nav: false,
      touchJump: false,
      appopen: false,
      customer: {},
      viewIndex: 1,
      swiperOption: {
        allowTouchMove: false,
        pagination: {
          el: '.posture-swiper-pagination',
          clickable: true,
          renderBullet: function renderBullet(index, className) {
            var display = "";
            console.log(Posture_bullets[index].containerClassName);
            return '<div style="' + display + '" v-on:click="drawBone(' + index + (')" class="content-row content-row-column content-align-center content-row-around ' + Posture_bullets[index].containerClassName + ' ' + className + '">') + ('<div class="' + Posture_bullets[index].iconClassName + '"></div>') + ('<span class="' + Posture_bullets[index].bulletClassName + '">' + Posture_bullets[index].text + '</span>') + '</div>';
          }
        },
        on: {
          init: function init() {
            document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0;
          },

          transitionEnd: function transitionEnd(event) {},
          transitionStart: function transitionStart() {},

          slidePrevTransitionStart: function slidePrevTransitionStart() {

            this.activeIndex == 0 ? document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0 : '';
          },
          sliderMove: function sliderMove(event) {

            /*  let x = sessionStorage.getItem("x");
            let y = sessionStorage.getItem("y");
            
            let newX = event.touches[0].pageX;
            let newY = event.touches[0].pageY;
            let containerSwiper = sessionStorage.getItem("containerSwiper");
            
            sessionStorage.setItem('dis','-1' )
            if((containerSwiper ==3 ) &&(x - newX > 10)){
            this.touchJump=true;
            sessionStorage.setItem('dis',x - newX )
            }else{
            this.touchJump = false;
            }
            */

          },
          touchEnd: function touchEnd() {
            _this2.start();
            /*  let dis = sessionStorage.getItem("dis");
            let containerSwiper = sessionStorage.getItem("containerSwiper");
            if((containerSwiper ==3 ) && (dis > 0)) {
            this.getSolutions();
            } */
          },
          touchStart: function touchStart(event) {
            /*  this.stop();
            let containerSwiper = sessionStorage.getItem("containerSwiper");
            let x = event.touches[0].pageX;
            let y = event.touches[0].pageY;
            
            this.touchJump=false;
            sessionStorage.setItem('x', x)
            sessionStorage.setItem('y', y)
            
            
            if(containerSwiper == 4){
            this.getSolutions();
            } */
          },

          slideChangeTransitionStart: function slideChangeTransitionStart() {

            sessionStorage.setItem('cur_index', this.activeIndex);
            sessionStorage.setItem('containerSwiper', this.activeIndex);
          },
          slideChangeTransitionEnd: function slideChangeTransitionEnd() {
            _this2.containerSwiper = sessionStorage.getItem("containerSwiper");
          },
          tap: function tap() {},
          click: function click() {
            var cur_index = sessionStorage.getItem("cur_index");
            var jumpTime = sessionStorage.getItem("jumpTime");
            sessionStorage.setItem('containerSwiper', cur_index);
            _this2.containerSwiper = cur_index;

            _this2.touchJump = false;

            /*  this.$refs.postureSwiper.swiper.allowSlideNext=true;
            if(cur_index == 3){
            this.$refs.postureSwiper.swiper.allowSlideNext=false;
            } */
          },
          slideChange: function slideChange(index) {
            var cur_index = sessionStorage.getItem("cur_index");

            if (_this2.activeIndex === 0) {

              document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0;
            } else {
              /* if(this.isWechat){
              this.showMini = true;
              }else{
              this.showMini = false;
              } */
              document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 1;
            }
            if (cur_index == 2 || cur_index == 4 || cur_index == 1) {
              _this2.updateSwiper = true;
            }
            /* if(cur_index == 1 ){
            if(this.isWechat){
            this.showMini = false;
            }
            
            } */
          }
        }
      },
      swiperOptionview: {
        allowTouchMove: true,
        autoplay: false,
        pagination: {
          el: '.postureView-swiper-pagination',
          clickable: true,
          renderBullet: function renderBullet(index, className) {

            return '<div  style="width:100px;"  class="content-row content-row-column content-align-center ' + 'views' + index + (' content-row-around ' + viwesNav[index].containerClassName + ' ' + className + '">') + '<div style = "height:2px;"></div>' + ('<span style="position:absolute" class="' + viwesNav[index].bulletClassName + '">' + viwesNav[index].text + '</span>') + ('<div style="height: 0.14rem;" class="' + viwesNav[index].iconClassName + '"></div>') + '</div>';
          }
        },
        on: {
          init: function init() {},

          allowSlidePrev: function allowSlidePrev() {},
          transitionEnd: function transitionEnd(event) {},
          transitionStart: function transitionStart() {},
          slidePrevTransitionStart: function slidePrevTransitionStart() {},
          touchStart: function touchStart() {
            /*  ////console.log("touchStart:",this.activeIndex)
            let touchIndex = this.activeIndex;
            sessionStorage.setItem('view', this.activeIndex) : '' */
            sessionStorage.setItem('views_index', this.activeIndex);
          },
          touchEnd: function touchEnd() {
            var viewsIndex = sessionStorage.getItem('views_index');
            _this2.viewsIndex = viewsIndex;
          },
          slideNextTransitionStart: function slideNextTransitionStart() {},
          slideChangeTransitionStart: function slideChangeTransitionStart() {},
          click: function click() {},
          slideChange: function slideChange(index) {
            /*  let cur_index = sessionStorage.getItem("cur_index")
            
            if (this.activeIndex === 0) {
            this.showMini = false;
            
            document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0
            } else {
            if(this.isWechat){
            this.showMini = true;
            }else{
            this.showMini = false;
            }
            document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 1
            }
            if ((cur_index == 2) || (cur_index == 4) || (cur_index == 1)) {
            this.updateSwiper = true;
            }
            if(cur_index == 1 ){
            if(this.isWechat){
            this.showMini = false;
            }
            
            } */
          }
        }
      },
      normalRisks: [],
      mildRisks: [],
      severeRisks: [],
      symptoms: {
        head: [{
          name: '头部侧倾',
          key: 'headSidesway',
          normal: {
            left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
            normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
          },
          definition: '在直立过程中，头部向左或右倾斜的现象。',
          harm: {
            bone: '颈椎侧屈',
            muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
            neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
            des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
          },
          risks: [{
            name: '肌肉韧带慢性劳损',
            des: '长期头侧倾容易导致颈后韧带、颈周围肌肉的慢性劳损。'
          }, {
            name: '颈椎病',
            des: '由于头部异位导致颈部软组织、骨骼的异常，增大了颈椎病患病风险。'
          }]
        }, {
          name: '头部前倾',
          key: 'headLean',
          normal: {
            normal: imgSrc_default.a.risk_normal.HEAD_LEAN
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
          },
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '椎弓变直或出现反弓',
            muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
            neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
            des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
          },
          risks: [{
            name: '头晕头痛',
            des: '头部前倾可能影响头部血液循环，由于血流不畅而导致头部缺氧，引发头晕头痛。'
          }, {
            name: '颈椎病',
            des: '长期的重度头部前倾可能会导致颈椎病。'
          }]
        }],
        shoulder: [{
          name: '高低肩',
          key: 'highLowShoulder',
          normal: {
            left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
            normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
          },
          definition: '肩峰左右高度差超过2CM则为高低肩。',
          harm: {
            bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
            muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
            neurovascular: '',
            des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
          },
          risks: [{
            name: '慢性头痛',
            des: '长期的高低肩容易产生颈肩部位、头部的慢性疼痛。'
          }, {
            name: '骨刺',
            des: '高低肩使颈椎受力异常，最后可能导致颈椎部位退化，易形成骨刺。'
          }, {
            name: '腰痛',
            des: '高低肩可能造成骨盆的移位，使腰部肌力不平衡，导致腰痛。'
          }, {
            name: '长短腿',
            des: '由于高低肩造成的骨盆移位可能会使腿长发生变化。'
          }]
        }, {
          name: '圆肩',
          key: 'roundShoulder',
          normal: {
            normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
          },
          definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
          harm: {
            bone: '肩胛骨外展、胸廓变小',
            muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
            neurovascular: '',
            des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
          },
          risks: [{
            name: '心脏负担加重',
            des: '过度圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉被压迫，使心脏工作负担加重。'
          }, {
            name: '头痛',
            des: '肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起头痛。'
          }, {
            name: '手臂麻木',
            des: '肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起手臂麻木。'
          }]
        }],
        trunk: [{
          name: '脊柱异位',
          key: 'spineSidesway',
          normal: {
            left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
            normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
          },
          definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
          harm: {
            bone: '脊柱出现S型弯曲或C型弯曲',
            muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
            neurovascular: '',
            des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
          },
          risks: [{
            name: '脊柱侧弯',
            des: '平面拍摄检测出脊柱异位提示您需进一步通过三维检测，确定是否存在脊柱侧弯的症状。'
          }, {
            name: '高低肩',
            des: '脊柱侧弯可能伴随高低肩症状。'
          }, {
            name: '骨盆侧倾',
            des: '脊柱侧弯可能伴随骨盆侧倾症状。'
          }]
        }],
        pelvis: [{
          name: '骨盆侧倾',
          key: 'pelvisLean',
          normal: {
            left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
            right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
            normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
            right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
          },
          definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
          harm: {
            bone: '骨盆倾斜',
            muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
            neurovascular: '',
            des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
          },
          risks: [{
            name: '慢性疼痛',
            des: '骨盆侧倾可能会引发腰腿疼痛、肩颈疼痛。'
          }, {
            name: '腰椎间盘突出',
            des: '骨盆侧倾可能加重腰椎间盘突出风险。'
          }, {
            name: '长短腿',
            des: '骨盆侧倾可能加重长短腿风险。。'
          }]
        }],
        'lower extremity': [{
          name: 'O型腿',
          key: 'legO',
          normal: {
            normal: imgSrc_default.a.risk_normal.LEG_O
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.LEG_O
          },
          definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
          harm: {
            bone: 'O型腿（膝内翻）',
            muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
            neurovascular: '',
            des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
          },
          risks: [{
            name: '半月板损伤',
            des: 'O型腿造成下肢力线发生改变，膝关节内侧间隙承受大于正常负荷的压力。可能引起膝关节内侧半月板损伤。'
          }, {
            name: '关节炎',
            des: '严重O型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n' + '置换手术。'
          }]
        }, {
          name: 'X型腿',
          key: 'legX',
          normal: {
            normal: imgSrc_default.a.risk_normal.LEG_X
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.LEG_X
          },
          definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
          harm: {
            bone: 'X型腿（膝外翻）',
            muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
            neurovascular: '',
            des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
          },
          risks: [{
            name: '半月板损伤',
            des: 'X型腿造成下肢力线发生改变，膝关节外侧间隙承受大于正常负荷的压力。可能引起膝关节外侧半月板损伤。'
          }, {
            name: '关节炎',
            des: '严重X型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n' + '置换手术。'
          }]
        }, {
          name: '膝过伸',
          key: 'kneeOverstretch',
          normal: {
            normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
          },
          definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
          harm: {
            bone: '踝关节背屈不足，使膝关节无法向前移动',
            muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
            neurovascular: '',
            des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
          },
          risks: [{
            name: '膝关节退变',
            des: '长期膝关节过伸，会引起膝关节的过度磨损，加大膝关节退变的发生率。'
          }, {
            name: '损害全身平衡',
            des: '膝关节位置的改变会引起髋关节、骨盆、踝关节的位置异常，由此逐渐损害全身的平衡状态，长期累积会引发各种体态异常。'
          }]
        }, {
          name: 'XO型腿',
          key: 'legXO',
          normal: {
            normal: imgSrc_default.a.risk_normal.LEG_XO
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.LEG_XO
          },
          definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
          harm: {
            bone: '这个是XO型腿',
            muscle: '这个是XO型腿',
            neurovascular: '',
            des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
          },
          risks: [{
            name: '膝关节疼痛',
            des: '由于XO型腿造成股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛。'
          }, {
            name: '膝关节炎',
            des: '重度XO型腿最终可能发展为膝关节骨性关节炎。'
          }]
        }]
      },
      level: {
        normal: 'normal',
        mild: 'mild',
        severe: 'severe'
      },
      risks: {},
      points: null,
      photos: null,
      coverInfo: {},
      modalInfo: null,
      keyMap: {
        face: {
          headSidesway: {
            position: ['neck', 'nose'],
            scale: 0.5
          },
          highLowShoulder: {
            position: ['shoulder-left', 'shoulder-right'],
            scale: 0.3
          },
          spineSidesway: {
            position: ['elbow-left', 'elbow-right'],
            scale: 0.5
          },
          pelvisLean: {
            position: ['hip-left', 'hip-right'],
            scale: 1.5
          },
          legO: {
            position: ['hip', 'ankle'],
            scale: 0.3
          },
          legX: {
            position: ['hip', 'ankle'],
            scale: 0.3
          },
          legXO: {
            position: ['hip', 'ankle'],
            scale: 0.3
          }
        },
        side: {
          headLean: {
            position: ['neck', 'ear'],
            scale: 0.3
          },
          roundShoulder: {
            position: ['nose', 'elbow'],
            scale: 0
          },
          kneeOverstretch: {
            position: ['hip', 'ankle'],
            scale: 0.3
          }
        }
      },
      canvas: null,
      img: {
        face: null,
        side: null
      },
      isWechat: false,
      uuid: '',
      type: '',
      showMini: false,
      drawFinish: {
        face: false,
        back: false,
        side: false
      }
    };
  },

  watch: {
    locale: function locale() {},
    containerSwiper: function containerSwiper() {
      this.containerSwiper != 0 ? this.last_nav = true : '';
      this.containerSwiper == 0 ? this.last_nav = false : '';

      if (this.isWechat) {
        if (this.containerSwiper == 3) {
          this.$refs.postureSwiper.swiper.allowSlideNext = false;
        } else {
          this.$refs.postureSwiper.swiper.allowSlideNext = true;
        }
      }

      sessionStorage.setItem('dis', '-1');
      if (this.isWechat && this.containerSwiper != 0) {
        this.showMini = true;
      } else {
        this.showMini = false;
      }
    },

    touchJump: function touchJump() {
      if (this.touchJump == true) {}
    },
    appopen: function appopen() {}
  },
  computed: {
    swiper: function swiper() {
      return this.$refs.postureSwiper.swiper;
    }
  },
  methods: extends_default()({
    changeLang: function changeLang(lang) {
      console.log("lang", lang);
    },
    stop: function stop() {
      this.$refs.Posture_bone.stop();
    },
    start: function start() {
      this.$refs.Posture_bone.start();
    },
    testClick: function testClick() {},
    updateSwiperIndex: function updateSwiperIndex(data) {
      this.updateSwiper = data;
    },
    getRiskImg: function getRiskImg(risk) {

      var direction = 'normal';
      var img = void 0;

      if (!lodash_default.a.isNull(risk.direction) && risk.key !== 'legO' && risk.key !== 'legX' && risk.key !== 'legXO' && risk.key !== 'kneeOverstretch') {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    getSolutions: function getSolutions() {

      var _this = this;
      if (this.isWechat) {

        weixin_js_sdk_default.a.miniProgram.navigateTo({
          url: '../solution/solution?uuid=' + this.uuid + '&type=' + this.type,
          success: function success() {
            _this.qrCode = false;
          },
          fail: function fail() {
            _this.qrCode = true;
          },
          complete: function complete() {}
        });
      } else {

        this.qrCode = true;
        _this.appopen = true;
      }
    },
    setModalInfo: function setModalInfo(risk) {
      var that = this;
      this.modalInfo = risk;
      this.isUpdate = true;

      this.$store.commit('updateUrl', risk.video);
      this.setSymptomCanvasModal(risk);
      this.$nextTick(function () {
        that.$refs.riskModalRef.show();
        var canvas = that.canvas;

        document.getElementById('modalBody').innerHTML = '';
        document.getElementById('modalBody').appendChild(canvas);
      });
    },
    setSymptomCanvasModal: function setSymptomCanvasModal(risk) {
      var points = this.points;
      var needDetail = ['legO', 'legX', 'legXO'];
      var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

      var riskKey = risk.key;
      var keyMap = this.keyMap;
      var positionArr = void 0;
      var positionPointsArr = [];
      var faceOrSide = void 0;
      var scale = void 0;

      keys_default()(keyMap).forEach(function (direction, index) {
        keys_default()(keyMap[direction]).forEach(function (key, index) {
          if (key === riskKey) {
            positionArr = keyMap[direction][key].position;
            scale = keyMap[direction][key].scale;
          }
        });
      });

      if (needDetail.indexOf(riskKey) !== -1) {

        var lOrR = void 0;
        if (risk.detail === '右腿') {
          lOrR = 'right';
        } else {
          lOrR = 'left';
        }

        for (var i = 0; i < positionArr.length; i++) {
          positionPointsArr.push(points.face[positionArr[i]][lOrR]);
        }

        faceOrSide = 'face';
      } else if (forSide.indexOf(riskKey) !== -1) {

        var _lOrR = this.conclusion.side.side;

        for (var _i = 0; _i < positionArr.length; _i++) {

          if (points.side[positionArr[_i]].left === undefined) {

            positionPointsArr.push(points.side[positionArr[_i]]);
          } else {
            positionPointsArr.push(points.side[positionArr[_i]][_lOrR]);
          }
        }

        faceOrSide = 'side';
      } else {

        for (var _i2 = 0; _i2 < positionArr.length; _i2++) {
          var positionAndDirectionArr = positionArr[_i2].split('-');
          if (positionAndDirectionArr.length === 1) {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
          } else {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
          }
        }

        faceOrSide = 'face';
      }

      var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
      var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
      var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
      var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

      var width = _x > _y ? _x : _y;
      width *= 1 + scale;

      var x = xMid - width / 2;
      var y = yMid - width / 2;

      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.width = width;
      canvas.height = width;

      var img = this.img[faceOrSide];

      ctx.drawImage(img, x, y, width, width, 0, 0, width, width);

      this.canvas = canvas;
    },
    drawBone: function drawBone(idx) {
      var data = this.reportData;

      if (idx === 0) {
        if (this.drawFinish.face === false) {
          bone_default.a.drawFrontBone(data, document.getElementById('faceBone'));
          this.drawFinish.face = true;
        }
      } else if (idx === 1) {
        if (this.drawFinish.side === false) {
          bone_default.a.drawSideBone(data, document.getElementById('sideBone'));
          this.drawFinish.side = true;
        }
      } else if (idx === 2) {
        if (this.drawFinish.back === false) {
          bone_default.a.drawBackBone(data, document.getElementById('backBone'));
          this.drawFinish.back = true;
        }
      }
    },
    shareWechatMini: function shareWechatMini() {

      weixin_js_sdk_default.a.miniProgram.reLaunch({ url: '../index/index' });
    },
    showDeleteButton: function showDeleteButton() {
      var that = this;
      clearInterval(that.Loop);
      that.Loop = setTimeout(function () {}, 1000);
    },
    share: function share() {
      if (this.isWechat) {
        this.shelter = true;
      } else {}
    },
    hideShelter: function hideShelter() {
      this.shelter = false;
    },
    initSolutions: function initSolutions() {},
    setSymptomCanvas: function setSymptomCanvas(option) {
      var canvas = option.el;
      var ctx = canvas.getContext('2d');

      var points = this.points;
      var needDetail = ['legO', 'legX', 'legXO'];
      var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

      var riskKey = canvas.dataset.key;
      var keyMap = this.keyMap;
      var positionArr = void 0;
      var positionPointsArr = [];
      var faceOrSide = void 0;
      var scale = void 0;

      keys_default()(keyMap).forEach(function (direction, index) {
        keys_default()(keyMap[direction]).forEach(function (key, index) {
          if (key === riskKey) {
            positionArr = keyMap[direction][key].position;
            scale = keyMap[direction][key].scale;
          }
        });
      });

      if (needDetail.indexOf(riskKey) !== -1) {

        var lOrR = void 0;
        if (canvas.dataset.detail === '右腿') {
          lOrR = 'right';
        } else {
          lOrR = 'left';
        }

        for (var i = 0; i < positionArr.length; i++) {
          positionPointsArr.push(points.face[positionArr[i]][lOrR]);
        }

        faceOrSide = 'face';
      } else if (forSide.indexOf(riskKey) !== -1) {

        var _lOrR2 = this.conclusion.side.side;

        for (var _i3 = 0; _i3 < positionArr.length; _i3++) {

          if (points.side[positionArr[_i3]].left === undefined) {

            positionPointsArr.push(points.side[positionArr[_i3]]);
          } else {
            positionPointsArr.push(points.side[positionArr[_i3]][_lOrR2]);
          }
        }

        faceOrSide = 'side';
      } else {

        for (var _i4 = 0; _i4 < positionArr.length; _i4++) {
          var positionAndDirectionArr = positionArr[_i4].split('-');
          if (positionAndDirectionArr.length === 1) {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
          } else {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
          }
        }

        faceOrSide = 'face';
      }

      var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
      var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
      var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
      var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

      var width = _x > _y ? _x : _y;
      width *= 1 + scale;

      var x = xMid - width / 2;
      var y = yMid - width / 2;

      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.width = width;
      canvas.height = width;
      var img = new Image();
      img.src = this.photos[faceOrSide];

      img.onload = function () {
        ctx.drawImage(img, x, y, width, width, 0, 0, width, width);
      };
    },
    hideModal: function hideModal() {
      this.$refs.riskModalRef.hide();
      this.isUpdate = false;
    },
    hideSolutionsModal: function hideSolutionsModal() {},
    getLevel: function getLevel(level) {
      switch (level) {
        case this.level.normal:
          return {
            des: '正常',
            className: 'level-normal'
          };
        case this.level.mild:
          return {
            des: '潜在风险',
            className: 'level-mild'
          };
        case this.level.severe:
          return {
            des: '高风险',
            className: 'level-severe'
          };
      }
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    sortHighToLow: function sortHighToLow(arr) {
      return lodash_default.a.orderBy(arr, ['value'], ['desc']);
    },
    slideIn: function slideIn(index) {
      this.swiper.slideTo(index);
    },
    initRiskBar: function initRiskBar() {
      this.$refs.riskModalRef.$el.getElementsByClassName('modal-content')[0].scrollTop = 0;
      var modalRiskBar = document.getElementById('modalRiskBar');
      canvas_default.a.initRiskLevel({
        el: modalRiskBar,
        width: Number(modalRiskBar.parentNode.offsetWidth),
        height: Number(modalRiskBar.parentNode.offsetHeight),
        color: {
          normal: '#00d963',
          mild: '#ffbf00',
          severe: '#ff4d4d'
        },
        level: this.level
      });
    },
    initRisksData: function initRisksData() {
      var risks = this.risks;
      var level = this.level;
      var symptoms = this.symptoms;
      var normalRisks = [];
      var mildRisks = [];
      var severeRisks = [];
      for (var direction in risks) {
        for (var i = 0; i < risks[direction].length; i++) {
          var symptom = symptoms[risks[direction][i].position][risks[direction][i].code - 1];

          if (symptom.value) {
            var otherSymptom = assign_default()({}, symptom);
            if (!risks[direction][i].valid) {
              otherSymptom.raw = 0;
              otherSymptom.value = 0;
              otherSymptom.level = level.normal;
              otherSymptom.detail = '';
              otherSymptom.direction = 'normal';
              otherSymptom.cover = risks[direction][i]['cover'];
              otherSymptom.video = risks[direction][i]['video'];
            } else {
              otherSymptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              otherSymptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              otherSymptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              otherSymptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
              otherSymptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
              otherSymptom.cover = risks[direction][i]['cover'];
              otherSymptom.video = risks[direction][i]['video'];
            }

            symptoms[risks[direction][i].position].push(otherSymptom);
          } else {
            /*   symptom.video = risks[direction][i].video;
            symptom.cover = risks[direction][i].cover; */
            if (!risks[direction][i].valid) {
              symptom.raw = 0;
              symptom.value = 0;
              symptom.level = level.normal;
              symptom.detail = '';
              symptom.direction = 'normal';
              symptom.cover = risks[direction][i]['cover'];
              symptom.video = risks[direction][i]['video'];
            } else {
              symptom.cover = risks[direction][i]['cover'];
              symptom.video = risks[direction][i]['video'];
              symptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              symptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              symptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              symptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
              symptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
            }
          }
        }
      }

      for (var position in symptoms) {
        for (var _i5 = 0; _i5 < symptoms[position].length; _i5++) {
          if (lodash_default.a.isUndefined(symptoms[position][_i5].value)) {
            continue;
          }
          switch (symptoms[position][_i5].level) {
            case level.normal:
              normalRisks.push(symptoms[position][_i5]);
              break;
            case level.mild:
              mildRisks.push(symptoms[position][_i5]);
              break;
            case level.severe:
              severeRisks.push(symptoms[position][_i5]);
              break;
            default:
              normalRisks.push(symptoms[position][_i5]);
              break;
          }
        }
      }

      this.normalRisks = this.sortHighToLow(normalRisks);
      this.mildRisks = this.sortHighToLow(mildRisks);
      this.severeRisks = this.sortHighToLow(severeRisks);
    },
    initRiskPoints: function initRiskPoints() {
      var that = this;
      var points = this.points;
      var photos = this.photos;
      var faceCanvas = document.createElement('canvas');
      var sideCanvas = document.createElement('canvas');
      var _this = this;

      var facePointsArr = [];
      var face = points.face;
      var faceImg = new Image();

      var hipRPoint = face['hip']['right'];
      var hipLPoint = face['hip']['left'];
      var neckPoint = face['neck'];
      var hipMPoint = {
        x: 0,
        y: 0
      };
      var hipAndNeckMPoint = {
        x: 0,
        y: 0
      };
      if (hipLPoint.x === 0 && hipLPoint.y === 0 || hipRPoint.x === 0 && hipRPoint.y === 0) {} else {

        hipMPoint.x = (hipLPoint.x + hipRPoint.x) / 2;
        hipMPoint.y = (hipLPoint.y + hipRPoint.y) / 2;

        if (!(neckPoint.x === 0 && neckPoint.y === 0)) {
          hipAndNeckMPoint.x = (neckPoint.x + hipMPoint.x) / 2;
          hipAndNeckMPoint.y = (neckPoint.y + hipMPoint.y) / 2;
        }
      };

      face.hipM = hipMPoint;
      face.hipAndNeckM = hipAndNeckMPoint;

      var faceOrder = [['ear-right', 'eye-right', 'nose', 'eye-left', 'ear-left'], ['wrist-right', 'elbow-right', 'shoulder-right', 'neck', 'shoulder-left', 'elbow-left', 'wrist-left'], ['ankle-right', 'knee-right', 'hip-right', 'hipM', 'hip-left', 'knee-left', 'ankle-left'], ['neck', 'hipAndNeckM', 'hipM'], ['nose', 'neck']];

      var verticalStandard = ['shoulder-right', 'ankle-middle', 'shoulder-left'];
      var verticalPointsArr = [];

      var risks = this.normalRisks.concat(this.mildRisks, this.severeRisks);

      var faceSymptomWithPosition = ['headSidesway-ear', 'highLowShoulder-shoulder', 'spineSidesway', 'pelvisLean-hip', 'legO-knee', 'legX-knee', 'legXO-knee'];
      var faceHorizontalArr = [];

      faceImg.src = photos.face;
      faceImg.onload = function () {
        that.img.face = faceImg;
      };

      var side = points.side;
      var sidePointsArr = [];
      var sideImg = new Image();

      sideImg.src = photos.side;
      sideImg.onload = function () {
        that.img.side = sideImg;
      };
    },
    initBone: function initBone() {
      var data = this.reportData;
      this.$nextTick(function () {
        bone_default.a.drawFrontBone(data, document.getElementById('faceBone'));
        bone_default.a.drawSideBone(data, document.getElementById('sideBone'));
        bone_default.a.drawBackBone(data, document.getElementById('backBone'));
      });
    },
    drawPoint: function drawPoint(option) {
      var canvas = option.el;
      var point = option.point;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.fillStyle = '#009eff';
      cxt.beginPath();
      cxt.arc(point.x, point.y, 5, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
      cxt.save();
      cxt.fillStyle = 'rgba(83, 158, 255, .3)';
      cxt.beginPath();
      cxt.arc(point.x, point.y, 10, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
    },
    drawLine: function drawLine(option) {

      if (option.points[0].x === 0 && option.points[0].y === 0 || option.points[1].x === 0 && option.points[1].y === 0) {
        return;
      }
      var canvas = option.el;
      var points = option.points;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.lineWidth = 3;
      if (!option.isSide) {
        cxt.strokeStyle = '#5f58f4';
        cxt.beginPath();
        cxt.moveTo(points[0].x, points[0].y);
        cxt.lineTo(points[1].x, points[1].y);
        cxt.closePath();
        cxt.stroke();
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var z = Math.sqrt(Math.pow(_x, 2) + Math.pow(_y, 2));
        var startX = void 0;
        var startY = void 0;
        var endX = void 0;
        var endY = void 0;
        var distance = 80;

        if (points[0].x > points[1].x) {
          startX = Math.round(points[1].x - distance * _x / z);
          startY = Math.round(points[1].y + distance * _y / z);
          endX = Math.round(points[0].x + distance * _x / z);
          endY = Math.round(points[0].y - distance * _y / z);
        } else {
          startX = Math.round(points[0].x - distance * _x / z);
          startY = Math.round(points[0].y - distance * _y / z);
          endX = Math.round(points[1].x + distance * _x / z);
          endY = Math.round(points[1].y + distance * _y / z);
        }

        cxt.strokeStyle = '#0ef8cd';
        cxt.beginPath();
        cxt.moveTo(startX, startY);
        cxt.lineTo(endX, endY);
        cxt.closePath();
        cxt.stroke();
      }

      cxt.restore();
    },
    drawRectAndAngle: function drawRectAndAngle(option) {
      var cxt = option.cxt;
      var angle = option.angle;
      var point = option.point;

      cxt.save();
      if (option.isSecond) {
        cxt.translate(0, 43);
      }
      cxt.save();
      cxt.fillStyle = 'rgba(100, 100, 98, 0.5)';
      cxt.beginPath();
      cxt.moveTo(point.x + 13, point.y + 3);
      cxt.lineTo(point.x + 99, point.y + 3);
      cxt.quadraticCurveTo(point.x + 109, point.y + 3, point.x + 109, point.y + 13);
      cxt.lineTo(point.x + 109, point.y + 33);
      cxt.quadraticCurveTo(point.x + 109, point.y + 43, point.x + 99, point.y + 43);
      cxt.lineTo(point.x + 13, point.y + 43);
      cxt.quadraticCurveTo(point.x + 3, point.y + 43, point.x + 3, point.y + 33);
      cxt.lineTo(point.x + 3, point.y + 13);
      cxt.quadraticCurveTo(point.x + 3, point.y + 3, point.x + 13, point.y + 3);
      cxt.closePath();
      cxt.fill();
      cxt.restore();

      cxt.save();
      cxt.font = '34px Arial';
      cxt.fillStyle = '#0cfcca';
      cxt.textAlign = 'center';
      if (option.isTrunk) {
        cxt.fillText(angle + '%', point.x + 56, point.y + 38);
      } else {
        cxt.fillText(angle + '\xB0', point.x + 56, point.y + 38);
      }
      cxt.restore();
      cxt.restore();
    },
    drawLineAndAngle: function drawLineAndAngle(option) {
      var canvas = option.el;
      var width = canvas.width;
      var points = option.points;
      var min = option.min - 100;
      var max = option.max + 100;
      var cxt = canvas.getContext('2d');

      for (var i = 0; i < points.length; i++) {
        if (points[i].x === 0 && points[i].y === 0) {
          return;
        }
      }

      if (points.length === 1) {
        this.drawRectAndAngle({
          cxt: cxt,
          angle: (option.angle * 100).toFixed(1),
          point: {
            x: width - 120,
            y: points[0].y
          },
          isSecond: false,
          isTrunk: true
        });
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var startPoint = {};
        var endPoint = {};
        var offsetYL = Number(((points[0].x - min) * _y / _x).toFixed(0));
        var offsetYR = Number(((max - points[1].x) * _y / _x).toFixed(0));

        if (points[0].y < points[1].y) {
          startPoint.x = min;
          startPoint.y = points[0].y - offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y + offsetYR;
        } else {
          startPoint.x = min;
          startPoint.y = points[0].y + offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y - offsetYR;
        }

        cxt.save();
        cxt.strokeStyle = '#14bc9a';
        cxt.beginPath();
        cxt.moveTo(startPoint.x, startPoint.y);
        cxt.lineTo(endPoint.x, endPoint.y);
        cxt.closePath();
        cxt.stroke();
        cxt.restore();

        this.drawRectAndAngle({
          cxt: cxt,
          angle: option.angle.toFixed(1),
          point: {
            x: width - 120,
            y: points[1].y
          },
          isSecond: false
        });

        if (!lodash_default.a.isUndefined(option.secondAngle)) {
          this.drawRectAndAngle({
            cxt: cxt,
            angle: option.secondAngle.toFixed(1),
            point: {
              x: width - 120,
              y: points[1].y
            },
            isSecond: true
          });
        }
      }
    }
  }, Object(vuex_esm["d" /* mapState */])({
    initReportData: function initReportData(state) {
      var reportData = state.vux.reportData;
      var _this = this;

      if (lodash_default.a.isNull(reportData)) {
        var uuid = '';
        var type = '';

        var urlquery = url_default.a.parse(window.location.href).query;
        var query = urlquery.split('&');
        for (var every = 0; every < query.length; every++) {
          if (query[every].indexOf('uuid=') !== -1) {
            uuid = query[every].replace('uuid=', '');
          }
          if (query[every].indexOf('type=') !== -1) {
            type = query[every].replace('type=', '');
          }
        }
        this.uuid = uuid;
        this.type = type;
        console.log({
          url: 'v1/posture/reports/' + uuid,
          language: this.$i18n.locale
        });
        var language = this.$i18n.locale;
        this.get({
          url: 'v1/posture/reports/' + uuid,
          params: {
            type: type,
            language: language
          },
          success: function success(result) {
            _this.updateReportData({
              reportData: result
            });
            _this.getReportData();
          },
          error: function error(data) {
            _this.loading = false;
            _this.valid = false;
          }
        });
      } else {
        _this.getReportData();
      }
    },
    getReportData: function getReportData(state) {
      this.loading = false;
      var reportData = state.vux.reportData;
      var that = this;
      weixin_js_sdk_default.a.miniProgram.getEnv(function (res) {

        if (res.miniprogram) {
          that.isWechat = true;
        } else {
          that.isWechat = false;
        }
      });

      this.qrImage = reportData.solutions;

      var customer = reportData.customer;
      var header = reportData.header;
      var user = reportData.user;
      var coverInfo = {};
      if (lodash_default.a.isNull(header)) {
        coverInfo.date = '--';
        coverInfo.time = '--';
      } else {
        coverInfo.date = moment_default()(header.creationTime).format('YYYY-MM-DD');
        coverInfo.time = moment_default()(header.creationTime).format('hh:mm');
      }

      if (lodash_default.a.isNull(user)) {
        coverInfo.userName = '--';
      } else {
        coverInfo.userName = user.name;
      }

      if (lodash_default.a.isNull(customer)) {
        coverInfo.customerName = '--';
      } else {
        coverInfo.customerName = customer.name;
      }

      if (lodash_default.a.isNull(header)) {
        coverInfo.logo = '';
      } else {
        coverInfo.logo = header.logo;
      }
      this.coverInfo = coverInfo;

      this.conclusion = reportData.conclusion;
      var conclusion = this.conclusion;
      if (!conclusion.face.valid || !conclusion.side.valid) {
        this.valid = false;
      } else {
        this.risks = {
          face: conclusion.face.risks,
          side: conclusion.side.risks
        };
        this.initRisksData();
        this.$nextTick(function () {
          var riskBodys = document.getElementsByClassName('risk-body');
          for (var i = 0; i < riskBodys.length; i++) {
            this.setSymptomCanvas({
              el: riskBodys[i],
              width: Number(riskBodys[i].parentNode.offsetWidth),
              height: Number(riskBodys[i].parentNode.offsetHeight)
            });
          }
          var riskBars = document.getElementsByClassName('risk-bar');
          for (var _i6 = 0; _i6 < riskBars.length; _i6++) {
            canvas_default.a.initRiskLevel({
              el: riskBars[_i6],
              width: Number(riskBars[_i6].parentNode.offsetWidth),
              height: Number(riskBars[_i6].parentNode.offsetHeight),
              color: {
                normal: '#00d963',
                mild: '#ffbf00',
                severe: '#ff4d4d'
              },
              level: this.level
            });
          }
        });
      }

      var points = {
        face: conclusion.face.points,
        side: assign_default()(conclusion.side.points, { side: conclusion.side.side })
      };
      this.points = points;

      var photos = {
        face: reportData.face,
        side: reportData.side
      };
      this.photos = photos;
      this.reportData = reportData;
      this.initRiskPoints();
    }
  }), {
    GetQueryString: function GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);return null;
    }
  }, Object(vuex_esm["b" /* mapActions */])(['get']), Object(vuex_esm["c" /* mapMutations */])(['updateReportData'])),
  created: function created() {
    this.initReportData();
    var _this = this;
    for (var i = 0; i < Posture_bullets.length; i++) {

      Posture_bullets[i].text = this.bullets[i].text;
    }
    for (var i = 0; i < viwesNav.length; i++) {
      viwesNav[i].text = this.viwesNav[i].text;
    }
    var symptoms = this.symptoms;
    _this.symptoms = assign_default()({}, _this.$t('symptoms'));
    if (this.GetQueryString("muscle") == 'hide') {
      this.MuscleShow = false;
    } else {
      this.MuscleShow = true;
    }
  },
  mounted: function mounted() {
    console.log('bullets:', this.bullets, this.$tc('bullets', 0));
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture.vue



































window.cur_index = 0;
var components_Posture_bullets = [{
  text: '首页',
  bulletClassName: 'pagination-bullet font-12',
  containerClassName: 'hidden-pagination',
  iconClassName: ''
}, {
  text: '体态数据',
  bulletClassName: 'pagination-bullet font-12',
  containerClassName: '',
  iconClassName: 'pagination-icon pagination-face'
}, {
  text: '风险评估',
  bulletClassName: 'pagination-bullet font-12',
  containerClassName: '',
  iconClassName: 'pagination-icon pagination-riskassess'
}, {
  text: '肌肉状态',
  bulletClassName: 'pagination-bullet font-12',
  containerClassName: '',
  iconClassName: 'pagination-icon pagination-bone'
}];
var Posture_viwesNav = [{
  text: '正面',
  bulletClassName: 'pagination-bullet view-flant',
  containerClassName: '',
  iconClassName: 'pagination-icon pagination-views'
}, {
  text: '侧面',
  bulletClassName: 'pagination-bullet view-side',
  containerClassName: '',
  iconClassName: 'pagination-icon pagination-views'
}];

/* harmony default export */ var components_Posture = ({
  name: 'posture',
  i18n: { // `i18n` option, setup locale info for component
    messages: extends_default()({}, posture)
  },
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {
    Qrcode: node_modules_vux_src_components_qrcode,
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    Previewer: vux_src_components_previewer,
    Loading: vux_src_components_loading,
    bModal: modal["a" /* default */],
    bTabs: tabs["a" /* default */],
    bTab: tab["a" /* default */],
    bCard: card["a" /* default */],
    Posture_symp: src_components_Posture_symp,
    Posture_front: src_components_Posture_front,
    Posture_flank: src_components_Posture_flank,
    Posture_home: src_components_Posture_home,
    Posture_report: src_components_Posture_report,
    Symp_item: src_components_Symp_item,
    Posture_modal: src_components_Posture_modal
  },
  data: function data() {
    var _this2 = this;

    return {
      bullets: [{
        text: this.$t('bullet.home'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: 'hidden-pagination',
        iconClassName: ''
      }, {
        text: this.$t('bullet.Posturedata'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-face'
      }, {
        text: this.$t('bullet.Score'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-riskassess'
      }, {
        text: this.$t('bullet.Muscle'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-bone'
      }, {
        text: this.$t('bullet.Solution'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-symptom'
      }],
      viwesNav: [{
        text: this.$tc('viwesNav', 0),
        bulletClassName: 'pagination-bullet view-flant',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-views'
      }, {
        text: this.$tc('viwesNav', 1),
        bulletClassName: 'pagination-bullet view-side',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-views'
      }],
      isUpdate: false,
      shelter: false,
      valid: true,
      loading: true,
      updateSwiper: false,
      containerSwiper: 0,
      qrCode: false,
      reportData: {},
      last_nav: false,
      touchJump: false,
      appopen: false,
      customer: {},
      viewIndex: 1,
      swiperOption: {
        allowTouchMove: false,
        pagination: {
          el: '.posture-swiper-pagination',
          clickable: true,
          renderBullet: function renderBullet(index, className) {
            var display = "";
            console.log(components_Posture_bullets[index].containerClassName);
            return '<div style="' + display + '" v-on:click="drawBone(' + index + (')" class="content-row content-row-column content-align-center content-row-around ' + components_Posture_bullets[index].containerClassName + ' ' + className + '">') + ('<div class="' + components_Posture_bullets[index].iconClassName + '"></div>') + ('<span class="' + components_Posture_bullets[index].bulletClassName + '">' + components_Posture_bullets[index].text + '</span>') + '</div>';
          }
        },
        on: {
          init: function init() {
            document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0;
          },

          transitionEnd: function transitionEnd(event) {},
          transitionStart: function transitionStart() {},

          slidePrevTransitionStart: function slidePrevTransitionStart() {

            this.activeIndex == 0 ? document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0 : '';
          },
          sliderMove: function sliderMove(event) {

            /*  let x = sessionStorage.getItem("x");
            let y = sessionStorage.getItem("y");
            
            let newX = event.touches[0].pageX;
            let newY = event.touches[0].pageY;
            let containerSwiper = sessionStorage.getItem("containerSwiper");
            
            sessionStorage.setItem('dis','-1' )
            if((containerSwiper ==3 ) &&(x - newX > 10)){
            this.touchJump=true;
            sessionStorage.setItem('dis',x - newX )
            }else{
            this.touchJump = false;
            }
            */

          },
          touchEnd: function touchEnd() {
            _this2.start();
            /*  let dis = sessionStorage.getItem("dis");
            let containerSwiper = sessionStorage.getItem("containerSwiper");
            if((containerSwiper ==3 ) && (dis > 0)) {
            this.getSolutions();
            } */
          },
          touchStart: function touchStart(event) {
            /*  this.stop();
            let containerSwiper = sessionStorage.getItem("containerSwiper");
            let x = event.touches[0].pageX;
            let y = event.touches[0].pageY;
            
            this.touchJump=false;
            sessionStorage.setItem('x', x)
            sessionStorage.setItem('y', y)
            
            
            if(containerSwiper == 4){
            this.getSolutions();
            } */
          },

          slideChangeTransitionStart: function slideChangeTransitionStart() {

            sessionStorage.setItem('cur_index', this.activeIndex);
            sessionStorage.setItem('containerSwiper', this.activeIndex);
          },
          slideChangeTransitionEnd: function slideChangeTransitionEnd() {
            _this2.containerSwiper = sessionStorage.getItem("containerSwiper");
          },
          tap: function tap() {},
          click: function click() {
            var cur_index = sessionStorage.getItem("cur_index");
            var jumpTime = sessionStorage.getItem("jumpTime");
            sessionStorage.setItem('containerSwiper', cur_index);
            _this2.containerSwiper = cur_index;

            _this2.touchJump = false;

            /*  this.$refs.postureSwiper.swiper.allowSlideNext=true;
            if(cur_index == 3){
            this.$refs.postureSwiper.swiper.allowSlideNext=false;
            } */
          },
          slideChange: function slideChange(index) {
            var cur_index = sessionStorage.getItem("cur_index");

            if (_this2.activeIndex === 0) {

              document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0;
            } else {
              /* if(this.isWechat){
              this.showMini = true;
              }else{
              this.showMini = false;
              } */
              document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 1;
            }
            if (cur_index == 2 || cur_index == 4 || cur_index == 1) {
              _this2.updateSwiper = true;
            }
            /* if(cur_index == 1 ){
            if(this.isWechat){
            this.showMini = false;
            }
            
            } */
          }
        }
      },
      swiperOptionview: {
        allowTouchMove: true,
        autoplay: false,
        pagination: {
          el: '.postureView-swiper-pagination',
          clickable: true,
          renderBullet: function renderBullet(index, className) {

            return '<div  style="width:100px;"  class="content-row content-row-column content-align-center ' + 'views' + index + (' content-row-around ' + Posture_viwesNav[index].containerClassName + ' ' + className + '">') + '<div style = "height:2px;"></div>' + ('<span style="position:absolute" class="' + Posture_viwesNav[index].bulletClassName + '">' + Posture_viwesNav[index].text + '</span>') + ('<div style="height: 0.14rem;" class="' + Posture_viwesNav[index].iconClassName + '"></div>') + '</div>';
          }
        },
        on: {
          init: function init() {},

          allowSlidePrev: function allowSlidePrev() {},
          transitionEnd: function transitionEnd(event) {},
          transitionStart: function transitionStart() {},
          slidePrevTransitionStart: function slidePrevTransitionStart() {},
          touchStart: function touchStart() {
            /*  ////console.log("touchStart:",this.activeIndex)
            let touchIndex = this.activeIndex;
            sessionStorage.setItem('view', this.activeIndex) : '' */
            sessionStorage.setItem('views_index', this.activeIndex);
          },
          touchEnd: function touchEnd() {
            var viewsIndex = sessionStorage.getItem('views_index');
            _this2.viewsIndex = viewsIndex;
          },
          slideNextTransitionStart: function slideNextTransitionStart() {},
          slideChangeTransitionStart: function slideChangeTransitionStart() {},
          click: function click() {},
          slideChange: function slideChange(index) {
            /*  let cur_index = sessionStorage.getItem("cur_index")
            
            if (this.activeIndex === 0) {
            this.showMini = false;
            
            document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0
            } else {
            if(this.isWechat){
            this.showMini = true;
            }else{
            this.showMini = false;
            }
            document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 1
            }
            if ((cur_index == 2) || (cur_index == 4) || (cur_index == 1)) {
            this.updateSwiper = true;
            }
            if(cur_index == 1 ){
            if(this.isWechat){
            this.showMini = false;
            }
            
            } */
          }
        }
      },
      normalRisks: [],
      mildRisks: [],
      severeRisks: [],
      symptoms: {
        head: [{
          name: '头部侧倾',
          key: 'headSidesway',
          normal: {
            left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
            normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
          },
          definition: '在直立过程中，头部向左或右倾斜的现象。',
          harm: {
            bone: '颈椎侧屈',
            muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
            neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
            des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
          },
          risks: [{
            name: '肌肉韧带慢性劳损',
            des: '长期头侧倾容易导致颈后韧带、颈周围肌肉的慢性劳损。'
          }, {
            name: '颈椎病',
            des: '由于头部异位导致颈部软组织、骨骼的异常，增大了颈椎病患病风险。'
          }]
        }, {
          name: '头部前倾',
          key: 'headLean',
          normal: {
            normal: imgSrc_default.a.risk_normal.HEAD_LEAN
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
          },
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '椎弓变直或出现反弓',
            muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
            neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
            des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
          },
          risks: [{
            name: '头晕头痛',
            des: '头部前倾可能影响头部血液循环，由于血流不畅而导致头部缺氧，引发头晕头痛。'
          }, {
            name: '颈椎病',
            des: '长期的重度头部前倾可能会导致颈椎病。'
          }]
        }],
        shoulder: [{
          name: '高低肩',
          key: 'highLowShoulder',
          normal: {
            left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
            normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
          },
          definition: '肩峰左右高度差超过2CM则为高低肩。',
          harm: {
            bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
            muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
            neurovascular: '',
            des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
          },
          risks: [{
            name: '慢性头痛',
            des: '长期的高低肩容易产生颈肩部位、头部的慢性疼痛。'
          }, {
            name: '骨刺',
            des: '高低肩使颈椎受力异常，最后可能导致颈椎部位退化，易形成骨刺。'
          }, {
            name: '腰痛',
            des: '高低肩可能造成骨盆的移位，使腰部肌力不平衡，导致腰痛。'
          }, {
            name: '长短腿',
            des: '由于高低肩造成的骨盆移位可能会使腿长发生变化。'
          }]
        }, {
          name: '圆肩',
          key: 'roundShoulder',
          normal: {
            normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
          },
          definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
          harm: {
            bone: '肩胛骨外展、胸廓变小',
            muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
            neurovascular: '',
            des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
          },
          risks: [{
            name: '心脏负担加重',
            des: '过度圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉被压迫，使心脏工作负担加重。'
          }, {
            name: '头痛',
            des: '肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起头痛。'
          }, {
            name: '手臂麻木',
            des: '肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起手臂麻木。'
          }]
        }],
        trunk: [{
          name: '脊柱异位',
          key: 'spineSidesway',
          normal: {
            left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
            normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
          },
          definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
          harm: {
            bone: '脊柱出现S型弯曲或C型弯曲',
            muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
            neurovascular: '',
            des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
          },
          risks: [{
            name: '脊柱侧弯',
            des: '平面拍摄检测出脊柱异位提示您需进一步通过三维检测，确定是否存在脊柱侧弯的症状。'
          }, {
            name: '高低肩',
            des: '脊柱侧弯可能伴随高低肩症状。'
          }, {
            name: '骨盆侧倾',
            des: '脊柱侧弯可能伴随骨盆侧倾症状。'
          }]
        }],
        pelvis: [{
          name: '骨盆侧倾',
          key: 'pelvisLean',
          normal: {
            left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
            right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
            normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
            right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
          },
          definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
          harm: {
            bone: '骨盆倾斜',
            muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
            neurovascular: '',
            des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
          },
          risks: [{
            name: '慢性疼痛',
            des: '骨盆侧倾可能会引发腰腿疼痛、肩颈疼痛。'
          }, {
            name: '腰椎间盘突出',
            des: '骨盆侧倾可能加重腰椎间盘突出风险。'
          }, {
            name: '长短腿',
            des: '骨盆侧倾可能加重长短腿风险。。'
          }]
        }],
        'lower extremity': [{
          name: 'O型腿',
          key: 'legO',
          normal: {
            normal: imgSrc_default.a.risk_normal.LEG_O
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.LEG_O
          },
          definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
          harm: {
            bone: 'O型腿（膝内翻）',
            muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
            neurovascular: '',
            des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
          },
          risks: [{
            name: '半月板损伤',
            des: 'O型腿造成下肢力线发生改变，膝关节内侧间隙承受大于正常负荷的压力。可能引起膝关节内侧半月板损伤。'
          }, {
            name: '关节炎',
            des: '严重O型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n' + '置换手术。'
          }]
        }, {
          name: 'X型腿',
          key: 'legX',
          normal: {
            normal: imgSrc_default.a.risk_normal.LEG_X
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.LEG_X
          },
          definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
          harm: {
            bone: 'X型腿（膝外翻）',
            muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
            neurovascular: '',
            des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
          },
          risks: [{
            name: '半月板损伤',
            des: 'X型腿造成下肢力线发生改变，膝关节外侧间隙承受大于正常负荷的压力。可能引起膝关节外侧半月板损伤。'
          }, {
            name: '关节炎',
            des: '严重X型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n' + '置换手术。'
          }]
        }, {
          name: '膝过伸',
          key: 'kneeOverstretch',
          normal: {
            normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
          },
          definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
          harm: {
            bone: '踝关节背屈不足，使膝关节无法向前移动',
            muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
            neurovascular: '',
            des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
          },
          risks: [{
            name: '膝关节退变',
            des: '长期膝关节过伸，会引起膝关节的过度磨损，加大膝关节退变的发生率。'
          }, {
            name: '损害全身平衡',
            des: '膝关节位置的改变会引起髋关节、骨盆、踝关节的位置异常，由此逐渐损害全身的平衡状态，长期累积会引发各种体态异常。'
          }]
        }, {
          name: 'XO型腿',
          key: 'legXO',
          normal: {
            normal: imgSrc_default.a.risk_normal.LEG_XO
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.LEG_XO
          },
          definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
          harm: {
            bone: '这个是XO型腿',
            muscle: '这个是XO型腿',
            neurovascular: '',
            des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
          },
          risks: [{
            name: '膝关节疼痛',
            des: '由于XO型腿造成股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛。'
          }, {
            name: '膝关节炎',
            des: '重度XO型腿最终可能发展为膝关节骨性关节炎。'
          }]
        }]
      },
      level: {
        normal: 'normal',
        mild: 'mild',
        severe: 'severe'
      },
      risks: {},
      points: null,
      photos: null,
      coverInfo: {},
      modalInfo: null,
      keyMap: {
        face: {
          headSidesway: {
            position: ['neck', 'nose'],
            scale: 0.5
          },
          highLowShoulder: {
            position: ['shoulder-left', 'shoulder-right'],
            scale: 0.3
          },
          spineSidesway: {
            position: ['elbow-left', 'elbow-right'],
            scale: 0.5
          },
          pelvisLean: {
            position: ['hip-left', 'hip-right'],
            scale: 1.5
          },
          legO: {
            position: ['hip', 'ankle'],
            scale: 0.3
          },
          legX: {
            position: ['hip', 'ankle'],
            scale: 0.3
          },
          legXO: {
            position: ['hip', 'ankle'],
            scale: 0.3
          }
        },
        side: {
          headLean: {
            position: ['neck', 'ear'],
            scale: 0.3
          },
          roundShoulder: {
            position: ['nose', 'elbow'],
            scale: 0
          },
          kneeOverstretch: {
            position: ['hip', 'ankle'],
            scale: 0.3
          }
        }
      },
      canvas: null,
      img: {
        face: null,
        side: null
      },
      isWechat: false,
      uuid: '',
      type: '',
      showMini: false,
      drawFinish: {
        face: false,
        back: false,
        side: false
      }
    };
  },

  watch: {
    locale: function locale() {},
    containerSwiper: function containerSwiper() {
      this.containerSwiper != 0 ? this.last_nav = true : '';
      this.containerSwiper == 0 ? this.last_nav = false : '';

      if (this.isWechat) {
        if (this.containerSwiper == 3) {
          this.$refs.postureSwiper.swiper.allowSlideNext = false;
        } else {
          this.$refs.postureSwiper.swiper.allowSlideNext = true;
        }
      }

      sessionStorage.setItem('dis', '-1');
      if (this.isWechat && this.containerSwiper != 0) {
        this.showMini = true;
      } else {
        this.showMini = false;
      }
    },

    touchJump: function touchJump() {
      if (this.touchJump == true) {}
    },
    appopen: function appopen() {}
  },
  computed: {
    swiper: function swiper() {
      return this.$refs.postureSwiper.swiper;
    }
  },
  methods: extends_default()({
    changeLang: function changeLang(lang) {
      console.log("lang", lang);
    },
    stop: function stop() {
      this.$refs.Posture_bone.stop();
    },
    start: function start() {
      this.$refs.Posture_bone.start();
    },
    testClick: function testClick() {},
    updateSwiperIndex: function updateSwiperIndex(data) {
      this.updateSwiper = data;
    },
    getRiskImg: function getRiskImg(risk) {

      var direction = 'normal';
      var img = void 0;

      if (!lodash_default.a.isNull(risk.direction) && risk.key !== 'legO' && risk.key !== 'legX' && risk.key !== 'legXO' && risk.key !== 'kneeOverstretch') {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    getSolutions: function getSolutions() {

      var _this = this;
      if (this.isWechat) {

        weixin_js_sdk_default.a.miniProgram.navigateTo({
          url: '../solution/solution?uuid=' + this.uuid + '&type=' + this.type,
          success: function success() {
            _this.qrCode = false;
          },
          fail: function fail() {
            _this.qrCode = true;
          },
          complete: function complete() {}
        });
      } else {

        this.qrCode = true;
        _this.appopen = true;
      }
    },
    setModalInfo: function setModalInfo(risk) {
      var that = this;
      this.modalInfo = risk;
      this.isUpdate = true;

      this.$store.commit('updateUrl', risk.video);
      this.setSymptomCanvasModal(risk);
      this.$nextTick(function () {
        that.$refs.riskModalRef.show();
        var canvas = that.canvas;

        document.getElementById('modalBody').innerHTML = '';
        document.getElementById('modalBody').appendChild(canvas);
      });
    },
    setSymptomCanvasModal: function setSymptomCanvasModal(risk) {
      var points = this.points;
      var needDetail = ['legO', 'legX', 'legXO'];
      var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

      var riskKey = risk.key;
      var keyMap = this.keyMap;
      var positionArr = void 0;
      var positionPointsArr = [];
      var faceOrSide = void 0;
      var scale = void 0;

      keys_default()(keyMap).forEach(function (direction, index) {
        keys_default()(keyMap[direction]).forEach(function (key, index) {
          if (key === riskKey) {
            positionArr = keyMap[direction][key].position;
            scale = keyMap[direction][key].scale;
          }
        });
      });

      if (needDetail.indexOf(riskKey) !== -1) {

        var lOrR = void 0;
        if (risk.detail === '右腿') {
          lOrR = 'right';
        } else {
          lOrR = 'left';
        }

        for (var i = 0; i < positionArr.length; i++) {
          positionPointsArr.push(points.face[positionArr[i]][lOrR]);
        }

        faceOrSide = 'face';
      } else if (forSide.indexOf(riskKey) !== -1) {

        var _lOrR = this.conclusion.side.side;

        for (var _i = 0; _i < positionArr.length; _i++) {

          if (points.side[positionArr[_i]].left === undefined) {

            positionPointsArr.push(points.side[positionArr[_i]]);
          } else {
            positionPointsArr.push(points.side[positionArr[_i]][_lOrR]);
          }
        }

        faceOrSide = 'side';
      } else {

        for (var _i2 = 0; _i2 < positionArr.length; _i2++) {
          var positionAndDirectionArr = positionArr[_i2].split('-');
          if (positionAndDirectionArr.length === 1) {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
          } else {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
          }
        }

        faceOrSide = 'face';
      }

      var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
      var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
      var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
      var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

      var width = _x > _y ? _x : _y;
      width *= 1 + scale;

      var x = xMid - width / 2;
      var y = yMid - width / 2;

      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.width = width;
      canvas.height = width;

      var img = this.img[faceOrSide];

      ctx.drawImage(img, x, y, width, width, 0, 0, width, width);

      this.canvas = canvas;
    },
    drawBone: function drawBone(idx) {
      var data = this.reportData;

      if (idx === 0) {
        if (this.drawFinish.face === false) {
          bone_default.a.drawFrontBone(data, document.getElementById('faceBone'));
          this.drawFinish.face = true;
        }
      } else if (idx === 1) {
        if (this.drawFinish.side === false) {
          bone_default.a.drawSideBone(data, document.getElementById('sideBone'));
          this.drawFinish.side = true;
        }
      } else if (idx === 2) {
        if (this.drawFinish.back === false) {
          bone_default.a.drawBackBone(data, document.getElementById('backBone'));
          this.drawFinish.back = true;
        }
      }
    },
    shareWechatMini: function shareWechatMini() {

      weixin_js_sdk_default.a.miniProgram.reLaunch({ url: '../index/index' });
    },
    showDeleteButton: function showDeleteButton() {
      var that = this;
      clearInterval(that.Loop);
      that.Loop = setTimeout(function () {}, 1000);
    },
    share: function share() {
      if (this.isWechat) {
        this.shelter = true;
      } else {}
    },
    hideShelter: function hideShelter() {
      this.shelter = false;
    },
    initSolutions: function initSolutions() {},
    setSymptomCanvas: function setSymptomCanvas(option) {
      var canvas = option.el;
      var ctx = canvas.getContext('2d');

      var points = this.points;
      var needDetail = ['legO', 'legX', 'legXO'];
      var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

      var riskKey = canvas.dataset.key;
      var keyMap = this.keyMap;
      var positionArr = void 0;
      var positionPointsArr = [];
      var faceOrSide = void 0;
      var scale = void 0;

      keys_default()(keyMap).forEach(function (direction, index) {
        keys_default()(keyMap[direction]).forEach(function (key, index) {
          if (key === riskKey) {
            positionArr = keyMap[direction][key].position;
            scale = keyMap[direction][key].scale;
          }
        });
      });

      if (needDetail.indexOf(riskKey) !== -1) {

        var lOrR = void 0;
        if (canvas.dataset.detail === '右腿') {
          lOrR = 'right';
        } else {
          lOrR = 'left';
        }

        for (var i = 0; i < positionArr.length; i++) {
          positionPointsArr.push(points.face[positionArr[i]][lOrR]);
        }

        faceOrSide = 'face';
      } else if (forSide.indexOf(riskKey) !== -1) {

        var _lOrR2 = this.conclusion.side.side;

        for (var _i3 = 0; _i3 < positionArr.length; _i3++) {

          if (points.side[positionArr[_i3]].left === undefined) {

            positionPointsArr.push(points.side[positionArr[_i3]]);
          } else {
            positionPointsArr.push(points.side[positionArr[_i3]][_lOrR2]);
          }
        }

        faceOrSide = 'side';
      } else {

        for (var _i4 = 0; _i4 < positionArr.length; _i4++) {
          var positionAndDirectionArr = positionArr[_i4].split('-');
          if (positionAndDirectionArr.length === 1) {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
          } else {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
          }
        }

        faceOrSide = 'face';
      }

      var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
      var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
      var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
      var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

      var width = _x > _y ? _x : _y;
      width *= 1 + scale;

      var x = xMid - width / 2;
      var y = yMid - width / 2;

      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.width = width;
      canvas.height = width;
      var img = new Image();
      img.src = this.photos[faceOrSide];

      img.onload = function () {
        ctx.drawImage(img, x, y, width, width, 0, 0, width, width);
      };
    },
    hideModal: function hideModal() {
      this.$refs.riskModalRef.hide();
      this.isUpdate = false;
    },
    hideSolutionsModal: function hideSolutionsModal() {},
    getLevel: function getLevel(level) {
      switch (level) {
        case this.level.normal:
          return {
            des: '正常',
            className: 'level-normal'
          };
        case this.level.mild:
          return {
            des: '潜在风险',
            className: 'level-mild'
          };
        case this.level.severe:
          return {
            des: '高风险',
            className: 'level-severe'
          };
      }
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    sortHighToLow: function sortHighToLow(arr) {
      return lodash_default.a.orderBy(arr, ['value'], ['desc']);
    },
    slideIn: function slideIn(index) {
      this.swiper.slideTo(index);
    },
    initRiskBar: function initRiskBar() {
      this.$refs.riskModalRef.$el.getElementsByClassName('modal-content')[0].scrollTop = 0;
      var modalRiskBar = document.getElementById('modalRiskBar');
      canvas_default.a.initRiskLevel({
        el: modalRiskBar,
        width: Number(modalRiskBar.parentNode.offsetWidth),
        height: Number(modalRiskBar.parentNode.offsetHeight),
        color: {
          normal: '#00d963',
          mild: '#ffbf00',
          severe: '#ff4d4d'
        },
        level: this.level
      });
    },
    initRisksData: function initRisksData() {
      var risks = this.risks;
      var level = this.level;
      var symptoms = this.symptoms;
      var normalRisks = [];
      var mildRisks = [];
      var severeRisks = [];
      for (var direction in risks) {
        for (var i = 0; i < risks[direction].length; i++) {
          var symptom = symptoms[risks[direction][i].position][risks[direction][i].code - 1];

          if (symptom.value) {
            var otherSymptom = assign_default()({}, symptom);
            if (!risks[direction][i].valid) {
              otherSymptom.raw = 0;
              otherSymptom.value = 0;
              otherSymptom.level = level.normal;
              otherSymptom.detail = '';
              otherSymptom.direction = 'normal';
              otherSymptom.cover = risks[direction][i]['cover'];
              otherSymptom.video = risks[direction][i]['video'];
            } else {
              otherSymptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              otherSymptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              otherSymptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              otherSymptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
              otherSymptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
              otherSymptom.cover = risks[direction][i]['cover'];
              otherSymptom.video = risks[direction][i]['video'];
            }

            symptoms[risks[direction][i].position].push(otherSymptom);
          } else {
            /*   symptom.video = risks[direction][i].video;
            symptom.cover = risks[direction][i].cover; */
            if (!risks[direction][i].valid) {
              symptom.raw = 0;
              symptom.value = 0;
              symptom.level = level.normal;
              symptom.detail = '';
              symptom.direction = 'normal';
              symptom.cover = risks[direction][i]['cover'];
              symptom.video = risks[direction][i]['video'];
            } else {
              symptom.cover = risks[direction][i]['cover'];
              symptom.video = risks[direction][i]['video'];
              symptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              symptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              symptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              symptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
              symptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
            }
          }
        }
      }

      for (var position in symptoms) {
        for (var _i5 = 0; _i5 < symptoms[position].length; _i5++) {
          if (lodash_default.a.isUndefined(symptoms[position][_i5].value)) {
            continue;
          }
          switch (symptoms[position][_i5].level) {
            case level.normal:
              normalRisks.push(symptoms[position][_i5]);
              break;
            case level.mild:
              mildRisks.push(symptoms[position][_i5]);
              break;
            case level.severe:
              severeRisks.push(symptoms[position][_i5]);
              break;
            default:
              normalRisks.push(symptoms[position][_i5]);
              break;
          }
        }
      }

      this.normalRisks = this.sortHighToLow(normalRisks);
      this.mildRisks = this.sortHighToLow(mildRisks);
      this.severeRisks = this.sortHighToLow(severeRisks);
    },
    initRiskPoints: function initRiskPoints() {
      var that = this;
      var points = this.points;
      var photos = this.photos;
      var faceCanvas = document.createElement('canvas');
      var sideCanvas = document.createElement('canvas');
      var _this = this;

      var facePointsArr = [];
      var face = points.face;
      var faceImg = new Image();

      var hipRPoint = face['hip']['right'];
      var hipLPoint = face['hip']['left'];
      var neckPoint = face['neck'];
      var hipMPoint = {
        x: 0,
        y: 0
      };
      var hipAndNeckMPoint = {
        x: 0,
        y: 0
      };
      if (hipLPoint.x === 0 && hipLPoint.y === 0 || hipRPoint.x === 0 && hipRPoint.y === 0) {} else {

        hipMPoint.x = (hipLPoint.x + hipRPoint.x) / 2;
        hipMPoint.y = (hipLPoint.y + hipRPoint.y) / 2;

        if (!(neckPoint.x === 0 && neckPoint.y === 0)) {
          hipAndNeckMPoint.x = (neckPoint.x + hipMPoint.x) / 2;
          hipAndNeckMPoint.y = (neckPoint.y + hipMPoint.y) / 2;
        }
      };

      face.hipM = hipMPoint;
      face.hipAndNeckM = hipAndNeckMPoint;

      var faceOrder = [['ear-right', 'eye-right', 'nose', 'eye-left', 'ear-left'], ['wrist-right', 'elbow-right', 'shoulder-right', 'neck', 'shoulder-left', 'elbow-left', 'wrist-left'], ['ankle-right', 'knee-right', 'hip-right', 'hipM', 'hip-left', 'knee-left', 'ankle-left'], ['neck', 'hipAndNeckM', 'hipM'], ['nose', 'neck']];

      var verticalStandard = ['shoulder-right', 'ankle-middle', 'shoulder-left'];
      var verticalPointsArr = [];

      var risks = this.normalRisks.concat(this.mildRisks, this.severeRisks);

      var faceSymptomWithPosition = ['headSidesway-ear', 'highLowShoulder-shoulder', 'spineSidesway', 'pelvisLean-hip', 'legO-knee', 'legX-knee', 'legXO-knee'];
      var faceHorizontalArr = [];

      faceImg.src = photos.face;
      faceImg.onload = function () {
        that.img.face = faceImg;
      };

      var side = points.side;
      var sidePointsArr = [];
      var sideImg = new Image();

      sideImg.src = photos.side;
      sideImg.onload = function () {
        that.img.side = sideImg;
      };
    },
    initBone: function initBone() {
      var data = this.reportData;
      this.$nextTick(function () {
        bone_default.a.drawFrontBone(data, document.getElementById('faceBone'));
        bone_default.a.drawSideBone(data, document.getElementById('sideBone'));
        bone_default.a.drawBackBone(data, document.getElementById('backBone'));
      });
    },
    drawPoint: function drawPoint(option) {
      var canvas = option.el;
      var point = option.point;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.fillStyle = '#009eff';
      cxt.beginPath();
      cxt.arc(point.x, point.y, 5, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
      cxt.save();
      cxt.fillStyle = 'rgba(83, 158, 255, .3)';
      cxt.beginPath();
      cxt.arc(point.x, point.y, 10, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
    },
    drawLine: function drawLine(option) {

      if (option.points[0].x === 0 && option.points[0].y === 0 || option.points[1].x === 0 && option.points[1].y === 0) {
        return;
      }
      var canvas = option.el;
      var points = option.points;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.lineWidth = 3;
      if (!option.isSide) {
        cxt.strokeStyle = '#5f58f4';
        cxt.beginPath();
        cxt.moveTo(points[0].x, points[0].y);
        cxt.lineTo(points[1].x, points[1].y);
        cxt.closePath();
        cxt.stroke();
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var z = Math.sqrt(Math.pow(_x, 2) + Math.pow(_y, 2));
        var startX = void 0;
        var startY = void 0;
        var endX = void 0;
        var endY = void 0;
        var distance = 80;

        if (points[0].x > points[1].x) {
          startX = Math.round(points[1].x - distance * _x / z);
          startY = Math.round(points[1].y + distance * _y / z);
          endX = Math.round(points[0].x + distance * _x / z);
          endY = Math.round(points[0].y - distance * _y / z);
        } else {
          startX = Math.round(points[0].x - distance * _x / z);
          startY = Math.round(points[0].y - distance * _y / z);
          endX = Math.round(points[1].x + distance * _x / z);
          endY = Math.round(points[1].y + distance * _y / z);
        }

        cxt.strokeStyle = '#0ef8cd';
        cxt.beginPath();
        cxt.moveTo(startX, startY);
        cxt.lineTo(endX, endY);
        cxt.closePath();
        cxt.stroke();
      }

      cxt.restore();
    },
    drawRectAndAngle: function drawRectAndAngle(option) {
      var cxt = option.cxt;
      var angle = option.angle;
      var point = option.point;

      cxt.save();
      if (option.isSecond) {
        cxt.translate(0, 43);
      }
      cxt.save();
      cxt.fillStyle = 'rgba(100, 100, 98, 0.5)';
      cxt.beginPath();
      cxt.moveTo(point.x + 13, point.y + 3);
      cxt.lineTo(point.x + 99, point.y + 3);
      cxt.quadraticCurveTo(point.x + 109, point.y + 3, point.x + 109, point.y + 13);
      cxt.lineTo(point.x + 109, point.y + 33);
      cxt.quadraticCurveTo(point.x + 109, point.y + 43, point.x + 99, point.y + 43);
      cxt.lineTo(point.x + 13, point.y + 43);
      cxt.quadraticCurveTo(point.x + 3, point.y + 43, point.x + 3, point.y + 33);
      cxt.lineTo(point.x + 3, point.y + 13);
      cxt.quadraticCurveTo(point.x + 3, point.y + 3, point.x + 13, point.y + 3);
      cxt.closePath();
      cxt.fill();
      cxt.restore();

      cxt.save();
      cxt.font = '34px Arial';
      cxt.fillStyle = '#0cfcca';
      cxt.textAlign = 'center';
      if (option.isTrunk) {
        cxt.fillText(angle + '%', point.x + 56, point.y + 38);
      } else {
        cxt.fillText(angle + '\xB0', point.x + 56, point.y + 38);
      }
      cxt.restore();
      cxt.restore();
    },
    drawLineAndAngle: function drawLineAndAngle(option) {
      var canvas = option.el;
      var width = canvas.width;
      var points = option.points;
      var min = option.min - 100;
      var max = option.max + 100;
      var cxt = canvas.getContext('2d');

      for (var i = 0; i < points.length; i++) {
        if (points[i].x === 0 && points[i].y === 0) {
          return;
        }
      }

      if (points.length === 1) {
        this.drawRectAndAngle({
          cxt: cxt,
          angle: (option.angle * 100).toFixed(1),
          point: {
            x: width - 120,
            y: points[0].y
          },
          isSecond: false,
          isTrunk: true
        });
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var startPoint = {};
        var endPoint = {};
        var offsetYL = Number(((points[0].x - min) * _y / _x).toFixed(0));
        var offsetYR = Number(((max - points[1].x) * _y / _x).toFixed(0));

        if (points[0].y < points[1].y) {
          startPoint.x = min;
          startPoint.y = points[0].y - offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y + offsetYR;
        } else {
          startPoint.x = min;
          startPoint.y = points[0].y + offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y - offsetYR;
        }

        cxt.save();
        cxt.strokeStyle = '#14bc9a';
        cxt.beginPath();
        cxt.moveTo(startPoint.x, startPoint.y);
        cxt.lineTo(endPoint.x, endPoint.y);
        cxt.closePath();
        cxt.stroke();
        cxt.restore();

        this.drawRectAndAngle({
          cxt: cxt,
          angle: option.angle.toFixed(1),
          point: {
            x: width - 120,
            y: points[1].y
          },
          isSecond: false
        });

        if (!lodash_default.a.isUndefined(option.secondAngle)) {
          this.drawRectAndAngle({
            cxt: cxt,
            angle: option.secondAngle.toFixed(1),
            point: {
              x: width - 120,
              y: points[1].y
            },
            isSecond: true
          });
        }
      }
    }
  }, Object(vuex_esm["d" /* mapState */])({
    initReportData: function initReportData(state) {
      var reportData = state.vux.reportData;
      var _this = this;

      if (lodash_default.a.isNull(reportData)) {
        var uuid = '';
        var type = '';

        var urlquery = url_default.a.parse(window.location.href).query;
        var query = urlquery.split('&');
        for (var every = 0; every < query.length; every++) {
          if (query[every].indexOf('uuid=') !== -1) {
            uuid = query[every].replace('uuid=', '');
          }
          if (query[every].indexOf('type=') !== -1) {
            type = query[every].replace('type=', '');
          }
        }
        this.uuid = uuid;
        this.type = type;
        console.log({
          url: 'v1/posture/reports/' + uuid,
          language: this.$i18n.locale
        });
        var language = this.$i18n.locale;
        this.get({
          url: 'v1/posture/reports/' + uuid,
          params: {
            type: type,
            language: language
          },
          success: function success(result) {
            _this.updateReportData({
              reportData: result
            });
            _this.getReportData();
          },
          error: function error(data) {
            _this.loading = false;
            _this.valid = false;
          }
        });
      } else {
        _this.getReportData();
      }
    },
    getReportData: function getReportData(state) {
      this.loading = false;
      var reportData = state.vux.reportData;
      var that = this;
      weixin_js_sdk_default.a.miniProgram.getEnv(function (res) {

        if (res.miniprogram) {
          that.isWechat = true;
        } else {
          that.isWechat = false;
        }
      });

      this.qrImage = reportData.solutions;

      var customer = reportData.customer;
      var header = reportData.header;
      var user = reportData.user;
      var coverInfo = {};
      if (lodash_default.a.isNull(header)) {
        coverInfo.date = '--';
        coverInfo.time = '--';
      } else {
        coverInfo.date = moment_default()(header.creationTime).format('YYYY-MM-DD');
        coverInfo.time = moment_default()(header.creationTime).format('hh:mm');
      }

      if (lodash_default.a.isNull(user)) {
        coverInfo.userName = '--';
      } else {
        coverInfo.userName = user.name;
      }

      if (lodash_default.a.isNull(customer)) {
        coverInfo.customerName = '--';
      } else {
        coverInfo.customerName = customer.name;
      }

      if (lodash_default.a.isNull(header)) {
        coverInfo.logo = '';
      } else {
        coverInfo.logo = header.logo;
      }
      this.coverInfo = coverInfo;

      this.conclusion = reportData.conclusion;
      var conclusion = this.conclusion;
      if (!conclusion.face.valid || !conclusion.side.valid) {
        this.valid = false;
      } else {
        this.risks = {
          face: conclusion.face.risks,
          side: conclusion.side.risks
        };
        this.initRisksData();
        this.$nextTick(function () {
          var riskBodys = document.getElementsByClassName('risk-body');
          for (var i = 0; i < riskBodys.length; i++) {
            this.setSymptomCanvas({
              el: riskBodys[i],
              width: Number(riskBodys[i].parentNode.offsetWidth),
              height: Number(riskBodys[i].parentNode.offsetHeight)
            });
          }
          var riskBars = document.getElementsByClassName('risk-bar');
          for (var _i6 = 0; _i6 < riskBars.length; _i6++) {
            canvas_default.a.initRiskLevel({
              el: riskBars[_i6],
              width: Number(riskBars[_i6].parentNode.offsetWidth),
              height: Number(riskBars[_i6].parentNode.offsetHeight),
              color: {
                normal: '#00d963',
                mild: '#ffbf00',
                severe: '#ff4d4d'
              },
              level: this.level
            });
          }
        });
      }

      var points = {
        face: conclusion.face.points,
        side: assign_default()(conclusion.side.points, { side: conclusion.side.side })
      };
      this.points = points;

      var photos = {
        face: reportData.face,
        side: reportData.side
      };
      this.photos = photos;
      this.reportData = reportData;
      this.initRiskPoints();
    }
  }), {
    GetQueryString: function GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);return null;
    }
  }, Object(vuex_esm["b" /* mapActions */])(['get']), Object(vuex_esm["c" /* mapMutations */])(['updateReportData'])),
  created: function created() {
    this.initReportData();
    var _this = this;
    for (var i = 0; i < components_Posture_bullets.length; i++) {

      components_Posture_bullets[i].text = this.bullets[i].text;
    }
    for (var i = 0; i < Posture_viwesNav.length; i++) {
      Posture_viwesNav[i].text = this.viwesNav[i].text;
    }
    var symptoms = this.symptoms;
    _this.symptoms = assign_default()({}, _this.$t('symptoms'));
    if (this.GetQueryString("muscle") == 'hide') {
      this.MuscleShow = false;
    } else {
      this.MuscleShow = true;
    }
  },
  mounted: function mounted() {
    console.log('bullets:', this.bullets, this.$tc('bullets', 0));
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-480276c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture.vue
var Posture_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "100%" } }, [
    _vm.loading
      ? _c("div", [_c("loading", { attrs: { show: _vm.loading } })], 1)
      : _c("div", { staticStyle: { position: "relative", height: "100%" } }, [
          !_vm.valid
            ? _c("div", {}, [
                _c(
                  "div",
                  {
                    staticClass: "font-20",
                    staticStyle: {
                      position: "fixed",
                      top: "50%",
                      left: "50%",
                      color: "#000",
                      transform: "translate(-50%, -50%)"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("InvalidData")))]
                )
              ])
            : _c(
                "div",
                { staticStyle: { height: "100%" } },
                [
                  _c(
                    "swiper",
                    {
                      ref: "postureSwiper",
                      attrs: { options: _vm.swiperOption }
                    },
                    [
                      _c(
                        "swiper-slide",
                        { staticClass: "cover" },
                        [
                          _c("posture_home", {
                            attrs: { coverInfo: _vm.coverInfo },
                            on: {
                              slideIn: function($event) {
                                _vm.slideIn(1)
                              },
                              changeLang: _vm.changeLang
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "swiper-slide",
                        { staticClass: "pagintaion-space" },
                        [
                          _c(
                            "swiper",
                            {
                              ref: "viewsSwiper",
                              attrs: { options: _vm.swiperOptionview }
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "swiper-pagination postureView-swiper-pagination content-row content-row-view",
                                attrs: { slot: "pagination" },
                                slot: "pagination"
                              }),
                              _vm._v(" "),
                              _c(
                                "swiper-slide",
                                [
                                  _c("Posture_front", {
                                    attrs: {
                                      points: _vm.points,
                                      photos: _vm.photos,
                                      severeRisks: _vm.severeRisks,
                                      mildRisks: _vm.mildRisks,
                                      normalRisks: _vm.normalRisks
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "swiper-slide",
                                [
                                  _c("Posture_flank", {
                                    attrs: {
                                      points: _vm.points,
                                      photos: _vm.photos,
                                      severeRisks: _vm.severeRisks,
                                      mildRisks: _vm.mildRisks,
                                      normalRisks: _vm.normalRisks
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "swiper-slide",
                        { staticStyle: { overflow: "scroll !important" } },
                        [
                          _c("Posture_symp", {
                            attrs: {
                              severeRisks: _vm.severeRisks,
                              mildRisks: _vm.mildRisks,
                              normalRisks: _vm.normalRisks
                            },
                            on: {
                              setModalInfo: _vm.setModalInfo,
                              share: _vm.share,
                              getSolutions: _vm.getSolutions
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.MuscleShow == true
                        ? _c(
                            "swiper-slide",
                            {
                              staticClass: "pagintaion-space",
                              staticStyle: { background: "#e9e9e9" }
                            },
                            [
                              _c("Posture_report", {
                                ref: "Posture_bone",
                                attrs: { updateSwiper: _vm.updateSwiper },
                                on: {
                                  slideIn: _vm.slideIn,
                                  updateSwiper: _vm.updateSwiperIndex
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "swiper-pagination posture-swiper-pagination content-row content-row-around",
                        attrs: { slot: "pagination" },
                        slot: "pagination"
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.modalInfo
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.touchJump == false,
                              expression: "touchJump==false"
                            }
                          ],
                          staticClass: "posture-modal"
                        },
                        [
                          _c(
                            "b-modal",
                            {
                              ref: "riskModalRef",
                              attrs: {
                                size: "lg",
                                title: "Large Modal",
                                "hide-footer": "",
                                "hide-header": ""
                              },
                              on: { shown: _vm.initRiskBar }
                            },
                            [
                              _c("Posture_modal", {
                                attrs: {
                                  modalInfo: _vm.modalInfo,
                                  isUpdate: _vm.isUpdate
                                },
                                on: { hideModal: _vm.hideModal }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
        ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showMini,
            expression: "showMini"
          }
        ]
      },
      [
        _c("div", {
          staticClass: "share-wechat-mini",
          attrs: { id: "shareWechatMini" },
          on: {
            click: function($event) {
              _vm.shareWechatMini()
            }
          }
        })
      ]
    ),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isWechat == true,
          expression: "isWechat==true"
        }
      ],
      attrs: { id: "jumpMiniUrl" },
      on: {
        click: function($event) {
          _vm.getSolutions()
        }
      }
    })
  ])
}
var Posture_staticRenderFns = []
Posture_render._withStripped = true
var Posture_esExports = { render: Posture_render, staticRenderFns: Posture_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Posture = (Posture_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-480276c8", Posture_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Posture.vue
var Posture_disposed = false
function Posture_injectStyle (ssrContext) {
  if (Posture_disposed) return
  __webpack_require__("h4Mb")
}
var Posture_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Posture___vue_template_functional__ = false
/* styles */
var Posture___vue_styles__ = Posture_injectStyle
/* scopeId */
var Posture___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Posture___vue_module_identifier__ = null
var Posture_Component = Posture_normalizeComponent(
  components_Posture,
  selectortype_template_index_0_src_components_Posture,
  Posture___vue_template_functional__,
  Posture___vue_styles__,
  Posture___vue_scopeId__,
  Posture___vue_module_identifier__
)
Posture_Component.options.__file = "src/components/Posture.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-480276c8", Posture_Component.options)
  } else {
    hotAPI.reload("data-v-480276c8", Posture_Component.options)
  }
  module.hot.dispose(function (data) {
    Posture_disposed = true
  })
})()}

/* harmony default export */ var src_components_Posture = (Posture_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Symp_itemIpad.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Symp_itemIpad = ({
  name: "Symp_itemIpad",
  i18n: {
    // `i18n` option, setup locale info for component
    messages: extends_default()({}, sympItemIpad)
  },
  data: function data() {
    return {
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      }
    };
  },

  props: ["riskLevelList", "mClass", "hClass", "tips", "classleve", "nClass", "isShow"],
  methods: {
    getRiskImg: function getRiskImg(risk) {
      var direction = "normal";
      var img = void 0;
      if (!_.isNull(risk.direction) && risk.key !== "legO" && risk.key !== "legX" && risk.key !== "legXO" && risk.key !== "kneeOverstretch") {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },

    setModalInfo: function setModalInfo(risk) {
      this.$emit("setModalInfo", risk);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Symp_itemIpad.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_Symp_itemIpad = ({
  name: "Symp_itemIpad",
  i18n: {
    // `i18n` option, setup locale info for component
    messages: extends_default()({}, sympItemIpad)
  },
  data: function data() {
    return {
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      }
    };
  },

  props: ["riskLevelList", "mClass", "hClass", "tips", "classleve", "nClass", "isShow"],
  methods: {
    getRiskImg: function getRiskImg(risk) {
      var direction = "normal";
      var img = void 0;
      if (!_.isNull(risk.direction) && risk.key !== "legO" && risk.key !== "legX" && risk.key !== "legXO" && risk.key !== "kneeOverstretch") {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },

    setModalInfo: function setModalInfo(risk) {
      this.$emit("setModalInfo", risk);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd4fa69a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Symp_itemIpad.vue
var Symp_itemIpad_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    _vm._l(_vm.riskLevelList, function(risk) {
      return _vm.isShow == true
        ? _c(
            "div",
            {
              staticClass: "content-row content-row-column risk-box",
              staticStyle: { width: "50%", padding: "0 0 .1rem .1rem" },
              on: {
                click: function($event) {
                  _vm.setModalInfo(risk)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "content-row content-align-center content-row-around",
                  staticStyle: {
                    position: "relative",
                    padding: "1rem 3rem 0 1.5rem",
                    background: "#fff"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "4rem",
                        height: "4rem",
                        "border-radius": ".5rem",
                        overflow: "hidden"
                      }
                    },
                    [
                      _c("canvas", {
                        staticClass: "risk-body",
                        attrs: {
                          "data-key": risk.key,
                          "data-detail": risk.detail
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("img", {
                    staticStyle: {
                      "margin-left": ".8rem",
                      width: "4rem",
                      height: "4rem",
                      "border-radius": ".5rem"
                    },
                    attrs: { src: _vm.getRiskImg(risk) }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "content-row content-row-column auto-width",
                      staticStyle: { flex: "1" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "content-row content-align-center",
                          staticStyle: {
                            width: "222px",
                            "margin-left": "1rem",
                            "margin-bottom": ".2rem",
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "font-20",
                              staticStyle: {
                                width: "120px",
                                "margin-right": ".5rem",
                                "white-space": "nowrap",
                                "text-overflow": "ellipsis",
                                overflow: "hidden"
                              }
                            },
                            [_vm._v(_vm._s(risk.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "font-14",
                              staticStyle: {
                                "white-space": "nowrap",
                                "text-overflow": "ellipsis",
                                overflow: "hidden",
                                "margin-right": ".5rem",
                                color: "#8d8d8d"
                              }
                            },
                            [_vm._v(_vm._s(risk.detail))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "level-box level-severe font-12",
                              class: {
                                "level-severe": _vm.hClass,
                                "level-mild": _vm.mClass,
                                "level-normal": _vm.nClass
                              },
                              staticStyle: {
                                "white-space": "nowrap",
                                "text-overflow": "ellipsis",
                                overflow: "hidden"
                              }
                            },
                            [
                              _vm.tips.tip === "高风险"
                                ? _c("p", [
                                    _vm._v(_vm._s(_vm.$t("heightRisk")))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.tips.tip === "潜在风险"
                                ? _c("p", [
                                    _vm._v(_vm._s(_vm.$t("potentialRisk")))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.tips.tip === "正常"
                                ? _c("p", [_vm._v(_vm._s(_vm.$t("normal")))])
                                : _vm._e()
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "content-row content-align-end",
                          staticStyle: {
                            "margin-left": "1rem",
                            height: "1.5rem"
                          }
                        },
                        [
                          _c("canvas", {
                            staticClass: "risk-bar",
                            attrs: {
                              "data-value": risk.value,
                              "data-level": risk.level
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "content-row content-row-between font-16 ItemClass",
                          staticStyle: {
                            "margin-left": "1rem",
                            width: "9rem",
                            padding: "0 .5rem"
                          }
                        },
                        [
                          _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 2)))]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 1)))]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 0)))])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content-row",
                  staticStyle: {
                    padding: ".8rem 3.3rem 1rem 1.5rem",
                    background: "#fff"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "content-row font-12",
                      staticStyle: {
                        color: "#949494",
                        "flex-wrap": "nowrap",
                        overflow: "hidden"
                      }
                    },
                    _vm._l(risk.risks, function(key) {
                      return _c(
                        "span",
                        {
                          staticClass: "key-box-risk",
                          staticStyle: { "white-space": "nowrap" }
                        },
                        [_vm._v(_vm._s(key.name))]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm._m(0, true)
                ]
              )
            ]
          )
        : _vm._e()
    }),
    0
  )
}
var Symp_itemIpad_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "content-row-end content-align-end",
        staticStyle: { height: "1rem", "margin-bottom": ".8rem" }
      },
      [_c("div", { staticClass: "down-arrow" })]
    )
  }
]
Symp_itemIpad_render._withStripped = true
var Symp_itemIpad_esExports = { render: Symp_itemIpad_render, staticRenderFns: Symp_itemIpad_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Symp_itemIpad = (Symp_itemIpad_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bd4fa69a", Symp_itemIpad_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Symp_itemIpad.vue
var Symp_itemIpad_disposed = false
function Symp_itemIpad_injectStyle (ssrContext) {
  if (Symp_itemIpad_disposed) return
  __webpack_require__("wiIv")
}
var Symp_itemIpad_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Symp_itemIpad___vue_template_functional__ = false
/* styles */
var Symp_itemIpad___vue_styles__ = Symp_itemIpad_injectStyle
/* scopeId */
var Symp_itemIpad___vue_scopeId__ = "data-v-bd4fa69a"
/* moduleIdentifier (server only) */
var Symp_itemIpad___vue_module_identifier__ = null
var Symp_itemIpad_Component = Symp_itemIpad_normalizeComponent(
  components_Symp_itemIpad,
  selectortype_template_index_0_src_components_Symp_itemIpad,
  Symp_itemIpad___vue_template_functional__,
  Symp_itemIpad___vue_styles__,
  Symp_itemIpad___vue_scopeId__,
  Symp_itemIpad___vue_module_identifier__
)
Symp_itemIpad_Component.options.__file = "src/components/Symp_itemIpad.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bd4fa69a", Symp_itemIpad_Component.options)
  } else {
    hotAPI.reload("data-v-bd4fa69a", Symp_itemIpad_Component.options)
  }
  module.hot.dispose(function (data) {
    Symp_itemIpad_disposed = true
  })
})()}

/* harmony default export */ var src_components_Symp_itemIpad = (Symp_itemIpad_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_sympipad.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Posture_sympipad = ({
  name: "Posture_sympipad",
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {
    Symp_itemIpad: src_components_Symp_itemIpad
  },
  props: ["severeRisks", "mildRisks", "normalRisks"],
  i18n: {
    // `i18n` option, setup locale info for component
    messages: extends_default()({}, postureSympIpad)
  },
  data: function data() {
    return {
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      },
      tips: {
        riskCount: 0,
        riskTip: "风险"
      },
      isShow: false,
      riskLevelList: [],
      hClass: false,
      mClass: false,
      nClass: false,
      classleve: "normal",
      ntips: {
        tip: "正常"
      },
      mtips: {
        tip: "潜在风险"
      }
    };
  },

  computed: {},
  methods: {
    getRiskImg: function getRiskImg(risk) {
      var direction = "normal";
      var img = void 0;
      console.log(risk.key);
      if (!lodash_default.a.isNull(risk.direction) && risk.key !== "legO" && risk.key !== "legX" && risk.key !== "legXO" && risk.key !== "kneeOverstretch") {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    setModalInfo: function setModalInfo(risk) {
      this.$emit("setModalInfo", risk);
    }
  },
  created: function created() {
    var riskTips = {},
        riskCount = 0,
        riskTip = "";

    if (this.severeRisks.length > 0) {
      riskCount = this.severeRisks.length;
      riskTip = "高风险";
      this.isShow = true;
      this.hClass = true;
      riskTips.tip = riskTip;
      this.classleve = "severe";
      this.riskLevelList = this.severeRisks;
    } else if (this.mildRisks.length > 0) {
      riskCount = this.mildRisks.length;
      riskTip = "潜在风险";
      this.isShow = false;
      this.mClass = true;
      riskTips.tip = riskTip;
      this.classleve = "mild";
      this.riskLevelList = this.mildRisks;
    } else {
      riskCount = this.normalRisks.length;
      riskTip = "风险";
      this.isShow = false;
      this.nClass = true;
    }
    riskTips.riskCount = riskCount;
    riskTips.riskTip = riskTip;
    this.tips = assign_default()({}, riskTips);
    console.log("this.riskTipsddddddddddddddddd:", this.tips);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_sympipad.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var components_Posture_sympipad = ({
  name: "Posture_sympipad",
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {
    Symp_itemIpad: src_components_Symp_itemIpad
  },
  props: ["severeRisks", "mildRisks", "normalRisks"],
  i18n: {
    // `i18n` option, setup locale info for component
    messages: extends_default()({}, postureSympIpad)
  },
  data: function data() {
    return {
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      },
      tips: {
        riskCount: 0,
        riskTip: "风险"
      },
      isShow: false,
      riskLevelList: [],
      hClass: false,
      mClass: false,
      nClass: false,
      classleve: "normal",
      ntips: {
        tip: "正常"
      },
      mtips: {
        tip: "潜在风险"
      }
    };
  },

  computed: {},
  methods: {
    getRiskImg: function getRiskImg(risk) {
      var direction = "normal";
      var img = void 0;
      console.log(risk.key);
      if (!lodash_default.a.isNull(risk.direction) && risk.key !== "legO" && risk.key !== "legX" && risk.key !== "legXO" && risk.key !== "kneeOverstretch") {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    setModalInfo: function setModalInfo(risk) {
      this.$emit("setModalInfo", risk);
    }
  },
  created: function created() {
    var riskTips = {},
        riskCount = 0,
        riskTip = "";

    if (this.severeRisks.length > 0) {
      riskCount = this.severeRisks.length;
      riskTip = "高风险";
      this.isShow = true;
      this.hClass = true;
      riskTips.tip = riskTip;
      this.classleve = "severe";
      this.riskLevelList = this.severeRisks;
    } else if (this.mildRisks.length > 0) {
      riskCount = this.mildRisks.length;
      riskTip = "潜在风险";
      this.isShow = false;
      this.mClass = true;
      riskTips.tip = riskTip;
      this.classleve = "mild";
      this.riskLevelList = this.mildRisks;
    } else {
      riskCount = this.normalRisks.length;
      riskTip = "风险";
      this.isShow = false;
      this.nClass = true;
    }
    riskTips.riskCount = riskCount;
    riskTips.riskTip = riskTip;
    this.tips = assign_default()({}, riskTips);
    console.log("this.riskTipsddddddddddddddddd:", this.tips);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cc4265a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_sympipad.vue
var Posture_sympipad_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container-box" }, [
      _c(
        "div",
        {
          staticClass: "content-row content-align-center",
          staticStyle: { background: "#fff" }
        },
        [
          _c("div", { staticClass: "hasrisk-icon" }),
          _vm._v(" "),
          _c("div", { staticStyle: { color: "#0170a6" } }, [
            _vm._v("\n        " + _vm._s(_vm.$t("detection")) + "\n        "),
            _c(
              "span",
              {
                staticClass: "font-24",
                staticStyle: { margin: "0 .5rem", color: "#fe5b3f" }
              },
              [_vm._v(_vm._s(_vm.tips.riskCount))]
            ),
            _vm._v("\n        " + _vm._s(_vm.$t("item")) + "\n      ")
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { overflow: "hidden" } }, [
        _c("div", { staticStyle: { margin: "0 -.1rem" } }, [
          _c(
            "div",
            {
              staticClass: "content-row",
              staticStyle: {
                background: "#e2edff",
                "flex-wrap": "wrap",
                padding: ".1rem  .1rem 0 0"
              }
            },
            [
              _c("Symp_itemIpad", {
                attrs: {
                  riskLevelList: _vm.riskLevelList,
                  tips: _vm.tips,
                  classleve: _vm.classleve,
                  mClass: _vm.mClass,
                  nClass: false,
                  isShow: true,
                  hClass: _vm.hClass
                },
                on: { setModalInfo: _vm.setModalInfo }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content-row content-align-center",
          staticStyle: { background: "#fff" }
        },
        [
          _c("div", { staticClass: "norisk-icon" }),
          _vm._v(" "),
          _c("div", { staticStyle: { color: "#0170a6" } }, [
            _vm._v(_vm._s(_vm.$t("otherDetecation")))
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { overflow: "hidden" } }, [
        _c("div", { staticStyle: { margin: "0 -.1rem" } }, [
          _c(
            "div",
            {
              staticClass: "content-row",
              staticStyle: {
                background: "#e2edff",
                "flex-wrap": "wrap",
                padding: ".1rem  .1rem 0 0"
              }
            },
            [
              _c("Symp_itemIpad", {
                attrs: {
                  riskLevelList: _vm.mildRisks,
                  tips: _vm.mtips,
                  classleve: _vm.classleve,
                  mClass: true,
                  nClass: false,
                  isShow: _vm.isShow,
                  hClass: false
                },
                on: { setModalInfo: _vm.setModalInfo }
              }),
              _vm._v(" "),
              _c("Symp_itemIpad", {
                attrs: {
                  riskLevelList: _vm.normalRisks,
                  tips: _vm.ntips,
                  classleve: _vm.classleve,
                  mClass: false,
                  nClass: true,
                  isShow: true,
                  hClass: false
                },
                on: { setModalInfo: _vm.setModalInfo }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content-row content-align-center content-row-center",
          staticStyle: { padding: "1.5rem 0" }
        },
        [
          _c(
            "div",
            {
              staticClass: "content-row content-row-column",
              staticStyle: {
                width: "90%",
                border: "1px solid #d7d5d6",
                "border-radius": ".5rem",
                overflow: "hidden"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "content-row",
                  staticStyle: { "border-bottom": "1px solid #d7d5d6" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "content-row content-row-center content-align-center",
                      staticStyle: { width: "16%", background: "#efeeec" }
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "level-box level-mild font-12" },
                        [_vm._v(_vm._s(_vm.$t("potentialRisk")))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "content-row content-align-center",
                      staticStyle: {
                        flex: "1",
                        "min-height": "2.5rem",
                        padding: "0 .7rem",
                        "border-left": "1px solid #d7d5d6"
                      }
                    },
                    [
                      _c("span", { staticClass: "font-18" }, [
                        _vm._v(_vm._s(_vm.$t("suggest")))
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "content-row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "content-row content-row-center content-align-center",
                    staticStyle: { width: "16%", background: "#efeeec" }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "level-box level-severe font-12" },
                      [_vm._v(_vm._s(_vm.$t("heightRisk")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "content-row content-align-center",
                    staticStyle: {
                      flex: "1",
                      "min-height": "2.5rem",
                      padding: "0 .7rem",
                      "border-left": "1px solid #d7d5d6"
                    }
                  },
                  [
                    _c("span", { staticClass: "font-18" }, [
                      _vm._v(_vm._s(_vm.$t("suggestSolve")))
                    ])
                  ]
                )
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var Posture_sympipad_staticRenderFns = []
Posture_sympipad_render._withStripped = true
var Posture_sympipad_esExports = { render: Posture_sympipad_render, staticRenderFns: Posture_sympipad_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Posture_sympipad = (Posture_sympipad_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cc4265a", Posture_sympipad_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Posture_sympipad.vue
var Posture_sympipad_disposed = false
function Posture_sympipad_injectStyle (ssrContext) {
  if (Posture_sympipad_disposed) return
  __webpack_require__("IwwR")
}
var Posture_sympipad_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Posture_sympipad___vue_template_functional__ = false
/* styles */
var Posture_sympipad___vue_styles__ = Posture_sympipad_injectStyle
/* scopeId */
var Posture_sympipad___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Posture_sympipad___vue_module_identifier__ = null
var Posture_sympipad_Component = Posture_sympipad_normalizeComponent(
  components_Posture_sympipad,
  selectortype_template_index_0_src_components_Posture_sympipad,
  Posture_sympipad___vue_template_functional__,
  Posture_sympipad___vue_styles__,
  Posture_sympipad___vue_scopeId__,
  Posture_sympipad___vue_module_identifier__
)
Posture_sympipad_Component.options.__file = "src/components/Posture_sympipad.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1cc4265a", Posture_sympipad_Component.options)
  } else {
    hotAPI.reload("data-v-1cc4265a", Posture_sympipad_Component.options)
  }
  module.hot.dispose(function (data) {
    Posture_sympipad_disposed = true
  })
})()}

/* harmony default export */ var src_components_Posture_sympipad = (Posture_sympipad_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_modal_ipad.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Posture_modal_ipad = ({
  name: "Posture_modal_ipad",
  i18n: {
    // `i18n` option, setup locale info for component
    messages: extends_default()({}, postureModalIpad)
  },
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {},
  props: ["modalInfo"],
  data: function data() {
    return {
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      }
    };
  },

  computed: {},
  methods: {
    getRiskImg: function getRiskImg(risk) {
      var direction = "normal";
      var img = void 0;
      console.log(risk.key);
      if (!lodash_default.a.isNull(risk.direction) && risk.key !== "legO" && risk.key !== "legX" && risk.key !== "legXO" && risk.key !== "kneeOverstretch") {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    show: function show() {},
    hideModal: function hideModal() {
      this.$emit("hideModal");
    },
    initRiskBar: function initRiskBar() {
      this.$emit("initRiskBar");
    },
    getLevel: function getLevel(level) {
      switch (level) {
        case this.level.normal:
          return {
            des: "正常",
            className: "level-normal"
          };
        case this.level.mild:
          return {
            des: "潜在风险",
            className: "level-mild"
          };
        case this.level.severe:
          return {
            des: "高风险",
            className: "level-severe"
          };
      }
    }
  },
  created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_modal_ipad.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_Posture_modal_ipad = ({
  name: "Posture_modal_ipad",
  i18n: {
    // `i18n` option, setup locale info for component
    messages: extends_default()({}, postureModalIpad)
  },
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {},
  props: ["modalInfo"],
  data: function data() {
    return {
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      }
    };
  },

  computed: {},
  methods: {
    getRiskImg: function getRiskImg(risk) {
      var direction = "normal";
      var img = void 0;
      console.log(risk.key);
      if (!lodash_default.a.isNull(risk.direction) && risk.key !== "legO" && risk.key !== "legX" && risk.key !== "legXO" && risk.key !== "kneeOverstretch") {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    show: function show() {},
    hideModal: function hideModal() {
      this.$emit("hideModal");
    },
    initRiskBar: function initRiskBar() {
      this.$emit("initRiskBar");
    },
    getLevel: function getLevel(level) {
      switch (level) {
        case this.level.normal:
          return {
            des: "正常",
            className: "level-normal"
          };
        case this.level.mild:
          return {
            des: "潜在风险",
            className: "level-mild"
          };
        case this.level.severe:
          return {
            des: "高风险",
            className: "level-severe"
          };
      }
    }
  },
  created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-756c5e63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_modal_ipad.vue
var Posture_modal_ipad_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal-box" }, [
      _c(
        "div",
        { staticStyle: { "margin-top": "-19rem" } },
        [
          _c(
            "div",
            {
              staticClass:
                "content-row content-align-center content-row-between modal-head"
            },
            [
              _c(
                "span",
                { staticClass: "font-24", staticStyle: { color: "#b2b2b2" } },
                [_vm._v(_vm._s(_vm.modalInfo.name))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "back-btn font-24",
                  on: { click: _vm.hideModal }
                },
                [_vm._v(_vm._s(_vm.$t("return")))]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content-row modal-risk-box" }, [
            _c(
              "div",
              {
                staticClass: "content-row content-row-around",
                staticStyle: {
                  "padding-top": ".8rem",
                  background: "#cbe7ff",
                  "border-radius": ".3rem",
                  width: "23.9rem"
                }
              },
              [
                _c("div", {
                  staticClass: "compare-img",
                  attrs: { id: "modalBody" }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "compare-img",
                  attrs: { src: _vm.getRiskImg(_vm.modalInfo) }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "padding-right": ".67rem",
                  "padding-left": "1.35rem",
                  "flex-grow": "1",
                  height: "40px"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "riskipad content-row content-align-center content-row-between"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "font-24",
                        staticStyle: {
                          color: "#474747",
                          "margin-right": ".5rem"
                        }
                      },
                      [_vm._v(_vm._s(_vm.modalInfo.name))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "font-22",
                        staticStyle: {
                          "margin-right": ".5rem",
                          color: "#8d8d8d"
                        }
                      },
                      [_vm._v(_vm._s(_vm.modalInfo.detail))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        class:
                          "modal-level-box  " +
                          _vm.getLevel(_vm.modalInfo.level).className +
                          " font-242"
                      },
                      [
                        _vm.getLevel(_vm.modalInfo.level).des === "高风险"
                          ? _c("p", [_vm._v(_vm._s(_vm.$t("heightRisk")))])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getLevel(_vm.modalInfo.level).des === "潜在风险"
                          ? _c("p", [_vm._v(_vm._s(_vm.$t("potentialRisk")))])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getLevel(_vm.modalInfo.level).des === "正常"
                          ? _c("p", [_vm._v(_vm._s(_vm.$t("normal")))])
                          : _vm._e()
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "content-row content-align-end",
                    staticStyle: { height: "3.1rem" }
                  },
                  [
                    _c("canvas", {
                      staticClass: "risk-bar",
                      attrs: {
                        "data-value": _vm.modalInfo.value,
                        "data-level": _vm.modalInfo.level,
                        id: "modalRiskBar"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "content-row content-row-between font-20 gmnClass riskipad",
                    staticStyle: { width: "auto", padding: "0 .5rem 0 .5rem" }
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 2)))]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 1)))]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 0)))])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "content-row font-18",
                    staticStyle: { "margin-top": "1.1rem", "flex-wrap": "wrap" }
                  },
                  _vm._l(_vm.modalInfo.risks, function(key) {
                    return _c("span", { staticClass: "key-box" }, [
                      _vm._v(_vm._s(key.name))
                    ])
                  }),
                  0
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-row content-row-column content-align-start",
              staticStyle: {
                "margin-top": ".5rem",
                "background-color": "#fff",
                padding: "1.2rem 1.75rem"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "content-row content-align-center font-20 risk-head auto-width",
                  staticStyle: { "margin-bottom": ".6rem" }
                },
                [
                  _c("span", { staticClass: "potentialRisk-icon" }),
                  _vm._v(" "),
                  _c("span", { staticStyle: { color: "#ff4d4d" } }, [
                    _vm._v(_vm._s(_vm.$tc("potentialRisk")))
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.modalInfo.risks, function(key) {
            return _c(
              "div",
              {
                staticClass: "col-md-6 col-xs-6 col-sm-6 col-lg-6",
                staticStyle: {
                  "background-color": "#fff",
                  height: "7.5rem",
                  float: "left",
                  padding: "0 1.75rem 0 3rem"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "font18",
                    staticStyle: { "font-weight": "bold", color: "#474747" },
                    attrs: { id: "risk-des" }
                  },
                  [_vm._v(_vm._s(key.name))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "font-18",
                    staticStyle: {
                      color: "#898989",
                      "padding-left": "1rem",
                      "margin-top": ".9rem"
                    }
                  },
                  [_c("ul", [_c("li", [_vm._v(_vm._s(key.des))])])]
                )
              ]
            )
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "content-row content-align-center content-row-center close-box"
      },
      [_c("span", { staticClass: "close-btn", on: { click: _vm.hideModal } })]
    )
  ])
}
var Posture_modal_ipad_staticRenderFns = []
Posture_modal_ipad_render._withStripped = true
var Posture_modal_ipad_esExports = { render: Posture_modal_ipad_render, staticRenderFns: Posture_modal_ipad_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Posture_modal_ipad = (Posture_modal_ipad_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-756c5e63", Posture_modal_ipad_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Posture_modal_ipad.vue
var Posture_modal_ipad_disposed = false
function Posture_modal_ipad_injectStyle (ssrContext) {
  if (Posture_modal_ipad_disposed) return
  __webpack_require__("itYS")
}
var Posture_modal_ipad_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Posture_modal_ipad___vue_template_functional__ = false
/* styles */
var Posture_modal_ipad___vue_styles__ = Posture_modal_ipad_injectStyle
/* scopeId */
var Posture_modal_ipad___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Posture_modal_ipad___vue_module_identifier__ = null
var Posture_modal_ipad_Component = Posture_modal_ipad_normalizeComponent(
  components_Posture_modal_ipad,
  selectortype_template_index_0_src_components_Posture_modal_ipad,
  Posture_modal_ipad___vue_template_functional__,
  Posture_modal_ipad___vue_styles__,
  Posture_modal_ipad___vue_scopeId__,
  Posture_modal_ipad___vue_module_identifier__
)
Posture_modal_ipad_Component.options.__file = "src/components/Posture_modal_ipad.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-756c5e63", Posture_modal_ipad_Component.options)
  } else {
    hotAPI.reload("data-v-756c5e63", Posture_modal_ipad_Component.options)
  }
  module.hot.dispose(function (data) {
    Posture_modal_ipad_disposed = true
  })
})()}

/* harmony default export */ var src_components_Posture_modal_ipad = (Posture_modal_ipad_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_ipad.vue





var _extends2;























var Posture_ipad_langs = {
  en: '中文',
  cn: 'English',
  "zh-tw": '中文繁体'
};
var Posture_ipad_bullets = [{
  text: '首页',
  bulletClassName: 'pagination-bullet font-24',
  containerClassName: 'pagination-container hidden-pagination',
  bottomLineClassName: 'nav-line'
}, {
  text: '体态视图',
  bulletClassName: 'pagination-bullet font-24',
  containerClassName: 'pagination-container',
  bottomLineClassName: 'nav-line'
}, {
  text: '肌肉状态',
  bulletClassName: 'pagination-bullet font-24',
  containerClassName: 'pagination-container',
  bottomLineClassName: 'nav-line'
}, {
  text: '体态症状',
  bulletClassName: 'pagination-bullet font-24',
  containerClassName: 'pagination-container',
  bottomLineClassName: 'nav-line'
}];

/* harmony default export */ var Posture_ipad = ({
  name: "posture_ipad",
  i18n: { // `i18n` option, setup locale info for component
    messages: extends_default()({}, postureIpad)
  },
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    Previewer: vux_src_components_previewer,
    Loading: vux_src_components_loading,
    bModal: modal["a" /* default */],
    Posture_report: src_components_Posture_report,
    Posture_front: src_components_Posture_front,
    Posture_flank: src_components_Posture_flank,
    Posture_home: src_components_Posture_home,
    Posture_sympipad: src_components_Posture_sympipad,
    Posture_modal_ipad: src_components_Posture_modal_ipad
  },
  data: function data() {
    var _this2 = this;

    return {
      MuscleShow: false,
      valid: true,
      loading: true,
      reportData: {},
      customer: {},
      updateSwiper: false,
      bullets: [{
        text: this.$t('bullet.home'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: 'hidden-pagination',
        iconClassName: ''
      }, {
        text: this.$t('bullet.Posturedata'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-face'
      }, {
        text: this.$t('bullet.Score'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-riskassess'
      }, {
        text: this.$t('bullet.Muscle'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-bone',
        display: 'none'
      }, {
        text: this.$t('bullet.Solution'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-symptom'
      }],
      viwesNav: [{
        text: this.$tc('viwesNav', 0),
        bulletClassName: 'pagination-bullet view-flant',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-views'
      }, {
        text: this.$tc('viwesNav', 1),
        bulletClassName: 'pagination-bullet view-side',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-views'
      }],
      swiperOption: {
        pagination: {

          el: '.posture-swiper-pagination',
          clickable: true,
          renderBullet: function renderBullet(index, className) {
            if (Posture_ipad_bullets[index].display == 'none') {
              console.log("================");
            } else {
              return '<div class="content-row content-row-column content-align-center content-row-between ' + Posture_ipad_bullets[index].containerClassName + ' ' + className + '">' + ('<span class="' + Posture_ipad_bullets[index].bulletClassName + '">' + Posture_ipad_bullets[index].text + '</span>') + ('<span class="' + Posture_ipad_bullets[index].bottomLineClassName + '"></span>') + '</div>';
            }
          }
        },
        on: {
          init: function init() {
            document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0;
          },

          transitionEnd: function transitionEnd(event) {
            var cur_index = sessionStorage.getItem('cur_index');
            console.log("touchEnd", cur_index);
            _this2.updateSwiper = true;
          },
          click: function click() {

            this.autoplay.stop();
            console.log("tapclickppppppppp");
          },
          tap: function tap() {
            this.autoplay.stop();
            console.log("tapppppppppp");
          },
          slideChange: function slideChange() {
            if (this.activeIndex === 0) {
              document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0;
            } else {
              document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 1;
            }
          },

          slideChangeTransitionStart: function slideChangeTransitionStart() {
            console.log('cur_index slideChangeTransitionStart', this.activeIndex);
            sessionStorage.setItem('cur_index', this.activeIndex);
          }
        }
      },
      normalRisks: [],
      mildRisks: [],
      severeRisks: [],
      symptoms: {
        head: [{
          name: '头部侧倾',
          key: 'headSidesway',
          normal: {
            left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
            normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
          },
          definition: '在直立过程中，头部向左或右倾斜的现象。',
          harm: {
            bone: '颈椎侧屈',
            muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
            neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
            des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
          },
          risks: [{
            name: '肌肉韧带慢性劳损',
            des: '长期头侧倾容易导致颈后韧带、颈周围肌肉的慢性劳损。'
          }, {
            name: '颈椎病',
            des: '由于头部异位导致颈部软组织、骨骼的异常，增大了颈椎病患病风险。'
          }]
        }, {
          name: '头部前倾',
          key: 'headLean',
          normal: {
            normal: imgSrc_default.a.risk_normal.HEAD_LEAN
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
          },
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '椎弓变直或出现反弓',
            muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
            neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
            des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
          },
          risks: [{
            name: '头晕头痛',
            des: '头部前倾可能影响头部血液循环，由于血流不畅而导致头部缺氧，引发头晕头痛。'
          }, {
            name: '颈椎病',
            des: '长期的重度头部前倾可能会导致颈椎病。'
          }, {
            name: '腰椎不稳',
            des: '由于头部前倾引发颈椎受力异常，由此引发整个脊柱的受力异常。'
          }, {
            name: '心脑血管疾病',
            des: '头部的异位可能影响头部血液循环，危害心脑血管健康。'
          }]
        }],
        shoulder: [{
          name: '高低肩',
          key: 'highLowShoulder',
          normal: {
            left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
            normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
          },
          definition: '肩峰左右高度差超过2CM则为高低肩。',
          harm: {
            bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
            muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
            neurovascular: '',
            des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
          },
          risks: [{
            name: '慢性头痛',
            des: '长期的高低肩容易产生颈肩部位、头部的慢性疼痛。'
          }, {
            name: '骨刺',
            des: '高低肩使颈椎受力异常，最后可能导致颈椎部位退化，易形成骨刺。'
          }, {
            name: '腰痛',
            des: '高低肩可能造成骨盆的移位，使腰部肌力不平衡，导致腰痛。'
          }, {
            name: '长短腿',
            des: '由于高低肩造成的骨盆移位可能会使腿长发生变化。'
          }]
        }, {
          name: '圆肩',
          key: 'roundShoulder',
          normal: {
            normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
          },
          definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
          harm: {
            bone: '肩胛骨外展、胸廓变小',
            muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
            neurovascular: '',
            des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
          },
          risks: [{
            name: '心脏负担加重',
            des: '过度圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉被压迫，使心脏工作负担加重。'
          }, {
            name: '头痛',
            des: '肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起头痛。'
          }, {
            name: '手臂麻木',
            des: '肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起手臂麻木。'
          }]
        }],
        trunk: [{
          name: '脊柱异位',
          key: 'spineSidesway',
          normal: {
            left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
            normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
          },
          definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
          harm: {
            bone: '脊柱出现S型弯曲或C型弯曲',
            muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
            neurovascular: '',
            des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
          },
          risks: [{
            name: '脊柱侧弯',
            des: '平面拍摄检测出脊柱异位提示您需进一步通过三维检测，确定是否存在脊柱侧弯的症状。'
          }, {
            name: '高低肩',
            des: '脊柱侧弯可能伴随高低肩症状。'
          }, {
            name: '骨盆侧倾',
            des: '脊柱侧弯可能伴随骨盆侧倾症状。'
          }]
        }],
        pelvis: [{
          name: '骨盆侧倾',
          key: 'pelvisLean',
          normal: {
            left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
            right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
            normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
            right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
          },
          definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
          harm: {
            bone: '骨盆倾斜',
            muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
            neurovascular: '',
            des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
          },
          risks: [{
            name: '慢性疼痛',
            des: '骨盆侧倾可能会引发腰腿疼痛、肩颈疼痛。'
          }, {
            name: '腰椎间盘突出',
            des: '骨盆侧倾可能加重腰椎间盘突出风险。'
          }, {
            name: '长短腿',
            des: '骨盆侧倾可能加重长短腿风险。。'
          }]
        }],
        'lower extremity': [{
          name: 'O型腿',
          key: 'legO',
          normal: {
            normal: imgSrc_default.a.risk_normal.LEG_O
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.LEG_O
          },
          definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
          harm: {
            bone: 'O型腿（膝内翻）',
            muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
            neurovascular: '',
            des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
          },
          risks: [{
            name: '半月板损伤',
            des: 'O型腿造成下肢力线发生改变，膝关节内侧间隙承受大于正常负荷的压力。可能引起膝关节内侧半月板损伤。'
          }, {
            name: '关节炎',
            des: '严重O型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n' + '置换手术。'
          }]
        }, {
          name: 'X型腿',
          key: 'legX',
          normal: {
            normal: imgSrc_default.a.risk_normal.LEG_X
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.LEG_X
          },
          definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
          harm: {
            bone: 'X型腿（膝外翻）',
            muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
            neurovascular: '',
            des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
          },
          risks: [{
            name: '半月板损伤',
            des: 'X型腿造成下肢力线发生改变，膝关节外侧间隙承受大于正常负荷的压力。可能引起膝关节外侧半月板损伤。'
          }, {
            name: '关节炎',
            des: '严重X型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n' + '置换手术。'
          }]
        }, {
          name: '膝过伸',
          key: 'kneeOverstretch',
          normal: {
            normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
          },
          definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
          harm: {
            bone: '踝关节背屈不足，使膝关节无法向前移动',
            muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
            neurovascular: '',
            des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
          },
          risks: [{
            name: '膝关节退变',
            des: '长期膝关节过伸，会引起膝关节的过度磨损，加大膝关节退变的发生率。'
          }, {
            name: '损害全身平衡',
            des: '膝关节位置的改变会引起髋关节、骨盆、踝关节的位置异常，由此逐渐损害全身的平衡状态，长期累积会引发各种体态异常。'
          }]
        }, {
          name: 'XO型腿',
          key: 'legXO',
          normal: {
            normal: imgSrc_default.a.risk_normal.LEG_XO
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.LEG_XO
          },
          definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
          harm: {
            bone: '这个是XO型腿',
            muscle: '这个是XO型腿',
            neurovascular: '',
            des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
          },
          risks: [{
            name: '膝关节疼痛',
            des: '由于XO型腿造成股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛。'
          }, {
            name: '膝关节炎',
            des: '重度XO型腿最终可能发展为膝关节骨性关节炎。'
          }]
        }]
      },
      level: {
        normal: 'normal',
        mild: 'mild',
        severe: 'severe'
      },
      locale: '',
      langTag: this.$i18n.locale,
      localeText: Posture_ipad_langs[this.$i18n.locale],
      risks: {},
      points: null,
      photos: null,
      coverInfo: {},
      modalInfo: null,
      keyMap: {
        face: {
          headSidesway: {
            position: ['neck', 'nose'],
            scale: 0.5
          },
          highLowShoulder: {
            position: ['shoulder-left', 'shoulder-right'],
            scale: 0.3
          },
          spineSidesway: {
            position: ['elbow-left', 'elbow-right'],
            scale: 0.5
          },
          pelvisLean: {
            position: ['hip-left', 'hip-right'],
            scale: 1.5
          },
          legO: {
            position: ['hip', 'ankle'],
            scale: 0.3
          },
          legX: {
            position: ['hip', 'ankle'],
            scale: 0.3
          },
          legXO: {
            position: ['hip', 'ankle'],
            scale: 0.3
          }
        },
        side: {
          headLean: {
            position: ['neck', 'ear'],
            scale: 0.3
          },
          roundShoulder: {
            position: ['nose', 'elbow'],
            scale: 0
          },
          kneeOverstretch: {
            position: ['hip', 'ankle'],
            scale: 0.3
          }
        }
      },
      img: {
        face: null,
        side: null
      }
    };
  },

  computed: {
    swiper: function swiper() {
      return this.$refs.postureSwiper.swiper;
    },

    show: function show() {

      return this.$t('indexPage.show');
    }
  },
  watch: {
    locale: function locale() {
      console.log('change locale', this.$i18n.locale);
    },
    updateSwiper: function updateSwiper() {
      console.log("this.updateSwiper", this.updateSwiper);
    }
  },
  methods: extends_default()((_extends2 = {
    updateSwiperIndex: function updateSwiperIndex(data) {
      this.updateSwiper = data;
    },
    setSymptomCanvasModal: function setSymptomCanvasModal(risk) {
      var points = this.points;
      var needDetail = ['legO', 'legX', 'legXO'];
      var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

      var riskKey = risk.key;
      var keyMap = this.keyMap;
      var positionArr = void 0;
      var positionPointsArr = [];
      var faceOrSide = void 0;
      var scale = void 0;

      console.log('keyMap =>', keyMap);

      keys_default()(keyMap).forEach(function (direction, index) {
        keys_default()(keyMap[direction]).forEach(function (key, index) {
          if (key === riskKey) {
            positionArr = keyMap[direction][key].position;
            scale = keyMap[direction][key].scale;
          }
        });
      });

      console.log('positionArr =>', positionArr);

      if (needDetail.indexOf(riskKey) !== -1) {

        var lOrR = void 0;
        if (risk.detail === '右腿') {
          lOrR = 'right';
        } else {
          lOrR = 'left';
        }

        for (var i = 0; i < positionArr.length; i++) {
          positionPointsArr.push(points.face[positionArr[i]][lOrR]);
        }

        faceOrSide = 'face';
      } else if (forSide.indexOf(riskKey) !== -1) {

        var _lOrR = this.conclusion.side.side;

        for (var _i = 0; _i < positionArr.length; _i++) {
          console.log('positionArr[i] =>', points.side[positionArr[_i]].left);
          if (points.side[positionArr[_i]].left === undefined) {
            console.log('in');
            positionPointsArr.push(points.side[positionArr[_i]]);
          } else {
            positionPointsArr.push(points.side[positionArr[_i]][_lOrR]);
          }
        }

        faceOrSide = 'side';
      } else {

        for (var _i2 = 0; _i2 < positionArr.length; _i2++) {
          var positionAndDirectionArr = positionArr[_i2].split('-');
          if (positionAndDirectionArr.length === 1) {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
          } else {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
          }
        }

        faceOrSide = 'face';
      }

      console.log('positionPointsArr =>', positionPointsArr);

      var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
      var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
      var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
      var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

      var width = _x > _y ? _x : _y;
      width *= 1 + scale;

      var x = xMid - width / 2;
      var y = yMid - width / 2;

      console.log('w =>', width);
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.width = width;
      canvas.height = width;

      var img = this.img[faceOrSide];
      console.log('img =>', img);
      ctx.drawImage(img, x, y, width, width, 0, 0, width, width);
      console.log('modalBody =>', document.getElementsByTagName('body'));

      this.canvas = canvas;
    },
    getRiskImg: function getRiskImg(risk) {
      var direction = 'normal';
      var img = void 0;
      console.log(risk.key);
      if (!lodash_default.a.isNull(risk.direction) && risk.key !== 'legO' && risk.key !== 'legX' && risk.key !== 'legXO' && risk.key !== 'kneeOverstretch') {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    }
  }, defineProperty_default()(_extends2, 'setSymptomCanvasModal', function setSymptomCanvasModal(risk) {
    var points = this.points;
    var needDetail = ['legO', 'legX', 'legXO'];
    var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

    var riskKey = risk.key;
    var keyMap = this.keyMap;
    var positionArr = void 0;
    var positionPointsArr = [];
    var faceOrSide = void 0;
    var scale = void 0;

    console.log('keyMap =>', keyMap);

    keys_default()(keyMap).forEach(function (direction, index) {
      keys_default()(keyMap[direction]).forEach(function (key, index) {
        if (key === riskKey) {
          positionArr = keyMap[direction][key].position;
          scale = keyMap[direction][key].scale;
        }
      });
    });

    console.log('positionArr =>', positionArr);

    if (needDetail.indexOf(riskKey) !== -1) {

      var lOrR = void 0;
      if (risk.detail === '右腿') {
        lOrR = 'right';
      } else {
        lOrR = 'left';
      }

      for (var i = 0; i < positionArr.length; i++) {
        positionPointsArr.push(points.face[positionArr[i]][lOrR]);
      }

      faceOrSide = 'face';
    } else if (forSide.indexOf(riskKey) !== -1) {

      var _lOrR2 = this.conclusion.side.side;

      for (var _i3 = 0; _i3 < positionArr.length; _i3++) {
        console.log('positionArr[i] =>', points.side[positionArr[_i3]].left);
        if (points.side[positionArr[_i3]].left === undefined) {
          console.log('in');
          positionPointsArr.push(points.side[positionArr[_i3]]);
        } else {
          positionPointsArr.push(points.side[positionArr[_i3]][_lOrR2]);
        }
      }

      faceOrSide = 'side';
    } else {

      for (var _i4 = 0; _i4 < positionArr.length; _i4++) {
        var positionAndDirectionArr = positionArr[_i4].split('-');
        if (positionAndDirectionArr.length === 1) {
          positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
        } else {
          positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
        }
      }

      faceOrSide = 'face';
    }

    console.log('positionPointsArr =>', positionPointsArr);

    var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
    var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
    var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
    var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

    var width = _x > _y ? _x : _y;
    width *= 1 + scale;

    var x = xMid - width / 2;
    var y = yMid - width / 2;

    console.log('w =>', width);
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.width = width;
    canvas.height = width;

    var img = this.img[faceOrSide];
    console.log('img =>', img);
    ctx.drawImage(img, x, y, width, width, 0, 0, width, width);
    console.log('modalBody =>', document.getElementsByTagName('body'));

    this.canvas = canvas;
  }), defineProperty_default()(_extends2, 'setModalInfo', function setModalInfo(risk) {
    var that = this;
    this.modalInfo = risk;
    console.log('risk =>', risk);
    this.setSymptomCanvasModal(risk);

    this.$nextTick(function () {
      this.$refs.riskModalRef.show();
      var canvas = that.canvas;
      document.getElementById('modalBody').innerHTML = '';
      document.getElementById('modalBody').appendChild(canvas);
    });
  }), defineProperty_default()(_extends2, 'setSymptomCanvas', function setSymptomCanvas(option) {
    var canvas = option.el;
    var ctx = canvas.getContext('2d');

    var points = this.points;
    var needDetail = ['legO', 'legX', 'legXO'];
    var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

    var riskKey = canvas.dataset.key;
    var keyMap = this.keyMap;
    var positionArr = void 0;
    var positionPointsArr = [];
    var faceOrSide = void 0;
    var scale = void 0;

    console.log('keyMap =>', keyMap);

    keys_default()(keyMap).forEach(function (direction, index) {
      keys_default()(keyMap[direction]).forEach(function (key, index) {
        if (key === riskKey) {
          positionArr = keyMap[direction][key].position;
          scale = keyMap[direction][key].scale;
        }
      });
    });

    console.log('positionArr =>', positionArr);

    if (needDetail.indexOf(riskKey) !== -1) {

      var lOrR = void 0;
      if (canvas.dataset.detail === '右腿') {
        lOrR = 'right';
      } else {
        lOrR = 'left';
      }

      for (var i = 0; i < positionArr.length; i++) {
        positionPointsArr.push(points.face[positionArr[i]][lOrR]);
      }

      faceOrSide = 'face';
    } else if (forSide.indexOf(riskKey) !== -1) {

      var _lOrR3 = this.conclusion.side.side;

      for (var _i5 = 0; _i5 < positionArr.length; _i5++) {
        console.log('positionArr[i] =>', points.side[positionArr[_i5]].left);
        if (points.side[positionArr[_i5]].left === undefined) {
          console.log('in');
          positionPointsArr.push(points.side[positionArr[_i5]]);
        } else {
          positionPointsArr.push(points.side[positionArr[_i5]][_lOrR3]);
        }
      }

      faceOrSide = 'side';
    } else {

      for (var _i6 = 0; _i6 < positionArr.length; _i6++) {
        var positionAndDirectionArr = positionArr[_i6].split('-');
        if (positionAndDirectionArr.length === 1) {
          positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
        } else {
          positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
        }
      }

      faceOrSide = 'face';
    }

    console.log('positionPointsArr =>', positionPointsArr);

    var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
    var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
    var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
    var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

    var width = _x > _y ? _x : _y;
    width *= 1 + scale;

    var x = xMid - width / 2;
    var y = yMid - width / 2;

    console.log('w =>', width);
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.width = width;
    canvas.height = width;
    var img = new Image();
    img.src = this.photos[faceOrSide];

    img.onload = function () {
      ctx.drawImage(img, x, y, width, width, 0, 0, width, width);
    };
  }), defineProperty_default()(_extends2, 'hideModal', function hideModal() {
    this.$refs.riskModalRef.hide();
  }), defineProperty_default()(_extends2, 'getLevel', function getLevel(level) {
    switch (level) {
      case this.level.normal:
        return {
          des: '正常',
          className: 'level-normal'
        };
      case this.level.mild:
        return {
          des: '潜在风险',
          className: 'level-mild'
        };
      case this.level.severe:
        return {
          des: '高风险',
          className: 'level-severe'
        };
    }
  }), defineProperty_default()(_extends2, 'checkIfAbnormal', function checkIfAbnormal(level) {
    switch (level) {
      case this.level.normal:
        return false;
      case this.level.mild:
        return false;
      case this.level.severe:
        return true;
    }
  }), defineProperty_default()(_extends2, 'sortHighToLow', function sortHighToLow(arr) {
    return lodash_default.a.orderBy(arr, ['value'], ['desc']);
  }), defineProperty_default()(_extends2, 'slideIn', function slideIn() {
    this.swiper.slideTo(1);
  }), defineProperty_default()(_extends2, 'initRiskBar', function initRiskBar() {
    this.$refs.riskModalRef.$el.getElementsByClassName('modal-content')[0].scrollTop = 0;
    var modalRiskBar = document.getElementById('modalRiskBar');
    this.initRiskLevelModal({
      el: modalRiskBar,
      width: Number(modalRiskBar.parentNode.offsetWidth),
      height: Number(modalRiskBar.parentNode.offsetHeight),
      color: {
        normal: '#00d963',
        mild: '#ffbf00',
        severe: '#ff4d4d'
      },
      level: this.level
    });
  }), defineProperty_default()(_extends2, 'initRiskLevelModal', function initRiskLevelModal(option) {
    console.log('el =>', option.width);
    var canvas = option.el;
    var cxt = canvas.getContext('2d');
    var scaleW = option.width / 229;
    var scaleH = option.height / 32;
    var scale = scaleW < scaleH ? 2 * scaleW : 2 * scaleH;
    canvas.width = 229 * scale;
    canvas.height = 32 * scale;
    canvas.style.width = 229 * scale / 2 + 'px';
    canvas.style.height = 32 * scale / 2 + 'px';
    var value = Number(canvas.dataset.value);
    value = Math.floor(value);
    console.log('color =>', option.color);
    console.log('level =>', option.level);
    var color = option.color[canvas.dataset.level];
    var valueX = value / 100 * 217;

    var midAndHightX = [{ id: 20, value: 20 / 100 * 217 }, { id: 60, value: 60 / 100 * 217 }];
    cxt.scale(scale, scale);
    cxt.translate(6, 0);

    cxt.save();
    cxt.fillStyle = color;
    cxt.beginPath();
    cxt.moveTo(valueX - 6, 2);
    cxt.lineTo(valueX + 6, 2);

    cxt.arc(valueX + 6, 3, 1, -Math.PI / 2, 0);

    cxt.lineTo(valueX + 7, 11);

    cxt.arc(valueX + 6, 11, 1, 0, Math.PI / 2);

    cxt.lineTo(valueX + 2, 12);
    cxt.lineTo(valueX, 14);
    cxt.lineTo(valueX - 2, 12);
    cxt.lineTo(valueX - 6, 12);

    cxt.arc(valueX - 6, 11, 1, Math.PI / 2, Math.PI);

    cxt.lineTo(valueX - 7, 3);
    cxt.arc(valueX - 6, 3, 1, Math.PI, Math.PI * 3 / 2);
    cxt.closePath();
    cxt.fill();
    cxt.fillStyle = '#fff';
    cxt.textAlign = 'center';
    cxt.font = '10px serif';
    cxt.fillText(value, valueX, 10);
    cxt.restore();

    cxt.save();
    cxt.fillStyle = '#b2b2b2';
    cxt.beginPath();
    cxt.moveTo(1.5, 18);
    cxt.lineTo(217, 18);
    cxt.arc(217, 19.5, 1.5, 3 * Math.PI / 2, Math.PI / 2);
    cxt.lineTo(1.5, 21);
    cxt.arc(1.5, 19.5, 1.5, Math.PI / 2, 3 * Math.PI / 2);
    cxt.closePath();
    cxt.fill();
    cxt.restore();

    var gradient = cxt.createLinearGradient(0, 0, 217, 0);
    gradient.addColorStop(0, '#00ff6a');
    gradient.addColorStop(.38, '#ffda08');
    gradient.addColorStop(1, '#ff4d4d');

    cxt.fillStyle = gradient;
    cxt.beginPath();
    if (valueX > 0) {
      cxt.moveTo(1.5, 18);
      cxt.lineTo(valueX, 18);
      cxt.arc(valueX, 19.5, 1.5, 3 * Math.PI / 2, Math.PI / 2);
      cxt.lineTo(1.5, 21);
      cxt.arc(1.5, 19.5, 1.5, Math.PI / 2, 3 * Math.PI / 2);
    }
    cxt.closePath();
    cxt.fill();

    for (var i = 0; i < midAndHightX.length; i++) {
      cxt.beginPath();
      cxt.strokeStyle = '#8a8b81';
      cxt.lineWidth = 0.5;
      cxt.setLineDash([4, 0.5]);
      cxt.moveTo(midAndHightX[i].value + 1, 16);
      cxt.lineTo(midAndHightX[i].value + 1, 24);
      cxt.fillStyle = '#b2b2b2';
      cxt.textAlign = 'center';
      cxt.font = '8px serif';
      cxt.fillText(midAndHightX[i].id, midAndHightX[i].value + 1, 30);
      cxt.stroke();
      cxt.closePath();
    }
  }), defineProperty_default()(_extends2, 'initRisksData', function initRisksData() {
    var risks = this.risks;
    var level = this.level;
    var symptoms = this.symptoms;
    var normalRisks = [];
    var mildRisks = [];
    var severeRisks = [];

    for (var direction in risks) {
      for (var i = 0; i < risks[direction].length; i++) {
        var symptom = symptoms[risks[direction][i].position][risks[direction][i].code - 1];

        if (symptom.value) {
          var otherSymptom = assign_default()({}, symptom);
          if (!risks[direction][i].valid) {
            otherSymptom.raw = 0;
            otherSymptom.value = 0;
            otherSymptom.level = level.normal;
            otherSymptom.detail = '';
            otherSymptom.direction = 'normal';
          } else {
            otherSymptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
            otherSymptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
            otherSymptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
            otherSymptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
            otherSymptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
          }

          symptoms[risks[direction][i].position].push(otherSymptom);
        } else {
          if (!risks[direction][i].valid) {
            symptom.raw = 0;
            symptom.value = 0;
            symptom.level = level.normal;
            symptom.detail = '';
            symptom.direction = 'normal';
          } else {
            symptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
            symptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
            symptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
            symptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
            symptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
          }
        }
      }
    }

    for (var position in symptoms) {
      for (var _i7 = 0; _i7 < symptoms[position].length; _i7++) {
        if (lodash_default.a.isUndefined(symptoms[position][_i7].value)) {
          continue;
        }
        switch (symptoms[position][_i7].level) {
          case level.normal:
            normalRisks.push(symptoms[position][_i7]);
            break;
          case level.mild:
            mildRisks.push(symptoms[position][_i7]);
            break;
          case level.severe:
            severeRisks.push(symptoms[position][_i7]);
            break;
          default:
            normalRisks.push(symptoms[position][_i7]);
            break;
        }
      }
    }

    this.normalRisks = this.sortHighToLow(normalRisks);
    this.mildRisks = this.sortHighToLow(mildRisks);
    this.severeRisks = this.sortHighToLow(severeRisks);
    console.log('normalRisks =>', normalRisks);
    console.log('mildRisks =>', mildRisks);
    console.log('severeRisks =>', severeRisks);
  }), defineProperty_default()(_extends2, 'initRiskPoints', function initRiskPoints() {
    var points = this.points;
    var photos = this.photos;
    var faceCanvas = document.createElement('canvas');
    var sideCanvas = document.createElement('canvas');
    var _this = this;

    var facePointsArr = [];
    var face = points.face;
    var faceImg = new Image();

    var hipRPoint = face['hip']['right'];
    var hipLPoint = face['hip']['left'];
    var neckPoint = face['neck'];
    var hipMPoint = {
      x: 0,
      y: 0
    };
    var hipAndNeckMPoint = {
      x: 0,
      y: 0
    };
    if (hipLPoint.x == 0 && hipLPoint.y == 0 || hipRPoint.x == 0 && hipRPoint.y == 0) {} else {

      hipMPoint.x = (hipLPoint.x + hipRPoint.x) / 2;
      hipMPoint.y = (hipLPoint.y + hipRPoint.y) / 2;

      if (!(neckPoint.x == 0 && neckPoint.y == 0)) {
        hipAndNeckMPoint.x = (neckPoint.x + hipMPoint.x) / 2;
        hipAndNeckMPoint.y = (neckPoint.y + hipMPoint.y) / 2;
      }
    };

    face.hipM = hipMPoint;
    face.hipAndNeckM = hipAndNeckMPoint;

    var faceOrder = [['ear-right', 'eye-right', 'nose', 'eye-left', 'ear-left'], ['wrist-right', 'elbow-right', 'shoulder-right', 'neck', 'shoulder-left', 'elbow-left', 'wrist-left'], ['ankle-right', 'knee-right', 'hip-right', 'hipM', 'hip-left', 'knee-left', 'ankle-left'], ['neck', 'hipAndNeckM', 'hipM'], ['nose', 'neck']];

    var verticalStandard = ['shoulder-right', 'ankle-middle', 'shoulder-left'];
    var verticalPointsArr = [];

    var risks = this.normalRisks.concat(this.mildRisks, this.severeRisks);

    console.log('risks =>', risks);
    var faceSymptomWithPosition = ['headSidesway-ear', 'highLowShoulder-shoulder', 'spineSidesway', 'pelvisLean-hip', 'legO-knee', 'legX-knee', 'legXO-knee'];
    var faceHorizontalArr = [];

    for (var i = 0; i < faceSymptomWithPosition.length; i++) {
      var symptomWithPositionArr = faceSymptomWithPosition[i].split('-');
      var pointsAndAngle = {
        key: symptomWithPositionArr[0]
      };

      for (var j = 0; j < risks.length; j++) {
        if (risks[j].key == symptomWithPositionArr[0]) {
          if (!lodash_default.a.isUndefined(pointsAndAngle.raw)) {
            pointsAndAngle.secondRaw = risks[j].raw;
          } else {
            pointsAndAngle.raw = risks[j].raw;
            if (symptomWithPositionArr.length == 1) {
              pointsAndAngle.points = [face['elbow'].left];
            } else {
              pointsAndAngle.points = [face[symptomWithPositionArr[1]].right, face[symptomWithPositionArr[1]].left];
            }
          }
        }
      }

      if (lodash_default.a.isUndefined(pointsAndAngle.raw) || lodash_default.a.isUndefined(pointsAndAngle.points)) {
        continue;
      } else {
        faceHorizontalArr.push(pointsAndAngle);
      }
    }

    console.log('faceHorizontalArr =>', faceHorizontalArr);

    for (var _i8 = 0; _i8 < faceOrder.length; _i8++) {
      var pointsArr = [];
      for (var _j = 0; _j < faceOrder[_i8].length; _j++) {
        var positionArr = faceOrder[_i8][_j].split('-');
        if (positionArr.length == 1) {
          pointsArr.push(face[positionArr[0]]);
        } else {
          pointsArr.push(face[positionArr[0]][positionArr[1]]);
        }
      }
      facePointsArr.push(pointsArr);
    }

    for (var _i9 = 0; _i9 < verticalStandard.length; _i9++) {
      var _positionArr = verticalStandard[_i9].split('-');

      if (_positionArr[1] == 'middle') {
        if (face[_positionArr[0]].left.x == 0 && face[_positionArr[0]].left.y == 0 || face[_positionArr[0]].right.x == 0 && face[_positionArr[0]].right.y == 0) {
          verticalPointsArr.push({
            x: 0,
            y: 0
          });
        } else {
          verticalPointsArr.push({
            x: (face[_positionArr[0]].left.x + face[_positionArr[0]].right.x) / 2,
            y: 0
          });
        }
      } else {
        verticalPointsArr.push(face[_positionArr[0]][_positionArr[1]]);
      }
    }

    console.log('verticalPointsArr =>', verticalPointsArr);

    faceImg.src = photos.face;
    faceImg.onload = function () {
      _this.img.face = faceImg;

      var width = faceImg.width;
      var height = faceImg.height;
      faceCanvas.width = width;
      faceCanvas.height = height;
      faceCanvas.style.width = '100%';

      var cxt = faceCanvas.getContext('2d');
      cxt.drawImage(faceImg, 0, 0, width, height);

      for (var _i10 = 0; _i10 < facePointsArr.length; _i10++) {
        for (var _j2 = 0; _j2 < facePointsArr[_i10].length; _j2++) {
          if (_j2 == 0 || facePointsArr[_i10][_j2].x == 0 && facePointsArr[_i10][_j2].y == 0 || facePointsArr[_i10][_j2 - 1].x == 0 && facePointsArr[_i10][_j2 - 1].y == 0) {
            if (facePointsArr[_i10][_j2].x == 0 && facePointsArr[_i10][_j2].y == 0) {
              continue;
            } else {
              _this.drawPoint({
                el: faceCanvas,
                point: facePointsArr[_i10][_j2]
              });
              continue;
            }
          } else {
            _this.drawPoint({
              el: faceCanvas,
              point: facePointsArr[_i10][_j2]
            });
            _this.drawLine({
              el: faceCanvas,
              points: [facePointsArr[_i10][_j2], facePointsArr[_i10][_j2 - 1]]
            });
          }
        }
      }

      for (var _i11 = 0; _i11 < verticalPointsArr.length; _i11++) {
        if (verticalPointsArr[_i11].x == 0 && verticalPointsArr[_i11].y == 0) {
          continue;
        } else {
          cxt.save();
          cxt.strokeStyle = '#4db664';
          cxt.beginPath();
          cxt.moveTo(verticalPointsArr[_i11].x, 0);
          cxt.lineTo(verticalPointsArr[_i11].x, height);
          cxt.closePath();
          cxt.stroke();
          cxt.restore();

          cxt.save();
          cxt.fillStyle = '#fe610f';
          cxt.font = '30px serif';
          var offset_height = (568 - 71) / (320 / width);
          if (_i11 == 0) {
            cxt.fillText('α', verticalPointsArr[_i11].x + 5, offset_height - 5);
          } else if (_i11 == verticalPointsArr.length - 1) {
            cxt.fillText('γ', verticalPointsArr[_i11].x + 5, offset_height - 5);
          } else {
            cxt.fillText('β', verticalPointsArr[_i11].x + 5, offset_height - 5);
          }
          cxt.restore();
        }
      }

      var min = 99999;
      var max = 0;
      var indexOfKneeArr = [];
      for (var _i12 = 0; _i12 < faceHorizontalArr.length; _i12++) {
        if (faceHorizontalArr[_i12].points.length !== 1) {
          if (faceHorizontalArr[_i12].points[0].x == 0 && faceHorizontalArr[_i12].points[0].y == 0 || faceHorizontalArr[_i12].points[1].x == 0 && faceHorizontalArr[_i12].points[1].y == 0) {
            continue;
          }
          if (faceHorizontalArr[_i12].points[0].x < min) {
            min = faceHorizontalArr[_i12].points[0].x;
          }
          if (faceHorizontalArr[_i12].points[1].x > max) {
            max = faceHorizontalArr[_i12].points[1].x;
          }
        }

        if (faceHorizontalArr[_i12].key == 'legX' || faceHorizontalArr[_i12].key == 'legO' || faceHorizontalArr[_i12].key == 'legXO') {
          indexOfKneeArr.push(_i12);
        }
      }

      if (indexOfKneeArr.length == 2) {
        faceHorizontalArr[indexOfKneeArr[0]].secondRaw = faceHorizontalArr[indexOfKneeArr[1]].raw;
        faceHorizontalArr.splice(indexOfKneeArr[1], 1);
      }

      for (var _i13 = 0; _i13 < faceHorizontalArr.length; _i13++) {
        _this.drawLineAndAngle({
          el: faceCanvas,
          angle: faceHorizontalArr[_i13].raw,
          secondAngle: faceHorizontalArr[_i13].secondRaw,
          points: faceHorizontalArr[_i13].points,
          min: min,
          max: max
        });
      }

      _this.$nextTick(function () {});
    };

    var side = points.side;
    var sidePointsArr = [];
    var sideImg = new Image();
    console.log('side =>', side);

    var lOrR = side.side;
    var sideOrder = [['ankle-' + lOrR, 'knee-' + lOrR, 'hip-' + lOrR, 'shoulder-' + lOrR, 'elbow-' + lOrR, 'wrist-' + lOrR], ['shoulder-' + lOrR, 'ear-' + lOrR, 'eye-' + lOrR, 'nose']];

    var sideVerticalStandard = ['ankle-' + lOrR, 'nose'];
    var sideVerticalPointsArr = [];

    for (var _i14 = 0; _i14 < sideOrder.length; _i14++) {
      var _pointsArr = [];
      for (var _j3 = 0; _j3 < sideOrder[_i14].length; _j3++) {
        var _positionArr2 = sideOrder[_i14][_j3].split('-');
        if (_positionArr2.length == 1) {
          _pointsArr.push(side[_positionArr2[0]]);
        } else {
          _pointsArr.push(side[_positionArr2[0]][_positionArr2[1]]);
        }
      }
      sidePointsArr.push(_pointsArr);
    }

    for (var _i15 = 0; _i15 < sideVerticalStandard.length; _i15++) {
      var _positionArr3 = sideVerticalStandard[_i15].split('-');
      if (_positionArr3.length == 1) {
        sideVerticalPointsArr.push(side[_positionArr3[0]]);
      } else {
        sideVerticalPointsArr.push(side[_positionArr3[0]][_positionArr3[1]]);
      }
    }

    var sideSymptomWithPosition = ['ear-shoulder', 'hip-knee'];
    var sideHorizontalArr = [];

    for (var _i16 = 0; _i16 < sideSymptomWithPosition.length; _i16++) {
      var horizontalArr = [];
      var _positionArr4 = sideSymptomWithPosition[_i16].split('-');
      for (var _j4 = 0; _j4 < _positionArr4.length; _j4++) {
        horizontalArr.push(side[_positionArr4[_j4]][lOrR]);
      }
      sideHorizontalArr.push(horizontalArr);
    }

    var sideSymptomWithAngle = ['headLean', 'roundShoulder', 'kneeOverstretch'];
    var sideSymptomWithAngleRisk = [];

    for (var _i17 = 0; _i17 < sideSymptomWithAngle.length; _i17++) {
      for (var _j5 = 0; _j5 < risks.length; _j5++) {
        if (risks[_j5].key == sideSymptomWithAngle[_i17]) {
          sideSymptomWithAngleRisk.push(risks[_j5]);
        }
      }
    }

    console.log('sideHorizontalArr =>', sideHorizontalArr);

    sideImg.src = photos.side;
    sideImg.onload = function () {
      _this.img.side = sideImg;

      var width = sideImg.width;
      var height = sideImg.height;
      sideCanvas.width = width;
      sideCanvas.height = height;
      sideCanvas.style.width = '100%';

      var cxt = sideCanvas.getContext('2d');
      cxt.drawImage(sideImg, 0, 0, width, height);

      for (var _i18 = 0; _i18 < sidePointsArr.length; _i18++) {
        for (var _j6 = 0; _j6 < sidePointsArr[_i18].length; _j6++) {
          if (_j6 == 0 || sidePointsArr[_i18][_j6].x == 0 && sidePointsArr[_i18][_j6].y == 0 || sidePointsArr[_i18][_j6 - 1].x == 0 && sidePointsArr[_i18][_j6 - 1].y == 0) {
            if (sidePointsArr[_i18][_j6].x == 0 && sidePointsArr[_i18][_j6].y == 0) {
              continue;
            } else {
              _this.drawPoint({
                el: sideCanvas,
                point: sidePointsArr[_i18][_j6]
              });
              continue;
            }
          } else {
            _this.drawPoint({
              el: sideCanvas,
              point: sidePointsArr[_i18][_j6]
            });
            if (_j6 != 3) {
              _this.drawLine({
                el: sideCanvas,
                points: [sidePointsArr[_i18][_j6], sidePointsArr[_i18][_j6 - 1]]
              });
            }
          }
        }
      }

      for (var _i19 = 0; _i19 < sideVerticalPointsArr.length; _i19++) {
        if (sideVerticalPointsArr[_i19].x == 0 && sideVerticalPointsArr[_i19].y == 0) {
          continue;
        } else {
          cxt.save();
          cxt.strokeStyle = '#4db664';
          cxt.beginPath();
          cxt.moveTo(sideVerticalPointsArr[_i19].x, 0);
          cxt.lineTo(sideVerticalPointsArr[_i19].x, height);
          cxt.closePath();
          cxt.stroke();
          cxt.restore();

          cxt.save();
          cxt.fillStyle = '#fe610f';
          cxt.font = '30px serif';
          var offset_height = (568 - 71) / (320 / width);
          if (_i19 == 0) {
            cxt.fillText('α', sideVerticalPointsArr[_i19].x + 5, offset_height - 5);
          } else {
            cxt.fillText('β', sideVerticalPointsArr[_i19].x + 5, offset_height - 5);
          }
          cxt.restore();
        }
      }

      for (var _i20 = 0; _i20 < sideHorizontalArr.length; _i20++) {
        _this.drawLine({
          el: sideCanvas,
          points: sideHorizontalArr[_i20],
          isSide: true
        });
      }

      for (var _i21 = 0; _i21 < sideSymptomWithAngleRisk.length; _i21++) {
        _this.drawRectAndAngle({
          cxt: cxt,
          angle: Number(sideSymptomWithAngleRisk[_i21].raw.toFixed(1)),
          point: {
            x: width - 120,
            y: height * .2 * (_i21 + 1)
          }
        });
      }

      _this.$nextTick(function () {});
    };
  }), defineProperty_default()(_extends2, 'drawPoint', function drawPoint(option) {
    var canvas = option.el;
    var point = option.point;
    var cxt = canvas.getContext('2d');
    cxt.save();
    cxt.fillStyle = '#009eff';
    cxt.beginPath();
    cxt.arc(point.x, point.y, 5, 0, 2 * Math.PI);
    cxt.closePath();
    cxt.fill();
    cxt.restore();
    cxt.save();
    cxt.fillStyle = "rgba(83, 158, 255, .3)";
    cxt.beginPath();
    cxt.arc(point.x, point.y, 10, 0, 2 * Math.PI);
    cxt.closePath();
    cxt.fill();
    cxt.restore();
  }), defineProperty_default()(_extends2, 'drawLine', function drawLine(option) {

    if (option.points[0].x == 0 && option.points[0].y == 0 || option.points[1].x == 0 && option.points[1].y == 0) {
      return;
    }
    var canvas = option.el;
    var points = option.points;
    var cxt = canvas.getContext('2d');
    cxt.save();
    cxt.lineWidth = 3;
    if (!option.isSide) {
      cxt.strokeStyle = '#5f58f4';
      cxt.beginPath();
      cxt.moveTo(points[0].x, points[0].y);
      cxt.lineTo(points[1].x, points[1].y);
      cxt.closePath();
      cxt.stroke();
    } else {
      var _x = Math.abs(points[0].x - points[1].x);
      var _y = Math.abs(points[0].y - points[1].y);
      var z = Math.sqrt(Math.pow(_x, 2) + Math.pow(_y, 2));
      var startX = void 0;
      var startY = void 0;
      var endX = void 0;
      var endY = void 0;
      var distance = 80;

      console.log('points ===>', points);
      if (points[0].x > points[1].x) {
        startX = Math.round(points[1].x - distance * _x / z);
        startY = Math.round(points[1].y + distance * _y / z);
        endX = Math.round(points[0].x + distance * _x / z);
        endY = Math.round(points[0].y - distance * _y / z);
      } else {
        startX = Math.round(points[0].x - distance * _x / z);
        startY = Math.round(points[0].y - distance * _y / z);
        endX = Math.round(points[1].x + distance * _x / z);
        endY = Math.round(points[1].y + distance * _y / z);
      }

      cxt.strokeStyle = '#0ef8cd';
      cxt.beginPath();
      cxt.moveTo(startX, startY);
      cxt.lineTo(endX, endY);
      cxt.closePath();
      cxt.stroke();
    }

    cxt.restore();
  }), defineProperty_default()(_extends2, 'drawRectAndAngle', function drawRectAndAngle(option) {
    var cxt = option.cxt;
    var angle = option.angle;
    var point = option.point;

    cxt.save();
    if (option.isSecond) {
      cxt.translate(0, 43);
    }
    cxt.save();
    cxt.fillStyle = 'rgba(100, 100, 98, 0.5)';
    cxt.beginPath();
    cxt.moveTo(point.x + 13, point.y + 3);
    cxt.lineTo(point.x + 99, point.y + 3);
    cxt.quadraticCurveTo(point.x + 109, point.y + 3, point.x + 109, point.y + 13);
    cxt.lineTo(point.x + 109, point.y + 33);
    cxt.quadraticCurveTo(point.x + 109, point.y + 43, point.x + 99, point.y + 43);
    cxt.lineTo(point.x + 13, point.y + 43);
    cxt.quadraticCurveTo(point.x + 3, point.y + 43, point.x + 3, point.y + 33);
    cxt.lineTo(point.x + 3, point.y + 13);
    cxt.quadraticCurveTo(point.x + 3, point.y + 3, point.x + 13, point.y + 3);
    cxt.closePath();
    cxt.fill();
    cxt.restore();

    cxt.save();
    cxt.font = '34px Arial';
    cxt.fillStyle = '#0cfcca';
    cxt.textAlign = 'center';
    if (option.isTrunk) {
      cxt.fillText(angle + '%', point.x + 56, point.y + 38);
    } else {
      cxt.fillText(angle + '\xB0', point.x + 56, point.y + 38);
    }
    cxt.restore();
    cxt.restore();
  }), defineProperty_default()(_extends2, 'drawLineAndAngle', function drawLineAndAngle(option) {
    var canvas = option.el;
    var width = canvas.width;
    var points = option.points;
    var min = option.min - 100;
    var max = option.max + 100;
    var cxt = canvas.getContext('2d');

    for (var i = 0; i < points.length; i++) {
      if (points[i].x == 0 && points[i].y == 0) {
        return;
      }
    }

    console.log('======== point', points);
    if (points.length == 1) {
      this.drawRectAndAngle({
        cxt: cxt,
        angle: (option.angle * 100).toFixed(1),
        point: {
          x: width - 120,
          y: points[0].y
        },
        isSecond: false,
        isTrunk: true
      });
    } else {
      var _x = Math.abs(points[0].x - points[1].x);
      var _y = Math.abs(points[0].y - points[1].y);
      var startPoint = {};
      var endPoint = {};
      var offsetYL = Number(((points[0].x - min) * _y / _x).toFixed(0));
      var offsetYR = Number(((max - points[1].x) * _y / _x).toFixed(0));

      if (points[0].y < points[1].y) {
        startPoint.x = min;
        startPoint.y = points[0].y - offsetYL;
        endPoint.x = max;
        endPoint.y = points[1].y + offsetYR;
      } else {
        startPoint.x = min;
        startPoint.y = points[0].y + offsetYL;
        endPoint.x = max;
        endPoint.y = points[1].y - offsetYR;
      }

      cxt.save();
      cxt.strokeStyle = '#14bc9a';
      cxt.beginPath();
      cxt.moveTo(startPoint.x, startPoint.y);
      cxt.lineTo(endPoint.x, endPoint.y);
      cxt.closePath();
      cxt.stroke();
      cxt.restore();

      this.drawRectAndAngle({
        cxt: cxt,
        angle: Number(option.angle.toFixed(1)),
        point: {
          x: width - 120,
          y: points[1].y
        },
        isSecond: false
      });
      console.log('secondAngle =>', option.secondAngle);
      if (!lodash_default.a.isUndefined(option.secondAngle)) {
        this.drawRectAndAngle({
          cxt: cxt,
          angle: Number(option.secondAngle.toFixed(1)),
          point: {
            x: width - 120,
            y: points[1].y
          },
          isSecond: true
        });
      }
    }
  }), _extends2), Object(vuex_esm["d" /* mapState */])({
    initReportData: function initReportData(state) {
      var reportData = state.vux.reportData;
      var _this = this;
      if (lodash_default.a.isNull(reportData)) {
        var uuid = '';
        var type = '';

        var urlquery = url_default.a.parse(window.location.href).query;
        var query = urlquery.split('&');
        for (var every = 0; every < query.length; every++) {
          if (query[every].indexOf('uuid=') != -1) {
            uuid = query[every].replace('uuid=', '');
          }
          if (query[every].indexOf('type=') != -1) {
            type = query[every].replace('type=', '');
          }
        }
        var language = this.$i18n.locale;
        this.get({
          url: 'v1/posture/reports/' + uuid,
          params: {
            type: type,
            language: language
          },
          success: function success(result) {
            _this.updateReportData({
              reportData: result
            });
            _this.getReportData();
            console.log('result=>', result);
          },
          error: function error(data) {
            _this.loading = false;
            _this.valid = false;
          }
        });
      } else {
        _this.getReportData();
      }
    },
    getReportData: function getReportData(state) {
      this.loading = false;
      var reportData = state.vux.reportData;

      var customer = reportData.customer;
      var header = reportData.header;
      var user = reportData.user;
      var coverInfo = {};
      if (lodash_default.a.isNull(header)) {
        coverInfo.date = '--';
        coverInfo.time = '--';
      } else {
        coverInfo.date = moment_default()(header.creationTime).format('YYYY-MM-DD');
        coverInfo.time = moment_default()(header.creationTime).format('hh:mm');
      }

      if (lodash_default.a.isNull(user)) {
        coverInfo.userName = '--';
      } else {
        coverInfo.userName = user.name;
      }

      if (lodash_default.a.isNull(customer)) {
        coverInfo.customerName = '--';
      } else {
        coverInfo.customerName = customer.name;
      }

      if (lodash_default.a.isNull(header)) {
        coverInfo.logo = '';
      } else {
        coverInfo.logo = header.logo;
      }

      this.coverInfo = coverInfo;

      this.conclusion = reportData.conclusion;
      var conclusion = this.conclusion;
      if (!conclusion.face.valid || !conclusion.side.valid) {
        this.valid = false;
      } else {
        this.risks = {
          face: conclusion.face.risks,
          side: conclusion.side.risks
        };
        this.initRisksData();
        this.$nextTick(function () {
          var riskBodys = document.getElementsByClassName('risk-body');
          for (var i = 0; i < riskBodys.length; i++) {
            this.setSymptomCanvas({
              el: riskBodys[i],
              width: Number(riskBodys[i].parentNode.offsetWidth),
              height: Number(riskBodys[i].parentNode.offsetHeight)
            });
          }
          var riskBars = document.getElementsByClassName('risk-bar');
          for (var _i22 = 0; _i22 < riskBars.length; _i22++) {
            canvas_default.a.initRiskLevel({
              el: riskBars[_i22],
              width: Number(riskBars[_i22].parentNode.offsetWidth),
              height: Number(riskBars[_i22].parentNode.offsetHeight),
              color: {
                normal: '#00d963',
                mild: '#ffbf00',
                severe: '#ff4d4d'
              },
              level: this.level
            });
          }
        });
      }

      var points = {
        face: conclusion.face.points,
        side: assign_default()(conclusion.side.points, { side: conclusion.side.side })
      };
      this.points = points;

      console.log('all points =>', points);

      var photos = {
        face: reportData.face,
        side: reportData.side
      };
      this.photos = photos;

      this.initRiskPoints();
    }
  }), {
    GetQueryString: function GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);return null;
    }
  }, Object(vuex_esm["b" /* mapActions */])(['get']), Object(vuex_esm["c" /* mapMutations */])(['updateReportData'])),
  created: function created() {
    this.initReportData();
    var _this = this;

    for (var i = 0; i < Posture_ipad_bullets.length; i++) {

      Posture_ipad_bullets[i].text = this.bullets[i].text;
    }
    var symptoms = this.symptoms;
    _this.symptoms = assign_default()({}, _this.$t('symptoms'));
    console.log(this.GetQueryString("muscle") == 'hide', 'haha');
    if (this.GetQueryString("muscle") == 'hide') {
      this.MuscleShow = false;
    } else {
      this.MuscleShow = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Posture_ipad.vue





var Posture_ipad__extends2;























var components_Posture_ipad_langs = {
  en: '中文',
  cn: 'English',
  "zh-tw": '中文繁体'
};
var components_Posture_ipad_bullets = [{
  text: '首页',
  bulletClassName: 'pagination-bullet font-24',
  containerClassName: 'pagination-container hidden-pagination',
  bottomLineClassName: 'nav-line'
}, {
  text: '体态视图',
  bulletClassName: 'pagination-bullet font-24',
  containerClassName: 'pagination-container',
  bottomLineClassName: 'nav-line'
}, {
  text: '肌肉状态',
  bulletClassName: 'pagination-bullet font-24',
  containerClassName: 'pagination-container',
  bottomLineClassName: 'nav-line'
}, {
  text: '体态症状',
  bulletClassName: 'pagination-bullet font-24',
  containerClassName: 'pagination-container',
  bottomLineClassName: 'nav-line'
}];

/* harmony default export */ var components_Posture_ipad = ({
  name: "posture_ipad",
  i18n: { // `i18n` option, setup locale info for component
    messages: extends_default()({}, postureIpad)
  },
  directive: {
    bModalDirective: modal_modal["a" /* default */]
  },
  components: {
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    Previewer: vux_src_components_previewer,
    Loading: vux_src_components_loading,
    bModal: modal["a" /* default */],
    Posture_report: src_components_Posture_report,
    Posture_front: src_components_Posture_front,
    Posture_flank: src_components_Posture_flank,
    Posture_home: src_components_Posture_home,
    Posture_sympipad: src_components_Posture_sympipad,
    Posture_modal_ipad: src_components_Posture_modal_ipad
  },
  data: function data() {
    var _this2 = this;

    return {
      MuscleShow: false,
      valid: true,
      loading: true,
      reportData: {},
      customer: {},
      updateSwiper: false,
      bullets: [{
        text: this.$t('bullet.home'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: 'hidden-pagination',
        iconClassName: ''
      }, {
        text: this.$t('bullet.Posturedata'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-face'
      }, {
        text: this.$t('bullet.Score'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-riskassess'
      }, {
        text: this.$t('bullet.Muscle'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-bone',
        display: 'none'
      }, {
        text: this.$t('bullet.Solution'),
        bulletClassName: 'pagination-bullet font-12',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-symptom'
      }],
      viwesNav: [{
        text: this.$tc('viwesNav', 0),
        bulletClassName: 'pagination-bullet view-flant',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-views'
      }, {
        text: this.$tc('viwesNav', 1),
        bulletClassName: 'pagination-bullet view-side',
        containerClassName: '',
        iconClassName: 'pagination-icon pagination-views'
      }],
      swiperOption: {
        pagination: {

          el: '.posture-swiper-pagination',
          clickable: true,
          renderBullet: function renderBullet(index, className) {
            if (components_Posture_ipad_bullets[index].display == 'none') {
              console.log("================");
            } else {
              return '<div class="content-row content-row-column content-align-center content-row-between ' + components_Posture_ipad_bullets[index].containerClassName + ' ' + className + '">' + ('<span class="' + components_Posture_ipad_bullets[index].bulletClassName + '">' + components_Posture_ipad_bullets[index].text + '</span>') + ('<span class="' + components_Posture_ipad_bullets[index].bottomLineClassName + '"></span>') + '</div>';
            }
          }
        },
        on: {
          init: function init() {
            document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0;
          },

          transitionEnd: function transitionEnd(event) {
            var cur_index = sessionStorage.getItem('cur_index');
            console.log("touchEnd", cur_index);
            _this2.updateSwiper = true;
          },
          click: function click() {

            this.autoplay.stop();
            console.log("tapclickppppppppp");
          },
          tap: function tap() {
            this.autoplay.stop();
            console.log("tapppppppppp");
          },
          slideChange: function slideChange() {
            if (this.activeIndex === 0) {
              document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 0;
            } else {
              document.getElementsByClassName('posture-swiper-pagination')[0].style.opacity = 1;
            }
          },

          slideChangeTransitionStart: function slideChangeTransitionStart() {
            console.log('cur_index slideChangeTransitionStart', this.activeIndex);
            sessionStorage.setItem('cur_index', this.activeIndex);
          }
        }
      },
      normalRisks: [],
      mildRisks: [],
      severeRisks: [],
      symptoms: {
        head: [{
          name: '头部侧倾',
          key: 'headSidesway',
          normal: {
            left: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_RIGHT,
            normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY_RIGHT
          },
          definition: '在直立过程中，头部向左或右倾斜的现象。',
          harm: {
            bone: '颈椎侧屈',
            muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
            neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
            des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
          },
          risks: [{
            name: '肌肉韧带慢性劳损',
            des: '长期头侧倾容易导致颈后韧带、颈周围肌肉的慢性劳损。'
          }, {
            name: '颈椎病',
            des: '由于头部异位导致颈部软组织、骨骼的异常，增大了颈椎病患病风险。'
          }]
        }, {
          name: '头部前倾',
          key: 'headLean',
          normal: {
            normal: imgSrc_default.a.risk_normal.HEAD_LEAN
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.HEAD_LEAN
          },
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '椎弓变直或出现反弓',
            muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
            neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
            des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
          },
          risks: [{
            name: '头晕头痛',
            des: '头部前倾可能影响头部血液循环，由于血流不畅而导致头部缺氧，引发头晕头痛。'
          }, {
            name: '颈椎病',
            des: '长期的重度头部前倾可能会导致颈椎病。'
          }, {
            name: '腰椎不稳',
            des: '由于头部前倾引发颈椎受力异常，由此引发整个脊柱的受力异常。'
          }, {
            name: '心脑血管疾病',
            des: '头部的异位可能影响头部血液循环，危害心脑血管健康。'
          }]
        }],
        shoulder: [{
          name: '高低肩',
          key: 'highLowShoulder',
          normal: {
            left: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
            normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
            right: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
          },
          definition: '肩峰左右高度差超过2CM则为高低肩。',
          harm: {
            bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
            muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
            neurovascular: '',
            des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
          },
          risks: [{
            name: '慢性头痛',
            des: '长期的高低肩容易产生颈肩部位、头部的慢性疼痛。'
          }, {
            name: '骨刺',
            des: '高低肩使颈椎受力异常，最后可能导致颈椎部位退化，易形成骨刺。'
          }, {
            name: '腰痛',
            des: '高低肩可能造成骨盆的移位，使腰部肌力不平衡，导致腰痛。'
          }, {
            name: '长短腿',
            des: '由于高低肩造成的骨盆移位可能会使腿长发生变化。'
          }]
        }, {
          name: '圆肩',
          key: 'roundShoulder',
          normal: {
            normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER
          },
          definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
          harm: {
            bone: '肩胛骨外展、胸廓变小',
            muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
            neurovascular: '',
            des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
          },
          risks: [{
            name: '心脏负担加重',
            des: '过度圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉被压迫，使心脏工作负担加重。'
          }, {
            name: '头痛',
            des: '肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起头痛。'
          }, {
            name: '手臂麻木',
            des: '肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起手臂麻木。'
          }]
        }],
        trunk: [{
          name: '脊柱异位',
          key: 'spineSidesway',
          normal: {
            left: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_RIGHT,
            normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_LEFT,
            right: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY_RIGHT
          },
          definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
          harm: {
            bone: '脊柱出现S型弯曲或C型弯曲',
            muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
            neurovascular: '',
            des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
          },
          risks: [{
            name: '脊柱侧弯',
            des: '平面拍摄检测出脊柱异位提示您需进一步通过三维检测，确定是否存在脊柱侧弯的症状。'
          }, {
            name: '高低肩',
            des: '脊柱侧弯可能伴随高低肩症状。'
          }, {
            name: '骨盆侧倾',
            des: '脊柱侧弯可能伴随骨盆侧倾症状。'
          }]
        }],
        pelvis: [{
          name: '骨盆侧倾',
          key: 'pelvisLean',
          normal: {
            left: imgSrc_default.a.risk_normal.PELVIS_LEAN_LEFT,
            right: imgSrc_default.a.risk_normal.PELVIS_LEAN_RIGHT,
            normal: imgSrc_default.a.risk_normal.PELVIS_LEAN_NORMAL
          },
          abnormal: {
            left: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_LEFT,
            right: imgSrc_default.a.risk_abnormal.PELVIS_LEAN_RIGHT
          },
          definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
          harm: {
            bone: '骨盆倾斜',
            muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
            neurovascular: '',
            des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
          },
          risks: [{
            name: '慢性疼痛',
            des: '骨盆侧倾可能会引发腰腿疼痛、肩颈疼痛。'
          }, {
            name: '腰椎间盘突出',
            des: '骨盆侧倾可能加重腰椎间盘突出风险。'
          }, {
            name: '长短腿',
            des: '骨盆侧倾可能加重长短腿风险。。'
          }]
        }],
        'lower extremity': [{
          name: 'O型腿',
          key: 'legO',
          normal: {
            normal: imgSrc_default.a.risk_normal.LEG_O
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.LEG_O
          },
          definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
          harm: {
            bone: 'O型腿（膝内翻）',
            muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
            neurovascular: '',
            des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
          },
          risks: [{
            name: '半月板损伤',
            des: 'O型腿造成下肢力线发生改变，膝关节内侧间隙承受大于正常负荷的压力。可能引起膝关节内侧半月板损伤。'
          }, {
            name: '关节炎',
            des: '严重O型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n' + '置换手术。'
          }]
        }, {
          name: 'X型腿',
          key: 'legX',
          normal: {
            normal: imgSrc_default.a.risk_normal.LEG_X
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.LEG_X
          },
          definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
          harm: {
            bone: 'X型腿（膝外翻）',
            muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
            neurovascular: '',
            des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
          },
          risks: [{
            name: '半月板损伤',
            des: 'X型腿造成下肢力线发生改变，膝关节外侧间隙承受大于正常负荷的压力。可能引起膝关节外侧半月板损伤。'
          }, {
            name: '关节炎',
            des: '严重X型腿最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节\n' + '置换手术。'
          }]
        }, {
          name: '膝过伸',
          key: 'kneeOverstretch',
          normal: {
            normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH
          },
          definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
          harm: {
            bone: '踝关节背屈不足，使膝关节无法向前移动',
            muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
            neurovascular: '',
            des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
          },
          risks: [{
            name: '膝关节退变',
            des: '长期膝关节过伸，会引起膝关节的过度磨损，加大膝关节退变的发生率。'
          }, {
            name: '损害全身平衡',
            des: '膝关节位置的改变会引起髋关节、骨盆、踝关节的位置异常，由此逐渐损害全身的平衡状态，长期累积会引发各种体态异常。'
          }]
        }, {
          name: 'XO型腿',
          key: 'legXO',
          normal: {
            normal: imgSrc_default.a.risk_normal.LEG_XO
          },
          abnormal: {
            normal: imgSrc_default.a.risk_abnormal.LEG_XO
          },
          definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
          harm: {
            bone: '这个是XO型腿',
            muscle: '这个是XO型腿',
            neurovascular: '',
            des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
          },
          risks: [{
            name: '膝关节疼痛',
            des: '由于XO型腿造成股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛。'
          }, {
            name: '膝关节炎',
            des: '重度XO型腿最终可能发展为膝关节骨性关节炎。'
          }]
        }]
      },
      level: {
        normal: 'normal',
        mild: 'mild',
        severe: 'severe'
      },
      locale: '',
      langTag: this.$i18n.locale,
      localeText: components_Posture_ipad_langs[this.$i18n.locale],
      risks: {},
      points: null,
      photos: null,
      coverInfo: {},
      modalInfo: null,
      keyMap: {
        face: {
          headSidesway: {
            position: ['neck', 'nose'],
            scale: 0.5
          },
          highLowShoulder: {
            position: ['shoulder-left', 'shoulder-right'],
            scale: 0.3
          },
          spineSidesway: {
            position: ['elbow-left', 'elbow-right'],
            scale: 0.5
          },
          pelvisLean: {
            position: ['hip-left', 'hip-right'],
            scale: 1.5
          },
          legO: {
            position: ['hip', 'ankle'],
            scale: 0.3
          },
          legX: {
            position: ['hip', 'ankle'],
            scale: 0.3
          },
          legXO: {
            position: ['hip', 'ankle'],
            scale: 0.3
          }
        },
        side: {
          headLean: {
            position: ['neck', 'ear'],
            scale: 0.3
          },
          roundShoulder: {
            position: ['nose', 'elbow'],
            scale: 0
          },
          kneeOverstretch: {
            position: ['hip', 'ankle'],
            scale: 0.3
          }
        }
      },
      img: {
        face: null,
        side: null
      }
    };
  },

  computed: {
    swiper: function swiper() {
      return this.$refs.postureSwiper.swiper;
    },

    show: function show() {

      return this.$t('indexPage.show');
    }
  },
  watch: {
    locale: function locale() {
      console.log('change locale', this.$i18n.locale);
    },
    updateSwiper: function updateSwiper() {
      console.log("this.updateSwiper", this.updateSwiper);
    }
  },
  methods: extends_default()((Posture_ipad__extends2 = {
    updateSwiperIndex: function updateSwiperIndex(data) {
      this.updateSwiper = data;
    },
    setSymptomCanvasModal: function setSymptomCanvasModal(risk) {
      var points = this.points;
      var needDetail = ['legO', 'legX', 'legXO'];
      var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

      var riskKey = risk.key;
      var keyMap = this.keyMap;
      var positionArr = void 0;
      var positionPointsArr = [];
      var faceOrSide = void 0;
      var scale = void 0;

      console.log('keyMap =>', keyMap);

      keys_default()(keyMap).forEach(function (direction, index) {
        keys_default()(keyMap[direction]).forEach(function (key, index) {
          if (key === riskKey) {
            positionArr = keyMap[direction][key].position;
            scale = keyMap[direction][key].scale;
          }
        });
      });

      console.log('positionArr =>', positionArr);

      if (needDetail.indexOf(riskKey) !== -1) {

        var lOrR = void 0;
        if (risk.detail === '右腿') {
          lOrR = 'right';
        } else {
          lOrR = 'left';
        }

        for (var i = 0; i < positionArr.length; i++) {
          positionPointsArr.push(points.face[positionArr[i]][lOrR]);
        }

        faceOrSide = 'face';
      } else if (forSide.indexOf(riskKey) !== -1) {

        var _lOrR = this.conclusion.side.side;

        for (var _i = 0; _i < positionArr.length; _i++) {
          console.log('positionArr[i] =>', points.side[positionArr[_i]].left);
          if (points.side[positionArr[_i]].left === undefined) {
            console.log('in');
            positionPointsArr.push(points.side[positionArr[_i]]);
          } else {
            positionPointsArr.push(points.side[positionArr[_i]][_lOrR]);
          }
        }

        faceOrSide = 'side';
      } else {

        for (var _i2 = 0; _i2 < positionArr.length; _i2++) {
          var positionAndDirectionArr = positionArr[_i2].split('-');
          if (positionAndDirectionArr.length === 1) {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
          } else {
            positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
          }
        }

        faceOrSide = 'face';
      }

      console.log('positionPointsArr =>', positionPointsArr);

      var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
      var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
      var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
      var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

      var width = _x > _y ? _x : _y;
      width *= 1 + scale;

      var x = xMid - width / 2;
      var y = yMid - width / 2;

      console.log('w =>', width);
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.width = width;
      canvas.height = width;

      var img = this.img[faceOrSide];
      console.log('img =>', img);
      ctx.drawImage(img, x, y, width, width, 0, 0, width, width);
      console.log('modalBody =>', document.getElementsByTagName('body'));

      this.canvas = canvas;
    },
    getRiskImg: function getRiskImg(risk) {
      var direction = 'normal';
      var img = void 0;
      console.log(risk.key);
      if (!lodash_default.a.isNull(risk.direction) && risk.key !== 'legO' && risk.key !== 'legX' && risk.key !== 'legXO' && risk.key !== 'kneeOverstretch') {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    }
  }, defineProperty_default()(Posture_ipad__extends2, 'setSymptomCanvasModal', function setSymptomCanvasModal(risk) {
    var points = this.points;
    var needDetail = ['legO', 'legX', 'legXO'];
    var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

    var riskKey = risk.key;
    var keyMap = this.keyMap;
    var positionArr = void 0;
    var positionPointsArr = [];
    var faceOrSide = void 0;
    var scale = void 0;

    console.log('keyMap =>', keyMap);

    keys_default()(keyMap).forEach(function (direction, index) {
      keys_default()(keyMap[direction]).forEach(function (key, index) {
        if (key === riskKey) {
          positionArr = keyMap[direction][key].position;
          scale = keyMap[direction][key].scale;
        }
      });
    });

    console.log('positionArr =>', positionArr);

    if (needDetail.indexOf(riskKey) !== -1) {

      var lOrR = void 0;
      if (risk.detail === '右腿') {
        lOrR = 'right';
      } else {
        lOrR = 'left';
      }

      for (var i = 0; i < positionArr.length; i++) {
        positionPointsArr.push(points.face[positionArr[i]][lOrR]);
      }

      faceOrSide = 'face';
    } else if (forSide.indexOf(riskKey) !== -1) {

      var _lOrR2 = this.conclusion.side.side;

      for (var _i3 = 0; _i3 < positionArr.length; _i3++) {
        console.log('positionArr[i] =>', points.side[positionArr[_i3]].left);
        if (points.side[positionArr[_i3]].left === undefined) {
          console.log('in');
          positionPointsArr.push(points.side[positionArr[_i3]]);
        } else {
          positionPointsArr.push(points.side[positionArr[_i3]][_lOrR2]);
        }
      }

      faceOrSide = 'side';
    } else {

      for (var _i4 = 0; _i4 < positionArr.length; _i4++) {
        var positionAndDirectionArr = positionArr[_i4].split('-');
        if (positionAndDirectionArr.length === 1) {
          positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
        } else {
          positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
        }
      }

      faceOrSide = 'face';
    }

    console.log('positionPointsArr =>', positionPointsArr);

    var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
    var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
    var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
    var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

    var width = _x > _y ? _x : _y;
    width *= 1 + scale;

    var x = xMid - width / 2;
    var y = yMid - width / 2;

    console.log('w =>', width);
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.width = width;
    canvas.height = width;

    var img = this.img[faceOrSide];
    console.log('img =>', img);
    ctx.drawImage(img, x, y, width, width, 0, 0, width, width);
    console.log('modalBody =>', document.getElementsByTagName('body'));

    this.canvas = canvas;
  }), defineProperty_default()(Posture_ipad__extends2, 'setModalInfo', function setModalInfo(risk) {
    var that = this;
    this.modalInfo = risk;
    console.log('risk =>', risk);
    this.setSymptomCanvasModal(risk);

    this.$nextTick(function () {
      this.$refs.riskModalRef.show();
      var canvas = that.canvas;
      document.getElementById('modalBody').innerHTML = '';
      document.getElementById('modalBody').appendChild(canvas);
    });
  }), defineProperty_default()(Posture_ipad__extends2, 'setSymptomCanvas', function setSymptomCanvas(option) {
    var canvas = option.el;
    var ctx = canvas.getContext('2d');

    var points = this.points;
    var needDetail = ['legO', 'legX', 'legXO'];
    var forSide = ['headLean', 'roundShoulder', 'kneeOverstretch'];

    var riskKey = canvas.dataset.key;
    var keyMap = this.keyMap;
    var positionArr = void 0;
    var positionPointsArr = [];
    var faceOrSide = void 0;
    var scale = void 0;

    console.log('keyMap =>', keyMap);

    keys_default()(keyMap).forEach(function (direction, index) {
      keys_default()(keyMap[direction]).forEach(function (key, index) {
        if (key === riskKey) {
          positionArr = keyMap[direction][key].position;
          scale = keyMap[direction][key].scale;
        }
      });
    });

    console.log('positionArr =>', positionArr);

    if (needDetail.indexOf(riskKey) !== -1) {

      var lOrR = void 0;
      if (canvas.dataset.detail === '右腿') {
        lOrR = 'right';
      } else {
        lOrR = 'left';
      }

      for (var i = 0; i < positionArr.length; i++) {
        positionPointsArr.push(points.face[positionArr[i]][lOrR]);
      }

      faceOrSide = 'face';
    } else if (forSide.indexOf(riskKey) !== -1) {

      var _lOrR3 = this.conclusion.side.side;

      for (var _i5 = 0; _i5 < positionArr.length; _i5++) {
        console.log('positionArr[i] =>', points.side[positionArr[_i5]].left);
        if (points.side[positionArr[_i5]].left === undefined) {
          console.log('in');
          positionPointsArr.push(points.side[positionArr[_i5]]);
        } else {
          positionPointsArr.push(points.side[positionArr[_i5]][_lOrR3]);
        }
      }

      faceOrSide = 'side';
    } else {

      for (var _i6 = 0; _i6 < positionArr.length; _i6++) {
        var positionAndDirectionArr = positionArr[_i6].split('-');
        if (positionAndDirectionArr.length === 1) {
          positionPointsArr.push(points.face[positionAndDirectionArr[0]]);
        } else {
          positionPointsArr.push(points.face[positionAndDirectionArr[0]][positionAndDirectionArr[1]]);
        }
      }

      faceOrSide = 'face';
    }

    console.log('positionPointsArr =>', positionPointsArr);

    var _x = Math.abs(positionPointsArr[0].x - positionPointsArr[1].x);
    var _y = Math.abs(positionPointsArr[0].y - positionPointsArr[1].y);
    var xMid = (positionPointsArr[0].x + positionPointsArr[1].x) / 2;
    var yMid = (positionPointsArr[0].y + positionPointsArr[1].y) / 2;

    var width = _x > _y ? _x : _y;
    width *= 1 + scale;

    var x = xMid - width / 2;
    var y = yMid - width / 2;

    console.log('w =>', width);
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.width = width;
    canvas.height = width;
    var img = new Image();
    img.src = this.photos[faceOrSide];

    img.onload = function () {
      ctx.drawImage(img, x, y, width, width, 0, 0, width, width);
    };
  }), defineProperty_default()(Posture_ipad__extends2, 'hideModal', function hideModal() {
    this.$refs.riskModalRef.hide();
  }), defineProperty_default()(Posture_ipad__extends2, 'getLevel', function getLevel(level) {
    switch (level) {
      case this.level.normal:
        return {
          des: '正常',
          className: 'level-normal'
        };
      case this.level.mild:
        return {
          des: '潜在风险',
          className: 'level-mild'
        };
      case this.level.severe:
        return {
          des: '高风险',
          className: 'level-severe'
        };
    }
  }), defineProperty_default()(Posture_ipad__extends2, 'checkIfAbnormal', function checkIfAbnormal(level) {
    switch (level) {
      case this.level.normal:
        return false;
      case this.level.mild:
        return false;
      case this.level.severe:
        return true;
    }
  }), defineProperty_default()(Posture_ipad__extends2, 'sortHighToLow', function sortHighToLow(arr) {
    return lodash_default.a.orderBy(arr, ['value'], ['desc']);
  }), defineProperty_default()(Posture_ipad__extends2, 'slideIn', function slideIn() {
    this.swiper.slideTo(1);
  }), defineProperty_default()(Posture_ipad__extends2, 'initRiskBar', function initRiskBar() {
    this.$refs.riskModalRef.$el.getElementsByClassName('modal-content')[0].scrollTop = 0;
    var modalRiskBar = document.getElementById('modalRiskBar');
    this.initRiskLevelModal({
      el: modalRiskBar,
      width: Number(modalRiskBar.parentNode.offsetWidth),
      height: Number(modalRiskBar.parentNode.offsetHeight),
      color: {
        normal: '#00d963',
        mild: '#ffbf00',
        severe: '#ff4d4d'
      },
      level: this.level
    });
  }), defineProperty_default()(Posture_ipad__extends2, 'initRiskLevelModal', function initRiskLevelModal(option) {
    console.log('el =>', option.width);
    var canvas = option.el;
    var cxt = canvas.getContext('2d');
    var scaleW = option.width / 229;
    var scaleH = option.height / 32;
    var scale = scaleW < scaleH ? 2 * scaleW : 2 * scaleH;
    canvas.width = 229 * scale;
    canvas.height = 32 * scale;
    canvas.style.width = 229 * scale / 2 + 'px';
    canvas.style.height = 32 * scale / 2 + 'px';
    var value = Number(canvas.dataset.value);
    value = Math.floor(value);
    console.log('color =>', option.color);
    console.log('level =>', option.level);
    var color = option.color[canvas.dataset.level];
    var valueX = value / 100 * 217;

    var midAndHightX = [{ id: 20, value: 20 / 100 * 217 }, { id: 60, value: 60 / 100 * 217 }];
    cxt.scale(scale, scale);
    cxt.translate(6, 0);

    cxt.save();
    cxt.fillStyle = color;
    cxt.beginPath();
    cxt.moveTo(valueX - 6, 2);
    cxt.lineTo(valueX + 6, 2);

    cxt.arc(valueX + 6, 3, 1, -Math.PI / 2, 0);

    cxt.lineTo(valueX + 7, 11);

    cxt.arc(valueX + 6, 11, 1, 0, Math.PI / 2);

    cxt.lineTo(valueX + 2, 12);
    cxt.lineTo(valueX, 14);
    cxt.lineTo(valueX - 2, 12);
    cxt.lineTo(valueX - 6, 12);

    cxt.arc(valueX - 6, 11, 1, Math.PI / 2, Math.PI);

    cxt.lineTo(valueX - 7, 3);
    cxt.arc(valueX - 6, 3, 1, Math.PI, Math.PI * 3 / 2);
    cxt.closePath();
    cxt.fill();
    cxt.fillStyle = '#fff';
    cxt.textAlign = 'center';
    cxt.font = '10px serif';
    cxt.fillText(value, valueX, 10);
    cxt.restore();

    cxt.save();
    cxt.fillStyle = '#b2b2b2';
    cxt.beginPath();
    cxt.moveTo(1.5, 18);
    cxt.lineTo(217, 18);
    cxt.arc(217, 19.5, 1.5, 3 * Math.PI / 2, Math.PI / 2);
    cxt.lineTo(1.5, 21);
    cxt.arc(1.5, 19.5, 1.5, Math.PI / 2, 3 * Math.PI / 2);
    cxt.closePath();
    cxt.fill();
    cxt.restore();

    var gradient = cxt.createLinearGradient(0, 0, 217, 0);
    gradient.addColorStop(0, '#00ff6a');
    gradient.addColorStop(.38, '#ffda08');
    gradient.addColorStop(1, '#ff4d4d');

    cxt.fillStyle = gradient;
    cxt.beginPath();
    if (valueX > 0) {
      cxt.moveTo(1.5, 18);
      cxt.lineTo(valueX, 18);
      cxt.arc(valueX, 19.5, 1.5, 3 * Math.PI / 2, Math.PI / 2);
      cxt.lineTo(1.5, 21);
      cxt.arc(1.5, 19.5, 1.5, Math.PI / 2, 3 * Math.PI / 2);
    }
    cxt.closePath();
    cxt.fill();

    for (var i = 0; i < midAndHightX.length; i++) {
      cxt.beginPath();
      cxt.strokeStyle = '#8a8b81';
      cxt.lineWidth = 0.5;
      cxt.setLineDash([4, 0.5]);
      cxt.moveTo(midAndHightX[i].value + 1, 16);
      cxt.lineTo(midAndHightX[i].value + 1, 24);
      cxt.fillStyle = '#b2b2b2';
      cxt.textAlign = 'center';
      cxt.font = '8px serif';
      cxt.fillText(midAndHightX[i].id, midAndHightX[i].value + 1, 30);
      cxt.stroke();
      cxt.closePath();
    }
  }), defineProperty_default()(Posture_ipad__extends2, 'initRisksData', function initRisksData() {
    var risks = this.risks;
    var level = this.level;
    var symptoms = this.symptoms;
    var normalRisks = [];
    var mildRisks = [];
    var severeRisks = [];

    for (var direction in risks) {
      for (var i = 0; i < risks[direction].length; i++) {
        var symptom = symptoms[risks[direction][i].position][risks[direction][i].code - 1];

        if (symptom.value) {
          var otherSymptom = assign_default()({}, symptom);
          if (!risks[direction][i].valid) {
            otherSymptom.raw = 0;
            otherSymptom.value = 0;
            otherSymptom.level = level.normal;
            otherSymptom.detail = '';
            otherSymptom.direction = 'normal';
          } else {
            otherSymptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
            otherSymptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
            otherSymptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
            otherSymptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
            otherSymptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
          }

          symptoms[risks[direction][i].position].push(otherSymptom);
        } else {
          if (!risks[direction][i].valid) {
            symptom.raw = 0;
            symptom.value = 0;
            symptom.level = level.normal;
            symptom.detail = '';
            symptom.direction = 'normal';
          } else {
            symptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
            symptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
            symptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
            symptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
            symptom.direction = risks[direction][i].direction ? risks[direction][i].direction : 'normal';
          }
        }
      }
    }

    for (var position in symptoms) {
      for (var _i7 = 0; _i7 < symptoms[position].length; _i7++) {
        if (lodash_default.a.isUndefined(symptoms[position][_i7].value)) {
          continue;
        }
        switch (symptoms[position][_i7].level) {
          case level.normal:
            normalRisks.push(symptoms[position][_i7]);
            break;
          case level.mild:
            mildRisks.push(symptoms[position][_i7]);
            break;
          case level.severe:
            severeRisks.push(symptoms[position][_i7]);
            break;
          default:
            normalRisks.push(symptoms[position][_i7]);
            break;
        }
      }
    }

    this.normalRisks = this.sortHighToLow(normalRisks);
    this.mildRisks = this.sortHighToLow(mildRisks);
    this.severeRisks = this.sortHighToLow(severeRisks);
    console.log('normalRisks =>', normalRisks);
    console.log('mildRisks =>', mildRisks);
    console.log('severeRisks =>', severeRisks);
  }), defineProperty_default()(Posture_ipad__extends2, 'initRiskPoints', function initRiskPoints() {
    var points = this.points;
    var photos = this.photos;
    var faceCanvas = document.createElement('canvas');
    var sideCanvas = document.createElement('canvas');
    var _this = this;

    var facePointsArr = [];
    var face = points.face;
    var faceImg = new Image();

    var hipRPoint = face['hip']['right'];
    var hipLPoint = face['hip']['left'];
    var neckPoint = face['neck'];
    var hipMPoint = {
      x: 0,
      y: 0
    };
    var hipAndNeckMPoint = {
      x: 0,
      y: 0
    };
    if (hipLPoint.x == 0 && hipLPoint.y == 0 || hipRPoint.x == 0 && hipRPoint.y == 0) {} else {

      hipMPoint.x = (hipLPoint.x + hipRPoint.x) / 2;
      hipMPoint.y = (hipLPoint.y + hipRPoint.y) / 2;

      if (!(neckPoint.x == 0 && neckPoint.y == 0)) {
        hipAndNeckMPoint.x = (neckPoint.x + hipMPoint.x) / 2;
        hipAndNeckMPoint.y = (neckPoint.y + hipMPoint.y) / 2;
      }
    };

    face.hipM = hipMPoint;
    face.hipAndNeckM = hipAndNeckMPoint;

    var faceOrder = [['ear-right', 'eye-right', 'nose', 'eye-left', 'ear-left'], ['wrist-right', 'elbow-right', 'shoulder-right', 'neck', 'shoulder-left', 'elbow-left', 'wrist-left'], ['ankle-right', 'knee-right', 'hip-right', 'hipM', 'hip-left', 'knee-left', 'ankle-left'], ['neck', 'hipAndNeckM', 'hipM'], ['nose', 'neck']];

    var verticalStandard = ['shoulder-right', 'ankle-middle', 'shoulder-left'];
    var verticalPointsArr = [];

    var risks = this.normalRisks.concat(this.mildRisks, this.severeRisks);

    console.log('risks =>', risks);
    var faceSymptomWithPosition = ['headSidesway-ear', 'highLowShoulder-shoulder', 'spineSidesway', 'pelvisLean-hip', 'legO-knee', 'legX-knee', 'legXO-knee'];
    var faceHorizontalArr = [];

    for (var i = 0; i < faceSymptomWithPosition.length; i++) {
      var symptomWithPositionArr = faceSymptomWithPosition[i].split('-');
      var pointsAndAngle = {
        key: symptomWithPositionArr[0]
      };

      for (var j = 0; j < risks.length; j++) {
        if (risks[j].key == symptomWithPositionArr[0]) {
          if (!lodash_default.a.isUndefined(pointsAndAngle.raw)) {
            pointsAndAngle.secondRaw = risks[j].raw;
          } else {
            pointsAndAngle.raw = risks[j].raw;
            if (symptomWithPositionArr.length == 1) {
              pointsAndAngle.points = [face['elbow'].left];
            } else {
              pointsAndAngle.points = [face[symptomWithPositionArr[1]].right, face[symptomWithPositionArr[1]].left];
            }
          }
        }
      }

      if (lodash_default.a.isUndefined(pointsAndAngle.raw) || lodash_default.a.isUndefined(pointsAndAngle.points)) {
        continue;
      } else {
        faceHorizontalArr.push(pointsAndAngle);
      }
    }

    console.log('faceHorizontalArr =>', faceHorizontalArr);

    for (var _i8 = 0; _i8 < faceOrder.length; _i8++) {
      var pointsArr = [];
      for (var _j = 0; _j < faceOrder[_i8].length; _j++) {
        var positionArr = faceOrder[_i8][_j].split('-');
        if (positionArr.length == 1) {
          pointsArr.push(face[positionArr[0]]);
        } else {
          pointsArr.push(face[positionArr[0]][positionArr[1]]);
        }
      }
      facePointsArr.push(pointsArr);
    }

    for (var _i9 = 0; _i9 < verticalStandard.length; _i9++) {
      var _positionArr = verticalStandard[_i9].split('-');

      if (_positionArr[1] == 'middle') {
        if (face[_positionArr[0]].left.x == 0 && face[_positionArr[0]].left.y == 0 || face[_positionArr[0]].right.x == 0 && face[_positionArr[0]].right.y == 0) {
          verticalPointsArr.push({
            x: 0,
            y: 0
          });
        } else {
          verticalPointsArr.push({
            x: (face[_positionArr[0]].left.x + face[_positionArr[0]].right.x) / 2,
            y: 0
          });
        }
      } else {
        verticalPointsArr.push(face[_positionArr[0]][_positionArr[1]]);
      }
    }

    console.log('verticalPointsArr =>', verticalPointsArr);

    faceImg.src = photos.face;
    faceImg.onload = function () {
      _this.img.face = faceImg;

      var width = faceImg.width;
      var height = faceImg.height;
      faceCanvas.width = width;
      faceCanvas.height = height;
      faceCanvas.style.width = '100%';

      var cxt = faceCanvas.getContext('2d');
      cxt.drawImage(faceImg, 0, 0, width, height);

      for (var _i10 = 0; _i10 < facePointsArr.length; _i10++) {
        for (var _j2 = 0; _j2 < facePointsArr[_i10].length; _j2++) {
          if (_j2 == 0 || facePointsArr[_i10][_j2].x == 0 && facePointsArr[_i10][_j2].y == 0 || facePointsArr[_i10][_j2 - 1].x == 0 && facePointsArr[_i10][_j2 - 1].y == 0) {
            if (facePointsArr[_i10][_j2].x == 0 && facePointsArr[_i10][_j2].y == 0) {
              continue;
            } else {
              _this.drawPoint({
                el: faceCanvas,
                point: facePointsArr[_i10][_j2]
              });
              continue;
            }
          } else {
            _this.drawPoint({
              el: faceCanvas,
              point: facePointsArr[_i10][_j2]
            });
            _this.drawLine({
              el: faceCanvas,
              points: [facePointsArr[_i10][_j2], facePointsArr[_i10][_j2 - 1]]
            });
          }
        }
      }

      for (var _i11 = 0; _i11 < verticalPointsArr.length; _i11++) {
        if (verticalPointsArr[_i11].x == 0 && verticalPointsArr[_i11].y == 0) {
          continue;
        } else {
          cxt.save();
          cxt.strokeStyle = '#4db664';
          cxt.beginPath();
          cxt.moveTo(verticalPointsArr[_i11].x, 0);
          cxt.lineTo(verticalPointsArr[_i11].x, height);
          cxt.closePath();
          cxt.stroke();
          cxt.restore();

          cxt.save();
          cxt.fillStyle = '#fe610f';
          cxt.font = '30px serif';
          var offset_height = (568 - 71) / (320 / width);
          if (_i11 == 0) {
            cxt.fillText('α', verticalPointsArr[_i11].x + 5, offset_height - 5);
          } else if (_i11 == verticalPointsArr.length - 1) {
            cxt.fillText('γ', verticalPointsArr[_i11].x + 5, offset_height - 5);
          } else {
            cxt.fillText('β', verticalPointsArr[_i11].x + 5, offset_height - 5);
          }
          cxt.restore();
        }
      }

      var min = 99999;
      var max = 0;
      var indexOfKneeArr = [];
      for (var _i12 = 0; _i12 < faceHorizontalArr.length; _i12++) {
        if (faceHorizontalArr[_i12].points.length !== 1) {
          if (faceHorizontalArr[_i12].points[0].x == 0 && faceHorizontalArr[_i12].points[0].y == 0 || faceHorizontalArr[_i12].points[1].x == 0 && faceHorizontalArr[_i12].points[1].y == 0) {
            continue;
          }
          if (faceHorizontalArr[_i12].points[0].x < min) {
            min = faceHorizontalArr[_i12].points[0].x;
          }
          if (faceHorizontalArr[_i12].points[1].x > max) {
            max = faceHorizontalArr[_i12].points[1].x;
          }
        }

        if (faceHorizontalArr[_i12].key == 'legX' || faceHorizontalArr[_i12].key == 'legO' || faceHorizontalArr[_i12].key == 'legXO') {
          indexOfKneeArr.push(_i12);
        }
      }

      if (indexOfKneeArr.length == 2) {
        faceHorizontalArr[indexOfKneeArr[0]].secondRaw = faceHorizontalArr[indexOfKneeArr[1]].raw;
        faceHorizontalArr.splice(indexOfKneeArr[1], 1);
      }

      for (var _i13 = 0; _i13 < faceHorizontalArr.length; _i13++) {
        _this.drawLineAndAngle({
          el: faceCanvas,
          angle: faceHorizontalArr[_i13].raw,
          secondAngle: faceHorizontalArr[_i13].secondRaw,
          points: faceHorizontalArr[_i13].points,
          min: min,
          max: max
        });
      }

      _this.$nextTick(function () {});
    };

    var side = points.side;
    var sidePointsArr = [];
    var sideImg = new Image();
    console.log('side =>', side);

    var lOrR = side.side;
    var sideOrder = [['ankle-' + lOrR, 'knee-' + lOrR, 'hip-' + lOrR, 'shoulder-' + lOrR, 'elbow-' + lOrR, 'wrist-' + lOrR], ['shoulder-' + lOrR, 'ear-' + lOrR, 'eye-' + lOrR, 'nose']];

    var sideVerticalStandard = ['ankle-' + lOrR, 'nose'];
    var sideVerticalPointsArr = [];

    for (var _i14 = 0; _i14 < sideOrder.length; _i14++) {
      var _pointsArr = [];
      for (var _j3 = 0; _j3 < sideOrder[_i14].length; _j3++) {
        var _positionArr2 = sideOrder[_i14][_j3].split('-');
        if (_positionArr2.length == 1) {
          _pointsArr.push(side[_positionArr2[0]]);
        } else {
          _pointsArr.push(side[_positionArr2[0]][_positionArr2[1]]);
        }
      }
      sidePointsArr.push(_pointsArr);
    }

    for (var _i15 = 0; _i15 < sideVerticalStandard.length; _i15++) {
      var _positionArr3 = sideVerticalStandard[_i15].split('-');
      if (_positionArr3.length == 1) {
        sideVerticalPointsArr.push(side[_positionArr3[0]]);
      } else {
        sideVerticalPointsArr.push(side[_positionArr3[0]][_positionArr3[1]]);
      }
    }

    var sideSymptomWithPosition = ['ear-shoulder', 'hip-knee'];
    var sideHorizontalArr = [];

    for (var _i16 = 0; _i16 < sideSymptomWithPosition.length; _i16++) {
      var horizontalArr = [];
      var _positionArr4 = sideSymptomWithPosition[_i16].split('-');
      for (var _j4 = 0; _j4 < _positionArr4.length; _j4++) {
        horizontalArr.push(side[_positionArr4[_j4]][lOrR]);
      }
      sideHorizontalArr.push(horizontalArr);
    }

    var sideSymptomWithAngle = ['headLean', 'roundShoulder', 'kneeOverstretch'];
    var sideSymptomWithAngleRisk = [];

    for (var _i17 = 0; _i17 < sideSymptomWithAngle.length; _i17++) {
      for (var _j5 = 0; _j5 < risks.length; _j5++) {
        if (risks[_j5].key == sideSymptomWithAngle[_i17]) {
          sideSymptomWithAngleRisk.push(risks[_j5]);
        }
      }
    }

    console.log('sideHorizontalArr =>', sideHorizontalArr);

    sideImg.src = photos.side;
    sideImg.onload = function () {
      _this.img.side = sideImg;

      var width = sideImg.width;
      var height = sideImg.height;
      sideCanvas.width = width;
      sideCanvas.height = height;
      sideCanvas.style.width = '100%';

      var cxt = sideCanvas.getContext('2d');
      cxt.drawImage(sideImg, 0, 0, width, height);

      for (var _i18 = 0; _i18 < sidePointsArr.length; _i18++) {
        for (var _j6 = 0; _j6 < sidePointsArr[_i18].length; _j6++) {
          if (_j6 == 0 || sidePointsArr[_i18][_j6].x == 0 && sidePointsArr[_i18][_j6].y == 0 || sidePointsArr[_i18][_j6 - 1].x == 0 && sidePointsArr[_i18][_j6 - 1].y == 0) {
            if (sidePointsArr[_i18][_j6].x == 0 && sidePointsArr[_i18][_j6].y == 0) {
              continue;
            } else {
              _this.drawPoint({
                el: sideCanvas,
                point: sidePointsArr[_i18][_j6]
              });
              continue;
            }
          } else {
            _this.drawPoint({
              el: sideCanvas,
              point: sidePointsArr[_i18][_j6]
            });
            if (_j6 != 3) {
              _this.drawLine({
                el: sideCanvas,
                points: [sidePointsArr[_i18][_j6], sidePointsArr[_i18][_j6 - 1]]
              });
            }
          }
        }
      }

      for (var _i19 = 0; _i19 < sideVerticalPointsArr.length; _i19++) {
        if (sideVerticalPointsArr[_i19].x == 0 && sideVerticalPointsArr[_i19].y == 0) {
          continue;
        } else {
          cxt.save();
          cxt.strokeStyle = '#4db664';
          cxt.beginPath();
          cxt.moveTo(sideVerticalPointsArr[_i19].x, 0);
          cxt.lineTo(sideVerticalPointsArr[_i19].x, height);
          cxt.closePath();
          cxt.stroke();
          cxt.restore();

          cxt.save();
          cxt.fillStyle = '#fe610f';
          cxt.font = '30px serif';
          var offset_height = (568 - 71) / (320 / width);
          if (_i19 == 0) {
            cxt.fillText('α', sideVerticalPointsArr[_i19].x + 5, offset_height - 5);
          } else {
            cxt.fillText('β', sideVerticalPointsArr[_i19].x + 5, offset_height - 5);
          }
          cxt.restore();
        }
      }

      for (var _i20 = 0; _i20 < sideHorizontalArr.length; _i20++) {
        _this.drawLine({
          el: sideCanvas,
          points: sideHorizontalArr[_i20],
          isSide: true
        });
      }

      for (var _i21 = 0; _i21 < sideSymptomWithAngleRisk.length; _i21++) {
        _this.drawRectAndAngle({
          cxt: cxt,
          angle: Number(sideSymptomWithAngleRisk[_i21].raw.toFixed(1)),
          point: {
            x: width - 120,
            y: height * .2 * (_i21 + 1)
          }
        });
      }

      _this.$nextTick(function () {});
    };
  }), defineProperty_default()(Posture_ipad__extends2, 'drawPoint', function drawPoint(option) {
    var canvas = option.el;
    var point = option.point;
    var cxt = canvas.getContext('2d');
    cxt.save();
    cxt.fillStyle = '#009eff';
    cxt.beginPath();
    cxt.arc(point.x, point.y, 5, 0, 2 * Math.PI);
    cxt.closePath();
    cxt.fill();
    cxt.restore();
    cxt.save();
    cxt.fillStyle = "rgba(83, 158, 255, .3)";
    cxt.beginPath();
    cxt.arc(point.x, point.y, 10, 0, 2 * Math.PI);
    cxt.closePath();
    cxt.fill();
    cxt.restore();
  }), defineProperty_default()(Posture_ipad__extends2, 'drawLine', function drawLine(option) {

    if (option.points[0].x == 0 && option.points[0].y == 0 || option.points[1].x == 0 && option.points[1].y == 0) {
      return;
    }
    var canvas = option.el;
    var points = option.points;
    var cxt = canvas.getContext('2d');
    cxt.save();
    cxt.lineWidth = 3;
    if (!option.isSide) {
      cxt.strokeStyle = '#5f58f4';
      cxt.beginPath();
      cxt.moveTo(points[0].x, points[0].y);
      cxt.lineTo(points[1].x, points[1].y);
      cxt.closePath();
      cxt.stroke();
    } else {
      var _x = Math.abs(points[0].x - points[1].x);
      var _y = Math.abs(points[0].y - points[1].y);
      var z = Math.sqrt(Math.pow(_x, 2) + Math.pow(_y, 2));
      var startX = void 0;
      var startY = void 0;
      var endX = void 0;
      var endY = void 0;
      var distance = 80;

      console.log('points ===>', points);
      if (points[0].x > points[1].x) {
        startX = Math.round(points[1].x - distance * _x / z);
        startY = Math.round(points[1].y + distance * _y / z);
        endX = Math.round(points[0].x + distance * _x / z);
        endY = Math.round(points[0].y - distance * _y / z);
      } else {
        startX = Math.round(points[0].x - distance * _x / z);
        startY = Math.round(points[0].y - distance * _y / z);
        endX = Math.round(points[1].x + distance * _x / z);
        endY = Math.round(points[1].y + distance * _y / z);
      }

      cxt.strokeStyle = '#0ef8cd';
      cxt.beginPath();
      cxt.moveTo(startX, startY);
      cxt.lineTo(endX, endY);
      cxt.closePath();
      cxt.stroke();
    }

    cxt.restore();
  }), defineProperty_default()(Posture_ipad__extends2, 'drawRectAndAngle', function drawRectAndAngle(option) {
    var cxt = option.cxt;
    var angle = option.angle;
    var point = option.point;

    cxt.save();
    if (option.isSecond) {
      cxt.translate(0, 43);
    }
    cxt.save();
    cxt.fillStyle = 'rgba(100, 100, 98, 0.5)';
    cxt.beginPath();
    cxt.moveTo(point.x + 13, point.y + 3);
    cxt.lineTo(point.x + 99, point.y + 3);
    cxt.quadraticCurveTo(point.x + 109, point.y + 3, point.x + 109, point.y + 13);
    cxt.lineTo(point.x + 109, point.y + 33);
    cxt.quadraticCurveTo(point.x + 109, point.y + 43, point.x + 99, point.y + 43);
    cxt.lineTo(point.x + 13, point.y + 43);
    cxt.quadraticCurveTo(point.x + 3, point.y + 43, point.x + 3, point.y + 33);
    cxt.lineTo(point.x + 3, point.y + 13);
    cxt.quadraticCurveTo(point.x + 3, point.y + 3, point.x + 13, point.y + 3);
    cxt.closePath();
    cxt.fill();
    cxt.restore();

    cxt.save();
    cxt.font = '34px Arial';
    cxt.fillStyle = '#0cfcca';
    cxt.textAlign = 'center';
    if (option.isTrunk) {
      cxt.fillText(angle + '%', point.x + 56, point.y + 38);
    } else {
      cxt.fillText(angle + '\xB0', point.x + 56, point.y + 38);
    }
    cxt.restore();
    cxt.restore();
  }), defineProperty_default()(Posture_ipad__extends2, 'drawLineAndAngle', function drawLineAndAngle(option) {
    var canvas = option.el;
    var width = canvas.width;
    var points = option.points;
    var min = option.min - 100;
    var max = option.max + 100;
    var cxt = canvas.getContext('2d');

    for (var i = 0; i < points.length; i++) {
      if (points[i].x == 0 && points[i].y == 0) {
        return;
      }
    }

    console.log('======== point', points);
    if (points.length == 1) {
      this.drawRectAndAngle({
        cxt: cxt,
        angle: (option.angle * 100).toFixed(1),
        point: {
          x: width - 120,
          y: points[0].y
        },
        isSecond: false,
        isTrunk: true
      });
    } else {
      var _x = Math.abs(points[0].x - points[1].x);
      var _y = Math.abs(points[0].y - points[1].y);
      var startPoint = {};
      var endPoint = {};
      var offsetYL = Number(((points[0].x - min) * _y / _x).toFixed(0));
      var offsetYR = Number(((max - points[1].x) * _y / _x).toFixed(0));

      if (points[0].y < points[1].y) {
        startPoint.x = min;
        startPoint.y = points[0].y - offsetYL;
        endPoint.x = max;
        endPoint.y = points[1].y + offsetYR;
      } else {
        startPoint.x = min;
        startPoint.y = points[0].y + offsetYL;
        endPoint.x = max;
        endPoint.y = points[1].y - offsetYR;
      }

      cxt.save();
      cxt.strokeStyle = '#14bc9a';
      cxt.beginPath();
      cxt.moveTo(startPoint.x, startPoint.y);
      cxt.lineTo(endPoint.x, endPoint.y);
      cxt.closePath();
      cxt.stroke();
      cxt.restore();

      this.drawRectAndAngle({
        cxt: cxt,
        angle: Number(option.angle.toFixed(1)),
        point: {
          x: width - 120,
          y: points[1].y
        },
        isSecond: false
      });
      console.log('secondAngle =>', option.secondAngle);
      if (!lodash_default.a.isUndefined(option.secondAngle)) {
        this.drawRectAndAngle({
          cxt: cxt,
          angle: Number(option.secondAngle.toFixed(1)),
          point: {
            x: width - 120,
            y: points[1].y
          },
          isSecond: true
        });
      }
    }
  }), Posture_ipad__extends2), Object(vuex_esm["d" /* mapState */])({
    initReportData: function initReportData(state) {
      var reportData = state.vux.reportData;
      var _this = this;
      if (lodash_default.a.isNull(reportData)) {
        var uuid = '';
        var type = '';

        var urlquery = url_default.a.parse(window.location.href).query;
        var query = urlquery.split('&');
        for (var every = 0; every < query.length; every++) {
          if (query[every].indexOf('uuid=') != -1) {
            uuid = query[every].replace('uuid=', '');
          }
          if (query[every].indexOf('type=') != -1) {
            type = query[every].replace('type=', '');
          }
        }
        var language = this.$i18n.locale;
        this.get({
          url: 'v1/posture/reports/' + uuid,
          params: {
            type: type,
            language: language
          },
          success: function success(result) {
            _this.updateReportData({
              reportData: result
            });
            _this.getReportData();
            console.log('result=>', result);
          },
          error: function error(data) {
            _this.loading = false;
            _this.valid = false;
          }
        });
      } else {
        _this.getReportData();
      }
    },
    getReportData: function getReportData(state) {
      this.loading = false;
      var reportData = state.vux.reportData;

      var customer = reportData.customer;
      var header = reportData.header;
      var user = reportData.user;
      var coverInfo = {};
      if (lodash_default.a.isNull(header)) {
        coverInfo.date = '--';
        coverInfo.time = '--';
      } else {
        coverInfo.date = moment_default()(header.creationTime).format('YYYY-MM-DD');
        coverInfo.time = moment_default()(header.creationTime).format('hh:mm');
      }

      if (lodash_default.a.isNull(user)) {
        coverInfo.userName = '--';
      } else {
        coverInfo.userName = user.name;
      }

      if (lodash_default.a.isNull(customer)) {
        coverInfo.customerName = '--';
      } else {
        coverInfo.customerName = customer.name;
      }

      if (lodash_default.a.isNull(header)) {
        coverInfo.logo = '';
      } else {
        coverInfo.logo = header.logo;
      }

      this.coverInfo = coverInfo;

      this.conclusion = reportData.conclusion;
      var conclusion = this.conclusion;
      if (!conclusion.face.valid || !conclusion.side.valid) {
        this.valid = false;
      } else {
        this.risks = {
          face: conclusion.face.risks,
          side: conclusion.side.risks
        };
        this.initRisksData();
        this.$nextTick(function () {
          var riskBodys = document.getElementsByClassName('risk-body');
          for (var i = 0; i < riskBodys.length; i++) {
            this.setSymptomCanvas({
              el: riskBodys[i],
              width: Number(riskBodys[i].parentNode.offsetWidth),
              height: Number(riskBodys[i].parentNode.offsetHeight)
            });
          }
          var riskBars = document.getElementsByClassName('risk-bar');
          for (var _i22 = 0; _i22 < riskBars.length; _i22++) {
            canvas_default.a.initRiskLevel({
              el: riskBars[_i22],
              width: Number(riskBars[_i22].parentNode.offsetWidth),
              height: Number(riskBars[_i22].parentNode.offsetHeight),
              color: {
                normal: '#00d963',
                mild: '#ffbf00',
                severe: '#ff4d4d'
              },
              level: this.level
            });
          }
        });
      }

      var points = {
        face: conclusion.face.points,
        side: assign_default()(conclusion.side.points, { side: conclusion.side.side })
      };
      this.points = points;

      console.log('all points =>', points);

      var photos = {
        face: reportData.face,
        side: reportData.side
      };
      this.photos = photos;

      this.initRiskPoints();
    }
  }), {
    GetQueryString: function GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);return null;
    }
  }, Object(vuex_esm["b" /* mapActions */])(['get']), Object(vuex_esm["c" /* mapMutations */])(['updateReportData'])),
  created: function created() {
    this.initReportData();
    var _this = this;

    for (var i = 0; i < components_Posture_ipad_bullets.length; i++) {

      components_Posture_ipad_bullets[i].text = this.bullets[i].text;
    }
    var symptoms = this.symptoms;
    _this.symptoms = assign_default()({}, _this.$t('symptoms'));
    console.log(this.GetQueryString("muscle") == 'hide', 'haha');
    if (this.GetQueryString("muscle") == 'hide') {
      this.MuscleShow = false;
    } else {
      this.MuscleShow = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b4fd451","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_ipad.vue
var Posture_ipad_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "100%" } }, [
    _vm.loading
      ? _c("div", [_c("loading", { attrs: { show: _vm.loading } })], 1)
      : _c("div", { staticStyle: { position: "relative", height: "100%" } }, [
          !_vm.valid
            ? _c("div", {}, [
                _c(
                  "div",
                  {
                    staticClass: "font-40",
                    staticStyle: {
                      position: "fixed",
                      top: "50%",
                      left: "50%",
                      color: "#000",
                      transform: "translate(-50%, -50%)"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("InvalidData")))]
                )
              ])
            : _c(
                "div",
                { staticStyle: { height: "100%" } },
                [
                  _c(
                    "swiper",
                    {
                      ref: "postureSwiper",
                      attrs: { options: _vm.swiperOption }
                    },
                    [
                      _c(
                        "swiper-slide",
                        { staticClass: "cover" },
                        [
                          _c("posture_home", {
                            attrs: { coverInfo: _vm.coverInfo },
                            on: {
                              slideIn: function($event) {
                                _vm.slideIn(1)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("swiper-slide", [
                        _c(
                          "div",
                          {
                            staticClass: "container-box",
                            staticStyle: {
                              padding: ".6rem",
                              background: "#e2edff"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content-row content-row-around content-align-center posture-view-box",
                                staticStyle: { background: "#fff" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "content-row content-row-column content-row-between",
                                    staticStyle: { width: "auto" }
                                  },
                                  [
                                    _c("Posture_front", {
                                      attrs: {
                                        points: _vm.points,
                                        photos: _vm.photos,
                                        severeRisks: _vm.severeRisks,
                                        mildRisks: _vm.mildRisks,
                                        normalRisks: _vm.normalRisks
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "content-row content-row-center content-align-center"
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "face-icon view-icon"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "content-row content-row-column content-align-center",
                                            staticStyle: {
                                              width: "auto",
                                              color: "#47a8cd"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-26",
                                                staticStyle: {
                                                  "line-height": "1.5rem"
                                                }
                                              },
                                              [_vm._v(_vm._s(_vm.$t("front")))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-14",
                                                staticStyle: {
                                                  color: "#d8ebf5"
                                                }
                                              },
                                              [_vm._v("Orthographic view")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "content-row content-row-column content-row-between",
                                    staticStyle: { width: "auto" }
                                  },
                                  [
                                    _c("Posture_flank", {
                                      attrs: {
                                        points: _vm.points,
                                        photos: _vm.photos,
                                        severeRisks: _vm.severeRisks,
                                        mildRisks: _vm.mildRisks,
                                        normalRisks: _vm.normalRisks
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "content-row content-row-center content-align-center"
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "side-icon view-icon"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "content-row content-row-column content-align-center",
                                            staticStyle: {
                                              width: "auto",
                                              color: "#47a8cd"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-26",
                                                staticStyle: {
                                                  "line-height": "1.5rem"
                                                }
                                              },
                                              [_vm._v(_vm._s(_vm.$t("side")))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-14",
                                                staticStyle: {
                                                  color: "#d8ebf5"
                                                }
                                              },
                                              [_vm._v("Side view")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "swiper-slide",
                        [
                          _c("Posture_sympipad", {
                            attrs: {
                              severeRisks: _vm.severeRisks,
                              mildRisks: _vm.mildRisks,
                              normalRisks: _vm.normalRisks
                            },
                            on: { setModalInfo: _vm.setModalInfo }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.MuscleShow == true
                        ? _c("Posture_report", {
                            attrs: { updateSwiper: _vm.updateSwiper },
                            on: {
                              slideIn: _vm.slideIn,
                              updateSwiper: _vm.updateSwiperIndex
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "swiper-pagination posture-swiper-pagination content-row content-row-center",
                        attrs: { slot: "pagination" },
                        slot: "pagination"
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.modalInfo
                    ? _c(
                        "div",
                        {
                          staticClass: "posture-modal",
                          staticStyle: { "background-color": "#c5c5c6" }
                        },
                        [
                          _c(
                            "b-modal",
                            {
                              ref: "riskModalRef",
                              attrs: {
                                size: "lg",
                                title: "Large Modal",
                                "hide-footer": "",
                                "hide-header": ""
                              },
                              on: { shown: _vm.initRiskBar }
                            },
                            [
                              _c("Posture_modal_ipad", {
                                attrs: { modalInfo: _vm.modalInfo },
                                on: { hideModal: _vm.hideModal }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
        ])
  ])
}
var Posture_ipad_staticRenderFns = []
Posture_ipad_render._withStripped = true
var Posture_ipad_esExports = { render: Posture_ipad_render, staticRenderFns: Posture_ipad_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Posture_ipad = (Posture_ipad_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b4fd451", Posture_ipad_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Posture_ipad.vue
var Posture_ipad_disposed = false
function Posture_ipad_injectStyle (ssrContext) {
  if (Posture_ipad_disposed) return
  __webpack_require__("ilpK")
}
var Posture_ipad_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Posture_ipad___vue_template_functional__ = false
/* styles */
var Posture_ipad___vue_styles__ = Posture_ipad_injectStyle
/* scopeId */
var Posture_ipad___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Posture_ipad___vue_module_identifier__ = null
var Posture_ipad_Component = Posture_ipad_normalizeComponent(
  components_Posture_ipad,
  selectortype_template_index_0_src_components_Posture_ipad,
  Posture_ipad___vue_template_functional__,
  Posture_ipad___vue_styles__,
  Posture_ipad___vue_scopeId__,
  Posture_ipad___vue_module_identifier__
)
Posture_ipad_Component.options.__file = "src/components/Posture_ipad.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2b4fd451", Posture_ipad_Component.options)
  } else {
    hotAPI.reload("data-v-2b4fd451", Posture_ipad_Component.options)
  }
  module.hot.dispose(function (data) {
    Posture_ipad_disposed = true
  })
})()}

/* harmony default export */ var src_components_Posture_ipad = (Posture_ipad_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Face.vue















var Face_bullets = [{
  text: '体态报告预览，付费查看详情',
  bulletClassName: 'pagination-bullet font-12',
  containerClassName: '',
  iconClassName: ''
}];

/* harmony default export */ var Face = ({
  name: "face",
  directive: {},
  components: {
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    Previewer: vux_src_components_previewer,
    Loading: vux_src_components_loading
  },
  data: function data() {
    return {
      valid: true,
      loading: true,
      reportData: {},
      customer: {},
      swiperOption: {
        pagination: {
          el: '.posture-swiper-pagination',
          clickable: true,
          renderBullet: function renderBullet(index, className) {
            return '<div class="content-row content-row-column content-align-center content-row-around ' + Face_bullets[index].containerClassName + ' ' + className + '">' + ('<span class="' + Face_bullets[index].bulletClassName + '">' + Face_bullets[index].text + '</span>') + '</div>';
          }
        }
      },
      normalRisks: [],
      mildRisks: [],
      severeRisks: [],
      symptoms: {
        head: [{
          name: '头部侧倾',
          key: 'headSidesway',
          normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY,
          abnormal: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY,
          definition: '在直立过程中，头部向左或右倾斜的现象。',
          harm: {
            bone: '颈椎侧屈',
            muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
            neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
            des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
          }
        }, {
          name: '头部前倾',
          key: 'headLean',
          normal: imgSrc_default.a.risk_normal.HEAD_LEAN,
          abnormal: imgSrc_default.a.risk_abnormal.HEAD_LEAN,
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '椎弓变直或出现反弓',
            muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
            neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
            des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
          }
        }],
        shoulder: [{
          name: '高低肩',
          key: 'highLowShoulder',
          normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER,
          abnormal: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER,
          definition: '肩峰左右高度差超过2CM则为高低肩。',
          harm: {
            bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
            muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
            neurovascular: '',
            des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
          }
        }, {
          name: '圆肩',
          key: 'roundShoulder',
          normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER,
          abnormal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER,
          definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
          harm: {
            bone: '肩胛骨外展、胸廓变小',
            muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
            neurovascular: '',
            des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
          }
        }],
        trunk: [{
          name: '脊柱侧弯',
          key: 'spineSidesway',
          normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY,
          abnormal: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY,
          definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
          harm: {
            bone: '脊柱出现S型弯曲或C型弯曲',
            muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
            neurovascular: '',
            des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
          }
        }],
        pelvis: [{
          name: '骨盆侧倾',
          key: 'pelvisLean',
          normal: imgSrc_default.a.risk_normal.PELVIS_LEAN,
          abnormal: imgSrc_default.a.risk_abnormal.PELVIS_LEAN,
          definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
          harm: {
            bone: '骨盆倾斜',
            muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
            neurovascular: '',
            des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
          }
        }],
        "lower extremity": [{
          name: 'O型腿',
          key: 'legO',
          normal: imgSrc_default.a.risk_normal.LEG_O,
          abnormal: imgSrc_default.a.risk_abnormal.LEG_O,
          definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
          harm: {
            bone: 'O型腿（膝内翻）',
            muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
            neurovascular: '',
            des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
          }
        }, {
          name: 'X型腿',
          key: 'legX',
          normal: imgSrc_default.a.risk_normal.LEG_X,
          abnormal: imgSrc_default.a.risk_abnormal.LEG_X,
          definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
          harm: {
            bone: 'X型腿（膝外翻）',
            muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
            neurovascular: '',
            des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
          }
        }, {
          name: '膝过伸',
          key: 'kneeOverstretch',
          normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH,
          abnormal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH,
          definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
          harm: {
            bone: '踝关节背屈不足，使膝关节无法向前移动',
            muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
            neurovascular: '',
            des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
          }
        }, {
          name: 'XO型腿',
          key: 'legXO',
          normal: imgSrc_default.a.risk_normal.LEG_X,
          abnormal: imgSrc_default.a.risk_abnormal.LEG_X,
          definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
          harm: {
            bone: '这个是XO型腿',
            muscle: '这个是XO型腿',
            neurovascular: '',
            des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
          }
        }]
      },
      level: {
        normal: 'normal',
        mild: 'mild',
        severe: 'severe'
      },
      risks: {},
      points: null,
      photos: null,
      coverInfo: {},
      modalInfo: null
    };
  },

  computed: {
    swiper: function swiper() {
      return this.$refs.postureSwiper.swiper;
    }
  },
  methods: extends_default()({
    getLevel: function getLevel(level) {
      switch (level) {
        case this.level.normal:
          return {
            des: '低风险',
            className: 'level-normal'
          };
        case this.level.mild:
          return {
            des: '中风险',
            className: 'level-mild'
          };
        case this.level.severe:
          return {
            des: '高风险',
            className: 'level-severe'
          };
      }
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    sortHighToLow: function sortHighToLow(arr) {
      return lodash_default.a.orderBy(arr, ['value'], ['desc']);
    },
    slideIn: function slideIn() {
      this.swiper.slideTo(1);
    },
    initRisksData: function initRisksData() {
      var risks = this.risks;
      var level = this.level;
      var symptoms = this.symptoms;
      var normalRisks = [];
      var mildRisks = [];
      var severeRisks = [];

      for (var direction in risks) {
        for (var i = 0; i < risks[direction].length; i++) {
          var symptom = symptoms[risks[direction][i].position][risks[direction][i].code - 1];

          if (symptom.value) {
            var otherSymptom = assign_default()({}, symptom);
            if (!risks[direction][i].valid) {
              otherSymptom.raw = 0;
              otherSymptom.value = 0;
              otherSymptom.level = level.normal;
              otherSymptom.detail = '';
            } else {
              otherSymptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              otherSymptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              otherSymptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              otherSymptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
            }

            symptoms[risks[direction][i].position].push(otherSymptom);
          } else {
            if (!risks[direction][i].valid) {
              symptom.raw = 0;
              symptom.value = 0;
              symptom.level = level.normal;
              symptom.detail = '';
            } else {
              symptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              symptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              symptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              symptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
            }
          }
        }
      }

      for (var position in symptoms) {
        for (var _i = 0; _i < symptoms[position].length; _i++) {
          if (lodash_default.a.isUndefined(symptoms[position][_i].value)) {
            continue;
          }
          switch (symptoms[position][_i].level) {
            case level.normal:
              normalRisks.push(symptoms[position][_i]);
              break;
            case level.mild:
              mildRisks.push(symptoms[position][_i]);
              break;
            case level.severe:
              severeRisks.push(symptoms[position][_i]);
              break;
            default:
              normalRisks.push(symptoms[position][_i]);
              break;
          }
        }
      }

      this.normalRisks = this.sortHighToLow(normalRisks);
      this.mildRisks = this.sortHighToLow(mildRisks);
      this.severeRisks = this.sortHighToLow(severeRisks);
      console.log('normalRisks =>', normalRisks);
      console.log('mildRisks =>', mildRisks);
      console.log('severeRisks =>', severeRisks);
    },
    initRiskPoints: function initRiskPoints() {
      var points = this.points;
      var photos = this.photos;
      var faceCanvas = document.createElement('canvas');
      var sideCanvas = document.createElement('canvas');
      var _this = this;

      var facePointsArr = [];
      var face = points.face;
      var faceImg = new Image();

      var hipRPoint = face['hip']['right'];
      var hipLPoint = face['hip']['left'];
      var neckPoint = face['neck'];
      var hipMPoint = {
        x: 0,
        y: 0
      };
      var hipAndNeckMPoint = {
        x: 0,
        y: 0
      };
      if (hipLPoint.x == 0 && hipLPoint.y == 0 || hipRPoint.x == 0 && hipRPoint.y == 0) {} else {

        hipMPoint.x = (hipLPoint.x + hipRPoint.x) / 2;
        hipMPoint.y = (hipLPoint.y + hipRPoint.y) / 2;

        if (!(neckPoint.x == 0 && neckPoint.y == 0)) {
          hipAndNeckMPoint.x = (neckPoint.x + hipMPoint.x) / 2;
          hipAndNeckMPoint.y = (neckPoint.y + hipMPoint.y) / 2;
        }
      };

      face.hipM = hipMPoint;
      face.hipAndNeckM = hipAndNeckMPoint;

      var faceOrder = [['ear-right', 'eye-right', 'nose', 'eye-left', 'ear-left'], ['wrist-right', 'elbow-right', 'shoulder-right', 'neck', 'shoulder-left', 'elbow-left', 'wrist-left'], ['ankle-right', 'knee-right', 'hip-right', 'hipM', 'hip-left', 'knee-left', 'ankle-left'], ['neck', 'hipAndNeckM', 'hipM'], ['nose', 'neck']];

      var verticalStandard = ['shoulder-right', 'ankle-middle', 'shoulder-left'];
      var verticalPointsArr = [];

      var risks = this.normalRisks.concat(this.mildRisks, this.severeRisks);

      console.log('risks =>', risks);
      var faceSymptomWithPosition = ['headSidesway-ear', 'highLowShoulder-shoulder', 'spineSidesway', 'pelvisLean-hip', 'legO-knee', 'legX-knee', 'legXO-knee'];
      var faceHorizontalArr = [];

      for (var i = 0; i < faceSymptomWithPosition.length; i++) {
        var symptomWithPositionArr = faceSymptomWithPosition[i].split('-');
        var pointsAndAngle = {
          key: symptomWithPositionArr[0]
        };

        for (var j = 0; j < risks.length; j++) {
          if (risks[j].key == symptomWithPositionArr[0]) {
            if (!lodash_default.a.isUndefined(pointsAndAngle.raw)) {
              pointsAndAngle.secondRaw = risks[j].raw;
            } else {
              pointsAndAngle.raw = risks[j].raw;
              if (symptomWithPositionArr.length == 1) {
                pointsAndAngle.points = [face['elbow'].left];
              } else {
                pointsAndAngle.points = [face[symptomWithPositionArr[1]].right, face[symptomWithPositionArr[1]].left];
              }
            }
          }
        }

        if (lodash_default.a.isUndefined(pointsAndAngle.raw) || lodash_default.a.isUndefined(pointsAndAngle.points)) {
          continue;
        } else {
          faceHorizontalArr.push(pointsAndAngle);
        }
      }

      console.log('faceHorizontalArr =>', faceHorizontalArr);

      for (var _i2 = 0; _i2 < faceOrder.length; _i2++) {
        var pointsArr = [];
        for (var _j = 0; _j < faceOrder[_i2].length; _j++) {
          var positionArr = faceOrder[_i2][_j].split('-');
          if (positionArr.length == 1) {
            pointsArr.push(face[positionArr[0]]);
          } else {
            pointsArr.push(face[positionArr[0]][positionArr[1]]);
          }
        }
        facePointsArr.push(pointsArr);
      }

      for (var _i3 = 0; _i3 < verticalStandard.length; _i3++) {
        var _positionArr = verticalStandard[_i3].split('-');

        if (_positionArr[1] == 'middle') {
          if (face[_positionArr[0]].left.x == 0 && face[_positionArr[0]].left.y == 0 || face[_positionArr[0]].right.x == 0 && face[_positionArr[0]].right.y == 0) {
            verticalPointsArr.push({
              x: 0,
              y: 0
            });
          } else {
            verticalPointsArr.push({
              x: (face[_positionArr[0]].left.x + face[_positionArr[0]].right.x) / 2,
              y: 0
            });
          }
        } else {
          verticalPointsArr.push(face[_positionArr[0]][_positionArr[1]]);
        }
      }

      console.log('verticalPointsArr =>', verticalPointsArr);

      faceImg.src = photos.face;
      faceImg.onload = function () {

        var width = faceImg.width;
        var height = faceImg.height;
        faceCanvas.width = width;
        faceCanvas.height = height;
        faceCanvas.style.width = '100%';

        var cxt = faceCanvas.getContext('2d');
        cxt.drawImage(faceImg, 0, 0, width, height);

        for (var _i4 = 0; _i4 < facePointsArr.length; _i4++) {
          for (var _j2 = 0; _j2 < facePointsArr[_i4].length; _j2++) {
            if (_j2 == 0 || facePointsArr[_i4][_j2].x == 0 && facePointsArr[_i4][_j2].y == 0 || facePointsArr[_i4][_j2 - 1].x == 0 && facePointsArr[_i4][_j2 - 1].y == 0) {
              if (facePointsArr[_i4][_j2].x == 0 && facePointsArr[_i4][_j2].y == 0) {
                continue;
              } else {
                _this.drawPoint({
                  el: faceCanvas,
                  point: facePointsArr[_i4][_j2]
                });
                continue;
              }
            } else {
              _this.drawPoint({
                el: faceCanvas,
                point: facePointsArr[_i4][_j2]
              });
              _this.drawLine({
                el: faceCanvas,
                points: [facePointsArr[_i4][_j2], facePointsArr[_i4][_j2 - 1]]
              });
            }
          }
        }

        for (var _i5 = 0; _i5 < verticalPointsArr.length; _i5++) {
          if (verticalPointsArr[_i5].x == 0 && verticalPointsArr[_i5].y == 0) {
            continue;
          } else {
            cxt.save();
            cxt.strokeStyle = '#4db664';
            cxt.beginPath();
            cxt.moveTo(verticalPointsArr[_i5].x, 0);
            cxt.lineTo(verticalPointsArr[_i5].x, height);
            cxt.closePath();
            cxt.stroke();
            cxt.restore();

            cxt.save();
            cxt.fillStyle = '#fe610f';
            cxt.font = '30px serif';
            var window_width = document.documentElement.clientWidth;
            var window_height = window.screen.height;
            var offset_height = (window_height - 125) / (window_width / width);
            if (_i5 == 0) {
              cxt.fillText('α', verticalPointsArr[_i5].x + 5, offset_height - 5);
            } else if (_i5 == verticalPointsArr.length - 1) {
              cxt.fillText('γ', verticalPointsArr[_i5].x + 5, offset_height - 5);
            } else {
              cxt.fillText('β', verticalPointsArr[_i5].x + 5, offset_height - 5);
            }
            cxt.restore();
          }
        }

        var min = 99999;
        var max = 0;
        var indexOfKneeArr = [];
        for (var _i6 = 0; _i6 < faceHorizontalArr.length; _i6++) {
          if (faceHorizontalArr[_i6].points.length !== 1) {
            if (faceHorizontalArr[_i6].points[0].x == 0 && faceHorizontalArr[_i6].points[0].y == 0 || faceHorizontalArr[_i6].points[1].x == 0 && faceHorizontalArr[_i6].points[1].y == 0) {
              continue;
            }
            if (faceHorizontalArr[_i6].points[0].x < min) {
              min = faceHorizontalArr[_i6].points[0].x;
            }
            if (faceHorizontalArr[_i6].points[1].x > max) {
              max = faceHorizontalArr[_i6].points[1].x;
            }
          }

          if (faceHorizontalArr[_i6].key == 'legX' || faceHorizontalArr[_i6].key == 'legO' || faceHorizontalArr[_i6].key == 'legXO') {
            indexOfKneeArr.push(_i6);
          }
        }

        if (indexOfKneeArr.length == 2) {
          faceHorizontalArr[indexOfKneeArr[0]].secondRaw = faceHorizontalArr[indexOfKneeArr[1]].raw;
          faceHorizontalArr.splice(indexOfKneeArr[1], 1);
        }

        for (var _i7 = 0; _i7 < faceHorizontalArr.length; _i7++) {
          _this.drawLineAndAngle({
            el: faceCanvas,
            angle: faceHorizontalArr[_i7].raw,
            secondAngle: faceHorizontalArr[_i7].secondRaw,
            points: faceHorizontalArr[_i7].points,
            min: min,
            max: max
          });
        }

        _this.$nextTick(function () {
          document.getElementById('face').appendChild(faceCanvas);
        });
      };
    },
    drawPoint: function drawPoint(option) {
      var canvas = option.el;
      var point = option.point;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.fillStyle = '#009eff';
      cxt.beginPath();
      cxt.arc(point.x, point.y, 5, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
      cxt.save();
      cxt.fillStyle = "rgba(83, 158, 255, .3)";
      cxt.beginPath();
      cxt.arc(point.x, point.y, 10, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
    },
    drawLine: function drawLine(option) {

      if (option.points[0].x == 0 && option.points[0].y == 0 || option.points[1].x == 0 && option.points[1].y == 0) {
        return;
      }
      var canvas = option.el;
      var points = option.points;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.lineWidth = 3;
      if (!option.isSide) {
        cxt.strokeStyle = '#5f58f4';
        cxt.beginPath();
        cxt.moveTo(points[0].x, points[0].y);
        cxt.lineTo(points[1].x, points[1].y);
        cxt.closePath();
        cxt.stroke();
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var z = Math.sqrt(Math.pow(_x, 2) + Math.pow(_y, 2));
        var startX = void 0;
        var startY = void 0;
        var endX = void 0;
        var endY = void 0;
        var distance = 80;

        console.log('points ===>', points);
        if (points[0].x > points[1].x) {
          startX = Math.round(points[1].x - distance * _x / z);
          startY = Math.round(points[1].y + distance * _y / z);
          endX = Math.round(points[0].x + distance * _x / z);
          endY = Math.round(points[0].y - distance * _y / z);
        } else {
          startX = Math.round(points[0].x - distance * _x / z);
          startY = Math.round(points[0].y - distance * _y / z);
          endX = Math.round(points[1].x + distance * _x / z);
          endY = Math.round(points[1].y + distance * _y / z);
        }

        cxt.strokeStyle = '#0ef8cd';
        cxt.beginPath();
        cxt.moveTo(startX, startY);
        cxt.lineTo(endX, endY);
        cxt.closePath();
        cxt.stroke();
      }

      cxt.restore();
    },
    drawRectAndAngle: function drawRectAndAngle(option) {
      var cxt = option.cxt;
      var angle = option.angle;
      var point = option.point;

      cxt.save();
      if (option.isSecond) {
        cxt.translate(0, 43);
      }
      cxt.save();
      cxt.fillStyle = 'rgba(100, 100, 98, 0.5)';
      cxt.beginPath();
      cxt.moveTo(point.x + 13, point.y + 3);
      cxt.lineTo(point.x + 99, point.y + 3);
      cxt.quadraticCurveTo(point.x + 109, point.y + 3, point.x + 109, point.y + 13);
      cxt.lineTo(point.x + 109, point.y + 33);
      cxt.quadraticCurveTo(point.x + 109, point.y + 43, point.x + 99, point.y + 43);
      cxt.lineTo(point.x + 13, point.y + 43);
      cxt.quadraticCurveTo(point.x + 3, point.y + 43, point.x + 3, point.y + 33);
      cxt.lineTo(point.x + 3, point.y + 13);
      cxt.quadraticCurveTo(point.x + 3, point.y + 3, point.x + 13, point.y + 3);
      cxt.closePath();
      cxt.fill();
      cxt.restore();

      cxt.save();
      cxt.font = '34px Arial';
      cxt.fillStyle = '#0cfcca';
      cxt.textAlign = 'center';
      if (option.isTrunk) {
        cxt.fillText(angle + '%', point.x + 56, point.y + 38);
      } else {
        cxt.fillText(angle + '\xB0', point.x + 56, point.y + 38);
      }
      cxt.restore();
      cxt.restore();
    },
    drawLineAndAngle: function drawLineAndAngle(option) {
      var canvas = option.el;
      var width = canvas.width;
      var points = option.points;
      var min = option.min - 100;
      var max = option.max + 100;
      var cxt = canvas.getContext('2d');

      for (var i = 0; i < points.length; i++) {
        if (points[i].x == 0 && points[i].y == 0) {
          return;
        }
      }

      console.log('======== point', points);
      if (points.length == 1) {
        this.drawRectAndAngle({
          cxt: cxt,
          angle: (option.angle * 100).toFixed(1),
          point: {
            x: width - 120,
            y: points[0].y
          },
          isSecond: false,
          isTrunk: true
        });
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var startPoint = {};
        var endPoint = {};
        var offsetYL = Number(((points[0].x - min) * _y / _x).toFixed(0));
        var offsetYR = Number(((max - points[1].x) * _y / _x).toFixed(0));

        if (points[0].y < points[1].y) {
          startPoint.x = min;
          startPoint.y = points[0].y - offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y + offsetYR;
        } else {
          startPoint.x = min;
          startPoint.y = points[0].y + offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y - offsetYR;
        }

        cxt.save();
        cxt.strokeStyle = '#14bc9a';
        cxt.beginPath();
        cxt.moveTo(startPoint.x, startPoint.y);
        cxt.lineTo(endPoint.x, endPoint.y);
        cxt.closePath();
        cxt.stroke();
        cxt.restore();

        this.drawRectAndAngle({
          cxt: cxt,
          angle: Number(option.angle.toFixed(1)),
          point: {
            x: width - 120,
            y: points[1].y
          },
          isSecond: false
        });
        console.log('secondAngle =>', option.secondAngle);
        if (!lodash_default.a.isUndefined(option.secondAngle)) {
          this.drawRectAndAngle({
            cxt: cxt,
            angle: Number(option.secondAngle.toFixed(1)),
            point: {
              x: width - 120,
              y: points[1].y
            },
            isSecond: true
          });
        }
      }
    }
  }, Object(vuex_esm["d" /* mapState */])({
    initReportData: function initReportData(state) {
      var reportData = state.vux.reportData;
      var _this = this;
      if (lodash_default.a.isNull(reportData)) {
        var uuid = '';
        var type = '';

        var urlquery = url_default.a.parse(window.location.href).query;
        var query = urlquery.split('&');
        for (var every = 0; every < query.length; every++) {
          if (query[every].indexOf('uuid=') != -1) {
            uuid = query[every].replace('uuid=', '');
          }
          if (query[every].indexOf('type=') != -1) {
            type = query[every].replace('type=', '');
          }
        }

        this.get({
          url: 'v1/posture/reports/' + uuid,
          params: {
            type: type
          },
          success: function success(result) {
            _this.updateReportData({
              reportData: result
            });
            _this.getReportData();
            console.log('result=>', result);
          },
          error: function error(data) {
            _this.loading = false;
            _this.valid = false;
          }
        });
      } else {
        _this.getReportData();
      }
    },
    getReportData: function getReportData(state) {
      this.loading = false;
      var reportData = state.vux.reportData;

      this.conclusion = reportData.conclusion;
      var conclusion = this.conclusion;
      if (!conclusion.face.valid || !conclusion.side.valid) {
        this.valid = false;
      } else {
        this.risks = {
          face: conclusion.face.risks,
          side: conclusion.side.risks
        };
        this.initRisksData();
      }

      var points = {
        face: conclusion.face.points,
        side: assign_default()(conclusion.side.points, { side: conclusion.side.side })
      };
      this.points = points;

      console.log('all points =>', points);

      var photos = {
        face: reportData.face,
        side: reportData.side
      };
      this.photos = photos;

      this.initRiskPoints();
    }
  }), Object(vuex_esm["b" /* mapActions */])(['get']), Object(vuex_esm["c" /* mapMutations */])(['updateReportData'])),
  created: function created() {
    this.initReportData();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Face.vue















var components_Face_bullets = [{
  text: '体态报告预览，付费查看详情',
  bulletClassName: 'pagination-bullet font-12',
  containerClassName: '',
  iconClassName: ''
}];

/* harmony default export */ var components_Face = ({
  name: "face",
  directive: {},
  components: {
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    Previewer: vux_src_components_previewer,
    Loading: vux_src_components_loading
  },
  data: function data() {
    return {
      valid: true,
      loading: true,
      reportData: {},
      customer: {},
      swiperOption: {
        pagination: {
          el: '.posture-swiper-pagination',
          clickable: true,
          renderBullet: function renderBullet(index, className) {
            return '<div class="content-row content-row-column content-align-center content-row-around ' + components_Face_bullets[index].containerClassName + ' ' + className + '">' + ('<span class="' + components_Face_bullets[index].bulletClassName + '">' + components_Face_bullets[index].text + '</span>') + '</div>';
          }
        }
      },
      normalRisks: [],
      mildRisks: [],
      severeRisks: [],
      symptoms: {
        head: [{
          name: '头部侧倾',
          key: 'headSidesway',
          normal: imgSrc_default.a.risk_normal.HEAD_SIDESWAY,
          abnormal: imgSrc_default.a.risk_abnormal.HEAD_SIDESWAY,
          definition: '在直立过程中，头部向左或右倾斜的现象。',
          harm: {
            bone: '颈椎侧屈',
            muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长',
            neurovascular: '单侧椎动脉受压迫、单侧颈神经受压迫',
            des: '长期使脖子侧歪容易使颈后韧带以及肌肉的慢性劳损，导致椎骨增生，颈椎病。'
          }
        }, {
          name: '头部前倾',
          key: 'headLean',
          normal: imgSrc_default.a.risk_normal.HEAD_LEAN,
          abnormal: imgSrc_default.a.risk_abnormal.HEAD_LEAN,
          definition: '头部过度向前伸的现象。',
          harm: {
            bone: '椎弓变直或出现反弓',
            muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张',
            neurovascular: '胸锁乳突肌--副神经可诱发面部疼痛，椎弓变直使椎间孔间隙变小压迫颈部神经和椎动脉，斜方肌过度缩短可能压迫锁骨下动脉导致手臂供血不足',
            des: '头部每前倾出2.5厘米，颈部多增加4千克重量负担，向前伸出6-9厘米，颈部的负荷已经超过了20升水的重量，头部前倾还会引发头晕、摇晃、眼睛里面疼痛、恶心、食欲不振、长期的颈椎病、肩周炎和偏头痛、思考能力下降、腹压降低、腰椎不稳、压迫神经，紧张性头痛、肺活量降低，影响心血管健康、血液循环变慢，影响大脑血供、影响形象美观。'
          }
        }],
        shoulder: [{
          name: '高低肩',
          key: 'highLowShoulder',
          normal: imgSrc_default.a.risk_normal.HIGH_LOW_SHOULDER,
          abnormal: imgSrc_default.a.risk_abnormal.HIGH_LOW_SHOULDER,
          definition: '肩峰左右高度差超过2CM则为高低肩。',
          harm: {
            bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
            muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：',
            neurovascular: '',
            des: '肩膀附近的肌肉过紧，或者由于脊柱侧弯导致的脊柱变形，因此容易产生颈肩部位的慢性疼痛、慢性头痛、高低肩使姿势不正确，使得颈椎所承受的负荷量过重，最后可能导致颈椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部组织肌力不平衡，导致腰痛。同时，骨盆移位也会使腿长发生变化。'
          }
        }, {
          name: '圆肩',
          key: 'roundShoulder',
          normal: imgSrc_default.a.risk_normal.ROUND_SHOULDER,
          abnormal: imgSrc_default.a.risk_abnormal.ROUND_SHOULDER,
          definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
          harm: {
            bone: '肩胛骨外展、胸廓变小',
            muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长',
            neurovascular: '',
            des: '圆肩会影响个人形象、气质欠佳、紧张的肌肉会造成肩颈酸痛，最严重可压迫颈椎神经，引起头痛和手臂麻木。颈部曲度减小，僵硬，引起对大脑供血不足，使人整天灰灰沉沉，打不起精神。圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉的压迫，使心脏工作负担加重。'
          }
        }],
        trunk: [{
          name: '脊柱侧弯',
          key: 'spineSidesway',
          normal: imgSrc_default.a.risk_normal.SPINE_SIDESWAY,
          abnormal: imgSrc_default.a.risk_abnormal.SPINE_SIDESWAY,
          definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
          harm: {
            bone: '脊柱出现S型弯曲或C型弯曲',
            muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛',
            neurovascular: '',
            des: '脊柱侧弯会发作肩背不平，腿脚不等长，驼背鸡胸，身材矮小，活动范围减小。胸廓变形、腹腔减小等造成腰背痛痛、神经受损、消化不良、心跳反常、肢体感觉障碍等症状。消化不良，食欲不振、肺-血液气体交换功能障碍，高低肩，肩颈部的不适，、消化不良，食欲不振，心搏加速，心慌意乱，气短，胸腹胀满，四肢肌肉无力，四肢反应敏感度不同，体力较弱等.'
          }
        }],
        pelvis: [{
          name: '骨盆侧倾',
          key: 'pelvisLean',
          normal: imgSrc_default.a.risk_normal.PELVIS_LEAN,
          abnormal: imgSrc_default.a.risk_abnormal.PELVIS_LEAN,
          definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
          harm: {
            bone: '骨盆倾斜',
            muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力',
            neurovascular: '',
            des: '骨盆侧倾可能会引发腰腿疼痛、坐骨神经痛、腰椎间盘突出、臀肌或腿部肌肉萎缩、脊椎侧弯、胸部疼痛、高低肩，长短腿，双腿并拢的时候可能膝盖还不一个高度，痛经，肩颈疼痛。'
          }
        }],
        "lower extremity": [{
          name: 'O型腿',
          key: 'legO',
          normal: imgSrc_default.a.risk_normal.LEG_O,
          abnormal: imgSrc_default.a.risk_abnormal.LEG_O,
          definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
          harm: {
            bone: 'O型腿（膝内翻）',
            muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大',
            neurovascular: '',
            des: '下肢臃肿之感、外侧肌肉发达，而内侧肌肉菲薄、膝关节内侧软骨面磨损，胫骨平台塌陷，继发骨性关节炎，O型腿也会影响体型外观。'
          }
        }, {
          name: 'X型腿',
          key: 'legX',
          normal: imgSrc_default.a.risk_normal.LEG_X,
          abnormal: imgSrc_default.a.risk_abnormal.LEG_X,
          definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
          harm: {
            bone: 'X型腿（膝外翻）',
            muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张',
            neurovascular: '',
            des: '影响美观，给人的心理造成一定的自卑感、膝内翻使下肢的力线发生改变，膝关节内侧间隙承受大于正常负荷的压力，长此以往，引起膝关节内侧间隙关节退变，最终可能发展为膝关节骨性关节炎引起疼痛，引起膝关节外侧间隙关节退变，严重者需要进行人工关节置换手术。'
          }
        }, {
          name: '膝过伸',
          key: 'kneeOverstretch',
          normal: imgSrc_default.a.risk_normal.KNEE_OVERSTRETCH,
          abnormal: imgSrc_default.a.risk_abnormal.KNEE_OVERSTRETCH,
          definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
          harm: {
            bone: '踝关节背屈不足，使膝关节无法向前移动',
            muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛',
            neurovascular: '',
            des: '膝关节伸展受限、膝关节控制能力差、下肢深感觉障碍、异常的运动模式。'
          }
        }, {
          name: 'XO型腿',
          key: 'legXO',
          normal: imgSrc_default.a.risk_normal.LEG_X,
          abnormal: imgSrc_default.a.risk_abnormal.LEG_X,
          definition: '股骨、胫骨均呈内旋位，双侧小腿不能并拢。',
          harm: {
            bone: '这个是XO型腿',
            muscle: '这个是XO型腿',
            neurovascular: '',
            des: 'XO型腿，股骨、胫骨均呈内旋位，双侧小腿间存在较大间隙，不能并拢，影响美观。由于股骨与胫骨位置相对不平衡，压力更易集中在膝关节外侧，更易发生膝关节疼痛甚至膝关节炎。'
          }
        }]
      },
      level: {
        normal: 'normal',
        mild: 'mild',
        severe: 'severe'
      },
      risks: {},
      points: null,
      photos: null,
      coverInfo: {},
      modalInfo: null
    };
  },

  computed: {
    swiper: function swiper() {
      return this.$refs.postureSwiper.swiper;
    }
  },
  methods: extends_default()({
    getLevel: function getLevel(level) {
      switch (level) {
        case this.level.normal:
          return {
            des: '低风险',
            className: 'level-normal'
          };
        case this.level.mild:
          return {
            des: '中风险',
            className: 'level-mild'
          };
        case this.level.severe:
          return {
            des: '高风险',
            className: 'level-severe'
          };
      }
    },
    checkIfAbnormal: function checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    sortHighToLow: function sortHighToLow(arr) {
      return lodash_default.a.orderBy(arr, ['value'], ['desc']);
    },
    slideIn: function slideIn() {
      this.swiper.slideTo(1);
    },
    initRisksData: function initRisksData() {
      var risks = this.risks;
      var level = this.level;
      var symptoms = this.symptoms;
      var normalRisks = [];
      var mildRisks = [];
      var severeRisks = [];

      for (var direction in risks) {
        for (var i = 0; i < risks[direction].length; i++) {
          var symptom = symptoms[risks[direction][i].position][risks[direction][i].code - 1];

          if (symptom.value) {
            var otherSymptom = assign_default()({}, symptom);
            if (!risks[direction][i].valid) {
              otherSymptom.raw = 0;
              otherSymptom.value = 0;
              otherSymptom.level = level.normal;
              otherSymptom.detail = '';
            } else {
              otherSymptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              otherSymptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              otherSymptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              otherSymptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
            }

            symptoms[risks[direction][i].position].push(otherSymptom);
          } else {
            if (!risks[direction][i].valid) {
              symptom.raw = 0;
              symptom.value = 0;
              symptom.level = level.normal;
              symptom.detail = '';
            } else {
              symptom.raw = risks[direction][i].raw ? risks[direction][i].raw : 0;
              symptom.value = risks[direction][i].value ? risks[direction][i].value : 0;
              symptom.level = risks[direction][i].level ? risks[direction][i].level : level.normal;
              symptom.detail = risks[direction][i].detail ? risks[direction][i].detail : '';
            }
          }
        }
      }

      for (var position in symptoms) {
        for (var _i = 0; _i < symptoms[position].length; _i++) {
          if (lodash_default.a.isUndefined(symptoms[position][_i].value)) {
            continue;
          }
          switch (symptoms[position][_i].level) {
            case level.normal:
              normalRisks.push(symptoms[position][_i]);
              break;
            case level.mild:
              mildRisks.push(symptoms[position][_i]);
              break;
            case level.severe:
              severeRisks.push(symptoms[position][_i]);
              break;
            default:
              normalRisks.push(symptoms[position][_i]);
              break;
          }
        }
      }

      this.normalRisks = this.sortHighToLow(normalRisks);
      this.mildRisks = this.sortHighToLow(mildRisks);
      this.severeRisks = this.sortHighToLow(severeRisks);
      console.log('normalRisks =>', normalRisks);
      console.log('mildRisks =>', mildRisks);
      console.log('severeRisks =>', severeRisks);
    },
    initRiskPoints: function initRiskPoints() {
      var points = this.points;
      var photos = this.photos;
      var faceCanvas = document.createElement('canvas');
      var sideCanvas = document.createElement('canvas');
      var _this = this;

      var facePointsArr = [];
      var face = points.face;
      var faceImg = new Image();

      var hipRPoint = face['hip']['right'];
      var hipLPoint = face['hip']['left'];
      var neckPoint = face['neck'];
      var hipMPoint = {
        x: 0,
        y: 0
      };
      var hipAndNeckMPoint = {
        x: 0,
        y: 0
      };
      if (hipLPoint.x == 0 && hipLPoint.y == 0 || hipRPoint.x == 0 && hipRPoint.y == 0) {} else {

        hipMPoint.x = (hipLPoint.x + hipRPoint.x) / 2;
        hipMPoint.y = (hipLPoint.y + hipRPoint.y) / 2;

        if (!(neckPoint.x == 0 && neckPoint.y == 0)) {
          hipAndNeckMPoint.x = (neckPoint.x + hipMPoint.x) / 2;
          hipAndNeckMPoint.y = (neckPoint.y + hipMPoint.y) / 2;
        }
      };

      face.hipM = hipMPoint;
      face.hipAndNeckM = hipAndNeckMPoint;

      var faceOrder = [['ear-right', 'eye-right', 'nose', 'eye-left', 'ear-left'], ['wrist-right', 'elbow-right', 'shoulder-right', 'neck', 'shoulder-left', 'elbow-left', 'wrist-left'], ['ankle-right', 'knee-right', 'hip-right', 'hipM', 'hip-left', 'knee-left', 'ankle-left'], ['neck', 'hipAndNeckM', 'hipM'], ['nose', 'neck']];

      var verticalStandard = ['shoulder-right', 'ankle-middle', 'shoulder-left'];
      var verticalPointsArr = [];

      var risks = this.normalRisks.concat(this.mildRisks, this.severeRisks);

      console.log('risks =>', risks);
      var faceSymptomWithPosition = ['headSidesway-ear', 'highLowShoulder-shoulder', 'spineSidesway', 'pelvisLean-hip', 'legO-knee', 'legX-knee', 'legXO-knee'];
      var faceHorizontalArr = [];

      for (var i = 0; i < faceSymptomWithPosition.length; i++) {
        var symptomWithPositionArr = faceSymptomWithPosition[i].split('-');
        var pointsAndAngle = {
          key: symptomWithPositionArr[0]
        };

        for (var j = 0; j < risks.length; j++) {
          if (risks[j].key == symptomWithPositionArr[0]) {
            if (!lodash_default.a.isUndefined(pointsAndAngle.raw)) {
              pointsAndAngle.secondRaw = risks[j].raw;
            } else {
              pointsAndAngle.raw = risks[j].raw;
              if (symptomWithPositionArr.length == 1) {
                pointsAndAngle.points = [face['elbow'].left];
              } else {
                pointsAndAngle.points = [face[symptomWithPositionArr[1]].right, face[symptomWithPositionArr[1]].left];
              }
            }
          }
        }

        if (lodash_default.a.isUndefined(pointsAndAngle.raw) || lodash_default.a.isUndefined(pointsAndAngle.points)) {
          continue;
        } else {
          faceHorizontalArr.push(pointsAndAngle);
        }
      }

      console.log('faceHorizontalArr =>', faceHorizontalArr);

      for (var _i2 = 0; _i2 < faceOrder.length; _i2++) {
        var pointsArr = [];
        for (var _j = 0; _j < faceOrder[_i2].length; _j++) {
          var positionArr = faceOrder[_i2][_j].split('-');
          if (positionArr.length == 1) {
            pointsArr.push(face[positionArr[0]]);
          } else {
            pointsArr.push(face[positionArr[0]][positionArr[1]]);
          }
        }
        facePointsArr.push(pointsArr);
      }

      for (var _i3 = 0; _i3 < verticalStandard.length; _i3++) {
        var _positionArr = verticalStandard[_i3].split('-');

        if (_positionArr[1] == 'middle') {
          if (face[_positionArr[0]].left.x == 0 && face[_positionArr[0]].left.y == 0 || face[_positionArr[0]].right.x == 0 && face[_positionArr[0]].right.y == 0) {
            verticalPointsArr.push({
              x: 0,
              y: 0
            });
          } else {
            verticalPointsArr.push({
              x: (face[_positionArr[0]].left.x + face[_positionArr[0]].right.x) / 2,
              y: 0
            });
          }
        } else {
          verticalPointsArr.push(face[_positionArr[0]][_positionArr[1]]);
        }
      }

      console.log('verticalPointsArr =>', verticalPointsArr);

      faceImg.src = photos.face;
      faceImg.onload = function () {

        var width = faceImg.width;
        var height = faceImg.height;
        faceCanvas.width = width;
        faceCanvas.height = height;
        faceCanvas.style.width = '100%';

        var cxt = faceCanvas.getContext('2d');
        cxt.drawImage(faceImg, 0, 0, width, height);

        for (var _i4 = 0; _i4 < facePointsArr.length; _i4++) {
          for (var _j2 = 0; _j2 < facePointsArr[_i4].length; _j2++) {
            if (_j2 == 0 || facePointsArr[_i4][_j2].x == 0 && facePointsArr[_i4][_j2].y == 0 || facePointsArr[_i4][_j2 - 1].x == 0 && facePointsArr[_i4][_j2 - 1].y == 0) {
              if (facePointsArr[_i4][_j2].x == 0 && facePointsArr[_i4][_j2].y == 0) {
                continue;
              } else {
                _this.drawPoint({
                  el: faceCanvas,
                  point: facePointsArr[_i4][_j2]
                });
                continue;
              }
            } else {
              _this.drawPoint({
                el: faceCanvas,
                point: facePointsArr[_i4][_j2]
              });
              _this.drawLine({
                el: faceCanvas,
                points: [facePointsArr[_i4][_j2], facePointsArr[_i4][_j2 - 1]]
              });
            }
          }
        }

        for (var _i5 = 0; _i5 < verticalPointsArr.length; _i5++) {
          if (verticalPointsArr[_i5].x == 0 && verticalPointsArr[_i5].y == 0) {
            continue;
          } else {
            cxt.save();
            cxt.strokeStyle = '#4db664';
            cxt.beginPath();
            cxt.moveTo(verticalPointsArr[_i5].x, 0);
            cxt.lineTo(verticalPointsArr[_i5].x, height);
            cxt.closePath();
            cxt.stroke();
            cxt.restore();

            cxt.save();
            cxt.fillStyle = '#fe610f';
            cxt.font = '30px serif';
            var window_width = document.documentElement.clientWidth;
            var window_height = window.screen.height;
            var offset_height = (window_height - 125) / (window_width / width);
            if (_i5 == 0) {
              cxt.fillText('α', verticalPointsArr[_i5].x + 5, offset_height - 5);
            } else if (_i5 == verticalPointsArr.length - 1) {
              cxt.fillText('γ', verticalPointsArr[_i5].x + 5, offset_height - 5);
            } else {
              cxt.fillText('β', verticalPointsArr[_i5].x + 5, offset_height - 5);
            }
            cxt.restore();
          }
        }

        var min = 99999;
        var max = 0;
        var indexOfKneeArr = [];
        for (var _i6 = 0; _i6 < faceHorizontalArr.length; _i6++) {
          if (faceHorizontalArr[_i6].points.length !== 1) {
            if (faceHorizontalArr[_i6].points[0].x == 0 && faceHorizontalArr[_i6].points[0].y == 0 || faceHorizontalArr[_i6].points[1].x == 0 && faceHorizontalArr[_i6].points[1].y == 0) {
              continue;
            }
            if (faceHorizontalArr[_i6].points[0].x < min) {
              min = faceHorizontalArr[_i6].points[0].x;
            }
            if (faceHorizontalArr[_i6].points[1].x > max) {
              max = faceHorizontalArr[_i6].points[1].x;
            }
          }

          if (faceHorizontalArr[_i6].key == 'legX' || faceHorizontalArr[_i6].key == 'legO' || faceHorizontalArr[_i6].key == 'legXO') {
            indexOfKneeArr.push(_i6);
          }
        }

        if (indexOfKneeArr.length == 2) {
          faceHorizontalArr[indexOfKneeArr[0]].secondRaw = faceHorizontalArr[indexOfKneeArr[1]].raw;
          faceHorizontalArr.splice(indexOfKneeArr[1], 1);
        }

        for (var _i7 = 0; _i7 < faceHorizontalArr.length; _i7++) {
          _this.drawLineAndAngle({
            el: faceCanvas,
            angle: faceHorizontalArr[_i7].raw,
            secondAngle: faceHorizontalArr[_i7].secondRaw,
            points: faceHorizontalArr[_i7].points,
            min: min,
            max: max
          });
        }

        _this.$nextTick(function () {
          document.getElementById('face').appendChild(faceCanvas);
        });
      };
    },
    drawPoint: function drawPoint(option) {
      var canvas = option.el;
      var point = option.point;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.fillStyle = '#009eff';
      cxt.beginPath();
      cxt.arc(point.x, point.y, 5, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
      cxt.save();
      cxt.fillStyle = "rgba(83, 158, 255, .3)";
      cxt.beginPath();
      cxt.arc(point.x, point.y, 10, 0, 2 * Math.PI);
      cxt.closePath();
      cxt.fill();
      cxt.restore();
    },
    drawLine: function drawLine(option) {

      if (option.points[0].x == 0 && option.points[0].y == 0 || option.points[1].x == 0 && option.points[1].y == 0) {
        return;
      }
      var canvas = option.el;
      var points = option.points;
      var cxt = canvas.getContext('2d');
      cxt.save();
      cxt.lineWidth = 3;
      if (!option.isSide) {
        cxt.strokeStyle = '#5f58f4';
        cxt.beginPath();
        cxt.moveTo(points[0].x, points[0].y);
        cxt.lineTo(points[1].x, points[1].y);
        cxt.closePath();
        cxt.stroke();
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var z = Math.sqrt(Math.pow(_x, 2) + Math.pow(_y, 2));
        var startX = void 0;
        var startY = void 0;
        var endX = void 0;
        var endY = void 0;
        var distance = 80;

        console.log('points ===>', points);
        if (points[0].x > points[1].x) {
          startX = Math.round(points[1].x - distance * _x / z);
          startY = Math.round(points[1].y + distance * _y / z);
          endX = Math.round(points[0].x + distance * _x / z);
          endY = Math.round(points[0].y - distance * _y / z);
        } else {
          startX = Math.round(points[0].x - distance * _x / z);
          startY = Math.round(points[0].y - distance * _y / z);
          endX = Math.round(points[1].x + distance * _x / z);
          endY = Math.round(points[1].y + distance * _y / z);
        }

        cxt.strokeStyle = '#0ef8cd';
        cxt.beginPath();
        cxt.moveTo(startX, startY);
        cxt.lineTo(endX, endY);
        cxt.closePath();
        cxt.stroke();
      }

      cxt.restore();
    },
    drawRectAndAngle: function drawRectAndAngle(option) {
      var cxt = option.cxt;
      var angle = option.angle;
      var point = option.point;

      cxt.save();
      if (option.isSecond) {
        cxt.translate(0, 43);
      }
      cxt.save();
      cxt.fillStyle = 'rgba(100, 100, 98, 0.5)';
      cxt.beginPath();
      cxt.moveTo(point.x + 13, point.y + 3);
      cxt.lineTo(point.x + 99, point.y + 3);
      cxt.quadraticCurveTo(point.x + 109, point.y + 3, point.x + 109, point.y + 13);
      cxt.lineTo(point.x + 109, point.y + 33);
      cxt.quadraticCurveTo(point.x + 109, point.y + 43, point.x + 99, point.y + 43);
      cxt.lineTo(point.x + 13, point.y + 43);
      cxt.quadraticCurveTo(point.x + 3, point.y + 43, point.x + 3, point.y + 33);
      cxt.lineTo(point.x + 3, point.y + 13);
      cxt.quadraticCurveTo(point.x + 3, point.y + 3, point.x + 13, point.y + 3);
      cxt.closePath();
      cxt.fill();
      cxt.restore();

      cxt.save();
      cxt.font = '34px Arial';
      cxt.fillStyle = '#0cfcca';
      cxt.textAlign = 'center';
      if (option.isTrunk) {
        cxt.fillText(angle + '%', point.x + 56, point.y + 38);
      } else {
        cxt.fillText(angle + '\xB0', point.x + 56, point.y + 38);
      }
      cxt.restore();
      cxt.restore();
    },
    drawLineAndAngle: function drawLineAndAngle(option) {
      var canvas = option.el;
      var width = canvas.width;
      var points = option.points;
      var min = option.min - 100;
      var max = option.max + 100;
      var cxt = canvas.getContext('2d');

      for (var i = 0; i < points.length; i++) {
        if (points[i].x == 0 && points[i].y == 0) {
          return;
        }
      }

      console.log('======== point', points);
      if (points.length == 1) {
        this.drawRectAndAngle({
          cxt: cxt,
          angle: (option.angle * 100).toFixed(1),
          point: {
            x: width - 120,
            y: points[0].y
          },
          isSecond: false,
          isTrunk: true
        });
      } else {
        var _x = Math.abs(points[0].x - points[1].x);
        var _y = Math.abs(points[0].y - points[1].y);
        var startPoint = {};
        var endPoint = {};
        var offsetYL = Number(((points[0].x - min) * _y / _x).toFixed(0));
        var offsetYR = Number(((max - points[1].x) * _y / _x).toFixed(0));

        if (points[0].y < points[1].y) {
          startPoint.x = min;
          startPoint.y = points[0].y - offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y + offsetYR;
        } else {
          startPoint.x = min;
          startPoint.y = points[0].y + offsetYL;
          endPoint.x = max;
          endPoint.y = points[1].y - offsetYR;
        }

        cxt.save();
        cxt.strokeStyle = '#14bc9a';
        cxt.beginPath();
        cxt.moveTo(startPoint.x, startPoint.y);
        cxt.lineTo(endPoint.x, endPoint.y);
        cxt.closePath();
        cxt.stroke();
        cxt.restore();

        this.drawRectAndAngle({
          cxt: cxt,
          angle: Number(option.angle.toFixed(1)),
          point: {
            x: width - 120,
            y: points[1].y
          },
          isSecond: false
        });
        console.log('secondAngle =>', option.secondAngle);
        if (!lodash_default.a.isUndefined(option.secondAngle)) {
          this.drawRectAndAngle({
            cxt: cxt,
            angle: Number(option.secondAngle.toFixed(1)),
            point: {
              x: width - 120,
              y: points[1].y
            },
            isSecond: true
          });
        }
      }
    }
  }, Object(vuex_esm["d" /* mapState */])({
    initReportData: function initReportData(state) {
      var reportData = state.vux.reportData;
      var _this = this;
      if (lodash_default.a.isNull(reportData)) {
        var uuid = '';
        var type = '';

        var urlquery = url_default.a.parse(window.location.href).query;
        var query = urlquery.split('&');
        for (var every = 0; every < query.length; every++) {
          if (query[every].indexOf('uuid=') != -1) {
            uuid = query[every].replace('uuid=', '');
          }
          if (query[every].indexOf('type=') != -1) {
            type = query[every].replace('type=', '');
          }
        }

        this.get({
          url: 'v1/posture/reports/' + uuid,
          params: {
            type: type
          },
          success: function success(result) {
            _this.updateReportData({
              reportData: result
            });
            _this.getReportData();
            console.log('result=>', result);
          },
          error: function error(data) {
            _this.loading = false;
            _this.valid = false;
          }
        });
      } else {
        _this.getReportData();
      }
    },
    getReportData: function getReportData(state) {
      this.loading = false;
      var reportData = state.vux.reportData;

      this.conclusion = reportData.conclusion;
      var conclusion = this.conclusion;
      if (!conclusion.face.valid || !conclusion.side.valid) {
        this.valid = false;
      } else {
        this.risks = {
          face: conclusion.face.risks,
          side: conclusion.side.risks
        };
        this.initRisksData();
      }

      var points = {
        face: conclusion.face.points,
        side: assign_default()(conclusion.side.points, { side: conclusion.side.side })
      };
      this.points = points;

      console.log('all points =>', points);

      var photos = {
        face: reportData.face,
        side: reportData.side
      };
      this.photos = photos;

      this.initRiskPoints();
    }
  }), Object(vuex_esm["b" /* mapActions */])(['get']), Object(vuex_esm["c" /* mapMutations */])(['updateReportData'])),
  created: function created() {
    this.initReportData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-189be7e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Face.vue
var Face_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "100%" } }, [
    _vm.loading
      ? _c("div", [_c("loading", { attrs: { show: _vm.loading } })], 1)
      : _c("div", { staticStyle: { position: "relative", height: "100%" } }, [
          !_vm.valid
            ? _c("div", {}, [
                _c(
                  "div",
                  {
                    staticClass: "font-20",
                    staticStyle: {
                      position: "fixed",
                      top: "50%",
                      left: "50%",
                      color: "#000",
                      transform: "translate(-50%, -50%)"
                    }
                  },
                  [_vm._v("数据无效")]
                )
              ])
            : _c(
                "div",
                { staticStyle: { height: "100%" } },
                [
                  _c(
                    "swiper",
                    {
                      ref: "postureSwiper",
                      attrs: { options: _vm.swiperOption }
                    },
                    [
                      _c("swiper-slide", { staticClass: "pagintaion-space" }, [
                        _c("div", {
                          staticStyle: { height: "100%", overflow: "hidden" },
                          attrs: { id: "face" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "swiper-pagination posture-swiper-pagination content-row content-row-around",
                        attrs: { slot: "pagination" },
                        slot: "pagination"
                      })
                    ],
                    1
                  )
                ],
                1
              )
        ])
  ])
}
var Face_staticRenderFns = []
Face_render._withStripped = true
var Face_esExports = { render: Face_render, staticRenderFns: Face_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Face = (Face_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-189be7e6", Face_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Face.vue
var Face_disposed = false
function Face_injectStyle (ssrContext) {
  if (Face_disposed) return
  __webpack_require__("k+JE")
}
var Face_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Face___vue_template_functional__ = false
/* styles */
var Face___vue_styles__ = Face_injectStyle
/* scopeId */
var Face___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Face___vue_module_identifier__ = null
var Face_Component = Face_normalizeComponent(
  components_Face,
  selectortype_template_index_0_src_components_Face,
  Face___vue_template_functional__,
  Face___vue_styles__,
  Face___vue_scopeId__,
  Face___vue_module_identifier__
)
Face_Component.options.__file = "src/components/Face.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-189be7e6", Face_Component.options)
  } else {
    hotAPI.reload("data-v-189be7e6", Face_Component.options)
  }
  module.hot.dispose(function (data) {
    Face_disposed = true
  })
})()}

/* harmony default export */ var src_components_Face = (Face_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Wechat_error.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Wechat_error = ({
    name: "wechat_tip"
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Wechat_error.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_Wechat_error = ({
    name: "wechat_tip"
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00e4705f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wechat_error.vue
var Wechat_error_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var Wechat_error_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "100%",
          height: "100%",
          "background-color": "#fff"
        }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "weui_msg content-row content-align-center content-row-column auto-width"
          },
          [
            _c("div", { staticClass: "weui_icon_area" }, [_vm._v("i")]),
            _vm._v(" "),
            _c("div", { staticClass: "weui_text_area" }, [
              _c("h4", { staticClass: "weui_msg_title" }, [
                _vm._v("请在微信客户端扫描二维码")
              ])
            ])
          ]
        )
      ]
    )
  }
]
Wechat_error_render._withStripped = true
var Wechat_error_esExports = { render: Wechat_error_render, staticRenderFns: Wechat_error_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Wechat_error = (Wechat_error_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00e4705f", Wechat_error_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Wechat_error.vue
var Wechat_error_disposed = false
function Wechat_error_injectStyle (ssrContext) {
  if (Wechat_error_disposed) return
  __webpack_require__("33Ju")
}
var Wechat_error_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Wechat_error___vue_template_functional__ = false
/* styles */
var Wechat_error___vue_styles__ = Wechat_error_injectStyle
/* scopeId */
var Wechat_error___vue_scopeId__ = "data-v-00e4705f"
/* moduleIdentifier (server only) */
var Wechat_error___vue_module_identifier__ = null
var Wechat_error_Component = Wechat_error_normalizeComponent(
  components_Wechat_error,
  selectortype_template_index_0_src_components_Wechat_error,
  Wechat_error___vue_template_functional__,
  Wechat_error___vue_styles__,
  Wechat_error___vue_scopeId__,
  Wechat_error___vue_module_identifier__
)
Wechat_error_Component.options.__file = "src/components/Wechat_error.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-00e4705f", Wechat_error_Component.options)
  } else {
    hotAPI.reload("data-v-00e4705f", Wechat_error_Component.options)
  }
  module.hot.dispose(function (data) {
    Wechat_error_disposed = true
  })
})()}

/* harmony default export */ var src_components_Wechat_error = (Wechat_error_Component.exports);

// CONCATENATED MODULE: ./src/assets/javascripts/ajax.js

/**
 * Created by hw_liu on 2017/10/30 .
 */
function checkUrl(isWechat) {
  if (isWechat) {
    return "https://gait.sennoapi.com/api/wechat/web";
  } else {
    return "https://gait.sennoapi.com/api";
  }
}

function send(config) {
  var options = assign_default()({
    url: config.url,
    method: config.method,
    params: config.params,
    data: config.data
  }, {
    headers: {
      'Content-Type': config.contentType ? config.contentType : 'application/x-www-form-urlencoded'
    },
    withCredentials: true,
    baseURL: checkUrl(config.isWechat)
  });

  config.http(options).then(function (response) {
    // console.log(`${config.method} ${config.url} ${response.status}: ${JSON.stringify(response.data)}`);

    if (config.success) {
      config.success(response.data);
    }
  }).catch(function (error) {
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      console.error(config.method + ' ' + config.url + ' ' + error.response.status + ': ' + error.response.data.errmsg);
      if (config.error) {
        config.error(error.response.data);
      }
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error: ', error.message);
    }
  });
}

function absoluteUrl(url) {
  if (typeof url === 'undefined' || url === null || Object.prototype.toString.call(url) !== '[object String]') {
    throw 'illegal url';
  }

  if (url.startsWith("/")) return "https://gait.sennoapi.com/api" + url;else return "https://gait.sennoapi.com/api" + '/' + url;
}

/* harmony default export */ var ajax = ({
  absoluteUrl: absoluteUrl,
  get: function get(config) {
    send(assign_default()({
      method: 'GET'
    }, config));
  },
  post: function post(config) {
    send(assign_default()({
      method: 'POST'
    }, config));
  },
  delete: function _delete(config) {
    send(assign_default()({
      method: 'DELETE'
    }, config));
  },
  patch: function patch(config) {
    if (!config.params) config.data = {};
    config.data = config.params;
    delete config.params;
    send(assign_default()({
      method: 'PATCH',
      contentType: 'application/json'
    }, config));
  }
});
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// CONCATENATED MODULE: ./src/assets/javascripts/locales.conf.js
var configLang = {
  'eu': 'eu', //               : euskara
  'hr_BA': 'hr_BA', //            : hrvatski (Bosna i Hercegovina)
  'en_CM': 'en_CM', //            : English (Cameroon)
  'en_BI': 'en_BI', //            : English (Burundi)
  'rw_RW': 'rw_RW', //            : Kinyarwanda (U Rwanda)
  'ast': 'ast', //              : asturianu
  'en_SZ': 'en_SZ', //            : English (Swaziland)
  'he_IL': 'he_IL', //            : עברית (ישראל)
  'ar': 'ar', //               : العربية
  'uz_Arab': 'uz_Arab', //          : اوزبیک (عربی)
  'en_PN': 'en_PN', //            : English (Pitcairn Islands)
  'as': 'as', //               : অসমীয়া
  'en_NF': 'en_NF', //            : English (Norfolk Island)
  'ks_IN': 'ks_IN', //            : کٲشُر (ہِنٛدوستان)
  'es_KY': 'es_KY', //            : español (Islas Caimán)
  'rwk_TZ': 'rwk_TZ', //           : Kiruwa (Tanzania)
  'zh_Hant_TW': 'zh_Hant_TW', //       : 中文（繁體，台灣）
  'en_CN': 'en_CN', //            : English (China)
  'gsw_LI': 'gsw_LI', //           : Schwiizertüütsch (Liächteschtäi)
  'ta_IN': 'ta_IN', //            : தமிழ் (இந்தியா)
  'th_TH': 'th_TH', //            : ไทย (ไทย)
  'es_EA': 'es_EA', //            : español (Ceuta y Melilla)
  'fr_GF': 'fr_GF', //            : français (Guyane française)
  'ar_001': 'ar_001', //           : العربية (العالم)
  'en_RW': 'en_RW', //            : English (Rwanda)
  'tr_TR': 'tr_TR', //            : Türkçe (Türkiye)
  'de_CH': 'de_CH', //            : Deutsch (Schweiz)
  'ee_TG': 'ee_TG', //            : Eʋegbe (Togo nutome)
  'en_NG': 'en_NG', //            : English (Nigeria)
  'fr_TG': 'fr_TG', //            : français (Togo)
  'az': 'az', //               : azərbaycan
  'fr_SC': 'fr_SC', //            : français (Seychelles)
  'es_HN': 'es_HN', //            : español (Honduras)
  'en_AG': 'en_AG', //            : English (Antigua & Barbuda)
  'ccp_IN': 'ccp_IN', //           : 𑄌𑄋𑄴𑄟𑄳𑄦 (𑄞𑄢𑄧𑄖𑄴)
  'ru_KZ': 'ru_KZ', //            : русский (Казахстан)
  'gsw': 'gsw', //              : Schwiizertüütsch
  'dyo': 'dyo', //              : joola
  'so_ET': 'so_ET', //            : Soomaali (Itoobiya)
  'zh_Hant_MO': 'zh_Hant_MO', //       : 中文（繁體字，澳門［中國］）
  'de_BE': 'de_BE', //            : Deutsch (Belgien)
  'nus_SS': 'nus_SS', //           : Thok Nath (SS)
  'km_KH': 'km_KH', //            : ខ្មែរ (កម្ពុជា)
  'my_MM': 'my_MM', //            : မြန်မာ (မြန်မာ)
  'mgh_MZ': 'mgh_MZ', //           : Makua (Umozambiki)
  'ee_GH': 'ee_GH', //            : Eʋegbe (Ghana nutome)
  'es_EC': 'es_EC', //            : español (Ecuador)
  'kw_GB': 'kw_GB', //            : kernewek (Rywvaneth Unys)
  'rm_CH': 'rm_CH', //            : rumantsch (Svizra)
  'en_ME': 'en_ME', //            : English (Montenegro)
  'nyn': 'nyn', //              : Runyankore
  'mk_MK': 'mk_MK', //            : македонски (Македонија)
  'bs_Cyrl_BA': 'bs_Cyrl_BA', //       : босански (ћирилица, Босна и Херцеговина)
  'ar_MR': 'ar_MR', //            : العربية (موريتانيا)
  'es_GL': 'es_GL', //            : español (Groenlandia)
  'en_BM': 'en_BM', //            : English (Bermuda)
  'ms_Arab': 'ms_Arab', //          : بهاس ملايو (عرب)
  'en_AI': 'en_AI', //            : English (Anguilla)
  'gl_ES': 'gl_ES', //            : galego (España)
  'en_PR': 'en_PR', //            : English (Puerto Rico)
  'ff_CM': 'ff_CM', //            : Pulaar (Kameruun)
  'ne_IN': 'ne_IN', //            : नेपाली (भारत)
  'or_IN': 'or_IN', //            : ଓଡ଼ିଆ (ଭାରତ)
  'khq_ML': 'khq_ML', //           : Koyra ciini (Maali)
  'en_MG': 'en_MG', //            : English (Madagascar)
  'pt_TL': 'pt_TL', //            : português (Timor-Leste)
  'en_LC': 'en_LC', //            : English (St. Lucia)
  'iu_CA': 'iu_CA', //            : ᐃᓄᒃᑎᑐᑦ (ᑲᓇᑕᒥ)
  'ta_SG': 'ta_SG', //            : தமிழ் (சிங்கப்பூர்)
  'jmc_TZ': 'jmc_TZ', //           : Kimachame (Tanzania)
  'om_ET': 'om_ET', //            : Oromoo (Itoophiyaa)
  'lv_LV': 'lv_LV', //            : latviešu (Latvija)
  'es_US': 'es_US', //            : español (Estados Unidos)
  'en_PT': 'en_PT', //            : English (Portugal)
  'vai_Latn_LR': 'vai_Latn_LR', //      : Vai (Latn, Laibhiya)
  'en_NL': 'en_NL', //            : English (Netherlands)
  'to_TO': 'to_TO', //            : lea fakatonga (Tonga)
  'cgg_UG': 'cgg_UG', //           : Rukiga (Uganda)
  'en_MH': 'en_MH', //            : English (Marshall Islands)
  'ta': 'ta', //               : தமிழ்
  'zu_ZA': 'zu_ZA', //            : isiZulu (iNingizimu Afrika)
  'shi_Latn_MA': 'shi_Latn_MA', //      : ⵜⴰⵛⵍⵃⵉⵜ (Latn, ⵍⵎⵖⵔⵉⴱ)
  'es_FK': 'es_FK', //            : español (Islas Malvinas)
  'ar_KM': 'ar_KM', //            : العربية (جزر القمر)
  'en_AL': 'en_AL', //            : English (Albania)
  'brx_IN': 'brx_IN', //           : बड़ो (भारत)
  'te': 'te', //               : తెలుగు
  'chr_US': 'chr_US', //           : ᏣᎳᎩ (ᏌᏊ ᎢᏳᎾᎵᏍᏔᏅ ᏍᎦᏚᎩ)
  'yo_BJ': 'yo_BJ', //            : Èdè Yorùbá (Orílɛ́ède Bɛ̀nɛ̀)
  'fr_VU': 'fr_VU', //            : français (Vanuatu)
  'pa': 'pa', //               : ਪੰਜਾਬੀ
  'tg': 'tg', //               : тоҷикӣ
  'kea': 'kea', //              : kabuverdianu
  'ksh_DE': 'ksh_DE', //           : Kölsch en Doütschland
  'sw_CD': 'sw_CD', //            : Kiswahili (Jamhuri ya Kidemokrasia ya Kongo)
  'te_IN': 'te_IN', //            : తెలుగు (భారతదేశం)
  'fr_RE': 'fr_RE', //            : français (La Réunion)
  'th': 'th', //               : ไทย
  'ur_IN': 'ur_IN', //            : اردو (بھارت)
  'yo_NG': 'yo_NG', //            : Èdè Yorùbá (Orílẹ́ède Nàìjíríà)
  'ti': 'ti', //               : ትግርኛ
  'es_HT': 'es_HT', //            : español (Haití)
  'es_GP': 'es_GP', //            : español (Guadalupe)
  'guz_KE': 'guz_KE', //           : Ekegusii (Kenya)
  'tk': 'tk', //               : Türkmen dili
  'kl_GL': 'kl_GL', //            : kalaallisut (Kalaallit Nunaat)
  'ksf_CM': 'ksf_CM', //           : rikpa (kamɛrún)
  'mua_CM': 'mua_CM', //           : MUNDAŊ (kameruŋ)
  'lag_TZ': 'lag_TZ', //           : Kɨlaangi (Taansanía)
  'lb': 'lb', //               : Lëtzebuergesch
  'fr_TN': 'fr_TN', //            : français (Tunisie)
  'es_PA': 'es_PA', //            : español (Panamá)
  'pl_PL': 'pl_PL', //            : polski (Polska)
  'to': 'to', //               : lea fakatonga
  'hi_IN': 'hi_IN', //            : हिन्दी (भारत)
  'dje_NE': 'dje_NE', //           : Zarmaciine (Nižer)
  'es_GQ': 'es_GQ', //            : español (Guinea Ecuatorial)
  'en_BR': 'en_BR', //            : English (Brazil)
  'kok_IN': 'kok_IN', //           : कोंकणी (भारत)
  'pl': 'pl', //               : polski
  'fr_GN': 'fr_GN', //            : français (Guinée)
  'bem': 'bem', //              : Ichibemba
  'ha': 'ha', //               : Hausa
  'ckb': 'ckb', //              : کوردیی ناوەندی
  'es_CA': 'es_CA', //            : español (Canadá)
  'lg': 'lg', //               : Luganda
  'tr': 'tr', //               : Türkçe
  'en_PW': 'en_PW', //            : English (Palau)
  'tt': 'tt', //               : татар
  'en_NO': 'en_NO', //            : English (Norway)
  'nyn_UG': 'nyn_UG', //           : Runyankore (Uganda)
  'sr_Latn_RS': 'sr_Latn_RS', //       : srpski (latinica, Srbija)
  'gsw_FR': 'gsw_FR', //           : Schwiizertüütsch (Frankriich)
  'pa_Guru': 'pa_Guru', //          : ਪੰਜਾਬੀ (ਗੁਰਮੁਖੀ)
  'he': 'he', //               : עברית
  'qu_BO': 'qu_BO', //            : Runasimi (Bolivia)
  'ps_AF': 'ps_AF', //            : پښتو (افغانستان)
  'lu_CD': 'lu_CD', //            : Tshiluba (Ditunga wa Kongu)
  'mgo_CM': 'mgo_CM', //           : metaʼ (Kamalun)
  'sn_ZW': 'sn_ZW', //            : chiShona (Zimbabwe)
  'en_BS': 'en_BS', //            : English (Bahamas)
  'da': 'da', //               : dansk
  'ps': 'ps', //               : پښتو
  'ln': 'ln', //               : lingála
  'hi': 'hi', //               : हिन्दी
  'lo': 'lo', //               : ລາວ
  'ebu': 'ebu', //              : Kĩembu
  'de': 'de', //               : Deutsch
  'gu_IN': 'gu_IN', //            : ગુજરાતી (ભારત)
  'wo_SN': 'wo_SN', //            : Wolof (Senegaal)
  'seh': 'seh', //              : sena
  'en_CX': 'en_CX', //            : English (Christmas Island)
  'en_ZM': 'en_ZM', //            : English (Zambia)
  'fr_HT': 'fr_HT', //            : français (Haïti)
  'fr_GP': 'fr_GP', //            : français (Guadeloupe)
  'pt_GQ': 'pt_GQ', //            : português (Guiné Equatorial)
  'lt': 'lt', //               : lietuvių
  'lu': 'lu', //               : Tshiluba
  'es_TT': 'es_TT', //            : español (Trinidad y Tobago)
  'ln_CD': 'ln_CD', //            : lingála (Republíki ya Kongó Demokratíki)
  'vai_Latn': 'vai_Latn', //         : Vai (Latn)
  'el_GR': 'el_GR', //            : Ελληνικά (Ελλάδα)
  'lv': 'lv', //               : latviešu
  'en_KE': 'en_KE', //            : English (Kenya)
  'sbp': 'sbp', //              : Ishisangu
  'hr': 'hr', //               : hrvatski
  'en_CY': 'en_CY', //            : English (Cyprus)
  'es_GT': 'es_GT', //            : español (Guatemala)
  'twq_NE': 'twq_NE', //           : Tasawaq senni (Nižer)
  'zh_Hant_HK': 'zh_Hant_HK', //       : 中文（繁體字，香港［中國］）
  'kln_KE': 'kln_KE', //           : Kalenjin (Emetab Kenya)
  'fr_GQ': 'fr_GQ', //            : français (Guinée équatoriale)
  'chr': 'chr', //              : ᏣᎳᎩ
  'hu': 'hu', //               : magyar
  'es_UY': 'es_UY', //            : español (Uruguay)
  'fr_CA': 'fr_CA', //            : français (Canada)
  'ms_BN': 'ms_BN', //            : Bahasa Melayu (Brunei)
  'en_NR': 'en_NR', //            : English (Nauru)
  'mer': 'mer', //              : Kĩmĩrũ
  'shi': 'shi', //              : ⵜⴰⵛⵍⵃⵉⵜ
  'es_PE': 'es_PE', //            : español (Perú)
  'fr_SN': 'fr_SN', //            : français (Sénégal)
  'bez': 'bez', //              : Hibena
  'sw_TZ': 'sw_TZ', //            : Kiswahili (Tanzania)
  'wae_CH': 'wae_CH', //           : Walser (Schwiz)
  'kkj': 'kkj', //              : kakɔ
  'hy': 'hy', //               : հայերեն
  'dz_BT': 'dz_BT', //            : རྫོང་ཁ། (འབྲུག།)
  'en_CZ': 'en_CZ', //            : English (Czechia)
  'teo_KE': 'teo_KE', //           : Kiteso (Kenia)
  'teo': 'teo', //              : Kiteso
  'en_AR': 'en_AR', //            : English (Argentina)
  'ar_JO': 'ar_JO', //            : العربية (الأردن)
  'yue_Hans_CN': 'yue_Hans_CN', //      : 粤语 (简体，中华人民共和国)
  'mer_KE': 'mer_KE', //           : Kĩmĩrũ (Kenya)
  'khq': 'khq', //              : Koyra ciini
  'ln_CF': 'ln_CF', //            : lingála (Repibiki ya Afríka ya Káti)
  'nn_NO': 'nn_NO', //            : nynorsk (Noreg)
  'es_SR': 'es_SR', //            : español (Surinam)
  'en_MO': 'en_MO', //            : English (Macau [China])
  'ar_TD': 'ar_TD', //            : العربية (تشاد)
  'dz': 'dz', //               : རྫོང་ཁ
  'ses': 'ses', //              : Koyraboro senni
  'en_BW': 'en_BW', //            : English (Botswana)
  'en_AS': 'en_AS', //            : English (American Samoa)
  'ar_IL': 'ar_IL', //            : العربية (إسرائيل)
  'es_BB': 'es_BB', //            : español (Barbados)
  'bo_CN': 'bo_CN', //            : བོད་སྐད་ (རྒྱ་ནག)
  'nnh': 'nnh', //              : Shwóŋò ngiembɔɔn
  'teo_UG': 'teo_UG', //           : Kiteso (Uganda)
  'hy_AM': 'hy_AM', //            : հայերեն (Հայաստան)
  'ln_CG': 'ln_CG', //            : lingála (Kongo)
  'sr_Latn_BA': 'sr_Latn_BA', //       : srpski (latinica, Bosna i Hercegovina)
  'en_MP': 'en_MP', //            : English (Northern Mariana Islands)
  'ksb_TZ': 'ksb_TZ', //           : Kishambaa (Tanzania)
  'ar_SA': 'ar_SA', //            : العربية (المملكة العربية السعودية)
  'smn_FI': 'smn_FI', //           : anarâškielâ (Suomâ)
  'ar_LY': 'ar_LY', //            : العربية (ليبيا)
  'en_AT': 'en_AT', //            : English (Austria)
  'so_KE': 'so_KE', //            : Soomaali (Kiiniya)
  'fr_CD': 'fr_CD', //            : français (Congo-Kinshasa)
  'af_NA': 'af_NA', //            : Afrikaans (Namibië)
  'en_NU': 'en_NU', //            : English (Niue)
  'es_PH': 'es_PH', //            : español (Filipinas)
  'en_KI': 'en_KI', //            : English (Kiribati)
  'en_JE': 'en_JE', //            : English (Jersey)
  'lkt': 'lkt', //              : Lakȟólʼiyapi
  'en_AU': 'en_AU', //            : English (Australia)
  'fa_IR': 'fa_IR', //            : فارسی (ایران)
  'pt_FR': 'pt_FR', //            : português (França)
  'uz_Latn_UZ': 'uz_Latn_UZ', //       : o‘zbek (lotin, Oʻzbekiston)
  'zh_Hans_CN': 'zh_Hans_CN', //       : 中文（简体，中国）
  'ewo_CM': 'ewo_CM', //           : ewondo (Kamərún)
  'fr_PF': 'fr_PF', //            : français (Polynésie française)
  'ca_IT': 'ca_IT', //            : català (Itàlia)
  'es_GY': 'es_GY', //            : español (Guyana)
  'en_BZ': 'en_BZ', //            : English (Belize)
  'ar_KW': 'ar_KW', //            : العربية (الكويت)
  'pt_GW': 'pt_GW', //            : português (Guiné-Bissau)
  'fr_FR': 'fr_FR', //            : français (France)
  'am_ET': 'am_ET', //            : አማርኛ (ኢትዮጵያ)
  'en_VC': 'en_VC', //            : English (St. Vincent & Grenadines)
  'es_DM': 'es_DM', //            : español (Dominica)
  'fr_DJ': 'fr_DJ', //            : français (Djibouti)
  'fr_CF': 'fr_CF', //            : français (République centrafricaine)
  'es_SV': 'es_SV', //            : español (El Salvador)
  'en_MS': 'en_MS', //            : English (Montserrat)
  'pt_ST': 'pt_ST', //            : português (São Tomé e Príncipe)
  'ar_SD': 'ar_SD', //            : العربية (السودان)
  'luy_KE': 'luy_KE', //           : Luluhia (Kenya)
  'gd_GB': 'gd_GB', //            : Gàidhlig (An Rìoghachd Aonaichte)
  'de_LI': 'de_LI', //            : Deutsch (Liechtenstein)
  'it_VA': 'it_VA', //            : italiano (Città del Vaticano)
  'fr_CG': 'fr_CG', //            : français (Congo-Brazzaville)
  'pt_CH': 'pt_CH', //            : português (Suíça)
  'ckb_IQ': 'ckb_IQ', //           : کوردیی ناوەندی (عێراق)
  'zh_Hans_SG': 'zh_Hans_SG', //       : 中文（简体，新加坡）
  'en_MT': 'en_MT', //            : English (Malta)
  'ha_NE': 'ha_NE', //            : Hausa (Nijar)
  'en_ID': 'en_ID', //            : English (Indonesia)
  'ewo': 'ewo', //              : ewondo
  'af_ZA': 'af_ZA', //            : Afrikaans (Suid-Afrika)
  'os_GE': 'os_GE', //            : ирон (Гуырдзыстон)
  'om_KE': 'om_KE', //            : Oromoo (Keeniyaa)
  'nl_SR': 'nl_SR', //            : Nederlands (Suriname)
  'es_ES': 'es_ES', //            : español (España)
  'es_DO': 'es_DO', //            : español (República Dominicana)
  'ar_IQ': 'ar_IQ', //            : العربية (العراق)
  'fr_CH': 'fr_CH', //            : français (Suisse)
  'nnh_CM': 'nnh_CM', //           : Shwóŋò ngiembɔɔn (Kàmalûm)
  'es_SX': 'es_SX', //            : español (Sint Maarten)
  'es_419': 'es_419', //           : español (Latinoamérica)
  'en_MU': 'en_MU', //            : English (Mauritius)
  'en_US_POSIX': 'en_US_POSIX', //      : English (United States, Computer)
  'yav_CM': 'yav_CM', //           : nuasue (Kemelún)
  'luo_KE': 'luo_KE', //           : Dholuo (Kenya)
  'dua_CM': 'dua_CM', //           : duálá (Cameroun)
  'et_EE': 'et_EE', //            : eesti (Eesti)
  'en_IE': 'en_IE', //            : English (Ireland)
  'ak_GH': 'ak_GH', //            : Akan (Gaana)
  'rwk': 'rwk', //              : Kiruwa
  'es_CL': 'es_CL', //            : español (Chile)
  'kea_CV': 'kea_CV', //           : kabuverdianu (Kabu Verdi)
  'fr_CI': 'fr_CI', //            : français (Côte d’Ivoire)
  'ckb_IR': 'ckb_IR', //           : کوردیی ناوەندی (ئێران)
  'fr_BE': 'fr_BE', //            : français (Belgique)
  'se': 'se', //               : davvisámegiella
  'en_NZ': 'en_NZ', //            : English (New Zealand)
  'en_MV': 'en_MV', //            : English (Maldives)
  'en_LR': 'en_LR', //            : English (Liberia)
  'es_PM': 'es_PM', //            : español (San Pedro y Miquelón)
  'en_KN': 'en_KN', //            : English (St. Kitts & Nevis)
  'nb_SJ': 'nb_SJ', //            : norsk bokmål (Svalbard og Jan Mayen)
  'ha_NG': 'ha_NG', //            : Hausa (Najeriya)
  'sg': 'sg', //               : Sängö
  'sr_Cyrl_RS': 'sr_Cyrl_RS', //       : српски (ћирилица, Србија)
  'ru_RU': 'ru_RU', //            : русский (Россия)
  'en_ZW': 'en_ZW', //            : English (Zimbabwe)
  'sv_AX': 'sv_AX', //            : svenska (Åland)
  'ga_IE': 'ga_IE', //            : Gaeilge (Éire)
  'si': 'si', //               : සිංහල
  'wo': 'wo', //               : Wolof
  'en_VG': 'en_VG', //            : English (British Virgin Islands)
  'ff_MR': 'ff_MR', //            : Pulaar (Muritani)
  'ky_KG': 'ky_KG', //            : кыргызча (Кыргызстан)
  'agq_CM': 'agq_CM', //           : Aghem (Kàmàlûŋ)
  'mzn': 'mzn', //              : مازرونی
  'fr_BF': 'fr_BF', //            : français (Burkina Faso)
  'naq_NA': 'naq_NA', //           : Khoekhoegowab (Namibiab)
  'mr_IN': 'mr_IN', //            : मराठी (भारत)
  'en_MW': 'en_MW', //            : English (Malawi)
  'de_AT': 'de_AT', //            : Deutsch (Österreich)
  'az_Latn': 'az_Latn', //          : azərbaycan (latın)
  'en_LS': 'en_LS', //            : English (Lesotho)
  'ka': 'ka', //               : ქართული
  'sk': 'sk', //               : slovenčina
  'sl': 'sl', //               : slovenščina
  'sn': 'sn', //               : chiShona
  'sr_Latn_ME': 'sr_Latn_ME', //       : srpski (latinica, Crna Gora)
  'fr_NC': 'fr_NC', //            : français (Nouvelle-Calédonie)
  'so': 'so', //               : Soomaali
  'is_IS': 'is_IS', //            : íslenska (Ísland)
  'twq': 'twq', //              : Tasawaq senni
  'ig_NG': 'ig_NG', //            : Igbo (Naịjịrịa)
  'sq': 'sq', //               : shqip
  'fo_FO': 'fo_FO', //            : føroyskt (Føroyar)
  'sr': 'sr', //               : српски
  'tzm': 'tzm', //              : Tamaziɣt n laṭlaṣ
  'ga': 'ga', //               : Gaeilge
  'om': 'om', //               : Oromoo
  'en_LT': 'en_LT', //            : English (Lithuania)
  'bas_CM': 'bas_CM', //           : Ɓàsàa (Kàmɛ̀rûn)
  'se_NO': 'se_NO', //            : davvisámegiella (Norga)
  'ki': 'ki', //               : Gikuyu
  'nl_BE': 'nl_BE', //            : Nederlands (België)
  'ar_QA': 'ar_QA', //            : العربية (قطر)
  'gd': 'gd', //               : Gàidhlig
  'sv': 'sv', //               : svenska
  'kk': 'kk', //               : қазақ тілі
  'rn_BI': 'rn_BI', //            : Ikirundi (Uburundi)
  'es_CO': 'es_CO', //            : español (Colombia)
  'az_Latn_AZ': 'az_Latn_AZ', //       : azərbaycan (latın, Azərbaycan)
  'kl': 'kl', //               : kalaallisut
  'or': 'or', //               : ଓଡ଼ିଆ
  'es_AG': 'es_AG', //            : español (Antigua y Barbuda)
  'ca': 'ca', //               : català
  'en_VI': 'en_VI', //            : English (U.S. Virgin Islands)
  'km': 'km', //               : ខ្មែរ
  'os': 'os', //               : ирон
  'sw': 'sw', //               : Kiswahili
  'en_MY': 'en_MY', //            : English (Malaysia)
  'kn': 'kn', //               : ಕನ್ನಡ
  'en_LU': 'en_LU', //            : English (Luxembourg)
  'fr_SY': 'fr_SY', //            : français (Syrie)
  'ar_TN': 'ar_TN', //            : العربية (تونس)
  'en_JM': 'en_JM', //            : English (Jamaica)
  'fr_PM': 'fr_PM', //            : français (Saint-Pierre-et-Miquelon)
  'ko': 'ko', //               : 한국어
  'fr_NE': 'fr_NE', //            : français (Niger)
  'ce': 'ce', //               : нохчийн
  'fr_MA': 'fr_MA', //            : français (Maroc)
  'gl': 'gl', //               : galego
  'ru_MD': 'ru_MD', //            : русский (Молдова)
  'es_BL': 'es_BL', //            : español (San Bartolomé)
  'saq_KE': 'saq_KE', //           : Kisampur (Kenya)
  'ks': 'ks', //               : کٲشُر
  'fr_CM': 'fr_CM', //            : français (Cameroun)
  'lb_LU': 'lb_LU', //            : Lëtzebuergesch (Lëtzebuerg)
  'gv_IM': 'gv_IM', //            : Gaelg (Ellan Vannin)
  'fr_BI': 'fr_BI', //            : français (Burundi)
  'en_LV': 'en_LV', //            : English (Latvia)
  'en_KR': 'en_KR', //            : English (South Korea)
  'es_NI': 'es_NI', //            : español (Nicaragua)
  'en_GB': 'en_GB', //            : English (United Kingdom)
  'kw': 'kw', //               : kernewek
  'nl_SX': 'nl_SX', //            : Nederlands (Sint-Maarten)
  'dav_KE': 'dav_KE', //           : Kitaita (Kenya)
  'tr_CY': 'tr_CY', //            : Türkçe (Kıbrıs)
  'ky': 'ky', //               : кыргызча
  'en_UG': 'en_UG', //            : English (Uganda)
  'es_BM': 'es_BM', //            : español (Bermudas)
  'en_TC': 'en_TC', //            : English (Turks & Caicos Islands)
  'es_AI': 'es_AI', //            : español (Anguila)
  'ar_EG': 'ar_EG', //            : العربية (مصر)
  'fr_BJ': 'fr_BJ', //            : français (Bénin)
  'gu': 'gu', //               : ગુજરાતી
  'es_PR': 'es_PR', //            : español (Puerto Rico)
  'fr_RW': 'fr_RW', //            : français (Rwanda)
  'gv': 'gv', //               : Gaelg
  'lrc_IQ': 'lrc_IQ', //           : لۊری شومالی (IQ)
  'sr_Cyrl_BA': 'sr_Cyrl_BA', //       : српски (ћирилица, Босна и Херцеговина)
  'es_MF': 'es_MF', //            : español (San Martín)
  'fr_MC': 'fr_MC', //            : français (Monaco)
  'cs': 'cs', //               : čeština
  'bez_TZ': 'bez_TZ', //           : Hibena (Hutanzania)
  'es_CR': 'es_CR', //            : español (Costa Rica)
  'asa_TZ': 'asa_TZ', //           : Kipare (Tadhania)
  'ar_EH': 'ar_EH', //            : العربية (الصحراء الغربية)
  'fo_DK': 'fo_DK', //            : føroyskt (Danmark)
  'ms_Arab_BN': 'ms_Arab_BN', //       : بهاس ملايو (عرب، بروني)
  'ccp': 'ccp', //              : 𑄌𑄋𑄴𑄟𑄳𑄦
  'en_JP': 'en_JP', //            : English (Japan)
  'sbp_TZ': 'sbp_TZ', //           : Ishisangu (Tansaniya)
  'en_IL': 'en_IL', //            : English (Israel)
  'lt_LT': 'lt_LT', //            : lietuvių (Lietuva)
  'mfe': 'mfe', //              : kreol morisien
  'en_GD': 'en_GD', //            : English (Grenada)
  'es_LC': 'es_LC', //            : español (Santa Lucía)
  'cy': 'cy', //               : Cymraeg
  'ug_CN': 'ug_CN', //            : ئۇيغۇرچە (جۇڭگو)
  'ca_FR': 'ca_FR', //            : català (França)
  'es_BO': 'es_BO', //            : español (Bolivia)
  'en_SA': 'en_SA', //            : English (Saudi Arabia)
  'fr_BL': 'fr_BL', //            : français (Saint-Barthélemy)
  'bn_IN': 'bn_IN', //            : বাংলা (ভারত)
  'uz_Cyrl_UZ': 'uz_Cyrl_UZ', //       : o‘zbek (kirill, Oʻzbekiston)
  'lrc_IR': 'lrc_IR', //           : لۊری شومالی (IR)
  'az_Cyrl': 'az_Cyrl', //          : азәрбајҹан (Кирил)
  'en_IM': 'en_IM', //            : English (Isle of Man)
  'sw_KE': 'sw_KE', //            : Kiswahili (Kenya)
  'en_SB': 'en_SB', //            : English (Solomon Islands)
  'pa_Arab': 'pa_Arab', //          : پنجابی (عربی)
  'ur_PK': 'ur_PK', //            : اردو (پاکستان)
  'haw_US': 'haw_US', //           : ʻŌlelo Hawaiʻi (ʻAmelika Hui Pū ʻIa)
  'ar_SO': 'ar_SO', //            : العربية (الصومال)
  'en_IN': 'en_IN', //            : English (India)
  'fil': 'fil', //              : Filipino
  'fr_MF': 'fr_MF', //            : français (Saint-Martin)
  'en_WS': 'en_WS', //            : English (Samoa)
  'es_CU': 'es_CU', //            : español (Cuba)
  'es_BQ': 'es_BQ', //            : español (Caribe neerlandés)
  'ja_JP': 'ja_JP', //            : 日本語（日本）
  'fy_NL': 'fy_NL', //            : Frysk (Nederlân)
  'en_SC': 'en_SC', //            : English (Seychelles)
  'yue_Hant_HK': 'yue_Hant_HK', //      : 粵語 (繁體，中華人民共和國香港特別行政區)
  'en_IO': 'en_IO', //            : English (British Indian Ocean Territory)
  'pt_PT': 'pt_PT', //            : português (Portugal)
  'en_HK': 'en_HK', //            : English (Hong Kong [China])
  'en_GG': 'en_GG', //            : English (Guernsey)
  'fr_MG': 'fr_MG', //            : français (Madagascar)
  'de_LU': 'de_LU', //            : Deutsch (Luxemburg)
  'tzm_MA': 'tzm_MA', //           : Tamaziɣt n laṭlaṣ (Meṛṛuk)
  'es_BR': 'es_BR', //            : español (Brasil)
  'en_TH': 'en_TH', //            : English (Thailand)
  'en_SD': 'en_SD', //            : English (Sudan)
  'nds_DE': 'nds_DE', //           : baixo-alemão (Alemanha)
  'shi_Tfng': 'shi_Tfng', //         : ⵜⴰⵛⵍⵃⵉⵜ (Tfng)
  'ln_AO': 'ln_AO', //            : lingála (Angóla)
  'as_IN': 'as_IN', //            : অসমীয়া (ভাৰত)
  'en_GH': 'en_GH', //            : English (Ghana)
  'ms_MY': 'ms_MY', //            : Bahasa Melayu (Malaysia)
  'ro_RO': 'ro_RO', //            : română (România)
  'jgo_CM': 'jgo_CM', //           : Ndaꞌa (Kamɛlûn)
  'es_CW': 'es_CW', //            : español (Curazao)
  'dua': 'dua', //              : duálá
  'en_UM': 'en_UM', //            : English (U.S. Outlying Islands)
  'es_BS': 'es_BS', //            : español (Bahamas)
  'en_SE': 'en_SE', //            : English (Sweden)
  'kn_IN': 'kn_IN', //            : ಕನ್ನಡ (ಭಾರತ)
  'en_KY': 'en_KY', //            : English (Cayman Islands)
  'vun_TZ': 'vun_TZ', //           : Kyivunjo (Tanzania)
  'kln': 'kln', //              : Kalenjin
  'lrc': 'lrc', //              : لۊری شومالی
  'en_GI': 'en_GI', //            : English (Gibraltar)
  'ca_ES': 'ca_ES', //            : català (Espanya)
  'rof': 'rof', //              : Kihorombo
  'pt_CV': 'pt_CV', //            : português (Cabo Verde)
  'kok': 'kok', //              : कोंकणी
  'pt_BR': 'pt_BR', //            : português (Brasil)
  'ar_DJ': 'ar_DJ', //            : العربية (جيبوتي)
  'yi_001': 'yi_001', //           : ייִדיש (וועלט)
  'fi_FI': 'fi_FI', //            : suomi (Suomi)
  'zh': 'zh', //               : 中文
  'es_PY': 'es_PY', //            : español (Paraguay)
  'ar_SS': 'ar_SS', //            : العربية (جنوب السودان)
  'mua': 'mua', //              : MUNDAŊ
  'sr_Cyrl_ME': 'sr_Cyrl_ME', //       : srpski (ćirilica, Crna Gora)
  'vai_Vaii_LR': 'vai_Vaii_LR', //      : ꕙꔤ (Vaii, ꕞꔤꔫꕩ)
  'en_001': 'en_001', //           : English (World)
  'nl_NL': 'nl_NL', //            : Nederlands (Nederland)
  'en_TK': 'en_TK', //            : English (Tokelau)
  'fr_DZ': 'fr_DZ', //            : français (Algérie)
  'en_SG': 'en_SG', //            : English (Singapore)
  'ca_AD': 'ca_AD', //            : català (Andorra)
  'si_LK': 'si_LK', //            : සිංහල (ශ්‍රී ලංකාව)
  'sv_SE': 'sv_SE', //            : svenska (Sverige)
  'pt_AO': 'pt_AO', //            : português (Angola)
  'vi': 'vi', //               : Tiếng Việt
  'xog_UG': 'xog_UG', //           : Olusoga (Yuganda)
  'xog': 'xog', //              : Olusoga
  'en_IS': 'en_IS', //            : English (Iceland)
  'nb': 'nb', //               : norsk bokmål
  'seh_MZ': 'seh_MZ', //           : sena (Moçambique)
  'es_AR': 'es_AR', //            : español (Argentina)
  'sk_SK': 'sk_SK', //            : slovenčina (Slovensko)
  'en_SH': 'en_SH', //            : English (St. Helena)
  'ti_ER': 'ti_ER', //            : ትግርኛ (ኤርትራ)
  'nd': 'nd', //               : isiNdebele
  'az_Cyrl_AZ': 'az_Cyrl_AZ', //       : азәрбајҹан (Кирил, Азәрбајҹан)
  'zu': 'zu', //               : isiZulu
  'ne': 'ne', //               : नेपाली
  'nd_ZW': 'nd_ZW', //            : isiNdebele (Zimbabwe)
  'el_CY': 'el_CY', //            : Ελληνικά (Κύπρος)
  'en_IT': 'en_IT', //            : English (Italy)
  'nl_BQ': 'nl_BQ', //            : Nederlands (Caribisch Nederland)
  'da_GL': 'da_GL', //            : dansk (Grønland)
  'ja': 'ja', //               : 日本語
  'rm': 'rm', //               : rumantsch
  'fr_ML': 'fr_ML', //            : français (Mali)
  'rn': 'rn', //               : Ikirundi
  'en_VU': 'en_VU', //            : English (Vanuatu)
  'rof_TZ': 'rof_TZ', //           : Kihorombo (Tanzania)
  'ro': 'ro', //               : română
  'ebu_KE': 'ebu_KE', //           : Kĩembu (Kenya)
  'ru_KG': 'ru_KG', //            : русский (Киргизия)
  'en_SI': 'en_SI', //            : English (Slovenia)
  'sg_CF': 'sg_CF', //            : Sängö (Ködörösêse tî Bêafrîka)
  'mfe_MU': 'mfe_MU', //           : kreol morisien (Moris)
  'nl': 'nl', //               : Nederlands
  'brx': 'brx', //              : बड़ो
  'bs_Latn': 'bs_Latn', //          : bosanski (latinica)
  'fa': 'fa', //               : فارسی
  'zgh_MA': 'zgh_MA', //           : ⵜⴰⵎⴰⵣⵉⵖⵜ (ⵍⵎⵖⵔⵉⴱ)
  'en_GM': 'en_GM', //            : English (Gambia)
  'shi_Latn': 'shi_Latn', //         : ⵜⴰⵛⵍⵃⵉⵜ (Latn)
  'en_FI': 'en_FI', //            : English (Finland)
  'nn': 'nn', //               : nynorsk
  'en_EE': 'en_EE', //            : English (Estonia)
  'ru': 'ru', //               : русский
  'yue': 'yue', //              : 粵語
  'kam_KE': 'kam_KE', //           : Kikamba (Kenya)
  'fur': 'fur', //              : furlan
  'vai_Vaii': 'vai_Vaii', //         : ꕙꔤ (Vaii)
  'ar_ER': 'ar_ER', //            : العربية (إريتريا)
  'rw': 'rw', //               : Kinyarwanda
  'ti_ET': 'ti_ET', //            : ትግርኛ (ኢትዮጵያ)
  'ff': 'ff', //               : Pulaar
  'luo': 'luo', //              : Dholuo
  'fa_AF': 'fa_AF', //            : فارسی (افغانستان)
  'nl_CW': 'nl_CW', //            : Nederlands (Curaçao)
  'es_MQ': 'es_MQ', //            : español (Martinica)
  'en_HR': 'en_HR', //            : English (Croatia)
  'en_FJ': 'en_FJ', //            : English (Fiji)
  'fi': 'fi', //               : suomi
  'pt_MO': 'pt_MO', //            : português (Macau [China])
  'be': 'be', //               : беларуская
  'en_US': 'en_US', //            : English (United States)
  'en_TO': 'en_TO', //            : English (Tonga)
  'en_SK': 'en_SK', //            : English (Slovakia)
  'bg': 'bg', //               : български
  'ru_BY': 'ru_BY', //            : русский (Беларусь)
  'it_IT': 'it_IT', //            : italiano (Italia)
  'ml_IN': 'ml_IN', //            : മലയാളം (ഇന്ത്യ)
  'gsw_CH': 'gsw_CH', //           : Schwiizertüütsch (Schwiiz)
  'qu_EC': 'qu_EC', //            : Runasimi (Ecuador)
  'fo': 'fo', //               : føroyskt
  'sv_FI': 'sv_FI', //            : svenska (Finland)
  'en_FK': 'en_FK', //            : English (Falkland Islands)
  'nus': 'nus', //              : Thok Nath
  'ta_LK': 'ta_LK', //            : தமிழ் (இலங்கை)
  'vun': 'vun', //              : Kyivunjo
  'sr_Latn': 'sr_Latn', //          : srpski (latinica)
  'es_BZ': 'es_BZ', //            : español (Belice)
  'fr': 'fr', //               : français
  'en_SL': 'en_SL', //            : English (Sierra Leone)
  'bm': 'bm', //               : bamanakan
  'es_VC': 'es_VC', //            : español (San Vicente y las Granadinas)
  'ar_BH': 'ar_BH', //            : العربية (البحرين)
  'guz': 'guz', //              : Ekegusii
  'bn': 'bn', //               : বাংলা
  'bo': 'bo', //               : བོད་སྐད་
  'ar_SY': 'ar_SY', //            : العربية (سوريا)
  'es_MS': 'es_MS', //            : español (Montserrat)
  'lo_LA': 'lo_LA', //            : ລາວ (ລາວ)
  'ne_NP': 'ne_NP', //            : नेपाली (नेपाल)
  'uz_Latn': 'uz_Latn', //          : o‘zbek (lotin)
  'be_BY': 'be_BY', //            : беларуская (Беларусь)
  'es_IC': 'es_IC', //            : español (Canarias)
  'sr_Latn_XK': 'sr_Latn_XK', //       : srpski (latinica, Kosovo)
  'ar_MA': 'ar_MA', //            : العربية (المغرب)
  'pa_Guru_IN': 'pa_Guru_IN', //       : ਪੰਜਾਬੀ (ਗੁਰਮੁਖੀ, ਭਾਰਤ)
  'br': 'br', //               : brezhoneg
  'luy': 'luy', //              : Luluhia
  'kde_TZ': 'kde_TZ', //           : Chimakonde (Tanzania)
  'es_AW': 'es_AW', //            : español (Aruba)
  'bs': 'bs', //               : bosanski
  'fy': 'fy', //               : Frysk
  'fur_IT': 'fur_IT', //           : furlan (Italie)
  'hu_HU': 'hu_HU', //            : magyar (Magyarország)
  'ar_AE': 'ar_AE', //            : العربية (الإمارات العربية المتحدة)
  'en_HU': 'en_HU', //            : English (Hungary)
  'sah_RU': 'sah_RU', //           : саха тыла (Арассыыйа)
  'zh_Hans': 'zh_Hans', //          : 中文（简体）
  'en_FM': 'en_FM', //            : English (Micronesia)
  'fr_MQ': 'fr_MQ', //            : français (Martinique)
  'ko_KP': 'ko_KP', //            : 한국어(조선민주주의인민공화국)
  'en_150': 'en_150', //           : English (Europe)
  'en_DE': 'en_DE', //            : English (Germany)
  'ce_RU': 'ce_RU', //            : нохчийн (Росси)
  'en_CA': 'en_CA', //            : English (Canada)
  'hsb_DE': 'hsb_DE', //           : hornjoserbšćina (Němska)
  'sq_AL': 'sq_AL', //            : shqip (Shqipëri)
  'en_TR': 'en_TR', //            : English (Turkey)
  'ro_MD': 'ro_MD', //            : română (Republica Moldova)
  'es_VE': 'es_VE', //            : español (Venezuela)
  'tg_TJ': 'tg_TJ', //            : тоҷикӣ (Тоҷикистон)
  'fr_WF': 'fr_WF', //            : français (Wallis-et-Futuna)
  'mt_MT': 'mt_MT', //            : Malti (Malta)
  'kab': 'kab', //              : Taqbaylit
  'nmg_CM': 'nmg_CM', //           : kwasio (Camarões)
  'ms_SG': 'ms_SG', //            : Bahasa Melayu (Singapura)
  'en_GR': 'en_GR', //            : English (Greece)
  'ru_UA': 'ru_UA', //            : русский (Украина)
  'fr_MR': 'fr_MR', //            : français (Mauritanie)
  'zh_Hans_MO': 'zh_Hans_MO', //       : 中文（简体，澳门［中国］）
  'de_IT': 'de_IT', //            : Deutsch (Italien)
  'ccp_BD': 'ccp_BD', //           : 𑄌𑄋𑄴𑄟𑄳𑄦 (𑄝𑄁𑄣𑄘𑄬𑄌𑄴)
  'ff_GN': 'ff_GN', //            : Pulaar (Gine)
  'bs_Cyrl': 'bs_Cyrl', //          : босански (ћирилица)
  'tt_RU': 'tt_RU', //            : татар (Россия)
  'nds_NL': 'nds_NL', //           : baixo-alemão (Países Baixos)
  'es_KN': 'es_KN', //            : español (San Cristóbal y Nieves)
  'sw_UG': 'sw_UG', //            : Kiswahili (Uganda)
  'yue_Hans': 'yue_Hans', //         : 粤语 (简体)
  'ko_KR': 'ko_KR', //            : 한국어(대한민국)
  'en_DG': 'en_DG', //            : English (Diego Garcia)
  'bo_IN': 'bo_IN', //            : བོད་སྐད་ (རྒྱ་གར་)
  'en_CC': 'en_CC', //            : English (Cocos [Keeling] Islands)
  'shi_Tfng_MA': 'shi_Tfng_MA', //      : ⵜⴰⵛⵍⵃⵉⵜ (Tfng, ⵍⵎⵖⵔⵉⴱ)
  'lag': 'lag', //              : Kɨlaangi
  'it_SM': 'it_SM', //            : italiano (San Marino)
  'os_RU': 'os_RU', //            : ирон (Уӕрӕсе)
  'en_TT': 'en_TT', //            : English (Trinidad & Tobago)
  'ms_Arab_MY': 'ms_Arab_MY', //       : بهاس ملايو (عرب، مليسيا)
  'sq_MK': 'sq_MK', //            : shqip (Maqedoni)
  'es_VG': 'es_VG', //            : español (Islas Vírgenes Británicas)
  'bem_ZM': 'bem_ZM', //           : Ichibemba (Zambia)
  'kde': 'kde', //              : Chimakonde
  'ar_OM': 'ar_OM', //            : العربية (عُمان)
  'kk_KZ': 'kk_KZ', //            : қазақ тілі (Қазақстан)
  'cgg': 'cgg', //              : Rukiga
  'bas': 'bas', //              : Ɓàsàa
  'kam': 'kam', //              : Kikamba
  'wae': 'wae', //              : Walser
  'es_MX': 'es_MX', //            : español (México)
  'sah': 'sah', //              : саха тыла
  'zh_Hant': 'zh_Hant', //          : 中文（繁體）
  'en_GU': 'en_GU', //            : English (Guam)
  'fr_MU': 'fr_MU', //            : français (Maurice)
  'fr_KM': 'fr_KM', //            : français (Comores)
  'ar_LB': 'ar_LB', //            : العربية (لبنان)
  'en_BA': 'en_BA', //            : English (Bosnia & Herzegovina)
  'en_TV': 'en_TV', //            : English (Tuvalu)
  'sr_Cyrl': 'sr_Cyrl', //          : српски (ћирилица)
  'mzn_IR': 'mzn_IR', //           : مازرونی (ایران)
  'es_VI': 'es_VI', //            : español (Islas Vírgenes de EE. UU.)
  'dje': 'dje', //              : Zarmaciine
  'kab_DZ': 'kab_DZ', //           : Taqbaylit (Lezzayer)
  'fil_PH': 'fil_PH', //           : Filipino (Pilipinas)
  'se_SE': 'se_SE', //            : davvisámegiella (Ruoŧŧa)
  'vai': 'vai', //              : ꕙꔤ
  'hr_HR': 'hr_HR', //            : hrvatski (Hrvatska)
  'bs_Latn_BA': 'bs_Latn_BA', //       : bosanski (latinica, Bosna i Hercegovina)
  'nl_AW': 'nl_AW', //            : Nederlands (Aruba)
  'dav': 'dav', //              : Kitaita
  'so_SO': 'so_SO', //            : Soomaali (Soomaaliya)
  'ar_PS': 'ar_PS', //            : العربية (الأراضي الفلسطينية)
  'en_FR': 'en_FR', //            : English (France)
  'uz_Cyrl': 'uz_Cyrl', //          : o‘zbek (kirill)
  'ff_SN': 'ff_SN', //            : Pulaar (Senegaal)
  'en_BB': 'en_BB', //            : English (Barbados)
  'ki_KE': 'ki_KE', //            : Gikuyu (Kenya)
  'en_TW': 'en_TW', //            : English (Taiwan)
  'naq': 'naq', //              : Khoekhoegowab
  'en_SS': 'en_SS', //            : English (South Sudan)
  'mg_MG': 'mg_MG', //            : Malagasy (Madagasikara)
  'mas_KE': 'mas_KE', //           : Maa (Kenya)
  'en_RO': 'en_RO', //            : English (Romania)
  'en_PG': 'en_PG', //            : English (Papua New Guinea)
  'mgh': 'mgh', //              : Makua
  'dyo_SN': 'dyo_SN', //           : joola (Senegal)
  'mas': 'mas', //              : Maa
  'agq': 'agq', //              : Aghem
  'bn_BD': 'bn_BD', //            : বাংলা (বাংলাদেশ)
  'haw': 'haw', //              : ʻŌlelo Hawaiʻi
  'yi': 'yi', //               : ייִדיש
  'nb_NO': 'nb_NO', //            : norsk bokmål (Norge)
  'da_DK': 'da_DK', //            : dansk (Danmark)
  'en_DK': 'en_DK', //            : English (Denmark)
  'saq': 'saq', //              : Kisampur
  'ug': 'ug', //               : ئۇيغۇرچە
  'cy_GB': 'cy_GB', //            : Cymraeg (Y Deyrnas Unedig)
  'fr_YT': 'fr_YT', //            : français (Mayotte)
  'jmc': 'jmc', //              : Kimachame
  'ses_ML': 'ses_ML', //           : Koyraboro senni (Maali)
  'en_PH': 'en_PH', //            : English (Philippines)
  'de_DE': 'de_DE', //            : Deutsch (Deutschland)
  'ar_YE': 'ar_YE', //            : العربية (اليمن)
  'es_TC': 'es_TC', //            : español (Islas Turcas y Caicos)
  'bm_ML': 'bm_ML', //            : bamanakan (Mali)
  'yo': 'yo', //               : Èdè Yorùbá
  'lkt_US': 'lkt_US', //           : Lakȟólʼiyapi (Mílahaŋska Tȟamákȟočhe)
  'uz_Arab_AF': 'uz_Arab_AF', //       : اوزبیک (عربی, افغانستان)
  'jgo': 'jgo', //              : Ndaꞌa
  'sl_SI': 'sl_SI', //            : slovenščina (Slovenija)
  'pt_LU': 'pt_LU', //            : português (Luxemburgo)
  'uk': 'uk', //               : українська
  'en_CH': 'en_CH', //            : English (Switzerland)
  'asa': 'asa', //              : Kipare
  'en_BD': 'en_BD', //            : English (Bangladesh)
  'lg_UG': 'lg_UG', //            : Luganda (Yuganda)
  'nds': 'nds', //              : baixo-alemão
  'qu_PE': 'qu_PE', //            : Runasimi (Perú)
  'mgo': 'mgo', //              : metaʼ
  'id_ID': 'id_ID', //            : Indonesia (Indonesia)
  'en_NA': 'en_NA', //            : English (Namibia)
  'en_GY': 'en_GY', //            : English (Guyana)
  'zgh': 'zgh', //              : ⵜⴰⵎⴰⵣⵉⵖⵜ
  'pt_MZ': 'pt_MZ', //            : português (Moçambique)
  'fr_LU': 'fr_LU', //            : français (Luxembourg)
  'dsb': 'dsb', //              : dolnoserbšćina
  'mas_TZ': 'mas_TZ', //           : Maa (Tansania)
  'en_DM': 'en_DM', //            : English (Dominica)
  'ta_MY': 'ta_MY', //            : தமிழ் (மலேசியா)
  'es_GD': 'es_GD', //            : español (Granada)
  'en_BE': 'en_BE', //            : English (Belgium)
  'mg': 'mg', //               : Malagasy
  'ur': 'ur', //               : اردو
  'fr_GA': 'fr_GA', //            : français (Gabon)
  'ka_GE': 'ka_GE', //            : ქართული (საქართველო)
  'nmg': 'nmg', //              : kwasio
  'en_TZ': 'en_TZ', //            : English (Tanzania)
  'eu_ES': 'eu_ES', //            : euskara (Espainia)
  'ar_DZ': 'ar_DZ', //            : العربية (الجزائر)
  'id': 'id', //               : Indonesia
  'so_DJ': 'so_DJ', //            : Soomaali (Jabuuti)
  'hsb': 'hsb', //              : hornjoserbšćina
  'yav': 'yav', //              : nuasue
  'mk': 'mk', //               : македонски
  'pa_Arab_PK': 'pa_Arab_PK', //       : پنجابی (عربی, پاکستان)
  'ml': 'ml', //               : മലയാളം
  'en_ER': 'en_ER', //            : English (Eritrea)
  'ig': 'ig', //               : Igbo
  'se_FI': 'se_FI', //            : davvisámegiella (Suopma)
  'mn': 'mn', //               : монгол
  'ksb': 'ksb', //              : Kishambaa
  'uz': 'uz', //               : o‘zbek
  'vi_VN': 'vi_VN', //            : Tiếng Việt (Việt Nam)
  'ii': 'ii', //               : ꆈꌠꉙ
  'qu': 'qu', //               : Runasimi
  'en_PK': 'en_PK', //            : English (Pakistan)
  'ee': 'ee', //               : Eʋegbe
  'ast_ES': 'ast_ES', //           : asturianu (España)
  'yue_Hant': 'yue_Hant', //         : 粵語 (繁體)
  'mr': 'mr', //               : मराठी
  'ms': 'ms', //               : Bahasa Melayu
  'en_ES': 'en_ES', //            : English (Spain)
  'ha_GH': 'ha_GH', //            : Hausa (Gana)
  'it_CH': 'it_CH', //            : italiano (Svizzera)
  'sq_XK': 'sq_XK', //            : shqip (Kosovë)
  'mt': 'mt', //               : Malti
  'en_CK': 'en_CK', //            : English (Cook Islands)
  'br_FR': 'br_FR', //            : brezhoneg (Frañs)
  'en_BG': 'en_BG', //            : English (Bulgaria)
  'es_GF': 'es_GF', //            : español (Guayana Francesa)
  'tk_TM': 'tk_TM', //            : Türkmen dili (Türkmenistan)
  'sr_Cyrl_XK': 'sr_Cyrl_XK', //       : српски (ћирилица, Косово)
  'ksf': 'ksf', //              : rikpa
  'en_SX': 'en_SX', //            : English (Sint Maarten)
  'bg_BG': 'bg_BG', //            : български (България)
  'en_PL': 'en_PL', //            : English (Poland)
  'af': 'af', //               : Afrikaans
  'el': 'el', //               : Ελληνικά
  'cs_CZ': 'cs_CZ', //            : čeština (Česko)
  'fr_TD': 'fr_TD', //            : français (Tchad)
  'zh_Hans_HK': 'zh_Hans_HK', //       : 中文（简体，香港［中国］）
  'is': 'is', //               : íslenska
  'ksh': 'ksh', //              : Kölsch
  'my': 'my', //               : မြန်မာ
  'mn_MN': 'mn_MN', //            : монгол (Монгол)
  'it': 'it', //               : italiano
  'dsb_DE': 'dsb_DE', //           : dolnoserbšćina (Nimska)
  'ii_CN': 'ii_CN', //            : ꆈꌠꉙ (ꍏꇩ)
  'eo': 'eo', //               : esperanto
  'iu': 'iu', //               : ᐃᓄᒃᑎᑐᑦ
  'en_ZA': 'en_ZA', //            : English (South Africa)
  'smn': 'smn', //              : anarâškielâ
  'en_AD': 'en_AD', //            : English (Andorra)
  'ak': 'ak', //               : Akan
  'en_RU': 'en_RU', //            : English (Russia)
  'kkj_CM': 'kkj_CM', //           : kakɔ (Kamɛrun)
  'am': 'am', //               : አማርኛ
  'es': 'es', //               : español
  'et': 'et', //               : eesti
  'uk_UA': 'uk_UA' //            : українська (Україна)

};var alreadyConfLang = {
  'cn': 'cn',
  'zh-tw': 'zh-tw',
  'en': 'en'
};


// EXTERNAL MODULE: ./node_modules/vux/src/plugins/ajax/index.js
var plugins_ajax = __webpack_require__("yD8N");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/bus/index.js
var bus = __webpack_require__("Sga9");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/config/index.js
var plugins_config = __webpack_require__("bSmc");

// CONCATENATED MODULE: ./src/main.js



















var dateTimeFormats = {
  'en-US': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  'ja-JP': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  }
};
var pathUrl = location.href.match(/(\w+)=(\w+)(-\w+)?/g);
var pathObj = {};
for (var main_i = 0; main_i < pathUrl.length; main_i++) {
  var pathItem = pathUrl[main_i].split('=');
  pathObj[pathItem[0]] = pathItem[1] || '';
}

var main_get = function get(language) {

  if (lodash_default.a.isNil(language) || !lodash_default.a.isString(language)) {
    console.log('illegal language: ' + language);
    return locales.zh;
  }

  language = language.toLowerCase();

  var locale = locales[language];
  if (locale) return locale;

  console.log(language.split('_')[0]);
  locale = locales[language.split('_')[0]];
  if (locale) return locale;else return locales.en;
};

var locales = {

  'zh': 'zhHans',
  'zh-hans': 'zhHans',
  'zh-hant': 'zhHant',
  'en': 'en',
  'pt': 'pt',
  'it': 'it',
  'ja': 'ja',

  'zh_hk': 'zhHant',
  'zh_tw': 'zhHant',
  'zh-hk': 'zhHant',
  'zh-tw': 'zhHant'
};

var main_locale = main_get(pathObj.language);
console.log(main_locale);

if (main_get(pathObj.language) === 'zhHans') {
  document.title = '体态报告';
} else if (main_get(pathObj.language) === 'zhHant') {
  document.title = '體態報告';
} else {
  document.title = 'Posture Report';
}

vue_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);
var i18n = new vue_i18n_esm["a" /* default */]({
  dateTimeFormats: dateTimeFormats,
  locale: main_locale,
  fallbackLocale: 'cn'
});


vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);
vue_esm["a" /* default */].use(plugins_ajax["a" /* default */]);
vue_esm["a" /* default */].use(bus["a" /* default */]);
/*
console.log('mock',process.env.NODE_ENV)
if(process.env.NODE_ENV == 'development') {
require('../test/mock/posture')
} */





var store = new vuex_esm["a" /* default */].Store({});

store.registerModule('vux', {

  state: {
    direction: 'forward',
    url: '',
    cur_index: 0,
    riskData: [{
      'position': 'head',
      'code': 2,
      'name': '头部前倾',
      'points': [{
        'x': 41.2926,
        'y': 17.8695
      }, {
        'x': 53.8244,
        'y': 18.2612
      }],
      'value': 35.82379560330111,
      'level': 'mild',
      'description': '有头部侧倾风险（左倾）',
      'valid': true
    }, {
      'position': 'shoulder',
      'code': 1,
      'name': '高低肩',
      'points': [{
        'x': 36.4531,
        'y': 35.6373
      }, {
        'x': 59.8613,
        'y': 34.8457
      }],
      'value': 29.378276641894587,
      'level': 'severe',
      'description': '有高低肩风险（左高右低）',
      'valid': true
    }],
    reportData: null,
    locale: main_locale
  },
  getters: {
    title: function title(state) {
      console.log('state:', state.title);
      return state.title;
    },
    getUrl: function getUrl(state) {
      return state.url;
    }

  },

  mutations: {
    updateDirection: function updateDirection(state, payload) {
      state.direction = payload.direction;
    },
    updateUrl: function updateUrl(state, url) {
      console.log({ url: url });
      state.url = url;
    },
    updateReportData: function updateReportData(state, payload) {
      state.reportData = payload.reportData;
    }
  },

  actions: {
    get: function get(context, config) {
      config.http = vue_esm["a" /* default */].http;
      ajax.get(config);
    },
    post: function post(context, config) {
      config.http = vue_esm["a" /* default */].http;
      ajax.post(config);
    },
    delete: function _delete(context, config) {
      config.http = vue_esm["a" /* default */].http;
      ajax.delete(config);
    },
    patch: function patch(context, config) {
      config.http = vue_esm["a" /* default */].http;
      ajax.patch(config);
    }
  }
});

vue_esm["a" /* default */].use(plugins_config["a" /* default */], {
  $layout: 'VIEW_BOX'
});

var isPhone = true;
if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  isPhone = true;
} else {
  isPhone = false;
}

var routes = [{
  path: '/home',
  component: src_components_Home
}, {
  path: '/world',
  component: src_components_HelloWorld
}, {
  path: '/riskDetail',
  component: src_components_RiskDetail
}, {
  path: '/face',
  component: src_components_Face
}, {
  path: '/',
  component: isPhone ? src_components_Posture : src_components_Posture_ipad
}, {
  path: '/fascial',
  component: src_components_HelloWorld
}, {
  path: '/error',
  component: src_components_Wechat_error
}];

var router = new vue_router_esm["a" /* default */]({
  routes: routes
});

var main_history = window.sessionStorage;
main_history.clear();
var historyCount = main_history.getItem('count') * 1 || 0;
main_history.setItem('/', 0);

router.beforeEach(function (to, from, next) {

  var toIndex = main_history.getItem(to.path);
  var fromIndex = main_history.getItem(from.path);

  if (toIndex) {
    if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || toIndex === fromIndex) {
      store.commit('updateDirection', { direction: 'forward' });
    } else {
      store.commit('updateDirection', { direction: 'reverse' });
    }
  } else {
    ++historyCount;
    main_history.setItem('count', historyCount);
    to.path !== '/' && main_history.setItem(to.path, historyCount);
    store.commit('updateDirection', { direction: 'forward' });
  }

  if (/\/http/.test(to.fullPath)) {
    var url = to.fullPath.split('http')[1];
    window.location.href = 'http' + url;
  } else {
    next();
  }
});

router.afterEach(function (to) {});

fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  i18n: i18n,
  store: store,
  router: router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "Njoo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/faceBone.63cd146.png";

/***/ }),

/***/ "OHj7":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("LYyO");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("10e48a85", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2b56ebd0\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_symp.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2b56ebd0\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_symp.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Oa+j":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQgAAABYCAQAAACjBqE3AAAB6klEQVR4Ae3bsWpUQRTG8YkkanwCa7GzVotsI/gEgk9h4Vu4ySLYmMYgbJrc3lrwZbJwC0FMt4j7F6Y4oIZrsXtgxvx/1c0ufEX4cnbmLCmSJEmSJEmSJEmSJP3XCBPvbJU+8doWmDFwyZpLBmYlNJebz0KwzykwsuSYJSNwykEJreV2BaBMaLIQZ2xYcFgqDlmw4ayE/FwL0dDk4Qh4W37DAjgqIT+3HRbigjH+iikVdxgZStgyN0Su2sXIeTwTT+esdpcbIlfNAuZ/TxresG4zV8kYWSZNiKUTokMMSWeIwTNEn4fK2TW3gRNgVkJLuVksROA9G+bEvoATNlBCa7nZXEwdxEZxzpKRKFh+bsv8LmPFmhX1OwfIz81jIRJQ5eeqG9B+riRJkiRJkiRJkiRJkiRJkiRJUkvA/8RQoEpKlJWINFkJ62AlrEP/mNBibnv2yz/A3t7Uq3LcpoxP8COjC1T5vxoAD5VdoEqdDrd5QuW1swtUSaueh3zkiuBiqgtA2OlkeMcP/uDqugsJdbjHF65VdPMKwS0+WQc/MgKvrIOHysB9vgPwk8+85hmPbnQdvHZyDMAFD7L3EOpgMcVdvnHFS0/vlatrXvCVx0U9gt3fxvnA0/hB4nmRJEmSJEmSJEmSJGmHfgFLaDPoMu5xWwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "Ocay":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/sideBone.4bd2ac1.png";

/***/ }),

/***/ "On8B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  DEFAULT_AVATAR: __webpack_require__("SxbP"),
  risk_normal: {
    HEAD_LEAN: __webpack_require__("yujV"),

    HEAD_SIDESWAY_LEFT: __webpack_require__("WxYu"),
    HEAD_SIDESWAY_RIGHT: __webpack_require__("REHF"),
    HEAD_SIDESWAY_NORMAL: __webpack_require__("uSsQ"),

    HIGH_LOW_SHOULDER_LEFT: __webpack_require__("1V3F"),
    HIGH_LOW_SHOULDER_RIGHT: __webpack_require__("UJZ8"),
    HIGH_LOW_SHOULDER_NORMAL: __webpack_require__("v8CS"),

    ROUND_SHOULDER: __webpack_require__("vZf5"),

    SPINE_SIDESWAY_LEFT: __webpack_require__("xHUF"),
    SPINE_SIDESWAY_RIGHT: __webpack_require__("goN3"),
    SPINE_SIDESWAY_NORMAL: __webpack_require__("EccH"),

    PELVIS_LEAN_LEFT: __webpack_require__("9JNv"),
    PELVIS_LEAN_RIGHT: __webpack_require__("nst3"),
    PELVIS_LEAN_NORMAL: __webpack_require__("3I8+"),

    LEG_O: __webpack_require__("Pnl9"),
    LEG_X: __webpack_require__("T69A"),
    KNEE_OVERSTRETCH: __webpack_require__("D0EO"),
    LEG_XO: __webpack_require__("7+Pl")
  },
  risk_abnormal: {
    HEAD_LEAN: __webpack_require__("s+mH"),
    HEAD_SIDESWAY_LEFT: __webpack_require__("Mks9"),
    HEAD_SIDESWAY_RIGHT: __webpack_require__("eBau"),
    HIGH_LOW_SHOULDER_LEFT: __webpack_require__("ec1k"),
    HIGH_LOW_SHOULDER_RIGHT: __webpack_require__("ihJy"),
    ROUND_SHOULDER: __webpack_require__("bFmA"),
    SPINE_SIDESWAY_LEFT: __webpack_require__("q80A"),
    SPINE_SIDESWAY_RIGHT: __webpack_require__("y73U"),
    PELVIS_LEAN_LEFT: __webpack_require__("uV2h"),
    PELVIS_LEAN_RIGHT: __webpack_require__("9izx"),
    LEG_O: __webpack_require__("5VGa"),
    LEG_X: __webpack_require__("c+bA"),
    KNEE_OVERSTRETCH: __webpack_require__("+64+"),
    LEG_XO: __webpack_require__("Oy1c")
  },
  RISK_ICON: __webpack_require__("kiVC"),
  RISKBAR_ICON: __webpack_require__("IIld"),
  riskbar_arrow: {
    low: __webpack_require__("yCic"),
    middle: __webpack_require__("Ty3t"),
    high: __webpack_require__("smaB")
  },
  bone: {
    face: __webpack_require__("GkfD"),
    side: __webpack_require__("YRIN"),
    faceBone: __webpack_require__("Njoo"),
    sideBone: __webpack_require__("Ocay"),
    backBone: __webpack_require__("wyWN"),
    boneCanvas: __webpack_require__("W9R/")
  }
};

/***/ }),

/***/ "Oy1c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/leg_xo.e41a82a.png";

/***/ }),

/***/ "Pnl9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/leg_o_normal.23569fa.png";

/***/ }),

/***/ "Q3KF":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "RDnu":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAABbCAYAAAAcNvmZAAAACXBIWXMAACE3AAAhNwEzWJ96AAAFLklEQVR4nO2d7XHiSBCGH6j9v9oIzEawvggsR7BsBJ7LgItg2QgOR3AQwUEEJzLAERyO4FAEcz9aMl8ChJgZqYWeKpVdZZgRL62enp6ecc9aS0cYPtV9Ax6JgCEQAwPg6eDvS2ANJMAc2Pi+oV4LLTsCJojQn0u+J0UEH+FR9L6vhmtihFjrC+WFJnvtS/bekfO7ymiLZUfAFPjuqL0ZHqy8DWJHiN/95rjdN8TfOxO8DW5kgnuhydqcuGxQu9gjxNf64gWHPlyzGxkAK64bCKuQZn3d7E40W/YY/0KT9eHEnWi17AgJ00KIDY6sW6tlXzNhccHnrM+b0Cp2rLFPrWI/auxTq8+u66Z7t7xZq2WrpBM7IJ3YAdEq9pvGPrWKvdLYp1axE419ag39IuC/wH1+4U6n6xtkNSUUMxxk/bRaNkhi6N8A/aTI7HF9a0NaLRvkw/8K0M8YB0KDbsvOSTiuCXHFAgfZvpw2iB0hYdmD43a7Bd8ChrgXeoFjoUG/2Ab4y3Gbv5Av0HlllOZaP4NboWc4HAyL0Cq24bLQfyDWOURCt0NX8474+jldYeVJDJeF/h0pR2sU2ny2QanQoEtsg2KhQY/YBuVCgw6xDS0QGpovtqElQkOzxTa0SGhortiGlgkNzRTb0EKhoXliG1oqNLiZrsfZFXFcD7dBpsRrJO+8PtOOocVCA2CtrXIZa+3cXs/aWjux1g4K2ruEqXivjbmqiLwuIUwZplZEvwuhrbWlE1Ex8vi6TtKXQbfr2KHMADkG/qET+mbODZD5HnCfW9/O0Sqh4bTYvnbNlqV1QsNpN+Jr12wZUuopnPROkdhj6nMdIDuzEuTpahWH0UiMDIZNYEk9u8K8cWjZTjfG38gTMqtsDbuWbXBfg3Er70gBZSvYtexxXTdxhgdaZN252D5KuFzh7Rih0OyK3VS+Uc+OXudoEBtaEpX0kQ8S8oSDKjTdGErRR8cjquEeL9JHx0yt6U9eKT6hxx/G1LP/MWZ/yS85+FkarSXDPomQ2N5QnIz7ufP7Aik3npZpuGmr63USsS2G/5NyWc/vyKx7TYnJVye28IikdX9SbXx4QERPODMG9vG4rcExa0/tGkQkFzPoJ+Q+C6MnTWL7iJqGiEW6jHbyfPyR4D1r7RD422FnvnlDDGTFtvBnXaGdx+z9vsLKo32UPWttHScc+GDJtvpqlV3nNiWt8L/098pOIi3PZ4fouA7e2S99y78EQ7jc/des7w+xR0i40+GeGVlYmIvdFlfSVL4AmzzODn1YyjUs674BBwzheFksreVWTjNDRvQe8BvwA9lbvkD8sRZiOC5lGLM/96+Tsscox9nrHneupmUJl0BcVMXalMjkB5LkqUKepYuRL2KAvwNgyvAODIrEHhDmePtz7MWnDjHUV67RO1Wf7Xt2dY6PUMkDdUVdKRCdyvqtkEcw9IDpU2gIcMzFCVZwPsWaCx5q1H8lTEFOHVHMBi7ns1eIS1l4vJEUGQxDFeMkgfo56rPM4kF+Gs0z7q3iFRmQq0YdVUgC9pUzh2on6ZjsqhpKpcia3YR6cumh/+3KR+nzLccWDdj+c8uiM5gOO8zzzyGt+BRjwk3ensmeJtdnRA3YL/G9lFOui1DWvVfQr/FALlf4XqE6OjD3nlfX5/g9ONdwMCbds2XnTHG/Yatwa2EntmBwkzNJEfeUFP3xnt3ILlMkX37LQsUMCQ6SUy/oxN6SpyeeKT9jThGRvyJPx9nIq3Mjp9nNicO2BmS18zO5psH/AZv2qbXWzevlAAAAAElFTkSuQmCC"

/***/ }),

/***/ "REHF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/head_sideway_right.2901530.png";

/***/ }),

/***/ "RtGo":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "S015":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "SQkG":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAABMCAYAAAD5sj5lAAAACXBIWXMAABYlAAAWJQFJUiTwAAAB+0lEQVRogdXa223bQBAF0GM2kJSQDhJgG1AnUTpICSnBHYTpICW4AQJxJ+7A+ZBlQxIl8bGP4f0kOMABQewCu/fh9fXVWIZh+IZf2KeUXkZfapSHMfQb+Amf8IxdJHh3/uAMDF/xNAzD54qumzlBj4CPCQV/R98AHxMG3jEJfEwIeDcDfExzeIcvpoOPaQrvUkp/8WPBbDN4Byml3obg76vHluAn6/RW4Bc74hbgF2jiw0fRxIZfRRMXfhNNTPhdNPHgk9DEgk9GEwc+C00M+Gw07eGL0LSFL0bTDr4KTRv4ajT14VnQ1IVnQ1MPnhVNHXh2NOXhRdCUhRdDUw5eFE0ZeHE0+eFV0OSFV0OTDz56fVE6wzDs8XvB6DN2TdCsg1f9Pc6yWzj3rwl6GIYe3xeM/kkp7auj14KpvHrkAFMRnQtMJXROMBXQucEURpcAUxBdCkwhdEkwBdClwWRG1wCTEV0LTCZ0TTAZ0LXBrES3ALMC3QrMQnRLMAvQrcHMREcAMwMdBcxEdCQwE9DRwNxBRwRzAx0VzBV0ZDDjrd5eYDCXrd5ecDCnrd7eBsB8tHp7GwFzaPX+tCEwhy/dOxxWz0kzMIdW74vDWfFUeFMwH63eqfDmYE5bvffgIcBctnqvwcOAGW/1nsNDgblxJfd2Z7dPKT3WJd3Pf0E0h9L/gGYnAAAAAElFTkSuQmCC"

/***/ }),

/***/ "SxbP":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "SzS9":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\np {\n  margin: 0;\n  padding: 0;\n}\n#routerView .swiper-slide {\n  overflow: auto !important;\n}\n@media screen and (min-width: 415px) {\n.key-box {\n    font-size: 0.8rem;\n}\n.font-18 {\n    font-size: 0.8rem;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "T1Sm":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAnCAYAAAD3h5P5AAACZElEQVRYhe3YTahOQRgH8N973pdLhFd0F6JIIl9ZKcpHyudaKVvfKWUnSVlYivLtrpWFnZTvSFk45ZtslB2SRDdcuSxmzjX3dLl6j3sp/nVqzn9mnv+ZmfM888zU8jxXwkxsxApMRlvkT2N9LG/F0VK/bTgWy+ewBp/wDBfRgYdphywpD8Vh3McOTE+EW0UbZkR793Acw4vKRiJ8Hssqiv0MGTZjGlaiqxj5wQEWTrE06skwC5t+oVMzKbf3Uz+6H1ubMKuBDaj/gvhK7MMrYQ3L2Im3mIiF/diqY0Mtz/Mnws812HicYcofEIZJmfCn/wmMzPpvM3D4L/7viTf64A7gMvZifuS+CEHkFrpb0BmCtdFGD2p5nn9N3t9gHL5iOS5E/qrqsb+G1xhbEOVpH4MFseGqhJ+NSRXFF0T7PShPe4ab6MSIhB8vJAXvKog3y0Rfa64kXKDel4Eq+O9qKT4Le/aEEt+JlxW0Jgou90PxL4Jv38F+7Ir8C8yNH9Uq5uG2JHEpT/s73I3lGwn/tKIwIXvt5S3lkTdxSsizdyf8IuwRIlwrqAsRrpe3lCPcoOLfdbW/zs+vx2ez3oeDM4ILtoKakPcv/pn4+9joo+AaZyN/G+taFC5wUAhSowoiQ1fSYKjv7pCOuql6it3EsOS9syFslcWJpU2Y2gdYkjScikdan/a6cIRKB/C8IWQr6XGpXd8Hwanx+V24lAk3Bq3kZVXQjY5MuKo4OcjiJ/Gw8PMduDJIwteiXk+Q6cJqHDFwS9CNE8JFUVcqXnzAdszBIWEb/VxRsFPwkkNCPrAFH4rKb3g3dC/v0+DFAAAAAElFTkSuQmCC"

/***/ }),

/***/ "T69A":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/leg_x_normal.139efd0.png";

/***/ }),

/***/ "Tki4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Ty3t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/middle.c886eb4.png";

/***/ }),

/***/ "UJZ8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/high_low_shoulder_right.2a5de87.png";

/***/ }),

/***/ "VEhD":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\nh1[data-v-469af010], h2[data-v-469af010] {\n  font-weight: normal;\n}\nul[data-v-469af010] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-469af010] {\n  display: inline-block;\n  margin: 0 10px;\n}\na[data-v-469af010] {\n  color: #42b983;\n}\n", ""]);

// exports


/***/ }),

/***/ "W9R/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/boneCanvas.5e01079.png";

/***/ }),

/***/ "WW73":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Mtz3");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("32646664", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js?{\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-19226772\",\"scoped\":false,\"hasInlineConfig\":false}!./photoswipe.css", function() {
     var newContent = require("!!../../css-loader/index.js?{\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-19226772\",\"scoped\":false,\"hasInlineConfig\":false}!./photoswipe.css");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "WxYu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/head_sideway_left.cbed27d.png";

/***/ }),

/***/ "Xkal":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("BRSA");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("fbe3c746", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-12b7debe\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_flank.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-12b7debe\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_flank.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "YEkT":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "YRIN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/side.c55d6ae.png";

/***/ }),

/***/ "ZtK3":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n#routerView .swiper-slide {\n  overflow: auto !important;\n}\n@media screen and (min-width: 415px) {\n.key-box {\n    font-size: 0.8rem;\n}\n.font-18 {\n    font-size: 0.8rem;\n}\n}\n.level-box {\n  width: 3.3rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "aA5A":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("+Ujf");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3124ca48", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2d249289\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Symp_item.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2d249289\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Symp_item.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "bFVm":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Created by zc on 2017/10/19 0019.
 */
var _ = __webpack_require__("M4fF");
function base64ToSrc(base64, defaultImage) {
  if (base64) return 'data:image/png;base64,' + base64;else return defaultImage;
}

module.exports = {
  base64ToSrc: base64ToSrc
};

/***/ }),

/***/ "bFmA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/round_shoulder_left.7676055.png";

/***/ }),

/***/ "c+bA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/leg_x_left.6d5e8bb.png";

/***/ }),

/***/ "c8Po":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Lltw");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5ac15a36", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-071df230\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RiskDetail.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-071df230\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RiskDetail.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "cgc+":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.bone-desc {\n  position: absolute;\n  text-align: center;\n  background: #f7f1efb8;\n  width: auto;\n  height: 40px;\n  right: 0;\n  z-index: 100;\n  padding: 5px 15px 5px 10px;\n  opacity: 1;\n  /*//background: url(\"../assets/images/posture/bone/boneDesc.png\") no-repeat;*/\n  background-size: 7.125rem 1.72rem;\n  margin-bottom: -1rem;\n  border-radius: 4px;\n  border-right: none;\n}\n.radiodot {\n  width: 6px;\n  height: 6px;\n  display: inline-block;\n  background: #000;\n  border-radius: 6px;\n}\n.p1 .radiodot {\n  background: #ff8a80;\n}\n.p2 .radiodot {\n  background: #b2ad8f;\n}\n.p1,\n.p2 {\n  width: 100%;\n  font-size: 12px;\n  /*position: absolute;*/\n  line-height: 12px;\n  text-align: center;\n}\n.p1 {\n  color: #ff5330;\n  z-index: 1000;\n}\n.p2 {\n  color: #a4a45a;\n  z-index: 1000;\n  padding-top: 5px;\n}\n.tab-content {\n  height: 100%;\n  background: url(" + escape(__webpack_require__("kufR")) + ") no-repeat\n    center center / 100% 100%;\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  border-bottom: 3px solid rgb(102, 204, 255);\n  color: rgb(102, 204, 255);\n  background-color: #fff;\n  border-radius: 0;\n  width: 2.8rem;\n  /*font-weight: 600;*/\n}\n.nav-pills .nav-link {\n  color: #999;\n  /*font-weight: 500;*/\n  font-size: 0.9rem;\n  text-align: center;\n  line-height: 0.6rem;\n  height: 1.75rem;\n  /*padding: 0;*/\n  width: 2.8rem;\n  padding-left: 0;\n  padding-right: 0;\n  margin-left: 1rem;\n}\n.swiper-slide {\n  overflow: hidden;\n}\n#routerView .swiper-slide {\n  overflow: hidden !important;\n}\n.bone_front {\n  text-align: right;\n}\n.bone_back {\n  text-align: left;\n}\n@media screen and (min-width: 1025px) /*and (max-width: 1024px) */ {\n.pc_marginTop {\n}\n}\n@media screen and (max-width: 414px) /*and (max-width: 1024px) */ {\n.pc_marginTop {\n}\n}\n.body_normal {\n  border: 1px solid #cccccc59;\n  position: absolute;\n  background: rgba(255, 255, 255, 0.7);\n  border-radius: 5px;\n  text-align: center;\n  width: 5.4rem;\n  margin-right: -4px;\n  line-height: 1.2rem;\n  /* height: 1.72rem; */\n  font-size: 13px;\n  color: rgb(102, 204, 255);\n  bottom: 10%;\n  right: 0;\n  z-index: 100;\n  opacity: 1;\n  background-size: 7.125rem 1.72rem;\n  margin-bottom: 60px;\n}\n.swiper-pagination-bullet-active .boneBar {\n  width: 1.9rem;\n  background: rgb(102, 204, 255);\n  border-radius: 0.14rem;\n}\n.boneBar0 {\n  position: absolute;\n  right: -2px;\n  bottom: 0px;\n}\n.bone1 {\n  width: 217px;\n}\n.boneBar1,\n.boneBar2 {\n  bottom: 0;\n  position: absolute;\n}\n.boneBar {\n}\n@media (min-width: 400px) {\n.boneBar {\n    display: none;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "dc5P":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "eBau":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/head_sideway_right.e5601a4.png";

/***/ }),

/***/ "ePlP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/wechatShare.767acb1.png";

/***/ }),

/***/ "ec1k":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/high_low_shoulder_left.9311356.png";

/***/ }),

/***/ "flp1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/badge.3c72576.png";

/***/ }),

/***/ "g3Gj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "go2v":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("jbP4");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7814f956", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-768f2d14\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_modal.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-768f2d14\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_modal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "goN3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/spine_sideway_right.21a4c97.png";

/***/ }),

/***/ "h4Mb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Lexk");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5fb60e9d", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-480276c8\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-480276c8\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "i0z+":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("/GUz");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("396e9a20", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8dc7cce2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Home.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8dc7cce2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Home.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "iI4W":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("qMKa");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("773f34b0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vux-loader/src/after-less-loader.js!../node_modules/less-loader/index.js?{\"sourceMap\":false}!../node_modules/vux-loader/src/style-loader.js!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vux-loader/src/after-less-loader.js!../node_modules/less-loader/index.js?{\"sourceMap\":false}!../node_modules/vux-loader/src/style-loader.js!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "iT//":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/cooperation-logo.593817a.png";

/***/ }),

/***/ "iXBp":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\np {\n  padding: 0;\n  margin: 0;\n}\n#langune {\n  /* display: none; */\n}\n.imgBorder {\n  /* border:1px solid red; */\n  padding: 5px 10px;\n  background: #fff;\n  border-radius: 10px;\n}\n.sennoTitle {\n  color: #fff;\n}\n@media screen and (max-width: 415px) {\n.margin-top-100 {\n    margin-top: 9.5rem;\n}\n.margin-bottom-60 {\n    margin-bottom: 2rem;\n}\n.sennoTitle {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: flex;\n    margin-top: 10px;\n    font-size: 14px;\n    height: 45px;\n    line-height: 45px;\n}\n.senno-logo {\n    width: 120px;\n\n    margin-left: 10px;\n    height: 30px;\n}\n.padding_left {\n    padding-left: 1.5rem;\n}\n.font-18 {\n    font-size: 0.9rem;\n}\n#langune {\n    display: block;\n    /*border:1px solid red;*/\n    position: relative;\n    position: absolute;\n    top: 0;\n    right: 10px;\n}\n#langune a {\n    cursor: pointer;\n    padding: 10px;\n    color: #fff;\n    text-decoration: none;\n}\n#langune .enlangune,\n  #langune .cnlangune {\n    display: block;\n    /*border:1px solid red;*/\n    display: inline-block;\n    font-size: 13px;\n    color: #fff;\n}\n}\n/* ipad and pc 适配 */\n@media screen and (min-width: 415px) {\n.sennoTitle {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: flex;\n    margin-top: 10px;\n    font-size: 14px;\n    height: 45px;\n    line-height: 45px;\n}\n.senno-logo {\n    width: 120px;\n\n    margin-left: 10px;\n    height: 30px;\n}\n.margin-bottom-80 {\n    margin-bottom: 4rem;\n}\n.margin-top-80 {\n    margin-top: 4rem;\n}\n.padding_left {\n    padding-left: 4rem !important;\n}\n.font-18 {\n    font-size: 1.8rem;\n    line-height: 4rem !important;\n}\n.margin_left {\n    margin-left: 60% !important;\n}\n.marginBottom_left {\n    margin-left: 40% !important;\n}\n.big_font {\n    font-size: 2rem;\n    white-space: nowrap;\n}\n.center_font {\n    font-size: 1.8rem;\n}\n.small_font {\n    font-size: 1.1rem;\n}\n#ul_list span {\n    line-height: 2rem !important;\n}\n#langune {\n    display: block;\n    position: absolute;\n    top: 60px;\n    right: 10px;\n}\n#langune a {\n    cursor: pointer;\n    padding: 10px;\n    color: #fff;\n    text-decoration: none;\n}\n#langune .enlangune,\n  #langune .cnlangune {\n    display: block;\n    /*border:1px solid red;*/\n    display: inline-block;\n    font-size: 24px;\n    color: #fff;\n}\n}\n@media screen and (min-width: 415px) and (max-width: 1024px) {\n.companyLogo {\n    width: 190px;\n    height: 50px;\n}\n.postureS-swiper-pagination {\n    margin-left: 28%;\n}\n.contentalignstart {\n    -webkit-transform: scale(1.5);\n            transform: scale(1.5);\n    left: 15vw;\n    position: absolute;\n    top: 19vh;\n    /* border: 1px solid red; */\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: start;\n    -webkit-justify-content: flex-start;\n            justify-content: flex-start;\n}\n}\n.mt300 {\n  margin-top: 15vh;\n}\n@media screen and (min-width: 1025px) {\n.postureS-swiper-pagination {\n    margin-left: 30%;\n}\n.bone_back,\n  .bone_front {\n    -webkit-box-align: center !important;\n    -webkit-align-items: center !important;\n    align-items: center !important;\n}\n.postureS-swiper-pagination {\n    margin-left: 28%;\n}\n.companyLogo {\n    width: 190px;\n    height: 50px;\n}\n.postureS-swiper-pagination {\n    margin-left: 28%;\n}\n.contentalignstart {\n    -webkit-transform: scale(1.5);\n            transform: scale(1.5);\n    left: 15vw;\n    position: absolute;\n    top: 20vh;\n    /* border: 1px solid red; */\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: start;\n    -webkit-justify-content: flex-start;\n            justify-content: flex-start;\n}\n.mt300 {\n    margin-top: 15vh;\n}\n}\n.cover-btn {\n  position: absolute;\n  right: 2rem;\n  bottom: 2rem;\n  min-width: 16vw;\n  height: 2.5rem;\n  font-size: 20px;\n  color: #fff;\n  text-align: center;\n  border-radius: 5px;\n  border: 1px solid none;\n  font-family: Georgia;\n  filter: Alpha(opacity=30);\n  background: #fff3;\n  line-height: 2.5rem;\n  overflow: hidden;\ntext-overflow: ellipsis;\n  text-align: center;\n  /* background: url('../assets/images/posture/cover-arrow.png') no-repeat center center / 100% 100%; */\n}\n.doublearrortop {\n  /* position: absolute; */\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n  margin-right: 20px;\n  /* width: 180px; */\n}\n.doublearrorbottom {\n  background: url(" + escape(__webpack_require__("GWoZ")) + ") no-repeat center center;\n  background-size: 100%;\n  display: inline-block;\n  width: 15px;\n  height: 100%;\n  position: absolute;\n  right: 10px;\n}\n@media screen and (max-width: 415px) {\n.companyLogo {\n    width: 190px;\n    height: 50px;\n}\n.contentalignstart {\n    left: 50px;\n    position: absolute;\n    top: 50px;\n    /* border: 1px solid red; */\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: start;\n    -webkit-justify-content: flex-start;\n            justify-content: flex-start;\n}\n.mt300 {\n    margin-top: 45vh;\n}\n}\n.sennoTitleActive {\n  top: 15vh;\n}\n", ""]);

// exports


/***/ }),

/***/ "ihJy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/high_low_shoulder_right.aa267a2.png";

/***/ }),

/***/ "ilpK":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("po/e");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("03e4f51a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2b4fd451\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_ipad.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2b4fd451\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_ipad.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "itYS":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("SzS9");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("c66a1e66", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-756c5e63\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_modal_ipad.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-756c5e63\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_modal_ipad.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "jbP4":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n@media screen and (min-width: 415px) {\n}\n", ""]);

// exports


/***/ }),

/***/ "k+JE":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("y8Tp");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1d3148c6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-189be7e6\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Face.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-189be7e6\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Face.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "kRl4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAvCAYAAAAb1BGUAAAEhElEQVRYha2YO2xcRRSGv7337sv2sn4tDgI5Eg6yeEkWBDdWJJIGySKFEeZRhhIkngVFROcmUCFBATREAhoIoqBBCERBGQmqRGBIFCkCrODnYq93vbummBnvmdmZu7uBX1rNnJlzzj9n5szMnc28efmQAVEBXgGeBo4DN4AvgHeBW4M4igbQzQAvAteA88AsUNDled3+ktb7X8lHUNG9r+shnfeASyk6A5OPAd8BT/XjEFjS+uP/lbwMfA/M90lsMK8HUL5d8gT4EpgbkNhgTtsnt0N+ATgT6sxGcHZalSk4A7w9KPmTwGtpXh+rwEIF5iup5ACvAmf7JR8HPqLHlnl4VJUPjfYkzwAf4klAH/kF4FiatzgD08OqfnxYyT1wTPtNJZ8DzvXyVCl2CKOMkvvACzjJ65KvAHEvL3cW0uUAIu3fS/4osNiPl9FcupyCReARH/nL9Hkuj+XS5RRkUJeSRT4GLPu07yvDhDOtpWy6PFFQdgEsa74j8mXAmzaLd8OpKbttxDmzXPJTU8ougKLmOyJf8mkNZ+GuIpwoOe0O+ZCToidKym7YGZTAkiEfAk77NKb0XEzkIScICg6ZlHOx0pf2HpwGhiLgJJD3aYzrRMpgZ3TO2aBSHs11sjZlF+SBkxGwENKQazki6nkncilLvXJ42gEWIuCBUO8dHkehW8y0S0I3ER3cHwEzoV5pbJIsCpwEpl0mYw/ymQiYNlIS2Ykl17IY/CSwIfWkfS5W/gXuiRBX3b0lmBWHg5xiE3AocnPRyG5JPltW/gXKEeJwmSxARZxm8qo0SRVacxOVTD450Mm88i9gn1WlxN6zvsh7IRR5KQu5lqUaJ0ANHX0xgXyPyOotf39DtyeBURbjriWrR0DDSBHhNW22/e0G5tHVDLy+okzXx8N+BOwYKRfbUy2jbPX5pJPk0j7r7CSgGgHbRmq0bRLJd9C2yy7Stl269s228i+wFQFrUluS73sibx92z4Jsk5HXhH3bHQ2sJcBNI+05yVQXI5WODtoQiymUEckBu+1Ost5MgOtH5E0VhcHOQadeFfX9lr0lJaHUk/a7zS7y6wlwxUgbdTspqgHy3aZ9Xe4FyGV9vd7ZjhpXE+BnI12r2qdaKHJ3eXabfj1pv7rdlSs/JcAq6u+Myl7T6mR9X5WtQ9is+8lcebOu9ONMx94dlOZbNbv6WzxYqylHf9bsXNhq2HpSbh/CH9purebz2uEz5F/5NA7a8FsVrmzb7S75piNf3YbVavhMMHzmYvka+BuYdLUu3bCzGVRiWuSO/ONa90emwJbmO4q8hnoWd2Gn0ZWl/FVLlxstZRfAB5rPOuvfATaCJs6A/tFJtttMJXKxgXgqS/JN4PV+vfyqr6NfdtL1HLyhebrIAS7qX09cXrfLPnAR+Fg2ZDx/f8bAZ8AzvbxVinArvJ0kPgeeB6zs8X23tIDngLcQHxo+9EHc0H6edYlD5KAuvxXgQeAToB7QC6EOfKrtV3AvUw3ftPswCTwBPI564cygHpgloArsAb+jLqkfgG9Q50Yq/gXHM0mTBwCL/AAAAABJRU5ErkJggg=="

/***/ }),

/***/ "kWoR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/cover-bg.6cc1e8b.png";

/***/ }),

/***/ "kiVC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/risk-icon.347b20d.png";

/***/ }),

/***/ "kufR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/boneBackground.503aad0.png";

/***/ }),

/***/ "l4Vc":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "l7Ol":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAvCAYAAADw46qXAAABB0lEQVRYhe3WQUrDQAAF0Gfpolo9SQXBnVirru0dRLBn0BuI9TjtBRTEjbjSE0jrWi+gCycQi45JSFzY+TCLzB/mJZAJWTm7f1ciPVzgIFxf4xxPRTdol8TusJGbGwZ8B49FNmmVAK8WsCzrGBfdpAy4X7GrDK5V7CqDtSSBCVxesIcJXsOYhLlS39Ki2cIturm5IQ7Rb+IJxwtYli4umwD3It2gCXA10nX+zVuaQJuY4i2MaZirPW1s48bXs3Pk8+dogIc6wZZfDmqdWAbuRvp+E2An0se6yuCfJoEJTGACE5jABC4LOIv0+e45su6l6LoWRph/U85Dl+X0h5ub4Th3PYqsO/kAyTMmFLawe1kAAAAASUVORK5CYII="

/***/ }),

/***/ "mbMD":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.h5video[data-v-7329a470]{\n    /* height: 327px; */\n}\n.riskdetail[data-v-7329a470]{\n    background: -webkit-linear-gradient(left, #cecece, #fbfbfb);\n}\n.riskdetailicon[data-v-7329a470]{\n    display: inline-block;\n    position: absolute;\n    width: 1rem;\n    height: 1rem;\n    margin: .2rem .5rem .5rem .5rem;\n    background: url(" + escape(__webpack_require__("F0Ri")) + ") no-repeat center center / 100% 100%;\n}\n.vjs-tech[data-v-7329a470] {\n    pointer-events: none;\n}\n", ""]);

// exports


/***/ }),

/***/ "nXJ6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/testxo.5f79f23.jpg";

/***/ }),

/***/ "now/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/translucence-bg.ec2a0b0.png";

/***/ }),

/***/ "npZJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAABSCAYAAAD9/DzoAAAACXBIWXMAACE3AAAhNwEzWJ96AAAB/klEQVRogdXbv43UQBiH4edMthEtUAHkm9AJVwKRi3BECdABJZBsDp3QwRH5dMd5dz3j+fPNG652JT8ayWvJ+j08PT3ZalmW9/iF3/M8P25+KUjT1ocvAB/xZVmW7w2vKbk3iP8Aa6EhrxBXAGthIc+IO4C1kJCJ3YC1cJB3p9MpBbD26XK5fDifzz/rXFZaE75JA6yFOZEJX/En8/chINM8z3/x2cCQCUaHPN9iR4a8+rMbFfLmsWNEyOYD4GiQTQRjQa4iGAdyE8EYkLsI4kN2IYgN2Y0gLiQJQUxIMoJ4kCwEsSDZCOJADiGIATmMoD+kCIK+kGII+kGKIugDKY6gPaQKgraQagjaQaoiaAOpjqA+pAmCupBmCOpBmiKoA2mOoDykC4KykIdr77Fblfiqbasf3U6iZF0RJU5hnufHbohSADqdREkAHRClATRG1ADQEFELQCNETQANELUBVEa0AFAR0QpAJURLABUQrQEURvQAUBDRC0AhRE8ABRC9ARxERABwABEFQCYiEoAMRDQAiYiIABIQUQHsREQGsAMRHcAdxAgAbiBGAbBvjpNTMwD75zgpNQWQNsfZU3MA6XOcW3UBkDfH2aobgPw5zsu6Ajg2xyEAgGNznBAA8uc4YQDkzXFCAUif44QDkDbHCQlg/xwnLIAbL+NHGpX/A/TfuYZopsowAAAAAElFTkSuQmCC"

/***/ }),

/***/ "nst3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/pelvis_lean_right.7a23236.png";

/***/ }),

/***/ "oNam":
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhFAAUAPMIAIeHhz8/P1dXVycnJ8/Pz7e3t5+fn29vb////wAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFBwAIACwAAAAAFAAUAEAEUxDJSatFxtwaggWAdIyHJAhXoRYSQUhDPGx0TbmujahbXGWZWqdDAYEsp5NupLPkdDwE7oXwWVasimzWrAE1tKFHErQRK8eL8mMUlRBJVI307uoiACH5BAUHAAgALAEAAQASABIAAAROEMkpS6E4W5upMdUmEQT2feFIltMJYivbvhnZ3R0A4NMwIDodz+cL7nDEn5CH8DGZh8MtEMBEoxkqlXKVIgQCibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpjaE4W5spANUmFQX2feFIltMJYivbvhnZ3d1x4BNBIDodz+cL7nDEn5CH8DGZAsFtMMBEoxkqlXKVIgIBibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpAaA4W5vpOdUmGQb2feFIltMJYivbvhnZ3Z0g4FNRIDodz+cL7nDEn5CH8DGZgcCNQMBEoxkqlXKVIgYDibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpz6E4W5upENUmAQD2feFIltMJYivbvhnZ3V0Q4JNhIDodz+cL7nDEn5CH8DGZg8GtUMBEoxkqlXKVIggEibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkphaA4W5tpCNUmHQf2feFIltMJYivbvhnZ3d0w4BMAIDodz+cL7nDEn5CH8DGZBMLNYMBEoxkqlXKVIgoFibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpQ6A4W5vpGNUmCQL2feFIltMJYivbvhnZ3R1B4NNxIDodz+cL7nDEn5CH8DGZhcINAMBEoxkqlXKVIgwGibbK9YLBYvLtHH5K0J0IACH5BAUHAAcALAEAAQASABIAAANCeLo6wzA6FxkhbaoQ4L3ZxnXLh0EjWZ4RV71VUcCLIByyTNt2PsO8m452sBGJBsNxkUwuD03lAQBASqnUJ7aq5UYSADs="

/***/ }),

/***/ "po/e":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* 封面 */\n.margin-bottom-80 {\n  margin-bottom: 4rem;\n}\n.margin-top-80 {\n  margin-top: 4rem;\n}\n.cover {\n  position: relative;\n  background: url(" + escape(__webpack_require__("q8a2")) + ") no-repeat center center / 100% 100%;\n}\n.cover-btn {\n  position: absolute;\n  right: 2rem;\n  bottom: 2rem;\n  width: 2.5rem;\n  height: 2.5rem;\n  /* background: url(\"../assets/images/posture/cover-arrow.png\") no-repeat center center / 100% 100%; */\n}\n.senno-logo {\n  width: 21rem;\n  height: 5rem;\n  background: url(" + escape(__webpack_require__("3tUu")) + ") no-repeat center center / 100% 100%;\n}\n.cooperation-logo {\n  background: url(" + escape(__webpack_require__("iT//")) + ");\n}\n.cooperation-logo:last-child {\n  margin-left: 1.5rem\n}\n.foundation-logo {\n  width: 4rem;\n  height: 6rem;\n  background-size: 12rem 6rem;\n  background-position: -7.6rem 0;\n}\n.hospital-logo {\n  width: 5rem;\n  height: 5rem;\n  background-size: 10.34rem 5.17rem;\n  background-position: -.35rem 0;\n}\n/* swiper 自定义样式开始 */\n.swiper-container {\n  width: 100%;\n  height: 100%;\n}\n.swiper-pagination-bullet {\n  opacity: 1;\n}\n.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {\n  top: 0;\n  bottom: initial;\n}\n.swiper-slide {\n  box-sizing: border-box;\n  overflow: scroll !important;\n  -webkit-overflow-scrolling: touch;\n  min-height: 100%;\n}\n.posture-swiper-pagination {\n  height: 3.1rem;\n  background: #fff;\n}\n.postureS-swiper-pagination {\n  margin-left: 27rem;\n  width: 44% !important;\n  top: 2rem !important;\n}\n@media (max-width: 768px) {\n.postureS-swiper-pagination {\n    margin-left: 10rem;\n    width: 44% !important;\n    top: 2rem !important;\n}\n}\n.pagination-container {\n  width: auto;\n  height: 100%;\n  margin: 0 4.4rem !important;\n}\n.hidden-pagination {\n  display: none;\n}\n.nav-line {\n  height: .25rem;\n  -webkit-align-self: stretch;\n          align-self: stretch;\n  border-radius: .125rem;\n}\n.pagination-bullet {\n  line-height: 2.8rem;\n  color: #c2c4c3;\n  width:100%;\n  white-space:nowrap;\n}\n.swiper-pagination-bullet-active .pagination-bullet {\n  color: #5cb4d0;\n}\n.swiper-pagination-bullet-active .nav-line {\n  background: #058fb6;\n}\n/* swiper 自定义样式结束 */\n.container-box {\n  position: absolute;\n  top: 3.1rem;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  border-top: 1px solid #efefef;\n  overflow: auto;\n}\n.posture-view-box {\n  min-height: 100%;\n  padding: 1rem 3.5rem;\n  background: #fff;\n}\n.face-icon {\n  width: 1.6rem;\n  height: 2rem;\n  background: url(" + escape(__webpack_require__("HmMl")) + ") no-repeat center center/100% 100%;\n}\n.side-icon {\n  width: 1rem;\n  height: 2rem;\n  margin-right: .8rem;\n  background: url(" + escape(__webpack_require__("v5mt")) + ") no-repeat center center/100% 100%;\n}\n/* 最后一页开始 */\n.hasrisk-icon {\n  width: 1.4rem;\n  height: 1.4rem;\n  margin: .6rem .5rem .6rem .9rem;\n  background: url(" + escape(__webpack_require__("7BL5")) + ") no-repeat center center / 100% 100%;\n}\n.norisk-icon {\n  width: 1.4rem;\n  height: 1.4rem;\n  margin: .6rem .5rem .6rem .9rem;\n  background: url(" + escape(__webpack_require__("1VHe")) + ") no-repeat center center / 100% 100%;\n}\n.risk-img {\n  width: 7rem;\n  height: 6.5rem;\n}\n.level-box {\n  display: inline-block;\n  width: 2.3rem;\n  line-height: 1rem;\n  color: #fff;\n  text-align: center;\n  border-bottom-left-radius: .4rem;\n  border-top-right-radius: .4rem;\n}\n.level-severe {\n  background: #ff4d4d;\n}\n.level-mild {\n  background: #ffbf00;\n}\n.level-normal {\n  background: #00d963;\n}\n.line-clamp-2 {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden\n}\n.risk-box {\n  padding: 1rem 2rem;\n}\n.right-arrow {\n  position: absolute;\n  width: .5rem;\n  height: .8rem;\n  right: 1.5rem;\n  bottom: 1rem;\n  background: url(" + escape(__webpack_require__("SQkG")) + ") no-repeat center center / 100% 100%;\n}\n/* 最后一页结束 */\n/* 设定 modal 为全屏覆盖 */\n.posture-modal .modal-dialog, .posture-modal .modal-content {\n  width: 100%;\n  max-width: initial;\n  height: 100%;\n  margin: 0;\n}\n.posture-modal .modal-content {\n  overflow: auto;\n}\n.posture-modal .modal-body {\n  width: 100%;\n  height: 100%;\n}\n.posture-modal .modal-dialog .modal-content{\n  border: 0;\n  border-radius: 0;\n  box-shadow: 0 0;\n}\n.posture-modal .modal-dialog .modal-content .modal-body {\n  padding: 0;\n}\n.posture-modal .modal-body {\n  padding-bottom: 4.5rem !important;\n}\n/* 定义 modal 结束 */\n.back-btn {\n  text-align: center;\n  width:3.9rem;\n  height:2rem;\n  line-height: 2rem;\n  color: #44a3ff;\n  background: #fff;\n  border: 1px solid #5aadff;\n  border-radius: .3rem;\n}\n.modal-risk-box {\n  height:16.8rem;\n  margin-top: .5rem;\n  padding: 2.6rem 1.75rem;\n  background-color: #fff;\n}\n.modal-risk-img {\n  width: 9.5rem;\n  height: 9rem;\n}\n.modal-level-box {\n  padding: 0 .3rem;\n  line-height: 1.6rem;\n  color: #fff;\n  text-align: center;\n  border-bottom-left-radius: .4rem;\n  border-top-right-radius: .4rem;\n}\n.potentialRisk-icon {\n  width: 1.2rem;\n  height: 1.1rem;\n  margin-right: .5rem;\n  background: url(" + escape(__webpack_require__("zrcO")) + ") no-repeat center center / 100% 100%;\n}\n.pagination-icon {\n  width: 1.5rem;\n  height: 1.5rem;\n  margin-top: .1rem;\n  background: url(" + escape(__webpack_require__("Tki4")) + ") no-repeat left top / 4.5rem 3rem;\n  -webkit-flex-shrink: 0;\n          flex-shrink: 0;\n}\n.potential-risk-box {\n  padding-left: 1rem;\n  margin-bottom: 0;\n  color: #939393;\n}\n.potential-risk-box li {\n  margin-bottom: .3rem\n}\n.modal-risk-head {\n  padding: 0 1.2rem;\n  background: -webkit-linear-gradient(left, #fee9e6, #fffcfb);\n  background: linear-gradient(left, #fee9e6, #fffcfb);\n}\n.close-box {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 4.5rem;\n  background: #f3f7fa;\n}\n.close-btn {\n  width: 3rem;\n  height: 3rem;\n  background: url(" + escape(__webpack_require__("3fkL")) + ") no-repeat center center / 100% 100%;\n}\n.modal-box::-webkit-scrollbar{\n  width: 0;\n}\n.modal-box {\n  height: 100%;\n  padding-top: 19rem;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  background-color: #e2edff;\n}\n.modal-head {\n  height:3.2rem;\n  background: #fff;\n  padding-left:1.75rem;\n  padding-right:1.75rem;\n}\n.risk-container-box {\n  padding: 0 1.5rem;\n  min-height: 100%;\n  background: #fffbfa;\n}\n.compare-img {\n  width: 10rem;\n  height: 10rem;\n  border-radius: .5rem;\n  overflow: hidden;\n}\n.risk-head {\n  padding: .1rem .8rem;\n  background: -webkit-linear-gradient(left, #c5c5c6, #fff);\n  background: linear-gradient(left, #c5c5c6, #fff);\n}\n.key-box {\n  padding: .3rem .8rem;\n  margin: 0 .5rem .5rem 0;\n  line-height: 1rem;\n  color: #898989;\n  border: 1px solid #b2b2b2;\n  border-radius: .3rem;\n}\n.down-arrow {\n  width: .4rem;\n  height: .7rem;\n  margin-top:.2rem;\n  margin-left: 1rem;\n  background: url(" + escape(__webpack_require__("npZJ")) + ") no-repeat center center / 100% 100%;\n}\n.key-box-risk {\n  padding: 0 .5rem;\n  margin: 0 .5rem .5rem 0;\n  line-height: 1rem;\n  color: #8a898a;\n  border: 1px solid #f3f3f3;\n  border-radius: .3rem;\n}\n.pc_marginTop {\n  margin-top:8rem;\n}\n@media screen and (min-width: 600px) and (max-width: 1024px) {\n.gmnClass{\n    width:22rem !important\n}\n}\n@media screen and (min-width: 1025px){\n.ItemClass{\n    width:11rem !important\n}\n}\n@media screen and (min-width: 1625px){\n.riskipad {\n    width:22rem !important\n}\n}\n.risk-box {\n    float: left !important;\n}\n@media screen and (min-width: 1025px){\n.ItemClass{\n    width:11rem !important\n}\n}\n\n", ""]);

// exports


/***/ }),

/***/ "q80A":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/spine_sideway_left.9e0c110.png";

/***/ }),

/***/ "q8a2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/cover-bg-ipad.6912d99.png";

/***/ }),

/***/ "qJFv":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAvCAYAAADw46qXAAABAklEQVRYhe3WTQ7BQBjG8b/GwudJSCR24nvNHUTCHdxAcBwuQCI2jRUnEKw5gYVpUsKYmbQWvE8yi84zmV+bdJomfN/HIgVgDLTU9RIYAXvTDZKW2AbIh+a6Cq8AO5NNPAtw9oQFyQFT001swKZj5wxmHDtnMJIIKOD/ggVgDlzUmKs5q2+paUrAGsiG5rpAG6jF8YTTJyxIFpjEAdY1XSMOMK3pUj/zlgpIEVgAVzUWai7yJIEysOLx7HS4/xw1gG2UoMeHgxolFoBVTV+LA0xpel3nDH41AgoooIACCijgv4BHTR/uDpp1Z9N1HjAETi/Kk+qCDN7c3BHoha6HmnX9G4sCJjbNT6N4AAAAAElFTkSuQmCC"

/***/ }),

/***/ "qMKa":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/**\n* actionsheet\n*/\n/**\n* en: primary type text color of menu item\n* zh-CN: 菜单项primary类型的文本颜色\n*/\n/**\n* en: warn type text color of menu item\n* zh-CN: 菜单项warn类型的文本颜色\n*/\n/**\n* en: default type text color of menu item\n* zh-CN: 菜单项default类型的文本颜色\n*/\n/**\n* en: disabled type text color of menu item\n* zh-CN: 菜单项disabled类型的文本颜色\n*/\n/**\n* datetime\n*/\n/**\n* tabbar\n*/\n/**\n* tab\n*/\n/**\n* dialog\n*/\n/**\n* en: title and content's padding-left and padding-right\n* zh-CN: 标题及内容区域的 padding-left 和 padding-right\n*/\n/**\n* x-number\n*/\n/**\n* checkbox\n*/\n/**\n* check-icon\n*/\n/**\n* Cell\n*/\n/**\n* Mask\n*/\n/**\n* Range\n*/\n/**\n* Tabbar\n*/\n/**\n* Header\n*/\n/**\n* Timeline\n*/\n/**\n* Switch\n*/\n/**\n* Button\n*/\n/**\n* en: border radius\n* zh-CN: 圆角边框\n*/\n/**\n* en: font color\n* zh-CN: 字体颜色\n*/\n/**\n* en: margin-top value between previous button, not works when there is only one button\n* zh-CN: 与相邻按钮的 margin-top 间隙，只有一个按钮时不生效\n*/\n/**\n* en: button height\n* zh-CN: 按钮高度\n*/\n/**\n* en: the font color in disabled\n* zh-CN: disabled状态下的字体颜色\n*/\n/**\n* en: the font color in disabled\n* zh-CN: disabled状态下的字体颜色\n*/\n/**\n* en: font size\n* zh-CN: 字体大小\n*/\n/**\n* en: the font size of the mini type\n* zh-CN: mini类型的字体大小\n*/\n/**\n* en: the line height of the mini type\n* zh-CN: mini类型的行高\n*/\n/**\n* en: the background color of the warn type\n* zh-CN: warn类型的背景颜色\n*/\n/**\n* en: the background color of the warn type in active\n* zh-CN: active状态下，warn类型的背景颜色\n*/\n/**\n* en: the background color of the warn type in disabled\n* zh-CN: disabled状态下，warn类型的背景颜色\n*/\n/**\n* en: the background color of the default type\n* zh-CN: default类型的背景颜色\n*/\n/**\n* en: the font color of the default type\n* zh-CN: default类型的字体颜色\n*/\n/**\n* en: the background color of the default type in active\n* zh-CN: active状态下，default类型的背景颜色\n*/\n/**\n* en: the font color of the default type in disabled\n* zh-CN: disabled状态下，default类型的字体颜色\n*/\n/**\n* en: the background color of the default type in disabled\n* zh-CN: disabled状态下，default类型的背景颜色\n*/\n/**\n* en: the font color of the default type in active\n* zh-CN: active状态下，default类型的字体颜色\n*/\n/**\n* en: the background color of the primary type\n* zh-CN: primary类型的背景颜色\n*/\n/**\n* en: the background color of the primary type in active\n* zh-CN: active状态下，primary类型的背景颜色\n*/\n/**\n* en: the background color of the primary type in disabled\n* zh-CN: disabled状态下，primary类型的背景颜色\n*/\n/**\n* en: the font color of the plain primary type\n* zh-CN: plain的primary类型的字体颜色\n*/\n/**\n* en: the border color of the plain primary type\n* zh-CN: plain的primary类型的边框颜色\n*/\n/**\n* en: the font color of the plain primary type in active\n* zh-CN: active状态下，plain的primary类型的字体颜色\n*/\n/**\n* en: the border color of the plain primary type in active\n* zh-CN: active状态下，plain的primary类型的边框颜色\n*/\n/**\n* en: the font color of the plain default type\n* zh-CN: plain的default类型的字体颜色\n*/\n/**\n* en: the border color of the plain default type\n* zh-CN: plain的default类型的边框颜色\n*/\n/**\n* en: the font color of the plain default type in active\n* zh-CN: active状态下，plain的default类型的字体颜色\n*/\n/**\n* en: the border color of the plain default type in active\n* zh-CN: active状态下，plain的default类型的边框颜色\n*/\n/**\n* en: the font color of the plain warn type\n* zh-CN: plain的warn类型的字体颜色\n*/\n/**\n* en: the border color of the plain warn type\n* zh-CN: plain的warn类型的边框颜色\n*/\n/**\n* en: the font color of the plain warn type in active\n* zh-CN: active状态下，plain的warn类型的字体颜色\n*/\n/**\n* en: the border color of the plain warn type in active\n* zh-CN: active状态下，plain的warn类型的边框颜色\n*/\n/**\n* swipeout\n*/\n/**\n* Cell\n*/\n/**\n* Badge\n*/\n/**\n* en: badge background color\n* zh-CN: badge的背景颜色\n*/\n/**\n* Popover\n*/\n/**\n* Button tab\n*/\n/**\n* en: not used\n* zh-CN: 未被使用\n*/\n/**\n* en: border radius color\n* zh-CN: 圆角边框的半径\n*/\n/**\n* en: border color\n* zh-CN: 边框的颜色\n*/\n/**\n* en: not used\n* zh-CN: 默认状态下圆角边框的颜色\n*/\n/**\n* en: not used\n* zh-CN: 未被使用\n*/\n/**\n* en: default background color\n* zh-CN: 默认状态下的背景颜色\n*/\n/**\n* en: selected background color\n* zh-CN: 选中状态下的背景颜色\n*/\n/**\n* en: not used\n* zh-CN: 未被使用\n*/\n/* alias */\n/**\n* en: not used\n* zh-CN: 未被使用\n*/\n/**\n* en: default text color\n* zh-CN: 默认状态下的文本颜色\n*/\n/**\n* en: height\n* zh-CN: 元素高度\n*/\n/**\n* en: line height\n* zh-CN: 元素行高\n*/\n/**\n* Swiper\n*/\n/**\n* checklist\n*/\n/**\n* popup-picker\n*/\n/**\n* popup\n*/\n/**\n* popup-header\n*/\n/**\n* form-preview\n*/\n/**\n* sticky\n*/\n/**\n* group\n*/\n/**\n* en: margin-top of title\n* zh-CN: 标题的margin-top\n*/\n/**\n* en: margin-bottom of title\n* zh-CN: 标题的margin-bottom\n*/\n/**\n* en: margin-top of footer title\n* zh-CN: 底部标题的margin-top\n*/\n/**\n* en: margin-bottom of footer title\n* zh-CN: 底部标题的margin-bottom\n*/\n/**\n* toast\n*/\n/**\n* en: text color of content\n* zh-CN: 内容文本颜色\n*/\n/**\n* en: default top\n* zh-CN: 默认状态下距离顶部的高度\n*/\n/**\n* en: position top\n* zh-CN: 顶部显示的高度\n*/\n/**\n* en: position bottom\n* zh-CN: 底部显示的高度\n*/\n/**\n* en: z-index\n* zh-CN: z-index\n*/\n/**\n* icon\n*/\n/**\n* calendar\n*/\n/**\n* en: forward and backward arrows color\n* zh-CN: 前进后退的箭头颜色\n*/\n/**\n* en: text color of week highlight\n* zh-CN: 周末高亮的文本颜色\n*/\n/**\n* en: background color when selected\n* zh-CN: 选中时的背景颜色\n*/\n/**\n* en: text color when disabled\n* zh-CN: 禁用时的文本颜色\n*/\n/**\n* en: text color of today\n* zh-CN: 今天的文本颜色\n*/\n/**\n* en: font size of cell\n* zh-CN: 单元格的字号\n*/\n/**\n* en: background color\n* zh-CN: 背景颜色\n*/\n/**\n* en: size of date cell\n* zh-CN: 日期单元格尺寸大小\n*/\n/**\n* en: line height of date cell\n* zh-CN: 日期单元格的行高\n*/\n/**\n* en: text color of header\n* zh-CN: 头部的文本颜色\n*/\n/**\n* week-calendar\n*/\n/**\n* search\n*/\n/**\n* en: text color of cancel button\n* zh-CN: 取消按钮文本颜色\n*/\n/**\n* en: background color\n* zh-CN: 背景颜色\n*/\n/**\n* en: text color of placeholder\n* zh-CN: placeholder文本颜色\n*/\n/**\n* radio\n*/\n/**\n* en: checked icon color\n* zh-CN: 选中状态的图标颜色\n*/\n/**\n* loadmore\n*/\n/**\n* en: not used\n* zh-CN: 未被使用\n*/\n/**\n* loading\n*/\n/**\n* en: z-index\n* zh-CN: z-index\n*/\nhtml{\n    font-size: 20px;\n}\n.swiper-container .container {\n    padding: 0;\n}\n/*custom*/\n.to-left {\n    float:left;\n}\n.to-right {\n    float: right;\n}\n.font-12 {\n  font-size: .6rem;\n}\n.font-14 {\n  font-size: .7rem\n}\n.font-16 {\n  font-size: .8rem;\n}\n.font-18 {\n  font-size: .9rem;\n}\n.font-20 {\n  font-size: 1rem;\n}\n.font-22 {\n  font-size: 1.1rem;\n}\n.font-24 {\n  font-size: 1.2rem;\n}\n.font-26 {\n  font-size: 1.3rem\n}\n.font-28 {\n  font-size: 1.4rem\n}\n.font-30 {\n  font-size: 1.5rem\n}\n.font-32 {\n  font-size: 1.6rem\n}\n.font-34 {\n  font-size: 1.7rem\n}\n.font-36 {\n  font-size: 1.8rem\n}\n.font-40 {\n  font-size: 2rem;\n}\n.content-top {\n    margin-top: 0.5rem;\n}\n.content-row {\n    display: -webkit-box;  /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */     /* 老版本语法: Firefox (buggy) */  /* 混合版本语法: IE 10 */\n    display: -webkit-flex;\n    display: flex;\n    padding: 0;\n    width: 100%;\n    height: auto;\n    background: #ffffff;\n}\n.content-row-bg {\n    background: none;\n}\n.content-row-start {\n    -webkit-box-pack: start;\n    -webkit-justify-content: flex-start;\n            justify-content: flex-start;\n}\n.content-row-end {\n    -webkit-box-pack: end;\n    -webkit-justify-content: flex-end;\n            justify-content: flex-end;\n}\n.content-row-between {\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n            justify-content: space-between;\n}\n.content-row-around {\n    -webkit-justify-content: space-around;\n            justify-content: space-around;\n}\n.content-row-center {\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n            justify-content: center;\n}\n.content-align-start {\n    -webkit-box-align: start;\n    -webkit-align-items: flex-start;\n            align-items: flex-start;\n}\n.content-align-center {\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n            align-items: center;\n}\n.content-align-end {\n    -webkit-box-align: end;\n    -webkit-align-items: flex-end;\n            align-items: flex-end;\n}\n.content-row-column {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n            flex-direction: column;\n}\n.content-flex-wrap {\n    -webkit-flex-wrap: wrap;\n            flex-wrap: wrap;\n}\n.content-inbox {\n    margin: 2rem 0 2rem 0;\n    width: 93%;\n    height: auto;\n}\n.font-green {\n    color: #c2d786;\n}\n.font-red {\n    color: #d9797c;\n}\n.color-sblue {\n    background: #256fb0;\n}\n.color-blue {\n    background: #084b82;\n}\n.color-red {\n    background: #c03c30;\n}\n.color-bblue {\n    background: #324554;\n}\n.flex {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: flex;\n}\n.border-bottom {\n    border-bottom: 0.1rem solid #edecee;\n}\n.font-num {\n    font-family: BlockGLECT;\n}\n.content-top-0 {\n    margin-top: 0rem;\n}\n.content-top-1 {\n    margin-top: 1rem;\n}\n.content-top-2 {\n    margin-top: 2rem;\n}\n.content-top-3 {\n    margin-top: 3rem;\n}\n.content-top-4 {\n    margin-top: 20%;\n}\n.content-top-5 {\n    margin-top: 5rem;\n}\n.content-top-6 {\n    margin-top: 6rem;\n}\n.content-bottom-0 {\n    margin-bottom: 0rem;\n}\n.content-bottom-1 {\n    margin-bottom: 1rem;\n}\n.content-bottom-2 {\n    margin-bottom: 2rem;\n}\n.content-bottom-3 {\n    margin-bottom: 3rem;\n}\n.tag-line {\n    display: inline-block;\n    width: 0.24rem;\n    height: 0.7rem;\n    background: #8e8e8e;\n}\n.auto-width {\n  width: auto;\n}\n.content-row {\n  background: transparent;\n}\n/*custom*/\nhtml {\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n}\nbody {\n  line-height: 1.6;\n  font-family: -apple-system-font, \"Helvetica Neue\", sans-serif;\n}\n* {\n  margin: 0;\n  padding: 0;\n}\na img {\n  border: 0;\n}\na {\n  text-decoration: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n/** env = windows **/\n::-webkit-input-placeholder {\n  font-family: -apple-system-font, \"Helvetica Neue\", sans-serif;\n}\n/** prevent default menu callout **/\na {\n  -webkit-touch-callout: none;\n}\nhtml {\n  touch-action: manipulation;\n}\n* {\n  pointer-events: auto;\n}\nhtml,\nbody {\n  height: 100%;\n  width: 100%;\n  overflow-x: hidden;\n}\n* {\n  box-sizing: border-box;\n}\nbody {\n  background-color: #fbf9fe;\n}\n.vux-pop-out-enter-active,\n.vux-pop-out-leave-active,\n.vux-pop-in-enter-active,\n.vux-pop-in-leave-active {\n  will-change: transform;\n  -webkit-transition: all 450ms;\n  transition: all 450ms;\n  height: 100%;\n  /*position: absolute;*/\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  -webkit-perspective: 1000;\n          perspective: 1000;\n}\n.vux-pop-out-enter {\n  opacity: 0;\n  -webkit-transform: translate3d(-100%, 0, 0);\n          transform: translate3d(-100%, 0, 0);\n}\n.vux-pop-out-leave-active {\n  opacity: 0;\n  -webkit-transform: translate3d(100%, 0, 0);\n          transform: translate3d(100%, 0, 0);\n}\n.vux-pop-in-enter {\n  opacity: 0;\n  -webkit-transform: translate3d(100%, 0, 0);\n          transform: translate3d(100%, 0, 0);\n}\n.vux-pop-in-leave-active {\n  opacity: 0;\n  -webkit-transform: translate3d(-100%, 0, 0);\n          transform: translate3d(-100%, 0, 0);\n}\n.vux-pull-out-enter-active,\n.vux-pull-out-leave-active,\n.vux-pull-in-enter-active,\n.vux-pull-in-leave-active {\n  will-change: transform;\n  -webkit-transition: all 450ms;\n  transition: all 450ms;\n  height: 100%;\n  position: absolute;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  -webkit-perspective: 1000;\n          perspective: 1000;\n}\n.vux-pull-out-enter {\n  opacity: 0;\n  -webkit-transform: translate3d(0, 0, -100%);\n          transform: translate3d(0, 0, -100%);\n}\n.vux-pull-out-leave-active {\n  opacity: 0;\n  -webkit-transform: translate3d(0, 0, 100%);\n          transform: translate3d(0, 0, 100%);\n}\n.vux-pull-in-enter {\n  opacity: 0;\n  -webkit-transform: translate3d(0, 0, 100%);\n          transform: translate3d(0, 0, 100%);\n}\n.vux-pull-in-leave-active {\n  opacity: 0;\n  -webkit-transform: translate3d(0, 0, -100%);\n          transform: translate3d(0, 0, -100%);\n}\n", ""]);

// exports


/***/ }),

/***/ "r2UY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "s+mH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/head_lean_left.d669539.png";

/***/ }),

/***/ "s9zb":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*! PhotoSwipe Default UI CSS by Dmitry Semenov | photoswipe.com | MIT license */\n/*\n\n\tContents:\n\n\t1. Buttons\n\t2. Share modal and links\n\t3. Index indicator (\"1 of X\" counter)\n\t4. Caption\n\t5. Loading indicator\n\t6. Additional styles (root element, top bar, idle state, hidden state, etc.)\n\n*/\n/*\n\t\n\t1. Buttons\n\n */\n/* <button> css reset */\n.pswp__button {\n  width: 44px;\n  height: 44px;\n  position: relative;\n  background: none;\n  cursor: pointer;\n  overflow: visible;\n  -webkit-appearance: none;\n  display: block;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  float: right;\n  opacity: 0.75;\n  -webkit-transition: opacity 0.2s;\n          transition: opacity 0.2s;\n  box-shadow: none;\n}\n.pswp__button:focus, .pswp__button:hover {\n    opacity: 1;\n}\n.pswp__button:active {\n    outline: none;\n    opacity: 0.9;\n}\n.pswp__button::-moz-focus-inner {\n    padding: 0;\n    border: 0;\n}\n/* pswp__ui--over-close class it added when mouse is over element that should close gallery */\n.pswp__ui--over-close .pswp__button--close {\n  opacity: 1;\n}\n.pswp__button,\n.pswp__button--arrow--left:before,\n.pswp__button--arrow--right:before {\n  background: url(" + escape(__webpack_require__("Oa+j")) + ") 0 0 no-repeat;\n  background-size: 264px 88px;\n  width: 44px;\n  height: 44px;\n}\n@media (-webkit-min-device-pixel-ratio: 1.1), (-webkit-min-device-pixel-ratio: 1.09375), (min-resolution: 105dpi), (min-resolution: 1.1dppx) {\n  /* Serve SVG sprite if browser supports SVG and resolution is more than 105dpi */\n.pswp--svg .pswp__button,\n  .pswp--svg .pswp__button--arrow--left:before,\n  .pswp--svg .pswp__button--arrow--right:before {\n    background-image: url(" + escape(__webpack_require__("6nyP")) + ");\n}\n.pswp--svg .pswp__button--arrow--left,\n  .pswp--svg .pswp__button--arrow--right {\n    background: none;\n}\n}\n.pswp__button--close {\n  background-position: 0 -44px;\n}\n.pswp__button--share {\n  background-position: -44px -44px;\n}\n.pswp__button--fs {\n  display: none;\n}\n.pswp--supports-fs .pswp__button--fs {\n  display: block;\n}\n.pswp--fs .pswp__button--fs {\n  background-position: -44px 0;\n}\n.pswp__button--zoom {\n  display: none;\n  background-position: -88px 0;\n}\n.pswp--zoom-allowed .pswp__button--zoom {\n  display: block;\n}\n.pswp--zoomed-in .pswp__button--zoom {\n  background-position: -132px 0;\n}\n/* no arrows on touch screens */\n.pswp--touch .pswp__button--arrow--left,\n.pswp--touch .pswp__button--arrow--right {\n  visibility: hidden;\n}\n/*\n\tArrow buttons hit area\n\t(icon is added to :before pseudo-element)\n*/\n.pswp__button--arrow--left,\n.pswp__button--arrow--right {\n  background: none;\n  top: 50%;\n  margin-top: -50px;\n  width: 70px;\n  height: 100px;\n  position: absolute;\n}\n.pswp__button--arrow--left {\n  left: 0;\n}\n.pswp__button--arrow--right {\n  right: 0;\n}\n.pswp__button--arrow--left:before,\n.pswp__button--arrow--right:before {\n  content: '';\n  top: 35px;\n  background-color: rgba(0, 0, 0, 0.3);\n  height: 30px;\n  width: 32px;\n  position: absolute;\n}\n.pswp__button--arrow--left:before {\n  left: 6px;\n  background-position: -138px -44px;\n}\n.pswp__button--arrow--right:before {\n  right: 6px;\n  background-position: -94px -44px;\n}\n/*\n\n\t2. Share modal/popup and links\n\n */\n.pswp__counter,\n.pswp__share-modal {\n  -webkit-user-select: none;\n      user-select: none;\n}\n.pswp__share-modal {\n  display: block;\n  background: rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  padding: 10px;\n  position: absolute;\n  z-index: 1600;\n  opacity: 0;\n  -webkit-transition: opacity 0.25s ease-out;\n          transition: opacity 0.25s ease-out;\n  -webkit-backface-visibility: hidden;\n  will-change: opacity;\n}\n.pswp__share-modal--hidden {\n  display: none;\n}\n.pswp__share-tooltip {\n  z-index: 1620;\n  position: absolute;\n  background: #FFF;\n  top: 56px;\n  border-radius: 2px;\n  display: block;\n  width: auto;\n  right: 44px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);\n  -webkit-transform: translateY(6px);\n          transform: translateY(6px);\n  -webkit-transition: -webkit-transform 0.25s;\n          transition: -webkit-transform 0.25s;\n          transition: transform 0.25s;\n          transition: transform 0.25s, -webkit-transform 0.25s;\n  -webkit-backface-visibility: hidden;\n  will-change: transform;\n}\n.pswp__share-tooltip a {\n    display: block;\n    padding: 8px 12px;\n    color: #000;\n    text-decoration: none;\n    font-size: 14px;\n    line-height: 18px;\n}\n.pswp__share-tooltip a:hover {\n      text-decoration: none;\n      color: #000;\n}\n.pswp__share-tooltip a:first-child {\n      /* round corners on the first/last list item */\n      border-radius: 2px 2px 0 0;\n}\n.pswp__share-tooltip a:last-child {\n      border-radius: 0 0 2px 2px;\n}\n.pswp__share-modal--fade-in {\n  opacity: 1;\n}\n.pswp__share-modal--fade-in .pswp__share-tooltip {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n/* increase size of share links on touch devices */\n.pswp--touch .pswp__share-tooltip a {\n  padding: 16px 12px;\n}\na.pswp__share--facebook:before {\n  content: '';\n  display: block;\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: -12px;\n  right: 15px;\n  border: 6px solid transparent;\n  border-bottom-color: #FFF;\n  -webkit-pointer-events: none;\n  -moz-pointer-events: none;\n  pointer-events: none;\n}\na.pswp__share--facebook:hover {\n  background: #3E5C9A;\n  color: #FFF;\n}\na.pswp__share--facebook:hover:before {\n    border-bottom-color: #3E5C9A;\n}\na.pswp__share--twitter:hover {\n  background: #55ACEE;\n  color: #FFF;\n}\na.pswp__share--pinterest:hover {\n  background: #CCC;\n  color: #CE272D;\n}\na.pswp__share--download:hover {\n  background: #DDD;\n}\n/*\n\n\t3. Index indicator (\"1 of X\" counter)\n\n */\n.pswp__counter {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 44px;\n  font-size: 13px;\n  line-height: 44px;\n  color: #FFF;\n  opacity: 0.75;\n  padding: 0 10px;\n}\n/*\n\t\n\t4. Caption\n\n */\n.pswp__caption {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  min-height: 44px;\n}\n.pswp__caption small {\n    font-size: 11px;\n    color: #BBB;\n}\n.pswp__caption__center {\n  text-align: left;\n  max-width: 420px;\n  margin: 0 auto;\n  font-size: 13px;\n  padding: 10px;\n  line-height: 20px;\n  color: #CCC;\n}\n.pswp__caption--empty {\n  display: none;\n}\n/* Fake caption element, used to calculate height of next/prev image */\n.pswp__caption--fake {\n  visibility: hidden;\n}\n/*\n\n\t5. Loading indicator (preloader)\n\n\tYou can play with it here - http://codepen.io/dimsemenov/pen/yyBWoR\n\n */\n.pswp__preloader {\n  width: 44px;\n  height: 44px;\n  position: absolute;\n  top: 0;\n  left: 50%;\n  margin-left: -22px;\n  opacity: 0;\n  -webkit-transition: opacity 0.25s ease-out;\n          transition: opacity 0.25s ease-out;\n  will-change: opacity;\n  direction: ltr;\n}\n.pswp__preloader__icn {\n  width: 20px;\n  height: 20px;\n  margin: 12px;\n}\n.pswp__preloader--active {\n  opacity: 1;\n}\n.pswp__preloader--active .pswp__preloader__icn {\n    /* We use .gif in browsers that don't support CSS animation */\n    background: url(" + escape(__webpack_require__("oNam")) + ") 0 0 no-repeat;\n}\n.pswp--css_animation .pswp__preloader--active {\n  opacity: 1;\n}\n.pswp--css_animation .pswp__preloader--active .pswp__preloader__icn {\n    -webkit-animation: clockwise 500ms linear infinite;\n            animation: clockwise 500ms linear infinite;\n}\n.pswp--css_animation .pswp__preloader--active .pswp__preloader__donut {\n    -webkit-animation: donut-rotate 1000ms cubic-bezier(0.4, 0, 0.22, 1) infinite;\n            animation: donut-rotate 1000ms cubic-bezier(0.4, 0, 0.22, 1) infinite;\n}\n.pswp--css_animation .pswp__preloader__icn {\n  background: none;\n  opacity: 0.75;\n  width: 14px;\n  height: 14px;\n  position: absolute;\n  left: 15px;\n  top: 15px;\n  margin: 0;\n}\n.pswp--css_animation .pswp__preloader__cut {\n  /* \n\t\t\tThe idea of animating inner circle is based on Polymer (\"material\") loading indicator \n\t\t\t by Keanu Lee https://blog.keanulee.com/2014/10/20/the-tale-of-three-spinners.html\n\t\t*/\n  position: relative;\n  width: 7px;\n  height: 14px;\n  overflow: hidden;\n}\n.pswp--css_animation .pswp__preloader__donut {\n  box-sizing: border-box;\n  width: 14px;\n  height: 14px;\n  border: 2px solid #FFF;\n  border-radius: 50%;\n  border-left-color: transparent;\n  border-bottom-color: transparent;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: none;\n  margin: 0;\n}\n@media screen and (max-width: 1024px) {\n.pswp__preloader {\n    position: relative;\n    left: auto;\n    top: auto;\n    margin: 0;\n    float: right;\n}\n}\n@-webkit-keyframes clockwise {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes clockwise {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@-webkit-keyframes donut-rotate {\n0% {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n}\n50% {\n    -webkit-transform: rotate(-140deg);\n            transform: rotate(-140deg);\n}\n100% {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n}\n}\n@keyframes donut-rotate {\n0% {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n}\n50% {\n    -webkit-transform: rotate(-140deg);\n            transform: rotate(-140deg);\n}\n100% {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n}\n}\n/*\n\t\n\t6. Additional styles\n\n */\n/* root element of UI */\n.pswp__ui {\n  -webkit-font-smoothing: auto;\n  visibility: visible;\n  opacity: 1;\n  z-index: 1550;\n}\n/* top black bar with buttons and \"1 of X\" indicator */\n.pswp__top-bar {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 44px;\n  width: 100%;\n}\n.pswp__caption,\n.pswp__top-bar,\n.pswp--has_mouse .pswp__button--arrow--left,\n.pswp--has_mouse .pswp__button--arrow--right {\n  -webkit-backface-visibility: hidden;\n  will-change: opacity;\n  -webkit-transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);\n          transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);\n}\n/* pswp--has_mouse class is added only when two subsequent mousemove events occur */\n.pswp--has_mouse .pswp__button--arrow--left,\n.pswp--has_mouse .pswp__button--arrow--right {\n  visibility: visible;\n}\n.pswp__top-bar,\n.pswp__caption {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n/* pswp__ui--fit class is added when main image \"fits\" between top bar and bottom bar (caption) */\n.pswp__ui--fit .pswp__top-bar,\n.pswp__ui--fit .pswp__caption {\n  background-color: rgba(0, 0, 0, 0.3);\n}\n/* pswp__ui--idle class is added when mouse isn't moving for several seconds (JS option timeToIdle) */\n.pswp__ui--idle .pswp__top-bar {\n  opacity: 0;\n}\n.pswp__ui--idle .pswp__button--arrow--left,\n.pswp__ui--idle .pswp__button--arrow--right {\n  opacity: 0;\n}\n/*\n\tpswp__ui--hidden class is added when controls are hidden\n\te.g. when user taps to toggle visibility of controls\n*/\n.pswp__ui--hidden .pswp__top-bar,\n.pswp__ui--hidden .pswp__caption,\n.pswp__ui--hidden .pswp__button--arrow--left,\n.pswp__ui--hidden .pswp__button--arrow--right {\n  /* Force paint & create composition layer for controls. */\n  opacity: 0.001;\n}\n/* pswp__ui--one-slide class is added when there is just one item in gallery */\n.pswp__ui--one-slide .pswp__button--arrow--left,\n.pswp__ui--one-slide .pswp__button--arrow--right,\n.pswp__ui--one-slide .pswp__counter {\n  display: none;\n}\n.pswp__element--disabled {\n  display: none !important;\n}\n.pswp--minimal--dark .pswp__top-bar {\n  background: none;\n}\n", ""]);

// exports


/***/ }),

/***/ "sjPr":
/***/ (function(module, exports, __webpack_require__) {

var imgSrc = __webpack_require__("On8B");
var level = {
  normal: 'normal',
  mild: 'mild',
  severe: 'severe'
};

function initRiskBar(option) {
  var canvas = option.element;
  //console.log('option =>', option);
  canvas.width = 200;
  canvas.height = 100;
  var cxt = canvas.getContext('2d');

  cxt.save();
  cxt.translate(0, 40);
  // 第一部分
  cxt.save();
  cxt.fillStyle = '#57d90b';
  cxt.beginPath();
  cxt.moveTo(0, 0);
  cxt.lineTo(60, 0);
  cxt.lineTo(60, 20);
  cxt.lineTo(0, 20);
  cxt.closePath();
  cxt.fill();
  cxt.restore();

  // 第二部分
  cxt.save();
  cxt.fillStyle = '#ff7200';
  cxt.beginPath();
  cxt.moveTo(70, 0);
  cxt.lineTo(130, 0);
  cxt.lineTo(130, 20);
  cxt.lineTo(70, 20);
  cxt.closePath();
  cxt.fill();
  cxt.restore();

  // 第三部分
  cxt.save();
  cxt.fillStyle = '#c91004';
  cxt.beginPath();
  cxt.moveTo(140, 0);
  cxt.lineTo(200, 0);
  cxt.lineTo(200, 20);
  cxt.lineTo(140, 20);
  cxt.closePath();
  cxt.fill();
  cxt.restore();

  cxt.restore();

  // 画顶部箭头
  var img = new Image();
  //console.log('option.level=>', option.level);
  switch (option.level) {
    case 'normal':
      img.src = imgSrc.riskbar_arrow.low;
      img.onload = function () {
        cxt.drawImage(img, 20, 0, 20, 25);
      };
      break;
    case 'mild':
      img.src = imgSrc.riskbar_arrow.middle;
      img.onload = function () {
        cxt.drawImage(img, 90, 0, 20, 25);
      };
      break;
    case 'severe':
      img.src = imgSrc.riskbar_arrow.high;
      img.onload = function () {
        cxt.drawImage(img, 160, 0, 20, 25);
      };
      break;
  }
}

function initRiskLevel(option) {
  //console.log('el =>', option.width);
  var canvas = option.el;
  var cxt = canvas.getContext('2d');
  var scaleW = option.width / 216;
  var scaleH = option.height / 30;
  var scale = scaleW < scaleH ? 2 * scaleW : 2 * scaleH;
  canvas.width = 216 * scale;
  canvas.height = 30 * scale;
  canvas.style.width = 216 * scale / 2 + 'px';
  canvas.style.height = 30 * scale / 2 + 'px';
  var value = Number(canvas.dataset.value);
  value = Math.floor(value);
  //console.log('color =>', option.color);
  //console.log('level =>', option.level);
  var color = option.color[canvas.dataset.level];
  var valueX = value / 100 * 190 + 5;
  var lowToMidX = 20 / 100 * 190 + 5;
  var midToHighX = 60 / 100 * 190 + 5;
  cxt.scale(scale, scale);
  cxt.translate(8, 0);

  // 画图标和风险值

  // cxt.save();
  // let icon = imgSrc.RISKBAR_ICON;
  // let img = new Image();
  // img.src = icon;
  // img.onload = function () {
  //   cxt.drawImage(img, valueX - 5, 5, 10, 15);
  //   cxt.font = '12px sans-serif';
  //   cxt.fillStyle = '#9b9b9b';
  //   if(valueX + 5 > 170) {
  //     cxt.fillText(value, valueX - 28, 17);
  //   } else {
  //     cxt.fillText(value, valueX + 8, 17);
  //   }
  // }
  // cxt.restore();
  cxt.save();
  cxt.fillStyle = color;
  cxt.beginPath();
  cxt.moveTo(valueX - 10, 2);
  cxt.lineTo(valueX + 10, 2);

  cxt.arc(valueX + 10, 3, 1, -Math.PI / 2, 0);

  cxt.lineTo(valueX + 11, 17);

  cxt.arc(valueX + 10, 17, 1, 0, Math.PI / 2);

  cxt.lineTo(valueX + 3, 18);
  cxt.lineTo(valueX, 20);
  cxt.lineTo(valueX - 3, 18);
  cxt.lineTo(valueX - 10, 18);

  cxt.arc(valueX - 10, 17, 1, Math.PI / 2, Math.PI);

  cxt.lineTo(valueX - 11, 3);
  cxt.arc(valueX - 10, 3, 1, Math.PI, Math.PI * 3 / 2);
  cxt.closePath();
  cxt.fill();
  cxt.fillStyle = '#fff';
  cxt.textAlign = 'center';
  cxt.font = '14px serif';
  cxt.fillText(value, valueX, 15);
  cxt.restore();

  // 画柱状图灰色背景
  cxt.save();
  cxt.fillStyle = '#c1c1c1';
  cxt.beginPath();
  cxt.moveTo(7, 23);
  cxt.lineTo(193, 23);
  cxt.arc(193, 25, 2, 3 * Math.PI / 2, Math.PI / 2);
  cxt.lineTo(7, 27);
  cxt.arc(7, 25, 2, Math.PI / 2, 3 * Math.PI / 2);
  cxt.closePath();
  cxt.fill();
  cxt.restore();

  // 画线性渐变风险柱状图
  var gradient = cxt.createLinearGradient(0, 0, 190, 0);
  gradient.addColorStop(0, '#00ff6a');
  gradient.addColorStop(.38, '#ffda08');
  gradient.addColorStop(1, '#ff4d4d');

  cxt.fillStyle = gradient;
  cxt.beginPath();
  if (valueX > 5) {
    cxt.moveTo(7, 23);
    cxt.lineTo(valueX - 2, 23);
    cxt.arc(valueX - 2, 25, 2, 3 * Math.PI / 2, Math.PI / 2);
    cxt.lineTo(7, 27);
    cxt.arc(7, 25, 2, Math.PI / 2, 3 * Math.PI / 2);
  }
  cxt.closePath();
  cxt.fill();

  // 画值为 20 的分界线
  cxt.beginPath();
  cxt.strokeStyle = '#8a8b81';
  cxt.lineWidth = 2;
  cxt.moveTo(lowToMidX, 18);
  cxt.lineTo(lowToMidX, 22);
  cxt.moveTo(lowToMidX, 23);
  cxt.lineTo(lowToMidX, 27);
  cxt.moveTo(lowToMidX, 28);
  cxt.lineTo(lowToMidX, 32);
  cxt.stroke();
  cxt.closePath();

  // 画值为 60 的分界线
  cxt.beginPath();
  cxt.strokeStyle = '#8a8b81';
  cxt.lineWidth = 2;
  cxt.moveTo(midToHighX, 18);
  cxt.lineTo(midToHighX, 22);
  cxt.moveTo(midToHighX, 23);
  cxt.lineTo(midToHighX, 27);
  cxt.moveTo(midToHighX, 28);
  cxt.lineTo(midToHighX, 32);
  cxt.stroke();
  cxt.closePath();
}

// ====== 骨骼筋膜图 ======
function getRad(topOrRightPoint, bottomOrLeftPoint, isHorizontal) {
  // 此时的 right 是指看人体正面时人体的右，即我们的左；
  // 此时的 left 是指看人体正面时人体的左，即我们的右；

  var _x = Math.abs(topOrRightPoint.x - bottomOrLeftPoint.x);
  var _y = Math.abs(topOrRightPoint.y - bottomOrLeftPoint.y);
  var radian = void 0;

  if (isHorizontal) {
    if (topOrRightPoint.y < bottomOrLeftPoint.y) {
      radian = Math.atan(_y / _x);
    } else if (topOrRightPoint.y > bottomOrLeftPoint.y) {
      radian = -Math.atan(_y / _x);
    } else {
      radian = 0;
    }
  } else {
    if (topOrRightPoint.y < bottomOrLeftPoint.y) {
      // 两个点垂直位置正常情况
      if (topOrRightPoint.x > bottomOrLeftPoint.x) {
        radian = Math.atan(_x / _y);
      } else if (topOrRightPoint.x < bottomOrLeftPoint.x) {
        radian = -Math.atan(_x / _y);
      } else {
        radian = 0;
      }
    } else {
      // 两个点位置垂直不正常情况
      if (topOrRightPoint.x > bottomOrLeftPoint.x) {
        radian = Math.atan(_y / _x) + Math.PI / 2;
      } else if (topOrRightPoint.x < bottomOrLeftPoint.x) {
        radian = 3 * Math.PI / 2 - Math.atan(_y / _x);
      } else {
        radian = Math.PI;
      }
    }
  }

  return radian;
}

function getLimitRad(rad, min, max) {
  if (rad > max) {
    return max;
  } else if (rad < min) {
    return min;
  } else {
    return rad;
  }
}

function isXO(risk) {
  if (risk.position === 'lower extremity' && risk.code !== 3) {
    return true;
  }
  return false;
}

function getXOLeftOrRight(risk) {
  // 此处需要注意，数据的左腿 --> 画图的右腿；数据的右腿 --> 画图的左腿
  if (risk.detail == '左腿') {
    return 'right';
  } else if (risk.detail == '右腿') {
    return 'left';
  }
}

function isHighLowShoulder(risk) {
  if (risk.position === 'shoulder' && risk.code == 1) {
    return true;
  }
  return false;
}

function getShoulderLeftOrRight(detail) {
  switch (detail) {
    case '左高':
      return 'left';
    case '右高':
      return 'right';
    default:
      return false;
  }
}

function getOrderInfos(locationInfo, order) {
  var orderInfos = [];
  for (var i = 0; i < order.length; i++) {
    var pathArr = order[i].split('-');
    var info = void 0;
    for (var j = 0; j < pathArr.length; j++) {
      if (j == 0) {
        info = locationInfo[pathArr[j]];
      } else {
        info = info[pathArr[j]];
      }
    }

    orderInfos.push(info);
  }
  return orderInfos;
}

function isHeadFront(risks) {
  var riskLevel = void 0;
  risks.forEach(function (item, index) {
    if (item.position === 'head' && item.code === 2) {
      riskLevel = item.level;
    }
  });
  if (riskLevel !== level.normal) {
    return true;
  }
  return false;
}

function getHeadDirection(risks) {
  var riskLevel = void 0;
  var detail = void 0;
  var direction = void 0;

  risks.forEach(function (item, index) {
    if (item.position === 'head' && item.code === 1) {
      riskLevel = item.level;
      detail = item.detail;
    }
  });

  switch (detail) {
    case '左倾':
      direction = 'right';
      break;
    case '右倾':
      direction = 'left';
      break;
    default:
      direction = 'mid';
      break;
  }

  if (riskLevel === level.severe) {
    return direction;
  } else {
    return 'mid';
  }
}

function getBodyDirection(risks) {
  var riskLevel = void 0;
  var detail = void 0;
  var direction = void 0;

  risks.forEach(function (item, index) {
    if (item.position === 'head' && item.code === 1) {
      riskLevel = item.level;
      detail = item.detail;
    }
  });

  switch (detail) {
    case '左高':
      direction = 'right';
      break;
    case '右高':
      direction = 'left';
      break;
    default:
      direction = 'mid';
      break;
  }

  if (riskLevel === level.severe) {
    return direction;
  } else {
    return 'mid';
  }
}

function firstUpperCase(str) {
  return str.toLowerCase().replace(/^[a-z]/g, function (L) {
    return L.toUpperCase();
  });
}

// 取需要展示疼痛的部位, direction 代表正面或者侧面, data 代表后台数据中的 conclusion, pains 代表包括正面、侧面疼痛的模板
function getPainArr(direction, data, pains) {
  var risks = data.face.risks.concat(data.side.risks);
  //console.log('risks =====>',  risks);
  var painsTemplate = pains[direction];
  //console.log('painsTemplate ===>', painsTemplate);
  var painArr = [];
  for (var i = 0; i < risks.length; i++) {
    if (risks[i].level === level.severe) {
      //console.log('in severe!')
      var _pains = painsTemplate[risks[i].position][risks[i].code - 1];
      switch (direction) {
        case 'face':
          var lOrR = void 0;
          if (isXO(risks[i])) {
            lOrR = getXOLeftOrRight(risks[i]);
            //console.log('isXO ==>', lOrR)
          } else if (isHighLowShoulder(risks[i])) {
            lOrR = getShoulderLeftOrRight(risks[i].detail);
          }
          for (var j = 0; j < _pains.length; j++) {
            if (lOrR === undefined) {
              painArr.push(_pains[j] + '-left');
              painArr.push(_pains[j] + '-right');
            } else if (typeof lOrR === 'string') {
              painArr.push(_pains[j] + ('-' + lOrR));
            }
          }
          break;
        case 'side':
          painArr = painArr.concat(_pains);
          break;
        default:
          break;
      }
    }
  }
  //console.log('painArr ====>', painArr)
  return painArr;
}

var pains = {
  face: {
    head: [[], ['neckPain']],
    shoulder: [['waistPain'], ['bosomPain']],
    trunk: [[]],
    pelvis: [[]],
    'lower extremity': [['thignPainForO', 'shankPain', 'hipPain'], ['thignPainForX', 'thignMidPainForX'], ['thignMidPainForKnee'], []]
  },
  side: {
    head: [[], ['neckMidPain', 'shoulderBackPain']],
    shoulder: [['neckBackPain'], ['neckWithBosomPain', 'shoulderBackPain']],
    trunk: [[]],
    pelvis: [[]],
    'lower extremity': [['shankOPain', 'thighLeftPain', 'thighRightPain'], ['shankMidPain'], ['shankLeftPain'], []]
  }

  // ====== 正面 ======
};function drawBoneFront(data, canvas) {
  //console.log('draw face begin!')
  var facePoints = data.conclusion.face.points;
  var faceRisks = data.conclusion.face.risks;

  var faceRad = {
    head: getRad(facePoints.ear.right, facePoints.ear.left, true),
    elbowToWristL: getRad(facePoints.elbow.right, facePoints.wrist.right),
    shoulderToElbowL: getRad(facePoints.shoulder.right, facePoints.wrist.right),
    shoulder: getRad(facePoints.shoulder.right, facePoints.shoulder.left, true),
    elbowToWristR: getRad(facePoints.elbow.left, facePoints.wrist.left),
    shoulderToElbowR: getRad(facePoints.shoulder.left, facePoints.elbow.left),
    hip: getRad(facePoints.hip.right, facePoints.hip.left, true),
    hipToKneeL: getRad(facePoints.hip.right, facePoints.knee.right),
    hipToKneeR: getRad(facePoints.hip.left, facePoints.knee.left),
    kneeToAnkleL: getRad(facePoints.knee.right, facePoints.ankle.right),
    kneeToAnkleR: getRad(facePoints.knee.left, facePoints.ankle.left)
  };

  //console.log('')
  var faceCanvas = canvas;
  //console.log('faceCanvas ==>', faceCanvas);

  var faceWidth = faceCanvas.width;
  var faceHeight = faceCanvas.height;

  //console.log('faceRad =>', faceRad)
  // let headDirection = (faceRad.head > - Math.PI / 15 && faceRad.head < Math.PI / 15) ? 'mid' : faceRad.head > Math.PI / 15 ? 'right' : 'left';
  var headDirection = getHeadDirection(faceRisks);
  //console.log('headDirection =>', headDirection);

  // let bodyDirection = (faceRad.shoulder > - Math.PI / 15 && faceRad.shoulder < Math.PI / 15) ? 'mid' : faceRad.shoulder > Math.PI / 15 ? 'right' : 'left';
  var bodyDirection = getBodyDirection(faceRisks);
  //console.log('bodyDirection =>', bodyDirection);

  // let headForBody = (faceRad.shoulder > - Math.PI / 15 && faceRad.shoulder < Math.PI / 15) ? 'forMidBody' : faceRad.shoulder > Math.PI / 15 ? 'forRightBody' : 'forLeftBody';
  var headForBody = 'for' + firstUpperCase(bodyDirection) + 'Body';
  //console.log('headForBody =>', headForBody);

  var locationInfo = {
    head: {
      left: {
        forLeftBody: {
          key: 'head-left-forLeftBody',
          type: 'noraml',
          x: 1186,
          y: 44,
          width: 182,
          height: 188,
          offsetW: -91,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false
        },
        forMidBody: { // 还需等 UI 图再确定位置
          key: 'head-left-forMidBody',
          type: 'noraml',
          x: 962,
          y: 798,
          width: 200,
          height: 168,
          offsetW: -100,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false
        },
        forRightBody: {
          key: 'head-left-forRightBody',
          type: 'noraml',
          x: 394,
          y: 800,
          width: 198,
          height: 179,
          offsetW: -99,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false
        }
      },
      mid: {
        forLeftBody: { // 等 UI 图待定
          key: 'head-mid-forLeftBody',
          type: 'noraml',
          x: 1241,
          y: 786,
          width: 220,
          height: 186,
          offsetW: -110,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false
        },
        forMidBody: {
          key: 'head-mid-forMidBody',
          type: 'noraml',
          x: 938,
          y: 44,
          width: 182,
          height: 188,
          offsetW: -91,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false
        },
        forRightBody: { // 等 UI 图待定
          key: 'head-mid-forRightBody',
          type: 'noraml',
          x: 1527,
          y: 784,
          width: 222,
          height: 190,
          offsetW: -111,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false
        }
      },
      right: {
        forLeftBody: {
          key: 'head-right-forLeftBody',
          type: 'noraml',
          x: 80,
          y: 798,
          width: 198,
          height: 179,
          offsetW: -99,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false
        },
        forMidBody: { // 等 UI 图待定
          key: 'head-right-forMidBody',
          type: 'noraml',
          x: 672,
          y: 798,
          width: 202,
          height: 178,
          offsetW: -101,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false
        },
        forRightBody: {
          key: 'head-right-forRightBody',
          type: 'noraml',
          x: 1438,
          y: 44,
          width: 182,
          height: 188,
          offsetW: -91,
          offsetH: 0,
          translateX: faceWidth / 2,
          translateY: 0,
          rotateBefore: 0,
          rotate: 0,
          maxRotate: 0,
          minRotate: 0,
          saveBefore: false,
          restoreAfter: false
        }
      }
    },
    body: {
      left: {
        key: 'body-left',
        type: 'noraml',
        x: 596,
        y: 32,
        width: 230,
        height: 344,
        offsetW: -115,
        offsetH: -40,
        translateX: 10,
        translateY: 183,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: false,
        restoreAfter: false
      },
      mid: {
        key: 'body-right',
        type: 'noraml',
        x: 48,
        y: 32,
        width: 230,
        height: 344,
        offsetW: -115,
        offsetH: -40,
        translateX: 0,
        translateY: 183,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: false,
        restoreAfter: false
      },
      right: {
        key: 'body-right',
        type: 'noraml',
        x: 320,
        y: 32,
        width: 230,
        height: 344,
        offsetW: -115,
        offsetH: -40,
        translateX: -10,
        translateY: 183,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: false,
        restoreAfter: false
      }
    },
    upperArm: {
      left: {
        key: 'upperArm-left',
        type: 'noraml',
        x: 64,
        y: 462,
        width: 72,
        height: 170,
        offsetW: 0,
        offsetH: 0,
        // translateX: (faceRad.shoulder > - Math.PI / 15 && faceRad.shoulder < Math.PI / 15) ? -102 : faceRad.shoulder < - Math.PI / 15 ? -105 : -95,
        translateX: -105,
        // translateY: (faceRad.shoulder > - Math.PI / 15 && faceRad.shoulder < Math.PI / 15) ? -20 : faceRad.shoulder < - Math.PI / 15 ? -20 : -25,
        translateY: bodyDirection === 'mid' ? -20 : bodyDirection === 'left' ? -20 : -25,
        rotateBefore: 0,
        rotate: faceRad.shoulderToElbowL,
        maxRotate: 0.3,
        minRotate: -0.05,
        saveBefore: true,
        restoreAfter: false,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'upperArm-right',
        type: 'noraml',
        x: 150,
        y: 460,
        width: 72,
        height: 170,
        offsetW: -36,
        offsetH: 0,
        // translateX: (faceRad.shoulder > - Math.PI / 15 && faceRad.shoulder < Math.PI / 15) ? 102 : faceRad.shoulder < - Math.PI / 15 ? 85 : 100,
        translateX: bodyDirection === 'mid' ? 102 : bodyDirection === 'left' ? 85 : 100,
        // translateY: (faceRad.shoulder > - Math.PI / 15 && faceRad.shoulder < Math.PI / 15) ? -20 : faceRad.shoulder < - Math.PI / 15 ? -40 : -20,
        translateY: bodyDirection === 'mid' ? -20 : bodyDirection === 'left' ? -40 : -20,
        rotateBefore: 0,
        rotate: faceRad.shoulderToElbowR,
        maxRotate: 0.05,
        minRotate: -0.3,
        saveBefore: true,
        restoreAfter: false,
        globalCompositeOperation: 'source-over'
      }
    },
    foreArm: {
      left: {
        key: 'foreArm-left',
        type: 'noraml',
        x: 246,
        y: 464,
        width: 58,
        height: 204,
        offsetW: -38,
        offsetH: 0,
        translateX: 0,
        translateY: 162,
        rotateBefore: -faceRad.shoulderToElbowL,
        rotate: faceRad.elbowToWristL,
        maxRotate: 0.3,
        minRotate: -0.3,
        saveBefore: false,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'foreArm-right',
        type: 'noraml',
        x: 320,
        y: 464,
        width: 58,
        height: 204,
        offsetW: -24,
        offsetH: 0,
        translateX: 0,
        translateY: 162,
        rotateBefore: -faceRad.shoulderToElbowR,
        rotate: faceRad.elbowToWristR,
        maxRotate: 0.3,
        minRotate: -0.3,
        saveBefore: false,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      }
    },
    thigh: {
      left: {
        key: 'thigh-left',
        type: 'noraml',
        x: faceRad.shoulder < 0 ? 1065 : 464,
        y: faceRad.shoulder < 0 ? 452 : 432,
        width: 90,
        height: 296,
        offsetW: -50,
        offsetH: 0,
        // translateX: faceRad.shoulder == 0 ? -50 : faceRad.shoulder < 0 ? -55 : -50,
        translateX: bodyDirection === 'mid' ? -50 : bodyDirection === 'left' ? -55 : -50,
        // translateY: faceRad.shoulder == 0 ? 200 : faceRad.shoulder < 0 ? 210 : 190,
        translateY: bodyDirection === 'mid' ? 200 : bodyDirection === 'left' ? 210 : 190,
        rotateBefore: 0,
        rotate: faceRad.hipToKneeL,
        maxRotate: 0.05,
        minRotate: -0.05,
        saveBefore: true,
        restoreAfter: false
      },
      right: {
        key: 'thigh-right',
        type: 'noraml',
        x: faceRad.shoulder < 0 ? 1233 : 625,
        y: faceRad.shoulder < 0 ? 451 : 434,
        width: 90,
        height: 296,
        offsetW: -40,
        offsetH: 0,
        // translateX: faceRad.shoulder == 0 ? 45 : faceRad.shoulder < 0 ? 50 : 55,
        translateX: bodyDirection === 'mid' ? 45 : bodyDirection === 'left' ? 50 : 55,
        // translateY: faceRad.shoulder == 0 ? 200 : faceRad.shoulder < 0 ? 190 : 210,
        translateY: bodyDirection === 'mid' ? 200 : bodyDirection === 'left' ? 190 : 210,
        rotateBefore: 0,
        rotate: faceRad.hipToKneeR,
        maxRotate: 0.05,
        minRotate: -0.05,
        saveBefore: true,
        restoreAfter: false
      }
    },
    shank: {
      left: {
        key: 'shank-left',
        type: 'noraml',
        x: faceRad.shoulder > 0 ? 779 : 1395,
        y: faceRad.shoulder < 0 ? 443 : 441,
        width: faceRad.shoulder > 0 ? 70 : 68,
        height: faceRad.shoulder > 0 ? 306 : 300,
        offsetW: faceRad.shoulder > 0 ? -27 : -26,
        offsetH: -13,
        translateX: -5,
        translateY: 300,
        rotateBefore: -faceRad.hipToKneeL,
        rotate: faceRad.kneeToAnkleL + 0.026,
        maxRotate: 0.05,
        minRotate: -0.05,
        saveBefore: false,
        restoreAfter: false
      },
      right: {
        key: 'shank-right',
        type: 'noraml',
        x: faceRad.shoulder > 0 ? 904 : 1551,
        y: 444,
        width: 64,
        height: 302,
        offsetW: -40,
        offsetH: -12,
        translateX: 5,
        translateY: 300,
        rotateBefore: -faceRad.hipToKneeR,
        rotate: faceRad.kneeToAnkleR - 0.026,
        maxRotate: 0.05,
        minRotate: -0.05,
        saveBefore: false,
        restoreAfter: false
      }
    },
    pelvis: {
      key: 'pelvis',
      type: 'noraml',
      x: 1720,
      y: 94,
      width: 148,
      height: 120,
      offsetW: -74,
      offsetH: -40,
      translateX: 0,
      translateY: 228,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: false
    },
    neckPain: { // --------
      left: {
        key: 'neckPain-left',
        type: 'pain',
        x: 59,
        y: 1064,
        width: 94,
        height: 36,
        offsetW: -47,
        offsetH: 0,
        translateX: -60,
        translateY: 140,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'neckPain-right',
        type: 'pain',
        x: 170,
        y: 1064,
        width: 94,
        height: 36,
        offsetW: -47,
        offsetH: 0,
        translateX: 55,
        translateY: 140,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      }
    },
    bosomPain: {
      left: {
        key: 'bosomPain-left',
        type: 'pain',
        x: 80,
        y: 1506,
        width: 90,
        height: 108,
        offsetW: -45,
        offsetH: 0,
        translateX: -55,
        translateY: -25,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'bosomPain-right',
        type: 'pain',
        x: 174,
        y: 1506,
        width: 90,
        height: 108,
        offsetW: -45,
        offsetH: 0,
        translateX: 55,
        translateY: -25,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      }
    },
    thignPainForO: {
      left: {
        key: 'thignPainForO-left',
        type: 'pain',
        x: 386,
        y: 1750,
        width: 46,
        height: 214,
        offsetW: -23,
        offsetH: 0,
        translateX: -30,
        translateY: 50,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'thignPainForO-right',
        type: 'pain',
        x: 533,
        y: 1750,
        width: 46,
        height: 214,
        offsetW: -23,
        offsetH: 0,
        translateX: 30,
        translateY: 50,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      }
    },
    thignPainForX: {
      left: {
        key: 'thignPainForX-left',
        type: 'pain',
        x: 80,
        y: 2110,
        width: 50,
        height: 168,
        offsetW: -25,
        offsetH: 0,
        translateX: -25,
        translateY: 100,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'thignPainForX-right',
        type: 'pain',
        x: 214,
        y: 2110,
        width: 50,
        height: 168,
        offsetW: -25,
        offsetH: 0,
        translateX: 25,
        translateY: 100,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      }
    },
    thignMidPainForKnee: {
      left: {
        key: 'thignMidPainForKnee-left',
        type: 'pain',
        x: 91,
        y: 1204,
        width: 52,
        height: 210,
        offsetW: -26,
        offsetH: 0,
        translateX: -10,
        translateY: 50,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'thignMidPainForKnee-right',
        type: 'pain',
        x: 199,
        y: 1204,
        width: 52,
        height: 210,
        offsetW: -26,
        offsetH: 0,
        translateX: 10,
        translateY: 50,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      }
    },
    thignMidPainForX: {
      left: {
        key: 'thignMidPainForX-left',
        type: 'pain',
        x: 424,
        y: 2110,
        width: 66,
        height: 180,
        offsetW: -33,
        offsetH: 0,
        translateX: 10,
        translateY: 100,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'thignMidPainForX-right',
        type: 'pain',
        x: 495,
        y: 2110,
        width: 66,
        height: 180,
        offsetW: -33,
        offsetH: 0,
        translateX: -10,
        translateY: 100,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      }
    },
    shankPain: {
      left: {
        key: 'shankPain-left',
        type: 'pain',
        x: 718,
        y: 1765,
        width: 36,
        height: 168,
        offsetW: -18,
        offsetH: 0,
        translateX: 0,
        translateY: 0,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'shankPain-right',
        type: 'pain',
        x: 808,
        y: 1765,
        width: 36,
        height: 168,
        offsetW: -18,
        offsetH: 0,
        translateX: 0,
        translateY: 0,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      }
    },
    hipPain: {
      left: {
        key: 'hipPain-left',
        type: 'pain',
        x: 98,
        y: 1766,
        width: 64,
        height: 132,
        offsetW: -32,
        offsetH: 0,
        translateX: -40,
        translateY: -65,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'shankPain-right',
        type: 'pain',
        x: 177,
        y: 1766,
        width: 64,
        height: 132,
        offsetW: -32,
        offsetH: 0,
        translateX: 45,
        translateY: -65,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      }
    },
    waistPain: {
      left: {
        key: 'waistPain-left',
        type: 'pain',
        x: 135,
        y: 2462,
        width: 58,
        height: 106,
        offsetW: -29,
        offsetH: 0,
        translateX: -25,
        translateY: -105,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'waistPain-right',
        type: 'pain',
        x: 255,
        y: 2462,
        width: 58,
        height: 106,
        offsetW: -29,
        offsetH: 0,
        translateX: 30,
        translateY: -105,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        globalCompositeOperation: 'source-over'
      }
    },
    restore: {
      key: 'restore'
    }
  };

  var faceOrder = ['head-' + headDirection + '-' + headForBody,
  // 'neckPain-left',
  // 'neckPain-right',
  'body-' + bodyDirection,
  // 'bosomPain-left',
  // 'bosomPain-right',
  // 'thigh-left',
  // 'thignPainForO-left',
  // 'thignPainForX-left',
  // 'thignMidPainForKnee-left',
  // 'thignMidPainForX-left',
  // 'shank-left',
  // 'shankPain-left',
  // 'restore',
  // 'thigh-right',
  // 'thignPainForO-right',
  // 'thignPainForX-right',
  // 'thignMidPainForKnee-right',
  // 'thignMidPainForX-right',
  // 'shank-right',
  // 'shankPain-right',
  // 'restore',
  // 'pelvis',
  // 'hipPain-left',
  // 'hipPain-right',
  // 'waistPain-left',
  // 'waistPain-right',
  // 'restore',
  'upperArm-left', 'foreArm-left'];

  var facePain = getPainArr('face', data.conclusion, pains);
  // 按身体部位绘制顺序取出每个部位的具体信息
  var faceOrderInfos = getOrderInfos(locationInfo, faceOrder);

  var faceImg = new Image();
  faceImg.src = imgSrc.bone.face;
  faceImg.onload = function () {
    //console.log('draw face !')
    var ctx = faceCanvas.getContext('2d');
    ctx.globalCompositeOperation = 'destination-over';
    // 开始画头
    ctx.save();
    ctx.translate(0, 100);
    for (var i = 0; i < faceOrderInfos.length; i++) {
      if (faceOrderInfos[i].key == 'restore') {
        ctx.restore();
        continue;
      }

      if (faceOrderInfos[i].type !== 'pain' || faceOrderInfos[i].type === 'pain' && facePain.indexOf(faceOrderInfos[i].key) !== -1) {
        if (faceOrderInfos[i].saveBefore) {
          ctx.save();
        }

        ctx.translate(faceOrderInfos[i].translateX, faceOrderInfos[i].translateY);
        ctx.rotate(faceOrderInfos[i].rotateBefore);
        // if(faceOrderInfos[i].rotate > faceOrderInfos[i].maxRotate) {
        //   ctx.rotate(faceOrderInfos[i].maxRotate);
        // } else if (faceOrderInfos[i].rotate < faceOrderInfos[i].minRotate) {
        //   ctx.rotate(faceOrderInfos[i].minRotate);
        // } else {
        ctx.rotate(faceOrderInfos[i].rotate);
        // }

        if (faceOrderInfos[i].globalCompositeOperation) {
          ctx.globalCompositeOperation = faceOrderInfos[i].globalCompositeOperation;
        }
        ctx.drawImage(faceImg, faceOrderInfos[i].x, faceOrderInfos[i].y, faceOrderInfos[i].width, faceOrderInfos[i].height, faceOrderInfos[i].offsetW, faceOrderInfos[i].offsetH, faceOrderInfos[i].width, faceOrderInfos[i].height);

        ctx.globalCompositeOperation = 'destination-over';

        if (faceOrderInfos[i].restoreAfter) {
          ctx.restore();
        }
      } else {
        continue;
      }
    }
  };
}

// ====== 侧面 ======
function drawBoneSide(data, canvas) {
  var sideCanvas = canvas;
  var sideWidth = sideCanvas.width;
  var sideHeight = sideCanvas.height;

  var sideRisks = data.conclusion.side.risks;

  var sidePoints = data.conclusion.side.points;
  var sideDirection = data.conclusion.side.side;
  var sideRad = {
    earToShoulder: getRad(sidePoints['ear'][sideDirection], sidePoints['shoulder'][sideDirection]),
    shoulderToElbow: getRad(sidePoints['shoulder'][sideDirection], sidePoints['elbow'][sideDirection]),
    elbowToWrist: getRad(sidePoints['elbow'][sideDirection], sidePoints['wrist'][sideDirection]),
    hipToKnee: getRad(sidePoints['hip'][sideDirection], sidePoints['knee'][sideDirection]),
    kneeToAnkle: getRad(sidePoints['knee'][sideDirection], sidePoints['ankle'][sideDirection])
  };

  var sideLocationInfo = {
    head: {
      mid: {
        key: 'head-mid',
        type: 'noraml',
        x: 1516,
        y: 71,
        width: 126,
        height: 168,
        offsetW: -63,
        offsetH: 0,
        translateX: sideWidth / 2,
        translateY: 0,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: false,
        restoreAfter: false
      },
      front: {
        key: 'head-front',
        type: 'noraml',
        x: 14,
        y: 91,
        width: 158,
        height: 168,
        offsetW: -79,
        offsetH: 0,
        translateX: sideWidth / 2,
        translateY: 0,
        rotateBefore: 0,
        rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: false,
        restoreAfter: false
      }
    },
    body: {
      key: 'body',
      type: 'noraml',
      x: 1212,
      y: 85,
      width: 148,
      height: 300,
      offsetW: -74,
      offsetH: -25,
      translateX: isHeadFront(sideRisks) ? -21 : -6,
      translateY: 168,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: false,
      restoreAfter: false
    },
    upperArm: {
      key: 'upperArm',
      type: 'noraml',
      x: 422,
      y: 89,
      width: 68,
      height: 178,
      offsetW: -34,
      offsetH: 0,
      translateX: -19,
      translateY: 0,
      rotateBefore: 0,
      rotate: sideRad.shoulderToElbow,
      maxRotate: 0.6,
      minRotate: -0.4,
      saveBefore: true,
      restoreAfter: false,
      globalCompositeOperation: 'source-over'
    },
    foreArm: {
      key: 'foreArm',
      type: 'noraml',
      x: 290,
      y: 85,
      width: 72,
      height: 244,
      offsetW: -15,
      offsetH: 0,
      translateX: 0,
      translateY: 155,
      rotateBefore: -getLimitRad(sideRad.shoulderToElbow, -0.4, 0.6),
      rotate: sideRad.elbowToWrist,
      maxRotate: 0,
      minRotate: -0.4,
      saveBefore: false,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    shank: {
      key: 'shank',
      type: 'noraml',
      x: 920,
      y: 79,
      width: 126,
      height: 326,
      offsetW: -63,
      offsetH: 0,
      translateX: 5,
      translateY: 205,
      rotateBefore: 0,
      rotate: sideRad.hipToKnee,
      maxRotate: 0.1,
      minRotate: -0.1,
      saveBefore: true,
      restoreAfter: false,
      globalCompositeOperation: 'destination-over'
    },
    thigh: {
      key: 'thigh',
      type: 'noraml',
      x: 633,
      y: 79,
      width: 156,
      height: 286,
      offsetW: -58,
      offsetH: -15,
      translateX: 0,
      translateY: 326,
      rotateBefore: -getLimitRad(sideRad.hipToKnee, -0.1, 0.1),
      rotate: sideRad.kneeToAnkle,
      maxRotate: 0.1,
      minRotate: -0.1,
      saveBefore: false,
      restoreAfter: false,
      globalCompositeOperation: 'source-over'
    },
    neckBackPain: {
      key: 'neckBackPain',
      type: 'pain',
      x: 34,
      y: 519,
      width: 54,
      height: 88,
      offsetW: -27,
      offsetH: 0,
      translateX: -30,
      translateY: 70,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    neckMidPain: {
      key: 'neckMidPain',
      type: 'pain',
      x: 24,
      y: 1686,
      width: 96,
      height: 122,
      offsetW: 0,
      offsetH: 0,
      translateX: -60,
      translateY: -80,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    shankMidPain: {
      key: 'shankMidPain',
      type: 'pain',
      x: 72,
      y: 1924,
      width: 82,
      height: 288,
      offsetW: -65,
      offsetH: 0,
      translateX: 0,
      translateY: 0,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    shankLeftPain: {
      key: 'shankLeftPain',
      type: 'pain',
      x: 45,
      y: 1365,
      width: 44,
      height: 220,
      offsetW: 0,
      offsetH: 0,
      translateX: -40,
      translateY: 80,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    neckWithBosomPain: {
      key: 'neckWithBosomPain',
      type: 'pain',
      x: 24,
      y: 1077,
      width: 70,
      height: 176,
      offsetW: 0,
      offsetH: 0,
      translateX: -12,
      translateY: -120,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    shoulderBackPain: {
      key: 'shoulderBackPain',
      type: 'pain',
      x: 241,
      y: 1076,
      width: 32,
      height: 176,
      offsetW: 0,
      offsetH: 0,
      translateX: -80,
      translateY: -15,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    shankOPain: {
      key: 'shankOPain',
      type: 'pain',
      x: 212,
      y: 690,
      width: 80,
      height: 296,
      offsetW: 0,
      offsetH: 0,
      translateX: -60,
      translateY: 0,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    thighLeftPain: {
      key: 'thighLeftPain',
      type: 'pain',
      x: 0,
      y: 713,
      width: 42,
      height: 246,
      offsetW: 0,
      offsetH: 0,
      translateX: -60,
      translateY: -10,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    thighRightPain: {
      key: 'thighRightPain',
      type: 'pain',
      x: 40,
      y: 740,
      width: 40,
      height: 200,
      offsetW: 0,
      offsetH: 0,
      translateX: -10,
      translateY: 0,
      rotateBefore: 0,
      rotate: 0,
      maxRotate: 0,
      minRotate: 0,
      saveBefore: true,
      restoreAfter: true,
      globalCompositeOperation: 'source-over'
    },
    restore: {
      key: 'restore'
    }
  };
  var sideHeadDirection = isHeadFront(sideRisks) ? 'front' : 'mid';
  var sideOrder = ['head-' + sideHeadDirection, 'neckBackPain', 'body', 'neckWithBosomPain', 'neckMidPain', 'shoulderBackPain', 'shank', 'shankMidPain', 'shankOPain', 'shankLeftPain', 'thigh', 'thighLeftPain', 'thighRightPain', 'restore', 'upperArm', 'foreArm'];

  var sideOrderInfos = getOrderInfos(sideLocationInfo, sideOrder);
  // let sidePain = ['neckBackPain', 'shankMidPain', 'neckWithBosomPain', 'shoulderBackPain', 'shankOPain', 'shankLeftPain', 'thighLeftPain', 'thighRightPain', 'neckMidPain'];
  var sidePain = getPainArr('side', data.conclusion, pains);
  //console.log('sidePain ==>', sidePain);

  var sideImg = new Image();
  sideImg.src = imgSrc.bone.side;
  sideImg.onload = function () {
    var ctx = sideCanvas.getContext('2d');
    ctx.globalCompositeOperation = 'destination-over';
    // 开始画头
    ctx.save();
    for (var i = 0; i < sideOrderInfos.length; i++) {
      if (sideOrderInfos[i].key == 'restore') {
        ctx.restore();
        continue;
      }

      if (sideOrderInfos[i].type !== 'pain' || sideOrderInfos[i].type === 'pain' && sidePain.indexOf(sideOrderInfos[i].key) !== -1) {
        // 非疼痛 或者 疼痛需要显示时
        //console.log('type =>', sideOrderInfos[i].type);
        //console.log('indexOf =>', sidePain.indexOf(sideOrderInfos[i].key))
        if (sideOrderInfos[i].saveBefore) {
          ctx.save();
        }

        ctx.translate(sideOrderInfos[i].translateX, sideOrderInfos[i].translateY);
        ctx.rotate(sideOrderInfos[i].rotateBefore);
        if (sideOrderInfos[i].rotate > sideOrderInfos[i].maxRotate) {
          ctx.rotate(sideOrderInfos[i].maxRotate);
        } else if (sideOrderInfos[i].rotate < sideOrderInfos[i].minRotate) {
          ctx.rotate(sideOrderInfos[i].minRotate);
        } else {
          ctx.rotate(sideOrderInfos[i].rotate);
        }

        if (sideOrderInfos[i].globalCompositeOperation) {
          ctx.globalCompositeOperation = sideOrderInfos[i].globalCompositeOperation;
        }
        ctx.drawImage(sideImg, sideOrderInfos[i].x, sideOrderInfos[i].y, sideOrderInfos[i].width, sideOrderInfos[i].height, sideOrderInfos[i].offsetW, sideOrderInfos[i].offsetH, sideOrderInfos[i].width, sideOrderInfos[i].height);

        ctx.globalCompositeOperation = 'destination-over';

        if (sideOrderInfos[i].restoreAfter) {
          ctx.restore();
        }
      } else {
        continue;
      }
    }
  };
}

module.exports = {
  initRiskBar: initRiskBar,
  initRiskLevel: initRiskLevel,
  drawBoneFront: drawBoneFront,
  drawBoneSide: drawBoneSide
};

/***/ }),

/***/ "smaB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/high.b1b9878.png";

/***/ }),

/***/ "uFFO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "uSsQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/head_sideway_normal.4716ec0.png";

/***/ }),

/***/ "uV2h":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/pelvis_lean_left.de9075d.png";

/***/ }),

/***/ "unJv":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAzCAYAAACE92h3AAADOElEQVRYhbXYX6hVRRTH8Y+ngoSyuqZlEUGG9WCUgRUihFBBQdlDwY3+0EMPkT30l8KoFAp6KEIFqSCIoPKhP09FFEEiioTpkaxe0krBixYXsRLkZvaw59bcObP3ntPZ/eBwZtZea33PzOz5d2Y9teOkQl2IJ3ELLsIJ/IAPsA5HS5KcWghbgs9wbmK/MnzuxvU41JaoVwDr4b0MLNZl2FiQqwi4IiRs0+04vwvgtQU+07mWdgEcKwTCOV0Ajw0BbPUtAf44BPCnLoDbC2F/4JsugN+HT5s+xvEugLC+wGddSaJS4Jv4uuH5O9jWJXAKd6jWzlSb8VBhnkbgEtWvnlS14FdcgxfwBT7Bo7gJc/Bl8N2Mq+uSzqrZLeZjD+ZFtj5WYn/iex0+xILINonL8UuauK6FLyYwuAo7cVeIOxvPqVq2IPEdw9pc4lwLF6mmQVN3TwZgk88JVStnjHsu4ImWRFQtaPM5BY+lxjRoDPe0JBpG90sW/xQ4jtkdAmdLGpAC7+0QNq0H6oCLVK9417pCde4ZAN73P8CmNZ4Djmcc9xmc6E36PMSkujMFLsbCjOMqvDsE8K0Qk2phYPwDvDXjtAmfYssQwC0hZlPm2W0xcGXy8Ih/J21uh8jpGA6E8iMhRxY4z+DxbjUmQvlnlNwHDkTlQ3g6eb4U83u4wcyXZztej+rH5V+EVN8l9TewNar3cGMPD0bGP0P9ryT4qwLg1qR+MuSaimyremZulq9idyZZyckgdzHag5ej+uIenld120d4NhN0iWgeNehxnJaxr8Hbqs34mbodP9Zq1YZcoptV06JWJV21LGP7Vn4FWt6WrAR4acb2MF7J2C9uS1ZyAz4vY+sbfJMZPNsMqK2Fp6vOLrH2qVaRvsEFYeQL6QUZWz98H8XeroG5e/2uDHxac7UMUxswd6Pt15SbYoqBuev2zppyJ8C5Sf0wDkb1zluYBqeACYN/Bo0EPCup78r4pLZOgbkxS4FnjgKck9RzY5ba0pj/DPxd/nyTtnAk4BlRebf8+rkXv3UFjNfR3PgJPyI+JYw0hvF5ZEeDX/zn0VStVwHwJVV3bcP7DX4bVF07gdeaEv4Nm46fpl/jU24AAAAASUVORK5CYII="

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v5mt":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAABkCAYAAAArKghlAAAACXBIWXMAAAsSAAALEgHS3X78AAAFFUlEQVR4nO1cS3LcNhB9Snkv5wTiDUZVcwAzi3AbZTc7TU4Q3cDjGygnyGQVLq3trOB9WCWdIPAJojmBvBiMTYINoIFumrQrr2oWQ6BBPHwajUaDFy8vL6DQtN1rAFv3W/WSHgDcHzZrQwoqoGm7CsAOwA2AS/f4CcB79+5nSu6CIuOIGAxJ+PjtsFnvSyscQtN2NwD2+ELCxxFAfdisH/2EHwICBnEiAPCna0Ft3CNMBC7NuAYfYESmabst0kTOuGHmY6FpuxrAFSPrJYA7/yHVM9cZ7x+1jhA55dX+AykZbYgaJzRn5oKVCFNkTIZ8Tl4ORhoqB5KeOWqvNW79eCqVp8iQCxIBUSsqlGv8BxSZqSqpjVGjS8hUoqrIyzX+gxEZN27fMQrjLG4l4KjnB8qcIW2zM5q2u8bJTgpZBL8eNuv3nBpy4MyjfyNZfoopnag2c+xtJMsuJl+AWHlPKe3JUc2xObRytpwYzi67jWSxqTI4ZEwifWTwFWKbSE8qJg6ZXSJ95eZWMZw5H+sVANhSZn8fUTJN2+0AvGHUR9o7nK3EFU57nSCCZFxrv2VWpmbmC4G7L7qNzVGSjOvOHJUrXXOqjLz3oR1uqGfuMN2iSIG7swVOu8w9lUBtmyvwh9dceONU+QBUz2ip2hx8KJBR9wGcUbwHcbAFMrX/gCJTsg83BTJ9lGw7Ru4oikzOZDzDFMj0UWSs+ouohkPjKLWcD5u1RdlQHUwJDTJaW4C9tIABGUrdMWCkldAqR6NnVHwG1M6RAd1hVliJEHLnjaoCkK4vPqxE2CdTf82XE5jNoyl+uUJ5qsPMCuV9cL2pZ6gqACuUH0Dqu5aSyW3JSSEio6yWxVjaYZMIIjIp18/XhrRn5jz/HMEnI1KNUriAhhwM5qxPJndCbzPzp5BLZtD4PhmbWdhKed7kkjH9PwMybseXC82hFgszoWD7fygFUOL2mQNHv/E1DmjnsgJYUU1ZlVO2Aj5KhJe2Ofuu9jNGIiwlo3bSrFGelIwRyg/gtFPxvJH4mv8KBX4KsS8VlJwCaA8xcbmSYTbJ+iJR9RIyViA7CYoXzUI7josiJbDUeDNbIvS/DwBCG0oJrEhAyyiIk2dqsKzmb2XOjPJQYY2PON2EmBOWkcf4D2K3NJaMj9TSECIzlamiBbJ+pWTmdpjvqYckGWcNxxwbsyqJkP0WW2fmbv0Qglv1GJlY61fFVZHDhhJKydSlNWEiVr4JJQTJuHiY0HpzpRXP7MPFhsaCXIPKKWWbxbTaVEF2sXI/xLYeKTK7SNpqoquNMef5LiaYugtgEVfRdUw+Fy4QKeg817gLEEMllM8pL+nQl94F0D4GrCTC0p75rg5oF4WlOc5FWFq4iZUIL22YWYnwtzTMVG42mUia6jBLLIrJdy2xZ0LGrQoZG0qY6Hwm1EDyYRaxUqeKFwi9L4klHmmQ5XJCHrlkqF4gX6oAUyoo6Zmp1HLxPFzcMJvlGHDiYNOiyA8uGX/fMvX5zGioceLakmTclWB/K2u5tVJE9CowALwKJbiW2AP4hUjm3HfWxq1zoGxDa9/oSw2OxJ37xSLzfpzIAkDTds+Jd/8BYOe//zMZx/oOpyBSTnhh9BMQpXCN+R8j6xEnv97+XI9XroB7AL9rV6wQFTPfJU7fELht2u4BwPbi57//eY3w98yOGC+OjwAep/hQ2xnOf3b+9VGBvkD+BKDuD7NrnLwtz0u7sEChV9/PdtsngEN1pWYhCyUAAAAASUVORK5CYII="

/***/ }),

/***/ "v8CS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/high_low_shoulder_normal.d4135a2.png";

/***/ }),

/***/ "vO9O":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dc5P");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("33a6ab49", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b012ef2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_front.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b012ef2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Posture_front.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vZf5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/round_shoulder_normal.9f9d5a6.png";

/***/ }),

/***/ "wKAa":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAA1CAYAAAC5mTBpAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAA0dJREFUWIXl2E2oVVUYxvGfpckpMLTsQpYGRYYEGUlBFE0iSB0bDhIb9jFQgu4gIkIH2qBBCTWKgoioQWBBJRINmqQRkYl9esu8cEuzD8M+LnYb7HNon3XWu/Y+2bZBD5zBetZ53/9a56z1rrU3/1fNqzcm35+DpXgU67AcJ3EAz+FZzDXkvBmTuAkTmMYePILpnWv+Rs5PAi/GfqyoeRfilv7nejxQAK/Fbpxb85bhHtyBNZgZdJyTBE8m4FT3YXWh/4kEXNcyPFQ3Uvj6QmKqv+nOoO8KrGyIX1eCl2Y90GWBf2mL2OUlePST1TUv8NNcOQ3lTwN+apHg1zH9un4swb9qkeBw4E+1iP2mBN/XIsF7gX8CXzbE7i/BX20I/hofFPp3N8QP9afwt5Vn/zj+LPQ/hVNB38d4swSfw134LBP8DJ4ugKn+9834I/GnsUEy8LS8Ui26G/qDWI1f8BbeaQAP9Ao+6sdP4BBekKz0CK4PfF1V629U1eR7VQvmSaMzG2gtNuIinMaHeCMHLsHvx05ckPgb0MO2TMxV/QHXi9B61XmxvR8zdCLmqtI27MqABzo/8Hvy1W8BHlMdOkNK4bfh4SD5mWoLbi/BN4tr97+hTSX40g7BVAs4hB/vGP5zCf5dx/CZeiOFf9oxfOjgSeGfdwwfOo5TeNOReKYaOvNT+LSqtHahOQ0zHwygCx3Hb03wYx3BT6RGDv5DR/Dv28BPdgT/tg28K40UsLMJP/Rfwve2gUe3m4GirTgT+FR3uoNt4Ecb4O8G/jH5Wy9B2c7BdymfbtcGfk/1mJzTa23hU1iFl4JEVwf+CpyX8V/G823hVAXhSNC3YEw/vJaVVnsv8H8f04/yFOFfBP4ngT+F2YwfHtMleLRyR7ZMX7PyA47yFOG57XFa+aqV+1XClwYl+JE+LPWi5zTyMw/vByX4rNGC03TBzP2/YdFqqu3pdosWYQQ/JXOJaAtP6/Xihu+nD5fFUt0ET28fpVefcF3SLj6ENMEXJe2VWFj4fjq46DG7ET4ft2a8qLbDNUl7FZb8E/jduDzjTxRiLknaC/HguPAl2BH0pXu/rtxrsq24chz4FqOzoNrnpfd0L2a8nuQ9+0B/Aa+fn5lCPar0AAAAAElFTkSuQmCC"

/***/ }),

/***/ "wiIv":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0tff");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3d72ef6b", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bd4fa69a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Symp_itemIpad.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bd4fa69a\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Symp_itemIpad.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "wyWN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/backBone.eb09752.png";

/***/ }),

/***/ "xHUF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/spine_sideway_left.c13ffd0.png";

/***/ }),

/***/ "xXsX":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAYAAACaq43EAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAHWlUWHRTb2Z0d2FyZQAAAAAAQWRvYmUgSW1hZ2VSZWFkeQatApcAAAMhaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzE0MiA3OS4xNjA5MjQsIDIwMTcvMDcvMTMtMDE6MDY6MzkgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjlFNjFFODJFNEFEMTFFNzk3NDlBMTk5MzNCNTc4QzQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjlFNjFFODNFNEFEMTFFNzk3NDlBMTk5MzNCNTc4QzQiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyOUU2MUU4MEU0QUQxMUU3OTc0OUExOTkzM0I1NzhDNCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyOUU2MUU4MUU0QUQxMUU3OTc0OUExOTkzM0I1NzhDNCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnlPNjYAAAGBSURBVEiJxdbPS1RRFADgbyjCTRRIiCSRILkQWgRuXCZBDBSIEIa0i1a1cOGuRS2CFirpIiJKmoWUw1CJNpD4gwraBCL+LUFR2LS458EgouPTcQ5cuO++x/vOvffcxyvUajWtiJMtUTO4Wq0eK1osFnPPuIBpbGI2zwvywtfxANvRSscBX8Lr6G9H/zfmmwn3YBWdeISvWMJcJFFpBnwx0C48weMYH8JC4H+jf2RwF9ZwARN4WHdvGcP4gHIksu8xaQQ+j3V0S5U8vsszVdwK+D1uRkK54Q5peXvwHGN7PLuAUbyTZn9DWqUDw+cC7ZUq9z72+75WAp/DonTsvh0EbscK+vAG9xpAs5hHWyT7KfDvjcBnpf25jLe4i38NolmUcAKvpP2/hh97wWcCvSIt2x3pfOaJWZySamMZg9jYDT4d2fVLxTF6CDSLF4FP43PgWzvhMgYCH8GfQ6JZzIQziWe4uhN+il+4fYRoFlP4iY/ZQD38JVqz4mX9RaFVvz7/AXBiV++/M9HhAAAAAElFTkSuQmCC"

/***/ }),

/***/ "y73U":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/spine_sideway_right.448871d.png";

/***/ }),

/***/ "y8Tp":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* swiper 自定义样式开始 */\n.swiper-container {\n  width: 100%;\n  height: 100%;\n}\n.swiper-pagination-bullet {\n  opacity: 1;\n}\n.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {\n  bottom: 0\n}\n.swiper-slide {\n  box-sizing: border-box;\n  overflow: scroll;\n  -webkit-overflow-scrolling: touch;\n}\n.posture-swiper-pagination {\n  height: 2.7rem;\n  background: #f7f7f7;\n}\n.pagination-bullet {\n  width: auto !important;\n  height: 16px !important;\n  line-height: 16px !important;\n  font-size: 16px !important;\n  color: #000 !important;\n}\n.hidden-pagination {\n  display: none;\n}\n.head-space {\n  padding-top: 1.5rem;\n}\n.pagintaion-space {\n  padding-bottom: 2.7rem;\n}\n.swiper-pagination-bullet-active .pagination-icon {\n  background-position-y: -1.5rem;\n}\n.swiper-pagination-bullet-active .pagination-bullet {\n  color: #000 !important;\n}\n/* swiper 自定义样式结束 */\n\n", ""]);

// exports


/***/ }),

/***/ "yCic":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/low.ed37853.png";

/***/ }),

/***/ "yboJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "yujV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "posture/static/img/head_lean_normal.c54b536.png";

/***/ }),

/***/ "zrcO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAACXBIWXMAAAsSAAALEgHS3X78AAACrUlEQVRYw92Y35HaMBDGfzD3DqngSAW4g/gKQJAK4qsgTgd0cL4KcCoIUQOBDkwFgQpiKiAPXmNZlvyH4TI32Ze7kbXaT7urb3cZXS4X3oOMeSfy0PpVqRkQAjNZOQI7tD7eW2/kDI1Sa2AFzD16e2CN1jtLLwTWwCeP3gHYovW6HYhSAZC2ALDlO1pHopsCX3rqHYAIrbMmkALEDpgYCicBlgFTIAAia89e/ppeOBt6uaH3aO0JSzAFEKWmAmJubIrROvXkQCwhmFhfzhKyxKMXAYmhdxAweflqYgtE6AUBiKFQDsI6NGnRS0XvLCtzsY0JhOv/RuxaDs2MQ2tu7qFXtweMLotFCPy6ekPr6SACKNxNqwfderkRoqcHuVUp28FMVAIoAG0keTPJuayFO7bGKwttZj3eRItFsifG6/kK/JCX45PjW1B87HhBiFduqjXTG70RO0nLwaA+W2OJZynhHb2x7tAzbWWjy2IxBf4Yix87i1rdG0cPkJKZY7TeOorib2Plwxitc4uYogHe6Arlo1GB8djYm8ya1Fxd3LTP0z0K7zxZlynlW4NpmzmVVslacMFJPkw6np1Lcqtin4HPHrpPjVCeSh4ae9y1vDJmP0mtvAgbeVGR3tJlc2y4eQe8Gps2vcAUTdTcKHyBs+ZUzFvKq9lYNTs0pTLLzc8t7cBMnv+k1iR1gzigddDFrHZ530j/4ZKZgHhuARE3QDj4ytez2o0SwE9p7/IBHJNaOXFthPqNE8XGUIxXCQyZNMhdIEIJ2dK6SOi7yKhzwFIqkWqKlWjxXfb3BlLdcGtReb0Td08AZ2DVGDtuBuKPecGehbxY64NyajR49lVqZbEjjk4+chLaXWffwkBgzDP2BBgMBXGbR5oc8eItcP8MSJWk9Bol3hTI//b7yF+m9C/Na/rXcgAAAABJRU5ErkJggg=="

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// posture/static/js/app.159854917f3a6fd9e7e7.js